/*!
 * pixi.js-legacy - v5.3.11
 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
 *
 * pixi.js-legacy is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
var PIXI = (function (exports) {
	'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function commonjsRequire () {
		throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
	}

	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	function getCjsExportFromNamespace (n) {
		return n && n['default'] || n;
	}

	var promise = createCommonjsModule(function (module, exports) {
	(function(global){

	//
	// Check for native Promise and it has correct interface
	//

	var NativePromise = global['Promise'];
	var nativePromiseSupported =
	  NativePromise &&
	  // Some of these methods are missing from
	  // Firefox/Chrome experimental implementations
	  'resolve' in NativePromise &&
	  'reject' in NativePromise &&
	  'all' in NativePromise &&
	  'race' in NativePromise &&
	  // Older version of the spec had a resolver object
	  // as the arg rather than a function
	  (function(){
	    var resolve;
	    new NativePromise(function(r){ resolve = r; });
	    return typeof resolve === 'function';
	  })();


	//
	// export if necessary
	//

	if ('object' !== 'undefined' && exports)
	{
	  // node.js
	  exports.Promise = nativePromiseSupported ? NativePromise : Promise;
	  exports.Polyfill = Promise;
	}
	else
	{
	  // AMD
	  if (typeof undefined == 'function' && undefined.amd)
	  {
	    undefined(function(){
	      return nativePromiseSupported ? NativePromise : Promise;
	    });
	  }
	  else
	  {
	    // in browser add to global
	    if (!nativePromiseSupported)
	      { global['Promise'] = Promise; }
	  }
	}


	//
	// Polyfill
	//

	var PENDING = 'pending';
	var SEALED = 'sealed';
	var FULFILLED = 'fulfilled';
	var REJECTED = 'rejected';
	var NOOP = function(){};

	function isArray(value) {
	  return Object.prototype.toString.call(value) === '[object Array]';
	}

	// async calls
	var asyncSetTimer = typeof setImmediate !== 'undefined' ? setImmediate : setTimeout;
	var asyncQueue = [];
	var asyncTimer;

	function asyncFlush(){
	  // run promise callbacks
	  for (var i = 0; i < asyncQueue.length; i++)
	    { asyncQueue[i][0](asyncQueue[i][1]); }

	  // reset async asyncQueue
	  asyncQueue = [];
	  asyncTimer = false;
	}

	function asyncCall(callback, arg){
	  asyncQueue.push([callback, arg]);

	  if (!asyncTimer)
	  {
	    asyncTimer = true;
	    asyncSetTimer(asyncFlush, 0);
	  }
	}


	function invokeResolver(resolver, promise) {
	  function resolvePromise(value) {
	    resolve(promise, value);
	  }

	  function rejectPromise(reason) {
	    reject(promise, reason);
	  }

	  try {
	    resolver(resolvePromise, rejectPromise);
	  } catch(e) {
	    rejectPromise(e);
	  }
	}

	function invokeCallback(subscriber){
	  var owner = subscriber.owner;
	  var settled = owner.state_;
	  var value = owner.data_;  
	  var callback = subscriber[settled];
	  var promise = subscriber.then;

	  if (typeof callback === 'function')
	  {
	    settled = FULFILLED;
	    try {
	      value = callback(value);
	    } catch(e) {
	      reject(promise, e);
	    }
	  }

	  if (!handleThenable(promise, value))
	  {
	    if (settled === FULFILLED)
	      { resolve(promise, value); }

	    if (settled === REJECTED)
	      { reject(promise, value); }
	  }
	}

	function handleThenable(promise, value) {
	  var resolved;

	  try {
	    if (promise === value)
	      { throw new TypeError('A promises callback cannot return that same promise.'); }

	    if (value && (typeof value === 'function' || typeof value === 'object'))
	    {
	      var then = value.then;  // then should be retrived only once

	      if (typeof then === 'function')
	      {
	        then.call(value, function(val){
	          if (!resolved)
	          {
	            resolved = true;

	            if (value !== val)
	              { resolve(promise, val); }
	            else
	              { fulfill(promise, val); }
	          }
	        }, function(reason){
	          if (!resolved)
	          {
	            resolved = true;

	            reject(promise, reason);
	          }
	        });

	        return true;
	      }
	    }
	  } catch (e) {
	    if (!resolved)
	      { reject(promise, e); }

	    return true;
	  }

	  return false;
	}

	function resolve(promise, value){
	  if (promise === value || !handleThenable(promise, value))
	    { fulfill(promise, value); }
	}

	function fulfill(promise, value){
	  if (promise.state_ === PENDING)
	  {
	    promise.state_ = SEALED;
	    promise.data_ = value;

	    asyncCall(publishFulfillment, promise);
	  }
	}

	function reject(promise, reason){
	  if (promise.state_ === PENDING)
	  {
	    promise.state_ = SEALED;
	    promise.data_ = reason;

	    asyncCall(publishRejection, promise);
	  }
	}

	function publish(promise) {
	  var callbacks = promise.then_;
	  promise.then_ = undefined;

	  for (var i = 0; i < callbacks.length; i++) {
	    invokeCallback(callbacks[i]);
	  }
	}

	function publishFulfillment(promise){
	  promise.state_ = FULFILLED;
	  publish(promise);
	}

	function publishRejection(promise){
	  promise.state_ = REJECTED;
	  publish(promise);
	}

	/**
	* @class
	*/
	function Promise(resolver){
	  if (typeof resolver !== 'function')
	    { throw new TypeError('Promise constructor takes a function argument'); }

	  if (this instanceof Promise === false)
	    { throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.'); }

	  this.then_ = [];

	  invokeResolver(resolver, this);
	}

	Promise.prototype = {
	  constructor: Promise,

	  state_: PENDING,
	  then_: null,
	  data_: undefined,

	  then: function(onFulfillment, onRejection){
	    var subscriber = {
	      owner: this,
	      then: new this.constructor(NOOP),
	      fulfilled: onFulfillment,
	      rejected: onRejection
	    };

	    if (this.state_ === FULFILLED || this.state_ === REJECTED)
	    {
	      // already resolved, call callback async
	      asyncCall(invokeCallback, subscriber);
	    }
	    else
	    {
	      // subscribe
	      this.then_.push(subscriber);
	    }

	    return subscriber.then;
	  },

	  'catch': function(onRejection) {
	    return this.then(null, onRejection);
	  }
	};

	Promise.all = function(promises){
	  var Class = this;

	  if (!isArray(promises))
	    { throw new TypeError('You must pass an array to Promise.all().'); }

	  return new Class(function(resolve, reject){
	    var results = [];
	    var remaining = 0;

	    function resolver(index){
	      remaining++;
	      return function(value){
	        results[index] = value;
	        if (!--remaining)
	          { resolve(results); }
	      };
	    }

	    for (var i = 0, promise; i < promises.length; i++)
	    {
	      promise = promises[i];

	      if (promise && typeof promise.then === 'function')
	        { promise.then(resolver(i), reject); }
	      else
	        { results[i] = promise; }
	    }

	    if (!remaining)
	      { resolve(results); }
	  });
	};

	Promise.race = function(promises){
	  var Class = this;

	  if (!isArray(promises))
	    { throw new TypeError('You must pass an array to Promise.race().'); }

	  return new Class(function(resolve, reject) {
	    for (var i = 0, promise; i < promises.length; i++)
	    {
	      promise = promises[i];

	      if (promise && typeof promise.then === 'function')
	        { promise.then(resolve, reject); }
	      else
	        { resolve(promise); }
	    }
	  });
	};

	Promise.resolve = function(value){
	  var Class = this;

	  if (value && typeof value === 'object' && value.constructor === Class)
	    { return value; }

	  return new Class(function(resolve){
	    resolve(value);
	  });
	};

	Promise.reject = function(reason){
	  var Class = this;

	  return new Class(function(resolve, reject){
	    reject(reason);
	  });
	};

	})(typeof window != 'undefined' ? window : typeof commonjsGlobal != 'undefined' ? commonjsGlobal : typeof self != 'undefined' ? self : commonjsGlobal);
	});
	var promise_1 = promise.Promise;
	var promise_2 = promise.Polyfill;

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/

	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var arguments$1 = arguments;

		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments$1[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};

	/*!
	 * @pixi/polyfill - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/polyfill is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	// Support for IE 9 - 11 which does not include Promises
	if (!window.Promise) {
	    window.Promise = promise_2;
	}

	// References:
	if (!Object.assign) {
	    Object.assign = objectAssign;
	}

	// References:
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	// https://gist.github.com/1579671
	// http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
	// https://gist.github.com/timhall/4078614
	// https://github.com/Financial-Times/polyfill-service/tree/master/polyfills/requestAnimationFrame
	// Expected to be used with Browserfiy
	// Browserify automatically detects the use of `global` and passes the
	// correct reference of `global`, `self`, and finally `window`
	var ONE_FRAME_TIME = 16;
	// Date.now
	if (!(Date.now && Date.prototype.getTime)) {
	    Date.now = function now() {
	        return new Date().getTime();
	    };
	}
	// performance.now
	if (!(window.performance && window.performance.now)) {
	    var startTime_1 = Date.now();
	    if (!window.performance) {
	        window.performance = {};
	    }
	    window.performance.now = function () { return Date.now() - startTime_1; };
	}
	// requestAnimationFrame
	var lastTime = Date.now();
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	    var p = vendors[x];
	    window.requestAnimationFrame = window[p + "RequestAnimationFrame"];
	    window.cancelAnimationFrame = window[p + "CancelAnimationFrame"]
	        || window[p + "CancelRequestAnimationFrame"];
	}
	if (!window.requestAnimationFrame) {
	    window.requestAnimationFrame = function (callback) {
	        if (typeof callback !== 'function') {
	            throw new TypeError(callback + "is not a function");
	        }
	        var currentTime = Date.now();
	        var delay = ONE_FRAME_TIME + lastTime - currentTime;
	        if (delay < 0) {
	            delay = 0;
	        }
	        lastTime = currentTime;
	        return window.setTimeout(function () {
	            lastTime = Date.now();
	            callback(performance.now());
	        }, delay);
	    };
	}
	if (!window.cancelAnimationFrame) {
	    window.cancelAnimationFrame = function (id) { return clearTimeout(id); };
	}

	// References:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
	if (!Math.sign) {
	    Math.sign = function mathSign(x) {
	        x = Number(x);
	        if (x === 0 || isNaN(x)) {
	            return x;
	        }
	        return x > 0 ? 1 : -1;
	    };
	}

	// References:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
	if (!Number.isInteger) {
	    Number.isInteger = function numberIsInteger(value) {
	        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	    };
	}

	if (!window.ArrayBuffer) {
	    window.ArrayBuffer = Array;
	}
	if (!window.Float32Array) {
	    window.Float32Array = Array;
	}
	if (!window.Uint32Array) {
	    window.Uint32Array = Array;
	}
	if (!window.Uint16Array) {
	    window.Uint16Array = Array;
	}
	if (!window.Uint8Array) {
	    window.Uint8Array = Array;
	}
	if (!window.Int32Array) {
	    window.Int32Array = Array;
	}

	var appleIphone = /iPhone/i;
	var appleIpod = /iPod/i;
	var appleTablet = /iPad/i;
	var appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
	var androidPhone = /\bAndroid(?:.+)Mobile\b/i;
	var androidTablet = /Android/i;
	var amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i;
	var amazonTablet = /Silk/i;
	var windowsPhone = /Windows Phone/i;
	var windowsTablet = /\bWindows(?:.+)ARM\b/i;
	var otherBlackBerry = /BlackBerry/i;
	var otherBlackBerry10 = /BB10/i;
	var otherOpera = /Opera Mini/i;
	var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
	var otherFirefox = /Mobile(?:.+)Firefox\b/i;
	var isAppleTabletOnIos13 = function (navigator) {
	    return (typeof navigator !== 'undefined' &&
	        navigator.platform === 'MacIntel' &&
	        typeof navigator.maxTouchPoints === 'number' &&
	        navigator.maxTouchPoints > 1 &&
	        typeof MSStream === 'undefined');
	};
	function createMatch(userAgent) {
	    return function (regex) { return regex.test(userAgent); };
	}
	function isMobile(param) {
	    var nav = {
	        userAgent: '',
	        platform: '',
	        maxTouchPoints: 0
	    };
	    if (!param && typeof navigator !== 'undefined') {
	        nav = {
	            userAgent: navigator.userAgent,
	            platform: navigator.platform,
	            maxTouchPoints: navigator.maxTouchPoints || 0
	        };
	    }
	    else if (typeof param === 'string') {
	        nav.userAgent = param;
	    }
	    else if (param && param.userAgent) {
	        nav = {
	            userAgent: param.userAgent,
	            platform: param.platform,
	            maxTouchPoints: param.maxTouchPoints || 0
	        };
	    }
	    var userAgent = nav.userAgent;
	    var tmp = userAgent.split('[FBAN');
	    if (typeof tmp[1] !== 'undefined') {
	        userAgent = tmp[0];
	    }
	    tmp = userAgent.split('Twitter');
	    if (typeof tmp[1] !== 'undefined') {
	        userAgent = tmp[0];
	    }
	    var match = createMatch(userAgent);
	    var result = {
	        apple: {
	            phone: match(appleIphone) && !match(windowsPhone),
	            ipod: match(appleIpod),
	            tablet: !match(appleIphone) &&
	                (match(appleTablet) || isAppleTabletOnIos13(nav)) &&
	                !match(windowsPhone),
	            universal: match(appleUniversal),
	            device: (match(appleIphone) ||
	                match(appleIpod) ||
	                match(appleTablet) ||
	                match(appleUniversal) ||
	                isAppleTabletOnIos13(nav)) &&
	                !match(windowsPhone)
	        },
	        amazon: {
	            phone: match(amazonPhone),
	            tablet: !match(amazonPhone) && match(amazonTablet),
	            device: match(amazonPhone) || match(amazonTablet)
	        },
	        android: {
	            phone: (!match(windowsPhone) && match(amazonPhone)) ||
	                (!match(windowsPhone) && match(androidPhone)),
	            tablet: !match(windowsPhone) &&
	                !match(amazonPhone) &&
	                !match(androidPhone) &&
	                (match(amazonTablet) || match(androidTablet)),
	            device: (!match(windowsPhone) &&
	                (match(amazonPhone) ||
	                    match(amazonTablet) ||
	                    match(androidPhone) ||
	                    match(androidTablet))) ||
	                match(/\bokhttp\b/i)
	        },
	        windows: {
	            phone: match(windowsPhone),
	            tablet: match(windowsTablet),
	            device: match(windowsPhone) || match(windowsTablet)
	        },
	        other: {
	            blackberry: match(otherBlackBerry),
	            blackberry10: match(otherBlackBerry10),
	            opera: match(otherOpera),
	            firefox: match(otherFirefox),
	            chrome: match(otherChrome),
	            device: match(otherBlackBerry) ||
	                match(otherBlackBerry10) ||
	                match(otherOpera) ||
	                match(otherFirefox) ||
	                match(otherChrome)
	        },
	        any: false,
	        phone: false,
	        tablet: false
	    };
	    result.any =
	        result.apple.device ||
	            result.android.device ||
	            result.windows.device ||
	            result.other.device;
	    result.phone =
	        result.apple.phone || result.android.phone || result.windows.phone;
	    result.tablet =
	        result.apple.tablet || result.android.tablet || result.windows.tablet;
	    return result;
	}

	/*!
	 * @pixi/settings - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/settings is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	// The ESM/CJS versions of ismobilejs only
	var isMobile$1 = isMobile(window.navigator);

	/**
	 * The maximum recommended texture units to use.
	 * In theory the bigger the better, and for desktop we'll use as many as we can.
	 * But some mobile devices slow down if there is to many branches in the shader.
	 * So in practice there seems to be a sweet spot size that varies depending on the device.
	 *
	 * In v4, all mobile devices were limited to 4 texture units because for this.
	 * In v5, we allow all texture units to be used on modern Apple or Android devices.
	 *
	 * @private
	 * @param {number} max
	 * @returns {number}
	 */
	function maxRecommendedTextures(max) {
	    var allowMax = true;
	    if (isMobile$1.tablet || isMobile$1.phone) {
	        if (isMobile$1.apple.device) {
	            var match = (navigator.userAgent).match(/OS (\d+)_(\d+)?/);
	            if (match) {
	                var majorVersion = parseInt(match[1], 10);
	                // Limit texture units on devices below iOS 11, which will be older hardware
	                if (majorVersion < 11) {
	                    allowMax = false;
	                }
	            }
	        }
	        if (isMobile$1.android.device) {
	            var match = (navigator.userAgent).match(/Android\s([0-9.]*)/);
	            if (match) {
	                var majorVersion = parseInt(match[1], 10);
	                // Limit texture units on devices below Android 7 (Nougat), which will be older hardware
	                if (majorVersion < 7) {
	                    allowMax = false;
	                }
	            }
	        }
	    }
	    return allowMax ? max : 4;
	}

	/**
	 * Uploading the same buffer multiple times in a single frame can cause performance issues.
	 * Apparent on iOS so only check for that at the moment
	 * This check may become more complex if this issue pops up elsewhere.
	 *
	 * @private
	 * @returns {boolean}
	 */
	function canUploadSameBuffer() {
	    return !isMobile$1.apple.device;
	}

	/**
	 * User's customizable globals for overriding the default PIXI settings, such
	 * as a renderer's default resolution, framerate, float precision, etc.
	 * @example
	 * // Use the native window resolution as the default resolution
	 * // will support high-density displays when rendering
	 * PIXI.settings.RESOLUTION = window.devicePixelRatio;
	 *
	 * // Disable interpolation when scaling, will make texture be pixelated
	 * PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
	 * @namespace PIXI.settings
	 */
	var settings = {
	    /**
	     * If set to true WebGL will attempt make textures mimpaped by default.
	     * Mipmapping will only succeed if the base texture uploaded has power of two dimensions.
	     *
	     * @static
	     * @name MIPMAP_TEXTURES
	     * @memberof PIXI.settings
	     * @type {PIXI.MIPMAP_MODES}
	     * @default PIXI.MIPMAP_MODES.POW2
	     */
	    MIPMAP_TEXTURES: 1,
	    /**
	     * Default anisotropic filtering level of textures.
	     * Usually from 0 to 16
	     *
	     * @static
	     * @name ANISOTROPIC_LEVEL
	     * @memberof PIXI.settings
	     * @type {number}
	     * @default 0
	     */
	    ANISOTROPIC_LEVEL: 0,
	    /**
	     * Default resolution / device pixel ratio of the renderer.
	     *
	     * @static
	     * @name RESOLUTION
	     * @memberof PIXI.settings
	     * @type {number}
	     * @default 1
	     */
	    RESOLUTION: 1,
	    /**
	     * Default filter resolution.
	     *
	     * @static
	     * @name FILTER_RESOLUTION
	     * @memberof PIXI.settings
	     * @type {number}
	     * @default 1
	     */
	    FILTER_RESOLUTION: 1,
	    /**
	     * The maximum textures that this device supports.
	     *
	     * @static
	     * @name SPRITE_MAX_TEXTURES
	     * @memberof PIXI.settings
	     * @type {number}
	     * @default 32
	     */
	    SPRITE_MAX_TEXTURES: maxRecommendedTextures(32),
	    // TODO: maybe change to SPRITE.BATCH_SIZE: 2000
	    // TODO: maybe add PARTICLE.BATCH_SIZE: 15000
	    /**
	     * The default sprite batch size.
	     *
	     * The default aims to balance desktop and mobile devices.
	     *
	     * @static
	     * @name SPRITE_BATCH_SIZE
	     * @memberof PIXI.settings
	     * @type {number}
	     * @default 4096
	     */
	    SPRITE_BATCH_SIZE: 4096,
	    /**
	     * The default render options if none are supplied to {@link PIXI.Renderer}
	     * or {@link PIXI.CanvasRenderer}.
	     *
	     * @static
	     * @name RENDER_OPTIONS
	     * @memberof PIXI.settings
	     * @type {object}
	     * @property {HTMLCanvasElement} view=null
	     * @property {number} resolution=1
	     * @property {boolean} antialias=false
	     * @property {boolean} autoDensity=false
	     * @property {boolean} transparent=false
	     * @property {number} backgroundColor=0x000000
	     * @property {boolean} clearBeforeRender=true
	     * @property {boolean} preserveDrawingBuffer=false
	     * @property {number} width=800
	     * @property {number} height=600
	     * @property {boolean} legacy=false
	     */
	    RENDER_OPTIONS: {
	        view: null,
	        antialias: false,
	        autoDensity: false,
	        transparent: false,
	        backgroundColor: 0x000000,
	        clearBeforeRender: true,
	        preserveDrawingBuffer: false,
	        width: 800,
	        height: 600,
	        legacy: false,
	    },
	    /**
	     * Default Garbage Collection mode.
	     *
	     * @static
	     * @name GC_MODE
	     * @memberof PIXI.settings
	     * @type {PIXI.GC_MODES}
	     * @default PIXI.GC_MODES.AUTO
	     */
	    GC_MODE: 0,
	    /**
	     * Default Garbage Collection max idle.
	     *
	     * @static
	     * @name GC_MAX_IDLE
	     * @memberof PIXI.settings
	     * @type {number}
	     * @default 3600
	     */
	    GC_MAX_IDLE: 60 * 60,
	    /**
	     * Default Garbage Collection maximum check count.
	     *
	     * @static
	     * @name GC_MAX_CHECK_COUNT
	     * @memberof PIXI.settings
	     * @type {number}
	     * @default 600
	     */
	    GC_MAX_CHECK_COUNT: 60 * 10,
	    /**
	     * Default wrap modes that are supported by pixi.
	     *
	     * @static
	     * @name WRAP_MODE
	     * @memberof PIXI.settings
	     * @type {PIXI.WRAP_MODES}
	     * @default PIXI.WRAP_MODES.CLAMP
	     */
	    WRAP_MODE: 33071,
	    /**
	     * Default scale mode for textures.
	     *
	     * @static
	     * @name SCALE_MODE
	     * @memberof PIXI.settings
	     * @type {PIXI.SCALE_MODES}
	     * @default PIXI.SCALE_MODES.LINEAR
	     */
	    SCALE_MODE: 1,
	    /**
	     * Default specify float precision in vertex shader.
	     *
	     * @static
	     * @name PRECISION_VERTEX
	     * @memberof PIXI.settings
	     * @type {PIXI.PRECISION}
	     * @default PIXI.PRECISION.HIGH
	     */
	    PRECISION_VERTEX: 'highp',
	    /**
	     * Default specify float precision in fragment shader.
	     * iOS is best set at highp due to https://github.com/pixijs/pixi.js/issues/3742
	     *
	     * @static
	     * @name PRECISION_FRAGMENT
	     * @memberof PIXI.settings
	     * @type {PIXI.PRECISION}
	     * @default PIXI.PRECISION.MEDIUM
	     */
	    PRECISION_FRAGMENT: isMobile$1.apple.device ? 'highp' : 'mediump',
	    /**
	     * Can we upload the same buffer in a single frame?
	     *
	     * @static
	     * @name CAN_UPLOAD_SAME_BUFFER
	     * @memberof PIXI.settings
	     * @type {boolean}
	     */
	    CAN_UPLOAD_SAME_BUFFER: canUploadSameBuffer(),
	    /**
	     * Enables bitmap creation before image load. This feature is experimental.
	     *
	     * @static
	     * @name CREATE_IMAGE_BITMAP
	     * @memberof PIXI.settings
	     * @type {boolean}
	     * @default false
	     */
	    CREATE_IMAGE_BITMAP: false,
	    /**
	     * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
	     * Advantages can include sharper image quality (like text) and faster rendering on canvas.
	     * The main disadvantage is movement of objects may appear less smooth.
	     *
	     * @static
	     * @constant
	     * @memberof PIXI.settings
	     * @type {boolean}
	     * @default false
	     */
	    ROUND_PIXELS: false,
	};

	var eventemitter3 = createCommonjsModule(function (module) {
	'use strict';

	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';

	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}

	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);

	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) { prefix = false; }
	}

	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}

	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }

	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;

	  if (!emitter._events[evt]) { emitter._events[evt] = listener, emitter._eventsCount++; }
	  else if (!emitter._events[evt].fn) { emitter._events[evt].push(listener); }
	  else { emitter._events[evt] = [emitter._events[evt], listener]; }

	  return emitter;
	}

	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) { emitter._events = new Events(); }
	  else { delete emitter._events[evt]; }
	}

	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}

	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;

	  if (this._eventsCount === 0) { return names; }

	  for (name in (events = this._events)) {
	    if (has.call(events, name)) { names.push(prefix ? name.slice(1) : name); }
	  }

	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }

	  return names;
	};

	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];

	  if (!handlers) { return []; }
	  if (handlers.fn) { return [handlers.fn]; }

	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }

	  return ee;
	};

	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];

	  if (!listeners) { return 0; }
	  if (listeners.fn) { return 1; }
	  return listeners.length;
	};

	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var arguments$1 = arguments;

	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) { return false; }

	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;

	  if (listeners.fn) {
	    if (listeners.once) { this.removeListener(event, listeners.fn, undefined, true); }

	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }

	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments$1[i];
	    }

	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;

	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) { this.removeListener(event, listeners[i].fn, undefined, true); }

	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) { for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments$1[j];
	          } }

	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }

	  return true;
	};

	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};

	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};

	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) { return this; }
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }

	  var listeners = this._events[evt];

	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }

	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) { this._events[evt] = events.length === 1 ? events[0] : events; }
	    else { clearEvent(this, evt); }
	  }

	  return this;
	};

	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;

	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) { clearEvent(this, evt); }
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }

	  return this;
	};

	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;

	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;

	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;

	//
	// Expose the module.
	//
	if ('undefined' !== 'object') {
	  module.exports = EventEmitter;
	}
	});

	'use strict';

	var earcut_1 = earcut;
	var default_1 = earcut;

	function earcut(data, holeIndices, dim) {

	    dim = dim || 2;

	    var hasHoles = holeIndices && holeIndices.length,
	        outerLen = hasHoles ? holeIndices[0] * dim : data.length,
	        outerNode = linkedList(data, 0, outerLen, dim, true),
	        triangles = [];

	    if (!outerNode || outerNode.next === outerNode.prev) { return triangles; }

	    var minX, minY, maxX, maxY, x, y, invSize;

	    if (hasHoles) { outerNode = eliminateHoles(data, holeIndices, outerNode, dim); }

	    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
	    if (data.length > 80 * dim) {
	        minX = maxX = data[0];
	        minY = maxY = data[1];

	        for (var i = dim; i < outerLen; i += dim) {
	            x = data[i];
	            y = data[i + 1];
	            if (x < minX) { minX = x; }
	            if (y < minY) { minY = y; }
	            if (x > maxX) { maxX = x; }
	            if (y > maxY) { maxY = y; }
	        }

	        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
	        invSize = Math.max(maxX - minX, maxY - minY);
	        invSize = invSize !== 0 ? 1 / invSize : 0;
	    }

	    earcutLinked(outerNode, triangles, dim, minX, minY, invSize);

	    return triangles;
	}

	// create a circular doubly linked list from polygon points in the specified winding order
	function linkedList(data, start, end, dim, clockwise) {
	    var i, last;

	    if (clockwise === (signedArea(data, start, end, dim) > 0)) {
	        for (i = start; i < end; i += dim) { last = insertNode(i, data[i], data[i + 1], last); }
	    } else {
	        for (i = end - dim; i >= start; i -= dim) { last = insertNode(i, data[i], data[i + 1], last); }
	    }

	    if (last && equals(last, last.next)) {
	        removeNode(last);
	        last = last.next;
	    }

	    return last;
	}

	// eliminate colinear or duplicate points
	function filterPoints(start, end) {
	    if (!start) { return start; }
	    if (!end) { end = start; }

	    var p = start,
	        again;
	    do {
	        again = false;

	        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
	            removeNode(p);
	            p = end = p.prev;
	            if (p === p.next) { break; }
	            again = true;

	        } else {
	            p = p.next;
	        }
	    } while (again || p !== end);

	    return end;
	}

	// main ear slicing loop which triangulates a polygon (given as a linked list)
	function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
	    if (!ear) { return; }

	    // interlink polygon nodes in z-order
	    if (!pass && invSize) { indexCurve(ear, minX, minY, invSize); }

	    var stop = ear,
	        prev, next;

	    // iterate through ears, slicing them one by one
	    while (ear.prev !== ear.next) {
	        prev = ear.prev;
	        next = ear.next;

	        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
	            // cut off the triangle
	            triangles.push(prev.i / dim);
	            triangles.push(ear.i / dim);
	            triangles.push(next.i / dim);

	            removeNode(ear);

	            // skipping the next vertex leads to less sliver triangles
	            ear = next.next;
	            stop = next.next;

	            continue;
	        }

	        ear = next;

	        // if we looped through the whole remaining polygon and can't find any more ears
	        if (ear === stop) {
	            // try filtering points and slicing again
	            if (!pass) {
	                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);

	            // if this didn't work, try curing all small self-intersections locally
	            } else if (pass === 1) {
	                ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
	                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);

	            // as a last resort, try splitting the remaining polygon into two
	            } else if (pass === 2) {
	                splitEarcut(ear, triangles, dim, minX, minY, invSize);
	            }

	            break;
	        }
	    }
	}

	// check whether a polygon node forms a valid ear with adjacent nodes
	function isEar(ear) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;

	    if (area(a, b, c) >= 0) { return false; } // reflex, can't be an ear

	    // now make sure we don't have other points inside the potential ear
	    var p = ear.next.next;

	    while (p !== ear.prev) {
	        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) { return false; }
	        p = p.next;
	    }

	    return true;
	}

	function isEarHashed(ear, minX, minY, invSize) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;

	    if (area(a, b, c) >= 0) { return false; } // reflex, can't be an ear

	    // triangle bbox; min & max are calculated like this for speed
	    var minTX = a.x < b.x ? (a.x < c.x ? a.x : c.x) : (b.x < c.x ? b.x : c.x),
	        minTY = a.y < b.y ? (a.y < c.y ? a.y : c.y) : (b.y < c.y ? b.y : c.y),
	        maxTX = a.x > b.x ? (a.x > c.x ? a.x : c.x) : (b.x > c.x ? b.x : c.x),
	        maxTY = a.y > b.y ? (a.y > c.y ? a.y : c.y) : (b.y > c.y ? b.y : c.y);

	    // z-order range for the current triangle bbox;
	    var minZ = zOrder(minTX, minTY, minX, minY, invSize),
	        maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);

	    var p = ear.prevZ,
	        n = ear.nextZ;

	    // look for points inside the triangle in both directions
	    while (p && p.z >= minZ && n && n.z <= maxZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) { return false; }
	        p = p.prevZ;

	        if (n !== ear.prev && n !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
	            area(n.prev, n, n.next) >= 0) { return false; }
	        n = n.nextZ;
	    }

	    // look for remaining points in decreasing z-order
	    while (p && p.z >= minZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) { return false; }
	        p = p.prevZ;
	    }

	    // look for remaining points in increasing z-order
	    while (n && n.z <= maxZ) {
	        if (n !== ear.prev && n !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
	            area(n.prev, n, n.next) >= 0) { return false; }
	        n = n.nextZ;
	    }

	    return true;
	}

	// go through all polygon nodes and cure small local self-intersections
	function cureLocalIntersections(start, triangles, dim) {
	    var p = start;
	    do {
	        var a = p.prev,
	            b = p.next.next;

	        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {

	            triangles.push(a.i / dim);
	            triangles.push(p.i / dim);
	            triangles.push(b.i / dim);

	            // remove two nodes involved
	            removeNode(p);
	            removeNode(p.next);

	            p = start = b;
	        }
	        p = p.next;
	    } while (p !== start);

	    return filterPoints(p);
	}

	// try splitting polygon into two and triangulate them independently
	function splitEarcut(start, triangles, dim, minX, minY, invSize) {
	    // look for a valid diagonal that divides the polygon into two
	    var a = start;
	    do {
	        var b = a.next.next;
	        while (b !== a.prev) {
	            if (a.i !== b.i && isValidDiagonal(a, b)) {
	                // split the polygon in two by the diagonal
	                var c = splitPolygon(a, b);

	                // filter colinear points around the cuts
	                a = filterPoints(a, a.next);
	                c = filterPoints(c, c.next);

	                // run earcut on each half
	                earcutLinked(a, triangles, dim, minX, minY, invSize);
	                earcutLinked(c, triangles, dim, minX, minY, invSize);
	                return;
	            }
	            b = b.next;
	        }
	        a = a.next;
	    } while (a !== start);
	}

	// link every hole into the outer loop, producing a single-ring polygon without holes
	function eliminateHoles(data, holeIndices, outerNode, dim) {
	    var queue = [],
	        i, len, start, end, list;

	    for (i = 0, len = holeIndices.length; i < len; i++) {
	        start = holeIndices[i] * dim;
	        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	        list = linkedList(data, start, end, dim, false);
	        if (list === list.next) { list.steiner = true; }
	        queue.push(getLeftmost(list));
	    }

	    queue.sort(compareX);

	    // process holes from left to right
	    for (i = 0; i < queue.length; i++) {
	        outerNode = eliminateHole(queue[i], outerNode);
	        outerNode = filterPoints(outerNode, outerNode.next);
	    }

	    return outerNode;
	}

	function compareX(a, b) {
	    return a.x - b.x;
	}

	// find a bridge between vertices that connects hole with an outer ring and and link it
	function eliminateHole(hole, outerNode) {
	    var bridge = findHoleBridge(hole, outerNode);
	    if (!bridge) {
	        return outerNode;
	    }

	    var bridgeReverse = splitPolygon(bridge, hole);

	    // filter collinear points around the cuts
	    var filteredBridge = filterPoints(bridge, bridge.next);
	    filterPoints(bridgeReverse, bridgeReverse.next);

	    // Check if input node was removed by the filtering
	    return outerNode === bridge ? filteredBridge : outerNode;
	}

	// David Eberly's algorithm for finding a bridge between hole and outer polygon
	function findHoleBridge(hole, outerNode) {
	    var p = outerNode,
	        hx = hole.x,
	        hy = hole.y,
	        qx = -Infinity,
	        m;

	    // find a segment intersected by a ray from the hole's leftmost point to the left;
	    // segment's endpoint with lesser x will be potential connection point
	    do {
	        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
	            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
	            if (x <= hx && x > qx) {
	                qx = x;
	                if (x === hx) {
	                    if (hy === p.y) { return p; }
	                    if (hy === p.next.y) { return p.next; }
	                }
	                m = p.x < p.next.x ? p : p.next;
	            }
	        }
	        p = p.next;
	    } while (p !== outerNode);

	    if (!m) { return null; }

	    if (hx === qx) { return m; } // hole touches outer segment; pick leftmost endpoint

	    // look for points inside the triangle of hole point, segment intersection and endpoint;
	    // if there are no points found, we have a valid connection;
	    // otherwise choose the point of the minimum angle with the ray as connection point

	    var stop = m,
	        mx = m.x,
	        my = m.y,
	        tanMin = Infinity,
	        tan;

	    p = m;

	    do {
	        if (hx >= p.x && p.x >= mx && hx !== p.x &&
	                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {

	            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential

	            if (locallyInside(p, hole) &&
	                (tan < tanMin || (tan === tanMin && (p.x > m.x || (p.x === m.x && sectorContainsSector(m, p)))))) {
	                m = p;
	                tanMin = tan;
	            }
	        }

	        p = p.next;
	    } while (p !== stop);

	    return m;
	}

	// whether sector in vertex m contains sector in vertex p in the same coordinates
	function sectorContainsSector(m, p) {
	    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
	}

	// interlink polygon nodes in z-order
	function indexCurve(start, minX, minY, invSize) {
	    var p = start;
	    do {
	        if (p.z === null) { p.z = zOrder(p.x, p.y, minX, minY, invSize); }
	        p.prevZ = p.prev;
	        p.nextZ = p.next;
	        p = p.next;
	    } while (p !== start);

	    p.prevZ.nextZ = null;
	    p.prevZ = null;

	    sortLinked(p);
	}

	// Simon Tatham's linked list merge sort algorithm
	// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
	function sortLinked(list) {
	    var i, p, q, e, tail, numMerges, pSize, qSize,
	        inSize = 1;

	    do {
	        p = list;
	        list = null;
	        tail = null;
	        numMerges = 0;

	        while (p) {
	            numMerges++;
	            q = p;
	            pSize = 0;
	            for (i = 0; i < inSize; i++) {
	                pSize++;
	                q = q.nextZ;
	                if (!q) { break; }
	            }
	            qSize = inSize;

	            while (pSize > 0 || (qSize > 0 && q)) {

	                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
	                    e = p;
	                    p = p.nextZ;
	                    pSize--;
	                } else {
	                    e = q;
	                    q = q.nextZ;
	                    qSize--;
	                }

	                if (tail) { tail.nextZ = e; }
	                else { list = e; }

	                e.prevZ = tail;
	                tail = e;
	            }

	            p = q;
	        }

	        tail.nextZ = null;
	        inSize *= 2;

	    } while (numMerges > 1);

	    return list;
	}

	// z-order of a point given coords and inverse of the longer side of data bbox
	function zOrder(x, y, minX, minY, invSize) {
	    // coords are transformed into non-negative 15-bit integer range
	    x = 32767 * (x - minX) * invSize;
	    y = 32767 * (y - minY) * invSize;

	    x = (x | (x << 8)) & 0x00FF00FF;
	    x = (x | (x << 4)) & 0x0F0F0F0F;
	    x = (x | (x << 2)) & 0x33333333;
	    x = (x | (x << 1)) & 0x55555555;

	    y = (y | (y << 8)) & 0x00FF00FF;
	    y = (y | (y << 4)) & 0x0F0F0F0F;
	    y = (y | (y << 2)) & 0x33333333;
	    y = (y | (y << 1)) & 0x55555555;

	    return x | (y << 1);
	}

	// find the leftmost node of a polygon ring
	function getLeftmost(start) {
	    var p = start,
	        leftmost = start;
	    do {
	        if (p.x < leftmost.x || (p.x === leftmost.x && p.y < leftmost.y)) { leftmost = p; }
	        p = p.next;
	    } while (p !== start);

	    return leftmost;
	}

	// check if a point lies within a convex triangle
	function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
	    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 &&
	           (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 &&
	           (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
	}

	// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
	function isValidDiagonal(a, b) {
	    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
	           (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
	            (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
	            equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
	}

	// signed area of a triangle
	function area(p, q, r) {
	    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
	}

	// check if two points are equal
	function equals(p1, p2) {
	    return p1.x === p2.x && p1.y === p2.y;
	}

	// check if two segments intersect
	function intersects(p1, q1, p2, q2) {
	    var o1 = sign(area(p1, q1, p2));
	    var o2 = sign(area(p1, q1, q2));
	    var o3 = sign(area(p2, q2, p1));
	    var o4 = sign(area(p2, q2, q1));

	    if (o1 !== o2 && o3 !== o4) { return true; } // general case

	    if (o1 === 0 && onSegment(p1, p2, q1)) { return true; } // p1, q1 and p2 are collinear and p2 lies on p1q1
	    if (o2 === 0 && onSegment(p1, q2, q1)) { return true; } // p1, q1 and q2 are collinear and q2 lies on p1q1
	    if (o3 === 0 && onSegment(p2, p1, q2)) { return true; } // p2, q2 and p1 are collinear and p1 lies on p2q2
	    if (o4 === 0 && onSegment(p2, q1, q2)) { return true; } // p2, q2 and q1 are collinear and q1 lies on p2q2

	    return false;
	}

	// for collinear points p, q, r, check if point q lies on segment pr
	function onSegment(p, q, r) {
	    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
	}

	function sign(num) {
	    return num > 0 ? 1 : num < 0 ? -1 : 0;
	}

	// check if a polygon diagonal intersects any polygon segments
	function intersectsPolygon(a, b) {
	    var p = a;
	    do {
	        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
	                intersects(p, p.next, a, b)) { return true; }
	        p = p.next;
	    } while (p !== a);

	    return false;
	}

	// check if a polygon diagonal is locally inside the polygon
	function locallyInside(a, b) {
	    return area(a.prev, a, a.next) < 0 ?
	        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
	        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
	}

	// check if the middle point of a polygon diagonal is inside the polygon
	function middleInside(a, b) {
	    var p = a,
	        inside = false,
	        px = (a.x + b.x) / 2,
	        py = (a.y + b.y) / 2;
	    do {
	        if (((p.y > py) !== (p.next.y > py)) && p.next.y !== p.y &&
	                (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
	            { inside = !inside; }
	        p = p.next;
	    } while (p !== a);

	    return inside;
	}

	// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
	// if one belongs to the outer ring and another to a hole, it merges it into a single ring
	function splitPolygon(a, b) {
	    var a2 = new Node(a.i, a.x, a.y),
	        b2 = new Node(b.i, b.x, b.y),
	        an = a.next,
	        bp = b.prev;

	    a.next = b;
	    b.prev = a;

	    a2.next = an;
	    an.prev = a2;

	    b2.next = a2;
	    a2.prev = b2;

	    bp.next = b2;
	    b2.prev = bp;

	    return b2;
	}

	// create a node and optionally link it with previous one (in a circular doubly linked list)
	function insertNode(i, x, y, last) {
	    var p = new Node(i, x, y);

	    if (!last) {
	        p.prev = p;
	        p.next = p;

	    } else {
	        p.next = last.next;
	        p.prev = last;
	        last.next.prev = p;
	        last.next = p;
	    }
	    return p;
	}

	function removeNode(p) {
	    p.next.prev = p.prev;
	    p.prev.next = p.next;

	    if (p.prevZ) { p.prevZ.nextZ = p.nextZ; }
	    if (p.nextZ) { p.nextZ.prevZ = p.prevZ; }
	}

	function Node(i, x, y) {
	    // vertex index in coordinates array
	    this.i = i;

	    // vertex coordinates
	    this.x = x;
	    this.y = y;

	    // previous and next vertex nodes in a polygon ring
	    this.prev = null;
	    this.next = null;

	    // z-order curve value
	    this.z = null;

	    // previous and next nodes in z-order
	    this.prevZ = null;
	    this.nextZ = null;

	    // indicates whether this is a steiner point
	    this.steiner = false;
	}

	// return a percentage difference between the polygon area and its triangulation area;
	// used to verify correctness of triangulation
	earcut.deviation = function (data, holeIndices, dim, triangles) {
	    var hasHoles = holeIndices && holeIndices.length;
	    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;

	    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
	    if (hasHoles) {
	        for (var i = 0, len = holeIndices.length; i < len; i++) {
	            var start = holeIndices[i] * dim;
	            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	            polygonArea -= Math.abs(signedArea(data, start, end, dim));
	        }
	    }

	    var trianglesArea = 0;
	    for (i = 0; i < triangles.length; i += 3) {
	        var a = triangles[i] * dim;
	        var b = triangles[i + 1] * dim;
	        var c = triangles[i + 2] * dim;
	        trianglesArea += Math.abs(
	            (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
	            (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
	    }

	    return polygonArea === 0 && trianglesArea === 0 ? 0 :
	        Math.abs((trianglesArea - polygonArea) / polygonArea);
	};

	function signedArea(data, start, end, dim) {
	    var sum = 0;
	    for (var i = start, j = end - dim; i < end; i += dim) {
	        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
	        j = i;
	    }
	    return sum;
	}

	// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
	earcut.flatten = function (data) {
	    var dim = data[0][0].length,
	        result = {vertices: [], holes: [], dimensions: dim},
	        holeIndex = 0;

	    for (var i = 0; i < data.length; i++) {
	        for (var j = 0; j < data[i].length; j++) {
	            for (var d = 0; d < dim; d++) { result.vertices.push(data[i][j][d]); }
	        }
	        if (i > 0) {
	            holeIndex += data[i - 1].length;
	            result.holes.push(holeIndex);
	        }
	    }
	    return result;
	};
	earcut_1.default = default_1;

	var punycode = createCommonjsModule(function (module, exports) {
	/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {

		/** Detect free variables */
		var freeExports = 'object' == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = 'object' == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}

		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,

		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'

		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},

		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,

		/** Temporary variable */
		key;

		/*--------------------------------------------------------------------------*/

		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}

		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}

		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}

		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}

		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}

		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}

		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}

		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}

		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;

			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.

			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}

			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}

			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.

			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

					if (index >= inputLength) {
						error('invalid-input');
					}

					digit = basicToDigit(input.charCodeAt(index++));

					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}

					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

					if (digit < t) {
						break;
					}

					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}

					w *= baseMinusT;

				}

				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);

				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}

				n += floor(i / out);
				i %= out;

				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);

			}

			return ucs2encode(output);
		}

		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;

			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);

			// Cache the length
			inputLength = input.length;

			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;

			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}

			handledCPCount = basicLength = output.length;

			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.

			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}

			// Main encoding loop:
			while (handledCPCount < inputLength) {

				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}

				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}

				delta += (m - n) * handledCPCountPlusOne;
				n = m;

				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];

					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}

					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}

						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}

				++delta;
				++n;

			}
			return output.join('');
		}

		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}

		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}

		/*--------------------------------------------------------------------------*/

		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};

		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			typeof undefined == 'function' &&
			typeof undefined.amd == 'object' &&
			undefined.amd
		) {
			undefined('punycode', function() {
				return punycode;
			});
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}

	}(commonjsGlobal));
	});

	'use strict';

	var util = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};
	var util_1 = util.isString;
	var util_2 = util.isObject;
	var util_3 = util.isNull;
	var util_4 = util.isNullOrUndefined;

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	'use strict';

	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty$1(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

	var decode = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};

	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }

	  var regexp = /\+/g;
	  qs = qs.split(sep);

	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }

	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }

	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;

	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }

	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);

	    if (!hasOwnProperty$1(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }

	  return obj;
	};

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	'use strict';

	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;

	    case 'boolean':
	      return v ? 'true' : 'false';

	    case 'number':
	      return isFinite(v) ? v : '';

	    default:
	      return '';
	  }
	};

	var encode = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }

	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);

	  }

	  if (!name) { return ''; }
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};

	var querystring = createCommonjsModule(function (module, exports) {
	'use strict';

	exports.decode = exports.parse = decode;
	exports.encode = exports.stringify = encode;
	});
	var querystring_1 = querystring.decode;
	var querystring_2 = querystring.parse;
	var querystring_3 = querystring.encode;
	var querystring_4 = querystring.stringify;

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	'use strict';




	var parse = urlParse;
	var resolve = urlResolve;
	var resolveObject = urlResolveObject;
	var format = urlFormat;

	var Url_1 = Url;

	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}

	// Reference: RFC 3986, RFC 1808, RFC 2396

	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,

	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    };

	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) { return url; }

	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}

	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }

	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);

	  var rest = url;

	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();

	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }

	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }

	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }

	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {

	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c

	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.

	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        { hostEnd = hec; }
	    }

	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }

	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }

	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        { hostEnd = hec; }
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      { hostEnd = rest.length; }

	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);

	    // pull out port.
	    this.parseHost();

	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';

	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';

	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) { continue; }
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }

	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }

	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }

	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;

	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }

	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {

	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        { continue; }
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }


	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) { this.pathname = rest; }
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }

	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }

	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};

	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) { obj = urlParse(obj); }
	  if (!(obj instanceof Url)) { return Url.prototype.format.call(obj); }
	  return obj.format();
	}

	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }

	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';

	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }

	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }

	  var search = this.search || (query && ('?' + query)) || '';

	  if (protocol && protocol.substr(-1) !== ':') { protocol += ':'; }

	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') { pathname = '/' + pathname; }
	  } else if (!host) {
	    host = '';
	  }

	  if (hash && hash.charAt(0) !== '#') { hash = '#' + hash; }
	  if (search && search.charAt(0) !== '?') { search = '?' + search; }

	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');

	  return protocol + host + pathname + search + hash;
	};

	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}

	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};

	function urlResolveObject(source, relative) {
	  if (!source) { return relative; }
	  return urlParse(source, false, true).resolveObject(relative);
	}

	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }

	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }

	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;

	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }

	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        { result[rkey] = relative[rkey]; }
	    }

	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }

	    result.href = result.format();
	    return result;
	  }

	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }

	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift())){ ; }
	      if (!relative.host) { relative.host = ''; }
	      if (!relative.hostname) { relative.hostname = ''; }
	      if (relPath[0] !== '') { relPath.unshift(''); }
	      if (relPath.length < 2) { relPath.unshift(''); }
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }

	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];

	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') { srcPath[0] = result.host; }
	      else { srcPath.unshift(result.host); }
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') { relPath[0] = relative.host; }
	        else { relPath.unshift(relative.host); }
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }

	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) { srcPath = []; }
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }

	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }

	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');

	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }

	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }

	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }

	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }

	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');

	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }

	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }

	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }

	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};

	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) { this.hostname = host; }
	};

	var url = {
		parse: parse,
		resolve: resolve,
		resolveObject: resolveObject,
		format: format,
		Url: Url_1
	};

	/*!
	 * @pixi/constants - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/constants is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */
	/**
	 * Different types of environments for WebGL.
	 *
	 * @static
	 * @memberof PIXI
	 * @name ENV
	 * @enum {number}
	 * @property {number} WEBGL_LEGACY - Used for older v1 WebGL devices. PixiJS will aim to ensure compatibility
	 *  with older / less advanced devices. If you experience unexplained flickering prefer this environment.
	 * @property {number} WEBGL - Version 1 of WebGL
	 * @property {number} WEBGL2 - Version 2 of WebGL
	 */

	(function (ENV) {
	    ENV[ENV["WEBGL_LEGACY"] = 0] = "WEBGL_LEGACY";
	    ENV[ENV["WEBGL"] = 1] = "WEBGL";
	    ENV[ENV["WEBGL2"] = 2] = "WEBGL2";
	})(exports.ENV || (exports.ENV = {}));
	/**
	 * Constant to identify the Renderer Type.
	 *
	 * @static
	 * @memberof PIXI
	 * @name RENDERER_TYPE
	 * @enum {number}
	 * @property {number} UNKNOWN - Unknown render type.
	 * @property {number} WEBGL - WebGL render type.
	 * @property {number} CANVAS - Canvas render type.
	 */

	(function (RENDERER_TYPE) {
	    RENDERER_TYPE[RENDERER_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
	    RENDERER_TYPE[RENDERER_TYPE["WEBGL"] = 1] = "WEBGL";
	    RENDERER_TYPE[RENDERER_TYPE["CANVAS"] = 2] = "CANVAS";
	})(exports.RENDERER_TYPE || (exports.RENDERER_TYPE = {}));
	/**
	 * Bitwise OR of masks that indicate the buffers to be cleared.
	 *
	 * @static
	 * @memberof PIXI
	 * @name BUFFER_BITS
	 * @enum {number}
	 * @property {number} COLOR - Indicates the buffers currently enabled for color writing.
	 * @property {number} DEPTH - Indicates the depth buffer.
	 * @property {number} STENCIL - Indicates the stencil buffer.
	 */

	(function (BUFFER_BITS) {
	    BUFFER_BITS[BUFFER_BITS["COLOR"] = 16384] = "COLOR";
	    BUFFER_BITS[BUFFER_BITS["DEPTH"] = 256] = "DEPTH";
	    BUFFER_BITS[BUFFER_BITS["STENCIL"] = 1024] = "STENCIL";
	})(exports.BUFFER_BITS || (exports.BUFFER_BITS = {}));
	/**
	 * Various blend modes supported by PIXI.
	 *
	 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
	 * Anything else will silently act like NORMAL.
	 *
	 * @memberof PIXI
	 * @name BLEND_MODES
	 * @enum {number}
	 * @property {number} NORMAL
	 * @property {number} ADD
	 * @property {number} MULTIPLY
	 * @property {number} SCREEN
	 * @property {number} OVERLAY
	 * @property {number} DARKEN
	 * @property {number} LIGHTEN
	 * @property {number} COLOR_DODGE
	 * @property {number} COLOR_BURN
	 * @property {number} HARD_LIGHT
	 * @property {number} SOFT_LIGHT
	 * @property {number} DIFFERENCE
	 * @property {number} EXCLUSION
	 * @property {number} HUE
	 * @property {number} SATURATION
	 * @property {number} COLOR
	 * @property {number} LUMINOSITY
	 * @property {number} NORMAL_NPM
	 * @property {number} ADD_NPM
	 * @property {number} SCREEN_NPM
	 * @property {number} NONE
	 * @property {number} SRC_IN
	 * @property {number} SRC_OUT
	 * @property {number} SRC_ATOP
	 * @property {number} DST_OVER
	 * @property {number} DST_IN
	 * @property {number} DST_OUT
	 * @property {number} DST_ATOP
	 * @property {number} SUBTRACT
	 * @property {number} SRC_OVER
	 * @property {number} ERASE
	 * @property {number} XOR
	 */

	(function (BLEND_MODES) {
	    BLEND_MODES[BLEND_MODES["NORMAL"] = 0] = "NORMAL";
	    BLEND_MODES[BLEND_MODES["ADD"] = 1] = "ADD";
	    BLEND_MODES[BLEND_MODES["MULTIPLY"] = 2] = "MULTIPLY";
	    BLEND_MODES[BLEND_MODES["SCREEN"] = 3] = "SCREEN";
	    BLEND_MODES[BLEND_MODES["OVERLAY"] = 4] = "OVERLAY";
	    BLEND_MODES[BLEND_MODES["DARKEN"] = 5] = "DARKEN";
	    BLEND_MODES[BLEND_MODES["LIGHTEN"] = 6] = "LIGHTEN";
	    BLEND_MODES[BLEND_MODES["COLOR_DODGE"] = 7] = "COLOR_DODGE";
	    BLEND_MODES[BLEND_MODES["COLOR_BURN"] = 8] = "COLOR_BURN";
	    BLEND_MODES[BLEND_MODES["HARD_LIGHT"] = 9] = "HARD_LIGHT";
	    BLEND_MODES[BLEND_MODES["SOFT_LIGHT"] = 10] = "SOFT_LIGHT";
	    BLEND_MODES[BLEND_MODES["DIFFERENCE"] = 11] = "DIFFERENCE";
	    BLEND_MODES[BLEND_MODES["EXCLUSION"] = 12] = "EXCLUSION";
	    BLEND_MODES[BLEND_MODES["HUE"] = 13] = "HUE";
	    BLEND_MODES[BLEND_MODES["SATURATION"] = 14] = "SATURATION";
	    BLEND_MODES[BLEND_MODES["COLOR"] = 15] = "COLOR";
	    BLEND_MODES[BLEND_MODES["LUMINOSITY"] = 16] = "LUMINOSITY";
	    BLEND_MODES[BLEND_MODES["NORMAL_NPM"] = 17] = "NORMAL_NPM";
	    BLEND_MODES[BLEND_MODES["ADD_NPM"] = 18] = "ADD_NPM";
	    BLEND_MODES[BLEND_MODES["SCREEN_NPM"] = 19] = "SCREEN_NPM";
	    BLEND_MODES[BLEND_MODES["NONE"] = 20] = "NONE";
	    BLEND_MODES[BLEND_MODES["SRC_OVER"] = 0] = "SRC_OVER";
	    BLEND_MODES[BLEND_MODES["SRC_IN"] = 21] = "SRC_IN";
	    BLEND_MODES[BLEND_MODES["SRC_OUT"] = 22] = "SRC_OUT";
	    BLEND_MODES[BLEND_MODES["SRC_ATOP"] = 23] = "SRC_ATOP";
	    BLEND_MODES[BLEND_MODES["DST_OVER"] = 24] = "DST_OVER";
	    BLEND_MODES[BLEND_MODES["DST_IN"] = 25] = "DST_IN";
	    BLEND_MODES[BLEND_MODES["DST_OUT"] = 26] = "DST_OUT";
	    BLEND_MODES[BLEND_MODES["DST_ATOP"] = 27] = "DST_ATOP";
	    BLEND_MODES[BLEND_MODES["ERASE"] = 26] = "ERASE";
	    BLEND_MODES[BLEND_MODES["SUBTRACT"] = 28] = "SUBTRACT";
	    BLEND_MODES[BLEND_MODES["XOR"] = 29] = "XOR";
	})(exports.BLEND_MODES || (exports.BLEND_MODES = {}));
	/**
	 * Various webgl draw modes. These can be used to specify which GL drawMode to use
	 * under certain situations and renderers.
	 *
	 * @memberof PIXI
	 * @static
	 * @name DRAW_MODES
	 * @enum {number}
	 * @property {number} POINTS
	 * @property {number} LINES
	 * @property {number} LINE_LOOP
	 * @property {number} LINE_STRIP
	 * @property {number} TRIANGLES
	 * @property {number} TRIANGLE_STRIP
	 * @property {number} TRIANGLE_FAN
	 */

	(function (DRAW_MODES) {
	    DRAW_MODES[DRAW_MODES["POINTS"] = 0] = "POINTS";
	    DRAW_MODES[DRAW_MODES["LINES"] = 1] = "LINES";
	    DRAW_MODES[DRAW_MODES["LINE_LOOP"] = 2] = "LINE_LOOP";
	    DRAW_MODES[DRAW_MODES["LINE_STRIP"] = 3] = "LINE_STRIP";
	    DRAW_MODES[DRAW_MODES["TRIANGLES"] = 4] = "TRIANGLES";
	    DRAW_MODES[DRAW_MODES["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
	    DRAW_MODES[DRAW_MODES["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
	})(exports.DRAW_MODES || (exports.DRAW_MODES = {}));
	/**
	 * Various GL texture/resources formats.
	 *
	 * @memberof PIXI
	 * @static
	 * @name FORMATS
	 * @enum {number}
	 * @property {number} RGBA=6408
	 * @property {number} RGB=6407
	 * @property {number} ALPHA=6406
	 * @property {number} LUMINANCE=6409
	 * @property {number} LUMINANCE_ALPHA=6410
	 * @property {number} DEPTH_COMPONENT=6402
	 * @property {number} DEPTH_STENCIL=34041
	 */

	(function (FORMATS) {
	    FORMATS[FORMATS["RGBA"] = 6408] = "RGBA";
	    FORMATS[FORMATS["RGB"] = 6407] = "RGB";
	    FORMATS[FORMATS["ALPHA"] = 6406] = "ALPHA";
	    FORMATS[FORMATS["LUMINANCE"] = 6409] = "LUMINANCE";
	    FORMATS[FORMATS["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
	    FORMATS[FORMATS["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
	    FORMATS[FORMATS["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
	})(exports.FORMATS || (exports.FORMATS = {}));
	/**
	 * Various GL target types.
	 *
	 * @memberof PIXI
	 * @static
	 * @name TARGETS
	 * @enum {number}
	 * @property {number} TEXTURE_2D=3553
	 * @property {number} TEXTURE_CUBE_MAP=34067
	 * @property {number} TEXTURE_2D_ARRAY=35866
	 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_X=34069
	 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_X=34070
	 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Y=34071
	 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Y=34072
	 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Z=34073
	 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Z=34074
	 */

	(function (TARGETS) {
	    TARGETS[TARGETS["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
	    TARGETS[TARGETS["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
	    TARGETS[TARGETS["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
	    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
	    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
	    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
	    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
	    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
	    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
	})(exports.TARGETS || (exports.TARGETS = {}));
	/**
	 * Various GL data format types.
	 *
	 * @memberof PIXI
	 * @static
	 * @name TYPES
	 * @enum {number}
	 * @property {number} UNSIGNED_BYTE=5121
	 * @property {number} UNSIGNED_SHORT=5123
	 * @property {number} UNSIGNED_SHORT_5_6_5=33635
	 * @property {number} UNSIGNED_SHORT_4_4_4_4=32819
	 * @property {number} UNSIGNED_SHORT_5_5_5_1=32820
	 * @property {number} FLOAT=5126
	 * @property {number} HALF_FLOAT=36193
	 */

	(function (TYPES) {
	    TYPES[TYPES["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
	    TYPES[TYPES["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
	    TYPES[TYPES["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
	    TYPES[TYPES["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
	    TYPES[TYPES["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
	    TYPES[TYPES["FLOAT"] = 5126] = "FLOAT";
	    TYPES[TYPES["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
	})(exports.TYPES || (exports.TYPES = {}));
	/**
	 * The scale modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
	 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
	 *
	 * @memberof PIXI
	 * @static
	 * @name SCALE_MODES
	 * @enum {number}
	 * @property {number} LINEAR Smooth scaling
	 * @property {number} NEAREST Pixelating scaling
	 */

	(function (SCALE_MODES) {
	    SCALE_MODES[SCALE_MODES["NEAREST"] = 0] = "NEAREST";
	    SCALE_MODES[SCALE_MODES["LINEAR"] = 1] = "LINEAR";
	})(exports.SCALE_MODES || (exports.SCALE_MODES = {}));
	/**
	 * The wrap modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
	 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
	 * If the texture is non power of two then clamp will be used regardless as WebGL can
	 * only use REPEAT if the texture is po2.
	 *
	 * This property only affects WebGL.
	 *
	 * @name WRAP_MODES
	 * @memberof PIXI
	 * @static
	 * @enum {number}
	 * @property {number} CLAMP - The textures uvs are clamped
	 * @property {number} REPEAT - The texture uvs tile and repeat
	 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
	 */

	(function (WRAP_MODES) {
	    WRAP_MODES[WRAP_MODES["CLAMP"] = 33071] = "CLAMP";
	    WRAP_MODES[WRAP_MODES["REPEAT"] = 10497] = "REPEAT";
	    WRAP_MODES[WRAP_MODES["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
	})(exports.WRAP_MODES || (exports.WRAP_MODES = {}));
	/**
	 * Mipmap filtering modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.MIPMAP_TEXTURES} affects default texture filtering.
	 * Mipmaps are generated for a baseTexture if its `mipmap` field is `ON`,
	 * or its `POW2` and texture dimensions are powers of 2.
	 * Due to platform restriction, `ON` option will work like `POW2` for webgl-1.
	 *
	 * This property only affects WebGL.
	 *
	 * @name MIPMAP_MODES
	 * @memberof PIXI
	 * @static
	 * @enum {number}
	 * @property {number} OFF - No mipmaps
	 * @property {number} POW2 - Generate mipmaps if texture dimensions are pow2
	 * @property {number} ON - Always generate mipmaps
	 */

	(function (MIPMAP_MODES) {
	    MIPMAP_MODES[MIPMAP_MODES["OFF"] = 0] = "OFF";
	    MIPMAP_MODES[MIPMAP_MODES["POW2"] = 1] = "POW2";
	    MIPMAP_MODES[MIPMAP_MODES["ON"] = 2] = "ON";
	})(exports.MIPMAP_MODES || (exports.MIPMAP_MODES = {}));
	/**
	 * How to treat textures with premultiplied alpha
	 *
	 * @name ALPHA_MODES
	 * @memberof PIXI
	 * @static
	 * @enum {number}
	 * @property {number} NO_PREMULTIPLIED_ALPHA - Source is not premultiplied, leave it like that.
	 *  Option for compressed and data textures that are created from typed arrays.
	 * @property {number} PREMULTIPLY_ON_UPLOAD - Source is not premultiplied, premultiply on upload.
	 *  Default option, used for all loaded images.
	 * @property {number} PREMULTIPLIED_ALPHA - Source is already premultiplied
	 *  Example: spine atlases with `_pma` suffix.
	 * @property {number} NPM - Alias for NO_PREMULTIPLIED_ALPHA.
	 * @property {number} UNPACK - Default option, alias for PREMULTIPLY_ON_UPLOAD.
	 * @property {number} PMA - Alias for PREMULTIPLIED_ALPHA.
	 */

	(function (ALPHA_MODES) {
	    ALPHA_MODES[ALPHA_MODES["NPM"] = 0] = "NPM";
	    ALPHA_MODES[ALPHA_MODES["UNPACK"] = 1] = "UNPACK";
	    ALPHA_MODES[ALPHA_MODES["PMA"] = 2] = "PMA";
	    ALPHA_MODES[ALPHA_MODES["NO_PREMULTIPLIED_ALPHA"] = 0] = "NO_PREMULTIPLIED_ALPHA";
	    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ON_UPLOAD"] = 1] = "PREMULTIPLY_ON_UPLOAD";
	    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ALPHA"] = 2] = "PREMULTIPLY_ALPHA";
	})(exports.ALPHA_MODES || (exports.ALPHA_MODES = {}));
	/**
	 * How to clear renderTextures in filter
	 *
	 * @name CLEAR_MODES
	 * @memberof PIXI
	 * @static
	 * @enum {number}
	 * @property {number} BLEND - Preserve the information in the texture, blend above
	 * @property {number} CLEAR - Must use `gl.clear` operation
	 * @property {number} BLIT - Clear or blit it, depends on device and level of paranoia
	 * @property {number} NO - Alias for BLEND, same as `false` in earlier versions
	 * @property {number} YES - Alias for CLEAR, same as `true` in earlier versions
	 * @property {number} AUTO - Alias for BLIT
	 */

	(function (CLEAR_MODES) {
	    CLEAR_MODES[CLEAR_MODES["NO"] = 0] = "NO";
	    CLEAR_MODES[CLEAR_MODES["YES"] = 1] = "YES";
	    CLEAR_MODES[CLEAR_MODES["AUTO"] = 2] = "AUTO";
	    CLEAR_MODES[CLEAR_MODES["BLEND"] = 0] = "BLEND";
	    CLEAR_MODES[CLEAR_MODES["CLEAR"] = 1] = "CLEAR";
	    CLEAR_MODES[CLEAR_MODES["BLIT"] = 2] = "BLIT";
	})(exports.CLEAR_MODES || (exports.CLEAR_MODES = {}));
	/**
	 * The gc modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
	 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
	 * used for a specified period of time they will be removed from the GPU. They will of course
	 * be uploaded again when they are required. This is a silent behind the scenes process that
	 * should ensure that the GPU does not  get filled up.
	 *
	 * Handy for mobile devices!
	 * This property only affects WebGL.
	 *
	 * @name GC_MODES
	 * @enum {number}
	 * @static
	 * @memberof PIXI
	 * @property {number} AUTO - Garbage collection will happen periodically automatically
	 * @property {number} MANUAL - Garbage collection will need to be called manually
	 */

	(function (GC_MODES) {
	    GC_MODES[GC_MODES["AUTO"] = 0] = "AUTO";
	    GC_MODES[GC_MODES["MANUAL"] = 1] = "MANUAL";
	})(exports.GC_MODES || (exports.GC_MODES = {}));
	/**
	 * Constants that specify float precision in shaders.
	 *
	 * @name PRECISION
	 * @memberof PIXI
	 * @constant
	 * @static
	 * @enum {string}
	 * @property {string} LOW='lowp'
	 * @property {string} MEDIUM='mediump'
	 * @property {string} HIGH='highp'
	 */

	(function (PRECISION) {
	    PRECISION["LOW"] = "lowp";
	    PRECISION["MEDIUM"] = "mediump";
	    PRECISION["HIGH"] = "highp";
	})(exports.PRECISION || (exports.PRECISION = {}));
	/**
	 * Constants for mask implementations.
	 * We use `type` suffix because it leads to very different behaviours
	 *
	 * @name MASK_TYPES
	 * @memberof PIXI
	 * @static
	 * @enum {number}
	 * @property {number} NONE - Mask is ignored
	 * @property {number} SCISSOR - Scissor mask, rectangle on screen, cheap
	 * @property {number} STENCIL - Stencil mask, 1-bit, medium, works only if renderer supports stencil
	 * @property {number} SPRITE - Mask that uses SpriteMaskFilter, uses temporary RenderTexture
	 */

	(function (MASK_TYPES) {
	    MASK_TYPES[MASK_TYPES["NONE"] = 0] = "NONE";
	    MASK_TYPES[MASK_TYPES["SCISSOR"] = 1] = "SCISSOR";
	    MASK_TYPES[MASK_TYPES["STENCIL"] = 2] = "STENCIL";
	    MASK_TYPES[MASK_TYPES["SPRITE"] = 3] = "SPRITE";
	})(exports.MASK_TYPES || (exports.MASK_TYPES = {}));
	/**
	 * Constants for multi-sampling antialiasing.
	 *
	 * @see PIXI.Framebuffer#multisample
	 *
	 * @name MSAA_QUALITY
	 * @memberof PIXI
	 * @static
	 * @enum {number}
	 * @property {number} NONE - No multisampling for this renderTexture
	 * @property {number} LOW - Try 2 samples
	 * @property {number} MEDIUM - Try 4 samples
	 * @property {number} HIGH - Try 8 samples
	 */

	(function (MSAA_QUALITY) {
	    MSAA_QUALITY[MSAA_QUALITY["NONE"] = 0] = "NONE";
	    MSAA_QUALITY[MSAA_QUALITY["LOW"] = 2] = "LOW";
	    MSAA_QUALITY[MSAA_QUALITY["MEDIUM"] = 4] = "MEDIUM";
	    MSAA_QUALITY[MSAA_QUALITY["HIGH"] = 8] = "HIGH";
	})(exports.MSAA_QUALITY || (exports.MSAA_QUALITY = {}));

	/*!
	 * @pixi/utils - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/utils is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * The prefix that denotes a URL is for a retina asset.
	 *
	 * @static
	 * @name RETINA_PREFIX
	 * @memberof PIXI.settings
	 * @type {RegExp}
	 * @default /@([0-9\.]+)x/
	 * @example `@2x`
	 */
	settings.RETINA_PREFIX = /@([0-9\.]+)x/;
	/**
	 * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported` function.
	 * For most scenarios this should be left as true, as otherwise the user may have a poor experience.
	 * However, it can be useful to disable under certain scenarios, such as headless unit tests.
	 *
	 * @static
	 * @name FAIL_IF_MAJOR_PERFORMANCE_CAVEAT
	 * @memberof PIXI.settings
	 * @type {boolean}
	 * @default true
	 */
	settings.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = true;

	var saidHello = false;
	var VERSION = '5.3.11';
	/**
	 * Skips the hello message of renderers that are created after this is run.
	 *
	 * @function skipHello
	 * @memberof PIXI.utils
	 */
	function skipHello() {
	    saidHello = true;
	}
	/**
	 * Logs out the version and renderer information for this running instance of PIXI.
	 * If you don't want to see this message you can run `PIXI.utils.skipHello()` before
	 * creating your renderer. Keep in mind that doing that will forever make you a jerk face.
	 *
	 * @static
	 * @function sayHello
	 * @memberof PIXI.utils
	 * @param {string} type - The string renderer type to log.
	 */
	function sayHello(type) {
	    var _a;
	    if (saidHello) {
	        return;
	    }
	    if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
	        var args = [
	            "\n %c %c %c PixiJS " + VERSION + " - \u2730 " + type + " \u2730  %c  %c  http://www.pixijs.com/  %c %c \u2665%c\u2665%c\u2665 \n\n",
	            'background: #ff66a5; padding:5px 0;',
	            'background: #ff66a5; padding:5px 0;',
	            'color: #ff66a5; background: #030307; padding:5px 0;',
	            'background: #ff66a5; padding:5px 0;',
	            'background: #ffc3dc; padding:5px 0;',
	            'background: #ff66a5; padding:5px 0;',
	            'color: #ff2424; background: #fff; padding:5px 0;',
	            'color: #ff2424; background: #fff; padding:5px 0;',
	            'color: #ff2424; background: #fff; padding:5px 0;' ];
	        (_a = window.console).log.apply(_a, args);
	    }
	    else if (window.console) {
	        window.console.log("PixiJS " + VERSION + " - " + type + " - http://www.pixijs.com/");
	    }
	    saidHello = true;
	}

	var supported;
	/**
	 * Helper for checking for WebGL support.
	 *
	 * @memberof PIXI.utils
	 * @function isWebGLSupported
	 * @return {boolean} Is WebGL supported.
	 */
	function isWebGLSupported() {
	    if (typeof supported === 'undefined') {
	        supported = (function supported() {
	            var contextOptions = {
	                stencil: true,
	                failIfMajorPerformanceCaveat: settings.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT,
	            };
	            try {
	                if (!window.WebGLRenderingContext) {
	                    return false;
	                }
	                var canvas = document.createElement('canvas');
	                var gl = (canvas.getContext('webgl', contextOptions)
	                    || canvas.getContext('experimental-webgl', contextOptions));
	                var success = !!(gl && gl.getContextAttributes().stencil);
	                if (gl) {
	                    var loseContext = gl.getExtension('WEBGL_lose_context');
	                    if (loseContext) {
	                        loseContext.loseContext();
	                    }
	                }
	                gl = null;
	                return success;
	            }
	            catch (e) {
	                return false;
	            }
	        })();
	    }
	    return supported;
	}

	/**
	 * Converts a hexadecimal color number to an [R, G, B] array of normalized floats (numbers from 0.0 to 1.0).
	 *
	 * @example
	 * PIXI.utils.hex2rgb(0xffffff); // returns [1, 1, 1]
	 * @memberof PIXI.utils
	 * @function hex2rgb
	 * @param {number} hex - The hexadecimal number to convert
	 * @param  {number[]} [out=[]] - If supplied, this array will be used rather than returning a new one
	 * @return {number[]} An array representing the [R, G, B] of the color where all values are floats.
	 */
	function hex2rgb(hex, out) {
	    if (out === void 0) { out = []; }
	    out[0] = ((hex >> 16) & 0xFF) / 255;
	    out[1] = ((hex >> 8) & 0xFF) / 255;
	    out[2] = (hex & 0xFF) / 255;
	    return out;
	}
	/**
	 * Converts a hexadecimal color number to a string.
	 *
	 * @example
	 * PIXI.utils.hex2string(0xffffff); // returns "#ffffff"
	 * @memberof PIXI.utils
	 * @function hex2string
	 * @param {number} hex - Number in hex (e.g., `0xffffff`)
	 * @return {string} The string color (e.g., `"#ffffff"`).
	 */
	function hex2string(hex) {
	    var hexString = hex.toString(16);
	    hexString = '000000'.substr(0, 6 - hexString.length) + hexString;
	    return "#" + hexString;
	}
	/**
	 * Converts a hexadecimal string to a hexadecimal color number.
	 *
	 * @example
	 * PIXI.utils.string2hex("#ffffff"); // returns 0xffffff
	 * @memberof PIXI.utils
	 * @function string2hex
	 * @param {string} string - The string color (e.g., `"#ffffff"`)
	 * @return {number} Number in hexadecimal.
	 */
	function string2hex(string) {
	    if (typeof string === 'string' && string[0] === '#') {
	        string = string.substr(1);
	    }
	    return parseInt(string, 16);
	}
	/**
	 * Converts a color as an [R, G, B] array of normalized floats to a hexadecimal number.
	 *
	 * @example
	 * PIXI.utils.rgb2hex([1, 1, 1]); // returns 0xffffff
	 * @memberof PIXI.utils
	 * @function rgb2hex
	 * @param {number[]} rgb - Array of numbers where all values are normalized floats from 0.0 to 1.0.
	 * @return {number} Number in hexadecimal.
	 */
	function rgb2hex(rgb) {
	    return (((rgb[0] * 255) << 16) + ((rgb[1] * 255) << 8) + (rgb[2] * 255 | 0));
	}

	/**
	 * Corrects PixiJS blend, takes premultiplied alpha into account
	 *
	 * @memberof PIXI.utils
	 * @function mapPremultipliedBlendModes
	 * @private
	 * @return {Array<number[]>} Mapped modes.
	 */
	function mapPremultipliedBlendModes() {
	    var pm = [];
	    var npm = [];
	    for (var i = 0; i < 32; i++) {
	        pm[i] = i;
	        npm[i] = i;
	    }
	    pm[exports.BLEND_MODES.NORMAL_NPM] = exports.BLEND_MODES.NORMAL;
	    pm[exports.BLEND_MODES.ADD_NPM] = exports.BLEND_MODES.ADD;
	    pm[exports.BLEND_MODES.SCREEN_NPM] = exports.BLEND_MODES.SCREEN;
	    npm[exports.BLEND_MODES.NORMAL] = exports.BLEND_MODES.NORMAL_NPM;
	    npm[exports.BLEND_MODES.ADD] = exports.BLEND_MODES.ADD_NPM;
	    npm[exports.BLEND_MODES.SCREEN] = exports.BLEND_MODES.SCREEN_NPM;
	    var array = [];
	    array.push(npm);
	    array.push(pm);
	    return array;
	}
	/**
	 * maps premultiply flag and blendMode to adjusted blendMode
	 * @memberof PIXI.utils
	 * @const premultiplyBlendMode
	 * @type {Array<number[]>}
	 */
	var premultiplyBlendMode = mapPremultipliedBlendModes();
	/**
	 * changes blendMode according to texture format
	 *
	 * @memberof PIXI.utils
	 * @function correctBlendMode
	 * @param {number} blendMode - supposed blend mode
	 * @param {boolean} premultiplied - whether source is premultiplied
	 * @returns {number} true blend mode for this texture
	 */
	function correctBlendMode(blendMode, premultiplied) {
	    return premultiplyBlendMode[premultiplied ? 1 : 0][blendMode];
	}
	/**
	 * combines rgb and alpha to out array
	 *
	 * @memberof PIXI.utils
	 * @function premultiplyRgba
	 * @param {Float32Array|number[]} rgb - input rgb
	 * @param {number} alpha - alpha param
	 * @param {Float32Array} [out] - output
	 * @param {boolean} [premultiply=true] - do premultiply it
	 * @returns {Float32Array} vec4 rgba
	 */
	function premultiplyRgba(rgb, alpha, out, premultiply) {
	    out = out || new Float32Array(4);
	    if (premultiply || premultiply === undefined) {
	        out[0] = rgb[0] * alpha;
	        out[1] = rgb[1] * alpha;
	        out[2] = rgb[2] * alpha;
	    }
	    else {
	        out[0] = rgb[0];
	        out[1] = rgb[1];
	        out[2] = rgb[2];
	    }
	    out[3] = alpha;
	    return out;
	}
	/**
	 * premultiplies tint
	 *
	 * @memberof PIXI.utils
	 * @function premultiplyTint
	 * @param {number} tint - integer RGB
	 * @param {number} alpha - floating point alpha (0.0-1.0)
	 * @returns {number} tint multiplied by alpha
	 */
	function premultiplyTint(tint, alpha) {
	    if (alpha === 1.0) {
	        return (alpha * 255 << 24) + tint;
	    }
	    if (alpha === 0.0) {
	        return 0;
	    }
	    var R = ((tint >> 16) & 0xFF);
	    var G = ((tint >> 8) & 0xFF);
	    var B = (tint & 0xFF);
	    R = ((R * alpha) + 0.5) | 0;
	    G = ((G * alpha) + 0.5) | 0;
	    B = ((B * alpha) + 0.5) | 0;
	    return (alpha * 255 << 24) + (R << 16) + (G << 8) + B;
	}
	/**
	 * converts integer tint and float alpha to vec4 form, premultiplies by default
	 *
	 * @memberof PIXI.utils
	 * @function premultiplyTintToRgba
	 * @param {number} tint - input tint
	 * @param {number} alpha - alpha param
	 * @param {Float32Array} [out] output
	 * @param {boolean} [premultiply=true] - do premultiply it
	 * @returns {Float32Array} vec4 rgba
	 */
	function premultiplyTintToRgba(tint, alpha, out, premultiply) {
	    out = out || new Float32Array(4);
	    out[0] = ((tint >> 16) & 0xFF) / 255.0;
	    out[1] = ((tint >> 8) & 0xFF) / 255.0;
	    out[2] = (tint & 0xFF) / 255.0;
	    if (premultiply || premultiply === undefined) {
	        out[0] *= alpha;
	        out[1] *= alpha;
	        out[2] *= alpha;
	    }
	    out[3] = alpha;
	    return out;
	}

	/**
	 * Generic Mask Stack data structure
	 *
	 * @memberof PIXI.utils
	 * @function createIndicesForQuads
	 * @param {number} size - Number of quads
	 * @param {Uint16Array|Uint32Array} [outBuffer] - Buffer for output, length has to be `6 * size`
	 * @return {Uint16Array|Uint32Array} - Resulting index buffer
	 */
	function createIndicesForQuads(size, outBuffer) {
	    if (outBuffer === void 0) { outBuffer = null; }
	    // the total number of indices in our array, there are 6 points per quad.
	    var totalIndices = size * 6;
	    outBuffer = outBuffer || new Uint16Array(totalIndices);
	    if (outBuffer.length !== totalIndices) {
	        throw new Error("Out buffer length is incorrect, got " + outBuffer.length + " and expected " + totalIndices);
	    }
	    // fill the indices with the quads to draw
	    for (var i = 0, j = 0; i < totalIndices; i += 6, j += 4) {
	        outBuffer[i + 0] = j + 0;
	        outBuffer[i + 1] = j + 1;
	        outBuffer[i + 2] = j + 2;
	        outBuffer[i + 3] = j + 0;
	        outBuffer[i + 4] = j + 2;
	        outBuffer[i + 5] = j + 3;
	    }
	    return outBuffer;
	}

	function getBufferType(array) {
	    if (array.BYTES_PER_ELEMENT === 4) {
	        if (array instanceof Float32Array) {
	            return 'Float32Array';
	        }
	        else if (array instanceof Uint32Array) {
	            return 'Uint32Array';
	        }
	        return 'Int32Array';
	    }
	    else if (array.BYTES_PER_ELEMENT === 2) {
	        if (array instanceof Uint16Array) {
	            return 'Uint16Array';
	        }
	    }
	    else if (array.BYTES_PER_ELEMENT === 1) {
	        if (array instanceof Uint8Array) {
	            return 'Uint8Array';
	        }
	    }
	    // TODO map out the rest of the array elements!
	    return null;
	}

	/* eslint-disable object-shorthand */
	var map = { Float32Array: Float32Array, Uint32Array: Uint32Array, Int32Array: Int32Array, Uint8Array: Uint8Array };
	function interleaveTypedArrays(arrays, sizes) {
	    var outSize = 0;
	    var stride = 0;
	    var views = {};
	    for (var i = 0; i < arrays.length; i++) {
	        stride += sizes[i];
	        outSize += arrays[i].length;
	    }
	    var buffer = new ArrayBuffer(outSize * 4);
	    var out = null;
	    var littleOffset = 0;
	    for (var i = 0; i < arrays.length; i++) {
	        var size = sizes[i];
	        var array = arrays[i];
	        /*
	        @todo This is unsafe casting but consistent with how the code worked previously. Should it stay this way
	              or should and `getBufferTypeUnsafe` function be exposed that throws an Error if unsupported type is passed?
	         */
	        var type = getBufferType(array);
	        if (!views[type]) {
	            views[type] = new map[type](buffer);
	        }
	        out = views[type];
	        for (var j = 0; j < array.length; j++) {
	            var indexStart = ((j / size | 0) * stride) + littleOffset;
	            var index = j % size;
	            out[indexStart + index] = array[j];
	        }
	        littleOffset += size;
	    }
	    return new Float32Array(buffer);
	}

	// Taken from the bit-twiddle package
	/**
	 * Rounds to next power of two.
	 *
	 * @function nextPow2
	 * @memberof PIXI.utils
	 * @param {number} v - input value
	 * @return {number}
	 */
	function nextPow2(v) {
	    v += v === 0 ? 1 : 0;
	    --v;
	    v |= v >>> 1;
	    v |= v >>> 2;
	    v |= v >>> 4;
	    v |= v >>> 8;
	    v |= v >>> 16;
	    return v + 1;
	}
	/**
	 * Checks if a number is a power of two.
	 *
	 * @function isPow2
	 * @memberof PIXI.utils
	 * @param {number} v - input value
	 * @return {boolean} `true` if value is power of two
	 */
	function isPow2(v) {
	    return !(v & (v - 1)) && (!!v);
	}
	/**
	 * Computes ceil of log base 2
	 *
	 * @function log2
	 * @memberof PIXI.utils
	 * @param {number} v - input value
	 * @return {number} logarithm base 2
	 */
	function log2(v) {
	    var r = (v > 0xFFFF ? 1 : 0) << 4;
	    v >>>= r;
	    var shift = (v > 0xFF ? 1 : 0) << 3;
	    v >>>= shift;
	    r |= shift;
	    shift = (v > 0xF ? 1 : 0) << 2;
	    v >>>= shift;
	    r |= shift;
	    shift = (v > 0x3 ? 1 : 0) << 1;
	    v >>>= shift;
	    r |= shift;
	    return r | (v >> 1);
	}

	/**
	 * Remove items from a javascript array without generating garbage
	 *
	 * @function removeItems
	 * @memberof PIXI.utils
	 * @param {Array<any>} arr - Array to remove elements from
	 * @param {number} startIdx - starting index
	 * @param {number} removeCount - how many to remove
	 */
	function removeItems(arr, startIdx, removeCount) {
	    var length = arr.length;
	    var i;
	    if (startIdx >= length || removeCount === 0) {
	        return;
	    }
	    removeCount = (startIdx + removeCount > length ? length - startIdx : removeCount);
	    var len = length - removeCount;
	    for (i = startIdx; i < len; ++i) {
	        arr[i] = arr[i + removeCount];
	    }
	    arr.length = len;
	}

	/**
	 * Returns sign of number
	 *
	 * @memberof PIXI.utils
	 * @function sign
	 * @param {number} n - the number to check the sign of
	 * @returns {number} 0 if `n` is 0, -1 if `n` is negative, 1 if `n` is positive
	 */
	function sign$1(n) {
	    if (n === 0)
	        { return 0; }
	    return n < 0 ? -1 : 1;
	}

	var nextUid = 0;
	/**
	 * Gets the next unique identifier
	 *
	 * @memberof PIXI.utils
	 * @function uid
	 * @return {number} The next unique identifier to use.
	 */
	function uid() {
	    return ++nextUid;
	}

	// A map of warning messages already fired
	var warnings = {};
	/**
	 * Helper for warning developers about deprecated features & settings.
	 * A stack track for warnings is given; useful for tracking-down where
	 * deprecated methods/properties/classes are being used within the code.
	 *
	 * @memberof PIXI.utils
	 * @function deprecation
	 * @param {string} version - The version where the feature became deprecated
	 * @param {string} message - Message should include what is deprecated, where, and the new solution
	 * @param {number} [ignoreDepth=3] - The number of steps to ignore at the top of the error stack
	 *        this is mostly to ignore internal deprecation calls.
	 */
	function deprecation(version, message, ignoreDepth) {
	    if (ignoreDepth === void 0) { ignoreDepth = 3; }
	    // Ignore duplicat
	    if (warnings[message]) {
	        return;
	    }
	    /* eslint-disable no-console */
	    var stack = new Error().stack;
	    // Handle IE < 10 and Safari < 6
	    if (typeof stack === 'undefined') {
	        console.warn('PixiJS Deprecation Warning: ', message + "\nDeprecated since v" + version);
	    }
	    else {
	        // chop off the stack trace which includes PixiJS internal calls
	        stack = stack.split('\n').splice(ignoreDepth).join('\n');
	        if (console.groupCollapsed) {
	            console.groupCollapsed('%cPixiJS Deprecation Warning: %c%s', 'color:#614108;background:#fffbe6', 'font-weight:normal;color:#614108;background:#fffbe6', message + "\nDeprecated since v" + version);
	            console.warn(stack);
	            console.groupEnd();
	        }
	        else {
	            console.warn('PixiJS Deprecation Warning: ', message + "\nDeprecated since v" + version);
	            console.warn(stack);
	        }
	    }
	    /* eslint-enable no-console */
	    warnings[message] = true;
	}

	/**
	 * @todo Describe property usage
	 *
	 * @static
	 * @name ProgramCache
	 * @memberof PIXI.utils
	 * @type {Object}
	 */
	var ProgramCache = {};
	/**
	 * @todo Describe property usage
	 *
	 * @static
	 * @name TextureCache
	 * @memberof PIXI.utils
	 * @type {Object}
	 */
	var TextureCache = Object.create(null);
	/**
	 * @todo Describe property usage
	 *
	 * @static
	 * @name BaseTextureCache
	 * @memberof PIXI.utils
	 * @type {Object}
	 */
	var BaseTextureCache = Object.create(null);
	/**
	 * Destroys all texture in the cache
	 *
	 * @memberof PIXI.utils
	 * @function destroyTextureCache
	 */
	function destroyTextureCache() {
	    var key;
	    for (key in TextureCache) {
	        TextureCache[key].destroy();
	    }
	    for (key in BaseTextureCache) {
	        BaseTextureCache[key].destroy();
	    }
	}
	/**
	 * Removes all textures from cache, but does not destroy them
	 *
	 * @memberof PIXI.utils
	 * @function clearTextureCache
	 */
	function clearTextureCache() {
	    var key;
	    for (key in TextureCache) {
	        delete TextureCache[key];
	    }
	    for (key in BaseTextureCache) {
	        delete BaseTextureCache[key];
	    }
	}

	/**
	 * Creates a Canvas element of the given size to be used as a target for rendering to.
	 *
	 * @class
	 * @memberof PIXI.utils
	 */
	var CanvasRenderTarget = /** @class */ (function () {
	    /**
	     * @param {number} width - the width for the newly created canvas
	     * @param {number} height - the height for the newly created canvas
	     * @param {number} [resolution=1] - The resolution / device pixel ratio of the canvas
	     */
	    function CanvasRenderTarget(width, height, resolution) {
	        /**
	         * The Canvas object that belongs to this CanvasRenderTarget.
	         *
	         * @member {HTMLCanvasElement}
	         */
	        this.canvas = document.createElement('canvas');
	        /**
	         * A CanvasRenderingContext2D object representing a two-dimensional rendering context.
	         *
	         * @member {CanvasRenderingContext2D}
	         */
	        this.context = this.canvas.getContext('2d');
	        this.resolution = resolution || settings.RESOLUTION;
	        this.resize(width, height);
	    }
	    /**
	     * Clears the canvas that was created by the CanvasRenderTarget class.
	     *
	     * @private
	     */
	    CanvasRenderTarget.prototype.clear = function () {
	        this.context.setTransform(1, 0, 0, 1, 0, 0);
	        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
	    };
	    /**
	     * Resizes the canvas to the specified width and height.
	     *
	     * @param {number} width - the new width of the canvas
	     * @param {number} height - the new height of the canvas
	     */
	    CanvasRenderTarget.prototype.resize = function (width, height) {
	        this.canvas.width = width * this.resolution;
	        this.canvas.height = height * this.resolution;
	    };
	    /**
	     * Destroys this canvas.
	     *
	     */
	    CanvasRenderTarget.prototype.destroy = function () {
	        this.context = null;
	        this.canvas = null;
	    };
	    Object.defineProperty(CanvasRenderTarget.prototype, "width", {
	        /**
	         * The width of the canvas buffer in pixels.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this.canvas.width;
	        },
	        set: function (val) {
	            this.canvas.width = val;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(CanvasRenderTarget.prototype, "height", {
	        /**
	         * The height of the canvas buffer in pixels.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this.canvas.height;
	        },
	        set: function (val) {
	            this.canvas.height = val;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return CanvasRenderTarget;
	}());

	/**
	 * Trim transparent borders from a canvas
	 *
	 * @memberof PIXI.utils
	 * @function trimCanvas
	 * @param {HTMLCanvasElement} canvas - the canvas to trim
	 * @returns {object} Trim data
	 */
	function trimCanvas(canvas) {
	    // https://gist.github.com/remy/784508
	    var width = canvas.width;
	    var height = canvas.height;
	    var context = canvas.getContext('2d');
	    var imageData = context.getImageData(0, 0, width, height);
	    var pixels = imageData.data;
	    var len = pixels.length;
	    var bound = {
	        top: null,
	        left: null,
	        right: null,
	        bottom: null,
	    };
	    var data = null;
	    var i;
	    var x;
	    var y;
	    for (i = 0; i < len; i += 4) {
	        if (pixels[i + 3] !== 0) {
	            x = (i / 4) % width;
	            y = ~~((i / 4) / width);
	            if (bound.top === null) {
	                bound.top = y;
	            }
	            if (bound.left === null) {
	                bound.left = x;
	            }
	            else if (x < bound.left) {
	                bound.left = x;
	            }
	            if (bound.right === null) {
	                bound.right = x + 1;
	            }
	            else if (bound.right < x) {
	                bound.right = x + 1;
	            }
	            if (bound.bottom === null) {
	                bound.bottom = y;
	            }
	            else if (bound.bottom < y) {
	                bound.bottom = y;
	            }
	        }
	    }
	    if (bound.top !== null) {
	        width = bound.right - bound.left;
	        height = bound.bottom - bound.top + 1;
	        data = context.getImageData(bound.left, bound.top, width, height);
	    }
	    return {
	        height: height,
	        width: width,
	        data: data,
	    };
	}

	/**
	 * Regexp for data URI.
	 * Based on: {@link https://github.com/ragingwind/data-uri-regex}
	 *
	 * @static
	 * @constant {RegExp|string} DATA_URI
	 * @memberof PIXI
	 * @example data:image/png;base64
	 */
	var DATA_URI = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;

	/**
	 * @memberof PIXI.utils
	 * @interface DecomposedDataUri
	 */
	/**
	 * type, eg. `image`
	 * @memberof PIXI.utils.DecomposedDataUri#
	 * @member {string} mediaType
	 */
	/**
	 * Sub type, eg. `png`
	 * @memberof PIXI.utils.DecomposedDataUri#
	 * @member {string} subType
	 */
	/**
	 * @memberof PIXI.utils.DecomposedDataUri#
	 * @member {string} charset
	 */
	/**
	 * Data encoding, eg. `base64`
	 * @memberof PIXI.utils.DecomposedDataUri#
	 * @member {string} encoding
	 */
	/**
	 * The actual data
	 * @memberof PIXI.utils.DecomposedDataUri#
	 * @member {string} data
	 */
	/**
	 * Split a data URI into components. Returns undefined if
	 * parameter `dataUri` is not a valid data URI.
	 *
	 * @memberof PIXI.utils
	 * @function decomposeDataUri
	 * @param {string} dataUri - the data URI to check
	 * @return {PIXI.utils.DecomposedDataUri|undefined} The decomposed data uri or undefined
	 */
	function decomposeDataUri(dataUri) {
	    var dataUriMatch = DATA_URI.exec(dataUri);
	    if (dataUriMatch) {
	        return {
	            mediaType: dataUriMatch[1] ? dataUriMatch[1].toLowerCase() : undefined,
	            subType: dataUriMatch[2] ? dataUriMatch[2].toLowerCase() : undefined,
	            charset: dataUriMatch[3] ? dataUriMatch[3].toLowerCase() : undefined,
	            encoding: dataUriMatch[4] ? dataUriMatch[4].toLowerCase() : undefined,
	            data: dataUriMatch[5],
	        };
	    }
	    return undefined;
	}

	var tempAnchor;
	/**
	 * Sets the `crossOrigin` property for this resource based on if the url
	 * for this resource is cross-origin. If crossOrigin was manually set, this
	 * function does nothing.
	 * Nipped from the resource loader!
	 *
	 * @ignore
	 * @param {string} url - The url to test.
	 * @param {object} [loc=window.location] - The location object to test against.
	 * @return {string} The crossOrigin value to use (or empty string for none).
	 */
	function determineCrossOrigin(url, loc) {
	    if (loc === void 0) { loc = window.location; }
	    // data: and javascript: urls are considered same-origin
	    if (url.indexOf('data:') === 0) {
	        return '';
	    }
	    // default is window.location
	    loc = loc || window.location;
	    if (!tempAnchor) {
	        tempAnchor = document.createElement('a');
	    }
	    // let the browser determine the full href for the url of this resource and then
	    // parse with the node url lib, we can't use the properties of the anchor element
	    // because they don't work in IE9 :(
	    tempAnchor.href = url;
	    var parsedUrl = parse(tempAnchor.href);
	    var samePort = (!parsedUrl.port && loc.port === '') || (parsedUrl.port === loc.port);
	    // if cross origin
	    if (parsedUrl.hostname !== loc.hostname || !samePort || parsedUrl.protocol !== loc.protocol) {
	        return 'anonymous';
	    }
	    return '';
	}

	/**
	 * get the resolution / device pixel ratio of an asset by looking for the prefix
	 * used by spritesheets and image urls
	 *
	 * @memberof PIXI.utils
	 * @function getResolutionOfUrl
	 * @param {string} url - the image path
	 * @param {number} [defaultValue=1] - the defaultValue if no filename prefix is set.
	 * @return {number} resolution / device pixel ratio of an asset
	 */
	function getResolutionOfUrl(url, defaultValue) {
	    var resolution = settings.RETINA_PREFIX.exec(url);
	    if (resolution) {
	        return parseFloat(resolution[1]);
	    }
	    return defaultValue !== undefined ? defaultValue : 1;
	}

	var utils_es = ({
		BaseTextureCache: BaseTextureCache,
		CanvasRenderTarget: CanvasRenderTarget,
		DATA_URI: DATA_URI,
		ProgramCache: ProgramCache,
		TextureCache: TextureCache,
		clearTextureCache: clearTextureCache,
		correctBlendMode: correctBlendMode,
		createIndicesForQuads: createIndicesForQuads,
		decomposeDataUri: decomposeDataUri,
		deprecation: deprecation,
		destroyTextureCache: destroyTextureCache,
		determineCrossOrigin: determineCrossOrigin,
		getBufferType: getBufferType,
		getResolutionOfUrl: getResolutionOfUrl,
		hex2rgb: hex2rgb,
		hex2string: hex2string,
		interleaveTypedArrays: interleaveTypedArrays,
		isPow2: isPow2,
		isWebGLSupported: isWebGLSupported,
		log2: log2,
		nextPow2: nextPow2,
		premultiplyBlendMode: premultiplyBlendMode,
		premultiplyRgba: premultiplyRgba,
		premultiplyTint: premultiplyTint,
		premultiplyTintToRgba: premultiplyTintToRgba,
		removeItems: removeItems,
		rgb2hex: rgb2hex,
		sayHello: sayHello,
		sign: sign$1,
		skipHello: skipHello,
		string2hex: string2hex,
		trimCanvas: trimCanvas,
		uid: uid,
		isMobile: isMobile$1,
		EventEmitter: eventemitter3,
		earcut: earcut_1,
		url: url
	});

	/*!
	 * @pixi/math - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/math is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */
	/**
	 * Two Pi.
	 *
	 * @static
	 * @constant {number} PI_2
	 * @memberof PIXI
	 */
	var PI_2 = Math.PI * 2;
	/**
	 * Conversion factor for converting radians to degrees.
	 *
	 * @static
	 * @constant {number} RAD_TO_DEG
	 * @memberof PIXI
	 */
	var RAD_TO_DEG = 180 / Math.PI;
	/**
	 * Conversion factor for converting degrees to radians.
	 *
	 * @static
	 * @constant {number} DEG_TO_RAD
	 * @memberof PIXI
	 */
	var DEG_TO_RAD = Math.PI / 180;

	(function (SHAPES) {
	    SHAPES[SHAPES["POLY"] = 0] = "POLY";
	    SHAPES[SHAPES["RECT"] = 1] = "RECT";
	    SHAPES[SHAPES["CIRC"] = 2] = "CIRC";
	    SHAPES[SHAPES["ELIP"] = 3] = "ELIP";
	    SHAPES[SHAPES["RREC"] = 4] = "RREC";
	})(exports.SHAPES || (exports.SHAPES = {}));
	/**
	 * Constants that identify shapes, mainly to prevent `instanceof` calls.
	 *
	 * @static
	 * @constant
	 * @name SHAPES
	 * @memberof PIXI
	 * @type {enum}
	 * @property {number} POLY Polygon
	 * @property {number} RECT Rectangle
	 * @property {number} CIRC Circle
	 * @property {number} ELIP Ellipse
	 * @property {number} RREC Rounded Rectangle
	 * @enum {number}
	 */

	/**
	 * Size object, contains width and height
	 *
	 * @memberof PIXI
	 * @typedef {object} ISize
	 * @property {number} width - Width component
	 * @property {number} height - Height component
	 */
	/**
	 * Rectangle object is an area defined by its position, as indicated by its top-left corner
	 * point (x, y) and by its width and its height.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Rectangle = /** @class */ (function () {
	    /**
	     * @param {number} [x=0] - The X coordinate of the upper-left corner of the rectangle
	     * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rectangle
	     * @param {number} [width=0] - The overall width of this rectangle
	     * @param {number} [height=0] - The overall height of this rectangle
	     */
	    function Rectangle(x, y, width, height) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = 0; }
	        if (width === void 0) { width = 0; }
	        if (height === void 0) { height = 0; }
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.x = Number(x);
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.y = Number(y);
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.width = Number(width);
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.height = Number(height);
	        /**
	         * The type of the object, mainly used to avoid `instanceof` checks
	         *
	         * @member {number}
	         * @readOnly
	         * @default PIXI.SHAPES.RECT
	         * @see PIXI.SHAPES
	         */
	        this.type = exports.SHAPES.RECT;
	    }
	    Object.defineProperty(Rectangle.prototype, "left", {
	        /**
	         * returns the left edge of the rectangle
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this.x;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Rectangle.prototype, "right", {
	        /**
	         * returns the right edge of the rectangle
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this.x + this.width;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Rectangle.prototype, "top", {
	        /**
	         * returns the top edge of the rectangle
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this.y;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Rectangle.prototype, "bottom", {
	        /**
	         * returns the bottom edge of the rectangle
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this.y + this.height;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Rectangle, "EMPTY", {
	        /**
	         * A constant empty rectangle.
	         *
	         * @static
	         * @constant
	         * @member {PIXI.Rectangle}
	         * @return {PIXI.Rectangle} An empty rectangle
	         */
	        get: function () {
	            return new Rectangle(0, 0, 0, 0);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Creates a clone of this Rectangle
	     *
	     * @return {PIXI.Rectangle} a copy of the rectangle
	     */
	    Rectangle.prototype.clone = function () {
	        return new Rectangle(this.x, this.y, this.width, this.height);
	    };
	    /**
	     * Copies another rectangle to this one.
	     *
	     * @param {PIXI.Rectangle} rectangle - The rectangle to copy from.
	     * @return {PIXI.Rectangle} Returns itself.
	     */
	    Rectangle.prototype.copyFrom = function (rectangle) {
	        this.x = rectangle.x;
	        this.y = rectangle.y;
	        this.width = rectangle.width;
	        this.height = rectangle.height;
	        return this;
	    };
	    /**
	     * Copies this rectangle to another one.
	     *
	     * @param {PIXI.Rectangle} rectangle - The rectangle to copy to.
	     * @return {PIXI.Rectangle} Returns given parameter.
	     */
	    Rectangle.prototype.copyTo = function (rectangle) {
	        rectangle.x = this.x;
	        rectangle.y = this.y;
	        rectangle.width = this.width;
	        rectangle.height = this.height;
	        return rectangle;
	    };
	    /**
	     * Checks whether the x and y coordinates given are contained within this Rectangle
	     *
	     * @param {number} x - The X coordinate of the point to test
	     * @param {number} y - The Y coordinate of the point to test
	     * @return {boolean} Whether the x/y coordinates are within this Rectangle
	     */
	    Rectangle.prototype.contains = function (x, y) {
	        if (this.width <= 0 || this.height <= 0) {
	            return false;
	        }
	        if (x >= this.x && x < this.x + this.width) {
	            if (y >= this.y && y < this.y + this.height) {
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * Pads the rectangle making it grow in all directions.
	     * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
	     *
	     * @param {number} [paddingX=0] - The horizontal padding amount.
	     * @param {number} [paddingY=0] - The vertical padding amount.
	     * @return {PIXI.Rectangle} Returns itself.
	     */
	    Rectangle.prototype.pad = function (paddingX, paddingY) {
	        if (paddingX === void 0) { paddingX = 0; }
	        if (paddingY === void 0) { paddingY = paddingX; }
	        this.x -= paddingX;
	        this.y -= paddingY;
	        this.width += paddingX * 2;
	        this.height += paddingY * 2;
	        return this;
	    };
	    /**
	     * Fits this rectangle around the passed one.
	     *
	     * @param {PIXI.Rectangle} rectangle - The rectangle to fit.
	     * @return {PIXI.Rectangle} Returns itself.
	     */
	    Rectangle.prototype.fit = function (rectangle) {
	        var x1 = Math.max(this.x, rectangle.x);
	        var x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width);
	        var y1 = Math.max(this.y, rectangle.y);
	        var y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
	        this.x = x1;
	        this.width = Math.max(x2 - x1, 0);
	        this.y = y1;
	        this.height = Math.max(y2 - y1, 0);
	        return this;
	    };
	    /**
	     * Enlarges rectangle that way its corners lie on grid
	     *
	     * @param {number} [resolution=1] resolution
	     * @param {number} [eps=0.001] precision
	     * @return {PIXI.Rectangle} Returns itself.
	     */
	    Rectangle.prototype.ceil = function (resolution, eps) {
	        if (resolution === void 0) { resolution = 1; }
	        if (eps === void 0) { eps = 0.001; }
	        var x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution;
	        var y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
	        this.x = Math.floor((this.x + eps) * resolution) / resolution;
	        this.y = Math.floor((this.y + eps) * resolution) / resolution;
	        this.width = x2 - this.x;
	        this.height = y2 - this.y;
	        return this;
	    };
	    /**
	     * Enlarges this rectangle to include the passed rectangle.
	     *
	     * @param {PIXI.Rectangle} rectangle - The rectangle to include.
	     * @return {PIXI.Rectangle} Returns itself.
	     */
	    Rectangle.prototype.enlarge = function (rectangle) {
	        var x1 = Math.min(this.x, rectangle.x);
	        var x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
	        var y1 = Math.min(this.y, rectangle.y);
	        var y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
	        this.x = x1;
	        this.width = x2 - x1;
	        this.y = y1;
	        this.height = y2 - y1;
	        return this;
	    };
	    return Rectangle;
	}());

	/**
	 * The Circle object is used to help draw graphics and can also be used to specify a hit area for displayObjects.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Circle = /** @class */ (function () {
	    /**
	     * @param {number} [x=0] - The X coordinate of the center of this circle
	     * @param {number} [y=0] - The Y coordinate of the center of this circle
	     * @param {number} [radius=0] - The radius of the circle
	     */
	    function Circle(x, y, radius) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = 0; }
	        if (radius === void 0) { radius = 0; }
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.x = x;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.y = y;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.radius = radius;
	        /**
	         * The type of the object, mainly used to avoid `instanceof` checks
	         *
	         * @member {number}
	         * @readOnly
	         * @default PIXI.SHAPES.CIRC
	         * @see PIXI.SHAPES
	         */
	        this.type = exports.SHAPES.CIRC;
	    }
	    /**
	     * Creates a clone of this Circle instance
	     *
	     * @return {PIXI.Circle} a copy of the Circle
	     */
	    Circle.prototype.clone = function () {
	        return new Circle(this.x, this.y, this.radius);
	    };
	    /**
	     * Checks whether the x and y coordinates given are contained within this circle
	     *
	     * @param {number} x - The X coordinate of the point to test
	     * @param {number} y - The Y coordinate of the point to test
	     * @return {boolean} Whether the x/y coordinates are within this Circle
	     */
	    Circle.prototype.contains = function (x, y) {
	        if (this.radius <= 0) {
	            return false;
	        }
	        var r2 = this.radius * this.radius;
	        var dx = (this.x - x);
	        var dy = (this.y - y);
	        dx *= dx;
	        dy *= dy;
	        return (dx + dy <= r2);
	    };
	    /**
	    * Returns the framing rectangle of the circle as a Rectangle object
	    *
	    * @return {PIXI.Rectangle} the framing rectangle
	    */
	    Circle.prototype.getBounds = function () {
	        return new Rectangle(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
	    };
	    return Circle;
	}());

	/**
	 * The Ellipse object is used to help draw graphics and can also be used to specify a hit area for displayObjects.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Ellipse = /** @class */ (function () {
	    /**
	     * @param {number} [x=0] - The X coordinate of the center of this ellipse
	     * @param {number} [y=0] - The Y coordinate of the center of this ellipse
	     * @param {number} [halfWidth=0] - The half width of this ellipse
	     * @param {number} [halfHeight=0] - The half height of this ellipse
	     */
	    function Ellipse(x, y, halfWidth, halfHeight) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = 0; }
	        if (halfWidth === void 0) { halfWidth = 0; }
	        if (halfHeight === void 0) { halfHeight = 0; }
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.x = x;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.y = y;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.width = halfWidth;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.height = halfHeight;
	        /**
	         * The type of the object, mainly used to avoid `instanceof` checks
	         *
	         * @member {number}
	         * @readOnly
	         * @default PIXI.SHAPES.ELIP
	         * @see PIXI.SHAPES
	         */
	        this.type = exports.SHAPES.ELIP;
	    }
	    /**
	     * Creates a clone of this Ellipse instance
	     *
	     * @return {PIXI.Ellipse} a copy of the ellipse
	     */
	    Ellipse.prototype.clone = function () {
	        return new Ellipse(this.x, this.y, this.width, this.height);
	    };
	    /**
	     * Checks whether the x and y coordinates given are contained within this ellipse
	     *
	     * @param {number} x - The X coordinate of the point to test
	     * @param {number} y - The Y coordinate of the point to test
	     * @return {boolean} Whether the x/y coords are within this ellipse
	     */
	    Ellipse.prototype.contains = function (x, y) {
	        if (this.width <= 0 || this.height <= 0) {
	            return false;
	        }
	        // normalize the coords to an ellipse with center 0,0
	        var normx = ((x - this.x) / this.width);
	        var normy = ((y - this.y) / this.height);
	        normx *= normx;
	        normy *= normy;
	        return (normx + normy <= 1);
	    };
	    /**
	     * Returns the framing rectangle of the ellipse as a Rectangle object
	     *
	     * @return {PIXI.Rectangle} the framing rectangle
	     */
	    Ellipse.prototype.getBounds = function () {
	        return new Rectangle(this.x - this.width, this.y - this.height, this.width, this.height);
	    };
	    return Ellipse;
	}());

	/**
	 * A class to define a shape via user defined co-orinates.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Polygon = /** @class */ (function () {
	    /**
	     * @param {PIXI.IPoint[]|number[]} points - This can be an array of Points
	     *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
	     *  the arguments passed can be all the points of the polygon e.g.
	     *  `new PIXI.Polygon(new PIXI.Point(), new PIXI.Point(), ...)`, or the arguments passed can be flat
	     *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
	     */
	    function Polygon() {
	        var arguments$1 = arguments;

	        var points = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            points[_i] = arguments$1[_i];
	        }
	        var flat = Array.isArray(points[0]) ? points[0] : points;
	        // if this is an array of points, convert it to a flat array of numbers
	        if (typeof flat[0] !== 'number') {
	            var p = [];
	            for (var i = 0, il = flat.length; i < il; i++) {
	                p.push(flat[i].x, flat[i].y);
	            }
	            flat = p;
	        }
	        /**
	         * An array of the points of this polygon
	         *
	         * @member {number[]}
	         */
	        this.points = flat;
	        /**
	         * The type of the object, mainly used to avoid `instanceof` checks
	         *
	         * @member {number}
	         * @readOnly
	         * @default PIXI.SHAPES.POLY
	         * @see PIXI.SHAPES
	         */
	        this.type = exports.SHAPES.POLY;
	        /**
	         * `false` after moveTo, `true` after `closePath`. In all other cases it is `true`.
	         * @member {boolean}
	         * @default true
	         */
	        this.closeStroke = true;
	    }
	    /**
	     * Creates a clone of this polygon
	     *
	     * @return {PIXI.Polygon} a copy of the polygon
	     */
	    Polygon.prototype.clone = function () {
	        var points = this.points.slice();
	        var polygon = new Polygon(points);
	        polygon.closeStroke = this.closeStroke;
	        return polygon;
	    };
	    /**
	     * Checks whether the x and y coordinates passed to this function are contained within this polygon
	     *
	     * @param {number} x - The X coordinate of the point to test
	     * @param {number} y - The Y coordinate of the point to test
	     * @return {boolean} Whether the x/y coordinates are within this polygon
	     */
	    Polygon.prototype.contains = function (x, y) {
	        var inside = false;
	        // use some raycasting to test hits
	        // https://github.com/substack/point-in-polygon/blob/master/index.js
	        var length = this.points.length / 2;
	        for (var i = 0, j = length - 1; i < length; j = i++) {
	            var xi = this.points[i * 2];
	            var yi = this.points[(i * 2) + 1];
	            var xj = this.points[j * 2];
	            var yj = this.points[(j * 2) + 1];
	            var intersect = ((yi > y) !== (yj > y)) && (x < ((xj - xi) * ((y - yi) / (yj - yi))) + xi);
	            if (intersect) {
	                inside = !inside;
	            }
	        }
	        return inside;
	    };
	    return Polygon;
	}());

	/**
	 * The Rounded Rectangle object is an area that has nice rounded corners, as indicated by its
	 * top-left corner point (x, y) and by its width and its height and its radius.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var RoundedRectangle = /** @class */ (function () {
	    /**
	     * @param {number} [x=0] - The X coordinate of the upper-left corner of the rounded rectangle
	     * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rounded rectangle
	     * @param {number} [width=0] - The overall width of this rounded rectangle
	     * @param {number} [height=0] - The overall height of this rounded rectangle
	     * @param {number} [radius=20] - Controls the radius of the rounded corners
	     */
	    function RoundedRectangle(x, y, width, height, radius) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = 0; }
	        if (width === void 0) { width = 0; }
	        if (height === void 0) { height = 0; }
	        if (radius === void 0) { radius = 20; }
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.x = x;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.y = y;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.width = width;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.height = height;
	        /**
	         * @member {number}
	         * @default 20
	         */
	        this.radius = radius;
	        /**
	         * The type of the object, mainly used to avoid `instanceof` checks
	         *
	         * @member {number}
	         * @readonly
	         * @default PIXI.SHAPES.RREC
	         * @see PIXI.SHAPES
	         */
	        this.type = exports.SHAPES.RREC;
	    }
	    /**
	     * Creates a clone of this Rounded Rectangle
	     *
	     * @return {PIXI.RoundedRectangle} a copy of the rounded rectangle
	     */
	    RoundedRectangle.prototype.clone = function () {
	        return new RoundedRectangle(this.x, this.y, this.width, this.height, this.radius);
	    };
	    /**
	     * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
	     *
	     * @param {number} x - The X coordinate of the point to test
	     * @param {number} y - The Y coordinate of the point to test
	     * @return {boolean} Whether the x/y coordinates are within this Rounded Rectangle
	     */
	    RoundedRectangle.prototype.contains = function (x, y) {
	        if (this.width <= 0 || this.height <= 0) {
	            return false;
	        }
	        if (x >= this.x && x <= this.x + this.width) {
	            if (y >= this.y && y <= this.y + this.height) {
	                if ((y >= this.y + this.radius && y <= this.y + this.height - this.radius)
	                    || (x >= this.x + this.radius && x <= this.x + this.width - this.radius)) {
	                    return true;
	                }
	                var dx = x - (this.x + this.radius);
	                var dy = y - (this.y + this.radius);
	                var radius2 = this.radius * this.radius;
	                if ((dx * dx) + (dy * dy) <= radius2) {
	                    return true;
	                }
	                dx = x - (this.x + this.width - this.radius);
	                if ((dx * dx) + (dy * dy) <= radius2) {
	                    return true;
	                }
	                dy = y - (this.y + this.height - this.radius);
	                if ((dx * dx) + (dy * dy) <= radius2) {
	                    return true;
	                }
	                dx = x - (this.x + this.radius);
	                if ((dx * dx) + (dy * dy) <= radius2) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    return RoundedRectangle;
	}());

	/**
	 * Common interface for points. Both Point and ObservablePoint implement it
	 * @memberof PIXI
	 * @interface IPointData
	 */
	/**
	 * X coord
	 * @memberof PIXI.IPointData#
	 * @member {number} x
	 */
	/**
	 * Y coord
	 * @memberof PIXI.IPointData#
	 * @member {number} y
	 */

	/**
	 * Common interface for points. Both Point and ObservablePoint implement it
	 * @memberof PIXI
	 * @interface IPoint
	 * @extends PIXI.IPointData
	 */
	/**
	 * Sets the point to a new x and y position.
	 * If y is omitted, both x and y will be set to x.
	 *
	 * @method set
	 * @memberof PIXI.IPoint#
	 * @param {number} [x=0] - position of the point on the x axis
	 * @param {number} [y=x] - position of the point on the y axis
	 */
	/**
	 * Copies x and y from the given point
	 * @method copyFrom
	 * @memberof PIXI.IPoint#
	 * @param {PIXI.IPointData} p - The point to copy from
	 * @returns {this} Returns itself.
	 */
	/**
	 * Copies x and y into the given point
	 * @method copyTo
	 * @memberof PIXI.IPoint#
	 * @param {PIXI.IPoint} p - The point to copy.
	 * @returns {PIXI.IPoint} Given point with values updated
	 */
	/**
	 * Returns true if the given point is equal to this point
	 *
	 * @method equals
	 * @memberof PIXI.IPoint#
	 * @param {PIXI.IPointData} p - The point to check
	 * @returns {boolean} Whether the given point equal to this point
	 */

	/**
	 * The Point object represents a location in a two-dimensional coordinate system, where x represents
	 * the horizontal axis and y represents the vertical axis.
	 *
	 * @class
	 * @memberof PIXI
	 * @implements IPoint
	 */
	var Point = /** @class */ (function () {
	    /**
	     * @param {number} [x=0] - position of the point on the x axis
	     * @param {number} [y=0] - position of the point on the y axis
	     */
	    function Point(x, y) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = 0; }
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.x = x;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.y = y;
	    }
	    /**
	     * Creates a clone of this point
	     *
	     * @return {PIXI.Point} a copy of the point
	     */
	    Point.prototype.clone = function () {
	        return new Point(this.x, this.y);
	    };
	    /**
	     * Copies x and y from the given point
	     *
	     * @param {PIXI.IPointData} p - The point to copy from
	     * @returns {this} Returns itself.
	     */
	    Point.prototype.copyFrom = function (p) {
	        this.set(p.x, p.y);
	        return this;
	    };
	    /**
	     * Copies x and y into the given point
	     *
	     * @param {PIXI.IPoint} p - The point to copy.
	     * @returns {PIXI.IPoint} Given point with values updated
	     */
	    Point.prototype.copyTo = function (p) {
	        p.set(this.x, this.y);
	        return p;
	    };
	    /**
	     * Returns true if the given point is equal to this point
	     *
	     * @param {PIXI.IPointData} p - The point to check
	     * @returns {boolean} Whether the given point equal to this point
	     */
	    Point.prototype.equals = function (p) {
	        return (p.x === this.x) && (p.y === this.y);
	    };
	    /**
	     * Sets the point to a new x and y position.
	     * If y is omitted, both x and y will be set to x.
	     *
	     * @param {number} [x=0] - position of the point on the x axis
	     * @param {number} [y=x] - position of the point on the y axis
	     * @returns {this} Returns itself.
	     */
	    Point.prototype.set = function (x, y) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = x; }
	        this.x = x;
	        this.y = y;
	        return this;
	    };
	    return Point;
	}());

	/**
	 * The Point object represents a location in a two-dimensional coordinate system, where x represents
	 * the horizontal axis and y represents the vertical axis.
	 *
	 * An ObservablePoint is a point that triggers a callback when the point's position is changed.
	 *
	 * @class
	 * @memberof PIXI
	 * @implements IPoint
	 */
	var ObservablePoint = /** @class */ (function () {
	    /**
	     * @param {Function} cb - callback when changed
	     * @param {object} scope - owner of callback
	     * @param {number} [x=0] - position of the point on the x axis
	     * @param {number} [y=0] - position of the point on the y axis
	     */
	    function ObservablePoint(cb, scope, x, y) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = 0; }
	        this._x = x;
	        this._y = y;
	        this.cb = cb;
	        this.scope = scope;
	    }
	    /**
	     * Creates a clone of this point.
	     * The callback and scope params can be overidden otherwise they will default
	     * to the clone object's values.
	     *
	     * @override
	     * @param {Function} [cb=null] - callback when changed
	     * @param {object} [scope=null] - owner of callback
	     * @return {PIXI.ObservablePoint} a copy of the point
	     */
	    ObservablePoint.prototype.clone = function (cb, scope) {
	        if (cb === void 0) { cb = this.cb; }
	        if (scope === void 0) { scope = this.scope; }
	        return new ObservablePoint(cb, scope, this._x, this._y);
	    };
	    /**
	     * Sets the point to a new x and y position.
	     * If y is omitted, both x and y will be set to x.
	     *
	     * @param {number} [x=0] - position of the point on the x axis
	     * @param {number} [y=x] - position of the point on the y axis
	     * @returns {this} Returns itself.
	     */
	    ObservablePoint.prototype.set = function (x, y) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = x; }
	        if (this._x !== x || this._y !== y) {
	            this._x = x;
	            this._y = y;
	            this.cb.call(this.scope);
	        }
	        return this;
	    };
	    /**
	     * Copies x and y from the given point
	     *
	     * @param {PIXI.IPointData} p - The point to copy from.
	     * @returns {this} Returns itself.
	     */
	    ObservablePoint.prototype.copyFrom = function (p) {
	        if (this._x !== p.x || this._y !== p.y) {
	            this._x = p.x;
	            this._y = p.y;
	            this.cb.call(this.scope);
	        }
	        return this;
	    };
	    /**
	     * Copies x and y into the given point
	     *
	     * @param {PIXI.IPoint} p - The point to copy.
	     * @returns {PIXI.IPoint} Given point with values updated
	     */
	    ObservablePoint.prototype.copyTo = function (p) {
	        p.set(this._x, this._y);
	        return p;
	    };
	    /**
	     * Returns true if the given point is equal to this point
	     *
	     * @param {PIXI.IPointData} p - The point to check
	     * @returns {boolean} Whether the given point equal to this point
	     */
	    ObservablePoint.prototype.equals = function (p) {
	        return (p.x === this._x) && (p.y === this._y);
	    };
	    Object.defineProperty(ObservablePoint.prototype, "x", {
	        /**
	         * The position of the displayObject on the x axis relative to the local coordinates of the parent.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._x;
	        },
	        set: function (value) {
	            if (this._x !== value) {
	                this._x = value;
	                this.cb.call(this.scope);
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ObservablePoint.prototype, "y", {
	        /**
	         * The position of the displayObject on the x axis relative to the local coordinates of the parent.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._y;
	        },
	        set: function (value) {
	            if (this._y !== value) {
	                this._y = value;
	                this.cb.call(this.scope);
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return ObservablePoint;
	}());

	/**
	 * The PixiJS Matrix as a class makes it a lot faster.
	 *
	 * Here is a representation of it:
	 * ```js
	 * | a | c | tx|
	 * | b | d | ty|
	 * | 0 | 0 | 1 |
	 * ```
	 * @class
	 * @memberof PIXI
	 */
	var Matrix = /** @class */ (function () {
	    /**
	     * @param {number} [a=1] - x scale
	     * @param {number} [b=0] - x skew
	     * @param {number} [c=0] - y skew
	     * @param {number} [d=1] - y scale
	     * @param {number} [tx=0] - x translation
	     * @param {number} [ty=0] - y translation
	     */
	    function Matrix(a, b, c, d, tx, ty) {
	        if (a === void 0) { a = 1; }
	        if (b === void 0) { b = 0; }
	        if (c === void 0) { c = 0; }
	        if (d === void 0) { d = 1; }
	        if (tx === void 0) { tx = 0; }
	        if (ty === void 0) { ty = 0; }
	        this.array = null;
	        /**
	         * @member {number}
	         * @default 1
	         */
	        this.a = a;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.b = b;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.c = c;
	        /**
	         * @member {number}
	         * @default 1
	         */
	        this.d = d;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.tx = tx;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.ty = ty;
	    }
	    /**
	     * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
	     *
	     * a = array[0]
	     * b = array[1]
	     * c = array[3]
	     * d = array[4]
	     * tx = array[2]
	     * ty = array[5]
	     *
	     * @param {number[]} array - The array that the matrix will be populated from.
	     */
	    Matrix.prototype.fromArray = function (array) {
	        this.a = array[0];
	        this.b = array[1];
	        this.c = array[3];
	        this.d = array[4];
	        this.tx = array[2];
	        this.ty = array[5];
	    };
	    /**
	     * sets the matrix properties
	     *
	     * @param {number} a - Matrix component
	     * @param {number} b - Matrix component
	     * @param {number} c - Matrix component
	     * @param {number} d - Matrix component
	     * @param {number} tx - Matrix component
	     * @param {number} ty - Matrix component
	     *
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	    Matrix.prototype.set = function (a, b, c, d, tx, ty) {
	        this.a = a;
	        this.b = b;
	        this.c = c;
	        this.d = d;
	        this.tx = tx;
	        this.ty = ty;
	        return this;
	    };
	    /**
	     * Creates an array from the current Matrix object.
	     *
	     * @param {boolean} transpose - Whether we need to transpose the matrix or not
	     * @param {Float32Array} [out=new Float32Array(9)] - If provided the array will be assigned to out
	     * @return {number[]} the newly created array which contains the matrix
	     */
	    Matrix.prototype.toArray = function (transpose, out) {
	        if (!this.array) {
	            this.array = new Float32Array(9);
	        }
	        var array = out || this.array;
	        if (transpose) {
	            array[0] = this.a;
	            array[1] = this.b;
	            array[2] = 0;
	            array[3] = this.c;
	            array[4] = this.d;
	            array[5] = 0;
	            array[6] = this.tx;
	            array[7] = this.ty;
	            array[8] = 1;
	        }
	        else {
	            array[0] = this.a;
	            array[1] = this.c;
	            array[2] = this.tx;
	            array[3] = this.b;
	            array[4] = this.d;
	            array[5] = this.ty;
	            array[6] = 0;
	            array[7] = 0;
	            array[8] = 1;
	        }
	        return array;
	    };
	    /**
	     * Get a new position with the current transformation applied.
	     * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
	     *
	     * @param {PIXI.IPointData} pos - The origin
	     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
	     * @return {PIXI.Point} The new point, transformed through this matrix
	     */
	    Matrix.prototype.apply = function (pos, newPos) {
	        newPos = (newPos || new Point());
	        var x = pos.x;
	        var y = pos.y;
	        newPos.x = (this.a * x) + (this.c * y) + this.tx;
	        newPos.y = (this.b * x) + (this.d * y) + this.ty;
	        return newPos;
	    };
	    /**
	     * Get a new position with the inverse of the current transformation applied.
	     * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
	     *
	     * @param {PIXI.IPointData} pos - The origin
	     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
	     * @return {PIXI.Point} The new point, inverse-transformed through this matrix
	     */
	    Matrix.prototype.applyInverse = function (pos, newPos) {
	        newPos = (newPos || new Point());
	        var id = 1 / ((this.a * this.d) + (this.c * -this.b));
	        var x = pos.x;
	        var y = pos.y;
	        newPos.x = (this.d * id * x) + (-this.c * id * y) + (((this.ty * this.c) - (this.tx * this.d)) * id);
	        newPos.y = (this.a * id * y) + (-this.b * id * x) + (((-this.ty * this.a) + (this.tx * this.b)) * id);
	        return newPos;
	    };
	    /**
	     * Translates the matrix on the x and y.
	     *
	     * @param {number} x - How much to translate x by
	     * @param {number} y - How much to translate y by
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	    Matrix.prototype.translate = function (x, y) {
	        this.tx += x;
	        this.ty += y;
	        return this;
	    };
	    /**
	     * Applies a scale transformation to the matrix.
	     *
	     * @param {number} x - The amount to scale horizontally
	     * @param {number} y - The amount to scale vertically
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	    Matrix.prototype.scale = function (x, y) {
	        this.a *= x;
	        this.d *= y;
	        this.c *= x;
	        this.b *= y;
	        this.tx *= x;
	        this.ty *= y;
	        return this;
	    };
	    /**
	     * Applies a rotation transformation to the matrix.
	     *
	     * @param {number} angle - The angle in radians.
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	    Matrix.prototype.rotate = function (angle) {
	        var cos = Math.cos(angle);
	        var sin = Math.sin(angle);
	        var a1 = this.a;
	        var c1 = this.c;
	        var tx1 = this.tx;
	        this.a = (a1 * cos) - (this.b * sin);
	        this.b = (a1 * sin) + (this.b * cos);
	        this.c = (c1 * cos) - (this.d * sin);
	        this.d = (c1 * sin) + (this.d * cos);
	        this.tx = (tx1 * cos) - (this.ty * sin);
	        this.ty = (tx1 * sin) + (this.ty * cos);
	        return this;
	    };
	    /**
	     * Appends the given Matrix to this Matrix.
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to append.
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	    Matrix.prototype.append = function (matrix) {
	        var a1 = this.a;
	        var b1 = this.b;
	        var c1 = this.c;
	        var d1 = this.d;
	        this.a = (matrix.a * a1) + (matrix.b * c1);
	        this.b = (matrix.a * b1) + (matrix.b * d1);
	        this.c = (matrix.c * a1) + (matrix.d * c1);
	        this.d = (matrix.c * b1) + (matrix.d * d1);
	        this.tx = (matrix.tx * a1) + (matrix.ty * c1) + this.tx;
	        this.ty = (matrix.tx * b1) + (matrix.ty * d1) + this.ty;
	        return this;
	    };
	    /**
	     * Sets the matrix based on all the available properties
	     *
	     * @param {number} x - Position on the x axis
	     * @param {number} y - Position on the y axis
	     * @param {number} pivotX - Pivot on the x axis
	     * @param {number} pivotY - Pivot on the y axis
	     * @param {number} scaleX - Scale on the x axis
	     * @param {number} scaleY - Scale on the y axis
	     * @param {number} rotation - Rotation in radians
	     * @param {number} skewX - Skew on the x axis
	     * @param {number} skewY - Skew on the y axis
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	    Matrix.prototype.setTransform = function (x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
	        this.a = Math.cos(rotation + skewY) * scaleX;
	        this.b = Math.sin(rotation + skewY) * scaleX;
	        this.c = -Math.sin(rotation - skewX) * scaleY;
	        this.d = Math.cos(rotation - skewX) * scaleY;
	        this.tx = x - ((pivotX * this.a) + (pivotY * this.c));
	        this.ty = y - ((pivotX * this.b) + (pivotY * this.d));
	        return this;
	    };
	    /**
	     * Prepends the given Matrix to this Matrix.
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to prepend
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	    Matrix.prototype.prepend = function (matrix) {
	        var tx1 = this.tx;
	        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
	            var a1 = this.a;
	            var c1 = this.c;
	            this.a = (a1 * matrix.a) + (this.b * matrix.c);
	            this.b = (a1 * matrix.b) + (this.b * matrix.d);
	            this.c = (c1 * matrix.a) + (this.d * matrix.c);
	            this.d = (c1 * matrix.b) + (this.d * matrix.d);
	        }
	        this.tx = (tx1 * matrix.a) + (this.ty * matrix.c) + matrix.tx;
	        this.ty = (tx1 * matrix.b) + (this.ty * matrix.d) + matrix.ty;
	        return this;
	    };
	    /**
	     * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
	     *
	     * @param {PIXI.Transform} transform - The transform to apply the properties to.
	     * @return {PIXI.Transform} The transform with the newly applied properties
	     */
	    Matrix.prototype.decompose = function (transform) {
	        // sort out rotation / skew..
	        var a = this.a;
	        var b = this.b;
	        var c = this.c;
	        var d = this.d;
	        var skewX = -Math.atan2(-c, d);
	        var skewY = Math.atan2(b, a);
	        var delta = Math.abs(skewX + skewY);
	        if (delta < 0.00001 || Math.abs(PI_2 - delta) < 0.00001) {
	            transform.rotation = skewY;
	            transform.skew.x = transform.skew.y = 0;
	        }
	        else {
	            transform.rotation = 0;
	            transform.skew.x = skewX;
	            transform.skew.y = skewY;
	        }
	        // next set scale
	        transform.scale.x = Math.sqrt((a * a) + (b * b));
	        transform.scale.y = Math.sqrt((c * c) + (d * d));
	        // next set position
	        transform.position.x = this.tx;
	        transform.position.y = this.ty;
	        return transform;
	    };
	    /**
	     * Inverts this matrix
	     *
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	    Matrix.prototype.invert = function () {
	        var a1 = this.a;
	        var b1 = this.b;
	        var c1 = this.c;
	        var d1 = this.d;
	        var tx1 = this.tx;
	        var n = (a1 * d1) - (b1 * c1);
	        this.a = d1 / n;
	        this.b = -b1 / n;
	        this.c = -c1 / n;
	        this.d = a1 / n;
	        this.tx = ((c1 * this.ty) - (d1 * tx1)) / n;
	        this.ty = -((a1 * this.ty) - (b1 * tx1)) / n;
	        return this;
	    };
	    /**
	     * Resets this Matrix to an identity (default) matrix.
	     *
	     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
	     */
	    Matrix.prototype.identity = function () {
	        this.a = 1;
	        this.b = 0;
	        this.c = 0;
	        this.d = 1;
	        this.tx = 0;
	        this.ty = 0;
	        return this;
	    };
	    /**
	     * Creates a new Matrix object with the same values as this one.
	     *
	     * @return {PIXI.Matrix} A copy of this matrix. Good for chaining method calls.
	     */
	    Matrix.prototype.clone = function () {
	        var matrix = new Matrix();
	        matrix.a = this.a;
	        matrix.b = this.b;
	        matrix.c = this.c;
	        matrix.d = this.d;
	        matrix.tx = this.tx;
	        matrix.ty = this.ty;
	        return matrix;
	    };
	    /**
	     * Changes the values of the given matrix to be the same as the ones in this matrix
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to copy to.
	     * @return {PIXI.Matrix} The matrix given in parameter with its values updated.
	     */
	    Matrix.prototype.copyTo = function (matrix) {
	        matrix.a = this.a;
	        matrix.b = this.b;
	        matrix.c = this.c;
	        matrix.d = this.d;
	        matrix.tx = this.tx;
	        matrix.ty = this.ty;
	        return matrix;
	    };
	    /**
	     * Changes the values of the matrix to be the same as the ones in given matrix
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to copy from.
	     * @return {PIXI.Matrix} this
	     */
	    Matrix.prototype.copyFrom = function (matrix) {
	        this.a = matrix.a;
	        this.b = matrix.b;
	        this.c = matrix.c;
	        this.d = matrix.d;
	        this.tx = matrix.tx;
	        this.ty = matrix.ty;
	        return this;
	    };
	    Object.defineProperty(Matrix, "IDENTITY", {
	        /**
	         * A default (identity) matrix
	         *
	         * @static
	         * @const
	         * @member {PIXI.Matrix}
	         */
	        get: function () {
	            return new Matrix();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Matrix, "TEMP_MATRIX", {
	        /**
	         * A temp matrix
	         *
	         * @static
	         * @const
	         * @member {PIXI.Matrix}
	         */
	        get: function () {
	            return new Matrix();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Matrix;
	}());

	// Your friendly neighbour https://en.wikipedia.org/wiki/Dihedral_group
	/*
	 * Transform matrix for operation n is:
	 * | ux | vx |
	 * | uy | vy |
	 */
	var ux = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1];
	var uy = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1];
	var vx = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1];
	var vy = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1];
	/**
	 * [Cayley Table]{@link https://en.wikipedia.org/wiki/Cayley_table}
	 * for the composition of each rotation in the dihederal group D8.
	 *
	 * @type number[][]
	 * @private
	 */
	var rotationCayley = [];
	/**
	 * Matrices for each `GD8Symmetry` rotation.
	 *
	 * @type Matrix[]
	 * @private
	 */
	var rotationMatrices = [];
	/*
	 * Alias for {@code Math.sign}.
	 */
	var signum = Math.sign;
	/*
	 * Initializes `rotationCayley` and `rotationMatrices`. It is called
	 * only once below.
	 */
	function init() {
	    for (var i = 0; i < 16; i++) {
	        var row = [];
	        rotationCayley.push(row);
	        for (var j = 0; j < 16; j++) {
	            /* Multiplies rotation matrices i and j. */
	            var _ux = signum((ux[i] * ux[j]) + (vx[i] * uy[j]));
	            var _uy = signum((uy[i] * ux[j]) + (vy[i] * uy[j]));
	            var _vx = signum((ux[i] * vx[j]) + (vx[i] * vy[j]));
	            var _vy = signum((uy[i] * vx[j]) + (vy[i] * vy[j]));
	            /* Finds rotation matrix matching the product and pushes it. */
	            for (var k = 0; k < 16; k++) {
	                if (ux[k] === _ux && uy[k] === _uy
	                    && vx[k] === _vx && vy[k] === _vy) {
	                    row.push(k);
	                    break;
	                }
	            }
	        }
	    }
	    for (var i = 0; i < 16; i++) {
	        var mat = new Matrix();
	        mat.set(ux[i], uy[i], vx[i], vy[i], 0, 0);
	        rotationMatrices.push(mat);
	    }
	}
	init();
	/**
	 * @memberof PIXI
	 * @typedef {number} GD8Symmetry
	 * @see PIXI.groupD8
	 */
	/**
	 * Implements the dihedral group D8, which is similar to
	 * [group D4]{@link http://mathworld.wolfram.com/DihedralGroupD4.html};
	 * D8 is the same but with diagonals, and it is used for texture
	 * rotations.
	 *
	 * The directions the U- and V- axes after rotation
	 * of an angle of `a: GD8Constant` are the vectors `(uX(a), uY(a))`
	 * and `(vX(a), vY(a))`. These aren't necessarily unit vectors.
	 *
	 * **Origin:**<br>
	 *  This is the small part of gameofbombs.com portal system. It works.
	 *
	 * @see PIXI.groupD8.E
	 * @see PIXI.groupD8.SE
	 * @see PIXI.groupD8.S
	 * @see PIXI.groupD8.SW
	 * @see PIXI.groupD8.W
	 * @see PIXI.groupD8.NW
	 * @see PIXI.groupD8.N
	 * @see PIXI.groupD8.NE
	 * @author Ivan @ivanpopelyshev
	 * @namespace PIXI.groupD8
	 * @memberof PIXI
	 */
	var groupD8 = {
	    /**
	     * | Rotation | Direction |
	     * |----------|-----------|
	     * | 0Â°       | East      |
	     *
	     * @memberof PIXI.groupD8
	     * @constant {PIXI.GD8Symmetry}
	     */
	    E: 0,
	    /**
	     * | Rotation | Direction |
	     * |----------|-----------|
	     * | 45Â°â†»     | Southeast |
	     *
	     * @memberof PIXI.groupD8
	     * @constant {PIXI.GD8Symmetry}
	     */
	    SE: 1,
	    /**
	     * | Rotation | Direction |
	     * |----------|-----------|
	     * | 90Â°â†»     | South     |
	     *
	     * @memberof PIXI.groupD8
	     * @constant {PIXI.GD8Symmetry}
	     */
	    S: 2,
	    /**
	     * | Rotation | Direction |
	     * |----------|-----------|
	     * | 135Â°â†»    | Southwest |
	     *
	     * @memberof PIXI.groupD8
	     * @constant {PIXI.GD8Symmetry}
	     */
	    SW: 3,
	    /**
	     * | Rotation | Direction |
	     * |----------|-----------|
	     * | 180Â°     | West      |
	     *
	     * @memberof PIXI.groupD8
	     * @constant {PIXI.GD8Symmetry}
	     */
	    W: 4,
	    /**
	     * | Rotation    | Direction    |
	     * |-------------|--------------|
	     * | -135Â°/225Â°â†» | Northwest    |
	     *
	     * @memberof PIXI.groupD8
	     * @constant {PIXI.GD8Symmetry}
	     */
	    NW: 5,
	    /**
	     * | Rotation    | Direction    |
	     * |-------------|--------------|
	     * | -90Â°/270Â°â†»  | North        |
	     *
	     * @memberof PIXI.groupD8
	     * @constant {PIXI.GD8Symmetry}
	     */
	    N: 6,
	    /**
	     * | Rotation    | Direction    |
	     * |-------------|--------------|
	     * | -45Â°/315Â°â†»  | Northeast    |
	     *
	     * @memberof PIXI.groupD8
	     * @constant {PIXI.GD8Symmetry}
	     */
	    NE: 7,
	    /**
	     * Reflection about Y-axis.
	     *
	     * @memberof PIXI.groupD8
	     * @constant {PIXI.GD8Symmetry}
	     */
	    MIRROR_VERTICAL: 8,
	    /**
	     * Reflection about the main diagonal.
	     *
	     * @memberof PIXI.groupD8
	     * @constant {PIXI.GD8Symmetry}
	     */
	    MAIN_DIAGONAL: 10,
	    /**
	     * Reflection about X-axis.
	     *
	     * @memberof PIXI.groupD8
	     * @constant {PIXI.GD8Symmetry}
	     */
	    MIRROR_HORIZONTAL: 12,
	    /**
	     * Reflection about reverse diagonal.
	     *
	     * @memberof PIXI.groupD8
	     * @constant {PIXI.GD8Symmetry}
	     */
	    REVERSE_DIAGONAL: 14,
	    /**
	     * @memberof PIXI.groupD8
	     * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
	     * @return {PIXI.GD8Symmetry} The X-component of the U-axis
	     *    after rotating the axes.
	     */
	    uX: function (ind) { return ux[ind]; },
	    /**
	     * @memberof PIXI.groupD8
	     * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
	     * @return {PIXI.GD8Symmetry} The Y-component of the U-axis
	     *    after rotating the axes.
	     */
	    uY: function (ind) { return uy[ind]; },
	    /**
	     * @memberof PIXI.groupD8
	     * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
	     * @return {PIXI.GD8Symmetry} The X-component of the V-axis
	     *    after rotating the axes.
	     */
	    vX: function (ind) { return vx[ind]; },
	    /**
	     * @memberof PIXI.groupD8
	     * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
	     * @return {PIXI.GD8Symmetry} The Y-component of the V-axis
	     *    after rotating the axes.
	     */
	    vY: function (ind) { return vy[ind]; },
	    /**
	     * @memberof PIXI.groupD8
	     * @param {PIXI.GD8Symmetry} rotation - symmetry whose opposite
	     *   is needed. Only rotations have opposite symmetries while
	     *   reflections don't.
	     * @return {PIXI.GD8Symmetry} The opposite symmetry of `rotation`
	     */
	    inv: function (rotation) {
	        if (rotation & 8) // true only if between 8 & 15 (reflections)
	         {
	            return rotation & 15; // or rotation % 16
	        }
	        return (-rotation) & 7; // or (8 - rotation) % 8
	    },
	    /**
	     * Composes the two D8 operations.
	     *
	     * Taking `^` as reflection:
	     *
	     * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
	     * |-------|-----|-----|-----|-----|------|-------|-------|-------|
	     * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
	     * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
	     * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
	     * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
	     * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
	     * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
	     * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
	     * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
	     *
	     * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
	     * @memberof PIXI.groupD8
	     * @param {PIXI.GD8Symmetry} rotationSecond - Second operation, which
	     *   is the row in the above cayley table.
	     * @param {PIXI.GD8Symmetry} rotationFirst - First operation, which
	     *   is the column in the above cayley table.
	     * @return {PIXI.GD8Symmetry} Composed operation
	     */
	    add: function (rotationSecond, rotationFirst) { return (rotationCayley[rotationSecond][rotationFirst]); },
	    /**
	     * Reverse of `add`.
	     *
	     * @memberof PIXI.groupD8
	     * @param {PIXI.GD8Symmetry} rotationSecond - Second operation
	     * @param {PIXI.GD8Symmetry} rotationFirst - First operation
	     * @return {PIXI.GD8Symmetry} Result
	     */
	    sub: function (rotationSecond, rotationFirst) { return (rotationCayley[rotationSecond][groupD8.inv(rotationFirst)]); },
	    /**
	     * Adds 180 degrees to rotation, which is a commutative
	     * operation.
	     *
	     * @memberof PIXI.groupD8
	     * @param {number} rotation - The number to rotate.
	     * @returns {number} Rotated number
	     */
	    rotate180: function (rotation) { return rotation ^ 4; },
	    /**
	     * Checks if the rotation angle is vertical, i.e. south
	     * or north. It doesn't work for reflections.
	     *
	     * @memberof PIXI.groupD8
	     * @param {PIXI.GD8Symmetry} rotation - The number to check.
	     * @returns {boolean} Whether or not the direction is vertical
	     */
	    isVertical: function (rotation) { return (rotation & 3) === 2; },
	    /**
	     * Approximates the vector `V(dx,dy)` into one of the
	     * eight directions provided by `groupD8`.
	     *
	     * @memberof PIXI.groupD8
	     * @param {number} dx - X-component of the vector
	     * @param {number} dy - Y-component of the vector
	     * @return {PIXI.GD8Symmetry} Approximation of the vector into
	     *  one of the eight symmetries.
	     */
	    byDirection: function (dx, dy) {
	        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
	            if (dy >= 0) {
	                return groupD8.S;
	            }
	            return groupD8.N;
	        }
	        else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
	            if (dx > 0) {
	                return groupD8.E;
	            }
	            return groupD8.W;
	        }
	        else if (dy > 0) {
	            if (dx > 0) {
	                return groupD8.SE;
	            }
	            return groupD8.SW;
	        }
	        else if (dx > 0) {
	            return groupD8.NE;
	        }
	        return groupD8.NW;
	    },
	    /**
	     * Helps sprite to compensate texture packer rotation.
	     *
	     * @memberof PIXI.groupD8
	     * @param {PIXI.Matrix} matrix - sprite world matrix
	     * @param {PIXI.GD8Symmetry} rotation - The rotation factor to use.
	     * @param {number} tx - sprite anchoring
	     * @param {number} ty - sprite anchoring
	     */
	    matrixAppendRotationInv: function (matrix, rotation, tx, ty) {
	        if (tx === void 0) { tx = 0; }
	        if (ty === void 0) { ty = 0; }
	        // Packer used "rotation", we use "inv(rotation)"
	        var mat = rotationMatrices[groupD8.inv(rotation)];
	        mat.tx = tx;
	        mat.ty = ty;
	        matrix.append(mat);
	    },
	};

	/**
	 * Transform that takes care about its versions
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Transform = /** @class */ (function () {
	    function Transform() {
	        /**
	         * The world transformation matrix.
	         *
	         * @member {PIXI.Matrix}
	         */
	        this.worldTransform = new Matrix();
	        /**
	         * The local transformation matrix.
	         *
	         * @member {PIXI.Matrix}
	         */
	        this.localTransform = new Matrix();
	        /**
	         * The coordinate of the object relative to the local coordinates of the parent.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        this.position = new ObservablePoint(this.onChange, this, 0, 0);
	        /**
	         * The scale factor of the object.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        this.scale = new ObservablePoint(this.onChange, this, 1, 1);
	        /**
	         * The pivot point of the displayObject that it rotates around.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        this.pivot = new ObservablePoint(this.onChange, this, 0, 0);
	        /**
	         * The skew amount, on the x and y axis.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        this.skew = new ObservablePoint(this.updateSkew, this, 0, 0);
	        /**
	         * The rotation amount.
	         *
	         * @protected
	         * @member {number}
	         */
	        this._rotation = 0;
	        /**
	         * The X-coordinate value of the normalized local X axis,
	         * the first column of the local transformation matrix without a scale.
	         *
	         * @protected
	         * @member {number}
	         */
	        this._cx = 1;
	        /**
	         * The Y-coordinate value of the normalized local X axis,
	         * the first column of the local transformation matrix without a scale.
	         *
	         * @protected
	         * @member {number}
	         */
	        this._sx = 0;
	        /**
	         * The X-coordinate value of the normalized local Y axis,
	         * the second column of the local transformation matrix without a scale.
	         *
	         * @protected
	         * @member {number}
	         */
	        this._cy = 0;
	        /**
	         * The Y-coordinate value of the normalized local Y axis,
	         * the second column of the local transformation matrix without a scale.
	         *
	         * @protected
	         * @member {number}
	         */
	        this._sy = 1;
	        /**
	         * The locally unique ID of the local transform.
	         *
	         * @protected
	         * @member {number}
	         */
	        this._localID = 0;
	        /**
	         * The locally unique ID of the local transform
	         * used to calculate the current local transformation matrix.
	         *
	         * @protected
	         * @member {number}
	         */
	        this._currentLocalID = 0;
	        /**
	         * The locally unique ID of the world transform.
	         *
	         * @protected
	         * @member {number}
	         */
	        this._worldID = 0;
	        /**
	         * The locally unique ID of the parent's world transform
	         * used to calculate the current world transformation matrix.
	         *
	         * @protected
	         * @member {number}
	         */
	        this._parentID = 0;
	    }
	    /**
	     * Called when a value changes.
	     *
	     * @protected
	     */
	    Transform.prototype.onChange = function () {
	        this._localID++;
	    };
	    /**
	     * Called when the skew or the rotation changes.
	     *
	     * @protected
	     */
	    Transform.prototype.updateSkew = function () {
	        this._cx = Math.cos(this._rotation + this.skew.y);
	        this._sx = Math.sin(this._rotation + this.skew.y);
	        this._cy = -Math.sin(this._rotation - this.skew.x); // cos, added PI/2
	        this._sy = Math.cos(this._rotation - this.skew.x); // sin, added PI/2
	        this._localID++;
	    };
	    /**
	     * Updates the local transformation matrix.
	     */
	    Transform.prototype.updateLocalTransform = function () {
	        var lt = this.localTransform;
	        if (this._localID !== this._currentLocalID) {
	            // get the matrix values of the displayobject based on its transform properties..
	            lt.a = this._cx * this.scale.x;
	            lt.b = this._sx * this.scale.x;
	            lt.c = this._cy * this.scale.y;
	            lt.d = this._sy * this.scale.y;
	            lt.tx = this.position.x - ((this.pivot.x * lt.a) + (this.pivot.y * lt.c));
	            lt.ty = this.position.y - ((this.pivot.x * lt.b) + (this.pivot.y * lt.d));
	            this._currentLocalID = this._localID;
	            // force an update..
	            this._parentID = -1;
	        }
	    };
	    /**
	     * Updates the local and the world transformation matrices.
	     *
	     * @param {PIXI.Transform} parentTransform - The parent transform
	     */
	    Transform.prototype.updateTransform = function (parentTransform) {
	        var lt = this.localTransform;
	        if (this._localID !== this._currentLocalID) {
	            // get the matrix values of the displayobject based on its transform properties..
	            lt.a = this._cx * this.scale.x;
	            lt.b = this._sx * this.scale.x;
	            lt.c = this._cy * this.scale.y;
	            lt.d = this._sy * this.scale.y;
	            lt.tx = this.position.x - ((this.pivot.x * lt.a) + (this.pivot.y * lt.c));
	            lt.ty = this.position.y - ((this.pivot.x * lt.b) + (this.pivot.y * lt.d));
	            this._currentLocalID = this._localID;
	            // force an update..
	            this._parentID = -1;
	        }
	        if (this._parentID !== parentTransform._worldID) {
	            // concat the parent matrix with the objects transform.
	            var pt = parentTransform.worldTransform;
	            var wt = this.worldTransform;
	            wt.a = (lt.a * pt.a) + (lt.b * pt.c);
	            wt.b = (lt.a * pt.b) + (lt.b * pt.d);
	            wt.c = (lt.c * pt.a) + (lt.d * pt.c);
	            wt.d = (lt.c * pt.b) + (lt.d * pt.d);
	            wt.tx = (lt.tx * pt.a) + (lt.ty * pt.c) + pt.tx;
	            wt.ty = (lt.tx * pt.b) + (lt.ty * pt.d) + pt.ty;
	            this._parentID = parentTransform._worldID;
	            // update the id of the transform..
	            this._worldID++;
	        }
	    };
	    /**
	     * Decomposes a matrix and sets the transforms properties based on it.
	     *
	     * @param {PIXI.Matrix} matrix - The matrix to decompose
	     */
	    Transform.prototype.setFromMatrix = function (matrix) {
	        matrix.decompose(this);
	        this._localID++;
	    };
	    Object.defineProperty(Transform.prototype, "rotation", {
	        /**
	         * The rotation of the object in radians.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._rotation;
	        },
	        set: function (value) {
	            if (this._rotation !== value) {
	                this._rotation = value;
	                this.updateSkew();
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * A default (identity) transform
	     *
	     * @static
	     * @constant
	     * @member {PIXI.Transform}
	     */
	    Transform.IDENTITY = new Transform();
	    return Transform;
	}());

	/*!
	 * @pixi/display - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/display is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * Sets the default value for the container property 'sortableChildren'.
	 * If set to true, the container will sort its children by zIndex value
	 * when updateTransform() is called, or manually if sortChildren() is called.
	 *
	 * This actually changes the order of elements in the array, so should be treated
	 * as a basic solution that is not performant compared to other solutions,
	 * such as @link https://github.com/pixijs/pixi-display
	 *
	 * Also be aware of that this may not work nicely with the addChildAt() function,
	 * as the zIndex sorting may cause the child to automatically sorted to another position.
	 *
	 * @static
	 * @constant
	 * @name SORTABLE_CHILDREN
	 * @memberof PIXI.settings
	 * @type {boolean}
	 * @default false
	 */
	settings.SORTABLE_CHILDREN = false;

	/**
	 * 'Builder' pattern for bounds rectangles.
	 *
	 * This could be called an Axis-Aligned Bounding Box.
	 * It is not an actual shape. It is a mutable thing; no 'EMPTY' or those kind of problems.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Bounds = /** @class */ (function () {
	    function Bounds() {
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.minX = Infinity;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.minY = Infinity;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.maxX = -Infinity;
	        /**
	         * @member {number}
	         * @default 0
	         */
	        this.maxY = -Infinity;
	        this.rect = null;
	        /**
	         * It is updated to _boundsID of corresponding object to keep bounds in sync with content.
	         * Updated from outside, thus public modifier.
	         *
	         * @member {number}
	         * @public
	         */
	        this.updateID = -1;
	    }
	    /**
	     * Checks if bounds are empty.
	     *
	     * @return {boolean} True if empty.
	     */
	    Bounds.prototype.isEmpty = function () {
	        return this.minX > this.maxX || this.minY > this.maxY;
	    };
	    /**
	     * Clears the bounds and resets.
	     *
	     */
	    Bounds.prototype.clear = function () {
	        this.minX = Infinity;
	        this.minY = Infinity;
	        this.maxX = -Infinity;
	        this.maxY = -Infinity;
	    };
	    /**
	     * Can return Rectangle.EMPTY constant, either construct new rectangle, either use your rectangle
	     * It is not guaranteed that it will return tempRect
	     *
	     * @param {PIXI.Rectangle} rect - temporary object will be used if AABB is not empty
	     * @returns {PIXI.Rectangle} A rectangle of the bounds
	     */
	    Bounds.prototype.getRectangle = function (rect) {
	        if (this.minX > this.maxX || this.minY > this.maxY) {
	            return Rectangle.EMPTY;
	        }
	        rect = rect || new Rectangle(0, 0, 1, 1);
	        rect.x = this.minX;
	        rect.y = this.minY;
	        rect.width = this.maxX - this.minX;
	        rect.height = this.maxY - this.minY;
	        return rect;
	    };
	    /**
	     * This function should be inlined when its possible.
	     *
	     * @param {PIXI.IPointData} point - The point to add.
	     */
	    Bounds.prototype.addPoint = function (point) {
	        this.minX = Math.min(this.minX, point.x);
	        this.maxX = Math.max(this.maxX, point.x);
	        this.minY = Math.min(this.minY, point.y);
	        this.maxY = Math.max(this.maxY, point.y);
	    };
	    /**
	     * Adds a quad, not transformed
	     *
	     * @param {Float32Array} vertices - The verts to add.
	     */
	    Bounds.prototype.addQuad = function (vertices) {
	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;
	        var x = vertices[0];
	        var y = vertices[1];
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	        x = vertices[2];
	        y = vertices[3];
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	        x = vertices[4];
	        y = vertices[5];
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	        x = vertices[6];
	        y = vertices[7];
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	        this.minX = minX;
	        this.minY = minY;
	        this.maxX = maxX;
	        this.maxY = maxY;
	    };
	    /**
	     * Adds sprite frame, transformed.
	     *
	     * @param {PIXI.Transform} transform - transform to apply
	     * @param {number} x0 - left X of frame
	     * @param {number} y0 - top Y of frame
	     * @param {number} x1 - right X of frame
	     * @param {number} y1 - bottom Y of frame
	     */
	    Bounds.prototype.addFrame = function (transform, x0, y0, x1, y1) {
	        this.addFrameMatrix(transform.worldTransform, x0, y0, x1, y1);
	    };
	    /**
	     * Adds sprite frame, multiplied by matrix
	     *
	     * @param {PIXI.Matrix} matrix - matrix to apply
	     * @param {number} x0 - left X of frame
	     * @param {number} y0 - top Y of frame
	     * @param {number} x1 - right X of frame
	     * @param {number} y1 - bottom Y of frame
	     */
	    Bounds.prototype.addFrameMatrix = function (matrix, x0, y0, x1, y1) {
	        var a = matrix.a;
	        var b = matrix.b;
	        var c = matrix.c;
	        var d = matrix.d;
	        var tx = matrix.tx;
	        var ty = matrix.ty;
	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;
	        var x = (a * x0) + (c * y0) + tx;
	        var y = (b * x0) + (d * y0) + ty;
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	        x = (a * x1) + (c * y0) + tx;
	        y = (b * x1) + (d * y0) + ty;
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	        x = (a * x0) + (c * y1) + tx;
	        y = (b * x0) + (d * y1) + ty;
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	        x = (a * x1) + (c * y1) + tx;
	        y = (b * x1) + (d * y1) + ty;
	        minX = x < minX ? x : minX;
	        minY = y < minY ? y : minY;
	        maxX = x > maxX ? x : maxX;
	        maxY = y > maxY ? y : maxY;
	        this.minX = minX;
	        this.minY = minY;
	        this.maxX = maxX;
	        this.maxY = maxY;
	    };
	    /**
	     * Adds screen vertices from array
	     *
	     * @param {Float32Array} vertexData - calculated vertices
	     * @param {number} beginOffset - begin offset
	     * @param {number} endOffset - end offset, excluded
	     */
	    Bounds.prototype.addVertexData = function (vertexData, beginOffset, endOffset) {
	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;
	        for (var i = beginOffset; i < endOffset; i += 2) {
	            var x = vertexData[i];
	            var y = vertexData[i + 1];
	            minX = x < minX ? x : minX;
	            minY = y < minY ? y : minY;
	            maxX = x > maxX ? x : maxX;
	            maxY = y > maxY ? y : maxY;
	        }
	        this.minX = minX;
	        this.minY = minY;
	        this.maxX = maxX;
	        this.maxY = maxY;
	    };
	    /**
	     * Add an array of mesh vertices
	     *
	     * @param {PIXI.Transform} transform - mesh transform
	     * @param {Float32Array} vertices - mesh coordinates in array
	     * @param {number} beginOffset - begin offset
	     * @param {number} endOffset - end offset, excluded
	     */
	    Bounds.prototype.addVertices = function (transform, vertices, beginOffset, endOffset) {
	        this.addVerticesMatrix(transform.worldTransform, vertices, beginOffset, endOffset);
	    };
	    /**
	     * Add an array of mesh vertices.
	     *
	     * @param {PIXI.Matrix} matrix - mesh matrix
	     * @param {Float32Array} vertices - mesh coordinates in array
	     * @param {number} beginOffset - begin offset
	     * @param {number} endOffset - end offset, excluded
	     * @param {number} [padX=0] - x padding
	     * @param {number} [padY=0] - y padding
	     */
	    Bounds.prototype.addVerticesMatrix = function (matrix, vertices, beginOffset, endOffset, padX, padY) {
	        if (padX === void 0) { padX = 0; }
	        if (padY === void 0) { padY = padX; }
	        var a = matrix.a;
	        var b = matrix.b;
	        var c = matrix.c;
	        var d = matrix.d;
	        var tx = matrix.tx;
	        var ty = matrix.ty;
	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;
	        for (var i = beginOffset; i < endOffset; i += 2) {
	            var rawX = vertices[i];
	            var rawY = vertices[i + 1];
	            var x = (a * rawX) + (c * rawY) + tx;
	            var y = (d * rawY) + (b * rawX) + ty;
	            minX = Math.min(minX, x - padX);
	            maxX = Math.max(maxX, x + padX);
	            minY = Math.min(minY, y - padY);
	            maxY = Math.max(maxY, y + padY);
	        }
	        this.minX = minX;
	        this.minY = minY;
	        this.maxX = maxX;
	        this.maxY = maxY;
	    };
	    /**
	     * Adds other Bounds.
	     *
	     * @param {PIXI.Bounds} bounds - The Bounds to be added
	     */
	    Bounds.prototype.addBounds = function (bounds) {
	        var minX = this.minX;
	        var minY = this.minY;
	        var maxX = this.maxX;
	        var maxY = this.maxY;
	        this.minX = bounds.minX < minX ? bounds.minX : minX;
	        this.minY = bounds.minY < minY ? bounds.minY : minY;
	        this.maxX = bounds.maxX > maxX ? bounds.maxX : maxX;
	        this.maxY = bounds.maxY > maxY ? bounds.maxY : maxY;
	    };
	    /**
	     * Adds other Bounds, masked with Bounds.
	     *
	     * @param {PIXI.Bounds} bounds - The Bounds to be added.
	     * @param {PIXI.Bounds} mask - TODO
	     */
	    Bounds.prototype.addBoundsMask = function (bounds, mask) {
	        var _minX = bounds.minX > mask.minX ? bounds.minX : mask.minX;
	        var _minY = bounds.minY > mask.minY ? bounds.minY : mask.minY;
	        var _maxX = bounds.maxX < mask.maxX ? bounds.maxX : mask.maxX;
	        var _maxY = bounds.maxY < mask.maxY ? bounds.maxY : mask.maxY;
	        if (_minX <= _maxX && _minY <= _maxY) {
	            var minX = this.minX;
	            var minY = this.minY;
	            var maxX = this.maxX;
	            var maxY = this.maxY;
	            this.minX = _minX < minX ? _minX : minX;
	            this.minY = _minY < minY ? _minY : minY;
	            this.maxX = _maxX > maxX ? _maxX : maxX;
	            this.maxY = _maxY > maxY ? _maxY : maxY;
	        }
	    };
	    /**
	     * Adds other Bounds, multiplied by matrix. Bounds shouldn't be empty.
	     *
	     * @param {PIXI.Bounds} bounds - other bounds
	     * @param {PIXI.Matrix} matrix - multiplicator
	     */
	    Bounds.prototype.addBoundsMatrix = function (bounds, matrix) {
	        this.addFrameMatrix(matrix, bounds.minX, bounds.minY, bounds.maxX, bounds.maxY);
	    };
	    /**
	     * Adds other Bounds, masked with Rectangle.
	     *
	     * @param {PIXI.Bounds} bounds - TODO
	     * @param {PIXI.Rectangle} area - TODO
	     */
	    Bounds.prototype.addBoundsArea = function (bounds, area) {
	        var _minX = bounds.minX > area.x ? bounds.minX : area.x;
	        var _minY = bounds.minY > area.y ? bounds.minY : area.y;
	        var _maxX = bounds.maxX < area.x + area.width ? bounds.maxX : (area.x + area.width);
	        var _maxY = bounds.maxY < area.y + area.height ? bounds.maxY : (area.y + area.height);
	        if (_minX <= _maxX && _minY <= _maxY) {
	            var minX = this.minX;
	            var minY = this.minY;
	            var maxX = this.maxX;
	            var maxY = this.maxY;
	            this.minX = _minX < minX ? _minX : minX;
	            this.minY = _minY < minY ? _minY : minY;
	            this.maxX = _maxX > maxX ? _maxX : maxX;
	            this.maxY = _maxY > maxY ? _maxY : maxY;
	        }
	    };
	    /**
	     * Pads bounds object, making it grow in all directions.
	     * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
	     *
	     * @param {number} [paddingX=0] - The horizontal padding amount.
	     * @param {number} [paddingY=0] - The vertical padding amount.
	     */
	    Bounds.prototype.pad = function (paddingX, paddingY) {
	        if (paddingX === void 0) { paddingX = 0; }
	        if (paddingY === void 0) { paddingY = paddingX; }
	        if (!this.isEmpty()) {
	            this.minX -= paddingX;
	            this.maxX += paddingX;
	            this.minY -= paddingY;
	            this.maxY += paddingY;
	        }
	    };
	    /**
	     * Adds padded frame. (x0, y0) should be strictly less than (x1, y1)
	     *
	     * @param {number} x0 - left X of frame
	     * @param {number} y0 - top Y of frame
	     * @param {number} x1 - right X of frame
	     * @param {number} y1 - bottom Y of frame
	     * @param {number} padX - padding X
	     * @param {number} padY - padding Y
	     */
	    Bounds.prototype.addFramePad = function (x0, y0, x1, y1, padX, padY) {
	        x0 -= padX;
	        y0 -= padY;
	        x1 += padX;
	        y1 += padY;
	        this.minX = this.minX < x0 ? this.minX : x0;
	        this.maxX = this.maxX > x1 ? this.maxX : x1;
	        this.minY = this.minY < y0 ? this.minY : y0;
	        this.maxY = this.maxY > y1 ? this.maxY : y1;
	    };
	    return Bounds;
	}());

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics = function(d, b) {
	    extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics(d, b);
	};

	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	/**
	 * The base class for all objects that are rendered on the screen.
	 *
	 * This is an abstract class and should not be used on its own; rather it should b e extended.
	 *
	 * @class
	 * @extends PIXI.utils.EventEmitter
	 * @memberof PIXI
	 */
	var DisplayObject = /** @class */ (function (_super) {
	    __extends(DisplayObject, _super);
	    function DisplayObject() {
	        var _this = _super.call(this) || this;
	        _this.tempDisplayObjectParent = null;
	        // TODO: need to create Transform from factory
	        /**
	         * World transform and local transform of this object.
	         * This will become read-only later, please do not assign anything there unless you know what are you doing.
	         *
	         * @member {PIXI.Transform}
	         */
	        _this.transform = new Transform();
	        /**
	         * The opacity of the object.
	         *
	         * @member {number}
	         */
	        _this.alpha = 1;
	        /**
	         * The visibility of the object. If false the object will not be drawn, and
	         * the updateTransform function will not be called.
	         *
	         * Only affects recursive calls from parent. You can ask for bounds or call updateTransform manually.
	         *
	         * @member {boolean}
	         */
	        _this.visible = true;
	        /**
	         * Can this object be rendered, if false the object will not be drawn but the updateTransform
	         * methods will still be called.
	         *
	         * Only affects recursive calls from parent. You can ask for bounds manually.
	         *
	         * @member {boolean}
	         */
	        _this.renderable = true;
	        /**
	         * The display object container that contains this display object.
	         *
	         * @member {PIXI.Container}
	         */
	        _this.parent = null;
	        /**
	         * The multiplied alpha of the displayObject.
	         *
	         * @member {number}
	         * @readonly
	         */
	        _this.worldAlpha = 1;
	        /**
	         * Which index in the children array the display component was before the previous zIndex sort.
	         * Used by containers to help sort objects with the same zIndex, by using previous array index as the decider.
	         *
	         * @member {number}
	         * @protected
	         */
	        _this._lastSortedIndex = 0;
	        /**
	         * The zIndex of the displayObject.
	         * A higher value will mean it will be rendered on top of other displayObjects within the same container.
	         *
	         * @member {number}
	         * @protected
	         */
	        _this._zIndex = 0;
	        /**
	         * The area the filter is applied to. This is used as more of an optimization
	         * rather than figuring out the dimensions of the displayObject each frame you can set this rectangle.
	         *
	         * Also works as an interaction mask.
	         *
	         * @member {?PIXI.Rectangle}
	         */
	        _this.filterArea = null;
	        /**
	         * Sets the filters for the displayObject.
	         * * IMPORTANT: This is a WebGL only feature and will be ignored by the canvas renderer.
	         * To remove filters simply set this property to `'null'`.
	         *
	         * @member {?PIXI.Filter[]}
	         */
	        _this.filters = null;
	        /**
	         * Currently enabled filters
	         * @member {PIXI.Filter[]}
	         * @protected
	         */
	        _this._enabledFilters = null;
	        /**
	         * The bounds object, this is used to calculate and store the bounds of the displayObject.
	         *
	         * @member {PIXI.Bounds}
	         */
	        _this._bounds = new Bounds();
	        /**
	         * Local bounds object, swapped with `_bounds` when using `getLocalBounds()`.
	         *
	         * @member {PIXI.Bounds}
	         */
	        _this._localBounds = null;
	        /**
	         * Flags the cached bounds as dirty.
	         *
	         * @member {number}
	         * @protected
	         */
	        _this._boundsID = 0;
	        /**
	         * Cache of this display-object's bounds-rectangle.
	         *
	         * @member {PIXI.Bounds}
	         * @protected
	         */
	        _this._boundsRect = null;
	        /**
	         * Cache of this display-object's local-bounds rectangle.
	         *
	         * @member {PIXI.Bounds}
	         * @protected
	         */
	        _this._localBoundsRect = null;
	        /**
	         * The original, cached mask of the object.
	         *
	         * @member {PIXI.Container|PIXI.MaskData|null}
	         * @protected
	         */
	        _this._mask = null;
	        /**
	         * Fired when this DisplayObject is added to a Container.
	         *
	         * @event PIXI.DisplayObject#added
	         * @param {PIXI.Container} container - The container added to.
	         */
	        /**
	         * Fired when this DisplayObject is removed from a Container.
	         *
	         * @event PIXI.DisplayObject#removed
	         * @param {PIXI.Container} container - The container removed from.
	         */
	        /**
	         * If the object has been destroyed via destroy(). If true, it should not be used.
	         *
	         * @member {boolean}
	         * @protected
	         */
	        _this._destroyed = false;
	        /**
	         * used to fast check if a sprite is.. a sprite!
	         * @member {boolean}
	         */
	        _this.isSprite = false;
	        /**
	         * Does any other displayObject use this object as a mask?
	         * @member {boolean}
	         */
	        _this.isMask = false;
	        return _this;
	    }
	    /**
	     * Mixes all enumerable properties and methods from a source object to DisplayObject.
	     *
	     * @param {object} source - The source of properties and methods to mix in.
	     */
	    DisplayObject.mixin = function (source) {
	        // in ES8/ES2017, this would be really easy:
	        // Object.defineProperties(DisplayObject.prototype, Object.getOwnPropertyDescriptors(source));
	        // get all the enumerable property keys
	        var keys = Object.keys(source);
	        // loop through properties
	        for (var i = 0; i < keys.length; ++i) {
	            var propertyName = keys[i];
	            // Set the property using the property descriptor - this works for accessors and normal value properties
	            Object.defineProperty(DisplayObject.prototype, propertyName, Object.getOwnPropertyDescriptor(source, propertyName));
	        }
	    };
	    /**
	     * Recursively updates transform of all objects from the root to this one
	     * internal function for toLocal()
	     */
	    DisplayObject.prototype._recursivePostUpdateTransform = function () {
	        if (this.parent) {
	            this.parent._recursivePostUpdateTransform();
	            this.transform.updateTransform(this.parent.transform);
	        }
	        else {
	            this.transform.updateTransform(this._tempDisplayObjectParent.transform);
	        }
	    };
	    /**
	     * Updates the object transform for rendering.
	     *
	     * TODO - Optimization pass!
	     */
	    DisplayObject.prototype.updateTransform = function () {
	        this._boundsID++;
	        this.transform.updateTransform(this.parent.transform);
	        // multiply the alphas..
	        this.worldAlpha = this.alpha * this.parent.worldAlpha;
	    };
	    /**
	     * Retrieves the bounds of the displayObject as a rectangle object.
	     *
	     * @param {boolean} [skipUpdate] - Setting to `true` will stop the transforms of the scene graph from
	     *  being updated. This means the calculation returned MAY be out of date BUT will give you a
	     *  nice performance boost.
	     * @param {PIXI.Rectangle} [rect] - Optional rectangle to store the result of the bounds calculation.
	     * @return {PIXI.Rectangle} The rectangular bounding area.
	     */
	    DisplayObject.prototype.getBounds = function (skipUpdate, rect) {
	        if (!skipUpdate) {
	            if (!this.parent) {
	                this.parent = this._tempDisplayObjectParent;
	                this.updateTransform();
	                this.parent = null;
	            }
	            else {
	                this._recursivePostUpdateTransform();
	                this.updateTransform();
	            }
	        }
	        if (this._bounds.updateID !== this._boundsID) {
	            this.calculateBounds();
	            this._bounds.updateID = this._boundsID;
	        }
	        if (!rect) {
	            if (!this._boundsRect) {
	                this._boundsRect = new Rectangle();
	            }
	            rect = this._boundsRect;
	        }
	        return this._bounds.getRectangle(rect);
	    };
	    /**
	     * Retrieves the local bounds of the displayObject as a rectangle object.
	     *
	     * @param {PIXI.Rectangle} [rect] - Optional rectangle to store the result of the bounds calculation.
	     * @return {PIXI.Rectangle} The rectangular bounding area.
	     */
	    DisplayObject.prototype.getLocalBounds = function (rect) {
	        if (!rect) {
	            if (!this._localBoundsRect) {
	                this._localBoundsRect = new Rectangle();
	            }
	            rect = this._localBoundsRect;
	        }
	        if (!this._localBounds) {
	            this._localBounds = new Bounds();
	        }
	        var transformRef = this.transform;
	        var parentRef = this.parent;
	        this.parent = null;
	        this.transform = this._tempDisplayObjectParent.transform;
	        var worldBounds = this._bounds;
	        var worldBoundsID = this._boundsID;
	        this._bounds = this._localBounds;
	        var bounds = this.getBounds(false, rect);
	        this.parent = parentRef;
	        this.transform = transformRef;
	        this._bounds = worldBounds;
	        this._bounds.updateID += this._boundsID - worldBoundsID; // reflect side-effects
	        return bounds;
	    };
	    /**
	     * Calculates the global position of the display object.
	     *
	     * @param {PIXI.IPointData} position - The world origin to calculate from.
	     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
	     *  (otherwise will create a new Point).
	     * @param {boolean} [skipUpdate=false] - Should we skip the update transform.
	     * @return {PIXI.Point} A point object representing the position of this object.
	     */
	    DisplayObject.prototype.toGlobal = function (position, point, skipUpdate) {
	        if (skipUpdate === void 0) { skipUpdate = false; }
	        if (!skipUpdate) {
	            this._recursivePostUpdateTransform();
	            // this parent check is for just in case the item is a root object.
	            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
	            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
	            if (!this.parent) {
	                this.parent = this._tempDisplayObjectParent;
	                this.displayObjectUpdateTransform();
	                this.parent = null;
	            }
	            else {
	                this.displayObjectUpdateTransform();
	            }
	        }
	        // don't need to update the lot
	        return this.worldTransform.apply(position, point);
	    };
	    /**
	     * Calculates the local position of the display object relative to another point.
	     *
	     * @param {PIXI.IPointData} position - The world origin to calculate from.
	     * @param {PIXI.DisplayObject} [from] - The DisplayObject to calculate the global position from.
	     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
	     *  (otherwise will create a new Point).
	     * @param {boolean} [skipUpdate=false] - Should we skip the update transform
	     * @return {PIXI.Point} A point object representing the position of this object
	     */
	    DisplayObject.prototype.toLocal = function (position, from, point, skipUpdate) {
	        if (from) {
	            position = from.toGlobal(position, point, skipUpdate);
	        }
	        if (!skipUpdate) {
	            this._recursivePostUpdateTransform();
	            // this parent check is for just in case the item is a root object.
	            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
	            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
	            if (!this.parent) {
	                this.parent = this._tempDisplayObjectParent;
	                this.displayObjectUpdateTransform();
	                this.parent = null;
	            }
	            else {
	                this.displayObjectUpdateTransform();
	            }
	        }
	        // simply apply the matrix..
	        return this.worldTransform.applyInverse(position, point);
	    };
	    /**
	     * Set the parent Container of this DisplayObject.
	     *
	     * @param {PIXI.Container} container - The Container to add this DisplayObject to.
	     * @return {PIXI.Container} The Container that this DisplayObject was added to.
	     */
	    DisplayObject.prototype.setParent = function (container) {
	        if (!container || !container.addChild) {
	            throw new Error('setParent: Argument must be a Container');
	        }
	        container.addChild(this);
	        return container;
	    };
	    /**
	     * Convenience function to set the position, scale, skew and pivot at once.
	     *
	     * @param {number} [x=0] - The X position
	     * @param {number} [y=0] - The Y position
	     * @param {number} [scaleX=1] - The X scale value
	     * @param {number} [scaleY=1] - The Y scale value
	     * @param {number} [rotation=0] - The rotation
	     * @param {number} [skewX=0] - The X skew value
	     * @param {number} [skewY=0] - The Y skew value
	     * @param {number} [pivotX=0] - The X pivot value
	     * @param {number} [pivotY=0] - The Y pivot value
	     * @return {PIXI.DisplayObject} The DisplayObject instance
	     */
	    DisplayObject.prototype.setTransform = function (x, y, scaleX, scaleY, rotation, skewX, skewY, pivotX, pivotY) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = 0; }
	        if (scaleX === void 0) { scaleX = 1; }
	        if (scaleY === void 0) { scaleY = 1; }
	        if (rotation === void 0) { rotation = 0; }
	        if (skewX === void 0) { skewX = 0; }
	        if (skewY === void 0) { skewY = 0; }
	        if (pivotX === void 0) { pivotX = 0; }
	        if (pivotY === void 0) { pivotY = 0; }
	        this.position.x = x;
	        this.position.y = y;
	        this.scale.x = !scaleX ? 1 : scaleX;
	        this.scale.y = !scaleY ? 1 : scaleY;
	        this.rotation = rotation;
	        this.skew.x = skewX;
	        this.skew.y = skewY;
	        this.pivot.x = pivotX;
	        this.pivot.y = pivotY;
	        return this;
	    };
	    /**
	     * Base destroy method for generic display objects. This will automatically
	     * remove the display object from its parent Container as well as remove
	     * all current event listeners and internal references. Do not use a DisplayObject
	     * after calling `destroy()`.
	     *
	     */
	    DisplayObject.prototype.destroy = function (_options) {
	        if (this.parent) {
	            this.parent.removeChild(this);
	        }
	        this.removeAllListeners();
	        this.transform = null;
	        this.parent = null;
	        this._bounds = null;
	        this._mask = null;
	        this.filters = null;
	        this.filterArea = null;
	        this.hitArea = null;
	        this.interactive = false;
	        this.interactiveChildren = false;
	        this._destroyed = true;
	    };
	    Object.defineProperty(DisplayObject.prototype, "_tempDisplayObjectParent", {
	        /**
	         * @protected
	         * @member {PIXI.Container}
	         */
	        get: function () {
	            if (this.tempDisplayObjectParent === null) {
	                // eslint-disable-next-line no-use-before-define
	                this.tempDisplayObjectParent = new TemporaryDisplayObject();
	            }
	            return this.tempDisplayObjectParent;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Used in Renderer, cacheAsBitmap and other places where you call an `updateTransform` on root
	     *
	     * ```
	     * const cacheParent = elem.enableTempParent();
	     * elem.updateTransform();
	     * elem.disableTempParent(cacheParent);
	     * ```
	     *
	     * @returns {PIXI.DisplayObject} current parent
	     */
	    DisplayObject.prototype.enableTempParent = function () {
	        var myParent = this.parent;
	        this.parent = this._tempDisplayObjectParent;
	        return myParent;
	    };
	    /**
	     * Pair method for `enableTempParent`
	     * @param {PIXI.DisplayObject} cacheParent actual parent of element
	     */
	    DisplayObject.prototype.disableTempParent = function (cacheParent) {
	        this.parent = cacheParent;
	    };
	    Object.defineProperty(DisplayObject.prototype, "x", {
	        /**
	         * The position of the displayObject on the x axis relative to the local coordinates of the parent.
	         * An alias to position.x
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this.position.x;
	        },
	        set: function (value) {
	            this.transform.position.x = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(DisplayObject.prototype, "y", {
	        /**
	         * The position of the displayObject on the y axis relative to the local coordinates of the parent.
	         * An alias to position.y
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this.position.y;
	        },
	        set: function (value) {
	            this.transform.position.y = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(DisplayObject.prototype, "worldTransform", {
	        /**
	         * Current transform of the object based on world (parent) factors.
	         *
	         * @member {PIXI.Matrix}
	         * @readonly
	         */
	        get: function () {
	            return this.transform.worldTransform;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(DisplayObject.prototype, "localTransform", {
	        /**
	         * Current transform of the object based on local factors: position, scale, other stuff.
	         *
	         * @member {PIXI.Matrix}
	         * @readonly
	         */
	        get: function () {
	            return this.transform.localTransform;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(DisplayObject.prototype, "position", {
	        /**
	         * The coordinate of the object relative to the local coordinates of the parent.
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        get: function () {
	            return this.transform.position;
	        },
	        set: function (value) {
	            this.transform.position.copyFrom(value);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(DisplayObject.prototype, "scale", {
	        /**
	         * The scale factor of the object.
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        get: function () {
	            return this.transform.scale;
	        },
	        set: function (value) {
	            this.transform.scale.copyFrom(value);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(DisplayObject.prototype, "pivot", {
	        /**
	         * The pivot point of the displayObject that it rotates around.
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        get: function () {
	            return this.transform.pivot;
	        },
	        set: function (value) {
	            this.transform.pivot.copyFrom(value);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(DisplayObject.prototype, "skew", {
	        /**
	         * The skew factor for the object in radians.
	         * Assignment by value since pixi-v4.
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        get: function () {
	            return this.transform.skew;
	        },
	        set: function (value) {
	            this.transform.skew.copyFrom(value);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(DisplayObject.prototype, "rotation", {
	        /**
	         * The rotation of the object in radians.
	         * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this.transform.rotation;
	        },
	        set: function (value) {
	            this.transform.rotation = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(DisplayObject.prototype, "angle", {
	        /**
	         * The angle of the object in degrees.
	         * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this.transform.rotation * RAD_TO_DEG;
	        },
	        set: function (value) {
	            this.transform.rotation = value * DEG_TO_RAD;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(DisplayObject.prototype, "zIndex", {
	        /**
	         * The zIndex of the displayObject.
	         * If a container has the sortableChildren property set to true, children will be automatically
	         * sorted by zIndex value; a higher value will mean it will be moved towards the end of the array,
	         * and thus rendered on top of other displayObjects within the same container.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._zIndex;
	        },
	        set: function (value) {
	            this._zIndex = value;
	            if (this.parent) {
	                this.parent.sortDirty = true;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(DisplayObject.prototype, "worldVisible", {
	        /**
	         * Indicates if the object is globally visible.
	         *
	         * @member {boolean}
	         * @readonly
	         */
	        get: function () {
	            var item = this;
	            do {
	                if (!item.visible) {
	                    return false;
	                }
	                item = item.parent;
	            } while (item);
	            return true;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(DisplayObject.prototype, "mask", {
	        /**
	         * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
	         * object to the shape of the mask applied to it. In PixiJS a regular mask must be a
	         * {@link PIXI.Graphics} or a {@link PIXI.Sprite} object. This allows for much faster masking in canvas as it
	         * utilities shape clipping. To remove a mask, set this property to `null`.
	         *
	         * For sprite mask both alpha and red channel are used. Black mask is the same as transparent mask.
	         * @example
	         * const graphics = new PIXI.Graphics();
	         * graphics.beginFill(0xFF3300);
	         * graphics.drawRect(50, 250, 100, 100);
	         * graphics.endFill();
	         *
	         * const sprite = new PIXI.Sprite(texture);
	         * sprite.mask = graphics;
	         * @todo At the moment, PIXI.CanvasRenderer doesn't support PIXI.Sprite as mask.
	         *
	         * @member {PIXI.Container|PIXI.MaskData|null}
	         */
	        get: function () {
	            return this._mask;
	        },
	        set: function (value) {
	            if (this._mask) {
	                var maskObject = (this._mask.maskObject || this._mask);
	                maskObject.renderable = true;
	                maskObject.isMask = false;
	            }
	            this._mask = value;
	            if (this._mask) {
	                var maskObject = (this._mask.maskObject || this._mask);
	                maskObject.renderable = false;
	                maskObject.isMask = true;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return DisplayObject;
	}(eventemitter3));
	var TemporaryDisplayObject = /** @class */ (function (_super) {
	    __extends(TemporaryDisplayObject, _super);
	    function TemporaryDisplayObject() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.sortDirty = null;
	        return _this;
	    }
	    return TemporaryDisplayObject;
	}(DisplayObject));
	/**
	 * DisplayObject default updateTransform, does not update children of container.
	 * Will crash if there's no parent element.
	 *
	 * @memberof PIXI.DisplayObject#
	 * @function displayObjectUpdateTransform
	 */
	DisplayObject.prototype.displayObjectUpdateTransform = DisplayObject.prototype.updateTransform;

	function sortChildren(a, b) {
	    if (a.zIndex === b.zIndex) {
	        return a._lastSortedIndex - b._lastSortedIndex;
	    }
	    return a.zIndex - b.zIndex;
	}
	/**
	 * A Container represents a collection of display objects.
	 *
	 * It is the base class of all display objects that act as a container for other objects (like Sprites).
	 *
	 *```js
	 * let container = new PIXI.Container();
	 * container.addChild(sprite);
	 * ```
	 *
	 * @class
	 * @extends PIXI.DisplayObject
	 * @memberof PIXI
	 */
	var Container = /** @class */ (function (_super) {
	    __extends(Container, _super);
	    function Container() {
	        var _this = _super.call(this) || this;
	        /**
	         * The array of children of this container.
	         *
	         * @member {PIXI.DisplayObject[]}
	         * @readonly
	         */
	        _this.children = [];
	        /**
	         * If set to true, the container will sort its children by zIndex value
	         * when updateTransform() is called, or manually if sortChildren() is called.
	         *
	         * This actually changes the order of elements in the array, so should be treated
	         * as a basic solution that is not performant compared to other solutions,
	         * such as @link https://github.com/pixijs/pixi-display
	         *
	         * Also be aware of that this may not work nicely with the addChildAt() function,
	         * as the zIndex sorting may cause the child to automatically sorted to another position.
	         *
	         * @see PIXI.settings.SORTABLE_CHILDREN
	         *
	         * @member {boolean}
	         */
	        _this.sortableChildren = settings.SORTABLE_CHILDREN;
	        /**
	         * Should children be sorted by zIndex at the next updateTransform call.
	         * Will get automatically set to true if a new child is added, or if a child's zIndex changes.
	         *
	         * @member {boolean}
	         */
	        _this.sortDirty = false;
	        return _this;
	        /**
	         * Fired when a DisplayObject is added to this Container.
	         *
	         * @event PIXI.Container#childAdded
	         * @param {PIXI.DisplayObject} child - The child added to the Container.
	         * @param {PIXI.Container} container - The container that added the child.
	         * @param {number} index - The children's index of the added child.
	         */
	        /**
	         * Fired when a DisplayObject is removed from this Container.
	         *
	         * @event PIXI.DisplayObject#removedFrom
	         * @param {PIXI.DisplayObject} child - The child removed from the Container.
	         * @param {PIXI.Container} container - The container that removed removed the child.
	         * @param {number} index - The former children's index of the removed child
	         */
	    }
	    /**
	     * Overridable method that can be used by Container subclasses whenever the children array is modified
	     *
	     * @protected
	     */
	    Container.prototype.onChildrenChange = function (_length) {
	        /* empty */
	    };
	    /**
	     * Adds one or more children to the container.
	     *
	     * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
	     *
	     * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to add to the container
	     * @return {PIXI.DisplayObject} The first child that was added.
	     */
	    Container.prototype.addChild = function () {
	        var arguments$1 = arguments;

	        var children = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            children[_i] = arguments$1[_i];
	        }
	        // if there is only one argument we can bypass looping through the them
	        if (children.length > 1) {
	            // loop through the array and add all children
	            for (var i = 0; i < children.length; i++) {
	                // eslint-disable-next-line prefer-rest-params
	                this.addChild(children[i]);
	            }
	        }
	        else {
	            var child = children[0];
	            // if the child has a parent then lets remove it as PixiJS objects can only exist in one place
	            if (child.parent) {
	                child.parent.removeChild(child);
	            }
	            child.parent = this;
	            this.sortDirty = true;
	            // ensure child transform will be recalculated
	            child.transform._parentID = -1;
	            this.children.push(child);
	            // ensure bounds will be recalculated
	            this._boundsID++;
	            // TODO - lets either do all callbacks or all events.. not both!
	            this.onChildrenChange(this.children.length - 1);
	            this.emit('childAdded', child, this, this.children.length - 1);
	            child.emit('added', this);
	        }
	        return children[0];
	    };
	    /**
	     * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown
	     *
	     * @param {PIXI.DisplayObject} child - The child to add
	     * @param {number} index - The index to place the child in
	     * @return {PIXI.DisplayObject} The child that was added.
	     */
	    Container.prototype.addChildAt = function (child, index) {
	        if (index < 0 || index > this.children.length) {
	            throw new Error(child + "addChildAt: The index " + index + " supplied is out of bounds " + this.children.length);
	        }
	        if (child.parent) {
	            child.parent.removeChild(child);
	        }
	        child.parent = this;
	        this.sortDirty = true;
	        // ensure child transform will be recalculated
	        child.transform._parentID = -1;
	        this.children.splice(index, 0, child);
	        // ensure bounds will be recalculated
	        this._boundsID++;
	        // TODO - lets either do all callbacks or all events.. not both!
	        this.onChildrenChange(index);
	        child.emit('added', this);
	        this.emit('childAdded', child, this, index);
	        return child;
	    };
	    /**
	     * Swaps the position of 2 Display Objects within this container.
	     *
	     * @param {PIXI.DisplayObject} child - First display object to swap
	     * @param {PIXI.DisplayObject} child2 - Second display object to swap
	     */
	    Container.prototype.swapChildren = function (child, child2) {
	        if (child === child2) {
	            return;
	        }
	        var index1 = this.getChildIndex(child);
	        var index2 = this.getChildIndex(child2);
	        this.children[index1] = child2;
	        this.children[index2] = child;
	        this.onChildrenChange(index1 < index2 ? index1 : index2);
	    };
	    /**
	     * Returns the index position of a child DisplayObject instance
	     *
	     * @param {PIXI.DisplayObject} child - The DisplayObject instance to identify
	     * @return {number} The index position of the child display object to identify
	     */
	    Container.prototype.getChildIndex = function (child) {
	        var index = this.children.indexOf(child);
	        if (index === -1) {
	            throw new Error('The supplied DisplayObject must be a child of the caller');
	        }
	        return index;
	    };
	    /**
	     * Changes the position of an existing child in the display object container
	     *
	     * @param {PIXI.DisplayObject} child - The child DisplayObject instance for which you want to change the index number
	     * @param {number} index - The resulting index number for the child display object
	     */
	    Container.prototype.setChildIndex = function (child, index) {
	        if (index < 0 || index >= this.children.length) {
	            throw new Error("The index " + index + " supplied is out of bounds " + this.children.length);
	        }
	        var currentIndex = this.getChildIndex(child);
	        removeItems(this.children, currentIndex, 1); // remove from old position
	        this.children.splice(index, 0, child); // add at new position
	        this.onChildrenChange(index);
	    };
	    /**
	     * Returns the child at the specified index
	     *
	     * @param {number} index - The index to get the child at
	     * @return {PIXI.DisplayObject} The child at the given index, if any.
	     */
	    Container.prototype.getChildAt = function (index) {
	        if (index < 0 || index >= this.children.length) {
	            throw new Error("getChildAt: Index (" + index + ") does not exist.");
	        }
	        return this.children[index];
	    };
	    /**
	     * Removes one or more children from the container.
	     *
	     * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to remove
	     * @return {PIXI.DisplayObject} The first child that was removed.
	     */
	    Container.prototype.removeChild = function () {
	        var arguments$1 = arguments;

	        var children = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            children[_i] = arguments$1[_i];
	        }
	        // if there is only one argument we can bypass looping through the them
	        if (children.length > 1) {
	            // loop through the arguments property and remove all children
	            for (var i = 0; i < children.length; i++) {
	                this.removeChild(children[i]);
	            }
	        }
	        else {
	            var child = children[0];
	            var index = this.children.indexOf(child);
	            if (index === -1)
	                { return null; }
	            child.parent = null;
	            // ensure child transform will be recalculated
	            child.transform._parentID = -1;
	            removeItems(this.children, index, 1);
	            // ensure bounds will be recalculated
	            this._boundsID++;
	            // TODO - lets either do all callbacks or all events.. not both!
	            this.onChildrenChange(index);
	            child.emit('removed', this);
	            this.emit('childRemoved', child, this, index);
	        }
	        return children[0];
	    };
	    /**
	     * Removes a child from the specified index position.
	     *
	     * @param {number} index - The index to get the child from
	     * @return {PIXI.DisplayObject} The child that was removed.
	     */
	    Container.prototype.removeChildAt = function (index) {
	        var child = this.getChildAt(index);
	        // ensure child transform will be recalculated..
	        child.parent = null;
	        child.transform._parentID = -1;
	        removeItems(this.children, index, 1);
	        // ensure bounds will be recalculated
	        this._boundsID++;
	        // TODO - lets either do all callbacks or all events.. not both!
	        this.onChildrenChange(index);
	        child.emit('removed', this);
	        this.emit('childRemoved', child, this, index);
	        return child;
	    };
	    /**
	     * Removes all children from this container that are within the begin and end indexes.
	     *
	     * @param {number} [beginIndex=0] - The beginning position.
	     * @param {number} [endIndex=this.children.length] - The ending position. Default value is size of the container.
	     * @returns {PIXI.DisplayObject[]} List of removed children
	     */
	    Container.prototype.removeChildren = function (beginIndex, endIndex) {
	        if (beginIndex === void 0) { beginIndex = 0; }
	        if (endIndex === void 0) { endIndex = this.children.length; }
	        var begin = beginIndex;
	        var end = endIndex;
	        var range = end - begin;
	        var removed;
	        if (range > 0 && range <= end) {
	            removed = this.children.splice(begin, range);
	            for (var i = 0; i < removed.length; ++i) {
	                removed[i].parent = null;
	                if (removed[i].transform) {
	                    removed[i].transform._parentID = -1;
	                }
	            }
	            this._boundsID++;
	            this.onChildrenChange(beginIndex);
	            for (var i = 0; i < removed.length; ++i) {
	                removed[i].emit('removed', this);
	                this.emit('childRemoved', removed[i], this, i);
	            }
	            return removed;
	        }
	        else if (range === 0 && this.children.length === 0) {
	            return [];
	        }
	        throw new RangeError('removeChildren: numeric values are outside the acceptable range.');
	    };
	    /**
	     * Sorts children by zIndex. Previous order is mantained for 2 children with the same zIndex.
	     */
	    Container.prototype.sortChildren = function () {
	        var sortRequired = false;
	        for (var i = 0, j = this.children.length; i < j; ++i) {
	            var child = this.children[i];
	            child._lastSortedIndex = i;
	            if (!sortRequired && child.zIndex !== 0) {
	                sortRequired = true;
	            }
	        }
	        if (sortRequired && this.children.length > 1) {
	            this.children.sort(sortChildren);
	        }
	        this.sortDirty = false;
	    };
	    /**
	     * Updates the transform on all children of this container for rendering
	     */
	    Container.prototype.updateTransform = function () {
	        if (this.sortableChildren && this.sortDirty) {
	            this.sortChildren();
	        }
	        this._boundsID++;
	        this.transform.updateTransform(this.parent.transform);
	        // TODO: check render flags, how to process stuff here
	        this.worldAlpha = this.alpha * this.parent.worldAlpha;
	        for (var i = 0, j = this.children.length; i < j; ++i) {
	            var child = this.children[i];
	            if (child.visible) {
	                child.updateTransform();
	            }
	        }
	    };
	    /**
	     * Recalculates the bounds of the container.
	     *
	     */
	    Container.prototype.calculateBounds = function () {
	        this._bounds.clear();
	        this._calculateBounds();
	        for (var i = 0; i < this.children.length; i++) {
	            var child = this.children[i];
	            if (!child.visible || !child.renderable) {
	                continue;
	            }
	            child.calculateBounds();
	            // TODO: filter+mask, need to mask both somehow
	            if (child._mask) {
	                var maskObject = (child._mask.maskObject || child._mask);
	                maskObject.calculateBounds();
	                this._bounds.addBoundsMask(child._bounds, maskObject._bounds);
	            }
	            else if (child.filterArea) {
	                this._bounds.addBoundsArea(child._bounds, child.filterArea);
	            }
	            else {
	                this._bounds.addBounds(child._bounds);
	            }
	        }
	        this._bounds.updateID = this._boundsID;
	    };
	    /**
	     * Retrieves the local bounds of the displayObject as a rectangle object.
	     *
	     * @param {PIXI.Rectangle} [rect] - Optional rectangle to store the result of the bounds calculation.
	     * @param {boolean} [skipChildrenUpdate=false] - Setting to `true` will stop re-calculation of children transforms,
	     *  it was default behaviour of pixi 4.0-5.2 and caused many problems to users.
	     * @return {PIXI.Rectangle} The rectangular bounding area.
	     */
	    Container.prototype.getLocalBounds = function (rect, skipChildrenUpdate) {
	        if (skipChildrenUpdate === void 0) { skipChildrenUpdate = false; }
	        var result = _super.prototype.getLocalBounds.call(this, rect);
	        if (!skipChildrenUpdate) {
	            for (var i = 0, j = this.children.length; i < j; ++i) {
	                var child = this.children[i];
	                if (child.visible) {
	                    child.updateTransform();
	                }
	            }
	        }
	        return result;
	    };
	    /**
	     * Recalculates the bounds of the object. Override this to
	     * calculate the bounds of the specific object (not including children).
	     *
	     * @protected
	     */
	    Container.prototype._calculateBounds = function () {
	        // FILL IN//
	    };
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @param {PIXI.Renderer} renderer - The renderer
	     */
	    Container.prototype.render = function (renderer) {
	        // if the object is not visible or the alpha is 0 then no need to render this element
	        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	            return;
	        }
	        // do a quick check to see if this element has a mask or a filter.
	        if (this._mask || (this.filters && this.filters.length)) {
	            this.renderAdvanced(renderer);
	        }
	        else {
	            this._render(renderer);
	            // simple render children!
	            for (var i = 0, j = this.children.length; i < j; ++i) {
	                this.children[i].render(renderer);
	            }
	        }
	    };
	    /**
	     * Render the object using the WebGL renderer and advanced features.
	     *
	     * @protected
	     * @param {PIXI.Renderer} renderer - The renderer
	     */
	    Container.prototype.renderAdvanced = function (renderer) {
	        renderer.batch.flush();
	        var filters = this.filters;
	        var mask = this._mask;
	        // push filter first as we need to ensure the stencil buffer is correct for any masking
	        if (filters) {
	            if (!this._enabledFilters) {
	                this._enabledFilters = [];
	            }
	            this._enabledFilters.length = 0;
	            for (var i = 0; i < filters.length; i++) {
	                if (filters[i].enabled) {
	                    this._enabledFilters.push(filters[i]);
	                }
	            }
	            if (this._enabledFilters.length) {
	                renderer.filter.push(this, this._enabledFilters);
	            }
	        }
	        if (mask) {
	            renderer.mask.push(this, this._mask);
	        }
	        // add this object to the batch, only rendered if it has a texture.
	        this._render(renderer);
	        // now loop through the children and make sure they get rendered
	        for (var i = 0, j = this.children.length; i < j; i++) {
	            this.children[i].render(renderer);
	        }
	        renderer.batch.flush();
	        if (mask) {
	            renderer.mask.pop(this);
	        }
	        if (filters && this._enabledFilters && this._enabledFilters.length) {
	            renderer.filter.pop();
	        }
	    };
	    /**
	     * To be overridden by the subclasses.
	     *
	     * @protected
	     * @param {PIXI.Renderer} renderer - The renderer
	     */
	    Container.prototype._render = function (_renderer) {
	        // this is where content itself gets rendered...
	    };
	    /**
	     * Removes all internal references and listeners as well as removes children from the display list.
	     * Do not use a Container after calling `destroy`.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
	     *  method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the texture of the child sprite
	     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the base texture of the child sprite
	     */
	    Container.prototype.destroy = function (options) {
	        _super.prototype.destroy.call(this);
	        this.sortDirty = false;
	        var destroyChildren = typeof options === 'boolean' ? options : options && options.children;
	        var oldChildren = this.removeChildren(0, this.children.length);
	        if (destroyChildren) {
	            for (var i = 0; i < oldChildren.length; ++i) {
	                oldChildren[i].destroy(options);
	            }
	        }
	    };
	    Object.defineProperty(Container.prototype, "width", {
	        /**
	         * The width of the Container, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this.scale.x * this.getLocalBounds().width;
	        },
	        set: function (value) {
	            var width = this.getLocalBounds().width;
	            if (width !== 0) {
	                this.scale.x = value / width;
	            }
	            else {
	                this.scale.x = 1;
	            }
	            this._width = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Container.prototype, "height", {
	        /**
	         * The height of the Container, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this.scale.y * this.getLocalBounds().height;
	        },
	        set: function (value) {
	            var height = this.getLocalBounds().height;
	            if (height !== 0) {
	                this.scale.y = value / height;
	            }
	            else {
	                this.scale.y = 1;
	            }
	            this._height = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Container;
	}(DisplayObject));
	/**
	 * Container default updateTransform, does update children of container.
	 * Will crash if there's no parent element.
	 *
	 * @memberof PIXI.Container#
	 * @function containerUpdateTransform
	 */
	Container.prototype.containerUpdateTransform = Container.prototype.updateTransform;

	/*!
	 * @pixi/accessibility - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/accessibility is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * Default property values of accessible objects
	 * used by {@link PIXI.AccessibilityManager}.
	 *
	 * @private
	 * @function accessibleTarget
	 * @memberof PIXI
	 * @type {Object}
	 * @example
	 *      function MyObject() {}
	 *
	 *      Object.assign(
	 *          MyObject.prototype,
	 *          PIXI.accessibleTarget
	 *      );
	 */
	var accessibleTarget = {
	    /**
	     *  Flag for if the object is accessible. If true AccessibilityManager will overlay a
	     *   shadow div with attributes set
	     *
	     * @member {boolean}
	     * @memberof PIXI.DisplayObject#
	     */
	    accessible: false,
	    /**
	     * Sets the title attribute of the shadow div
	     * If accessibleTitle AND accessibleHint has not been this will default to 'displayObject [tabIndex]'
	     *
	     * @member {?string}
	     * @memberof PIXI.DisplayObject#
	     */
	    accessibleTitle: null,
	    /**
	     * Sets the aria-label attribute of the shadow div
	     *
	     * @member {string}
	     * @memberof PIXI.DisplayObject#
	     */
	    accessibleHint: null,
	    /**
	     * @member {number}
	     * @memberof PIXI.DisplayObject#
	     * @private
	     * @todo Needs docs.
	     */
	    tabIndex: 0,
	    /**
	     * @member {boolean}
	     * @memberof PIXI.DisplayObject#
	     * @todo Needs docs.
	     */
	    _accessibleActive: false,
	    /**
	     * @member {boolean}
	     * @memberof PIXI.DisplayObject#
	     * @todo Needs docs.
	     */
	    _accessibleDiv: null,
	    /**
	     * Specify the type of div the accessible layer is. Screen readers treat the element differently
	     * depending on this type. Defaults to button.
	     *
	     * @member {string}
	     * @memberof PIXI.DisplayObject#
	     * @default 'button'
	     */
	    accessibleType: 'button',
	    /**
	     * Specify the pointer-events the accessible div will use
	     * Defaults to auto.
	     *
	     * @member {string}
	     * @memberof PIXI.DisplayObject#
	     * @default 'auto'
	     */
	    accessiblePointerEvents: 'auto',
	    /**
	     * Setting to false will prevent any children inside this container to
	     * be accessible. Defaults to true.
	     *
	     * @member {boolean}
	     * @memberof PIXI.DisplayObject#
	     * @default true
	     */
	    accessibleChildren: true,
	    renderId: -1,
	};

	// add some extra variables to the container..
	DisplayObject.mixin(accessibleTarget);
	var KEY_CODE_TAB = 9;
	var DIV_TOUCH_SIZE = 100;
	var DIV_TOUCH_POS_X = 0;
	var DIV_TOUCH_POS_Y = 0;
	var DIV_TOUCH_ZINDEX = 2;
	var DIV_HOOK_SIZE = 1;
	var DIV_HOOK_POS_X = -1000;
	var DIV_HOOK_POS_Y = -1000;
	var DIV_HOOK_ZINDEX = 2;
	/**
	 * The Accessibility manager recreates the ability to tab and have content read by screen readers.
	 * This is very important as it can possibly help people with disabilities access PixiJS content.
	 *
	 * A DisplayObject can be made accessible just like it can be made interactive. This manager will map the
	 * events as if the mouse was being used, minimizing the effort required to implement.
	 *
	 * An instance of this class is automatically created by default, and can be found at `renderer.plugins.accessibility`
	 *
	 * @class
	 * @memberof PIXI
	 */
	var AccessibilityManager = /** @class */ (function () {
	    /**
	     * @param {PIXI.CanvasRenderer|PIXI.Renderer} renderer - A reference to the current renderer
	     */
	    function AccessibilityManager(renderer) {
	        /**
	         * @type {?HTMLElement}
	         * @private
	         */
	        this._hookDiv = null;
	        if (isMobile$1.tablet || isMobile$1.phone) {
	            this.createTouchHook();
	        }
	        // first we create a div that will sit over the PixiJS element. This is where the div overlays will go.
	        var div = document.createElement('div');
	        div.style.width = DIV_TOUCH_SIZE + "px";
	        div.style.height = DIV_TOUCH_SIZE + "px";
	        div.style.position = 'absolute';
	        div.style.top = DIV_TOUCH_POS_X + "px";
	        div.style.left = DIV_TOUCH_POS_Y + "px";
	        div.style.zIndex = DIV_TOUCH_ZINDEX.toString();
	        /**
	         * This is the dom element that will sit over the PixiJS element. This is where the div overlays will go.
	         *
	         * @type {HTMLElement}
	         * @private
	         */
	        this.div = div;
	        /**
	         * A simple pool for storing divs.
	         *
	         * @type {*}
	         * @private
	         */
	        this.pool = [];
	        /**
	         * This is a tick used to check if an object is no longer being rendered.
	         *
	         * @type {Number}
	         * @private
	         */
	        this.renderId = 0;
	        /**
	         * Setting this to true will visually show the divs.
	         *
	         * @type {boolean}
	         */
	        this.debug = false;
	        /**
	         * The renderer this accessibility manager works for.
	         *
	         * @member {PIXI.AbstractRenderer}
	         */
	        this.renderer = renderer;
	        /**
	         * The array of currently active accessible items.
	         *
	         * @member {Array<*>}
	         * @private
	         */
	        this.children = [];
	        /**
	         * pre-bind the functions
	         *
	         * @type {Function}
	         * @private
	         */
	        this._onKeyDown = this._onKeyDown.bind(this);
	        /**
	         * pre-bind the functions
	         *
	         * @type {Function}
	         * @private
	         */
	        this._onMouseMove = this._onMouseMove.bind(this);
	        this._isActive = false;
	        this._isMobileAccessibility = false;
	        /**
	         * count to throttle div updates on android devices
	         * @type number
	         * @private
	         */
	        this.androidUpdateCount = 0;
	        /**
	         * the frequency to update the div elements ()
	         * @private
	         */
	        this.androidUpdateFrequency = 500; // 2fps
	        // let listen for tab.. once pressed we can fire up and show the accessibility layer
	        window.addEventListener('keydown', this._onKeyDown, false);
	    }
	    Object.defineProperty(AccessibilityManager.prototype, "isActive", {
	        /**
	         * A flag
	         * @member {boolean}
	         * @readonly
	         */
	        get: function () {
	            return this._isActive;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(AccessibilityManager.prototype, "isMobileAccessibility", {
	        /**
	         * A flag
	         * @member {boolean}
	         * @readonly
	         */
	        get: function () {
	            return this._isMobileAccessibility;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Creates the touch hooks.
	     *
	     * @private
	     */
	    AccessibilityManager.prototype.createTouchHook = function () {
	        var _this = this;
	        var hookDiv = document.createElement('button');
	        hookDiv.style.width = DIV_HOOK_SIZE + "px";
	        hookDiv.style.height = DIV_HOOK_SIZE + "px";
	        hookDiv.style.position = 'absolute';
	        hookDiv.style.top = DIV_HOOK_POS_X + "px";
	        hookDiv.style.left = DIV_HOOK_POS_Y + "px";
	        hookDiv.style.zIndex = DIV_HOOK_ZINDEX.toString();
	        hookDiv.style.backgroundColor = '#FF0000';
	        hookDiv.title = 'select to enable accessability for this content';
	        hookDiv.addEventListener('focus', function () {
	            _this._isMobileAccessibility = true;
	            _this.activate();
	            _this.destroyTouchHook();
	        });
	        document.body.appendChild(hookDiv);
	        this._hookDiv = hookDiv;
	    };
	    /**
	     * Destroys the touch hooks.
	     *
	     * @private
	     */
	    AccessibilityManager.prototype.destroyTouchHook = function () {
	        if (!this._hookDiv) {
	            return;
	        }
	        document.body.removeChild(this._hookDiv);
	        this._hookDiv = null;
	    };
	    /**
	     * Activating will cause the Accessibility layer to be shown.
	     * This is called when a user presses the tab key.
	     *
	     * @private
	     */
	    AccessibilityManager.prototype.activate = function () {
	        if (this._isActive) {
	            return;
	        }
	        this._isActive = true;
	        window.document.addEventListener('mousemove', this._onMouseMove, true);
	        window.removeEventListener('keydown', this._onKeyDown, false);
	        // TODO: Remove casting when CanvasRenderer is converted
	        this.renderer.on('postrender', this.update, this);
	        if (this.renderer.view.parentNode) {
	            this.renderer.view.parentNode.appendChild(this.div);
	        }
	    };
	    /**
	     * Deactivating will cause the Accessibility layer to be hidden.
	     * This is called when a user moves the mouse.
	     *
	     * @private
	     */
	    AccessibilityManager.prototype.deactivate = function () {
	        if (!this._isActive || this._isMobileAccessibility) {
	            return;
	        }
	        this._isActive = false;
	        window.document.removeEventListener('mousemove', this._onMouseMove, true);
	        window.addEventListener('keydown', this._onKeyDown, false);
	        // TODO: Remove casting when CanvasRenderer is converted
	        this.renderer.off('postrender', this.update);
	        if (this.div.parentNode) {
	            this.div.parentNode.removeChild(this.div);
	        }
	    };
	    /**
	     * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
	     *
	     * @private
	     * @param {PIXI.Container} displayObject - The DisplayObject to check.
	     */
	    AccessibilityManager.prototype.updateAccessibleObjects = function (displayObject) {
	        if (!displayObject.visible || !displayObject.accessibleChildren) {
	            return;
	        }
	        if (displayObject.accessible && displayObject.interactive) {
	            if (!displayObject._accessibleActive) {
	                this.addChild(displayObject);
	            }
	            displayObject.renderId = this.renderId;
	        }
	        var children = displayObject.children;
	        for (var i = 0; i < children.length; i++) {
	            this.updateAccessibleObjects(children[i]);
	        }
	    };
	    /**
	     * Before each render this function will ensure that all divs are mapped correctly to their DisplayObjects.
	     *
	     * @private
	     */
	    AccessibilityManager.prototype.update = function () {
	        /* On Android default web browser, tab order seems to be calculated by position rather than tabIndex,
	        *  moving buttons can cause focus to flicker between two buttons making it hard/impossible to navigate,
	        *  so I am just running update every half a second, seems to fix it.
	        */
	        var now = performance.now();
	        if (isMobile$1.android.device && now < this.androidUpdateCount) {
	            return;
	        }
	        this.androidUpdateCount = now + this.androidUpdateFrequency;
	        if (!this.renderer.renderingToScreen) {
	            return;
	        }
	        // update children...
	        if (this.renderer._lastObjectRendered) {
	            this.updateAccessibleObjects(this.renderer._lastObjectRendered);
	        }
	        // TODO: Remove casting when CanvasRenderer is converted
	        var rect = this.renderer.view.getBoundingClientRect();
	        var resolution = this.renderer.resolution;
	        var sx = (rect.width / this.renderer.width) * resolution;
	        var sy = (rect.height / this.renderer.height) * resolution;
	        var div = this.div;
	        div.style.left = rect.left + "px";
	        div.style.top = rect.top + "px";
	        div.style.width = this.renderer.width + "px";
	        div.style.height = this.renderer.height + "px";
	        for (var i = 0; i < this.children.length; i++) {
	            var child = this.children[i];
	            if (child.renderId !== this.renderId) {
	                child._accessibleActive = false;
	                removeItems(this.children, i, 1);
	                this.div.removeChild(child._accessibleDiv);
	                this.pool.push(child._accessibleDiv);
	                child._accessibleDiv = null;
	                i--;
	            }
	            else {
	                // map div to display..
	                div = child._accessibleDiv;
	                var hitArea = child.hitArea;
	                var wt = child.worldTransform;
	                if (child.hitArea) {
	                    div.style.left = (wt.tx + (hitArea.x * wt.a)) * sx + "px";
	                    div.style.top = (wt.ty + (hitArea.y * wt.d)) * sy + "px";
	                    div.style.width = hitArea.width * wt.a * sx + "px";
	                    div.style.height = hitArea.height * wt.d * sy + "px";
	                }
	                else {
	                    hitArea = child.getBounds();
	                    this.capHitArea(hitArea);
	                    div.style.left = hitArea.x * sx + "px";
	                    div.style.top = hitArea.y * sy + "px";
	                    div.style.width = hitArea.width * sx + "px";
	                    div.style.height = hitArea.height * sy + "px";
	                    // update button titles and hints if they exist and they've changed
	                    if (div.title !== child.accessibleTitle && child.accessibleTitle !== null) {
	                        div.title = child.accessibleTitle;
	                    }
	                    if (div.getAttribute('aria-label') !== child.accessibleHint
	                        && child.accessibleHint !== null) {
	                        div.setAttribute('aria-label', child.accessibleHint);
	                    }
	                }
	                // the title or index may have changed, if so lets update it!
	                if (child.accessibleTitle !== div.title || child.tabIndex !== div.tabIndex) {
	                    div.title = child.accessibleTitle;
	                    div.tabIndex = child.tabIndex;
	                    if (this.debug)
	                        { this.updateDebugHTML(div); }
	                }
	            }
	        }
	        // increment the render id..
	        this.renderId++;
	    };
	    /**
	     * private function that will visually add the information to the
	     * accessability div
	     *
	     * @param {HTMLElement} div
	     */
	    AccessibilityManager.prototype.updateDebugHTML = function (div) {
	        div.innerHTML = "type: " + div.type + "</br> title : " + div.title + "</br> tabIndex: " + div.tabIndex;
	    };
	    /**
	     * Adjust the hit area based on the bounds of a display object
	     *
	     * @param {PIXI.Rectangle} hitArea - Bounds of the child
	     */
	    AccessibilityManager.prototype.capHitArea = function (hitArea) {
	        if (hitArea.x < 0) {
	            hitArea.width += hitArea.x;
	            hitArea.x = 0;
	        }
	        if (hitArea.y < 0) {
	            hitArea.height += hitArea.y;
	            hitArea.y = 0;
	        }
	        // TODO: Remove casting when CanvasRenderer is converted
	        if (hitArea.x + hitArea.width > this.renderer.width) {
	            hitArea.width = this.renderer.width - hitArea.x;
	        }
	        if (hitArea.y + hitArea.height > this.renderer.height) {
	            hitArea.height = this.renderer.height - hitArea.y;
	        }
	    };
	    /**
	     * Adds a DisplayObject to the accessibility manager
	     *
	     * @private
	     * @param {PIXI.DisplayObject} displayObject - The child to make accessible.
	     */
	    AccessibilityManager.prototype.addChild = function (displayObject) {
	        //    this.activate();
	        var div = this.pool.pop();
	        if (!div) {
	            div = document.createElement('button');
	            div.style.width = DIV_TOUCH_SIZE + "px";
	            div.style.height = DIV_TOUCH_SIZE + "px";
	            div.style.backgroundColor = this.debug ? 'rgba(255,255,255,0.5)' : 'transparent';
	            div.style.position = 'absolute';
	            div.style.zIndex = DIV_TOUCH_ZINDEX.toString();
	            div.style.borderStyle = 'none';
	            // ARIA attributes ensure that button title and hint updates are announced properly
	            if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
	                // Chrome doesn't need aria-live to work as intended; in fact it just gets more confused.
	                div.setAttribute('aria-live', 'off');
	            }
	            else {
	                div.setAttribute('aria-live', 'polite');
	            }
	            if (navigator.userAgent.match(/rv:.*Gecko\//)) {
	                // FireFox needs this to announce only the new button name
	                div.setAttribute('aria-relevant', 'additions');
	            }
	            else {
	                // required by IE, other browsers don't much care
	                div.setAttribute('aria-relevant', 'text');
	            }
	            div.addEventListener('click', this._onClick.bind(this));
	            div.addEventListener('focus', this._onFocus.bind(this));
	            div.addEventListener('focusout', this._onFocusOut.bind(this));
	        }
	        // set pointer events
	        div.style.pointerEvents = displayObject.accessiblePointerEvents;
	        // set the type, this defaults to button!
	        div.type = displayObject.accessibleType;
	        if (displayObject.accessibleTitle && displayObject.accessibleTitle !== null) {
	            div.title = displayObject.accessibleTitle;
	        }
	        else if (!displayObject.accessibleHint
	            || displayObject.accessibleHint === null) {
	            div.title = "displayObject " + displayObject.tabIndex;
	        }
	        if (displayObject.accessibleHint
	            && displayObject.accessibleHint !== null) {
	            div.setAttribute('aria-label', displayObject.accessibleHint);
	        }
	        if (this.debug)
	            { this.updateDebugHTML(div); }
	        displayObject._accessibleActive = true;
	        displayObject._accessibleDiv = div;
	        div.displayObject = displayObject;
	        this.children.push(displayObject);
	        this.div.appendChild(displayObject._accessibleDiv);
	        displayObject._accessibleDiv.tabIndex = displayObject.tabIndex;
	    };
	    /**
	     * Maps the div button press to pixi's InteractionManager (click)
	     *
	     * @private
	     * @param {MouseEvent} e - The click event.
	     */
	    AccessibilityManager.prototype._onClick = function (e) {
	        // TODO: Remove casting when CanvasRenderer is converted
	        var interactionManager = this.renderer.plugins.interaction;
	        interactionManager.dispatchEvent(e.target.displayObject, 'click', interactionManager.eventData);
	        interactionManager.dispatchEvent(e.target.displayObject, 'pointertap', interactionManager.eventData);
	        interactionManager.dispatchEvent(e.target.displayObject, 'tap', interactionManager.eventData);
	    };
	    /**
	     * Maps the div focus events to pixi's InteractionManager (mouseover)
	     *
	     * @private
	     * @param {FocusEvent} e - The focus event.
	     */
	    AccessibilityManager.prototype._onFocus = function (e) {
	        if (!e.target.getAttribute('aria-live')) {
	            e.target.setAttribute('aria-live', 'assertive');
	        }
	        // TODO: Remove casting when CanvasRenderer is converted
	        var interactionManager = this.renderer.plugins.interaction;
	        interactionManager.dispatchEvent(e.target.displayObject, 'mouseover', interactionManager.eventData);
	    };
	    /**
	     * Maps the div focus events to pixi's InteractionManager (mouseout)
	     *
	     * @private
	     * @param {FocusEvent} e - The focusout event.
	     */
	    AccessibilityManager.prototype._onFocusOut = function (e) {
	        if (!e.target.getAttribute('aria-live')) {
	            e.target.setAttribute('aria-live', 'polite');
	        }
	        // TODO: Remove casting when CanvasRenderer is converted
	        var interactionManager = this.renderer.plugins.interaction;
	        interactionManager.dispatchEvent(e.target.displayObject, 'mouseout', interactionManager.eventData);
	    };
	    /**
	     * Is called when a key is pressed
	     *
	     * @private
	     * @param {KeyboardEvent} e - The keydown event.
	     */
	    AccessibilityManager.prototype._onKeyDown = function (e) {
	        if (e.keyCode !== KEY_CODE_TAB) {
	            return;
	        }
	        this.activate();
	    };
	    /**
	     * Is called when the mouse moves across the renderer element
	     *
	     * @private
	     * @param {MouseEvent} e - The mouse event.
	     */
	    AccessibilityManager.prototype._onMouseMove = function (e) {
	        if (e.movementX === 0 && e.movementY === 0) {
	            return;
	        }
	        this.deactivate();
	    };
	    /**
	     * Destroys the accessibility manager
	     *
	     */
	    AccessibilityManager.prototype.destroy = function () {
	        this.destroyTouchHook();
	        this.div = null;
	        window.document.removeEventListener('mousemove', this._onMouseMove, true);
	        window.removeEventListener('keydown', this._onKeyDown);
	        this.pool = null;
	        this.children = null;
	        this.renderer = null;
	    };
	    return AccessibilityManager;
	}());

	/*!
	 * @pixi/ticker - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/ticker is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * Target frames per millisecond.
	 *
	 * @static
	 * @name TARGET_FPMS
	 * @memberof PIXI.settings
	 * @type {number}
	 * @default 0.06
	 */
	settings.TARGET_FPMS = 0.06;

	/**
	 * Represents the update priorities used by internal PIXI classes when registered with
	 * the {@link PIXI.Ticker} object. Higher priority items are updated first and lower
	 * priority items, such as render, should go later.
	 *
	 * @static
	 * @constant
	 * @name UPDATE_PRIORITY
	 * @memberof PIXI
	 * @enum {number}
	 * @property {number} INTERACTION=50 Highest priority, used for {@link PIXI.InteractionManager}
	 * @property {number} HIGH=25 High priority updating, {@link PIXI.VideoBaseTexture} and {@link PIXI.AnimatedSprite}
	 * @property {number} NORMAL=0 Default priority for ticker events, see {@link PIXI.Ticker#add}.
	 * @property {number} LOW=-25 Low priority used for {@link PIXI.Application} rendering.
	 * @property {number} UTILITY=-50 Lowest priority used for {@link PIXI.BasePrepare} utility.
	 */

	(function (UPDATE_PRIORITY) {
	    UPDATE_PRIORITY[UPDATE_PRIORITY["INTERACTION"] = 50] = "INTERACTION";
	    UPDATE_PRIORITY[UPDATE_PRIORITY["HIGH"] = 25] = "HIGH";
	    UPDATE_PRIORITY[UPDATE_PRIORITY["NORMAL"] = 0] = "NORMAL";
	    UPDATE_PRIORITY[UPDATE_PRIORITY["LOW"] = -25] = "LOW";
	    UPDATE_PRIORITY[UPDATE_PRIORITY["UTILITY"] = -50] = "UTILITY";
	})(exports.UPDATE_PRIORITY || (exports.UPDATE_PRIORITY = {}));

	/**
	 * Internal class for handling the priority sorting of ticker handlers.
	 *
	 * @private
	 * @class
	 * @memberof PIXI
	 */
	var TickerListener = /** @class */ (function () {
	    /**
	     * Constructor
	     * @private
	     * @param {Function} fn - The listener function to be added for one update
	     * @param {*} [context=null] - The listener context
	     * @param {number} [priority=0] - The priority for emitting
	     * @param {boolean} [once=false] - If the handler should fire once
	     */
	    function TickerListener(fn, context, priority, once) {
	        if (context === void 0) { context = null; }
	        if (priority === void 0) { priority = 0; }
	        if (once === void 0) { once = false; }
	        /**
	         * The handler function to execute.
	         * @private
	         * @member {Function}
	         */
	        this.fn = fn;
	        /**
	         * The calling to execute.
	         * @private
	         * @member {*}
	         */
	        this.context = context;
	        /**
	         * The current priority.
	         * @private
	         * @member {number}
	         */
	        this.priority = priority;
	        /**
	         * If this should only execute once.
	         * @private
	         * @member {boolean}
	         */
	        this.once = once;
	        /**
	         * The next item in chain.
	         * @private
	         * @member {TickerListener}
	         */
	        this.next = null;
	        /**
	         * The previous item in chain.
	         * @private
	         * @member {TickerListener}
	         */
	        this.previous = null;
	        /**
	         * `true` if this listener has been destroyed already.
	         * @member {boolean}
	         * @private
	         */
	        this._destroyed = false;
	    }
	    /**
	     * Simple compare function to figure out if a function and context match.
	     * @private
	     * @param {Function} fn - The listener function to be added for one update
	     * @param {any} [context] - The listener context
	     * @return {boolean} `true` if the listener match the arguments
	     */
	    TickerListener.prototype.match = function (fn, context) {
	        if (context === void 0) { context = null; }
	        return this.fn === fn && this.context === context;
	    };
	    /**
	     * Emit by calling the current function.
	     * @private
	     * @param {number} deltaTime - time since the last emit.
	     * @return {TickerListener} Next ticker
	     */
	    TickerListener.prototype.emit = function (deltaTime) {
	        if (this.fn) {
	            if (this.context) {
	                this.fn.call(this.context, deltaTime);
	            }
	            else {
	                this.fn(deltaTime);
	            }
	        }
	        var redirect = this.next;
	        if (this.once) {
	            this.destroy(true);
	        }
	        // Soft-destroying should remove
	        // the next reference
	        if (this._destroyed) {
	            this.next = null;
	        }
	        return redirect;
	    };
	    /**
	     * Connect to the list.
	     * @private
	     * @param {TickerListener} previous - Input node, previous listener
	     */
	    TickerListener.prototype.connect = function (previous) {
	        this.previous = previous;
	        if (previous.next) {
	            previous.next.previous = this;
	        }
	        this.next = previous.next;
	        previous.next = this;
	    };
	    /**
	     * Destroy and don't use after this.
	     * @private
	     * @param {boolean} [hard = false] `true` to remove the `next` reference, this
	     *        is considered a hard destroy. Soft destroy maintains the next reference.
	     * @return {TickerListener} The listener to redirect while emitting or removing.
	     */
	    TickerListener.prototype.destroy = function (hard) {
	        if (hard === void 0) { hard = false; }
	        this._destroyed = true;
	        this.fn = null;
	        this.context = null;
	        // Disconnect, hook up next and previous
	        if (this.previous) {
	            this.previous.next = this.next;
	        }
	        if (this.next) {
	            this.next.previous = this.previous;
	        }
	        // Redirect to the next item
	        var redirect = this.next;
	        // Remove references
	        this.next = hard ? null : redirect;
	        this.previous = null;
	        return redirect;
	    };
	    return TickerListener;
	}());

	/**
	 * A Ticker class that runs an update loop that other objects listen to.
	 *
	 * This class is composed around listeners meant for execution on the next requested animation frame.
	 * Animation frames are requested only when necessary, e.g. When the ticker is started and the emitter has listeners.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Ticker = /** @class */ (function () {
	    function Ticker() {
	        var _this = this;
	        /**
	         * The first listener. All new listeners added are chained on this.
	         * @private
	         * @type {TickerListener}
	         */
	        this._head = new TickerListener(null, null, Infinity);
	        /**
	         * Internal current frame request ID
	         * @type {?number}
	         * @private
	         */
	        this._requestId = null;
	        /**
	         * Internal value managed by minFPS property setter and getter.
	         * This is the maximum allowed milliseconds between updates.
	         * @type {number}
	         * @private
	         */
	        this._maxElapsedMS = 100;
	        /**
	         * Internal value managed by maxFPS property setter and getter.
	         * This is the minimum allowed milliseconds between updates.
	         * @type {number}
	         * @private
	         */
	        this._minElapsedMS = 0;
	        /**
	         * Whether or not this ticker should invoke the method
	         * {@link PIXI.Ticker#start} automatically
	         * when a listener is added.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        this.autoStart = false;
	        /**
	         * Scalar time value from last frame to this frame.
	         * This value is capped by setting {@link PIXI.Ticker#minFPS}
	         * and is scaled with {@link PIXI.Ticker#speed}.
	         * **Note:** The cap may be exceeded by scaling.
	         *
	         * @member {number}
	         * @default 1
	         */
	        this.deltaTime = 1;
	        /**
	         * Scaler time elapsed in milliseconds from last frame to this frame.
	         * This value is capped by setting {@link PIXI.Ticker#minFPS}
	         * and is scaled with {@link PIXI.Ticker#speed}.
	         * **Note:** The cap may be exceeded by scaling.
	         * If the platform supports DOMHighResTimeStamp,
	         * this value will have a precision of 1 Âµs.
	         * Defaults to target frame time
	         *
	         * @member {number}
	         * @default 16.66
	         */
	        this.deltaMS = 1 / settings.TARGET_FPMS;
	        /**
	         * Time elapsed in milliseconds from last frame to this frame.
	         * Opposed to what the scalar {@link PIXI.Ticker#deltaTime}
	         * is based, this value is neither capped nor scaled.
	         * If the platform supports DOMHighResTimeStamp,
	         * this value will have a precision of 1 Âµs.
	         * Defaults to target frame time
	         *
	         * @member {number}
	         * @default 16.66
	         */
	        this.elapsedMS = 1 / settings.TARGET_FPMS;
	        /**
	         * The last time {@link PIXI.Ticker#update} was invoked.
	         * This value is also reset internally outside of invoking
	         * update, but only when a new animation frame is requested.
	         * If the platform supports DOMHighResTimeStamp,
	         * this value will have a precision of 1 Âµs.
	         *
	         * @member {number}
	         * @default -1
	         */
	        this.lastTime = -1;
	        /**
	         * Factor of current {@link PIXI.Ticker#deltaTime}.
	         * @example
	         * // Scales ticker.deltaTime to what would be
	         * // the equivalent of approximately 120 FPS
	         * ticker.speed = 2;
	         *
	         * @member {number}
	         * @default 1
	         */
	        this.speed = 1;
	        /**
	         * Whether or not this ticker has been started.
	         * `true` if {@link PIXI.Ticker#start} has been called.
	         * `false` if {@link PIXI.Ticker#stop} has been called.
	         * While `false`, this value may change to `true` in the
	         * event of {@link PIXI.Ticker#autoStart} being `true`
	         * and a listener is added.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        this.started = false;
	        /**
	         * If enabled, deleting is disabled.
	         * @member {boolean}
	         * @default false
	         * @private
	         */
	        this._protected = false;
	        /**
	         * The last time keyframe was executed.
	         * Maintains a relatively fixed interval with the previous value.
	         * @member {number}
	         * @default -1
	         * @private
	         */
	        this._lastFrame = -1;
	        /**
	         * Internal tick method bound to ticker instance.
	         * This is because in early 2015, Function.bind
	         * is still 60% slower in high performance scenarios.
	         * Also separating frame requests from update method
	         * so listeners may be called at any time and with
	         * any animation API, just invoke ticker.update(time).
	         *
	         * @private
	         * @param {number} time - Time since last tick.
	         */
	        this._tick = function (time) {
	            _this._requestId = null;
	            if (_this.started) {
	                // Invoke listeners now
	                _this.update(time);
	                // Listener side effects may have modified ticker state.
	                if (_this.started && _this._requestId === null && _this._head.next) {
	                    _this._requestId = requestAnimationFrame(_this._tick);
	                }
	            }
	        };
	    }
	    /**
	     * Conditionally requests a new animation frame.
	     * If a frame has not already been requested, and if the internal
	     * emitter has listeners, a new frame is requested.
	     *
	     * @private
	     */
	    Ticker.prototype._requestIfNeeded = function () {
	        if (this._requestId === null && this._head.next) {
	            // ensure callbacks get correct delta
	            this.lastTime = performance.now();
	            this._lastFrame = this.lastTime;
	            this._requestId = requestAnimationFrame(this._tick);
	        }
	    };
	    /**
	     * Conditionally cancels a pending animation frame.
	     *
	     * @private
	     */
	    Ticker.prototype._cancelIfNeeded = function () {
	        if (this._requestId !== null) {
	            cancelAnimationFrame(this._requestId);
	            this._requestId = null;
	        }
	    };
	    /**
	     * Conditionally requests a new animation frame.
	     * If the ticker has been started it checks if a frame has not already
	     * been requested, and if the internal emitter has listeners. If these
	     * conditions are met, a new frame is requested. If the ticker has not
	     * been started, but autoStart is `true`, then the ticker starts now,
	     * and continues with the previous conditions to request a new frame.
	     *
	     * @private
	     */
	    Ticker.prototype._startIfPossible = function () {
	        if (this.started) {
	            this._requestIfNeeded();
	        }
	        else if (this.autoStart) {
	            this.start();
	        }
	    };
	    /**
	     * Register a handler for tick events. Calls continuously unless
	     * it is removed or the ticker is stopped.
	     *
	     * @param {Function} fn - The listener function to be added for updates
	     * @param {*} [context] - The listener context
	     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
	     * @returns {PIXI.Ticker} This instance of a ticker
	     */
	    Ticker.prototype.add = function (fn, context, priority) {
	        if (priority === void 0) { priority = exports.UPDATE_PRIORITY.NORMAL; }
	        return this._addListener(new TickerListener(fn, context, priority));
	    };
	    /**
	     * Add a handler for the tick event which is only execute once.
	     *
	     * @param {Function} fn - The listener function to be added for one update
	     * @param {*} [context] - The listener context
	     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
	     * @returns {PIXI.Ticker} This instance of a ticker
	     */
	    Ticker.prototype.addOnce = function (fn, context, priority) {
	        if (priority === void 0) { priority = exports.UPDATE_PRIORITY.NORMAL; }
	        return this._addListener(new TickerListener(fn, context, priority, true));
	    };
	    /**
	     * Internally adds the event handler so that it can be sorted by priority.
	     * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
	     * before the rendering.
	     *
	     * @private
	     * @param {TickerListener} listener - Current listener being added.
	     * @returns {PIXI.Ticker} This instance of a ticker
	     */
	    Ticker.prototype._addListener = function (listener) {
	        // For attaching to head
	        var current = this._head.next;
	        var previous = this._head;
	        // Add the first item
	        if (!current) {
	            listener.connect(previous);
	        }
	        else {
	            // Go from highest to lowest priority
	            while (current) {
	                if (listener.priority > current.priority) {
	                    listener.connect(previous);
	                    break;
	                }
	                previous = current;
	                current = current.next;
	            }
	            // Not yet connected
	            if (!listener.previous) {
	                listener.connect(previous);
	            }
	        }
	        this._startIfPossible();
	        return this;
	    };
	    /**
	     * Removes any handlers matching the function and context parameters.
	     * If no handlers are left after removing, then it cancels the animation frame.
	     *
	     * @param {Function} fn - The listener function to be removed
	     * @param {*} [context] - The listener context to be removed
	     * @returns {PIXI.Ticker} This instance of a ticker
	     */
	    Ticker.prototype.remove = function (fn, context) {
	        var listener = this._head.next;
	        while (listener) {
	            // We found a match, lets remove it
	            // no break to delete all possible matches
	            // incase a listener was added 2+ times
	            if (listener.match(fn, context)) {
	                listener = listener.destroy();
	            }
	            else {
	                listener = listener.next;
	            }
	        }
	        if (!this._head.next) {
	            this._cancelIfNeeded();
	        }
	        return this;
	    };
	    Object.defineProperty(Ticker.prototype, "count", {
	        /**
	         * The number of listeners on this ticker, calculated by walking through linked list
	         *
	         * @readonly
	         * @member {number}
	         */
	        get: function () {
	            if (!this._head) {
	                return 0;
	            }
	            var count = 0;
	            var current = this._head;
	            while ((current = current.next)) {
	                count++;
	            }
	            return count;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Starts the ticker. If the ticker has listeners
	     * a new animation frame is requested at this point.
	     */
	    Ticker.prototype.start = function () {
	        if (!this.started) {
	            this.started = true;
	            this._requestIfNeeded();
	        }
	    };
	    /**
	     * Stops the ticker. If the ticker has requested
	     * an animation frame it is canceled at this point.
	     */
	    Ticker.prototype.stop = function () {
	        if (this.started) {
	            this.started = false;
	            this._cancelIfNeeded();
	        }
	    };
	    /**
	     * Destroy the ticker and don't use after this. Calling
	     * this method removes all references to internal events.
	     */
	    Ticker.prototype.destroy = function () {
	        if (!this._protected) {
	            this.stop();
	            var listener = this._head.next;
	            while (listener) {
	                listener = listener.destroy(true);
	            }
	            this._head.destroy();
	            this._head = null;
	        }
	    };
	    /**
	     * Triggers an update. An update entails setting the
	     * current {@link PIXI.Ticker#elapsedMS},
	     * the current {@link PIXI.Ticker#deltaTime},
	     * invoking all listeners with current deltaTime,
	     * and then finally setting {@link PIXI.Ticker#lastTime}
	     * with the value of currentTime that was provided.
	     * This method will be called automatically by animation
	     * frame callbacks if the ticker instance has been started
	     * and listeners are added.
	     *
	     * @param {number} [currentTime=performance.now()] - the current time of execution
	     */
	    Ticker.prototype.update = function (currentTime) {
	        if (currentTime === void 0) { currentTime = performance.now(); }
	        var elapsedMS;
	        // If the difference in time is zero or negative, we ignore most of the work done here.
	        // If there is no valid difference, then should be no reason to let anyone know about it.
	        // A zero delta, is exactly that, nothing should update.
	        //
	        // The difference in time can be negative, and no this does not mean time traveling.
	        // This can be the result of a race condition between when an animation frame is requested
	        // on the current JavaScript engine event loop, and when the ticker's start method is invoked
	        // (which invokes the internal _requestIfNeeded method). If a frame is requested before
	        // _requestIfNeeded is invoked, then the callback for the animation frame the ticker requests,
	        // can receive a time argument that can be less than the lastTime value that was set within
	        // _requestIfNeeded. This difference is in microseconds, but this is enough to cause problems.
	        //
	        // This check covers this browser engine timing issue, as well as if consumers pass an invalid
	        // currentTime value. This may happen if consumers opt-out of the autoStart, and update themselves.
	        if (currentTime > this.lastTime) {
	            // Save uncapped elapsedMS for measurement
	            elapsedMS = this.elapsedMS = currentTime - this.lastTime;
	            // cap the milliseconds elapsed used for deltaTime
	            if (elapsedMS > this._maxElapsedMS) {
	                elapsedMS = this._maxElapsedMS;
	            }
	            elapsedMS *= this.speed;
	            // If not enough time has passed, exit the function.
	            // Get ready for next frame by setting _lastFrame, but based on _minElapsedMS
	            // adjustment to ensure a relatively stable interval.
	            if (this._minElapsedMS) {
	                var delta = currentTime - this._lastFrame | 0;
	                if (delta < this._minElapsedMS) {
	                    return;
	                }
	                this._lastFrame = currentTime - (delta % this._minElapsedMS);
	            }
	            this.deltaMS = elapsedMS;
	            this.deltaTime = this.deltaMS * settings.TARGET_FPMS;
	            // Cache a local reference, in-case ticker is destroyed
	            // during the emit, we can still check for head.next
	            var head = this._head;
	            // Invoke listeners added to internal emitter
	            var listener = head.next;
	            while (listener) {
	                listener = listener.emit(this.deltaTime);
	            }
	            if (!head.next) {
	                this._cancelIfNeeded();
	            }
	        }
	        else {
	            this.deltaTime = this.deltaMS = this.elapsedMS = 0;
	        }
	        this.lastTime = currentTime;
	    };
	    Object.defineProperty(Ticker.prototype, "FPS", {
	        /**
	         * The frames per second at which this ticker is running.
	         * The default is approximately 60 in most modern browsers.
	         * **Note:** This does not factor in the value of
	         * {@link PIXI.Ticker#speed}, which is specific
	         * to scaling {@link PIXI.Ticker#deltaTime}.
	         *
	         * @member {number}
	         * @readonly
	         */
	        get: function () {
	            return 1000 / this.elapsedMS;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Ticker.prototype, "minFPS", {
	        /**
	         * Manages the maximum amount of milliseconds allowed to
	         * elapse between invoking {@link PIXI.Ticker#update}.
	         * This value is used to cap {@link PIXI.Ticker#deltaTime},
	         * but does not effect the measured value of {@link PIXI.Ticker#FPS}.
	         * When setting this property it is clamped to a value between
	         * `0` and `PIXI.settings.TARGET_FPMS * 1000`.
	         *
	         * @member {number}
	         * @default 10
	         */
	        get: function () {
	            return 1000 / this._maxElapsedMS;
	        },
	        set: function (fps) {
	            // Minimum must be below the maxFPS
	            var minFPS = Math.min(this.maxFPS, fps);
	            // Must be at least 0, but below 1 / settings.TARGET_FPMS
	            var minFPMS = Math.min(Math.max(0, minFPS) / 1000, settings.TARGET_FPMS);
	            this._maxElapsedMS = 1 / minFPMS;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Ticker.prototype, "maxFPS", {
	        /**
	         * Manages the minimum amount of milliseconds required to
	         * elapse between invoking {@link PIXI.Ticker#update}.
	         * This will effect the measured value of {@link PIXI.Ticker#FPS}.
	         * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
	         * Otherwise it will be at least `minFPS`
	         *
	         * @member {number}
	         * @default 0
	         */
	        get: function () {
	            if (this._minElapsedMS) {
	                return Math.round(1000 / this._minElapsedMS);
	            }
	            return 0;
	        },
	        set: function (fps) {
	            if (fps === 0) {
	                this._minElapsedMS = 0;
	            }
	            else {
	                // Max must be at least the minFPS
	                var maxFPS = Math.max(this.minFPS, fps);
	                this._minElapsedMS = 1 / (maxFPS / 1000);
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Ticker, "shared", {
	        /**
	         * The shared ticker instance used by {@link PIXI.AnimatedSprite} and by
	         * {@link PIXI.VideoResource} to update animation frames / video textures.
	         *
	         * It may also be used by {@link PIXI.Application} if created with the `sharedTicker` option property set to true.
	         *
	         * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
	         * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
	         *
	         * @example
	         * let ticker = PIXI.Ticker.shared;
	         * // Set this to prevent starting this ticker when listeners are added.
	         * // By default this is true only for the PIXI.Ticker.shared instance.
	         * ticker.autoStart = false;
	         * // FYI, call this to ensure the ticker is stopped. It should be stopped
	         * // if you have not attempted to render anything yet.
	         * ticker.stop();
	         * // Call this when you are ready for a running shared ticker.
	         * ticker.start();
	         *
	         * @example
	         * // You may use the shared ticker to render...
	         * let renderer = PIXI.autoDetectRenderer();
	         * let stage = new PIXI.Container();
	         * document.body.appendChild(renderer.view);
	         * ticker.add(function (time) {
	         *     renderer.render(stage);
	         * });
	         *
	         * @example
	         * // Or you can just update it manually.
	         * ticker.autoStart = false;
	         * ticker.stop();
	         * function animate(time) {
	         *     ticker.update(time);
	         *     renderer.render(stage);
	         *     requestAnimationFrame(animate);
	         * }
	         * animate(performance.now());
	         *
	         * @member {PIXI.Ticker}
	         * @static
	         */
	        get: function () {
	            if (!Ticker._shared) {
	                var shared = Ticker._shared = new Ticker();
	                shared.autoStart = true;
	                shared._protected = true;
	            }
	            return Ticker._shared;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Ticker, "system", {
	        /**
	         * The system ticker instance used by {@link PIXI.InteractionManager} and by
	         * {@link PIXI.BasePrepare} for core timing functionality that shouldn't usually need to be paused,
	         * unlike the `shared` ticker which drives visual animations and rendering which may want to be paused.
	         *
	         * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
	         *
	         * @member {PIXI.Ticker}
	         * @static
	         */
	        get: function () {
	            if (!Ticker._system) {
	                var system = Ticker._system = new Ticker();
	                system.autoStart = true;
	                system._protected = true;
	            }
	            return Ticker._system;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Ticker;
	}());

	/**
	 * Middleware for for Application Ticker.
	 *
	 * @example
	 * import {TickerPlugin} from '@pixi/ticker';
	 * import {Application} from '@pixi/app';
	 * Application.registerPlugin(TickerPlugin);
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TickerPlugin = /** @class */ (function () {
	    function TickerPlugin() {
	    }
	    /**
	     * Initialize the plugin with scope of application instance
	     *
	     * @static
	     * @private
	     * @param {object} [options] - See application options
	     */
	    TickerPlugin.init = function (options) {
	        var _this = this;
	        // Set default
	        options = Object.assign({
	            autoStart: true,
	            sharedTicker: false,
	        }, options);
	        // Create ticker setter
	        Object.defineProperty(this, 'ticker', {
	            set: function (ticker) {
	                if (this._ticker) {
	                    this._ticker.remove(this.render, this);
	                }
	                this._ticker = ticker;
	                if (ticker) {
	                    ticker.add(this.render, this, exports.UPDATE_PRIORITY.LOW);
	                }
	            },
	            get: function () {
	                return this._ticker;
	            },
	        });
	        /**
	         * Convenience method for stopping the render.
	         *
	         * @method PIXI.Application#stop
	         */
	        this.stop = function () {
	            _this._ticker.stop();
	        };
	        /**
	         * Convenience method for starting the render.
	         *
	         * @method PIXI.Application#start
	         */
	        this.start = function () {
	            _this._ticker.start();
	        };
	        /**
	         * Internal reference to the ticker.
	         *
	         * @type {PIXI.Ticker}
	         * @name _ticker
	         * @memberof PIXI.Application#
	         * @private
	         */
	        this._ticker = null;
	        /**
	         * Ticker for doing render updates.
	         *
	         * @type {PIXI.Ticker}
	         * @name ticker
	         * @memberof PIXI.Application#
	         * @default PIXI.Ticker.shared
	         */
	        this.ticker = options.sharedTicker ? Ticker.shared : new Ticker();
	        // Start the rendering
	        if (options.autoStart) {
	            this.start();
	        }
	    };
	    /**
	     * Clean up the ticker, scoped to application.
	     *
	     * @static
	     * @private
	     */
	    TickerPlugin.destroy = function () {
	        if (this._ticker) {
	            var oldTicker = this._ticker;
	            this.ticker = null;
	            oldTicker.destroy();
	        }
	    };
	    return TickerPlugin;
	}());

	/*!
	 * @pixi/interaction - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/interaction is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * Holds all information related to an Interaction event
	 *
	 * @class
	 * @memberof PIXI
	 */
	var InteractionData = /** @class */ (function () {
	    function InteractionData() {
	        this.pressure = 0;
	        this.rotationAngle = 0;
	        this.twist = 0;
	        this.tangentialPressure = 0;
	        /**
	         * This point stores the global coords of where the touch/mouse event happened
	         *
	         * @member {PIXI.Point}
	         */
	        this.global = new Point();
	        /**
	         * The target Sprite that was interacted with
	         *
	         * @member {PIXI.Sprite}
	         */
	        this.target = null;
	        /**
	         * When passed to an event handler, this will be the original DOM Event that was captured
	         *
	         * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent
	         * @see https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent
	         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent
	         * @member {MouseEvent|TouchEvent|PointerEvent}
	         */
	        this.originalEvent = null;
	        /**
	         * Unique identifier for this interaction
	         *
	         * @member {number}
	         */
	        this.identifier = null;
	        /**
	         * Indicates whether or not the pointer device that created the event is the primary pointer.
	         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/isPrimary
	         * @type {Boolean}
	         */
	        this.isPrimary = false;
	        /**
	         * Indicates which button was pressed on the mouse or pointer device to trigger the event.
	         * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
	         * @type {number}
	         */
	        this.button = 0;
	        /**
	         * Indicates which buttons are pressed on the mouse or pointer device when the event is triggered.
	         * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
	         * @type {number}
	         */
	        this.buttons = 0;
	        /**
	         * The width of the pointer's contact along the x-axis, measured in CSS pixels.
	         * radiusX of TouchEvents will be represented by this value.
	         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/width
	         * @type {number}
	         */
	        this.width = 0;
	        /**
	         * The height of the pointer's contact along the y-axis, measured in CSS pixels.
	         * radiusY of TouchEvents will be represented by this value.
	         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/height
	         * @type {number}
	         */
	        this.height = 0;
	        /**
	         * The angle, in degrees, between the pointer device and the screen.
	         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltX
	         * @type {number}
	         */
	        this.tiltX = 0;
	        /**
	         * The angle, in degrees, between the pointer device and the screen.
	         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltY
	         * @type {number}
	         */
	        this.tiltY = 0;
	        /**
	         * The type of pointer that triggered the event.
	         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerType
	         * @type {string}
	         */
	        this.pointerType = null;
	        /**
	         * Pressure applied by the pointing device during the event. A Touch's force property
	         * will be represented by this value.
	         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pressure
	         * @type {number}
	         */
	        this.pressure = 0;
	        /**
	         * From TouchEvents (not PointerEvents triggered by touches), the rotationAngle of the Touch.
	         * @see https://developer.mozilla.org/en-US/docs/Web/API/Touch/rotationAngle
	         * @type {number}
	         */
	        this.rotationAngle = 0;
	        /**
	         * Twist of a stylus pointer.
	         * @see https://w3c.github.io/pointerevents/#pointerevent-interface
	         * @type {number}
	         */
	        this.twist = 0;
	        /**
	         * Barrel pressure on a stylus pointer.
	         * @see https://w3c.github.io/pointerevents/#pointerevent-interface
	         * @type {number}
	         */
	        this.tangentialPressure = 0;
	    }
	    Object.defineProperty(InteractionData.prototype, "pointerId", {
	        /**
	         * The unique identifier of the pointer. It will be the same as `identifier`.
	         * @readonly
	         * @member {number}
	         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerId
	         */
	        get: function () {
	            return this.identifier;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * This will return the local coordinates of the specified displayObject for this InteractionData
	     *
	     * @param {PIXI.DisplayObject} displayObject - The DisplayObject that you would like the local
	     *  coords off
	     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional (otherwise
	     *  will create a new point)
	     * @param {PIXI.Point} [globalPos] - A Point object containing your custom global coords, optional
	     *  (otherwise will use the current global coords)
	     * @return {PIXI.Point} A point containing the coordinates of the InteractionData position relative
	     *  to the DisplayObject
	     */
	    InteractionData.prototype.getLocalPosition = function (displayObject, point, globalPos) {
	        return displayObject.worldTransform.applyInverse(globalPos || this.global, point);
	    };
	    /**
	     * Copies properties from normalized event data.
	     *
	     * @param {Touch|MouseEvent|PointerEvent} event - The normalized event data
	     */
	    InteractionData.prototype.copyEvent = function (event) {
	        // isPrimary should only change on touchstart/pointerdown, so we don't want to overwrite
	        // it with "false" on later events when our shim for it on touch events might not be
	        // accurate
	        if ('isPrimary' in event && event.isPrimary) {
	            this.isPrimary = true;
	        }
	        this.button = 'button' in event && event.button;
	        // event.buttons is not available in all browsers (ie. Safari), but it does have a non-standard
	        // event.which property instead, which conveys the same information.
	        var buttons = 'buttons' in event && event.buttons;
	        this.buttons = Number.isInteger(buttons) ? buttons : 'which' in event && event.which;
	        this.width = 'width' in event && event.width;
	        this.height = 'height' in event && event.height;
	        this.tiltX = 'tiltX' in event && event.tiltX;
	        this.tiltY = 'tiltY' in event && event.tiltY;
	        this.pointerType = 'pointerType' in event && event.pointerType;
	        this.pressure = 'pressure' in event && event.pressure;
	        this.rotationAngle = 'rotationAngle' in event && event.rotationAngle;
	        this.twist = ('twist' in event && event.twist) || 0;
	        this.tangentialPressure = ('tangentialPressure' in event && event.tangentialPressure) || 0;
	    };
	    /**
	     * Resets the data for pooling.
	     */
	    InteractionData.prototype.reset = function () {
	        // isPrimary is the only property that we really need to reset - everything else is
	        // guaranteed to be overwritten
	        this.isPrimary = false;
	    };
	    return InteractionData;
	}());

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$1 = function(d, b) {
	    extendStatics$1 = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$1(d, b);
	};

	function __extends$1(d, b) {
	    extendStatics$1(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	/**
	 * Event class that mimics native DOM events.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var InteractionEvent = /** @class */ (function () {
	    function InteractionEvent() {
	        /**
	         * Whether this event will continue propagating in the tree.
	         *
	         * Remaining events for the {@link stopsPropagatingAt} object
	         * will still be dispatched.
	         *
	         * @member {boolean}
	         */
	        this.stopped = false;
	        /**
	         * At which object this event stops propagating.
	         *
	         * @private
	         * @member {PIXI.DisplayObject}
	         */
	        this.stopsPropagatingAt = null;
	        /**
	         * Whether we already reached the element we want to
	         * stop propagating at. This is important for delayed events,
	         * where we start over deeper in the tree again.
	         *
	         * @private
	         * @member {boolean}
	         */
	        this.stopPropagationHint = false;
	        /**
	         * The object which caused this event to be dispatched.
	         * For listener callback see {@link PIXI.InteractionEvent.currentTarget}.
	         *
	         * @member {PIXI.DisplayObject}
	         */
	        this.target = null;
	        /**
	         * The object whose event listenerâ€™s callback is currently being invoked.
	         *
	         * @member {PIXI.DisplayObject}
	         */
	        this.currentTarget = null;
	        /**
	         * Type of the event
	         *
	         * @member {string}
	         */
	        this.type = null;
	        /**
	         * InteractionData related to this event
	         *
	         * @member {PIXI.InteractionData}
	         */
	        this.data = null;
	    }
	    /**
	     * Prevents event from reaching any objects other than the current object.
	     *
	     */
	    InteractionEvent.prototype.stopPropagation = function () {
	        this.stopped = true;
	        this.stopPropagationHint = true;
	        this.stopsPropagatingAt = this.currentTarget;
	    };
	    /**
	     * Resets the event.
	     */
	    InteractionEvent.prototype.reset = function () {
	        this.stopped = false;
	        this.stopsPropagatingAt = null;
	        this.stopPropagationHint = false;
	        this.currentTarget = null;
	        this.target = null;
	    };
	    return InteractionEvent;
	}());

	/**
	 * DisplayObjects with the {@link PIXI.interactiveTarget} mixin use this class to track interactions
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var InteractionTrackingData = /** @class */ (function () {
	    /**
	     * @param {number} pointerId - Unique pointer id of the event
	     * @private
	     */
	    function InteractionTrackingData(pointerId) {
	        this._pointerId = pointerId;
	        this._flags = InteractionTrackingData.FLAGS.NONE;
	    }
	    /**
	     *
	     * @private
	     * @param {number} flag - The interaction flag to set
	     * @param {boolean} yn - Should the flag be set or unset
	     */
	    InteractionTrackingData.prototype._doSet = function (flag, yn) {
	        if (yn) {
	            this._flags = this._flags | flag;
	        }
	        else {
	            this._flags = this._flags & (~flag);
	        }
	    };
	    Object.defineProperty(InteractionTrackingData.prototype, "pointerId", {
	        /**
	         * Unique pointer id of the event
	         *
	         * @readonly
	         * @private
	         * @member {number}
	         */
	        get: function () {
	            return this._pointerId;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(InteractionTrackingData.prototype, "flags", {
	        /**
	         * State of the tracking data, expressed as bit flags
	         *
	         * @private
	         * @member {number}
	         */
	        get: function () {
	            return this._flags;
	        },
	        set: function (flags) {
	            this._flags = flags;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(InteractionTrackingData.prototype, "none", {
	        /**
	         * Is the tracked event inactive (not over or down)?
	         *
	         * @private
	         * @member {number}
	         */
	        get: function () {
	            return this._flags === InteractionTrackingData.FLAGS.NONE;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(InteractionTrackingData.prototype, "over", {
	        /**
	         * Is the tracked event over the DisplayObject?
	         *
	         * @private
	         * @member {boolean}
	         */
	        get: function () {
	            return (this._flags & InteractionTrackingData.FLAGS.OVER) !== 0;
	        },
	        set: function (yn) {
	            this._doSet(InteractionTrackingData.FLAGS.OVER, yn);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(InteractionTrackingData.prototype, "rightDown", {
	        /**
	         * Did the right mouse button come down in the DisplayObject?
	         *
	         * @private
	         * @member {boolean}
	         */
	        get: function () {
	            return (this._flags & InteractionTrackingData.FLAGS.RIGHT_DOWN) !== 0;
	        },
	        set: function (yn) {
	            this._doSet(InteractionTrackingData.FLAGS.RIGHT_DOWN, yn);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(InteractionTrackingData.prototype, "leftDown", {
	        /**
	         * Did the left mouse button come down in the DisplayObject?
	         *
	         * @private
	         * @member {boolean}
	         */
	        get: function () {
	            return (this._flags & InteractionTrackingData.FLAGS.LEFT_DOWN) !== 0;
	        },
	        set: function (yn) {
	            this._doSet(InteractionTrackingData.FLAGS.LEFT_DOWN, yn);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    InteractionTrackingData.FLAGS = Object.freeze({
	        NONE: 0,
	        OVER: 1 << 0,
	        LEFT_DOWN: 1 << 1,
	        RIGHT_DOWN: 1 << 2,
	    });
	    return InteractionTrackingData;
	}());

	/**
	 * Strategy how to search through stage tree for interactive objects
	 *
	 * @private
	 * @class
	 * @memberof PIXI
	 */
	var TreeSearch = /** @class */ (function () {
	    function TreeSearch() {
	        this._tempPoint = new Point();
	    }
	    /**
	     * Recursive implementation for findHit
	     *
	     * @private
	     * @param {PIXI.InteractionEvent} interactionEvent - event containing the point that
	     *  is tested for collision
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - the displayObject
	     *  that will be hit test (recursively crawls its children)
	     * @param {Function} [func] - the function that will be called on each interactive object. The
	     *  interactionEvent, displayObject and hit will be passed to the function
	     * @param {boolean} [hitTest] - this indicates if the objects inside should be hit test against the point
	     * @param {boolean} [interactive] - Whether the displayObject is interactive
	     * @return {boolean} returns true if the displayObject hit the point
	     */
	    TreeSearch.prototype.recursiveFindHit = function (interactionEvent, displayObject, func, hitTest, interactive) {
	        if (!displayObject || !displayObject.visible) {
	            return false;
	        }
	        var point = interactionEvent.data.global;
	        // Took a little while to rework this function correctly! But now it is done and nice and optimized! ^_^
	        //
	        // This function will now loop through all objects and then only hit test the objects it HAS
	        // to, not all of them. MUCH faster..
	        // An object will be hit test if the following is true:
	        //
	        // 1: It is interactive.
	        // 2: It belongs to a parent that is interactive AND one of the parents children have not already been hit.
	        //
	        // As another little optimization once an interactive object has been hit we can carry on
	        // through the scenegraph, but we know that there will be no more hits! So we can avoid extra hit tests
	        // A final optimization is that an object is not hit test directly if a child has already been hit.
	        interactive = displayObject.interactive || interactive;
	        var hit = false;
	        var interactiveParent = interactive;
	        // Flag here can set to false if the event is outside the parents hitArea or mask
	        var hitTestChildren = true;
	        // If there is a hitArea, no need to test against anything else if the pointer is not within the hitArea
	        // There is also no longer a need to hitTest children.
	        if (displayObject.hitArea) {
	            if (hitTest) {
	                displayObject.worldTransform.applyInverse(point, this._tempPoint);
	                if (!displayObject.hitArea.contains(this._tempPoint.x, this._tempPoint.y)) {
	                    hitTest = false;
	                    hitTestChildren = false;
	                }
	                else {
	                    hit = true;
	                }
	            }
	            interactiveParent = false;
	        }
	        // If there is a mask, no need to hitTest against anything else if the pointer is not within the mask.
	        // We still want to hitTestChildren, however, to ensure a mouseout can still be generated.
	        // https://github.com/pixijs/pixi.js/issues/5135
	        else if (displayObject._mask) {
	            if (hitTest) {
	                if (!(displayObject._mask.containsPoint && displayObject._mask.containsPoint(point))) {
	                    hitTest = false;
	                }
	            }
	        }
	        // ** FREE TIP **! If an object is not interactive or has no buttons in it
	        // (such as a game scene!) set interactiveChildren to false for that displayObject.
	        // This will allow PixiJS to completely ignore and bypass checking the displayObjects children.
	        if (hitTestChildren && displayObject.interactiveChildren && displayObject.children) {
	            var children = displayObject.children;
	            for (var i = children.length - 1; i >= 0; i--) {
	                var child = children[i];
	                // time to get recursive.. if this function will return if something is hit..
	                var childHit = this.recursiveFindHit(interactionEvent, child, func, hitTest, interactiveParent);
	                if (childHit) {
	                    // its a good idea to check if a child has lost its parent.
	                    // this means it has been removed whilst looping so its best
	                    if (!child.parent) {
	                        continue;
	                    }
	                    // we no longer need to hit test any more objects in this container as we we
	                    // now know the parent has been hit
	                    interactiveParent = false;
	                    // If the child is interactive , that means that the object hit was actually
	                    // interactive and not just the child of an interactive object.
	                    // This means we no longer need to hit test anything else. We still need to run
	                    // through all objects, but we don't need to perform any hit tests.
	                    if (childHit) {
	                        if (interactionEvent.target) {
	                            hitTest = false;
	                        }
	                        hit = true;
	                    }
	                }
	            }
	        }
	        // no point running this if the item is not interactive or does not have an interactive parent.
	        if (interactive) {
	            // if we are hit testing (as in we have no hit any objects yet)
	            // We also don't need to worry about hit testing if once of the displayObjects children
	            // has already been hit - but only if it was interactive, otherwise we need to keep
	            // looking for an interactive child, just in case we hit one
	            if (hitTest && !interactionEvent.target) {
	                // already tested against hitArea if it is defined
	                if (!displayObject.hitArea && displayObject.containsPoint) {
	                    if (displayObject.containsPoint(point)) {
	                        hit = true;
	                    }
	                }
	            }
	            if (displayObject.interactive) {
	                if (hit && !interactionEvent.target) {
	                    interactionEvent.target = displayObject;
	                }
	                if (func) {
	                    func(interactionEvent, displayObject, !!hit);
	                }
	            }
	        }
	        return hit;
	    };
	    /**
	     * This function is provides a neat way of crawling through the scene graph and running a
	     * specified function on all interactive objects it finds. It will also take care of hit
	     * testing the interactive objects and passes the hit across in the function.
	     *
	     * @private
	     * @param {PIXI.InteractionEvent} interactionEvent - event containing the point that
	     *  is tested for collision
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - the displayObject
	     *  that will be hit test (recursively crawls its children)
	     * @param {Function} [func] - the function that will be called on each interactive object. The
	     *  interactionEvent, displayObject and hit will be passed to the function
	     * @param {boolean} [hitTest] - this indicates if the objects inside should be hit test against the point
	     * @return {boolean} returns true if the displayObject hit the point
	     */
	    TreeSearch.prototype.findHit = function (interactionEvent, displayObject, func, hitTest) {
	        this.recursiveFindHit(interactionEvent, displayObject, func, hitTest, false);
	    };
	    return TreeSearch;
	}());

	/**
	 * Interface for classes that represent a hit area.
	 *
	 * It is implemented by the following classes:
	 * - {@link PIXI.Circle}
	 * - {@link PIXI.Ellipse}
	 * - {@link PIXI.Polygon}
	 * - {@link PIXI.RoundedRectangle}
	 *
	 * @interface IHitArea
	 * @memberof PIXI
	 */
	/**
	 * Checks whether the x and y coordinates given are contained within this area
	 *
	 * @method
	 * @name contains
	 * @memberof PIXI.IHitArea#
	 * @param {number} x - The X coordinate of the point to test
	 * @param {number} y - The Y coordinate of the point to test
	 * @return {boolean} Whether the x/y coordinates are within this area
	 */
	/**
	 * Default property values of interactive objects
	 * Used by {@link PIXI.InteractionManager} to automatically give all DisplayObjects these properties
	 *
	 * @private
	 * @name interactiveTarget
	 * @type {Object}
	 * @memberof PIXI
	 * @example
	 *      function MyObject() {}
	 *
	 *      Object.assign(
	 *          DisplayObject.prototype,
	 *          PIXI.interactiveTarget
	 *      );
	 */
	var interactiveTarget = {
	    /**
	     * Enable interaction events for the DisplayObject. Touch, pointer and mouse
	     * events will not be emitted unless `interactive` is set to `true`.
	     *
	     * @example
	     * const sprite = new PIXI.Sprite(texture);
	     * sprite.interactive = true;
	     * sprite.on('tap', (event) => {
	     *    //handle event
	     * });
	     * @member {boolean}
	     * @memberof PIXI.DisplayObject#
	     */
	    interactive: false,
	    /**
	     * Determines if the children to the displayObject can be clicked/touched
	     * Setting this to false allows PixiJS to bypass a recursive `hitTest` function
	     *
	     * @member {boolean}
	     * @memberof PIXI.Container#
	     */
	    interactiveChildren: true,
	    /**
	     * Interaction shape. Children will be hit first, then this shape will be checked.
	     * Setting this will cause this shape to be checked in hit tests rather than the displayObject's bounds.
	     *
	     * @example
	     * const sprite = new PIXI.Sprite(texture);
	     * sprite.interactive = true;
	     * sprite.hitArea = new PIXI.Rectangle(0, 0, 100, 100);
	     * @member {PIXI.IHitArea}
	     * @memberof PIXI.DisplayObject#
	     */
	    hitArea: null,
	    /**
	     * If enabled, the mouse cursor use the pointer behavior when hovered over the displayObject if it is interactive
	     * Setting this changes the 'cursor' property to `'pointer'`.
	     *
	     * @example
	     * const sprite = new PIXI.Sprite(texture);
	     * sprite.interactive = true;
	     * sprite.buttonMode = true;
	     * @member {boolean}
	     * @memberof PIXI.DisplayObject#
	     */
	    get buttonMode() {
	        return this.cursor === 'pointer';
	    },
	    set buttonMode(value) {
	        if (value) {
	            this.cursor = 'pointer';
	        }
	        else if (this.cursor === 'pointer') {
	            this.cursor = null;
	        }
	    },
	    /**
	     * This defines what cursor mode is used when the mouse cursor
	     * is hovered over the displayObject.
	     *
	     * @example
	     * const sprite = new PIXI.Sprite(texture);
	     * sprite.interactive = true;
	     * sprite.cursor = 'wait';
	     * @see https://developer.mozilla.org/en/docs/Web/CSS/cursor
	     *
	     * @member {string}
	     * @memberof PIXI.DisplayObject#
	     */
	    cursor: null,
	    /**
	     * Internal set of all active pointers, by identifier
	     *
	     * @member {Map<number, InteractionTrackingData>}
	     * @memberof PIXI.DisplayObject#
	     * @private
	     */
	    get trackedPointers() {
	        if (this._trackedPointers === undefined)
	            { this._trackedPointers = {}; }
	        return this._trackedPointers;
	    },
	    /**
	     * Map of all tracked pointers, by identifier. Use trackedPointers to access.
	     *
	     * @private
	     * @type {Map<number, InteractionTrackingData>}
	     */
	    _trackedPointers: undefined,
	};

	// Mix interactiveTarget into DisplayObject.prototype,
	// after deprecation has been handled
	DisplayObject.mixin(interactiveTarget);
	var MOUSE_POINTER_ID = 1;
	// helpers for hitTest() - only used inside hitTest()
	var hitTestEvent = {
	    target: null,
	    data: {
	        global: null,
	    },
	};
	/**
	 * The interaction manager deals with mouse, touch and pointer events.
	 *
	 * Any DisplayObject can be interactive if its `interactive` property is set to true.
	 *
	 * This manager also supports multitouch.
	 *
	 * An instance of this class is automatically created by default, and can be found at `renderer.plugins.interaction`
	 *
	 * @class
	 * @extends PIXI.utils.EventEmitter
	 * @memberof PIXI
	 */
	var InteractionManager = /** @class */ (function (_super) {
	    __extends$1(InteractionManager, _super);
	    /**
	     * @param {PIXI.CanvasRenderer|PIXI.Renderer} renderer - A reference to the current renderer
	     * @param {object} [options] - The options for the manager.
	     * @param {boolean} [options.autoPreventDefault=true] - Should the manager automatically prevent default browser actions.
	     * @param {number} [options.interactionFrequency=10] - Maximum requency (ms) at pointer over/out states will be checked.
	     * @param {number} [options.useSystemTicker=true] - Whether to add {@link tickerUpdate} to {@link PIXI.Ticker.system}.
	     */
	    function InteractionManager(renderer, options) {
	        var _this = _super.call(this) || this;
	        options = options || {};
	        /**
	         * The renderer this interaction manager works for.
	         *
	         * @member {PIXI.AbstractRenderer}
	         */
	        _this.renderer = renderer;
	        /**
	         * Should default browser actions automatically be prevented.
	         * Does not apply to pointer events for backwards compatibility
	         * preventDefault on pointer events stops mouse events from firing
	         * Thus, for every pointer event, there will always be either a mouse of touch event alongside it.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.autoPreventDefault = options.autoPreventDefault !== undefined ? options.autoPreventDefault : true;
	        /**
	         * Maximum requency in milliseconds at which pointer over/out states will be checked by {@link tickerUpdate}.
	         *
	         * @member {number}
	         * @default 10
	         */
	        _this.interactionFrequency = options.interactionFrequency || 10;
	        /**
	         * The mouse data
	         *
	         * @member {PIXI.InteractionData}
	         */
	        _this.mouse = new InteractionData();
	        _this.mouse.identifier = MOUSE_POINTER_ID;
	        // setting the mouse to start off far off screen will mean that mouse over does
	        //  not get called before we even move the mouse.
	        _this.mouse.global.set(-999999);
	        /**
	         * Actively tracked InteractionData
	         *
	         * @private
	         * @member {Object.<number,PIXI.InteractionData>}
	         */
	        _this.activeInteractionData = {};
	        _this.activeInteractionData[MOUSE_POINTER_ID] = _this.mouse;
	        /**
	         * Pool of unused InteractionData
	         *
	         * @private
	         * @member {PIXI.InteractionData[]}
	         */
	        _this.interactionDataPool = [];
	        /**
	         * An event data object to handle all the event tracking/dispatching
	         *
	         * @member {object}
	         */
	        _this.eventData = new InteractionEvent();
	        /**
	         * The DOM element to bind to.
	         *
	         * @protected
	         * @member {HTMLElement}
	         */
	        _this.interactionDOMElement = null;
	        /**
	         * This property determines if mousemove and touchmove events are fired only when the cursor
	         * is over the object.
	         * Setting to true will make things work more in line with how the DOM version works.
	         * Setting to false can make things easier for things like dragging
	         * It is currently set to false as this is how PixiJS used to work. This will be set to true in
	         * future versions of pixi.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        _this.moveWhenInside = false;
	        /**
	         * Have events been attached to the dom element?
	         *
	         * @protected
	         * @member {boolean}
	         */
	        _this.eventsAdded = false;
	        /**
	         * Has the system ticker been added?
	         *
	         * @protected
	         * @member {boolean}
	         */
	        _this.tickerAdded = false;
	        /**
	         * Is the mouse hovering over the renderer?
	         *
	         * @protected
	         * @member {boolean}
	         */
	        _this.mouseOverRenderer = false;
	        /**
	         * Does the device support touch events
	         * https://www.w3.org/TR/touch-events/
	         *
	         * @readonly
	         * @member {boolean}
	         */
	        _this.supportsTouchEvents = 'ontouchstart' in window;
	        /**
	         * Does the device support pointer events
	         * https://www.w3.org/Submission/pointer-events/
	         *
	         * @readonly
	         * @member {boolean}
	         */
	        _this.supportsPointerEvents = !!window.PointerEvent;
	        // this will make it so that you don't have to call bind all the time
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerUp = _this.onPointerUp.bind(_this);
	        _this.processPointerUp = _this.processPointerUp.bind(_this);
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerCancel = _this.onPointerCancel.bind(_this);
	        _this.processPointerCancel = _this.processPointerCancel.bind(_this);
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerDown = _this.onPointerDown.bind(_this);
	        _this.processPointerDown = _this.processPointerDown.bind(_this);
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerMove = _this.onPointerMove.bind(_this);
	        _this.processPointerMove = _this.processPointerMove.bind(_this);
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerOut = _this.onPointerOut.bind(_this);
	        _this.processPointerOverOut = _this.processPointerOverOut.bind(_this);
	        /**
	         * @private
	         * @member {Function}
	         */
	        _this.onPointerOver = _this.onPointerOver.bind(_this);
	        /**
	         * Dictionary of how different cursor modes are handled. Strings are handled as CSS cursor
	         * values, objects are handled as dictionaries of CSS values for interactionDOMElement,
	         * and functions are called instead of changing the CSS.
	         * Default CSS cursor values are provided for 'default' and 'pointer' modes.
	         * @member {Object.<string, Object>}
	         */
	        _this.cursorStyles = {
	            default: 'inherit',
	            pointer: 'pointer',
	        };
	        /**
	         * The mode of the cursor that is being used.
	         * The value of this is a key from the cursorStyles dictionary.
	         *
	         * @member {string}
	         */
	        _this.currentCursorMode = null;
	        /**
	         * Internal cached let.
	         *
	         * @private
	         * @member {string}
	         */
	        _this.cursor = null;
	        /**
	         * The current resolution / device pixel ratio.
	         *
	         * @member {number}
	         * @default 1
	         */
	        _this.resolution = 1;
	        /**
	         * Delayed pointer events. Used to guarantee correct ordering of over/out events.
	         *
	         * @private
	         * @member {Array}
	         */
	        _this.delayedEvents = [];
	        /**
	         * TreeSearch component that is used to hitTest stage tree
	         *
	         * @private
	         * @member {PIXI.TreeSearch}
	         */
	        _this.search = new TreeSearch();
	        /**
	         * Used as a last rendered object in case renderer doesnt have _lastObjectRendered
	         * @member {DisplayObject}
	         * @private
	         */
	        _this._tempDisplayObject = new TemporaryDisplayObject();
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display
	         * object.
	         *
	         * @event PIXI.InteractionManager#mousedown
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * on the display object.
	         *
	         * @event PIXI.InteractionManager#rightdown
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released over the display
	         * object.
	         *
	         * @event PIXI.InteractionManager#mouseup
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * over the display object.
	         *
	         * @event PIXI.InteractionManager#rightup
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
	         * the display object.
	         *
	         * @event PIXI.InteractionManager#click
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * and released on the display object.
	         *
	         * @event PIXI.InteractionManager#rightclick
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released outside the
	         * display object that initially registered a
	         * [mousedown]{@link PIXI.InteractionManager#event:mousedown}.
	         *
	         * @event PIXI.InteractionManager#mouseupoutside
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * outside the display object that initially registered a
	         * [rightdown]{@link PIXI.InteractionManager#event:rightdown}.
	         *
	         * @event PIXI.InteractionManager#rightupoutside
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device (usually a mouse) is moved while over the display object
	         *
	         * @event PIXI.InteractionManager#mousemove
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device (usually a mouse) is moved onto the display object
	         *
	         * @event PIXI.InteractionManager#mouseover
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device (usually a mouse) is moved off the display object
	         *
	         * @event PIXI.InteractionManager#mouseout
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device button is pressed on the display object.
	         *
	         * @event PIXI.InteractionManager#pointerdown
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device button is released over the display object.
	         * Not always fired when some buttons are held down while others are released. In those cases,
	         * use [mousedown]{@link PIXI.InteractionManager#event:mousedown} and
	         * [mouseup]{@link PIXI.InteractionManager#event:mouseup} instead.
	         *
	         * @event PIXI.InteractionManager#pointerup
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when the operating system cancels a pointer event
	         *
	         * @event PIXI.InteractionManager#pointercancel
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device button is pressed and released on the display object.
	         *
	         * @event PIXI.InteractionManager#pointertap
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device button is released outside the display object that initially
	         * registered a [pointerdown]{@link PIXI.InteractionManager#event:pointerdown}.
	         *
	         * @event PIXI.InteractionManager#pointerupoutside
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device is moved while over the display object
	         *
	         * @event PIXI.InteractionManager#pointermove
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device is moved onto the display object
	         *
	         * @event PIXI.InteractionManager#pointerover
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device is moved off the display object
	         *
	         * @event PIXI.InteractionManager#pointerout
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a touch point is placed on the display object.
	         *
	         * @event PIXI.InteractionManager#touchstart
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a touch point is removed from the display object.
	         *
	         * @event PIXI.InteractionManager#touchend
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when the operating system cancels a touch
	         *
	         * @event PIXI.InteractionManager#touchcancel
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a touch point is placed and removed from the display object.
	         *
	         * @event PIXI.InteractionManager#tap
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a touch point is removed outside of the display object that initially
	         * registered a [touchstart]{@link PIXI.InteractionManager#event:touchstart}.
	         *
	         * @event PIXI.InteractionManager#touchendoutside
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a touch point is moved along the display object.
	         *
	         * @event PIXI.InteractionManager#touchmove
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display.
	         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mousedown
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightdown
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released over the display
	         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseup
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * over the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightup
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
	         * the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#click
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
	         * and released on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightclick
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device button (usually a mouse left-button) is released outside the
	         * display object that initially registered a
	         * [mousedown]{@link PIXI.DisplayObject#event:mousedown}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseupoutside
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device secondary button (usually a mouse right-button) is released
	         * outside the display object that initially registered a
	         * [rightdown]{@link PIXI.DisplayObject#event:rightdown}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#rightupoutside
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device (usually a mouse) is moved while over the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mousemove
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device (usually a mouse) is moved onto the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseover
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device (usually a mouse) is moved off the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#mouseout
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device button is pressed on the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerdown
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device button is released over the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerup
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when the operating system cancels a pointer event.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointercancel
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device button is pressed and released on the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointertap
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device button is released outside the display object that initially
	         * registered a [pointerdown]{@link PIXI.DisplayObject#event:pointerdown}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerupoutside
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device is moved while over the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointermove
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device is moved onto the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerover
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a pointer device is moved off the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#pointerout
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a touch point is placed on the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchstart
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a touch point is removed from the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchend
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when the operating system cancels a touch.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchcancel
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a touch point is placed and removed from the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#tap
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a touch point is removed outside of the display object that initially
	         * registered a [touchstart]{@link PIXI.DisplayObject#event:touchstart}.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchendoutside
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        /**
	         * Fired when a touch point is moved along the display object.
	         * DisplayObject's `interactive` property must be set to `true` to fire event.
	         *
	         * @event PIXI.DisplayObject#touchmove
	         * @param {PIXI.InteractionEvent} event - Interaction event
	         */
	        _this._useSystemTicker = options.useSystemTicker !== undefined ? options.useSystemTicker : true;
	        _this.setTargetElement(_this.renderer.view, _this.renderer.resolution);
	        return _this;
	    }
	    Object.defineProperty(InteractionManager.prototype, "useSystemTicker", {
	        /**
	         * Should the InteractionManager automatically add {@link tickerUpdate} to {@link PIXI.Ticker.system}.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        get: function () {
	            return this._useSystemTicker;
	        },
	        set: function (useSystemTicker) {
	            this._useSystemTicker = useSystemTicker;
	            if (useSystemTicker) {
	                this.addTickerListener();
	            }
	            else {
	                this.removeTickerListener();
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(InteractionManager.prototype, "lastObjectRendered", {
	        /**
	         * Last rendered object or temp object
	         * @readonly
	         * @protected
	         * @member {PIXI.DisplayObject}
	         */
	        get: function () {
	            return this.renderer._lastObjectRendered || this._tempDisplayObject;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Hit tests a point against the display tree, returning the first interactive object that is hit.
	     *
	     * @param {PIXI.Point} globalPoint - A point to hit test with, in global space.
	     * @param {PIXI.Container} [root] - The root display object to start from. If omitted, defaults
	     * to the last rendered root of the associated renderer.
	     * @return {PIXI.DisplayObject} The hit display object, if any.
	     */
	    InteractionManager.prototype.hitTest = function (globalPoint, root) {
	        // clear the target for our hit test
	        hitTestEvent.target = null;
	        // assign the global point
	        hitTestEvent.data.global = globalPoint;
	        // ensure safety of the root
	        if (!root) {
	            root = this.lastObjectRendered;
	        }
	        // run the hit test
	        this.processInteractive(hitTestEvent, root, null, true);
	        // return our found object - it'll be null if we didn't hit anything
	        return hitTestEvent.target;
	    };
	    /**
	     * Sets the DOM element which will receive mouse/touch events. This is useful for when you have
	     * other DOM elements on top of the renderers Canvas element. With this you'll be bale to delegate
	     * another DOM element to receive those events.
	     *
	     * @param {HTMLElement} element - the DOM element which will receive mouse and touch events.
	     * @param {number} [resolution=1] - The resolution / device pixel ratio of the new element (relative to the canvas).
	     */
	    InteractionManager.prototype.setTargetElement = function (element, resolution) {
	        if (resolution === void 0) { resolution = 1; }
	        this.removeTickerListener();
	        this.removeEvents();
	        this.interactionDOMElement = element;
	        this.resolution = resolution;
	        this.addEvents();
	        this.addTickerListener();
	    };
	    /**
	     * Add the ticker listener
	     *
	     * @private
	     */
	    InteractionManager.prototype.addTickerListener = function () {
	        if (this.tickerAdded || !this.interactionDOMElement || !this._useSystemTicker) {
	            return;
	        }
	        Ticker.system.add(this.tickerUpdate, this, exports.UPDATE_PRIORITY.INTERACTION);
	        this.tickerAdded = true;
	    };
	    /**
	     * Remove the ticker listener
	     *
	     * @private
	     */
	    InteractionManager.prototype.removeTickerListener = function () {
	        if (!this.tickerAdded) {
	            return;
	        }
	        Ticker.system.remove(this.tickerUpdate, this);
	        this.tickerAdded = false;
	    };
	    /**
	     * Registers all the DOM events
	     *
	     * @private
	     */
	    InteractionManager.prototype.addEvents = function () {
	        if (this.eventsAdded || !this.interactionDOMElement) {
	            return;
	        }
	        var style = this.interactionDOMElement.style;
	        if (window.navigator.msPointerEnabled) {
	            style.msContentZooming = 'none';
	            style.msTouchAction = 'none';
	        }
	        else if (this.supportsPointerEvents) {
	            style.touchAction = 'none';
	        }
	        /**
	         * These events are added first, so that if pointer events are normalized, they are fired
	         * in the same order as non-normalized events. ie. pointer event 1st, mouse / touch 2nd
	         */
	        if (this.supportsPointerEvents) {
	            window.document.addEventListener('pointermove', this.onPointerMove, true);
	            this.interactionDOMElement.addEventListener('pointerdown', this.onPointerDown, true);
	            // pointerout is fired in addition to pointerup (for touch events) and pointercancel
	            // we already handle those, so for the purposes of what we do in onPointerOut, we only
	            // care about the pointerleave event
	            this.interactionDOMElement.addEventListener('pointerleave', this.onPointerOut, true);
	            this.interactionDOMElement.addEventListener('pointerover', this.onPointerOver, true);
	            window.addEventListener('pointercancel', this.onPointerCancel, true);
	            window.addEventListener('pointerup', this.onPointerUp, true);
	        }
	        else {
	            window.document.addEventListener('mousemove', this.onPointerMove, true);
	            this.interactionDOMElement.addEventListener('mousedown', this.onPointerDown, true);
	            this.interactionDOMElement.addEventListener('mouseout', this.onPointerOut, true);
	            this.interactionDOMElement.addEventListener('mouseover', this.onPointerOver, true);
	            window.addEventListener('mouseup', this.onPointerUp, true);
	        }
	        // always look directly for touch events so that we can provide original data
	        // In a future version we should change this to being just a fallback and rely solely on
	        // PointerEvents whenever available
	        if (this.supportsTouchEvents) {
	            this.interactionDOMElement.addEventListener('touchstart', this.onPointerDown, true);
	            this.interactionDOMElement.addEventListener('touchcancel', this.onPointerCancel, true);
	            this.interactionDOMElement.addEventListener('touchend', this.onPointerUp, true);
	            this.interactionDOMElement.addEventListener('touchmove', this.onPointerMove, true);
	        }
	        this.eventsAdded = true;
	    };
	    /**
	     * Removes all the DOM events that were previously registered
	     *
	     * @private
	     */
	    InteractionManager.prototype.removeEvents = function () {
	        if (!this.eventsAdded || !this.interactionDOMElement) {
	            return;
	        }
	        var style = this.interactionDOMElement.style;
	        if (window.navigator.msPointerEnabled) {
	            style.msContentZooming = '';
	            style.msTouchAction = '';
	        }
	        else if (this.supportsPointerEvents) {
	            style.touchAction = '';
	        }
	        if (this.supportsPointerEvents) {
	            window.document.removeEventListener('pointermove', this.onPointerMove, true);
	            this.interactionDOMElement.removeEventListener('pointerdown', this.onPointerDown, true);
	            this.interactionDOMElement.removeEventListener('pointerleave', this.onPointerOut, true);
	            this.interactionDOMElement.removeEventListener('pointerover', this.onPointerOver, true);
	            window.removeEventListener('pointercancel', this.onPointerCancel, true);
	            window.removeEventListener('pointerup', this.onPointerUp, true);
	        }
	        else {
	            window.document.removeEventListener('mousemove', this.onPointerMove, true);
	            this.interactionDOMElement.removeEventListener('mousedown', this.onPointerDown, true);
	            this.interactionDOMElement.removeEventListener('mouseout', this.onPointerOut, true);
	            this.interactionDOMElement.removeEventListener('mouseover', this.onPointerOver, true);
	            window.removeEventListener('mouseup', this.onPointerUp, true);
	        }
	        if (this.supportsTouchEvents) {
	            this.interactionDOMElement.removeEventListener('touchstart', this.onPointerDown, true);
	            this.interactionDOMElement.removeEventListener('touchcancel', this.onPointerCancel, true);
	            this.interactionDOMElement.removeEventListener('touchend', this.onPointerUp, true);
	            this.interactionDOMElement.removeEventListener('touchmove', this.onPointerMove, true);
	        }
	        this.interactionDOMElement = null;
	        this.eventsAdded = false;
	    };
	    /**
	     * Updates the state of interactive objects if at least {@link interactionFrequency}
	     * milliseconds have passed since the last invocation.
	     *
	     * Invoked by a throttled ticker update from {@link PIXI.Ticker.system}.
	     *
	     * @param {number} deltaTime - time delta since the last call
	     */
	    InteractionManager.prototype.tickerUpdate = function (deltaTime) {
	        this._deltaTime += deltaTime;
	        if (this._deltaTime < this.interactionFrequency) {
	            return;
	        }
	        this._deltaTime = 0;
	        this.update();
	    };
	    /**
	     * Updates the state of interactive objects.
	     */
	    InteractionManager.prototype.update = function () {
	        if (!this.interactionDOMElement) {
	            return;
	        }
	        // if the user move the mouse this check has already been done using the mouse move!
	        if (this._didMove) {
	            this._didMove = false;
	            return;
	        }
	        this.cursor = null;
	        // Resets the flag as set by a stopPropagation call. This flag is usually reset by a user interaction of any kind,
	        // but there was a scenario of a display object moving under a static mouse cursor.
	        // In this case, mouseover and mouseevents would not pass the flag test in dispatchEvent function
	        for (var k in this.activeInteractionData) {
	            // eslint-disable-next-line no-prototype-builtins
	            if (this.activeInteractionData.hasOwnProperty(k)) {
	                var interactionData = this.activeInteractionData[k];
	                if (interactionData.originalEvent && interactionData.pointerType !== 'touch') {
	                    var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, interactionData.originalEvent, interactionData);
	                    this.processInteractive(interactionEvent, this.lastObjectRendered, this.processPointerOverOut, true);
	                }
	            }
	        }
	        this.setCursorMode(this.cursor);
	    };
	    /**
	     * Sets the current cursor mode, handling any callbacks or CSS style changes.
	     *
	     * @param {string} mode - cursor mode, a key from the cursorStyles dictionary
	     */
	    InteractionManager.prototype.setCursorMode = function (mode) {
	        mode = mode || 'default';
	        // if the mode didn't actually change, bail early
	        if (this.currentCursorMode === mode) {
	            return;
	        }
	        this.currentCursorMode = mode;
	        var style = this.cursorStyles[mode];
	        // only do things if there is a cursor style for it
	        if (style) {
	            switch (typeof style) {
	                case 'string':
	                    // string styles are handled as cursor CSS
	                    this.interactionDOMElement.style.cursor = style;
	                    break;
	                case 'function':
	                    // functions are just called, and passed the cursor mode
	                    style(mode);
	                    break;
	                case 'object':
	                    // if it is an object, assume that it is a dictionary of CSS styles,
	                    // apply it to the interactionDOMElement
	                    Object.assign(this.interactionDOMElement.style, style);
	                    break;
	            }
	        }
	        else if (typeof mode === 'string' && !Object.prototype.hasOwnProperty.call(this.cursorStyles, mode)) {
	            // if it mode is a string (not a Symbol) and cursorStyles doesn't have any entry
	            // for the mode, then assume that the dev wants it to be CSS for the cursor.
	            this.interactionDOMElement.style.cursor = mode;
	        }
	    };
	    /**
	     * Dispatches an event on the display object that was interacted with
	     *
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - the display object in question
	     * @param {string} eventString - the name of the event (e.g, mousedown)
	     * @param {PIXI.InteractionEvent} eventData - the event data object
	     * @private
	     */
	    InteractionManager.prototype.dispatchEvent = function (displayObject, eventString, eventData) {
	        // Even if the event was stopped, at least dispatch any remaining events
	        // for the same display object.
	        if (!eventData.stopPropagationHint || displayObject === eventData.stopsPropagatingAt) {
	            eventData.currentTarget = displayObject;
	            eventData.type = eventString;
	            displayObject.emit(eventString, eventData);
	            if (displayObject[eventString]) {
	                displayObject[eventString](eventData);
	            }
	        }
	    };
	    /**
	     * Puts a event on a queue to be dispatched later. This is used to guarantee correct
	     * ordering of over/out events.
	     *
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - the display object in question
	     * @param {string} eventString - the name of the event (e.g, mousedown)
	     * @param {object} eventData - the event data object
	     * @private
	     */
	    InteractionManager.prototype.delayDispatchEvent = function (displayObject, eventString, eventData) {
	        this.delayedEvents.push({ displayObject: displayObject, eventString: eventString, eventData: eventData });
	    };
	    /**
	     * Maps x and y coords from a DOM object and maps them correctly to the PixiJS view. The
	     * resulting value is stored in the point. This takes into account the fact that the DOM
	     * element could be scaled and positioned anywhere on the screen.
	     *
	     * @param  {PIXI.IPointData} point - the point that the result will be stored in
	     * @param  {number} x - the x coord of the position to map
	     * @param  {number} y - the y coord of the position to map
	     */
	    InteractionManager.prototype.mapPositionToPoint = function (point, x, y) {
	        var rect;
	        // IE 11 fix
	        if (!this.interactionDOMElement.parentElement) {
	            rect = { x: 0, y: 0, width: 0, height: 0 };
	        }
	        else {
	            rect = this.interactionDOMElement.getBoundingClientRect();
	        }
	        var resolutionMultiplier = 1.0 / this.resolution;
	        point.x = ((x - rect.left) * (this.interactionDOMElement.width / rect.width)) * resolutionMultiplier;
	        point.y = ((y - rect.top) * (this.interactionDOMElement.height / rect.height)) * resolutionMultiplier;
	    };
	    /**
	     * This function is provides a neat way of crawling through the scene graph and running a
	     * specified function on all interactive objects it finds. It will also take care of hit
	     * testing the interactive objects and passes the hit across in the function.
	     *
	     * @protected
	     * @param {PIXI.InteractionEvent} interactionEvent - event containing the point that
	     *  is tested for collision
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - the displayObject
	     *  that will be hit test (recursively crawls its children)
	     * @param {Function} [func] - the function that will be called on each interactive object. The
	     *  interactionEvent, displayObject and hit will be passed to the function
	     * @param {boolean} [hitTest] - indicates whether we want to calculate hits
	     *  or just iterate through all interactive objects
	     */
	    InteractionManager.prototype.processInteractive = function (interactionEvent, displayObject, func, hitTest) {
	        var hit = this.search.findHit(interactionEvent, displayObject, func, hitTest);
	        var delayedEvents = this.delayedEvents;
	        if (!delayedEvents.length) {
	            return hit;
	        }
	        // Reset the propagation hint, because we start deeper in the tree again.
	        interactionEvent.stopPropagationHint = false;
	        var delayedLen = delayedEvents.length;
	        this.delayedEvents = [];
	        for (var i = 0; i < delayedLen; i++) {
	            var _a = delayedEvents[i], displayObject_1 = _a.displayObject, eventString = _a.eventString, eventData = _a.eventData;
	            // When we reach the object we wanted to stop propagating at,
	            // set the propagation hint.
	            if (eventData.stopsPropagatingAt === displayObject_1) {
	                eventData.stopPropagationHint = true;
	            }
	            this.dispatchEvent(displayObject_1, eventString, eventData);
	        }
	        return hit;
	    };
	    /**
	     * Is called when the pointer button is pressed down on the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being pressed down
	     */
	    InteractionManager.prototype.onPointerDown = function (originalEvent) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch')
	            { return; }
	        var events = this.normalizeToPointerData(originalEvent);
	        /**
	         * No need to prevent default on natural pointer events, as there are no side effects
	         * Normalized events, however, may have the double mousedown/touchstart issue on the native android browser,
	         * so still need to be prevented.
	         */
	        // Guaranteed that there will be at least one event in events, and all events must have the same pointer type
	        if (this.autoPreventDefault && events[0].isNormalized) {
	            var cancelable = originalEvent.cancelable || !('cancelable' in originalEvent);
	            if (cancelable) {
	                originalEvent.preventDefault();
	            }
	        }
	        var eventLen = events.length;
	        for (var i = 0; i < eventLen; i++) {
	            var event = events[i];
	            var interactionData = this.getInteractionDataForPointerId(event);
	            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
	            interactionEvent.data.originalEvent = originalEvent;
	            this.processInteractive(interactionEvent, this.lastObjectRendered, this.processPointerDown, true);
	            this.emit('pointerdown', interactionEvent);
	            if (event.pointerType === 'touch') {
	                this.emit('touchstart', interactionEvent);
	            }
	            // emit a mouse event for "pen" pointers, the way a browser would emit a fallback event
	            else if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	                var isRightButton = event.button === 2;
	                this.emit(isRightButton ? 'rightdown' : 'mousedown', this.eventData);
	            }
	        }
	    };
	    /**
	     * Processes the result of the pointer down check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */
	    InteractionManager.prototype.processPointerDown = function (interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;
	        var id = interactionEvent.data.identifier;
	        if (hit) {
	            if (!displayObject.trackedPointers[id]) {
	                displayObject.trackedPointers[id] = new InteractionTrackingData(id);
	            }
	            this.dispatchEvent(displayObject, 'pointerdown', interactionEvent);
	            if (data.pointerType === 'touch') {
	                this.dispatchEvent(displayObject, 'touchstart', interactionEvent);
	            }
	            else if (data.pointerType === 'mouse' || data.pointerType === 'pen') {
	                var isRightButton = data.button === 2;
	                if (isRightButton) {
	                    displayObject.trackedPointers[id].rightDown = true;
	                }
	                else {
	                    displayObject.trackedPointers[id].leftDown = true;
	                }
	                this.dispatchEvent(displayObject, isRightButton ? 'rightdown' : 'mousedown', interactionEvent);
	            }
	        }
	    };
	    /**
	     * Is called when the pointer button is released on the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being released
	     * @param {boolean} cancelled - true if the pointer is cancelled
	     * @param {Function} func - Function passed to {@link processInteractive}
	     */
	    InteractionManager.prototype.onPointerComplete = function (originalEvent, cancelled, func) {
	        var events = this.normalizeToPointerData(originalEvent);
	        var eventLen = events.length;
	        // if the event wasn't targeting our canvas, then consider it to be pointerupoutside
	        // in all cases (unless it was a pointercancel)
	        var eventAppend = originalEvent.target !== this.interactionDOMElement ? 'outside' : '';
	        for (var i = 0; i < eventLen; i++) {
	            var event = events[i];
	            var interactionData = this.getInteractionDataForPointerId(event);
	            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
	            interactionEvent.data.originalEvent = originalEvent;
	            // perform hit testing for events targeting our canvas or cancel events
	            this.processInteractive(interactionEvent, this.lastObjectRendered, func, cancelled || !eventAppend);
	            this.emit(cancelled ? 'pointercancel' : "pointerup" + eventAppend, interactionEvent);
	            if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	                var isRightButton = event.button === 2;
	                this.emit(isRightButton ? "rightup" + eventAppend : "mouseup" + eventAppend, interactionEvent);
	            }
	            else if (event.pointerType === 'touch') {
	                this.emit(cancelled ? 'touchcancel' : "touchend" + eventAppend, interactionEvent);
	                this.releaseInteractionDataForPointerId(event.pointerId);
	            }
	        }
	    };
	    /**
	     * Is called when the pointer button is cancelled
	     *
	     * @private
	     * @param {PointerEvent} event - The DOM event of a pointer button being released
	     */
	    InteractionManager.prototype.onPointerCancel = function (event) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && event.pointerType === 'touch')
	            { return; }
	        this.onPointerComplete(event, true, this.processPointerCancel);
	    };
	    /**
	     * Processes the result of the pointer cancel check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - The display object that was tested
	     */
	    InteractionManager.prototype.processPointerCancel = function (interactionEvent, displayObject) {
	        var data = interactionEvent.data;
	        var id = interactionEvent.data.identifier;
	        if (displayObject.trackedPointers[id] !== undefined) {
	            delete displayObject.trackedPointers[id];
	            this.dispatchEvent(displayObject, 'pointercancel', interactionEvent);
	            if (data.pointerType === 'touch') {
	                this.dispatchEvent(displayObject, 'touchcancel', interactionEvent);
	            }
	        }
	    };
	    /**
	     * Is called when the pointer button is released on the renderer element
	     *
	     * @private
	     * @param {PointerEvent} event - The DOM event of a pointer button being released
	     */
	    InteractionManager.prototype.onPointerUp = function (event) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && event.pointerType === 'touch')
	            { return; }
	        this.onPointerComplete(event, false, this.processPointerUp);
	    };
	    /**
	     * Processes the result of the pointer up check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */
	    InteractionManager.prototype.processPointerUp = function (interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;
	        var id = interactionEvent.data.identifier;
	        var trackingData = displayObject.trackedPointers[id];
	        var isTouch = data.pointerType === 'touch';
	        var isMouse = (data.pointerType === 'mouse' || data.pointerType === 'pen');
	        // need to track mouse down status in the mouse block so that we can emit
	        // event in a later block
	        var isMouseTap = false;
	        // Mouse only
	        if (isMouse) {
	            var isRightButton = data.button === 2;
	            var flags = InteractionTrackingData.FLAGS;
	            var test = isRightButton ? flags.RIGHT_DOWN : flags.LEFT_DOWN;
	            var isDown = trackingData !== undefined && (trackingData.flags & test);
	            if (hit) {
	                this.dispatchEvent(displayObject, isRightButton ? 'rightup' : 'mouseup', interactionEvent);
	                if (isDown) {
	                    this.dispatchEvent(displayObject, isRightButton ? 'rightclick' : 'click', interactionEvent);
	                    // because we can confirm that the mousedown happened on this object, flag for later emit of pointertap
	                    isMouseTap = true;
	                }
	            }
	            else if (isDown) {
	                this.dispatchEvent(displayObject, isRightButton ? 'rightupoutside' : 'mouseupoutside', interactionEvent);
	            }
	            // update the down state of the tracking data
	            if (trackingData) {
	                if (isRightButton) {
	                    trackingData.rightDown = false;
	                }
	                else {
	                    trackingData.leftDown = false;
	                }
	            }
	        }
	        // Pointers and Touches, and Mouse
	        if (hit) {
	            this.dispatchEvent(displayObject, 'pointerup', interactionEvent);
	            if (isTouch)
	                { this.dispatchEvent(displayObject, 'touchend', interactionEvent); }
	            if (trackingData) {
	                // emit pointertap if not a mouse, or if the mouse block decided it was a tap
	                if (!isMouse || isMouseTap) {
	                    this.dispatchEvent(displayObject, 'pointertap', interactionEvent);
	                }
	                if (isTouch) {
	                    this.dispatchEvent(displayObject, 'tap', interactionEvent);
	                    // touches are no longer over (if they ever were) when we get the touchend
	                    // so we should ensure that we don't keep pretending that they are
	                    trackingData.over = false;
	                }
	            }
	        }
	        else if (trackingData) {
	            this.dispatchEvent(displayObject, 'pointerupoutside', interactionEvent);
	            if (isTouch)
	                { this.dispatchEvent(displayObject, 'touchendoutside', interactionEvent); }
	        }
	        // Only remove the tracking data if there is no over/down state still associated with it
	        if (trackingData && trackingData.none) {
	            delete displayObject.trackedPointers[id];
	        }
	    };
	    /**
	     * Is called when the pointer moves across the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer moving
	     */
	    InteractionManager.prototype.onPointerMove = function (originalEvent) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch')
	            { return; }
	        var events = this.normalizeToPointerData(originalEvent);
	        if (events[0].pointerType === 'mouse' || events[0].pointerType === 'pen') {
	            this._didMove = true;
	            this.cursor = null;
	        }
	        var eventLen = events.length;
	        for (var i = 0; i < eventLen; i++) {
	            var event = events[i];
	            var interactionData = this.getInteractionDataForPointerId(event);
	            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
	            interactionEvent.data.originalEvent = originalEvent;
	            this.processInteractive(interactionEvent, this.lastObjectRendered, this.processPointerMove, true);
	            this.emit('pointermove', interactionEvent);
	            if (event.pointerType === 'touch')
	                { this.emit('touchmove', interactionEvent); }
	            if (event.pointerType === 'mouse' || event.pointerType === 'pen')
	                { this.emit('mousemove', interactionEvent); }
	        }
	        if (events[0].pointerType === 'mouse') {
	            this.setCursorMode(this.cursor);
	            // TODO BUG for parents interactive object (border order issue)
	        }
	    };
	    /**
	     * Processes the result of the pointer move check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */
	    InteractionManager.prototype.processPointerMove = function (interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;
	        var isTouch = data.pointerType === 'touch';
	        var isMouse = (data.pointerType === 'mouse' || data.pointerType === 'pen');
	        if (isMouse) {
	            this.processPointerOverOut(interactionEvent, displayObject, hit);
	        }
	        if (!this.moveWhenInside || hit) {
	            this.dispatchEvent(displayObject, 'pointermove', interactionEvent);
	            if (isTouch)
	                { this.dispatchEvent(displayObject, 'touchmove', interactionEvent); }
	            if (isMouse)
	                { this.dispatchEvent(displayObject, 'mousemove', interactionEvent); }
	        }
	    };
	    /**
	     * Is called when the pointer is moved out of the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer being moved out
	     */
	    InteractionManager.prototype.onPointerOut = function (originalEvent) {
	        // if we support touch events, then only use those for touch events, not pointer events
	        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch')
	            { return; }
	        var events = this.normalizeToPointerData(originalEvent);
	        // Only mouse and pointer can call onPointerOut, so events will always be length 1
	        var event = events[0];
	        if (event.pointerType === 'mouse') {
	            this.mouseOverRenderer = false;
	            this.setCursorMode(null);
	        }
	        var interactionData = this.getInteractionDataForPointerId(event);
	        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
	        interactionEvent.data.originalEvent = event;
	        this.processInteractive(interactionEvent, this.lastObjectRendered, this.processPointerOverOut, false);
	        this.emit('pointerout', interactionEvent);
	        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	            this.emit('mouseout', interactionEvent);
	        }
	        else {
	            // we can get touchleave events after touchend, so we want to make sure we don't
	            // introduce memory leaks
	            this.releaseInteractionDataForPointerId(interactionData.identifier);
	        }
	    };
	    /**
	     * Processes the result of the pointer over/out check and dispatches the event if need be
	     *
	     * @private
	     * @param {PIXI.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
	     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - The display object that was tested
	     * @param {boolean} hit - the result of the hit test on the display object
	     */
	    InteractionManager.prototype.processPointerOverOut = function (interactionEvent, displayObject, hit) {
	        var data = interactionEvent.data;
	        var id = interactionEvent.data.identifier;
	        var isMouse = (data.pointerType === 'mouse' || data.pointerType === 'pen');
	        var trackingData = displayObject.trackedPointers[id];
	        // if we just moused over the display object, then we need to track that state
	        if (hit && !trackingData) {
	            trackingData = displayObject.trackedPointers[id] = new InteractionTrackingData(id);
	        }
	        if (trackingData === undefined)
	            { return; }
	        if (hit && this.mouseOverRenderer) {
	            if (!trackingData.over) {
	                trackingData.over = true;
	                this.delayDispatchEvent(displayObject, 'pointerover', interactionEvent);
	                if (isMouse) {
	                    this.delayDispatchEvent(displayObject, 'mouseover', interactionEvent);
	                }
	            }
	            // only change the cursor if it has not already been changed (by something deeper in the
	            // display tree)
	            if (isMouse && this.cursor === null) {
	                this.cursor = displayObject.cursor;
	            }
	        }
	        else if (trackingData.over) {
	            trackingData.over = false;
	            this.dispatchEvent(displayObject, 'pointerout', this.eventData);
	            if (isMouse) {
	                this.dispatchEvent(displayObject, 'mouseout', interactionEvent);
	            }
	            // if there is no mouse down information for the pointer, then it is safe to delete
	            if (trackingData.none) {
	                delete displayObject.trackedPointers[id];
	            }
	        }
	    };
	    /**
	     * Is called when the pointer is moved into the renderer element
	     *
	     * @private
	     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being moved into the renderer view
	     */
	    InteractionManager.prototype.onPointerOver = function (originalEvent) {
	        var events = this.normalizeToPointerData(originalEvent);
	        // Only mouse and pointer can call onPointerOver, so events will always be length 1
	        var event = events[0];
	        var interactionData = this.getInteractionDataForPointerId(event);
	        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
	        interactionEvent.data.originalEvent = event;
	        if (event.pointerType === 'mouse') {
	            this.mouseOverRenderer = true;
	        }
	        this.emit('pointerover', interactionEvent);
	        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
	            this.emit('mouseover', interactionEvent);
	        }
	    };
	    /**
	     * Get InteractionData for a given pointerId. Store that data as well
	     *
	     * @private
	     * @param {PointerEvent} event - Normalized pointer event, output from normalizeToPointerData
	     * @return {PIXI.InteractionData} - Interaction data for the given pointer identifier
	     */
	    InteractionManager.prototype.getInteractionDataForPointerId = function (event) {
	        var pointerId = event.pointerId;
	        var interactionData;
	        if (pointerId === MOUSE_POINTER_ID || event.pointerType === 'mouse') {
	            interactionData = this.mouse;
	        }
	        else if (this.activeInteractionData[pointerId]) {
	            interactionData = this.activeInteractionData[pointerId];
	        }
	        else {
	            interactionData = this.interactionDataPool.pop() || new InteractionData();
	            interactionData.identifier = pointerId;
	            this.activeInteractionData[pointerId] = interactionData;
	        }
	        // copy properties from the event, so that we can make sure that touch/pointer specific
	        // data is available
	        interactionData.copyEvent(event);
	        return interactionData;
	    };
	    /**
	     * Return unused InteractionData to the pool, for a given pointerId
	     *
	     * @private
	     * @param {number} pointerId - Identifier from a pointer event
	     */
	    InteractionManager.prototype.releaseInteractionDataForPointerId = function (pointerId) {
	        var interactionData = this.activeInteractionData[pointerId];
	        if (interactionData) {
	            delete this.activeInteractionData[pointerId];
	            interactionData.reset();
	            this.interactionDataPool.push(interactionData);
	        }
	    };
	    /**
	     * Configure an InteractionEvent to wrap a DOM PointerEvent and InteractionData
	     *
	     * @private
	     * @param {PIXI.InteractionEvent} interactionEvent - The event to be configured
	     * @param {PointerEvent} pointerEvent - The DOM event that will be paired with the InteractionEvent
	     * @param {PIXI.InteractionData} interactionData - The InteractionData that will be paired
	     *        with the InteractionEvent
	     * @return {PIXI.InteractionEvent} the interaction event that was passed in
	     */
	    InteractionManager.prototype.configureInteractionEventForDOMEvent = function (interactionEvent, pointerEvent, interactionData) {
	        interactionEvent.data = interactionData;
	        this.mapPositionToPoint(interactionData.global, pointerEvent.clientX, pointerEvent.clientY);
	        // Not really sure why this is happening, but it's how a previous version handled things
	        if (pointerEvent.pointerType === 'touch') {
	            pointerEvent.globalX = interactionData.global.x;
	            pointerEvent.globalY = interactionData.global.y;
	        }
	        interactionData.originalEvent = pointerEvent;
	        interactionEvent.reset();
	        return interactionEvent;
	    };
	    /**
	     * Ensures that the original event object contains all data that a regular pointer event would have
	     *
	     * @private
	     * @param {TouchEvent|MouseEvent|PointerEvent} event - The original event data from a touch or mouse event
	     * @return {PointerEvent[]} An array containing a single normalized pointer event, in the case of a pointer
	     *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
	     */
	    InteractionManager.prototype.normalizeToPointerData = function (event) {
	        var normalizedEvents = [];
	        if (this.supportsTouchEvents && event instanceof TouchEvent) {
	            for (var i = 0, li = event.changedTouches.length; i < li; i++) {
	                var touch = event.changedTouches[i];
	                if (typeof touch.button === 'undefined')
	                    { touch.button = event.touches.length ? 1 : 0; }
	                if (typeof touch.buttons === 'undefined')
	                    { touch.buttons = event.touches.length ? 1 : 0; }
	                if (typeof touch.isPrimary === 'undefined') {
	                    touch.isPrimary = event.touches.length === 1 && event.type === 'touchstart';
	                }
	                if (typeof touch.width === 'undefined')
	                    { touch.width = touch.radiusX || 1; }
	                if (typeof touch.height === 'undefined')
	                    { touch.height = touch.radiusY || 1; }
	                if (typeof touch.tiltX === 'undefined')
	                    { touch.tiltX = 0; }
	                if (typeof touch.tiltY === 'undefined')
	                    { touch.tiltY = 0; }
	                if (typeof touch.pointerType === 'undefined')
	                    { touch.pointerType = 'touch'; }
	                if (typeof touch.pointerId === 'undefined')
	                    { touch.pointerId = touch.identifier || 0; }
	                if (typeof touch.pressure === 'undefined')
	                    { touch.pressure = touch.force || 0.5; }
	                if (typeof touch.twist === 'undefined')
	                    { touch.twist = 0; }
	                if (typeof touch.tangentialPressure === 'undefined')
	                    { touch.tangentialPressure = 0; }
	                // TODO: Remove these, as layerX/Y is not a standard, is deprecated, has uneven
	                // support, and the fill ins are not quite the same
	                // offsetX/Y might be okay, but is not the same as clientX/Y when the canvas's top
	                // left is not 0,0 on the page
	                if (typeof touch.layerX === 'undefined')
	                    { touch.layerX = touch.offsetX = touch.clientX; }
	                if (typeof touch.layerY === 'undefined')
	                    { touch.layerY = touch.offsetY = touch.clientY; }
	                // mark the touch as normalized, just so that we know we did it
	                touch.isNormalized = true;
	                normalizedEvents.push(touch);
	            }
	        }
	        // apparently PointerEvent subclasses MouseEvent, so yay
	        else if (event instanceof MouseEvent && (!this.supportsPointerEvents || !(event instanceof window.PointerEvent))) {
	            var tempEvent = event;
	            if (typeof tempEvent.isPrimary === 'undefined')
	                { tempEvent.isPrimary = true; }
	            if (typeof tempEvent.width === 'undefined')
	                { tempEvent.width = 1; }
	            if (typeof tempEvent.height === 'undefined')
	                { tempEvent.height = 1; }
	            if (typeof tempEvent.tiltX === 'undefined')
	                { tempEvent.tiltX = 0; }
	            if (typeof tempEvent.tiltY === 'undefined')
	                { tempEvent.tiltY = 0; }
	            if (typeof tempEvent.pointerType === 'undefined')
	                { tempEvent.pointerType = 'mouse'; }
	            if (typeof tempEvent.pointerId === 'undefined')
	                { tempEvent.pointerId = MOUSE_POINTER_ID; }
	            if (typeof tempEvent.pressure === 'undefined')
	                { tempEvent.pressure = 0.5; }
	            if (typeof tempEvent.twist === 'undefined')
	                { tempEvent.twist = 0; }
	            if (typeof tempEvent.tangentialPressure === 'undefined')
	                { tempEvent.tangentialPressure = 0; }
	            // mark the mouse event as normalized, just so that we know we did it
	            tempEvent.isNormalized = true;
	            normalizedEvents.push(tempEvent);
	        }
	        else {
	            normalizedEvents.push(event);
	        }
	        return normalizedEvents;
	    };
	    /**
	     * Destroys the interaction manager
	     *
	     */
	    InteractionManager.prototype.destroy = function () {
	        this.removeEvents();
	        this.removeTickerListener();
	        this.removeAllListeners();
	        this.renderer = null;
	        this.mouse = null;
	        this.eventData = null;
	        this.interactionDOMElement = null;
	        this.onPointerDown = null;
	        this.processPointerDown = null;
	        this.onPointerUp = null;
	        this.processPointerUp = null;
	        this.onPointerCancel = null;
	        this.processPointerCancel = null;
	        this.onPointerMove = null;
	        this.processPointerMove = null;
	        this.onPointerOut = null;
	        this.processPointerOverOut = null;
	        this.onPointerOver = null;
	        this.search = null;
	    };
	    return InteractionManager;
	}(eventemitter3));

	/*!
	 * @pixi/runner - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/runner is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */
	/**
	 * A Runner is a highly performant and simple alternative to signals. Best used in situations
	 * where events are dispatched to many objects at high frequency (say every frame!)
	 *
	 *
	 * like a signal..
	 * ```
	 * import { Runner } from '@pixi/runner';
	 *
	 * const myObject = {
	 *     loaded: new Runner('loaded')
	 * }
	 *
	 * const listener = {
	 *     loaded: function(){
	 *         // thin
	 *     }
	 * }
	 *
	 * myObject.update.add(listener);
	 *
	 * myObject.loaded.emit();
	 * ```
	 *
	 * Or for handling calling the same function on many items
	 * ```
	 * import { Runner } from '@pixi/runner';
	 *
	 * const myGame = {
	 *     update: new Runner('update')
	 * }
	 *
	 * const gameObject = {
	 *     update: function(time){
	 *         // update my gamey state
	 *     }
	 * }
	 *
	 * myGame.update.add(gameObject1);
	 *
	 * myGame.update.emit(time);
	 * ```
	 * @class
	 * @memberof PIXI
	 */
	var Runner = /** @class */ (function () {
	    /**
	     *  @param {string} name - the function name that will be executed on the listeners added to this Runner.
	     */
	    function Runner(name) {
	        this.items = [];
	        this._name = name;
	        this._aliasCount = 0;
	    }
	    /**
	     * Dispatch/Broadcast Runner to all listeners added to the queue.
	     * @param {...any} params - optional parameters to pass to each listener
	     * @return {PIXI.Runner}
	     */
	    Runner.prototype.emit = function (a0, a1, a2, a3, a4, a5, a6, a7) {
	        if (arguments.length > 8) {
	            throw new Error('max arguments reached');
	        }
	        var _a = this, name = _a.name, items = _a.items;
	        this._aliasCount++;
	        for (var i = 0, len = items.length; i < len; i++) {
	            items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
	        }
	        if (items === this.items) {
	            this._aliasCount--;
	        }
	        return this;
	    };
	    Runner.prototype.ensureNonAliasedItems = function () {
	        if (this._aliasCount > 0 && this.items.length > 1) {
	            this._aliasCount = 0;
	            this.items = this.items.slice(0);
	        }
	    };
	    /**
	     * Add a listener to the Runner
	     *
	     * Runners do not need to have scope or functions passed to them.
	     * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
	     * as the name provided to the Runner when it was created.
	     *
	     * Eg A listener passed to this Runner will require a 'complete' function.
	     *
	     * ```
	     * import { Runner } from '@pixi/runner';
	     *
	     * const complete = new Runner('complete');
	     * ```
	     *
	     * The scope used will be the object itself.
	     *
	     * @param {any} item - The object that will be listening.
	     * @return {PIXI.Runner}
	     */
	    Runner.prototype.add = function (item) {
	        if (item[this._name]) {
	            this.ensureNonAliasedItems();
	            this.remove(item);
	            this.items.push(item);
	        }
	        return this;
	    };
	    /**
	     * Remove a single listener from the dispatch queue.
	     * @param {any} item - The listenr that you would like to remove.
	     * @return {PIXI.Runner}
	     */
	    Runner.prototype.remove = function (item) {
	        var index = this.items.indexOf(item);
	        if (index !== -1) {
	            this.ensureNonAliasedItems();
	            this.items.splice(index, 1);
	        }
	        return this;
	    };
	    /**
	     * Check to see if the listener is already in the Runner
	     * @param {any} item - The listener that you would like to check.
	     */
	    Runner.prototype.contains = function (item) {
	        return this.items.indexOf(item) !== -1;
	    };
	    /**
	     * Remove all listeners from the Runner
	     * @return {PIXI.Runner}
	     */
	    Runner.prototype.removeAll = function () {
	        this.ensureNonAliasedItems();
	        this.items.length = 0;
	        return this;
	    };
	    /**
	     * Remove all references, don't use after this.
	     */
	    Runner.prototype.destroy = function () {
	        this.removeAll();
	        this.items = null;
	        this._name = null;
	    };
	    Object.defineProperty(Runner.prototype, "empty", {
	        /**
	         * `true` if there are no this Runner contains no listeners
	         *
	         * @member {boolean}
	         * @readonly
	         */
	        get: function () {
	            return this.items.length === 0;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Runner.prototype, "name", {
	        /**
	         * The name of the runner.
	         *
	         * @member {string}
	         * @readonly
	         */
	        get: function () {
	            return this._name;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Runner;
	}());
	Object.defineProperties(Runner.prototype, {
	    /**
	     * Alias for `emit`
	     * @memberof PIXI.Runner#
	     * @method dispatch
	     * @see PIXI.Runner#emit
	     */
	    dispatch: { value: Runner.prototype.emit },
	    /**
	     * Alias for `emit`
	     * @memberof PIXI.Runner#
	     * @method run
	     * @see PIXI.Runner#emit
	     */
	    run: { value: Runner.prototype.emit },
	});

	/*!
	 * @pixi/core - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/core is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * The maximum support for using WebGL. If a device does not
	 * support WebGL version, for instance WebGL 2, it will still
	 * attempt to fallback support to WebGL 1. If you want to
	 * explicitly remove feature support to target a more stable
	 * baseline, prefer a lower environment.
	 *
	 * Due to {@link https://bugs.chromium.org/p/chromium/issues/detail?id=934823|bug in chromium}
	 * we disable webgl2 by default for all non-apple mobile devices.
	 *
	 * @static
	 * @name PREFER_ENV
	 * @memberof PIXI.settings
	 * @type {number}
	 * @default PIXI.ENV.WEBGL2
	 */
	settings.PREFER_ENV = isMobile$1.any ? exports.ENV.WEBGL : exports.ENV.WEBGL2;
	/**
	 * If set to `true`, *only* Textures and BaseTexture objects stored
	 * in the caches ({@link PIXI.utils.TextureCache TextureCache} and
	 * {@link PIXI.utils.BaseTextureCache BaseTextureCache}) can be
	 * used when calling {@link PIXI.Texture.from Texture.from} or
	 * {@link PIXI.BaseTexture.from BaseTexture.from}.
	 * Otherwise, these `from` calls throw an exception. Using this property
	 * can be useful if you want to enforce preloading all assets with
	 * {@link PIXI.Loader Loader}.
	 *
	 * @static
	 * @name STRICT_TEXTURE_CACHE
	 * @memberof PIXI.settings
	 * @type {boolean}
	 * @default false
	 */
	settings.STRICT_TEXTURE_CACHE = false;

	/**
	 * Collection of installed resource types, class must extend {@link PIXI.resources.Resource}.
	 * @example
	 * class CustomResource extends PIXI.resources.Resource {
	 *   // MUST have source, options constructor signature
	 *   // for auto-detected resources to be created.
	 *   constructor(source, options) {
	 *     super();
	 *   }
	 *   upload(renderer, baseTexture, glTexture) {
	 *     // upload with GL
	 *     return true;
	 *   }
	 *   // used to auto-detect resource
	 *   static test(source, extension) {
	 *     return extension === 'xyz'|| source instanceof SomeClass;
	 *   }
	 * }
	 * // Install the new resource type
	 * PIXI.resources.INSTALLED.push(CustomResource);
	 *
	 * @name PIXI.resources.INSTALLED
	 * @type {Array<*>}
	 * @static
	 * @readonly
	 */
	var INSTALLED = [];
	/**
	 * Create a resource element from a single source element. This
	 * auto-detects which type of resource to create. All resources that
	 * are auto-detectable must have a static `test` method and a constructor
	 * with the arguments `(source, options?)`. Currently, the supported
	 * resources for auto-detection include:
	 *  - {@link PIXI.resources.ImageResource}
	 *  - {@link PIXI.resources.CanvasResource}
	 *  - {@link PIXI.resources.VideoResource}
	 *  - {@link PIXI.resources.SVGResource}
	 *  - {@link PIXI.resources.BufferResource}
	 * @static
	 * @function PIXI.resources.autoDetectResource
	 * @param {string|*} source - Resource source, this can be the URL to the resource,
	 *        a typed-array (for BufferResource), HTMLVideoElement, SVG data-uri
	 *        or any other resource that can be auto-detected. If not resource is
	 *        detected, it's assumed to be an ImageResource.
	 * @param {object} [options] - Pass-through options to use for Resource
	 * @param {number} [options.width] - Width of BufferResource or SVG rasterization
	 * @param {number} [options.height] - Height of BufferResource or SVG rasterization
	 * @param {boolean} [options.autoLoad=true] - Image, SVG and Video flag to start loading
	 * @param {number} [options.scale=1] - SVG source scale. Overridden by width, height
	 * @param {boolean} [options.createBitmap=PIXI.settings.CREATE_IMAGE_BITMAP] - Image option to create Bitmap object
	 * @param {boolean} [options.crossorigin=true] - Image and Video option to set crossOrigin
	 * @param {boolean} [options.autoPlay=true] - Video option to start playing video immediately
	 * @param {number} [options.updateFPS=0] - Video option to update how many times a second the
	 *        texture should be updated from the video. Leave at 0 to update at every render
	 * @return {PIXI.resources.Resource} The created resource.
	 */
	function autoDetectResource(source, options) {
	    if (!source) {
	        return null;
	    }
	    var extension = '';
	    if (typeof source === 'string') {
	        // search for file extension: period, 3-4 chars, then ?, # or EOL
	        var result = (/\.(\w{3,4})(?:$|\?|#)/i).exec(source);
	        if (result) {
	            extension = result[1].toLowerCase();
	        }
	    }
	    for (var i = INSTALLED.length - 1; i >= 0; --i) {
	        var ResourcePlugin = INSTALLED[i];
	        if (ResourcePlugin.test && ResourcePlugin.test(source, extension)) {
	            return new ResourcePlugin(source, options);
	        }
	    }
	    throw new Error('Unrecognized source type to auto-detect Resource');
	}

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$2 = function(d, b) {
	    extendStatics$2 = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$2(d, b);
	};

	function __extends$2(d, b) {
	    extendStatics$2(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	/**
	 * Base resource class for textures that manages validation and uploading, depending on its type.
	 *
	 * Uploading of a base texture to the GPU is required.
	 *
	 * @class
	 * @memberof PIXI.resources
	 */
	var Resource = /** @class */ (function () {
	    /**
	     * @param {number} [width=0] - Width of the resource
	     * @param {number} [height=0] - Height of the resource
	     */
	    function Resource(width, height) {
	        if (width === void 0) { width = 0; }
	        if (height === void 0) { height = 0; }
	        /**
	         * Internal width of the resource
	         * @member {number}
	         * @protected
	         */
	        this._width = width;
	        /**
	         * Internal height of the resource
	         * @member {number}
	         * @protected
	         */
	        this._height = height;
	        /**
	         * If resource has been destroyed
	         * @member {boolean}
	         * @readonly
	         * @default false
	         */
	        this.destroyed = false;
	        /**
	         * `true` if resource is created by BaseTexture
	         * useful for doing cleanup with BaseTexture destroy
	         * and not cleaning up resources that were created
	         * externally.
	         * @member {boolean}
	         * @protected
	         */
	        this.internal = false;
	        /**
	         * Mini-runner for handling resize events
	         * accepts 2 parameters: width, height
	         *
	         * @member {Runner}
	         * @private
	         */
	        this.onResize = new Runner('setRealSize');
	        /**
	         * Mini-runner for handling update events
	         *
	         * @member {Runner}
	         * @private
	         */
	        this.onUpdate = new Runner('update');
	        /**
	         * Handle internal errors, such as loading errors
	         * accepts 1 param: error
	         *
	         * @member {Runner}
	         * @private
	         */
	        this.onError = new Runner('onError');
	    }
	    /**
	     * Bind to a parent BaseTexture
	     *
	     * @param {PIXI.BaseTexture} baseTexture - Parent texture
	     */
	    Resource.prototype.bind = function (baseTexture) {
	        this.onResize.add(baseTexture);
	        this.onUpdate.add(baseTexture);
	        this.onError.add(baseTexture);
	        // Call a resize immediate if we already
	        // have the width and height of the resource
	        if (this._width || this._height) {
	            this.onResize.emit(this._width, this._height);
	        }
	    };
	    /**
	     * Unbind to a parent BaseTexture
	     *
	     * @param {PIXI.BaseTexture} baseTexture - Parent texture
	     */
	    Resource.prototype.unbind = function (baseTexture) {
	        this.onResize.remove(baseTexture);
	        this.onUpdate.remove(baseTexture);
	        this.onError.remove(baseTexture);
	    };
	    /**
	     * Trigger a resize event
	     * @param {number} width - X dimension
	     * @param {number} height - Y dimension
	     */
	    Resource.prototype.resize = function (width, height) {
	        if (width !== this._width || height !== this._height) {
	            this._width = width;
	            this._height = height;
	            this.onResize.emit(width, height);
	        }
	    };
	    Object.defineProperty(Resource.prototype, "valid", {
	        /**
	         * Has been validated
	         * @readonly
	         * @member {boolean}
	         */
	        get: function () {
	            return !!this._width && !!this._height;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Has been updated trigger event
	     */
	    Resource.prototype.update = function () {
	        if (!this.destroyed) {
	            this.onUpdate.emit();
	        }
	    };
	    /**
	     * This can be overridden to start preloading a resource
	     * or do any other prepare step.
	     * @protected
	     * @return {Promise<void>} Handle the validate event
	     */
	    Resource.prototype.load = function () {
	        return Promise.resolve(this);
	    };
	    Object.defineProperty(Resource.prototype, "width", {
	        /**
	         * The width of the resource.
	         *
	         * @member {number}
	         * @readonly
	         */
	        get: function () {
	            return this._width;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Resource.prototype, "height", {
	        /**
	         * The height of the resource.
	         *
	         * @member {number}
	         * @readonly
	         */
	        get: function () {
	            return this._height;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Set the style, optional to override
	     *
	     * @param {PIXI.Renderer} renderer - yeah, renderer!
	     * @param {PIXI.BaseTexture} baseTexture - the texture
	     * @param {PIXI.GLTexture} glTexture - texture instance for this webgl context
	     * @returns {boolean} `true` is success
	     */
	    Resource.prototype.style = function (_renderer, _baseTexture, _glTexture) {
	        return false;
	    };
	    /**
	     * Clean up anything, this happens when destroying is ready.
	     *
	     * @protected
	     */
	    Resource.prototype.dispose = function () {
	        // override
	    };
	    /**
	     * Call when destroying resource, unbind any BaseTexture object
	     * before calling this method, as reference counts are maintained
	     * internally.
	     */
	    Resource.prototype.destroy = function () {
	        if (!this.destroyed) {
	            this.destroyed = true;
	            this.dispose();
	            this.onError.removeAll();
	            this.onError = null;
	            this.onResize.removeAll();
	            this.onResize = null;
	            this.onUpdate.removeAll();
	            this.onUpdate = null;
	        }
	    };
	    /**
	     * Abstract, used to auto-detect resource type
	     *
	     * @static
	     * @param {*} source - The source object
	     * @param {string} extension - The extension of source, if set
	     */
	    Resource.test = function (_source, _extension) {
	        return false;
	    };
	    return Resource;
	}());

	/**
	 * @interface SharedArrayBuffer
	 */
	/**
	 * Buffer resource with data of typed array.
	 * @class
	 * @extends PIXI.resources.Resource
	 * @memberof PIXI.resources
	 */
	var BufferResource = /** @class */ (function (_super) {
	    __extends$2(BufferResource, _super);
	    /**
	     * @param {Float32Array|Uint8Array|Uint32Array} source - Source buffer
	     * @param {object} options - Options
	     * @param {number} options.width - Width of the texture
	     * @param {number} options.height - Height of the texture
	     */
	    function BufferResource(source, options) {
	        var _this = this;
	        var _a = options || {}, width = _a.width, height = _a.height;
	        if (!width || !height) {
	            throw new Error('BufferResource width or height invalid');
	        }
	        _this = _super.call(this, width, height) || this;
	        /**
	         * Source array
	         * Cannot be ClampedUint8Array because it cant be uploaded to WebGL
	         *
	         * @member {Float32Array|Uint8Array|Uint32Array}
	         */
	        _this.data = source;
	        return _this;
	    }
	    /**
	     * Upload the texture to the GPU.
	     * @param {PIXI.Renderer} renderer - Upload to the renderer
	     * @param {PIXI.BaseTexture} baseTexture - Reference to parent texture
	     * @param {PIXI.GLTexture} glTexture - glTexture
	     * @returns {boolean} true is success
	     */
	    BufferResource.prototype.upload = function (renderer, baseTexture, glTexture) {
	        var gl = renderer.gl;
	        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === exports.ALPHA_MODES.UNPACK);
	        if (glTexture.width === baseTexture.width && glTexture.height === baseTexture.height) {
	            gl.texSubImage2D(baseTexture.target, 0, 0, 0, baseTexture.width, baseTexture.height, baseTexture.format, baseTexture.type, this.data);
	        }
	        else {
	            glTexture.width = baseTexture.width;
	            glTexture.height = baseTexture.height;
	            gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, baseTexture.width, baseTexture.height, 0, baseTexture.format, glTexture.type, this.data);
	        }
	        return true;
	    };
	    /**
	     * Destroy and don't use after this
	     * @override
	     */
	    BufferResource.prototype.dispose = function () {
	        this.data = null;
	    };
	    /**
	     * Used to auto-detect the type of resource.
	     *
	     * @static
	     * @param {*} source - The source object
	     * @return {boolean} `true` if <canvas>
	     */
	    BufferResource.test = function (source) {
	        return source instanceof Float32Array
	            || source instanceof Uint8Array
	            || source instanceof Uint32Array;
	    };
	    return BufferResource;
	}(Resource));

	var defaultBufferOptions = {
	    scaleMode: exports.SCALE_MODES.NEAREST,
	    format: exports.FORMATS.RGBA,
	    alphaMode: exports.ALPHA_MODES.NPM,
	};
	/**
	 * A Texture stores the information that represents an image.
	 * All textures have a base texture, which contains information about the source.
	 * Therefore you can have many textures all using a single BaseTexture
	 *
	 * @class
	 * @extends PIXI.utils.EventEmitter
	 * @memberof PIXI
	 * @param {PIXI.resources.Resource|string|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} [resource=null]
	 *        The current resource to use, for things that aren't Resource objects, will be converted
	 *        into a Resource.
	 * @param {Object} [options] - Collection of options
	 * @param {PIXI.MIPMAP_MODES} [options.mipmap=PIXI.settings.MIPMAP_TEXTURES] - If mipmapping is enabled for texture
	 * @param {number} [options.anisotropicLevel=PIXI.settings.ANISOTROPIC_LEVEL] - Anisotropic filtering level of texture
	 * @param {PIXI.WRAP_MODES} [options.wrapMode=PIXI.settings.WRAP_MODE] - Wrap mode for textures
	 * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.settings.SCALE_MODE] - Default scale mode, linear, nearest
	 * @param {PIXI.FORMATS} [options.format=PIXI.FORMATS.RGBA] - GL format type
	 * @param {PIXI.TYPES} [options.type=PIXI.TYPES.UNSIGNED_BYTE] - GL data type
	 * @param {PIXI.TARGETS} [options.target=PIXI.TARGETS.TEXTURE_2D] - GL texture target
	 * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.UNPACK] - Pre multiply the image alpha
	 * @param {number} [options.width=0] - Width of the texture
	 * @param {number} [options.height=0] - Height of the texture
	 * @param {number} [options.resolution] - Resolution of the base texture
	 * @param {object} [options.resourceOptions] - Optional resource options,
	 *        see {@link PIXI.resources.autoDetectResource autoDetectResource}
	 */
	var BaseTexture = /** @class */ (function (_super) {
	    __extends$2(BaseTexture, _super);
	    function BaseTexture(resource, options) {
	        if (resource === void 0) { resource = null; }
	        if (options === void 0) { options = null; }
	        var _this = _super.call(this) || this;
	        options = options || {};
	        var alphaMode = options.alphaMode, mipmap = options.mipmap, anisotropicLevel = options.anisotropicLevel, scaleMode = options.scaleMode, width = options.width, height = options.height, wrapMode = options.wrapMode, format = options.format, type = options.type, target = options.target, resolution = options.resolution, resourceOptions = options.resourceOptions;
	        // Convert the resource to a Resource object
	        if (resource && !(resource instanceof Resource)) {
	            resource = autoDetectResource(resource, resourceOptions);
	            resource.internal = true;
	        }
	        /**
	         * The width of the base texture set when the image has loaded
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.width = width || 0;
	        /**
	         * The height of the base texture set when the image has loaded
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.height = height || 0;
	        /**
	         * The resolution / device pixel ratio of the texture
	         *
	         * @member {number}
	         * @default PIXI.settings.RESOLUTION
	         */
	        _this.resolution = resolution || settings.RESOLUTION;
	        /**
	         * Mipmap mode of the texture, affects downscaled images
	         *
	         * @member {PIXI.MIPMAP_MODES}
	         * @default PIXI.settings.MIPMAP_TEXTURES
	         */
	        _this.mipmap = mipmap !== undefined ? mipmap : settings.MIPMAP_TEXTURES;
	        /**
	         * Anisotropic filtering level of texture
	         *
	         * @member {number}
	         * @default PIXI.settings.ANISOTROPIC_LEVEL
	         */
	        _this.anisotropicLevel = anisotropicLevel !== undefined ? anisotropicLevel : settings.ANISOTROPIC_LEVEL;
	        /**
	         * How the texture wraps
	         * @member {number}
	         */
	        _this.wrapMode = wrapMode || settings.WRAP_MODE;
	        /**
	         * The scale mode to apply when scaling this texture
	         *
	         * @member {PIXI.SCALE_MODES}
	         * @default PIXI.settings.SCALE_MODE
	         */
	        _this.scaleMode = scaleMode !== undefined ? scaleMode : settings.SCALE_MODE;
	        /**
	         * The pixel format of the texture
	         *
	         * @member {PIXI.FORMATS}
	         * @default PIXI.FORMATS.RGBA
	         */
	        _this.format = format || exports.FORMATS.RGBA;
	        /**
	         * The type of resource data
	         *
	         * @member {PIXI.TYPES}
	         * @default PIXI.TYPES.UNSIGNED_BYTE
	         */
	        _this.type = type || exports.TYPES.UNSIGNED_BYTE;
	        /**
	         * The target type
	         *
	         * @member {PIXI.TARGETS}
	         * @default PIXI.TARGETS.TEXTURE_2D
	         */
	        _this.target = target || exports.TARGETS.TEXTURE_2D;
	        /**
	         * How to treat premultiplied alpha, see {@link PIXI.ALPHA_MODES}.
	         *
	         * @member {PIXI.ALPHA_MODES}
	         * @default PIXI.ALPHA_MODES.UNPACK
	         */
	        _this.alphaMode = alphaMode !== undefined ? alphaMode : exports.ALPHA_MODES.UNPACK;
	        if (options.premultiplyAlpha !== undefined) {
	            // triggers deprecation
	            _this.premultiplyAlpha = options.premultiplyAlpha;
	        }
	        /**
	         * Global unique identifier for this BaseTexture
	         *
	         * @member {number}
	         * @protected
	         */
	        _this.uid = uid();
	        /**
	         * Used by automatic texture Garbage Collection, stores last GC tick when it was bound
	         *
	         * @member {number}
	         * @protected
	         */
	        _this.touched = 0;
	        /**
	         * Whether or not the texture is a power of two, try to use power of two textures as much
	         * as you can
	         *
	         * @readonly
	         * @member {boolean}
	         * @default false
	         */
	        _this.isPowerOfTwo = false;
	        _this._refreshPOT();
	        /**
	         * The map of render context textures where this is bound
	         *
	         * @member {Object}
	         * @private
	         */
	        _this._glTextures = {};
	        /**
	         * Used by TextureSystem to only update texture to the GPU when needed.
	         * Please call `update()` to increment it.
	         *
	         * @readonly
	         * @member {number}
	         */
	        _this.dirtyId = 0;
	        /**
	         * Used by TextureSystem to only update texture style when needed.
	         *
	         * @protected
	         * @member {number}
	         */
	        _this.dirtyStyleId = 0;
	        /**
	         * Currently default cache ID.
	         *
	         * @member {string}
	         */
	        _this.cacheId = null;
	        /**
	         * Generally speaking means when resource is loaded.
	         * @readonly
	         * @member {boolean}
	         */
	        _this.valid = width > 0 && height > 0;
	        /**
	         * The collection of alternative cache ids, since some BaseTextures
	         * can have more than one ID, short name and longer full URL
	         *
	         * @member {Array<string>}
	         * @readonly
	         */
	        _this.textureCacheIds = [];
	        /**
	         * Flag if BaseTexture has been destroyed.
	         *
	         * @member {boolean}
	         * @readonly
	         */
	        _this.destroyed = false;
	        /**
	         * The resource used by this BaseTexture, there can only
	         * be one resource per BaseTexture, but textures can share
	         * resources.
	         *
	         * @member {PIXI.resources.Resource}
	         * @readonly
	         */
	        _this.resource = null;
	        /**
	         * Number of the texture batch, used by multi-texture renderers
	         *
	         * @member {number}
	         */
	        _this._batchEnabled = 0;
	        /**
	         * Location inside texture batch, used by multi-texture renderers
	         *
	         * @member {number}
	         */
	        _this._batchLocation = 0;
	        /**
	         * Whether its a part of another texture, handled by ArrayResource or CubeResource
	         *
	         * @member {PIXI.BaseTexture}
	         */
	        _this.parentTextureArray = null;
	        /**
	         * Fired when a not-immediately-available source finishes loading.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#loaded
	         * @param {PIXI.BaseTexture} baseTexture - Resource loaded.
	         */
	        /**
	         * Fired when a not-immediately-available source fails to load.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#error
	         * @param {PIXI.BaseTexture} baseTexture - Resource errored.
	         * @param {ErrorEvent} event - Load error event.
	         */
	        /**
	         * Fired when BaseTexture is updated.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#loaded
	         * @param {PIXI.BaseTexture} baseTexture - Resource loaded.
	         */
	        /**
	         * Fired when BaseTexture is updated.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#update
	         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being updated.
	         */
	        /**
	         * Fired when BaseTexture is destroyed.
	         *
	         * @protected
	         * @event PIXI.BaseTexture#dispose
	         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being destroyed.
	         */
	        // Set the resource
	        _this.setResource(resource);
	        return _this;
	    }
	    Object.defineProperty(BaseTexture.prototype, "realWidth", {
	        /**
	         * Pixel width of the source of this texture
	         *
	         * @readonly
	         * @member {number}
	         */
	        get: function () {
	            return Math.ceil((this.width * this.resolution) - 1e-4);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BaseTexture.prototype, "realHeight", {
	        /**
	         * Pixel height of the source of this texture
	         *
	         * @readonly
	         * @member {number}
	         */
	        get: function () {
	            return Math.ceil((this.height * this.resolution) - 1e-4);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Changes style options of BaseTexture
	     *
	     * @param {PIXI.SCALE_MODES} [scaleMode] - Pixi scalemode
	     * @param {PIXI.MIPMAP_MODES} [mipmap] - enable mipmaps
	     * @returns {PIXI.BaseTexture} this
	     */
	    BaseTexture.prototype.setStyle = function (scaleMode, mipmap) {
	        var dirty;
	        if (scaleMode !== undefined && scaleMode !== this.scaleMode) {
	            this.scaleMode = scaleMode;
	            dirty = true;
	        }
	        if (mipmap !== undefined && mipmap !== this.mipmap) {
	            this.mipmap = mipmap;
	            dirty = true;
	        }
	        if (dirty) {
	            this.dirtyStyleId++;
	        }
	        return this;
	    };
	    /**
	     * Changes w/h/resolution. Texture becomes valid if width and height are greater than zero.
	     *
	     * @param {number} width - Visual width
	     * @param {number} height - Visual height
	     * @param {number} [resolution] - Optionally set resolution
	     * @returns {PIXI.BaseTexture} this
	     */
	    BaseTexture.prototype.setSize = function (width, height, resolution) {
	        this.resolution = resolution || this.resolution;
	        this.width = width;
	        this.height = height;
	        this._refreshPOT();
	        this.update();
	        return this;
	    };
	    /**
	     * Sets real size of baseTexture, preserves current resolution.
	     *
	     * @param {number} realWidth - Full rendered width
	     * @param {number} realHeight - Full rendered height
	     * @param {number} [resolution] - Optionally set resolution
	     * @returns {PIXI.BaseTexture} this
	     */
	    BaseTexture.prototype.setRealSize = function (realWidth, realHeight, resolution) {
	        this.resolution = resolution || this.resolution;
	        this.width = realWidth / this.resolution;
	        this.height = realHeight / this.resolution;
	        this._refreshPOT();
	        this.update();
	        return this;
	    };
	    /**
	     * Refresh check for isPowerOfTwo texture based on size
	     *
	     * @private
	     */
	    BaseTexture.prototype._refreshPOT = function () {
	        this.isPowerOfTwo = isPow2(this.realWidth) && isPow2(this.realHeight);
	    };
	    /**
	     * Changes resolution
	     *
	     * @param {number} resolution - res
	     * @returns {PIXI.BaseTexture} this
	     */
	    BaseTexture.prototype.setResolution = function (resolution) {
	        var oldResolution = this.resolution;
	        if (oldResolution === resolution) {
	            return this;
	        }
	        this.resolution = resolution;
	        if (this.valid) {
	            this.width = this.width * oldResolution / resolution;
	            this.height = this.height * oldResolution / resolution;
	            this.emit('update', this);
	        }
	        this._refreshPOT();
	        return this;
	    };
	    /**
	     * Sets the resource if it wasn't set. Throws error if resource already present
	     *
	     * @param {PIXI.resources.Resource} resource - that is managing this BaseTexture
	     * @returns {PIXI.BaseTexture} this
	     */
	    BaseTexture.prototype.setResource = function (resource) {
	        if (this.resource === resource) {
	            return this;
	        }
	        if (this.resource) {
	            throw new Error('Resource can be set only once');
	        }
	        resource.bind(this);
	        this.resource = resource;
	        return this;
	    };
	    /**
	     * Invalidates the object. Texture becomes valid if width and height are greater than zero.
	     */
	    BaseTexture.prototype.update = function () {
	        if (!this.valid) {
	            if (this.width > 0 && this.height > 0) {
	                this.valid = true;
	                this.emit('loaded', this);
	                this.emit('update', this);
	            }
	        }
	        else {
	            this.dirtyId++;
	            this.dirtyStyleId++;
	            this.emit('update', this);
	        }
	    };
	    /**
	     * Handle errors with resources.
	     * @private
	     * @param {ErrorEvent} event - Error event emitted.
	     */
	    BaseTexture.prototype.onError = function (event) {
	        this.emit('error', this, event);
	    };
	    /**
	     * Destroys this base texture.
	     * The method stops if resource doesn't want this texture to be destroyed.
	     * Removes texture from all caches.
	     */
	    BaseTexture.prototype.destroy = function () {
	        // remove and destroy the resource
	        if (this.resource) {
	            this.resource.unbind(this);
	            // only destroy resourced created internally
	            if (this.resource.internal) {
	                this.resource.destroy();
	            }
	            this.resource = null;
	        }
	        if (this.cacheId) {
	            delete BaseTextureCache[this.cacheId];
	            delete TextureCache[this.cacheId];
	            this.cacheId = null;
	        }
	        // finally let the WebGL renderer know..
	        this.dispose();
	        BaseTexture.removeFromCache(this);
	        this.textureCacheIds = null;
	        this.destroyed = true;
	    };
	    /**
	     * Frees the texture from WebGL memory without destroying this texture object.
	     * This means you can still use the texture later which will upload it to GPU
	     * memory again.
	     *
	     * @fires PIXI.BaseTexture#dispose
	     */
	    BaseTexture.prototype.dispose = function () {
	        this.emit('dispose', this);
	    };
	    /**
	     * Utility function for BaseTexture|Texture cast
	     */
	    BaseTexture.prototype.castToBaseTexture = function () {
	        return this;
	    };
	    /**
	     * Helper function that creates a base texture based on the source you provide.
	     * The source can be - image url, image element, canvas element. If the
	     * source is an image url or an image element and not in the base texture
	     * cache, it will be created and loaded.
	     *
	     * @static
	     * @param {string|HTMLImageElement|HTMLCanvasElement|SVGElement|HTMLVideoElement} source - The
	     *        source to create base texture from.
	     * @param {object} [options] See {@link PIXI.BaseTexture}'s constructor for options.
	     * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
	     * @returns {PIXI.BaseTexture} The new base texture.
	     */
	    BaseTexture.from = function (source, options, strict) {
	        if (strict === void 0) { strict = settings.STRICT_TEXTURE_CACHE; }
	        var isFrame = typeof source === 'string';
	        var cacheId = null;
	        if (isFrame) {
	            cacheId = source;
	        }
	        else {
	            if (!source._pixiId) {
	                source._pixiId = "pixiid_" + uid();
	            }
	            cacheId = source._pixiId;
	        }
	        var baseTexture = BaseTextureCache[cacheId];
	        // Strict-mode rejects invalid cacheIds
	        if (isFrame && strict && !baseTexture) {
	            throw new Error("The cacheId \"" + cacheId + "\" does not exist in BaseTextureCache.");
	        }
	        if (!baseTexture) {
	            baseTexture = new BaseTexture(source, options);
	            baseTexture.cacheId = cacheId;
	            BaseTexture.addToCache(baseTexture, cacheId);
	        }
	        return baseTexture;
	    };
	    /**
	     * Create a new BaseTexture with a BufferResource from a Float32Array.
	     * RGBA values are floats from 0 to 1.
	     * @static
	     * @param {Float32Array|Uint8Array} buffer - The optional array to use, if no data
	     *        is provided, a new Float32Array is created.
	     * @param {number} width - Width of the resource
	     * @param {number} height - Height of the resource
	     * @param {object} [options] See {@link PIXI.BaseTexture}'s constructor for options.
	     * @return {PIXI.BaseTexture} The resulting new BaseTexture
	     */
	    BaseTexture.fromBuffer = function (buffer, width, height, options) {
	        buffer = buffer || new Float32Array(width * height * 4);
	        var resource = new BufferResource(buffer, { width: width, height: height });
	        var type = buffer instanceof Float32Array ? exports.TYPES.FLOAT : exports.TYPES.UNSIGNED_BYTE;
	        return new BaseTexture(resource, Object.assign(defaultBufferOptions, options || { width: width, height: height, type: type }));
	    };
	    /**
	     * Adds a BaseTexture to the global BaseTextureCache. This cache is shared across the whole PIXI object.
	     *
	     * @static
	     * @param {PIXI.BaseTexture} baseTexture - The BaseTexture to add to the cache.
	     * @param {string} id - The id that the BaseTexture will be stored against.
	     */
	    BaseTexture.addToCache = function (baseTexture, id) {
	        if (id) {
	            if (baseTexture.textureCacheIds.indexOf(id) === -1) {
	                baseTexture.textureCacheIds.push(id);
	            }
	            if (BaseTextureCache[id]) {
	                // eslint-disable-next-line no-console
	                console.warn("BaseTexture added to the cache with an id [" + id + "] that already had an entry");
	            }
	            BaseTextureCache[id] = baseTexture;
	        }
	    };
	    /**
	     * Remove a BaseTexture from the global BaseTextureCache.
	     *
	     * @static
	     * @param {string|PIXI.BaseTexture} baseTexture - id of a BaseTexture to be removed, or a BaseTexture instance itself.
	     * @return {PIXI.BaseTexture|null} The BaseTexture that was removed.
	     */
	    BaseTexture.removeFromCache = function (baseTexture) {
	        if (typeof baseTexture === 'string') {
	            var baseTextureFromCache = BaseTextureCache[baseTexture];
	            if (baseTextureFromCache) {
	                var index = baseTextureFromCache.textureCacheIds.indexOf(baseTexture);
	                if (index > -1) {
	                    baseTextureFromCache.textureCacheIds.splice(index, 1);
	                }
	                delete BaseTextureCache[baseTexture];
	                return baseTextureFromCache;
	            }
	        }
	        else if (baseTexture && baseTexture.textureCacheIds) {
	            for (var i = 0; i < baseTexture.textureCacheIds.length; ++i) {
	                delete BaseTextureCache[baseTexture.textureCacheIds[i]];
	            }
	            baseTexture.textureCacheIds.length = 0;
	            return baseTexture;
	        }
	        return null;
	    };
	    /**
	     * Global number of the texture batch, used by multi-texture renderers
	     *
	     * @static
	     * @member {number}
	     */
	    BaseTexture._globalBatch = 0;
	    return BaseTexture;
	}(eventemitter3));

	/**
	 * Resource that can manage several resource (items) inside.
	 * All resources need to have the same pixel size.
	 * Parent class for CubeResource and ArrayResource
	 *
	 * @class
	 * @extends PIXI.resources.Resource
	 * @memberof PIXI.resources
	 * @param {object} [options] Options to for Resource constructor
	 * @param {number} [options.width] - Width of the resource
	 * @param {number} [options.height] - Height of the resource
	 */
	var AbstractMultiResource = /** @class */ (function (_super) {
	    __extends$2(AbstractMultiResource, _super);
	    function AbstractMultiResource(length, options) {
	        var _this = this;
	        var _a = options || {}, width = _a.width, height = _a.height;
	        _this = _super.call(this, width, height) || this;
	        /**
	         * Collection of partial baseTextures that correspond to resources
	         * @member {Array<PIXI.BaseTexture>}
	         * @readonly
	         */
	        _this.items = [];
	        /**
	         * Dirty IDs for each part
	         * @member {Array<number>}
	         * @readonly
	         */
	        _this.itemDirtyIds = [];
	        for (var i = 0; i < length; i++) {
	            var partTexture = new BaseTexture();
	            _this.items.push(partTexture);
	            // -2 - first run of texture array upload
	            // -1 - texture item was allocated
	            // >=0 - texture item uploaded , in sync with items[i].dirtyId
	            _this.itemDirtyIds.push(-2);
	        }
	        /**
	         * Number of elements in array
	         *
	         * @member {number}
	         * @readonly
	         */
	        _this.length = length;
	        /**
	         * Promise when loading
	         * @member {Promise}
	         * @private
	         * @default null
	         */
	        _this._load = null;
	        /**
	         * Bound baseTexture, there can only be one
	         * @member {PIXI.BaseTexture}
	         */
	        _this.baseTexture = null;
	        return _this;
	    }
	    /**
	     * used from ArrayResource and CubeResource constructors
	     * @param {Array<*>} resources - Can be resources, image elements, canvas, etc. ,
	     *  length should be same as constructor length
	     * @param {object} [options] - detect options for resources
	     * @protected
	     */
	    AbstractMultiResource.prototype.initFromArray = function (resources, options) {
	        for (var i = 0; i < this.length; i++) {
	            if (!resources[i]) {
	                continue;
	            }
	            if (resources[i].castToBaseTexture) {
	                this.addBaseTextureAt(resources[i].castToBaseTexture(), i);
	            }
	            else if (resources[i] instanceof Resource) {
	                this.addResourceAt(resources[i], i);
	            }
	            else {
	                this.addResourceAt(autoDetectResource(resources[i], options), i);
	            }
	        }
	    };
	    /**
	     * Destroy this BaseImageResource
	     * @override
	     */
	    AbstractMultiResource.prototype.dispose = function () {
	        for (var i = 0, len = this.length; i < len; i++) {
	            this.items[i].destroy();
	        }
	        this.items = null;
	        this.itemDirtyIds = null;
	        this._load = null;
	    };
	    /**
	     * Set a resource by ID
	     *
	     * @param {PIXI.resources.Resource} resource
	     * @param {number} index - Zero-based index of resource to set
	     * @return {PIXI.resources.ArrayResource} Instance for chaining
	     */
	    AbstractMultiResource.prototype.addResourceAt = function (resource, index) {
	        if (!this.items[index]) {
	            throw new Error("Index " + index + " is out of bounds");
	        }
	        // Inherit the first resource dimensions
	        if (resource.valid && !this.valid) {
	            this.resize(resource.width, resource.height);
	        }
	        this.items[index].setResource(resource);
	        return this;
	    };
	    /**
	     * Set the parent base texture
	     * @member {PIXI.BaseTexture}
	     * @override
	     */
	    AbstractMultiResource.prototype.bind = function (baseTexture) {
	        if (this.baseTexture !== null) {
	            throw new Error('Only one base texture per TextureArray is allowed');
	        }
	        _super.prototype.bind.call(this, baseTexture);
	        for (var i = 0; i < this.length; i++) {
	            this.items[i].parentTextureArray = baseTexture;
	            this.items[i].on('update', baseTexture.update, baseTexture);
	        }
	    };
	    /**
	     * Unset the parent base texture
	     * @member {PIXI.BaseTexture}
	     * @override
	     */
	    AbstractMultiResource.prototype.unbind = function (baseTexture) {
	        _super.prototype.unbind.call(this, baseTexture);
	        for (var i = 0; i < this.length; i++) {
	            this.items[i].parentTextureArray = null;
	            this.items[i].off('update', baseTexture.update, baseTexture);
	        }
	    };
	    /**
	     * Load all the resources simultaneously
	     * @override
	     * @return {Promise<void>} When load is resolved
	     */
	    AbstractMultiResource.prototype.load = function () {
	        var _this = this;
	        if (this._load) {
	            return this._load;
	        }
	        var resources = this.items.map(function (item) { return item.resource; }).filter(function (item) { return item; });
	        // TODO: also implement load part-by-part strategy
	        var promises = resources.map(function (item) { return item.load(); });
	        this._load = Promise.all(promises)
	            .then(function () {
	            var _a = _this.items[0], realWidth = _a.realWidth, realHeight = _a.realHeight;
	            _this.resize(realWidth, realHeight);
	            return Promise.resolve(_this);
	        });
	        return this._load;
	    };
	    return AbstractMultiResource;
	}(Resource));

	/**
	 * A resource that contains a number of sources.
	 *
	 * @class
	 * @extends PIXI.resources.Resource
	 * @memberof PIXI.resources
	 * @param {number|Array<*>} source - Number of items in array or the collection
	 *        of image URLs to use. Can also be resources, image elements, canvas, etc.
	 * @param {object} [options] - Options to apply to {@link PIXI.resources.autoDetectResource}
	 * @param {number} [options.width] - Width of the resource
	 * @param {number} [options.height] - Height of the resource
	 */
	var ArrayResource = /** @class */ (function (_super) {
	    __extends$2(ArrayResource, _super);
	    function ArrayResource(source, options) {
	        var _this = this;
	        var _a = options || {}, width = _a.width, height = _a.height;
	        var urls;
	        var length;
	        if (Array.isArray(source)) {
	            urls = source;
	            length = source.length;
	        }
	        else {
	            length = source;
	        }
	        _this = _super.call(this, length, { width: width, height: height }) || this;
	        if (urls) {
	            _this.initFromArray(urls, options);
	        }
	        return _this;
	    }
	    /**
	     * Set a baseTexture by ID,
	     * ArrayResource just takes resource from it, nothing more
	     *
	     * @param {PIXI.BaseTexture} baseTexture
	     * @param {number} index - Zero-based index of resource to set
	     * @return {PIXI.resources.ArrayResource} Instance for chaining
	     */
	    ArrayResource.prototype.addBaseTextureAt = function (baseTexture, index) {
	        if (baseTexture.resource) {
	            this.addResourceAt(baseTexture.resource, index);
	        }
	        else {
	            throw new Error('ArrayResource does not support RenderTexture');
	        }
	        return this;
	    };
	    /**
	     * Add binding
	     * @member {PIXI.BaseTexture}
	     * @override
	     */
	    ArrayResource.prototype.bind = function (baseTexture) {
	        _super.prototype.bind.call(this, baseTexture);
	        baseTexture.target = exports.TARGETS.TEXTURE_2D_ARRAY;
	    };
	    /**
	     * Upload the resources to the GPU.
	     * @param {PIXI.Renderer} renderer
	     * @param {PIXI.BaseTexture} texture
	     * @param {PIXI.GLTexture} glTexture
	     * @returns {boolean} whether texture was uploaded
	     */
	    ArrayResource.prototype.upload = function (renderer, texture, glTexture) {
	        var _a = this, length = _a.length, itemDirtyIds = _a.itemDirtyIds, items = _a.items;
	        var gl = renderer.gl;
	        if (glTexture.dirtyId < 0) {
	            gl.texImage3D(gl.TEXTURE_2D_ARRAY, 0, texture.format, this._width, this._height, length, 0, texture.format, texture.type, null);
	        }
	        for (var i = 0; i < length; i++) {
	            var item = items[i];
	            if (itemDirtyIds[i] < item.dirtyId) {
	                itemDirtyIds[i] = item.dirtyId;
	                if (item.valid) {
	                    gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, 0, 0, // xoffset
	                    0, // yoffset
	                    i, // zoffset
	                    item.resource.width, item.resource.height, 1, texture.format, texture.type, item.resource.source);
	                }
	            }
	        }
	        return true;
	    };
	    return ArrayResource;
	}(AbstractMultiResource));

	/**
	 * Base for all the image/canvas resources
	 * @class
	 * @extends PIXI.resources.Resource
	 * @memberof PIXI.resources
	 */
	var BaseImageResource = /** @class */ (function (_super) {
	    __extends$2(BaseImageResource, _super);
	    /**
	     * @param {HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|SVGElement} source
	     */
	    function BaseImageResource(source) {
	        var _this = this;
	        var sourceAny = source;
	        var width = sourceAny.naturalWidth || sourceAny.videoWidth || sourceAny.width;
	        var height = sourceAny.naturalHeight || sourceAny.videoHeight || sourceAny.height;
	        _this = _super.call(this, width, height) || this;
	        /**
	         * The source element
	         * @member {HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|SVGElement}
	         * @readonly
	         */
	        _this.source = source;
	        /**
	         * If set to `true`, will force `texImage2D` over `texSubImage2D` for uploading.
	         * Certain types of media (e.g. video) using `texImage2D` is more performant.
	         * @member {boolean}
	         * @default false
	         * @private
	         */
	        _this.noSubImage = false;
	        return _this;
	    }
	    /**
	     * Set cross origin based detecting the url and the crossorigin
	     * @protected
	     * @param {HTMLElement} element - Element to apply crossOrigin
	     * @param {string} url - URL to check
	     * @param {boolean|string} [crossorigin=true] - Cross origin value to use
	     */
	    BaseImageResource.crossOrigin = function (element, url, crossorigin) {
	        if (crossorigin === undefined && url.indexOf('data:') !== 0) {
	            element.crossOrigin = determineCrossOrigin(url);
	        }
	        else if (crossorigin !== false) {
	            element.crossOrigin = typeof crossorigin === 'string' ? crossorigin : 'anonymous';
	        }
	    };
	    /**
	     * Upload the texture to the GPU.
	     * @param {PIXI.Renderer} renderer - Upload to the renderer
	     * @param {PIXI.BaseTexture} baseTexture - Reference to parent texture
	     * @param {PIXI.GLTexture} glTexture
	     * @param {HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|SVGElement} [source] (optional)
	     * @returns {boolean} true is success
	     */
	    BaseImageResource.prototype.upload = function (renderer, baseTexture, glTexture, source) {
	        var gl = renderer.gl;
	        var width = baseTexture.realWidth;
	        var height = baseTexture.realHeight;
	        source = source || this.source;
	        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === exports.ALPHA_MODES.UNPACK);
	        if (!this.noSubImage
	            && baseTexture.target === gl.TEXTURE_2D
	            && glTexture.width === width
	            && glTexture.height === height) {
	            gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, baseTexture.format, baseTexture.type, source);
	        }
	        else {
	            glTexture.width = width;
	            glTexture.height = height;
	            gl.texImage2D(baseTexture.target, 0, baseTexture.format, baseTexture.format, baseTexture.type, source);
	        }
	        return true;
	    };
	    /**
	     * Checks if source width/height was changed, resize can cause extra baseTexture update.
	     * Triggers one update in any case.
	     */
	    BaseImageResource.prototype.update = function () {
	        if (this.destroyed) {
	            return;
	        }
	        var source = this.source;
	        var width = source.naturalWidth || source.videoWidth || source.width;
	        var height = source.naturalHeight || source.videoHeight || source.height;
	        this.resize(width, height);
	        _super.prototype.update.call(this);
	    };
	    /**
	     * Destroy this BaseImageResource
	     * @override
	     */
	    BaseImageResource.prototype.dispose = function () {
	        this.source = null;
	    };
	    return BaseImageResource;
	}(Resource));

	/**
	 * @interface OffscreenCanvas
	 */
	/**
	 * Resource type for HTMLCanvasElement.
	 * @class
	 * @extends PIXI.resources.BaseImageResource
	 * @memberof PIXI.resources
	 * @param {HTMLCanvasElement} source - Canvas element to use
	 */
	var CanvasResource = /** @class */ (function (_super) {
	    __extends$2(CanvasResource, _super);
	    function CanvasResource() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Used to auto-detect the type of resource.
	     *
	     * @static
	     * @param {HTMLCanvasElement|OffscreenCanvas} source - The source object
	     * @return {boolean} `true` if source is HTMLCanvasElement or OffscreenCanvas
	     */
	    CanvasResource.test = function (source) {
	        var OffscreenCanvas = window.OffscreenCanvas;
	        // Check for browsers that don't yet support OffscreenCanvas
	        if (OffscreenCanvas && source instanceof OffscreenCanvas) {
	            return true;
	        }
	        return source instanceof HTMLCanvasElement;
	    };
	    return CanvasResource;
	}(BaseImageResource));

	/**
	 * Resource for a CubeTexture which contains six resources.
	 *
	 * @class
	 * @extends PIXI.resources.ArrayResource
	 * @memberof PIXI.resources
	 * @param {Array<string|PIXI.resources.Resource>} [source] - Collection of URLs or resources
	 *        to use as the sides of the cube.
	 * @param {object} [options] - ImageResource options
	 * @param {number} [options.width] - Width of resource
	 * @param {number} [options.height] - Height of resource
	 * @param {number} [options.autoLoad=true] - Whether to auto-load resources
	 * @param {number} [options.linkBaseTexture=true] - In case BaseTextures are supplied,
	 *   whether to copy them or use
	 */
	var CubeResource = /** @class */ (function (_super) {
	    __extends$2(CubeResource, _super);
	    function CubeResource(source, options) {
	        var _this = this;
	        var _a = options || {}, width = _a.width, height = _a.height, autoLoad = _a.autoLoad, linkBaseTexture = _a.linkBaseTexture;
	        if (source && source.length !== CubeResource.SIDES) {
	            throw new Error("Invalid length. Got " + source.length + ", expected 6");
	        }
	        _this = _super.call(this, 6, { width: width, height: height }) || this;
	        for (var i = 0; i < CubeResource.SIDES; i++) {
	            _this.items[i].target = exports.TARGETS.TEXTURE_CUBE_MAP_POSITIVE_X + i;
	        }
	        /**
	         * In case BaseTextures are supplied, whether to use same resource or bind baseTexture itself
	         * @member {boolean}
	         * @protected
	         */
	        _this.linkBaseTexture = linkBaseTexture !== false;
	        if (source) {
	            _this.initFromArray(source, options);
	        }
	        if (autoLoad !== false) {
	            _this.load();
	        }
	        return _this;
	    }
	    /**
	     * Add binding
	     *
	     * @override
	     * @param {PIXI.BaseTexture} baseTexture - parent base texture
	     */
	    CubeResource.prototype.bind = function (baseTexture) {
	        _super.prototype.bind.call(this, baseTexture);
	        baseTexture.target = exports.TARGETS.TEXTURE_CUBE_MAP;
	    };
	    CubeResource.prototype.addBaseTextureAt = function (baseTexture, index, linkBaseTexture) {
	        if (linkBaseTexture === undefined) {
	            linkBaseTexture = this.linkBaseTexture;
	        }
	        if (!this.items[index]) {
	            throw new Error("Index " + index + " is out of bounds");
	        }
	        if (!this.linkBaseTexture
	            || baseTexture.parentTextureArray
	            || Object.keys(baseTexture._glTextures).length > 0) {
	            // copy mode
	            if (baseTexture.resource) {
	                this.addResourceAt(baseTexture.resource, index);
	            }
	            else {
	                throw new Error("CubeResource does not support copying of renderTexture.");
	            }
	        }
	        else {
	            // link mode, the difficult one!
	            baseTexture.target = exports.TARGETS.TEXTURE_CUBE_MAP_POSITIVE_X + index;
	            baseTexture.parentTextureArray = this.baseTexture;
	            this.items[index] = baseTexture;
	        }
	        if (baseTexture.valid && !this.valid) {
	            this.resize(baseTexture.realWidth, baseTexture.realHeight);
	        }
	        this.items[index] = baseTexture;
	        return this;
	    };
	    /**
	     * Upload the resource
	     *
	     * @returns {boolean} true is success
	     */
	    CubeResource.prototype.upload = function (renderer, _baseTexture, glTexture) {
	        var dirty = this.itemDirtyIds;
	        for (var i = 0; i < CubeResource.SIDES; i++) {
	            var side = this.items[i];
	            if (dirty[i] < side.dirtyId) {
	                if (side.valid && side.resource) {
	                    side.resource.upload(renderer, side, glTexture);
	                    dirty[i] = side.dirtyId;
	                }
	                else if (dirty[i] < -1) {
	                    // either item is not valid yet, either its a renderTexture
	                    // allocate the memory
	                    renderer.gl.texImage2D(side.target, 0, glTexture.internalFormat, _baseTexture.realWidth, _baseTexture.realHeight, 0, _baseTexture.format, glTexture.type, null);
	                    dirty[i] = -1;
	                }
	            }
	        }
	        return true;
	    };
	    /**
	     * Used to auto-detect the type of resource.
	     *
	     * @static
	     * @param {object} source - The source object
	     * @return {boolean} `true` if source is an array of 6 elements
	     */
	    CubeResource.test = function (source) {
	        return Array.isArray(source) && source.length === CubeResource.SIDES;
	    };
	    /**
	     * Number of texture sides to store for CubeResources
	     *
	     * @name PIXI.resources.CubeResource.SIDES
	     * @static
	     * @member {number}
	     * @default 6
	     */
	    CubeResource.SIDES = 6;
	    return CubeResource;
	}(AbstractMultiResource));

	/**
	 * Resource type for HTMLImageElement.
	 * @class
	 * @extends PIXI.resources.BaseImageResource
	 * @memberof PIXI.resources
	 */
	var ImageResource = /** @class */ (function (_super) {
	    __extends$2(ImageResource, _super);
	    /**
	     * @param {HTMLImageElement|string} source - image source or URL
	     * @param {object} [options]
	     * @param {boolean} [options.autoLoad=true] - start loading process
	     * @param {boolean} [options.createBitmap=PIXI.settings.CREATE_IMAGE_BITMAP] - whether its required to create
	     *        a bitmap before upload
	     * @param {boolean} [options.crossorigin=true] - Load image using cross origin
	     * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.UNPACK] - Premultiply image alpha in bitmap
	     */
	    function ImageResource(source, options) {
	        var _this = this;
	        options = options || {};
	        if (!(source instanceof HTMLImageElement)) {
	            var imageElement = new Image();
	            BaseImageResource.crossOrigin(imageElement, source, options.crossorigin);
	            imageElement.src = source;
	            source = imageElement;
	        }
	        _this = _super.call(this, source) || this;
	        // FireFox 68, and possibly other versions, seems like setting the HTMLImageElement#width and #height
	        // to non-zero values before its loading completes if images are in a cache.
	        // Because of this, need to set the `_width` and the `_height` to zero to avoid uploading incomplete images.
	        // Please refer to the issue #5968 (https://github.com/pixijs/pixi.js/issues/5968).
	        if (!source.complete && !!_this._width && !!_this._height) {
	            _this._width = 0;
	            _this._height = 0;
	        }
	        /**
	         * URL of the image source
	         * @member {string}
	         */
	        _this.url = source.src;
	        /**
	         * When process is completed
	         * @member {Promise<void>}
	         * @private
	         */
	        _this._process = null;
	        /**
	         * If the image should be disposed after upload
	         * @member {boolean}
	         * @default false
	         */
	        _this.preserveBitmap = false;
	        /**
	         * If capable, convert the image using createImageBitmap API
	         * @member {boolean}
	         * @default PIXI.settings.CREATE_IMAGE_BITMAP
	         */
	        _this.createBitmap = (options.createBitmap !== undefined
	            ? options.createBitmap : settings.CREATE_IMAGE_BITMAP) && !!window.createImageBitmap;
	        /**
	         * Controls texture alphaMode field
	         * Copies from options
	         * Default is `null`, copies option from baseTexture
	         *
	         * @member {PIXI.ALPHA_MODES|null}
	         * @readonly
	         */
	        _this.alphaMode = typeof options.alphaMode === 'number' ? options.alphaMode : null;
	        if (options.premultiplyAlpha !== undefined) {
	            // triggers deprecation
	            _this.premultiplyAlpha = options.premultiplyAlpha;
	        }
	        /**
	         * The ImageBitmap element created for HTMLImageElement
	         * @member {ImageBitmap}
	         * @default null
	         */
	        _this.bitmap = null;
	        /**
	         * Promise when loading
	         * @member {Promise<void>}
	         * @private
	         * @default null
	         */
	        _this._load = null;
	        if (options.autoLoad !== false) {
	            _this.load();
	        }
	        return _this;
	    }
	    /**
	     * returns a promise when image will be loaded and processed
	     *
	     * @param {boolean} [createBitmap] - whether process image into bitmap
	     * @returns {Promise<void>}
	     */
	    ImageResource.prototype.load = function (createBitmap) {
	        var _this = this;
	        if (this._load) {
	            return this._load;
	        }
	        if (createBitmap !== undefined) {
	            this.createBitmap = createBitmap;
	        }
	        this._load = new Promise(function (resolve, reject) {
	            var source = _this.source;
	            _this.url = source.src;
	            var completed = function () {
	                if (_this.destroyed) {
	                    return;
	                }
	                source.onload = null;
	                source.onerror = null;
	                _this.resize(source.width, source.height);
	                _this._load = null;
	                if (_this.createBitmap) {
	                    resolve(_this.process());
	                }
	                else {
	                    resolve(_this);
	                }
	            };
	            if (source.complete && source.src) {
	                completed();
	            }
	            else {
	                source.onload = completed;
	                source.onerror = function (event) {
	                    // Avoids Promise freezing when resource broken
	                    reject(event);
	                    _this.onError.emit(event);
	                };
	            }
	        });
	        return this._load;
	    };
	    /**
	     * Called when we need to convert image into BitmapImage.
	     * Can be called multiple times, real promise is cached inside.
	     *
	     * @returns {Promise<void>} cached promise to fill that bitmap
	     */
	    ImageResource.prototype.process = function () {
	        var _this = this;
	        var source = this.source;
	        if (this._process !== null) {
	            return this._process;
	        }
	        if (this.bitmap !== null || !window.createImageBitmap) {
	            return Promise.resolve(this);
	        }
	        this._process = window.createImageBitmap(source, 0, 0, source.width, source.height, {
	            premultiplyAlpha: this.alphaMode === exports.ALPHA_MODES.UNPACK ? 'premultiply' : 'none',
	        })
	            .then(function (bitmap) {
	            if (_this.destroyed) {
	                return Promise.reject();
	            }
	            _this.bitmap = bitmap;
	            _this.update();
	            _this._process = null;
	            return Promise.resolve(_this);
	        });
	        return this._process;
	    };
	    /**
	     * Upload the image resource to GPU.
	     *
	     * @param {PIXI.Renderer} renderer - Renderer to upload to
	     * @param {PIXI.BaseTexture} baseTexture - BaseTexture for this resource
	     * @param {PIXI.GLTexture} glTexture - GLTexture to use
	     * @returns {boolean} true is success
	     */
	    ImageResource.prototype.upload = function (renderer, baseTexture, glTexture) {
	        if (typeof this.alphaMode === 'number') {
	            // bitmap stores unpack premultiply flag, we dont have to notify texImage2D about it
	            baseTexture.alphaMode = this.alphaMode;
	        }
	        if (!this.createBitmap) {
	            return _super.prototype.upload.call(this, renderer, baseTexture, glTexture);
	        }
	        if (!this.bitmap) {
	            // yeah, ignore the output
	            this.process();
	            if (!this.bitmap) {
	                return false;
	            }
	        }
	        _super.prototype.upload.call(this, renderer, baseTexture, glTexture, this.bitmap);
	        if (!this.preserveBitmap) {
	            // checks if there are other renderers that possibly need this bitmap
	            var flag = true;
	            var glTextures = baseTexture._glTextures;
	            for (var key in glTextures) {
	                var otherTex = glTextures[key];
	                if (otherTex !== glTexture && otherTex.dirtyId !== baseTexture.dirtyId) {
	                    flag = false;
	                    break;
	                }
	            }
	            if (flag) {
	                if (this.bitmap.close) {
	                    this.bitmap.close();
	                }
	                this.bitmap = null;
	            }
	        }
	        return true;
	    };
	    /**
	     * Destroys this texture
	     * @override
	     */
	    ImageResource.prototype.dispose = function () {
	        this.source.onload = null;
	        this.source.onerror = null;
	        _super.prototype.dispose.call(this);
	        if (this.bitmap) {
	            this.bitmap.close();
	            this.bitmap = null;
	        }
	        this._process = null;
	        this._load = null;
	    };
	    /**
	     * Used to auto-detect the type of resource.
	     *
	     * @static
	     * @param {string|HTMLImageElement} source - The source object
	     * @return {boolean} `true` if source is string or HTMLImageElement
	     */
	    ImageResource.test = function (source) {
	        return typeof source === 'string' || source instanceof HTMLImageElement;
	    };
	    return ImageResource;
	}(BaseImageResource));

	/**
	 * Resource type for SVG elements and graphics.
	 * @class
	 * @extends PIXI.resources.BaseImageResource
	 * @memberof PIXI.resources
	 * @param {string} source - Base64 encoded SVG element or URL for SVG file.
	 * @param {object} [options] - Options to use
	 * @param {number} [options.scale=1] - Scale to apply to SVG. Overridden by...
	 * @param {number} [options.width] - Rasterize SVG this wide. Aspect ratio preserved if height not specified.
	 * @param {number} [options.height] - Rasterize SVG this high. Aspect ratio preserved if width not specified.
	 * @param {boolean} [options.autoLoad=true] - Start loading right away.
	 */
	var SVGResource = /** @class */ (function (_super) {
	    __extends$2(SVGResource, _super);
	    function SVGResource(sourceBase64, options) {
	        var _this = this;
	        options = options || {};
	        _this = _super.call(this, document.createElement('canvas')) || this;
	        _this._width = 0;
	        _this._height = 0;
	        /**
	         * Base64 encoded SVG element or URL for SVG file
	         * @readonly
	         * @member {string}
	         */
	        _this.svg = sourceBase64;
	        /**
	         * The source scale to apply when rasterizing on load
	         * @readonly
	         * @member {number}
	         */
	        _this.scale = options.scale || 1;
	        /**
	         * A width override for rasterization on load
	         * @readonly
	         * @member {number}
	         */
	        _this._overrideWidth = options.width;
	        /**
	         * A height override for rasterization on load
	         * @readonly
	         * @member {number}
	         */
	        _this._overrideHeight = options.height;
	        /**
	         * Call when completely loaded
	         * @private
	         * @member {function}
	         */
	        _this._resolve = null;
	        /**
	         * Cross origin value to use
	         * @private
	         * @member {boolean|string}
	         */
	        _this._crossorigin = options.crossorigin;
	        /**
	         * Promise when loading
	         * @member {Promise<void>}
	         * @private
	         * @default null
	         */
	        _this._load = null;
	        if (options.autoLoad !== false) {
	            _this.load();
	        }
	        return _this;
	    }
	    SVGResource.prototype.load = function () {
	        var _this = this;
	        if (this._load) {
	            return this._load;
	        }
	        this._load = new Promise(function (resolve) {
	            // Save this until after load is finished
	            _this._resolve = function () {
	                _this.resize(_this.source.width, _this.source.height);
	                resolve(_this);
	            };
	            // Convert SVG inline string to data-uri
	            if ((/^\<svg/).test(_this.svg.trim())) {
	                if (!btoa) {
	                    throw new Error('Your browser doesn\'t support base64 conversions.');
	                }
	                _this.svg = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(_this.svg)));
	            }
	            _this._loadSvg();
	        });
	        return this._load;
	    };
	    /**
	     * Loads an SVG image from `imageUrl` or `data URL`.
	     *
	     * @private
	     */
	    SVGResource.prototype._loadSvg = function () {
	        var _this = this;
	        var tempImage = new Image();
	        BaseImageResource.crossOrigin(tempImage, this.svg, this._crossorigin);
	        tempImage.src = this.svg;
	        tempImage.onerror = function (event) {
	            if (!_this._resolve) {
	                return;
	            }
	            tempImage.onerror = null;
	            _this.onError.emit(event);
	        };
	        tempImage.onload = function () {
	            if (!_this._resolve) {
	                return;
	            }
	            var svgWidth = tempImage.width;
	            var svgHeight = tempImage.height;
	            if (!svgWidth || !svgHeight) {
	                throw new Error('The SVG image must have width and height defined (in pixels), canvas API needs them.');
	            }
	            // Set render size
	            var width = svgWidth * _this.scale;
	            var height = svgHeight * _this.scale;
	            if (_this._overrideWidth || _this._overrideHeight) {
	                width = _this._overrideWidth || _this._overrideHeight / svgHeight * svgWidth;
	                height = _this._overrideHeight || _this._overrideWidth / svgWidth * svgHeight;
	            }
	            width = Math.round(width);
	            height = Math.round(height);
	            // Create a canvas element
	            var canvas = _this.source;
	            canvas.width = width;
	            canvas.height = height;
	            canvas._pixiId = "canvas_" + uid();
	            // Draw the Svg to the canvas
	            canvas
	                .getContext('2d')
	                .drawImage(tempImage, 0, 0, svgWidth, svgHeight, 0, 0, width, height);
	            _this._resolve();
	            _this._resolve = null;
	        };
	    };
	    /**
	     * Get size from an svg string using regexp.
	     *
	     * @method
	     * @param {string} svgString - a serialized svg element
	     * @return {PIXI.ISize} image extension
	     */
	    SVGResource.getSize = function (svgString) {
	        var sizeMatch = SVGResource.SVG_SIZE.exec(svgString);
	        var size = {};
	        if (sizeMatch) {
	            size[sizeMatch[1]] = Math.round(parseFloat(sizeMatch[3]));
	            size[sizeMatch[5]] = Math.round(parseFloat(sizeMatch[7]));
	        }
	        return size;
	    };
	    /**
	     * Destroys this texture
	     * @override
	     */
	    SVGResource.prototype.dispose = function () {
	        _super.prototype.dispose.call(this);
	        this._resolve = null;
	        this._crossorigin = null;
	    };
	    /**
	     * Used to auto-detect the type of resource.
	     *
	     * @static
	     * @param {*} source - The source object
	     * @param {string} extension - The extension of source, if set
	     */
	    SVGResource.test = function (source, extension) {
	        // url file extension is SVG
	        return extension === 'svg'
	            // source is SVG data-uri
	            || (typeof source === 'string' && (/^data:image\/svg\+xml(;(charset=utf8|utf8))?;base64/).test(source))
	            // source is SVG inline
	            || (typeof source === 'string' && source.indexOf('<svg') === 0);
	    };
	    /**
	     * RegExp for SVG size.
	     *
	     * @static
	     * @constant {RegExp|string} SVG_SIZE
	     * @memberof PIXI.resources.SVGResource
	     * @example &lt;svg width="100" height="100"&gt;&lt;/svg&gt;
	     */
	    SVGResource.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i; // eslint-disable-line max-len
	    return SVGResource;
	}(BaseImageResource));

	/**
	 * Resource type for HTMLVideoElement.
	 * @class
	 * @extends PIXI.resources.BaseImageResource
	 * @memberof PIXI.resources
	 * @param {HTMLVideoElement|object|string|Array<string|object>} source - Video element to use.
	 * @param {object} [options] - Options to use
	 * @param {boolean} [options.autoLoad=true] - Start loading the video immediately
	 * @param {boolean} [options.autoPlay=true] - Start playing video immediately
	 * @param {number} [options.updateFPS=0] - How many times a second to update the texture from the video.
	 * Leave at 0 to update at every render.
	 * @param {boolean} [options.crossorigin=true] - Load image using cross origin
	 */
	var VideoResource = /** @class */ (function (_super) {
	    __extends$2(VideoResource, _super);
	    function VideoResource(source, options) {
	        var _this = this;
	        options = options || {};
	        if (!(source instanceof HTMLVideoElement)) {
	            var videoElement = document.createElement('video');
	            // workaround for https://github.com/pixijs/pixi.js/issues/5996
	            videoElement.setAttribute('preload', 'auto');
	            videoElement.setAttribute('webkit-playsinline', '');
	            videoElement.setAttribute('playsinline', '');
	            if (typeof source === 'string') {
	                source = [source];
	            }
	            var firstSrc = source[0].src || source[0];
	            BaseImageResource.crossOrigin(videoElement, firstSrc, options.crossorigin);
	            // array of objects or strings
	            for (var i = 0; i < source.length; ++i) {
	                var sourceElement = document.createElement('source');
	                var _a = source[i], src = _a.src, mime = _a.mime;
	                src = src || source[i];
	                var baseSrc = src.split('?').shift().toLowerCase();
	                var ext = baseSrc.substr(baseSrc.lastIndexOf('.') + 1);
	                mime = mime || VideoResource.MIME_TYPES[ext] || "video/" + ext;
	                sourceElement.src = src;
	                sourceElement.type = mime;
	                videoElement.appendChild(sourceElement);
	            }
	            // Override the source
	            source = videoElement;
	        }
	        _this = _super.call(this, source) || this;
	        _this.noSubImage = true;
	        /**
	         * `true` to use PIXI.Ticker.shared to auto update the base texture.
	         *
	         * @type {boolean}
	         * @default true
	         * @private
	         */
	        _this._autoUpdate = true;
	        /**
	         * `true` if the instance is currently connected to PIXI.Ticker.shared to auto update the base texture.
	         *
	         * @type {boolean}
	         * @default false
	         * @private
	         */
	        _this._isConnectedToTicker = false;
	        _this._updateFPS = options.updateFPS || 0;
	        _this._msToNextUpdate = 0;
	        /**
	         * When set to true will automatically play videos used by this texture once
	         * they are loaded. If false, it will not modify the playing state.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.autoPlay = options.autoPlay !== false;
	        /**
	         * Promise when loading
	         * @member {Promise<void>}
	         * @private
	         * @default null
	         */
	        _this._load = null;
	        /**
	         * Callback when completed with load.
	         * @member {function}
	         * @private
	         */
	        _this._resolve = null;
	        // Bind for listeners
	        _this._onCanPlay = _this._onCanPlay.bind(_this);
	        _this._onError = _this._onError.bind(_this);
	        if (options.autoLoad !== false) {
	            _this.load();
	        }
	        return _this;
	    }
	    /**
	     * Trigger updating of the texture
	     *
	     * @param {number} [deltaTime=0] - time delta since last tick
	     */
	    VideoResource.prototype.update = function (_deltaTime) {
	        if (_deltaTime === void 0) { _deltaTime = 0; }
	        if (!this.destroyed) {
	            // account for if video has had its playbackRate changed
	            var elapsedMS = Ticker.shared.elapsedMS * this.source.playbackRate;
	            this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
	            if (!this._updateFPS || this._msToNextUpdate <= 0) {
	                _super.prototype.update.call(this);
	                this._msToNextUpdate = this._updateFPS ? Math.floor(1000 / this._updateFPS) : 0;
	            }
	        }
	    };
	    /**
	     * Start preloading the video resource.
	     *
	     * @protected
	     * @return {Promise<void>} Handle the validate event
	     */
	    VideoResource.prototype.load = function () {
	        var _this = this;
	        if (this._load) {
	            return this._load;
	        }
	        var source = this.source;
	        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA)
	            && source.width && source.height) {
	            source.complete = true;
	        }
	        source.addEventListener('play', this._onPlayStart.bind(this));
	        source.addEventListener('pause', this._onPlayStop.bind(this));
	        if (!this._isSourceReady()) {
	            source.addEventListener('canplay', this._onCanPlay);
	            source.addEventListener('canplaythrough', this._onCanPlay);
	            source.addEventListener('error', this._onError, true);
	        }
	        else {
	            this._onCanPlay();
	        }
	        this._load = new Promise(function (resolve) {
	            if (_this.valid) {
	                resolve(_this);
	            }
	            else {
	                _this._resolve = resolve;
	                source.load();
	            }
	        });
	        return this._load;
	    };
	    /**
	     * Handle video error events.
	     *
	     * @private
	     */
	    VideoResource.prototype._onError = function (event) {
	        this.source.removeEventListener('error', this._onError, true);
	        this.onError.emit(event);
	    };
	    /**
	     * Returns true if the underlying source is playing.
	     *
	     * @private
	     * @return {boolean} True if playing.
	     */
	    VideoResource.prototype._isSourcePlaying = function () {
	        var source = this.source;
	        return (source.currentTime > 0 && source.paused === false && source.ended === false && source.readyState > 2);
	    };
	    /**
	     * Returns true if the underlying source is ready for playing.
	     *
	     * @private
	     * @return {boolean} True if ready.
	     */
	    VideoResource.prototype._isSourceReady = function () {
	        var source = this.source;
	        return source.readyState === 3 || source.readyState === 4;
	    };
	    /**
	     * Runs the update loop when the video is ready to play
	     *
	     * @private
	     */
	    VideoResource.prototype._onPlayStart = function () {
	        // Just in case the video has not received its can play even yet..
	        if (!this.valid) {
	            this._onCanPlay();
	        }
	        if (this.autoUpdate && !this._isConnectedToTicker) {
	            Ticker.shared.add(this.update, this);
	            this._isConnectedToTicker = true;
	        }
	    };
	    /**
	     * Fired when a pause event is triggered, stops the update loop
	     *
	     * @private
	     */
	    VideoResource.prototype._onPlayStop = function () {
	        if (this._isConnectedToTicker) {
	            Ticker.shared.remove(this.update, this);
	            this._isConnectedToTicker = false;
	        }
	    };
	    /**
	     * Fired when the video is loaded and ready to play
	     *
	     * @private
	     */
	    VideoResource.prototype._onCanPlay = function () {
	        var source = this.source;
	        source.removeEventListener('canplay', this._onCanPlay);
	        source.removeEventListener('canplaythrough', this._onCanPlay);
	        var valid = this.valid;
	        this.resize(source.videoWidth, source.videoHeight);
	        // prevent multiple loaded dispatches..
	        if (!valid && this._resolve) {
	            this._resolve(this);
	            this._resolve = null;
	        }
	        if (this._isSourcePlaying()) {
	            this._onPlayStart();
	        }
	        else if (this.autoPlay) {
	            source.play();
	        }
	    };
	    /**
	     * Destroys this texture
	     * @override
	     */
	    VideoResource.prototype.dispose = function () {
	        if (this._isConnectedToTicker) {
	            Ticker.shared.remove(this.update, this);
	        }
	        var source = this.source;
	        if (source) {
	            source.removeEventListener('error', this._onError, true);
	            source.pause();
	            source.src = '';
	            source.load();
	        }
	        _super.prototype.dispose.call(this);
	    };
	    Object.defineProperty(VideoResource.prototype, "autoUpdate", {
	        /**
	         * Should the base texture automatically update itself, set to true by default
	         *
	         * @member {boolean}
	         */
	        get: function () {
	            return this._autoUpdate;
	        },
	        set: function (value) {
	            if (value !== this._autoUpdate) {
	                this._autoUpdate = value;
	                if (!this._autoUpdate && this._isConnectedToTicker) {
	                    Ticker.shared.remove(this.update, this);
	                    this._isConnectedToTicker = false;
	                }
	                else if (this._autoUpdate && !this._isConnectedToTicker && this._isSourcePlaying()) {
	                    Ticker.shared.add(this.update, this);
	                    this._isConnectedToTicker = true;
	                }
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(VideoResource.prototype, "updateFPS", {
	        /**
	         * How many times a second to update the texture from the video. Leave at 0 to update at every render.
	         * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._updateFPS;
	        },
	        set: function (value) {
	            if (value !== this._updateFPS) {
	                this._updateFPS = value;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Used to auto-detect the type of resource.
	     *
	     * @static
	     * @param {*} source - The source object
	     * @param {string} extension - The extension of source, if set
	     * @return {boolean} `true` if video source
	     */
	    VideoResource.test = function (source, extension) {
	        return (source instanceof HTMLVideoElement)
	            || VideoResource.TYPES.indexOf(extension) > -1;
	    };
	    /**
	     * List of common video file extensions supported by VideoResource.
	     * @constant
	     * @member {Array<string>}
	     * @static
	     * @readonly
	     */
	    VideoResource.TYPES = ['mp4', 'm4v', 'webm', 'ogg', 'ogv', 'h264', 'avi', 'mov'];
	    /**
	     * Map of video MIME types that can't be directly derived from file extensions.
	     * @constant
	     * @member {object}
	     * @static
	     * @readonly
	     */
	    VideoResource.MIME_TYPES = {
	        ogv: 'video/ogg',
	        mov: 'video/quicktime',
	        m4v: 'video/mp4',
	    };
	    return VideoResource;
	}(BaseImageResource));

	/**
	 * Resource type for ImageBitmap.
	 * @class
	 * @extends PIXI.resources.BaseImageResource
	 * @memberof PIXI.resources
	 * @param {ImageBitmap} source - Image element to use
	 */
	var ImageBitmapResource = /** @class */ (function (_super) {
	    __extends$2(ImageBitmapResource, _super);
	    function ImageBitmapResource() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Used to auto-detect the type of resource.
	     *
	     * @static
	     * @param {ImageBitmap} source - The source object
	     * @return {boolean} `true` if source is an ImageBitmap
	     */
	    ImageBitmapResource.test = function (source) {
	        return !!window.createImageBitmap && source instanceof ImageBitmap;
	    };
	    return ImageBitmapResource;
	}(BaseImageResource));

	INSTALLED.push(ImageResource, ImageBitmapResource, CanvasResource, VideoResource, SVGResource, BufferResource, CubeResource, ArrayResource);

	var index = ({
	    Resource: Resource,
	    BaseImageResource: BaseImageResource,
	    INSTALLED: INSTALLED,
	    autoDetectResource: autoDetectResource,
	    AbstractMultiResource: AbstractMultiResource,
	    ArrayResource: ArrayResource,
	    BufferResource: BufferResource,
	    CanvasResource: CanvasResource,
	    CubeResource: CubeResource,
	    ImageResource: ImageResource,
	    SVGResource: SVGResource,
	    VideoResource: VideoResource,
	    ImageBitmapResource: ImageBitmapResource
	});

	/**
	 * System is a base class used for extending systems used by the {@link PIXI.Renderer}
	 *
	 * @see PIXI.Renderer#addSystem
	 * @class
	 * @memberof PIXI
	 */
	var System = /** @class */ (function () {
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this manager works for.
	     */
	    function System(renderer) {
	        /**
	         * The renderer this manager works for.
	         *
	         * @member {PIXI.Renderer}
	         */
	        this.renderer = renderer;
	    }
	    /**
	     * Generic destroy methods to be overridden by the subclass
	     */
	    System.prototype.destroy = function () {
	        this.renderer = null;
	    };
	    return System;
	}());

	/**
	 * Resource type for DepthTexture.
	 * @class
	 * @extends PIXI.resources.BufferResource
	 * @memberof PIXI.resources
	 */
	var DepthResource = /** @class */ (function (_super) {
	    __extends$2(DepthResource, _super);
	    function DepthResource() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Upload the texture to the GPU.
	     * @param {PIXI.Renderer} renderer - Upload to the renderer
	     * @param {PIXI.BaseTexture} baseTexture - Reference to parent texture
	     * @param {PIXI.GLTexture} glTexture - glTexture
	     * @returns {boolean} true is success
	     */
	    DepthResource.prototype.upload = function (renderer, baseTexture, glTexture) {
	        var gl = renderer.gl;
	        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === exports.ALPHA_MODES.UNPACK);
	        if (glTexture.width === baseTexture.width && glTexture.height === baseTexture.height) {
	            gl.texSubImage2D(baseTexture.target, 0, 0, 0, baseTexture.width, baseTexture.height, baseTexture.format, baseTexture.type, this.data);
	        }
	        else {
	            glTexture.width = baseTexture.width;
	            glTexture.height = baseTexture.height;
	            gl.texImage2D(baseTexture.target, 0, 
	            //  gl.DEPTH_COMPONENT16 Needed for depth to render properly in webgl2.0
	            renderer.context.webGLVersion === 1 ? gl.DEPTH_COMPONENT : gl.DEPTH_COMPONENT16, baseTexture.width, baseTexture.height, 0, baseTexture.format, baseTexture.type, this.data);
	        }
	        return true;
	    };
	    return DepthResource;
	}(BufferResource));

	/**
	 * Frame buffer used by the BaseRenderTexture
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Framebuffer = /** @class */ (function () {
	    /**
	     * @param {number} width - Width of the frame buffer
	     * @param {number} height - Height of the frame buffer
	     */
	    function Framebuffer(width, height) {
	        /**
	         * Width of framebuffer in pixels
	         * @member {number}
	         */
	        this.width = Math.ceil(width || 100);
	        /**
	         * Height of framebuffer in pixels
	         * @member {number}
	         */
	        this.height = Math.ceil(height || 100);
	        this.stencil = false;
	        this.depth = false;
	        this.dirtyId = 0;
	        this.dirtyFormat = 0;
	        this.dirtySize = 0;
	        this.depthTexture = null;
	        this.colorTextures = [];
	        this.glFramebuffers = {};
	        this.disposeRunner = new Runner('disposeFramebuffer');
	        /**
	         * Desired number of samples for antialiasing. 0 means AA should not be used.
	         *
	         * Experimental WebGL2 feature, allows to use antialiasing in individual renderTextures.
	         * Antialiasing is the same as for main buffer with renderer `antialias:true` options.
	         * Seriously affects GPU memory consumption and GPU performance.
	         *
	         *```js
	         * renderTexture.framebuffer.multisample = PIXI.MSAA_QUALITY.HIGH;
	         * //...
	         * renderer.render(renderTexture, myContainer);
	         * renderer.framebuffer.blit(); // copies data from MSAA framebuffer to texture
	         *  ```
	         *
	         * @member {PIXI.MSAA_QUALITY}
	         * @default PIXI.MSAA_QUALITY.NONE
	         */
	        this.multisample = exports.MSAA_QUALITY.NONE;
	    }
	    Object.defineProperty(Framebuffer.prototype, "colorTexture", {
	        /**
	         * Reference to the colorTexture.
	         *
	         * @member {PIXI.BaseTexture[]}
	         * @readonly
	         */
	        get: function () {
	            return this.colorTextures[0];
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Add texture to the colorTexture array
	     *
	     * @param {number} [index=0] - Index of the array to add the texture to
	     * @param {PIXI.BaseTexture} [texture] - Texture to add to the array
	     */
	    Framebuffer.prototype.addColorTexture = function (index, texture) {
	        if (index === void 0) { index = 0; }
	        // TODO add some validation to the texture - same width / height etc?
	        this.colorTextures[index] = texture || new BaseTexture(null, {
	            scaleMode: exports.SCALE_MODES.NEAREST,
	            resolution: 1,
	            mipmap: exports.MIPMAP_MODES.OFF,
	            width: this.width,
	            height: this.height,
	        });
	        this.dirtyId++;
	        this.dirtyFormat++;
	        return this;
	    };
	    /**
	     * Add a depth texture to the frame buffer
	     *
	     * @param {PIXI.BaseTexture} [texture] - Texture to add
	     */
	    Framebuffer.prototype.addDepthTexture = function (texture) {
	        /* eslint-disable max-len */
	        this.depthTexture = texture || new BaseTexture(new DepthResource(null, { width: this.width, height: this.height }), {
	            scaleMode: exports.SCALE_MODES.NEAREST,
	            resolution: 1,
	            width: this.width,
	            height: this.height,
	            mipmap: exports.MIPMAP_MODES.OFF,
	            format: exports.FORMATS.DEPTH_COMPONENT,
	            type: exports.TYPES.UNSIGNED_SHORT,
	        });
	        this.dirtyId++;
	        this.dirtyFormat++;
	        return this;
	    };
	    /**
	     * Enable depth on the frame buffer
	     */
	    Framebuffer.prototype.enableDepth = function () {
	        this.depth = true;
	        this.dirtyId++;
	        this.dirtyFormat++;
	        return this;
	    };
	    /**
	     * Enable stencil on the frame buffer
	     */
	    Framebuffer.prototype.enableStencil = function () {
	        this.stencil = true;
	        this.dirtyId++;
	        this.dirtyFormat++;
	        return this;
	    };
	    /**
	     * Resize the frame buffer
	     *
	     * @param {number} width - Width of the frame buffer to resize to
	     * @param {number} height - Height of the frame buffer to resize to
	     */
	    Framebuffer.prototype.resize = function (width, height) {
	        width = Math.ceil(width);
	        height = Math.ceil(height);
	        if (width === this.width && height === this.height)
	            { return; }
	        this.width = width;
	        this.height = height;
	        this.dirtyId++;
	        this.dirtySize++;
	        for (var i = 0; i < this.colorTextures.length; i++) {
	            var texture = this.colorTextures[i];
	            var resolution = texture.resolution;
	            // take into acount the fact the texture may have a different resolution..
	            texture.setSize(width / resolution, height / resolution);
	        }
	        if (this.depthTexture) {
	            var resolution = this.depthTexture.resolution;
	            this.depthTexture.setSize(width / resolution, height / resolution);
	        }
	    };
	    /**
	     * Disposes WebGL resources that are connected to this geometry
	     */
	    Framebuffer.prototype.dispose = function () {
	        this.disposeRunner.emit(this, false);
	    };
	    /**
	     * Destroys and removes the depth texture added to this framebuffer.
	     */
	    Framebuffer.prototype.destroyDepthTexture = function () {
	        if (this.depthTexture) {
	            this.depthTexture.destroy();
	            this.depthTexture = null;
	            ++this.dirtyId;
	            ++this.dirtyFormat;
	        }
	    };
	    return Framebuffer;
	}());

	/**
	 * A BaseRenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
	 *
	 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a BaseRenderTexture should be preloaded
	 * otherwise black rectangles will be drawn instead.
	 *
	 * A BaseRenderTexture takes a snapshot of any Display Object given to its render method. The position
	 * and rotation of the given Display Objects is ignored. For example:
	 *
	 * ```js
	 * let renderer = PIXI.autoDetectRenderer();
	 * let baseRenderTexture = new PIXI.BaseRenderTexture({ width: 800, height: 600 });
	 * let renderTexture = new PIXI.RenderTexture(baseRenderTexture);
	 * let sprite = PIXI.Sprite.from("spinObj_01.png");
	 *
	 * sprite.position.x = 800/2;
	 * sprite.position.y = 600/2;
	 * sprite.anchor.x = 0.5;
	 * sprite.anchor.y = 0.5;
	 *
	 * renderer.render(sprite, renderTexture);
	 * ```
	 *
	 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
	 * you can clear the transform
	 *
	 * ```js
	 *
	 * sprite.setTransform()
	 *
	 * let baseRenderTexture = new PIXI.BaseRenderTexture({ width: 100, height: 100 });
	 * let renderTexture = new PIXI.RenderTexture(baseRenderTexture);
	 *
	 * renderer.render(sprite, renderTexture);  // Renders to center of RenderTexture
	 * ```
	 *
	 * @class
	 * @extends PIXI.BaseTexture
	 * @memberof PIXI
	 */
	var BaseRenderTexture = /** @class */ (function (_super) {
	    __extends$2(BaseRenderTexture, _super);
	    /**
	     * @param {object} [options]
	     * @param {number} [options.width=100] - The width of the base render texture.
	     * @param {number} [options.height=100] - The height of the base render texture.
	     * @param {PIXI.SCALE_MODES} [options.scaleMode] - See {@link PIXI.SCALE_MODES} for possible values.
	     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the texture being generated.
	     */
	    function BaseRenderTexture(options) {
	        var _this = this;
	        if (typeof options === 'number') {
	            /* eslint-disable prefer-rest-params */
	            // Backward compatibility of signature
	            var width_1 = arguments[0];
	            var height_1 = arguments[1];
	            var scaleMode = arguments[2];
	            var resolution = arguments[3];
	            options = { width: width_1, height: height_1, scaleMode: scaleMode, resolution: resolution };
	            /* eslint-enable prefer-rest-params */
	        }
	        _this = _super.call(this, null, options) || this;
	        var _a = options || {}, width = _a.width, height = _a.height;
	        // Set defaults
	        _this.mipmap = 0;
	        _this.width = Math.ceil(width) || 100;
	        _this.height = Math.ceil(height) || 100;
	        _this.valid = true;
	        _this.clearColor = [0, 0, 0, 0];
	        _this.framebuffer = new Framebuffer(_this.width * _this.resolution, _this.height * _this.resolution)
	            .addColorTexture(0, _this);
	        // TODO - could this be added the systems?
	        /**
	         * The data structure for the stencil masks.
	         *
	         * @member {PIXI.MaskData[]}
	         */
	        _this.maskStack = [];
	        /**
	         * The data structure for the filters.
	         *
	         * @member {Object[]}
	         */
	        _this.filterStack = [{}];
	        return _this;
	    }
	    /**
	     * Resizes the BaseRenderTexture.
	     *
	     * @param {number} width - The width to resize to.
	     * @param {number} height - The height to resize to.
	     */
	    BaseRenderTexture.prototype.resize = function (width, height) {
	        width = Math.ceil(width);
	        height = Math.ceil(height);
	        this.framebuffer.resize(width * this.resolution, height * this.resolution);
	    };
	    /**
	     * Frees the texture and framebuffer from WebGL memory without destroying this texture object.
	     * This means you can still use the texture later which will upload it to GPU
	     * memory again.
	     *
	     * @fires PIXI.BaseTexture#dispose
	     */
	    BaseRenderTexture.prototype.dispose = function () {
	        this.framebuffer.dispose();
	        _super.prototype.dispose.call(this);
	    };
	    /**
	     * Destroys this texture.
	     */
	    BaseRenderTexture.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.framebuffer.destroyDepthTexture();
	        this.framebuffer = null;
	    };
	    return BaseRenderTexture;
	}(BaseTexture));

	/**
	 * Stores a texture's frame in UV coordinates, in
	 * which everything lies in the rectangle `[(0,0), (1,0),
	 * (1,1), (0,1)]`.
	 *
	 * | Corner       | Coordinates |
	 * |--------------|-------------|
	 * | Top-Left     | `(x0,y0)`   |
	 * | Top-Right    | `(x1,y1)`   |
	 * | Bottom-Right | `(x2,y2)`   |
	 * | Bottom-Left  | `(x3,y3)`   |
	 *
	 * @class
	 * @protected
	 * @memberof PIXI
	 */
	var TextureUvs = /** @class */ (function () {
	    function TextureUvs() {
	        /**
	         * X-component of top-left corner `(x0,y0)`.
	         *
	         * @member {number}
	         */
	        this.x0 = 0;
	        /**
	         * Y-component of top-left corner `(x0,y0)`.
	         *
	         * @member {number}
	         */
	        this.y0 = 0;
	        /**
	         * X-component of top-right corner `(x1,y1)`.
	         *
	         * @member {number}
	         */
	        this.x1 = 1;
	        /**
	         * Y-component of top-right corner `(x1,y1)`.
	         *
	         * @member {number}
	         */
	        this.y1 = 0;
	        /**
	         * X-component of bottom-right corner `(x2,y2)`.
	         *
	         * @member {number}
	         */
	        this.x2 = 1;
	        /**
	         * Y-component of bottom-right corner `(x2,y2)`.
	         *
	         * @member {number}
	         */
	        this.y2 = 1;
	        /**
	         * X-component of bottom-left corner `(x3,y3)`.
	         *
	         * @member {number}
	         */
	        this.x3 = 0;
	        /**
	         * Y-component of bottom-right corner `(x3,y3)`.
	         *
	         * @member {number}
	         */
	        this.y3 = 1;
	        this.uvsFloat32 = new Float32Array(8);
	    }
	    /**
	     * Sets the texture Uvs based on the given frame information.
	     *
	     * @protected
	     * @param {PIXI.Rectangle} frame - The frame of the texture
	     * @param {PIXI.Rectangle} baseFrame - The base frame of the texture
	     * @param {number} rotate - Rotation of frame, see {@link PIXI.groupD8}
	     */
	    TextureUvs.prototype.set = function (frame, baseFrame, rotate) {
	        var tw = baseFrame.width;
	        var th = baseFrame.height;
	        if (rotate) {
	            // width and height div 2 div baseFrame size
	            var w2 = frame.width / 2 / tw;
	            var h2 = frame.height / 2 / th;
	            // coordinates of center
	            var cX = (frame.x / tw) + w2;
	            var cY = (frame.y / th) + h2;
	            rotate = groupD8.add(rotate, groupD8.NW); // NW is top-left corner
	            this.x0 = cX + (w2 * groupD8.uX(rotate));
	            this.y0 = cY + (h2 * groupD8.uY(rotate));
	            rotate = groupD8.add(rotate, 2); // rotate 90 degrees clockwise
	            this.x1 = cX + (w2 * groupD8.uX(rotate));
	            this.y1 = cY + (h2 * groupD8.uY(rotate));
	            rotate = groupD8.add(rotate, 2);
	            this.x2 = cX + (w2 * groupD8.uX(rotate));
	            this.y2 = cY + (h2 * groupD8.uY(rotate));
	            rotate = groupD8.add(rotate, 2);
	            this.x3 = cX + (w2 * groupD8.uX(rotate));
	            this.y3 = cY + (h2 * groupD8.uY(rotate));
	        }
	        else {
	            this.x0 = frame.x / tw;
	            this.y0 = frame.y / th;
	            this.x1 = (frame.x + frame.width) / tw;
	            this.y1 = frame.y / th;
	            this.x2 = (frame.x + frame.width) / tw;
	            this.y2 = (frame.y + frame.height) / th;
	            this.x3 = frame.x / tw;
	            this.y3 = (frame.y + frame.height) / th;
	        }
	        this.uvsFloat32[0] = this.x0;
	        this.uvsFloat32[1] = this.y0;
	        this.uvsFloat32[2] = this.x1;
	        this.uvsFloat32[3] = this.y1;
	        this.uvsFloat32[4] = this.x2;
	        this.uvsFloat32[5] = this.y2;
	        this.uvsFloat32[6] = this.x3;
	        this.uvsFloat32[7] = this.y3;
	    };
	    return TextureUvs;
	}());

	var DEFAULT_UVS = new TextureUvs();
	/**
	 * A texture stores the information that represents an image or part of an image.
	 *
	 * It cannot be added to the display list directly; instead use it as the texture for a Sprite.
	 * If no frame is provided for a texture, then the whole image is used.
	 *
	 * You can directly create a texture from an image and then reuse it multiple times like this :
	 *
	 * ```js
	 * let texture = PIXI.Texture.from('assets/image.png');
	 * let sprite1 = new PIXI.Sprite(texture);
	 * let sprite2 = new PIXI.Sprite(texture);
	 * ```
	 *
	 * If you didnt pass the texture frame to constructor, it enables `noFrame` mode:
	 * it subscribes on baseTexture events, it automatically resizes at the same time as baseTexture.
	 *
	 * Textures made from SVGs, loaded or not, cannot be used before the file finishes processing.
	 * You can check for this by checking the sprite's _textureID property.
	 * ```js
	 * var texture = PIXI.Texture.from('assets/image.svg');
	 * var sprite1 = new PIXI.Sprite(texture);
	 * //sprite1._textureID should not be undefined if the texture has finished processing the SVG file
	 * ```
	 * You can use a ticker or rAF to ensure your sprites load the finished textures after processing. See issue #3068.
	 *
	 * @class
	 * @extends PIXI.utils.EventEmitter
	 * @memberof PIXI
	 */
	var Texture = /** @class */ (function (_super) {
	    __extends$2(Texture, _super);
	    /**
	     * @param {PIXI.BaseTexture} baseTexture - The base texture source to create the texture from
	     * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
	     * @param {PIXI.Rectangle} [orig] - The area of original texture
	     * @param {PIXI.Rectangle} [trim] - Trimmed rectangle of original texture
	     * @param {number} [rotate] - indicates how the texture was rotated by texture packer. See {@link PIXI.groupD8}
	     * @param {PIXI.IPointData} [anchor] - Default anchor point used for sprite placement / rotation
	     */
	    function Texture(baseTexture, frame, orig, trim, rotate, anchor) {
	        var _this = _super.call(this) || this;
	        /**
	         * Does this Texture have any frame data assigned to it?
	         *
	         * This mode is enabled automatically if no frame was passed inside constructor.
	         *
	         * In this mode texture is subscribed to baseTexture events, and fires `update` on any change.
	         *
	         * Beware, after loading or resize of baseTexture event can fired two times!
	         * If you want more control, subscribe on baseTexture itself.
	         *
	         * ```js
	         * texture.on('update', () => {});
	         * ```
	         *
	         * Any assignment of `frame` switches off `noFrame` mode.
	         *
	         * @member {boolean}
	         */
	        _this.noFrame = false;
	        if (!frame) {
	            _this.noFrame = true;
	            frame = new Rectangle(0, 0, 1, 1);
	        }
	        if (baseTexture instanceof Texture) {
	            baseTexture = baseTexture.baseTexture;
	        }
	        /**
	         * The base texture that this texture uses.
	         *
	         * @member {PIXI.BaseTexture}
	         */
	        _this.baseTexture = baseTexture;
	        /**
	         * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
	         * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this._frame = frame;
	        /**
	         * This is the trimmed area of original texture, before it was put in atlas
	         * Please call `updateUvs()` after you change coordinates of `trim` manually.
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this.trim = trim;
	        /**
	         * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
	         *
	         * @member {boolean}
	         */
	        _this.valid = false;
	        /**
	         * The WebGL UV data cache. Can be used as quad UV
	         *
	         * @member {PIXI.TextureUvs}
	         * @protected
	         */
	        _this._uvs = DEFAULT_UVS;
	        /**
	         * Default TextureMatrix instance for this texture
	         * By default that object is not created because its heavy
	         *
	         * @member {PIXI.TextureMatrix}
	         */
	        _this.uvMatrix = null;
	        /**
	         * This is the area of original texture, before it was put in atlas
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this.orig = orig || frame; // new Rectangle(0, 0, 1, 1);
	        _this._rotate = Number(rotate || 0);
	        if (rotate === true) {
	            // this is old texturepacker legacy, some games/libraries are passing "true" for rotated textures
	            _this._rotate = 2;
	        }
	        else if (_this._rotate % 2 !== 0) {
	            throw new Error('attempt to use diamond-shaped UVs. If you are sure, set rotation manually');
	        }
	        /**
	         * Anchor point that is used as default if sprite is created with this texture.
	         * Changing the `defaultAnchor` at a later point of time will not update Sprite's anchor point.
	         * @member {PIXI.Point}
	         * @default {0,0}
	         */
	        _this.defaultAnchor = anchor ? new Point(anchor.x, anchor.y) : new Point(0, 0);
	        /**
	         * Update ID is observed by sprites and TextureMatrix instances.
	         * Call updateUvs() to increment it.
	         *
	         * @member {number}
	         * @protected
	         */
	        _this._updateID = 0;
	        /**
	         * The ids under which this Texture has been added to the texture cache. This is
	         * automatically set as long as Texture.addToCache is used, but may not be set if a
	         * Texture is added directly to the TextureCache array.
	         *
	         * @member {string[]}
	         */
	        _this.textureCacheIds = [];
	        if (!baseTexture.valid) {
	            baseTexture.once('loaded', _this.onBaseTextureUpdated, _this);
	        }
	        else if (_this.noFrame) {
	            // if there is no frame we should monitor for any base texture changes..
	            if (baseTexture.valid) {
	                _this.onBaseTextureUpdated(baseTexture);
	            }
	        }
	        else {
	            _this.frame = frame;
	        }
	        if (_this.noFrame) {
	            baseTexture.on('update', _this.onBaseTextureUpdated, _this);
	        }
	        return _this;
	    }
	    /**
	     * Updates this texture on the gpu.
	     *
	     * Calls the TextureResource update.
	     *
	     * If you adjusted `frame` manually, please call `updateUvs()` instead.
	     *
	     */
	    Texture.prototype.update = function () {
	        if (this.baseTexture.resource) {
	            this.baseTexture.resource.update();
	        }
	    };
	    /**
	     * Called when the base texture is updated
	     *
	     * @protected
	     * @param {PIXI.BaseTexture} baseTexture - The base texture.
	     */
	    Texture.prototype.onBaseTextureUpdated = function (baseTexture) {
	        if (this.noFrame) {
	            if (!this.baseTexture.valid) {
	                return;
	            }
	            this._frame.width = baseTexture.width;
	            this._frame.height = baseTexture.height;
	            this.valid = true;
	            this.updateUvs();
	        }
	        else {
	            // TODO this code looks confusing.. boo to abusing getters and setters!
	            // if user gave us frame that has bigger size than resized texture it can be a problem
	            this.frame = this._frame;
	        }
	        this.emit('update', this);
	    };
	    /**
	     * Destroys this texture
	     *
	     * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
	     */
	    Texture.prototype.destroy = function (destroyBase) {
	        if (this.baseTexture) {
	            if (destroyBase) {
	                var resource = this.baseTexture;
	                // delete the texture if it exists in the texture cache..
	                // this only needs to be removed if the base texture is actually destroyed too..
	                if (resource && resource.url && TextureCache[resource.url]) {
	                    Texture.removeFromCache(resource.url);
	                }
	                this.baseTexture.destroy();
	            }
	            this.baseTexture.off('loaded', this.onBaseTextureUpdated, this);
	            this.baseTexture.off('update', this.onBaseTextureUpdated, this);
	            this.baseTexture = null;
	        }
	        this._frame = null;
	        this._uvs = null;
	        this.trim = null;
	        this.orig = null;
	        this.valid = false;
	        Texture.removeFromCache(this);
	        this.textureCacheIds = null;
	    };
	    /**
	     * Creates a new texture object that acts the same as this one.
	     *
	     * @return {PIXI.Texture} The new texture
	     */
	    Texture.prototype.clone = function () {
	        return new Texture(this.baseTexture, this.frame.clone(), this.orig.clone(), this.trim && this.trim.clone(), this.rotate, this.defaultAnchor);
	    };
	    /**
	     * Updates the internal WebGL UV cache. Use it after you change `frame` or `trim` of the texture.
	     * Call it after changing the frame
	     */
	    Texture.prototype.updateUvs = function () {
	        if (this._uvs === DEFAULT_UVS) {
	            this._uvs = new TextureUvs();
	        }
	        this._uvs.set(this._frame, this.baseTexture, this.rotate);
	        this._updateID++;
	    };
	    /**
	     * Helper function that creates a new Texture based on the source you provide.
	     * The source can be - frame id, image url, video url, canvas element, video element, base texture
	     *
	     * @static
	     * @param {string|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|PIXI.BaseTexture} source
	     *        Source to create texture from
	     * @param {object} [options] See {@link PIXI.BaseTexture}'s constructor for options.
	     * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
	     * @return {PIXI.Texture} The newly created texture
	     */
	    Texture.from = function (source, options, strict) {
	        if (options === void 0) { options = {}; }
	        if (strict === void 0) { strict = settings.STRICT_TEXTURE_CACHE; }
	        var isFrame = typeof source === 'string';
	        var cacheId = null;
	        if (isFrame) {
	            cacheId = source;
	        }
	        else {
	            if (!source._pixiId) {
	                source._pixiId = "pixiid_" + uid();
	            }
	            cacheId = source._pixiId;
	        }
	        var texture = TextureCache[cacheId];
	        // Strict-mode rejects invalid cacheIds
	        if (isFrame && strict && !texture) {
	            throw new Error("The cacheId \"" + cacheId + "\" does not exist in TextureCache.");
	        }
	        if (!texture) {
	            if (!options.resolution) {
	                options.resolution = getResolutionOfUrl(source);
	            }
	            texture = new Texture(new BaseTexture(source, options));
	            texture.baseTexture.cacheId = cacheId;
	            BaseTexture.addToCache(texture.baseTexture, cacheId);
	            Texture.addToCache(texture, cacheId);
	        }
	        // lets assume its a base texture!
	        return texture;
	    };
	    /**
	     * Useful for loading textures via URLs. Use instead of `Texture.from` because
	     * it does a better job of handling failed URLs more effectively. This also ignores
	     * `PIXI.settings.STRICT_TEXTURE_CACHE`. Works for Videos, SVGs, Images.
	     * @param {string} url The remote URL to load.
	     * @param {object} [options] Optional options to include
	     * @return {Promise<PIXI.Texture>} A Promise that resolves to a Texture.
	     */
	    Texture.fromURL = function (url, options) {
	        var resourceOptions = Object.assign({ autoLoad: false }, options === null || options === void 0 ? void 0 : options.resourceOptions);
	        var texture = Texture.from(url, Object.assign({ resourceOptions: resourceOptions }, options), false);
	        var resource = texture.baseTexture.resource;
	        // The texture was already loaded
	        if (texture.baseTexture.valid) {
	            return Promise.resolve(texture);
	        }
	        // Manually load the texture, this should allow users to handle load errors
	        return resource.load().then(function () { return Promise.resolve(texture); });
	    };
	    /**
	     * Create a new Texture with a BufferResource from a Float32Array.
	     * RGBA values are floats from 0 to 1.
	     * @static
	     * @param {Float32Array|Uint8Array} buffer - The optional array to use, if no data
	     *        is provided, a new Float32Array is created.
	     * @param {number} width - Width of the resource
	     * @param {number} height - Height of the resource
	     * @param {object} [options] See {@link PIXI.BaseTexture}'s constructor for options.
	     * @return {PIXI.Texture} The resulting new BaseTexture
	     */
	    Texture.fromBuffer = function (buffer, width, height, options) {
	        return new Texture(BaseTexture.fromBuffer(buffer, width, height, options));
	    };
	    /**
	     * Create a texture from a source and add to the cache.
	     *
	     * @static
	     * @param {HTMLImageElement|HTMLCanvasElement} source - The input source.
	     * @param {String} imageUrl - File name of texture, for cache and resolving resolution.
	     * @param {String} [name] - Human readable name for the texture cache. If no name is
	     *        specified, only `imageUrl` will be used as the cache ID.
	     * @return {PIXI.Texture} Output texture
	     */
	    Texture.fromLoader = function (source, imageUrl, name) {
	        var resource = new ImageResource(source);
	        resource.url = imageUrl;
	        var baseTexture = new BaseTexture(resource, {
	            scaleMode: settings.SCALE_MODE,
	            resolution: getResolutionOfUrl(imageUrl),
	        });
	        var texture = new Texture(baseTexture);
	        // No name, use imageUrl instead
	        if (!name) {
	            name = imageUrl;
	        }
	        // lets also add the frame to pixi's global cache for 'fromLoader' function
	        BaseTexture.addToCache(texture.baseTexture, name);
	        Texture.addToCache(texture, name);
	        // also add references by url if they are different.
	        if (name !== imageUrl) {
	            BaseTexture.addToCache(texture.baseTexture, imageUrl);
	            Texture.addToCache(texture, imageUrl);
	        }
	        return texture;
	    };
	    /**
	     * Adds a Texture to the global TextureCache. This cache is shared across the whole PIXI object.
	     *
	     * @static
	     * @param {PIXI.Texture} texture - The Texture to add to the cache.
	     * @param {string} id - The id that the Texture will be stored against.
	     */
	    Texture.addToCache = function (texture, id) {
	        if (id) {
	            if (texture.textureCacheIds.indexOf(id) === -1) {
	                texture.textureCacheIds.push(id);
	            }
	            if (TextureCache[id]) {
	                // eslint-disable-next-line no-console
	                console.warn("Texture added to the cache with an id [" + id + "] that already had an entry");
	            }
	            TextureCache[id] = texture;
	        }
	    };
	    /**
	     * Remove a Texture from the global TextureCache.
	     *
	     * @static
	     * @param {string|PIXI.Texture} texture - id of a Texture to be removed, or a Texture instance itself
	     * @return {PIXI.Texture|null} The Texture that was removed
	     */
	    Texture.removeFromCache = function (texture) {
	        if (typeof texture === 'string') {
	            var textureFromCache = TextureCache[texture];
	            if (textureFromCache) {
	                var index = textureFromCache.textureCacheIds.indexOf(texture);
	                if (index > -1) {
	                    textureFromCache.textureCacheIds.splice(index, 1);
	                }
	                delete TextureCache[texture];
	                return textureFromCache;
	            }
	        }
	        else if (texture && texture.textureCacheIds) {
	            for (var i = 0; i < texture.textureCacheIds.length; ++i) {
	                // Check that texture matches the one being passed in before deleting it from the cache.
	                if (TextureCache[texture.textureCacheIds[i]] === texture) {
	                    delete TextureCache[texture.textureCacheIds[i]];
	                }
	            }
	            texture.textureCacheIds.length = 0;
	            return texture;
	        }
	        return null;
	    };
	    Object.defineProperty(Texture.prototype, "resolution", {
	        /**
	         * Returns resolution of baseTexture
	         *
	         * @member {number}
	         * @readonly
	         */
	        get: function () {
	            return this.baseTexture.resolution;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Texture.prototype, "frame", {
	        /**
	         * The frame specifies the region of the base texture that this texture uses.
	         * Please call `updateUvs()` after you change coordinates of `frame` manually.
	         *
	         * @member {PIXI.Rectangle}
	         */
	        get: function () {
	            return this._frame;
	        },
	        set: function (frame) {
	            this._frame = frame;
	            this.noFrame = false;
	            var x = frame.x, y = frame.y, width = frame.width, height = frame.height;
	            var xNotFit = x + width > this.baseTexture.width;
	            var yNotFit = y + height > this.baseTexture.height;
	            if (xNotFit || yNotFit) {
	                var relationship = xNotFit && yNotFit ? 'and' : 'or';
	                var errorX = "X: " + x + " + " + width + " = " + (x + width) + " > " + this.baseTexture.width;
	                var errorY = "Y: " + y + " + " + height + " = " + (y + height) + " > " + this.baseTexture.height;
	                throw new Error('Texture Error: frame does not fit inside the base Texture dimensions: '
	                    + (errorX + " " + relationship + " " + errorY));
	            }
	            this.valid = width && height && this.baseTexture.valid;
	            if (!this.trim && !this.rotate) {
	                this.orig = frame;
	            }
	            if (this.valid) {
	                this.updateUvs();
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Texture.prototype, "rotate", {
	        /**
	         * Indicates whether the texture is rotated inside the atlas
	         * set to 2 to compensate for texture packer rotation
	         * set to 6 to compensate for spine packer rotation
	         * can be used to rotate or mirror sprites
	         * See {@link PIXI.groupD8} for explanation
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._rotate;
	        },
	        set: function (rotate) {
	            this._rotate = rotate;
	            if (this.valid) {
	                this.updateUvs();
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Texture.prototype, "width", {
	        /**
	         * The width of the Texture in pixels.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this.orig.width;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Texture.prototype, "height", {
	        /**
	         * The height of the Texture in pixels.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this.orig.height;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Utility function for BaseTexture|Texture cast
	     */
	    Texture.prototype.castToBaseTexture = function () {
	        return this.baseTexture;
	    };
	    return Texture;
	}(eventemitter3));
	function createWhiteTexture() {
	    var canvas = document.createElement('canvas');
	    canvas.width = 16;
	    canvas.height = 16;
	    var context = canvas.getContext('2d');
	    context.fillStyle = 'white';
	    context.fillRect(0, 0, 16, 16);
	    return new Texture(new BaseTexture(new CanvasResource(canvas)));
	}
	function removeAllHandlers(tex) {
	    tex.destroy = function _emptyDestroy() { };
	    tex.on = function _emptyOn() { };
	    tex.once = function _emptyOnce() { };
	    tex.emit = function _emptyEmit() { };
	}
	/**
	 * An empty texture, used often to not have to create multiple empty textures.
	 * Can not be destroyed.
	 *
	 * @static
	 * @constant
	 * @member {PIXI.Texture}
	 */
	Texture.EMPTY = new Texture(new BaseTexture());
	removeAllHandlers(Texture.EMPTY);
	removeAllHandlers(Texture.EMPTY.baseTexture);
	/**
	 * A white texture of 16x16 size, used for graphics and other things
	 * Can not be destroyed.
	 *
	 * @static
	 * @constant
	 * @member {PIXI.Texture}
	 */
	Texture.WHITE = createWhiteTexture();
	removeAllHandlers(Texture.WHITE);
	removeAllHandlers(Texture.WHITE.baseTexture);

	/**
	 * A RenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
	 *
	 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a RenderTexture should be preloaded
	 * otherwise black rectangles will be drawn instead.
	 *
	 * __Hint-2__: The actual memory allocation will happen on first render.
	 * You shouldn't create renderTextures each frame just to delete them after, try to reuse them.
	 *
	 * A RenderTexture takes a snapshot of any Display Object given to its render method. For example:
	 *
	 * ```js
	 * let renderer = PIXI.autoDetectRenderer();
	 * let renderTexture = PIXI.RenderTexture.create({ width: 800, height: 600 });
	 * let sprite = PIXI.Sprite.from("spinObj_01.png");
	 *
	 * sprite.position.x = 800/2;
	 * sprite.position.y = 600/2;
	 * sprite.anchor.x = 0.5;
	 * sprite.anchor.y = 0.5;
	 *
	 * renderer.render(sprite, renderTexture);
	 * ```
	 *
	 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
	 * you can clear the transform
	 *
	 * ```js
	 *
	 * sprite.setTransform()
	 *
	 * let renderTexture = new PIXI.RenderTexture.create(100, 100);
	 *
	 * renderer.render(sprite, renderTexture);  // Renders to center of RenderTexture
	 * ```
	 *
	 * @class
	 * @extends PIXI.Texture
	 * @memberof PIXI
	 */
	var RenderTexture = /** @class */ (function (_super) {
	    __extends$2(RenderTexture, _super);
	    /**
	     * @param {PIXI.BaseRenderTexture} baseRenderTexture - The base texture object that this texture uses
	     * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
	     */
	    function RenderTexture(baseRenderTexture, frame) {
	        var _this = this;
	        // support for legacy..
	        var _legacyRenderer = null;
	        if (!(baseRenderTexture instanceof BaseRenderTexture)) {
	            /* eslint-disable prefer-rest-params, no-console */
	            var width = arguments[1];
	            var height = arguments[2];
	            var scaleMode = arguments[3];
	            var resolution = arguments[4];
	            // we have an old render texture..
	            console.warn("Please use RenderTexture.create(" + width + ", " + height + ") instead of the ctor directly.");
	            _legacyRenderer = arguments[0];
	            /* eslint-enable prefer-rest-params, no-console */
	            frame = null;
	            baseRenderTexture = new BaseRenderTexture({
	                width: width,
	                height: height,
	                scaleMode: scaleMode,
	                resolution: resolution,
	            });
	        }
	        /**
	         * The base texture object that this texture uses
	         *
	         * @member {PIXI.BaseTexture}
	         */
	        _this = _super.call(this, baseRenderTexture, frame) || this;
	        _this.legacyRenderer = _legacyRenderer;
	        /**
	         * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
	         *
	         * @member {boolean}
	         */
	        _this.valid = true;
	        /**
	         * Stores `sourceFrame` when this texture is inside current filter stack.
	         * You can read it inside filters.
	         *
	         * @readonly
	         * @member {PIXI.Rectangle}
	         */
	        _this.filterFrame = null;
	        /**
	         * The key for pooled texture of FilterSystem
	         * @protected
	         * @member {string}
	         */
	        _this.filterPoolKey = null;
	        _this.updateUvs();
	        return _this;
	    }
	    Object.defineProperty(RenderTexture.prototype, "framebuffer", {
	        /**
	         * Shortcut to `this.baseTexture.framebuffer`, saves baseTexture cast.
	         * @member {PIXI.Framebuffer}
	         * @readonly
	         */
	        get: function () {
	            return this.baseTexture.framebuffer;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Resizes the RenderTexture.
	     *
	     * @param {number} width - The width to resize to.
	     * @param {number} height - The height to resize to.
	     * @param {boolean} [resizeBaseTexture=true] - Should the baseTexture.width and height values be resized as well?
	     */
	    RenderTexture.prototype.resize = function (width, height, resizeBaseTexture) {
	        if (resizeBaseTexture === void 0) { resizeBaseTexture = true; }
	        width = Math.ceil(width);
	        height = Math.ceil(height);
	        // TODO - could be not required..
	        this.valid = (width > 0 && height > 0);
	        this._frame.width = this.orig.width = width;
	        this._frame.height = this.orig.height = height;
	        if (resizeBaseTexture) {
	            this.baseTexture.resize(width, height);
	        }
	        this.updateUvs();
	    };
	    /**
	     * Changes the resolution of baseTexture, but does not change framebuffer size.
	     *
	     * @param {number} resolution - The new resolution to apply to RenderTexture
	     */
	    RenderTexture.prototype.setResolution = function (resolution) {
	        var baseTexture = this.baseTexture;
	        if (baseTexture.resolution === resolution) {
	            return;
	        }
	        baseTexture.setResolution(resolution);
	        this.resize(baseTexture.width, baseTexture.height, false);
	    };
	    /**
	     * A short hand way of creating a render texture.
	     *
	     * @param {object} [options] - Options
	     * @param {number} [options.width=100] - The width of the render texture
	     * @param {number} [options.height=100] - The height of the render texture
	     * @param {number} [options.scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
	     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the texture being generated
	     * @return {PIXI.RenderTexture} The new render texture
	     */
	    RenderTexture.create = function (options) {
	        // fallback, old-style: create(width, height, scaleMode, resolution)
	        if (typeof options === 'number') {
	            /* eslint-disable prefer-rest-params */
	            options = {
	                width: options,
	                height: arguments[1],
	                scaleMode: arguments[2],
	                resolution: arguments[3],
	            };
	            /* eslint-enable prefer-rest-params */
	        }
	        return new RenderTexture(new BaseRenderTexture(options));
	    };
	    return RenderTexture;
	}(Texture));

	/**
	 * Experimental!
	 *
	 * Texture pool, used by FilterSystem and plugins
	 * Stores collection of temporary pow2 or screen-sized renderTextures
	 *
	 * If you use custom RenderTexturePool for your filters, you can use methods
	 * `getFilterTexture` and `returnFilterTexture` same as in
	 *
	 * @class
	 * @memberof PIXI
	 */
	var RenderTexturePool = /** @class */ (function () {
	    /**
	     * @param {object} [textureOptions] - options that will be passed to BaseRenderTexture constructor
	     * @param {PIXI.SCALE_MODES} [textureOptions.scaleMode] - See {@link PIXI.SCALE_MODES} for possible values.
	     */
	    function RenderTexturePool(textureOptions) {
	        this.texturePool = {};
	        this.textureOptions = textureOptions || {};
	        /**
	         * Allow renderTextures of the same size as screen, not just pow2
	         *
	         * Automatically sets to true after `setScreenSize`
	         *
	         * @member {boolean}
	         * @default false
	         */
	        this.enableFullScreen = false;
	        this._pixelsWidth = 0;
	        this._pixelsHeight = 0;
	    }
	    /**
	     * creates of texture with params that were specified in pool constructor
	     *
	     * @param {number} realWidth - width of texture in pixels
	     * @param {number} realHeight - height of texture in pixels
	     * @returns {RenderTexture}
	     */
	    RenderTexturePool.prototype.createTexture = function (realWidth, realHeight) {
	        var baseRenderTexture = new BaseRenderTexture(Object.assign({
	            width: realWidth,
	            height: realHeight,
	            resolution: 1,
	        }, this.textureOptions));
	        return new RenderTexture(baseRenderTexture);
	    };
	    /**
	     * Gets a Power-of-Two render texture or fullScreen texture
	     *
	     * @protected
	     * @param {number} minWidth - The minimum width of the render texture in real pixels.
	     * @param {number} minHeight - The minimum height of the render texture in real pixels.
	     * @param {number} [resolution=1] - The resolution of the render texture.
	     * @return {PIXI.RenderTexture} The new render texture.
	     */
	    RenderTexturePool.prototype.getOptimalTexture = function (minWidth, minHeight, resolution) {
	        if (resolution === void 0) { resolution = 1; }
	        var key = RenderTexturePool.SCREEN_KEY;
	        minWidth *= resolution;
	        minHeight *= resolution;
	        if (!this.enableFullScreen || minWidth !== this._pixelsWidth || minHeight !== this._pixelsHeight) {
	            minWidth = nextPow2(minWidth);
	            minHeight = nextPow2(minHeight);
	            key = ((minWidth & 0xFFFF) << 16) | (minHeight & 0xFFFF);
	        }
	        if (!this.texturePool[key]) {
	            this.texturePool[key] = [];
	        }
	        var renderTexture = this.texturePool[key].pop();
	        if (!renderTexture) {
	            renderTexture = this.createTexture(minWidth, minHeight);
	        }
	        renderTexture.filterPoolKey = key;
	        renderTexture.setResolution(resolution);
	        return renderTexture;
	    };
	    /**
	     * Gets extra texture of the same size as input renderTexture
	     *
	     * `getFilterTexture(input, 0.5)` or `getFilterTexture(0.5, input)`
	     *
	     * @param {PIXI.RenderTexture} input - renderTexture from which size and resolution will be copied
	     * @param {number} [resolution] - override resolution of the renderTexture
	     *  It overrides, it does not multiply
	     * @returns {PIXI.RenderTexture}
	     */
	    RenderTexturePool.prototype.getFilterTexture = function (input, resolution) {
	        var filterTexture = this.getOptimalTexture(input.width, input.height, resolution || input.resolution);
	        filterTexture.filterFrame = input.filterFrame;
	        return filterTexture;
	    };
	    /**
	     * Place a render texture back into the pool.
	     * @param {PIXI.RenderTexture} renderTexture - The renderTexture to free
	     */
	    RenderTexturePool.prototype.returnTexture = function (renderTexture) {
	        var key = renderTexture.filterPoolKey;
	        renderTexture.filterFrame = null;
	        this.texturePool[key].push(renderTexture);
	    };
	    /**
	     * Alias for returnTexture, to be compliant with FilterSystem interface
	     * @param {PIXI.RenderTexture} renderTexture - The renderTexture to free
	     */
	    RenderTexturePool.prototype.returnFilterTexture = function (renderTexture) {
	        this.returnTexture(renderTexture);
	    };
	    /**
	     * Clears the pool
	     *
	     * @param {boolean} [destroyTextures=true] - destroy all stored textures
	     */
	    RenderTexturePool.prototype.clear = function (destroyTextures) {
	        destroyTextures = destroyTextures !== false;
	        if (destroyTextures) {
	            for (var i in this.texturePool) {
	                var textures = this.texturePool[i];
	                if (textures) {
	                    for (var j = 0; j < textures.length; j++) {
	                        textures[j].destroy(true);
	                    }
	                }
	            }
	        }
	        this.texturePool = {};
	    };
	    /**
	     * If screen size was changed, drops all screen-sized textures,
	     * sets new screen size, sets `enableFullScreen` to true
	     *
	     * Size is measured in pixels, `renderer.view` can be passed here, not `renderer.screen`
	     *
	     * @param {PIXI.ISize} size - Initial size of screen
	     */
	    RenderTexturePool.prototype.setScreenSize = function (size) {
	        if (size.width === this._pixelsWidth
	            && size.height === this._pixelsHeight) {
	            return;
	        }
	        var screenKey = RenderTexturePool.SCREEN_KEY;
	        var textures = this.texturePool[screenKey];
	        this.enableFullScreen = size.width > 0 && size.height > 0;
	        if (textures) {
	            for (var j = 0; j < textures.length; j++) {
	                textures[j].destroy(true);
	            }
	        }
	        this.texturePool[screenKey] = [];
	        this._pixelsWidth = size.width;
	        this._pixelsHeight = size.height;
	    };
	    /**
	     * Key that is used to store fullscreen renderTextures in a pool
	     *
	     * @static
	     * @const {string}
	     */
	    RenderTexturePool.SCREEN_KEY = 'screen';
	    return RenderTexturePool;
	}());

	/* eslint-disable max-len */
	/**
	 * Holds the information for a single attribute structure required to render geometry.
	 *
	 * This does not contain the actual data, but instead has a buffer id that maps to a {@link PIXI.Buffer}
	 * This can include anything from positions, uvs, normals, colors etc.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Attribute = /** @class */ (function () {
	    /**
	     * @param {string} buffer - the id of the buffer that this attribute will look for
	     * @param {Number} [size=0] - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2.
	     * @param {Boolean} [normalized=false] - should the data be normalized.
	     * @param {Number} [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
	     * @param {Number} [stride=0] - How far apart (in floats) the start of each value is. (used for interleaving data)
	     * @param {Number} [start=0] - How far into the array to start reading values (used for interleaving data)
	     */
	    function Attribute(buffer, size, normalized, type, stride, start, instance) {
	        if (size === void 0) { size = 0; }
	        if (normalized === void 0) { normalized = false; }
	        if (type === void 0) { type = 5126; }
	        this.buffer = buffer;
	        this.size = size;
	        this.normalized = normalized;
	        this.type = type;
	        this.stride = stride;
	        this.start = start;
	        this.instance = instance;
	    }
	    /**
	     * Destroys the Attribute.
	     */
	    Attribute.prototype.destroy = function () {
	        this.buffer = null;
	    };
	    /**
	     * Helper function that creates an Attribute based on the information provided
	     *
	     * @static
	     * @param {string} buffer - the id of the buffer that this attribute will look for
	     * @param {Number} [size=0] - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
	     * @param {Boolean} [normalized=false] - should the data be normalized.
	     * @param {Number} [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
	     * @param {Number} [stride=0] - How far apart (in floats) the start of each value is. (used for interleaving data)
	     *
	     * @returns {PIXI.Attribute} A new {@link PIXI.Attribute} based on the information provided
	     */
	    Attribute.from = function (buffer, size, normalized, type, stride) {
	        return new Attribute(buffer, size, normalized, type, stride);
	    };
	    return Attribute;
	}());

	var UID = 0;
	/**
	 * A wrapper for data so that it can be used and uploaded by WebGL
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Buffer = /** @class */ (function () {
	    /**
	     * @param {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} data - the data to store in the buffer.
	     * @param {boolean} [_static=true] - `true` for static buffer
	     * @param {boolean} [index=false] - `true` for index buffer
	     */
	    function Buffer(data, _static, index) {
	        if (_static === void 0) { _static = true; }
	        if (index === void 0) { index = false; }
	        /**
	         * The data in the buffer, as a typed array
	         *
	         * @member {ArrayBuffer| SharedArrayBuffer | ArrayBufferView}
	         */
	        this.data = (data || new Float32Array(1));
	        /**
	         * A map of renderer IDs to webgl buffer
	         *
	         * @private
	         * @member {object<number, GLBuffer>}
	         */
	        this._glBuffers = {};
	        this._updateID = 0;
	        this.index = index;
	        this.static = _static;
	        this.id = UID++;
	        this.disposeRunner = new Runner('disposeBuffer');
	    }
	    // TODO could explore flagging only a partial upload?
	    /**
	     * flags this buffer as requiring an upload to the GPU
	     * @param {ArrayBuffer|SharedArrayBuffer|ArrayBufferView} [data] - the data to update in the buffer.
	     */
	    Buffer.prototype.update = function (data) {
	        this.data = data || this.data;
	        this._updateID++;
	    };
	    /**
	     * disposes WebGL resources that are connected to this geometry
	     */
	    Buffer.prototype.dispose = function () {
	        this.disposeRunner.emit(this, false);
	    };
	    /**
	     * Destroys the buffer
	     */
	    Buffer.prototype.destroy = function () {
	        this.dispose();
	        this.data = null;
	    };
	    /**
	     * Helper function that creates a buffer based on an array or TypedArray
	     *
	     * @static
	     * @param {ArrayBufferView | number[]} data - the TypedArray that the buffer will store. If this is a regular Array it will be converted to a Float32Array.
	     * @return {PIXI.Buffer} A new Buffer based on the data provided.
	     */
	    Buffer.from = function (data) {
	        if (data instanceof Array) {
	            data = new Float32Array(data);
	        }
	        return new Buffer(data);
	    };
	    return Buffer;
	}());

	function getBufferType$1(array) {
	    if (array.BYTES_PER_ELEMENT === 4) {
	        if (array instanceof Float32Array) {
	            return 'Float32Array';
	        }
	        else if (array instanceof Uint32Array) {
	            return 'Uint32Array';
	        }
	        return 'Int32Array';
	    }
	    else if (array.BYTES_PER_ELEMENT === 2) {
	        if (array instanceof Uint16Array) {
	            return 'Uint16Array';
	        }
	    }
	    else if (array.BYTES_PER_ELEMENT === 1) {
	        if (array instanceof Uint8Array) {
	            return 'Uint8Array';
	        }
	    }
	    // TODO map out the rest of the array elements!
	    return null;
	}

	/* eslint-disable object-shorthand */
	var map$1 = {
	    Float32Array: Float32Array,
	    Uint32Array: Uint32Array,
	    Int32Array: Int32Array,
	    Uint8Array: Uint8Array,
	};
	function interleaveTypedArrays$1(arrays, sizes) {
	    var outSize = 0;
	    var stride = 0;
	    var views = {};
	    for (var i = 0; i < arrays.length; i++) {
	        stride += sizes[i];
	        outSize += arrays[i].length;
	    }
	    var buffer = new ArrayBuffer(outSize * 4);
	    var out = null;
	    var littleOffset = 0;
	    for (var i = 0; i < arrays.length; i++) {
	        var size = sizes[i];
	        var array = arrays[i];
	        var type = getBufferType$1(array);
	        if (!views[type]) {
	            views[type] = new map$1[type](buffer);
	        }
	        out = views[type];
	        for (var j = 0; j < array.length; j++) {
	            var indexStart = ((j / size | 0) * stride) + littleOffset;
	            var index = j % size;
	            out[indexStart + index] = array[j];
	        }
	        littleOffset += size;
	    }
	    return new Float32Array(buffer);
	}

	var byteSizeMap = { 5126: 4, 5123: 2, 5121: 1 };
	var UID$1 = 0;
	/* eslint-disable object-shorthand */
	var map$1$1 = {
	    Float32Array: Float32Array,
	    Uint32Array: Uint32Array,
	    Int32Array: Int32Array,
	    Uint8Array: Uint8Array,
	    Uint16Array: Uint16Array,
	};
	/* eslint-disable max-len */
	/**
	 * The Geometry represents a model. It consists of two components:
	 * - GeometryStyle - The structure of the model such as the attributes layout
	 * - GeometryData - the data of the model - this consists of buffers.
	 * This can include anything from positions, uvs, normals, colors etc.
	 *
	 * Geometry can be defined without passing in a style or data if required (thats how I prefer!)
	 *
	 * ```js
	 * let geometry = new PIXI.Geometry();
	 *
	 * geometry.addAttribute('positions', [0, 0, 100, 0, 100, 100, 0, 100], 2);
	 * geometry.addAttribute('uvs', [0,0,1,0,1,1,0,1],2)
	 * geometry.addIndex([0,1,2,1,3,2])
	 *
	 * ```
	 * @class
	 * @memberof PIXI
	 */
	var Geometry = /** @class */ (function () {
	    /**
	     * @param {PIXI.Buffer[]} [buffers] - an array of buffers. optional.
	     * @param {object} [attributes] - of the geometry, optional structure of the attributes layout
	     */
	    function Geometry(buffers, attributes) {
	        if (buffers === void 0) { buffers = []; }
	        if (attributes === void 0) { attributes = {}; }
	        this.buffers = buffers;
	        this.indexBuffer = null;
	        this.attributes = attributes;
	        /**
	         * A map of renderer IDs to webgl VAOs
	         *
	         * @protected
	         * @type {object}
	         */
	        this.glVertexArrayObjects = {};
	        this.id = UID$1++;
	        this.instanced = false;
	        /**
	         * Number of instances in this geometry, pass it to `GeometrySystem.draw()`
	         * @member {number}
	         * @default 1
	         */
	        this.instanceCount = 1;
	        this.disposeRunner = new Runner('disposeGeometry');
	        /**
	         * Count of existing (not destroyed) meshes that reference this geometry
	         * @member {number}
	         */
	        this.refCount = 0;
	    }
	    /**
	    *
	    * Adds an attribute to the geometry
	    * Note: `stride` and `start` should be `undefined` if you dont know them, not 0!
	    *
	    * @param {String} id - the name of the attribute (matching up to a shader)
	    * @param {PIXI.Buffer|number[]} [buffer] - the buffer that holds the data of the attribute . You can also provide an Array and a buffer will be created from it.
	    * @param {Number} [size=0] - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
	    * @param {Boolean} [normalized=false] - should the data be normalized.
	    * @param {Number} [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {PIXI.TYPES} to see the ones available
	    * @param {Number} [stride] - How far apart (in floats) the start of each value is. (used for interleaving data)
	    * @param {Number} [start] - How far into the array to start reading values (used for interleaving data)
	    * @param {boolean} [instance=false] - Instancing flag
	    *
	    * @return {PIXI.Geometry} returns self, useful for chaining.
	    */
	    Geometry.prototype.addAttribute = function (id, buffer, size, normalized, type, stride, start, instance) {
	        if (size === void 0) { size = 0; }
	        if (normalized === void 0) { normalized = false; }
	        if (instance === void 0) { instance = false; }
	        if (!buffer) {
	            throw new Error('You must pass a buffer when creating an attribute');
	        }
	        // check if this is a buffer!
	        if (!(buffer instanceof Buffer)) {
	            // its an array!
	            if (buffer instanceof Array) {
	                buffer = new Float32Array(buffer);
	            }
	            buffer = new Buffer(buffer);
	        }
	        var ids = id.split('|');
	        if (ids.length > 1) {
	            for (var i = 0; i < ids.length; i++) {
	                this.addAttribute(ids[i], buffer, size, normalized, type);
	            }
	            return this;
	        }
	        var bufferIndex = this.buffers.indexOf(buffer);
	        if (bufferIndex === -1) {
	            this.buffers.push(buffer);
	            bufferIndex = this.buffers.length - 1;
	        }
	        this.attributes[id] = new Attribute(bufferIndex, size, normalized, type, stride, start, instance);
	        // assuming that if there is instanced data then this will be drawn with instancing!
	        this.instanced = this.instanced || instance;
	        return this;
	    };
	    /**
	     * returns the requested attribute
	     *
	     * @param {String} id - the name of the attribute required
	     * @return {PIXI.Attribute} the attribute requested.
	     */
	    Geometry.prototype.getAttribute = function (id) {
	        return this.attributes[id];
	    };
	    /**
	     * returns the requested buffer
	     *
	     * @param {String} id - the name of the buffer required
	     * @return {PIXI.Buffer} the buffer requested.
	     */
	    Geometry.prototype.getBuffer = function (id) {
	        return this.buffers[this.getAttribute(id).buffer];
	    };
	    /**
	    *
	    * Adds an index buffer to the geometry
	    * The index buffer contains integers, three for each triangle in the geometry, which reference the various attribute buffers (position, colour, UV coordinates, other UV coordinates, normal, â€¦). There is only ONE index buffer.
	    *
	    * @param {PIXI.Buffer|number[]} [buffer] - the buffer that holds the data of the index buffer. You can also provide an Array and a buffer will be created from it.
	    * @return {PIXI.Geometry} returns self, useful for chaining.
	    */
	    Geometry.prototype.addIndex = function (buffer) {
	        if (!(buffer instanceof Buffer)) {
	            // its an array!
	            if (buffer instanceof Array) {
	                buffer = new Uint16Array(buffer);
	            }
	            buffer = new Buffer(buffer);
	        }
	        buffer.index = true;
	        this.indexBuffer = buffer;
	        if (this.buffers.indexOf(buffer) === -1) {
	            this.buffers.push(buffer);
	        }
	        return this;
	    };
	    /**
	     * returns the index buffer
	     *
	     * @return {PIXI.Buffer} the index buffer.
	     */
	    Geometry.prototype.getIndex = function () {
	        return this.indexBuffer;
	    };
	    /**
	     * this function modifies the structure so that all current attributes become interleaved into a single buffer
	     * This can be useful if your model remains static as it offers a little performance boost
	     *
	     * @return {PIXI.Geometry} returns self, useful for chaining.
	     */
	    Geometry.prototype.interleave = function () {
	        // a simple check to see if buffers are already interleaved..
	        if (this.buffers.length === 1 || (this.buffers.length === 2 && this.indexBuffer))
	            { return this; }
	        // assume already that no buffers are interleaved
	        var arrays = [];
	        var sizes = [];
	        var interleavedBuffer = new Buffer();
	        var i;
	        for (i in this.attributes) {
	            var attribute = this.attributes[i];
	            var buffer = this.buffers[attribute.buffer];
	            arrays.push(buffer.data);
	            sizes.push((attribute.size * byteSizeMap[attribute.type]) / 4);
	            attribute.buffer = 0;
	        }
	        interleavedBuffer.data = interleaveTypedArrays$1(arrays, sizes);
	        for (i = 0; i < this.buffers.length; i++) {
	            if (this.buffers[i] !== this.indexBuffer) {
	                this.buffers[i].destroy();
	            }
	        }
	        this.buffers = [interleavedBuffer];
	        if (this.indexBuffer) {
	            this.buffers.push(this.indexBuffer);
	        }
	        return this;
	    };
	    Geometry.prototype.getSize = function () {
	        for (var i in this.attributes) {
	            var attribute = this.attributes[i];
	            var buffer = this.buffers[attribute.buffer];
	            return buffer.data.length / ((attribute.stride / 4) || attribute.size);
	        }
	        return 0;
	    };
	    /**
	     * disposes WebGL resources that are connected to this geometry
	     */
	    Geometry.prototype.dispose = function () {
	        this.disposeRunner.emit(this, false);
	    };
	    /**
	     * Destroys the geometry.
	     */
	    Geometry.prototype.destroy = function () {
	        this.dispose();
	        this.buffers = null;
	        this.indexBuffer = null;
	        this.attributes = null;
	    };
	    /**
	     * returns a clone of the geometry
	     *
	     * @returns {PIXI.Geometry} a new clone of this geometry
	     */
	    Geometry.prototype.clone = function () {
	        var geometry = new Geometry();
	        for (var i = 0; i < this.buffers.length; i++) {
	            geometry.buffers[i] = new Buffer(this.buffers[i].data.slice(0));
	        }
	        for (var i in this.attributes) {
	            var attrib = this.attributes[i];
	            geometry.attributes[i] = new Attribute(attrib.buffer, attrib.size, attrib.normalized, attrib.type, attrib.stride, attrib.start, attrib.instance);
	        }
	        if (this.indexBuffer) {
	            geometry.indexBuffer = geometry.buffers[this.buffers.indexOf(this.indexBuffer)];
	            geometry.indexBuffer.index = true;
	        }
	        return geometry;
	    };
	    /**
	     * merges an array of geometries into a new single one
	     * geometry attribute styles must match for this operation to work
	     *
	     * @param {PIXI.Geometry[]} geometries - array of geometries to merge
	     * @returns {PIXI.Geometry} shiny new geometry!
	     */
	    Geometry.merge = function (geometries) {
	        // todo add a geometry check!
	        // also a size check.. cant be too big!]
	        var geometryOut = new Geometry();
	        var arrays = [];
	        var sizes = [];
	        var offsets = [];
	        var geometry;
	        // pass one.. get sizes..
	        for (var i = 0; i < geometries.length; i++) {
	            geometry = geometries[i];
	            for (var j = 0; j < geometry.buffers.length; j++) {
	                sizes[j] = sizes[j] || 0;
	                sizes[j] += geometry.buffers[j].data.length;
	                offsets[j] = 0;
	            }
	        }
	        // build the correct size arrays..
	        for (var i = 0; i < geometry.buffers.length; i++) {
	            // TODO types!
	            arrays[i] = new map$1$1[getBufferType$1(geometry.buffers[i].data)](sizes[i]);
	            geometryOut.buffers[i] = new Buffer(arrays[i]);
	        }
	        // pass to set data..
	        for (var i = 0; i < geometries.length; i++) {
	            geometry = geometries[i];
	            for (var j = 0; j < geometry.buffers.length; j++) {
	                arrays[j].set(geometry.buffers[j].data, offsets[j]);
	                offsets[j] += geometry.buffers[j].data.length;
	            }
	        }
	        geometryOut.attributes = geometry.attributes;
	        if (geometry.indexBuffer) {
	            geometryOut.indexBuffer = geometryOut.buffers[geometry.buffers.indexOf(geometry.indexBuffer)];
	            geometryOut.indexBuffer.index = true;
	            var offset = 0;
	            var stride = 0;
	            var offset2 = 0;
	            var bufferIndexToCount = 0;
	            // get a buffer
	            for (var i = 0; i < geometry.buffers.length; i++) {
	                if (geometry.buffers[i] !== geometry.indexBuffer) {
	                    bufferIndexToCount = i;
	                    break;
	                }
	            }
	            // figure out the stride of one buffer..
	            for (var i in geometry.attributes) {
	                var attribute = geometry.attributes[i];
	                if ((attribute.buffer | 0) === bufferIndexToCount) {
	                    stride += ((attribute.size * byteSizeMap[attribute.type]) / 4);
	                }
	            }
	            // time to off set all indexes..
	            for (var i = 0; i < geometries.length; i++) {
	                var indexBufferData = geometries[i].indexBuffer.data;
	                for (var j = 0; j < indexBufferData.length; j++) {
	                    geometryOut.indexBuffer.data[j + offset2] += offset;
	                }
	                offset += geometry.buffers[bufferIndexToCount].data.length / (stride);
	                offset2 += indexBufferData.length;
	            }
	        }
	        return geometryOut;
	    };
	    return Geometry;
	}());

	/**
	 * Helper class to create a quad
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Quad = /** @class */ (function (_super) {
	    __extends$2(Quad, _super);
	    function Quad() {
	        var _this = _super.call(this) || this;
	        _this.addAttribute('aVertexPosition', new Float32Array([
	            0, 0,
	            1, 0,
	            1, 1,
	            0, 1 ]))
	            .addIndex([0, 1, 3, 2]);
	        return _this;
	    }
	    return Quad;
	}(Geometry));

	/**
	 * Helper class to create a quad with uvs like in v4
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.Geometry
	 */
	var QuadUv = /** @class */ (function (_super) {
	    __extends$2(QuadUv, _super);
	    function QuadUv() {
	        var _this = _super.call(this) || this;
	        /**
	         * An array of vertices
	         *
	         * @member {Float32Array}
	         */
	        _this.vertices = new Float32Array([
	            -1, -1,
	            1, -1,
	            1, 1,
	            -1, 1 ]);
	        /**
	         * The Uvs of the quad
	         *
	         * @member {Float32Array}
	         */
	        _this.uvs = new Float32Array([
	            0, 0,
	            1, 0,
	            1, 1,
	            0, 1 ]);
	        _this.vertexBuffer = new Buffer(_this.vertices);
	        _this.uvBuffer = new Buffer(_this.uvs);
	        _this.addAttribute('aVertexPosition', _this.vertexBuffer)
	            .addAttribute('aTextureCoord', _this.uvBuffer)
	            .addIndex([0, 1, 2, 0, 2, 3]);
	        return _this;
	    }
	    /**
	     * Maps two Rectangle to the quad.
	     *
	     * @param {PIXI.Rectangle} targetTextureFrame - the first rectangle
	     * @param {PIXI.Rectangle} destinationFrame - the second rectangle
	     * @return {PIXI.Quad} Returns itself.
	     */
	    QuadUv.prototype.map = function (targetTextureFrame, destinationFrame) {
	        var x = 0; // destinationFrame.x / targetTextureFrame.width;
	        var y = 0; // destinationFrame.y / targetTextureFrame.height;
	        this.uvs[0] = x;
	        this.uvs[1] = y;
	        this.uvs[2] = x + (destinationFrame.width / targetTextureFrame.width);
	        this.uvs[3] = y;
	        this.uvs[4] = x + (destinationFrame.width / targetTextureFrame.width);
	        this.uvs[5] = y + (destinationFrame.height / targetTextureFrame.height);
	        this.uvs[6] = x;
	        this.uvs[7] = y + (destinationFrame.height / targetTextureFrame.height);
	        x = destinationFrame.x;
	        y = destinationFrame.y;
	        this.vertices[0] = x;
	        this.vertices[1] = y;
	        this.vertices[2] = x + destinationFrame.width;
	        this.vertices[3] = y;
	        this.vertices[4] = x + destinationFrame.width;
	        this.vertices[5] = y + destinationFrame.height;
	        this.vertices[6] = x;
	        this.vertices[7] = y + destinationFrame.height;
	        this.invalidate();
	        return this;
	    };
	    /**
	     * legacy upload method, just marks buffers dirty
	     * @returns {PIXI.QuadUv} Returns itself.
	     */
	    QuadUv.prototype.invalidate = function () {
	        this.vertexBuffer._updateID++;
	        this.uvBuffer._updateID++;
	        return this;
	    };
	    return QuadUv;
	}(Geometry));

	var UID$2 = 0;
	/**
	 * Uniform group holds uniform map and some ID's for work
	 *
	 * @class
	 * @memberof PIXI
	 */
	var UniformGroup = /** @class */ (function () {
	    /**
	     * @param {object} [uniforms] - Custom uniforms to use to augment the built-in ones.
	     * @param {boolean} [_static] - Uniforms wont be changed after creation
	     */
	    function UniformGroup(uniforms, _static) {
	        /**
	         * uniform values
	         * @member {object}
	         * @readonly
	         */
	        this.uniforms = uniforms;
	        /**
	         * Its a group and not a single uniforms
	         * @member {boolean}
	         * @readonly
	         * @default true
	         */
	        this.group = true;
	        // lets generate this when the shader ?
	        this.syncUniforms = {};
	        /**
	         * dirty version
	         * @protected
	         * @member {number}
	         */
	        this.dirtyId = 0;
	        /**
	         * unique id
	         * @protected
	         * @member {number}
	         */
	        this.id = UID$2++;
	        /**
	         * Uniforms wont be changed after creation
	         * @member {boolean}
	         */
	        this.static = !!_static;
	    }
	    UniformGroup.prototype.update = function () {
	        this.dirtyId++;
	    };
	    UniformGroup.prototype.add = function (name, uniforms, _static) {
	        this.uniforms[name] = new UniformGroup(uniforms, _static);
	    };
	    UniformGroup.from = function (uniforms, _static) {
	        return new UniformGroup(uniforms, _static);
	    };
	    return UniformGroup;
	}());

	/**
	 * System plugin to the renderer to manage filter states.
	 *
	 * @class
	 * @private
	 */
	var FilterState = /** @class */ (function () {
	    function FilterState() {
	        this.renderTexture = null;
	        /**
	         * Target of the filters
	         * We store for case when custom filter wants to know the element it was applied on
	         * @member {PIXI.DisplayObject}
	         * @private
	         */
	        this.target = null;
	        /**
	         * Compatibility with PixiJS v4 filters
	         * @member {boolean}
	         * @default false
	         * @private
	         */
	        this.legacy = false;
	        /**
	         * Resolution of filters
	         * @member {number}
	         * @default 1
	         * @private
	         */
	        this.resolution = 1;
	        // next three fields are created only for root
	        // re-assigned for everything else
	        /**
	         * Source frame
	         * @member {PIXI.Rectangle}
	         * @private
	         */
	        this.sourceFrame = new Rectangle();
	        /**
	         * Destination frame
	         * @member {PIXI.Rectangle}
	         * @private
	         */
	        this.destinationFrame = new Rectangle();
	        /**
	         * Collection of filters
	         * @member {PIXI.Filter[]}
	         * @private
	         */
	        this.filters = [];
	    }
	    /**
	     * clears the state
	     * @private
	     */
	    FilterState.prototype.clear = function () {
	        this.target = null;
	        this.filters = null;
	        this.renderTexture = null;
	    };
	    return FilterState;
	}());

	/**
	 * System plugin to the renderer to manage the filters.
	 *
	 * @class
	 * @memberof PIXI.systems
	 * @extends PIXI.System
	 */
	var FilterSystem = /** @class */ (function (_super) {
	    __extends$2(FilterSystem, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this System works for.
	     */
	    function FilterSystem(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        /**
	         * List of filters for the FilterSystem
	         * @member {Object[]}
	         * @readonly
	         */
	        _this.defaultFilterStack = [{}];
	        /**
	         * stores a bunch of PO2 textures used for filtering
	         * @member {Object}
	         */
	        _this.texturePool = new RenderTexturePool();
	        _this.texturePool.setScreenSize(renderer.view);
	        /**
	         * a pool for storing filter states, save us creating new ones each tick
	         * @member {Object[]}
	         */
	        _this.statePool = [];
	        /**
	         * A very simple geometry used when drawing a filter effect to the screen
	         * @member {PIXI.Quad}
	         */
	        _this.quad = new Quad();
	        /**
	         * Quad UVs
	         * @member {PIXI.QuadUv}
	         */
	        _this.quadUv = new QuadUv();
	        /**
	         * Temporary rect for maths
	         * @type {PIXI.Rectangle}
	         */
	        _this.tempRect = new Rectangle();
	        /**
	         * Active state
	         * @member {object}
	         */
	        _this.activeState = {};
	        /**
	         * This uniform group is attached to filter uniforms when used
	         * @member {PIXI.UniformGroup}
	         * @property {PIXI.Rectangle} outputFrame
	         * @property {Float32Array} inputSize
	         * @property {Float32Array} inputPixel
	         * @property {Float32Array} inputClamp
	         * @property {Number} resolution
	         * @property {Float32Array} filterArea
	         * @property {Fload32Array} filterClamp
	         */
	        _this.globalUniforms = new UniformGroup({
	            outputFrame: _this.tempRect,
	            inputSize: new Float32Array(4),
	            inputPixel: new Float32Array(4),
	            inputClamp: new Float32Array(4),
	            resolution: 1,
	            // legacy variables
	            filterArea: new Float32Array(4),
	            filterClamp: new Float32Array(4),
	        }, true);
	        /**
	         * Whether to clear output renderTexture in AUTO/BLIT mode. See {@link PIXI.CLEAR_MODES}
	         * @member {boolean}
	         */
	        _this.forceClear = false;
	        /**
	         * Old padding behavior is to use the max amount instead of sum padding.
	         * Use this flag if you need the old behavior.
	         * @member {boolean}
	         * @default false
	         */
	        _this.useMaxPadding = false;
	        return _this;
	    }
	    /**
	     * Adds a new filter to the System.
	     *
	     * @param {PIXI.DisplayObject} target - The target of the filter to render.
	     * @param {PIXI.Filter[]} filters - The filters to apply.
	     */
	    FilterSystem.prototype.push = function (target, filters) {
	        var renderer = this.renderer;
	        var filterStack = this.defaultFilterStack;
	        var state = this.statePool.pop() || new FilterState();
	        var resolution = filters[0].resolution;
	        var padding = filters[0].padding;
	        var autoFit = filters[0].autoFit;
	        var legacy = filters[0].legacy;
	        for (var i = 1; i < filters.length; i++) {
	            var filter = filters[i];
	            // lets use the lowest resolution..
	            resolution = Math.min(resolution, filter.resolution);
	            // figure out the padding required for filters
	            padding = this.useMaxPadding
	                // old behavior: use largest amount of padding!
	                ? Math.max(padding, filter.padding)
	                // new behavior: sum the padding
	                : padding + filter.padding;
	            // only auto fit if all filters are autofit
	            autoFit = autoFit && filter.autoFit;
	            legacy = legacy || filter.legacy;
	        }
	        if (filterStack.length === 1) {
	            this.defaultFilterStack[0].renderTexture = renderer.renderTexture.current;
	        }
	        filterStack.push(state);
	        state.resolution = resolution;
	        state.legacy = legacy;
	        state.target = target;
	        state.sourceFrame.copyFrom(target.filterArea || target.getBounds(true));
	        state.sourceFrame.pad(padding);
	        if (autoFit) {
	            state.sourceFrame.fit(this.renderer.renderTexture.sourceFrame);
	        }
	        // round to whole number based on resolution
	        state.sourceFrame.ceil(resolution);
	        state.renderTexture = this.getOptimalFilterTexture(state.sourceFrame.width, state.sourceFrame.height, resolution);
	        state.filters = filters;
	        state.destinationFrame.width = state.renderTexture.width;
	        state.destinationFrame.height = state.renderTexture.height;
	        var destinationFrame = this.tempRect;
	        destinationFrame.width = state.sourceFrame.width;
	        destinationFrame.height = state.sourceFrame.height;
	        state.renderTexture.filterFrame = state.sourceFrame;
	        renderer.renderTexture.bind(state.renderTexture, state.sourceFrame, destinationFrame);
	        renderer.renderTexture.clear();
	    };
	    /**
	     * Pops off the filter and applies it.
	     *
	     */
	    FilterSystem.prototype.pop = function () {
	        var filterStack = this.defaultFilterStack;
	        var state = filterStack.pop();
	        var filters = state.filters;
	        this.activeState = state;
	        var globalUniforms = this.globalUniforms.uniforms;
	        globalUniforms.outputFrame = state.sourceFrame;
	        globalUniforms.resolution = state.resolution;
	        var inputSize = globalUniforms.inputSize;
	        var inputPixel = globalUniforms.inputPixel;
	        var inputClamp = globalUniforms.inputClamp;
	        inputSize[0] = state.destinationFrame.width;
	        inputSize[1] = state.destinationFrame.height;
	        inputSize[2] = 1.0 / inputSize[0];
	        inputSize[3] = 1.0 / inputSize[1];
	        inputPixel[0] = inputSize[0] * state.resolution;
	        inputPixel[1] = inputSize[1] * state.resolution;
	        inputPixel[2] = 1.0 / inputPixel[0];
	        inputPixel[3] = 1.0 / inputPixel[1];
	        inputClamp[0] = 0.5 * inputPixel[2];
	        inputClamp[1] = 0.5 * inputPixel[3];
	        inputClamp[2] = (state.sourceFrame.width * inputSize[2]) - (0.5 * inputPixel[2]);
	        inputClamp[3] = (state.sourceFrame.height * inputSize[3]) - (0.5 * inputPixel[3]);
	        // only update the rect if its legacy..
	        if (state.legacy) {
	            var filterArea = globalUniforms.filterArea;
	            filterArea[0] = state.destinationFrame.width;
	            filterArea[1] = state.destinationFrame.height;
	            filterArea[2] = state.sourceFrame.x;
	            filterArea[3] = state.sourceFrame.y;
	            globalUniforms.filterClamp = globalUniforms.inputClamp;
	        }
	        this.globalUniforms.update();
	        var lastState = filterStack[filterStack.length - 1];
	        if (state.renderTexture.framebuffer.multisample > 1) {
	            this.renderer.framebuffer.blit();
	        }
	        if (filters.length === 1) {
	            filters[0].apply(this, state.renderTexture, lastState.renderTexture, exports.CLEAR_MODES.BLEND, state);
	            this.returnFilterTexture(state.renderTexture);
	        }
	        else {
	            var flip = state.renderTexture;
	            var flop = this.getOptimalFilterTexture(flip.width, flip.height, state.resolution);
	            flop.filterFrame = flip.filterFrame;
	            var i = 0;
	            for (i = 0; i < filters.length - 1; ++i) {
	                filters[i].apply(this, flip, flop, exports.CLEAR_MODES.CLEAR, state);
	                var t = flip;
	                flip = flop;
	                flop = t;
	            }
	            filters[i].apply(this, flip, lastState.renderTexture, exports.CLEAR_MODES.BLEND, state);
	            this.returnFilterTexture(flip);
	            this.returnFilterTexture(flop);
	        }
	        state.clear();
	        this.statePool.push(state);
	    };
	    /**
	     * Binds a renderTexture with corresponding `filterFrame`, clears it if mode corresponds.
	     * @param {PIXI.RenderTexture} filterTexture - renderTexture to bind, should belong to filter pool or filter stack
	     * @param {PIXI.CLEAR_MODES} [clearMode] - clearMode, by default its CLEAR/YES. See {@link PIXI.CLEAR_MODES}
	     */
	    FilterSystem.prototype.bindAndClear = function (filterTexture, clearMode) {
	        if (clearMode === void 0) { clearMode = exports.CLEAR_MODES.CLEAR; }
	        if (filterTexture && filterTexture.filterFrame) {
	            var destinationFrame = this.tempRect;
	            destinationFrame.width = filterTexture.filterFrame.width;
	            destinationFrame.height = filterTexture.filterFrame.height;
	            this.renderer.renderTexture.bind(filterTexture, filterTexture.filterFrame, destinationFrame);
	        }
	        else {
	            this.renderer.renderTexture.bind(filterTexture);
	        }
	        // TODO: remove in next major version
	        if (typeof clearMode === 'boolean') {
	            clearMode = clearMode ? exports.CLEAR_MODES.CLEAR : exports.CLEAR_MODES.BLEND;
	            // get deprecation function from utils
	            deprecation('5.2.1', 'Use CLEAR_MODES when using clear applyFilter option');
	        }
	        if (clearMode === exports.CLEAR_MODES.CLEAR
	            || (clearMode === exports.CLEAR_MODES.BLIT && this.forceClear)) {
	            this.renderer.renderTexture.clear();
	        }
	    };
	    /**
	     * Draws a filter.
	     *
	     * @param {PIXI.Filter} filter - The filter to draw.
	     * @param {PIXI.RenderTexture} input - The input render target.
	     * @param {PIXI.RenderTexture} output - The target to output to.
	     * @param {PIXI.CLEAR_MODES} [clearMode] - Should the output be cleared before rendering to it
	     */
	    FilterSystem.prototype.applyFilter = function (filter, input, output, clearMode) {
	        var renderer = this.renderer;
	        this.bindAndClear(output, clearMode);
	        // set the uniforms..
	        filter.uniforms.uSampler = input;
	        filter.uniforms.filterGlobals = this.globalUniforms;
	        // TODO make it so that the order of this does not matter..
	        // because it does at the moment cos of global uniforms.
	        // they need to get resynced
	        renderer.state.set(filter.state);
	        renderer.shader.bind(filter);
	        if (filter.legacy) {
	            this.quadUv.map(input._frame, input.filterFrame);
	            renderer.geometry.bind(this.quadUv);
	            renderer.geometry.draw(exports.DRAW_MODES.TRIANGLES);
	        }
	        else {
	            renderer.geometry.bind(this.quad);
	            renderer.geometry.draw(exports.DRAW_MODES.TRIANGLE_STRIP);
	        }
	    };
	    /**
	     * Multiply _input normalized coordinates_ to this matrix to get _sprite texture normalized coordinates_.
	     *
	     * Use `outputMatrix * vTextureCoord` in the shader.
	     *
	     * @param {PIXI.Matrix} outputMatrix - The matrix to output to.
	     * @param {PIXI.Sprite} sprite - The sprite to map to.
	     * @return {PIXI.Matrix} The mapped matrix.
	     */
	    FilterSystem.prototype.calculateSpriteMatrix = function (outputMatrix, sprite) {
	        var _a = this.activeState, sourceFrame = _a.sourceFrame, destinationFrame = _a.destinationFrame;
	        var orig = sprite._texture.orig;
	        var mappedMatrix = outputMatrix.set(destinationFrame.width, 0, 0, destinationFrame.height, sourceFrame.x, sourceFrame.y);
	        var worldTransform = sprite.worldTransform.copyTo(Matrix.TEMP_MATRIX);
	        worldTransform.invert();
	        mappedMatrix.prepend(worldTransform);
	        mappedMatrix.scale(1.0 / orig.width, 1.0 / orig.height);
	        mappedMatrix.translate(sprite.anchor.x, sprite.anchor.y);
	        return mappedMatrix;
	    };
	    /**
	     * Destroys this Filter System.
	     */
	    FilterSystem.prototype.destroy = function () {
	        // Those textures has to be destroyed by RenderTextureSystem or FramebufferSystem
	        this.texturePool.clear(false);
	    };
	    /**
	     * Gets a Power-of-Two render texture or fullScreen texture
	     *
	     * @protected
	     * @param {number} minWidth - The minimum width of the render texture in real pixels.
	     * @param {number} minHeight - The minimum height of the render texture in real pixels.
	     * @param {number} [resolution=1] - The resolution of the render texture.
	     * @return {PIXI.RenderTexture} The new render texture.
	     */
	    FilterSystem.prototype.getOptimalFilterTexture = function (minWidth, minHeight, resolution) {
	        if (resolution === void 0) { resolution = 1; }
	        return this.texturePool.getOptimalTexture(minWidth, minHeight, resolution);
	    };
	    /**
	     * Gets extra render texture to use inside current filter
	     * To be compliant with older filters, you can use params in any order
	     *
	     * @param {PIXI.RenderTexture} [input] - renderTexture from which size and resolution will be copied
	     * @param {number} [resolution] - override resolution of the renderTexture
	     * @returns {PIXI.RenderTexture}
	     */
	    FilterSystem.prototype.getFilterTexture = function (input, resolution) {
	        if (typeof input === 'number') {
	            var swap = input;
	            input = resolution;
	            resolution = swap;
	        }
	        input = input || this.activeState.renderTexture;
	        var filterTexture = this.texturePool.getOptimalTexture(input.width, input.height, resolution || input.resolution);
	        filterTexture.filterFrame = input.filterFrame;
	        return filterTexture;
	    };
	    /**
	     * Frees a render texture back into the pool.
	     *
	     * @param {PIXI.RenderTexture} renderTexture - The renderTarget to free
	     */
	    FilterSystem.prototype.returnFilterTexture = function (renderTexture) {
	        this.texturePool.returnTexture(renderTexture);
	    };
	    /**
	     * Empties the texture pool.
	     */
	    FilterSystem.prototype.emptyPool = function () {
	        this.texturePool.clear(true);
	    };
	    /**
	     * calls `texturePool.resize()`, affects fullScreen renderTextures
	     */
	    FilterSystem.prototype.resize = function () {
	        this.texturePool.setScreenSize(this.renderer.view);
	    };
	    return FilterSystem;
	}(System));

	/**
	 * Base for a common object renderer that can be used as a
	 * system renderer plugin.
	 *
	 * @class
	 * @extends PIXI.System
	 * @memberof PIXI
	 */
	var ObjectRenderer = /** @class */ (function () {
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this manager works for.
	     */
	    function ObjectRenderer(renderer) {
	        /**
	         * The renderer this manager works for.
	         *
	         * @member {PIXI.Renderer}
	         */
	        this.renderer = renderer;
	    }
	    /**
	     * Stub method that should be used to empty the current
	     * batch by rendering objects now.
	     */
	    ObjectRenderer.prototype.flush = function () {
	        // flush!
	    };
	    /**
	     * Generic destruction method that frees all resources. This
	     * should be called by subclasses.
	     */
	    ObjectRenderer.prototype.destroy = function () {
	        this.renderer = null;
	    };
	    /**
	     * Stub method that initializes any state required before
	     * rendering starts. It is different from the `prerender`
	     * signal, which occurs every frame, in that it is called
	     * whenever an object requests _this_ renderer specifically.
	     */
	    ObjectRenderer.prototype.start = function () {
	        // set the shader..
	    };
	    /**
	     * Stops the renderer. It should free up any state and
	     * become dormant.
	     */
	    ObjectRenderer.prototype.stop = function () {
	        this.flush();
	    };
	    /**
	     * Keeps the object to render. It doesn't have to be
	     * rendered immediately.
	     *
	     * @param {PIXI.DisplayObject} object - The object to render.
	     */
	    ObjectRenderer.prototype.render = function (_object) {
	        // render the object
	    };
	    return ObjectRenderer;
	}());

	/**
	 * System plugin to the renderer to manage batching.
	 *
	 * @class
	 * @extends PIXI.System
	 * @memberof PIXI.systems
	 */
	var BatchSystem = /** @class */ (function (_super) {
	    __extends$2(BatchSystem, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this System works for.
	     */
	    function BatchSystem(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        /**
	         * An empty renderer.
	         *
	         * @member {PIXI.ObjectRenderer}
	         */
	        _this.emptyRenderer = new ObjectRenderer(renderer);
	        /**
	         * The currently active ObjectRenderer.
	         *
	         * @member {PIXI.ObjectRenderer}
	         */
	        _this.currentRenderer = _this.emptyRenderer;
	        return _this;
	    }
	    /**
	     * Changes the current renderer to the one given in parameter
	     *
	     * @param {PIXI.ObjectRenderer} objectRenderer - The object renderer to use.
	     */
	    BatchSystem.prototype.setObjectRenderer = function (objectRenderer) {
	        if (this.currentRenderer === objectRenderer) {
	            return;
	        }
	        this.currentRenderer.stop();
	        this.currentRenderer = objectRenderer;
	        this.currentRenderer.start();
	    };
	    /**
	     * This should be called if you wish to do some custom rendering
	     * It will basically render anything that may be batched up such as sprites
	     */
	    BatchSystem.prototype.flush = function () {
	        this.setObjectRenderer(this.emptyRenderer);
	    };
	    /**
	     * Reset the system to an empty renderer
	     */
	    BatchSystem.prototype.reset = function () {
	        this.setObjectRenderer(this.emptyRenderer);
	    };
	    /**
	     * Handy function for batch renderers: copies bound textures in first maxTextures locations to array
	     * sets actual _batchLocation for them
	     *
	     * @param {PIXI.BaseTexture[]} - arr copy destination
	     * @param {number} maxTextures - number of copied elements
	     */
	    BatchSystem.prototype.copyBoundTextures = function (arr, maxTextures) {
	        var boundTextures = this.renderer.texture.boundTextures;
	        for (var i = maxTextures - 1; i >= 0; --i) {
	            arr[i] = boundTextures[i] || null;
	            if (arr[i]) {
	                arr[i]._batchLocation = i;
	            }
	        }
	    };
	    /**
	     * Assigns batch locations to textures in array based on boundTextures state.
	     * All textures in texArray should have `_batchEnabled = _batchId`,
	     * and their count should be less than `maxTextures`.
	     *
	     * @param {PIXI.BatchTextureArray} texArray - textures to bound
	     * @param {PIXI.BaseTexture[]} boundTextures - current state of bound textures
	     * @param {number} batchId - marker for _batchEnabled param of textures in texArray
	     * @param {number} maxTextures - number of texture locations to manipulate
	     */
	    BatchSystem.prototype.boundArray = function (texArray, boundTextures, batchId, maxTextures) {
	        var elements = texArray.elements, ids = texArray.ids, count = texArray.count;
	        var j = 0;
	        for (var i = 0; i < count; i++) {
	            var tex = elements[i];
	            var loc = tex._batchLocation;
	            if (loc >= 0 && loc < maxTextures
	                && boundTextures[loc] === tex) {
	                ids[i] = loc;
	                continue;
	            }
	            while (j < maxTextures) {
	                var bound = boundTextures[j];
	                if (bound && bound._batchEnabled === batchId
	                    && bound._batchLocation === j) {
	                    j++;
	                    continue;
	                }
	                ids[i] = j;
	                tex._batchLocation = j;
	                boundTextures[j] = tex;
	                break;
	            }
	        }
	    };
	    return BatchSystem;
	}(System));

	var CONTEXT_UID_COUNTER = 0;
	/**
	 * System plugin to the renderer to manage the context.
	 *
	 * @class
	 * @extends PIXI.System
	 * @memberof PIXI.systems
	 */
	var ContextSystem = /** @class */ (function (_super) {
	    __extends$2(ContextSystem, _super);
	    /* eslint-enable camelcase */
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this System works for.
	     */
	    function ContextSystem(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        /**
	         * Either 1 or 2 to reflect the WebGL version being used
	         * @member {number}
	         * @readonly
	         */
	        _this.webGLVersion = 1;
	        /**
	         * Extensions being used
	         * @member {object}
	         * @readonly
	         * @property {WEBGL_draw_buffers} drawBuffers - WebGL v1 extension
	         * @property {WEBGL_depth_texture} depthTexture - WebGL v1 extension
	         * @property {OES_texture_float} floatTexture - WebGL v1 extension
	         * @property {WEBGL_lose_context} loseContext - WebGL v1 extension
	         * @property {OES_vertex_array_object} vertexArrayObject - WebGL v1 extension
	         * @property {EXT_texture_filter_anisotropic} anisotropicFiltering - WebGL v1 and v2 extension
	         */
	        _this.extensions = {};
	        /**
	         * Features supported by current context
	         * @member {object}
	         * @private
	         * @readonly
	         * @property {boolean} uint32Indices - Supports of 32-bit indices buffer
	         */
	        _this.supports = {
	            uint32Indices: false,
	        };
	        // Bind functions
	        _this.handleContextLost = _this.handleContextLost.bind(_this);
	        _this.handleContextRestored = _this.handleContextRestored.bind(_this);
	        renderer.view.addEventListener('webglcontextlost', _this.handleContextLost, false);
	        renderer.view.addEventListener('webglcontextrestored', _this.handleContextRestored, false);
	        return _this;
	    }
	    Object.defineProperty(ContextSystem.prototype, "isLost", {
	        /**
	         * `true` if the context is lost
	         * @member {boolean}
	         * @readonly
	         */
	        get: function () {
	            return (!this.gl || this.gl.isContextLost());
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Handle the context change event
	     * @param {WebGLRenderingContext} gl - new webgl context
	     */
	    ContextSystem.prototype.contextChange = function (gl) {
	        this.gl = gl;
	        this.renderer.gl = gl;
	        this.renderer.CONTEXT_UID = CONTEXT_UID_COUNTER++;
	        // restore a context if it was previously lost
	        if (gl.isContextLost() && gl.getExtension('WEBGL_lose_context')) {
	            gl.getExtension('WEBGL_lose_context').restoreContext();
	        }
	    };
	    /**
	     * Initialize the context
	     *
	     * @protected
	     * @param {WebGLRenderingContext} gl - WebGL context
	     */
	    ContextSystem.prototype.initFromContext = function (gl) {
	        this.gl = gl;
	        this.validateContext(gl);
	        this.renderer.gl = gl;
	        this.renderer.CONTEXT_UID = CONTEXT_UID_COUNTER++;
	        this.renderer.runners.contextChange.emit(gl);
	    };
	    /**
	     * Initialize from context options
	     *
	     * @protected
	     * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext
	     * @param {object} options - context attributes
	     */
	    ContextSystem.prototype.initFromOptions = function (options) {
	        var gl = this.createContext(this.renderer.view, options);
	        this.initFromContext(gl);
	    };
	    /**
	     * Helper class to create a WebGL Context
	     *
	     * @param canvas {HTMLCanvasElement} the canvas element that we will get the context from
	     * @param options {object} An options object that gets passed in to the canvas element containing the context attributes
	     * @see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext
	     * @return {WebGLRenderingContext} the WebGL context
	     */
	    ContextSystem.prototype.createContext = function (canvas, options) {
	        var gl;
	        if (settings.PREFER_ENV >= exports.ENV.WEBGL2) {
	            gl = canvas.getContext('webgl2', options);
	        }
	        if (gl) {
	            this.webGLVersion = 2;
	        }
	        else {
	            this.webGLVersion = 1;
	            gl = canvas.getContext('webgl', options)
	                || canvas.getContext('experimental-webgl', options);
	            if (!gl) {
	                // fail, not able to get a context
	                throw new Error('This browser does not support WebGL. Try using the canvas renderer');
	            }
	        }
	        this.gl = gl;
	        this.getExtensions();
	        return this.gl;
	    };
	    /**
	     * Auto-populate the extensions
	     *
	     * @protected
	     */
	    ContextSystem.prototype.getExtensions = function () {
	        // time to set up default extensions that Pixi uses.
	        var gl = this.gl;
	        if (this.webGLVersion === 1) {
	            Object.assign(this.extensions, {
	                drawBuffers: gl.getExtension('WEBGL_draw_buffers'),
	                depthTexture: gl.getExtension('WEBGL_depth_texture'),
	                loseContext: gl.getExtension('WEBGL_lose_context'),
	                vertexArrayObject: gl.getExtension('OES_vertex_array_object')
	                    || gl.getExtension('MOZ_OES_vertex_array_object')
	                    || gl.getExtension('WEBKIT_OES_vertex_array_object'),
	                anisotropicFiltering: gl.getExtension('EXT_texture_filter_anisotropic'),
	                uint32ElementIndex: gl.getExtension('OES_element_index_uint'),
	                // Floats and half-floats
	                floatTexture: gl.getExtension('OES_texture_float'),
	                floatTextureLinear: gl.getExtension('OES_texture_float_linear'),
	                textureHalfFloat: gl.getExtension('OES_texture_half_float'),
	                textureHalfFloatLinear: gl.getExtension('OES_texture_half_float_linear'),
	            });
	        }
	        else if (this.webGLVersion === 2) {
	            Object.assign(this.extensions, {
	                anisotropicFiltering: gl.getExtension('EXT_texture_filter_anisotropic'),
	                // Floats and half-floats
	                colorBufferFloat: gl.getExtension('EXT_color_buffer_float'),
	                floatTextureLinear: gl.getExtension('OES_texture_float_linear'),
	            });
	        }
	    };
	    /**
	     * Handles a lost webgl context
	     *
	     * @protected
	     * @param {WebGLContextEvent} event - The context lost event.
	     */
	    ContextSystem.prototype.handleContextLost = function (event) {
	        event.preventDefault();
	    };
	    /**
	     * Handles a restored webgl context
	     *
	     * @protected
	     */
	    ContextSystem.prototype.handleContextRestored = function () {
	        this.renderer.runners.contextChange.emit(this.gl);
	    };
	    ContextSystem.prototype.destroy = function () {
	        var view = this.renderer.view;
	        // remove listeners
	        view.removeEventListener('webglcontextlost', this.handleContextLost);
	        view.removeEventListener('webglcontextrestored', this.handleContextRestored);
	        this.gl.useProgram(null);
	        if (this.extensions.loseContext) {
	            this.extensions.loseContext.loseContext();
	        }
	    };
	    /**
	     * Handle the post-render runner event
	     *
	     * @protected
	     */
	    ContextSystem.prototype.postrender = function () {
	        if (this.renderer.renderingToScreen) {
	            this.gl.flush();
	        }
	    };
	    /**
	     * Validate context
	     *
	     * @protected
	     * @param {WebGLRenderingContext} gl - Render context
	     */
	    ContextSystem.prototype.validateContext = function (gl) {
	        var attributes = gl.getContextAttributes();
	        var isWebGl2 = 'WebGL2RenderingContext' in window && gl instanceof window.WebGL2RenderingContext;
	        if (isWebGl2) {
	            this.webGLVersion = 2;
	        }
	        // this is going to be fairly simple for now.. but at least we have room to grow!
	        if (!attributes.stencil) {
	            /* eslint-disable max-len, no-console */
	            console.warn('Provided WebGL context does not have a stencil buffer, masks may not render correctly');
	            /* eslint-enable max-len, no-console */
	        }
	        var hasuint32 = isWebGl2 || !!gl.getExtension('OES_element_index_uint');
	        this.supports.uint32Indices = hasuint32;
	        if (!hasuint32) {
	            /* eslint-disable max-len, no-console */
	            console.warn('Provided WebGL context does not support 32 index buffer, complex graphics may not render correctly');
	            /* eslint-enable max-len, no-console */
	        }
	    };
	    return ContextSystem;
	}(System));

	/**
	 * Internal framebuffer for WebGL context
	 * @class
	 * @memberof PIXI
	 */
	var GLFramebuffer = /** @class */ (function () {
	    function GLFramebuffer(framebuffer) {
	        /**
	         * The WebGL framebuffer
	         * @member {WebGLFramebuffer}
	         */
	        this.framebuffer = framebuffer;
	        /**
	         * stencil+depth , usually costs 32bits per pixel
	         * @member {WebGLRenderbuffer}
	         */
	        this.stencil = null;
	        /**
	         * latest known version of framebuffer
	         * @member {number}
	         * @protected
	         */
	        this.dirtyId = 0;
	        /**
	         * latest known version of framebuffer format
	         * @member {number}
	         * @protected
	         */
	        this.dirtyFormat = 0;
	        /**
	         * latest known version of framebuffer size
	         * @member {number}
	         * @protected
	         */
	        this.dirtySize = 0;
	        /**
	         * Detected AA samples number
	         * @member {PIXI.MSAA_QUALITY}
	         */
	        this.multisample = exports.MSAA_QUALITY.NONE;
	        /**
	         * In case MSAA, we use this Renderbuffer instead of colorTextures[0] when we write info
	         * @member {WebGLRenderbuffer}
	         */
	        this.msaaBuffer = null;
	        /**
	         * In case we use MSAA, this is actual framebuffer that has colorTextures[0]
	         * The contents of that framebuffer are read when we use that renderTexture in sprites
	         * @member {PIXI.Framebuffer}
	         */
	        this.blitFramebuffer = null;
	    }
	    return GLFramebuffer;
	}());

	var tempRectangle = new Rectangle();
	/**
	 * System plugin to the renderer to manage framebuffers.
	 *
	 * @class
	 * @extends PIXI.System
	 * @memberof PIXI.systems
	 */
	var FramebufferSystem = /** @class */ (function (_super) {
	    __extends$2(FramebufferSystem, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this System works for.
	     */
	    function FramebufferSystem(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        /**
	         * A list of managed framebuffers
	         * @member {PIXI.Framebuffer[]}
	         * @readonly
	         */
	        _this.managedFramebuffers = [];
	        /**
	         * Framebuffer value that shows that we don't know what is bound
	         * @member {Framebuffer}
	         * @readonly
	         */
	        _this.unknownFramebuffer = new Framebuffer(10, 10);
	        _this.msaaSamples = null;
	        return _this;
	    }
	    /**
	     * Sets up the renderer context and necessary buffers.
	     */
	    FramebufferSystem.prototype.contextChange = function () {
	        var gl = this.gl = this.renderer.gl;
	        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
	        this.current = this.unknownFramebuffer;
	        this.viewport = new Rectangle();
	        this.hasMRT = true;
	        this.writeDepthTexture = true;
	        this.disposeAll(true);
	        // webgl2
	        if (this.renderer.context.webGLVersion === 1) {
	            // webgl 1!
	            var nativeDrawBuffersExtension_1 = this.renderer.context.extensions.drawBuffers;
	            var nativeDepthTextureExtension = this.renderer.context.extensions.depthTexture;
	            if (settings.PREFER_ENV === exports.ENV.WEBGL_LEGACY) {
	                nativeDrawBuffersExtension_1 = null;
	                nativeDepthTextureExtension = null;
	            }
	            if (nativeDrawBuffersExtension_1) {
	                gl.drawBuffers = function (activeTextures) {
	                    return nativeDrawBuffersExtension_1.drawBuffersWEBGL(activeTextures);
	                };
	            }
	            else {
	                this.hasMRT = false;
	                gl.drawBuffers = function () {
	                    // empty
	                };
	            }
	            if (!nativeDepthTextureExtension) {
	                this.writeDepthTexture = false;
	            }
	        }
	        else {
	            // WebGL2
	            // cache possible MSAA samples
	            this.msaaSamples = gl.getInternalformatParameter(gl.RENDERBUFFER, gl.RGBA8, gl.SAMPLES);
	        }
	    };
	    /**
	     * Bind a framebuffer
	     *
	     * @param {PIXI.Framebuffer} framebuffer
	     * @param {PIXI.Rectangle} [frame] frame, default is framebuffer size
	     */
	    FramebufferSystem.prototype.bind = function (framebuffer, frame) {
	        var gl = this.gl;
	        if (framebuffer) {
	            // TODO caching layer!
	            var fbo = framebuffer.glFramebuffers[this.CONTEXT_UID] || this.initFramebuffer(framebuffer);
	            if (this.current !== framebuffer) {
	                this.current = framebuffer;
	                gl.bindFramebuffer(gl.FRAMEBUFFER, fbo.framebuffer);
	            }
	            // make sure all textures are unbound..
	            // now check for updates...
	            if (fbo.dirtyId !== framebuffer.dirtyId) {
	                fbo.dirtyId = framebuffer.dirtyId;
	                if (fbo.dirtyFormat !== framebuffer.dirtyFormat) {
	                    fbo.dirtyFormat = framebuffer.dirtyFormat;
	                    this.updateFramebuffer(framebuffer);
	                }
	                else if (fbo.dirtySize !== framebuffer.dirtySize) {
	                    fbo.dirtySize = framebuffer.dirtySize;
	                    this.resizeFramebuffer(framebuffer);
	                }
	            }
	            for (var i = 0; i < framebuffer.colorTextures.length; i++) {
	                var tex = framebuffer.colorTextures[i];
	                this.renderer.texture.unbind(tex.parentTextureArray || tex);
	            }
	            if (framebuffer.depthTexture) {
	                this.renderer.texture.unbind(framebuffer.depthTexture);
	            }
	            if (frame) {
	                this.setViewport(frame.x, frame.y, frame.width, frame.height);
	            }
	            else {
	                this.setViewport(0, 0, framebuffer.width, framebuffer.height);
	            }
	        }
	        else {
	            if (this.current) {
	                this.current = null;
	                gl.bindFramebuffer(gl.FRAMEBUFFER, null);
	            }
	            if (frame) {
	                this.setViewport(frame.x, frame.y, frame.width, frame.height);
	            }
	            else {
	                this.setViewport(0, 0, this.renderer.width, this.renderer.height);
	            }
	        }
	    };
	    /**
	     * Set the WebGLRenderingContext's viewport.
	     *
	     * @param {Number} x - X position of viewport
	     * @param {Number} y - Y position of viewport
	     * @param {Number} width - Width of viewport
	     * @param {Number} height - Height of viewport
	     */
	    FramebufferSystem.prototype.setViewport = function (x, y, width, height) {
	        var v = this.viewport;
	        if (v.width !== width || v.height !== height || v.x !== x || v.y !== y) {
	            v.x = x;
	            v.y = y;
	            v.width = width;
	            v.height = height;
	            this.gl.viewport(x, y, width, height);
	        }
	    };
	    Object.defineProperty(FramebufferSystem.prototype, "size", {
	        /**
	         * Get the size of the current width and height. Returns object with `width` and `height` values.
	         *
	         * @member {object}
	         * @readonly
	         */
	        get: function () {
	            if (this.current) {
	                // TODO store temp
	                return { x: 0, y: 0, width: this.current.width, height: this.current.height };
	            }
	            return { x: 0, y: 0, width: this.renderer.width, height: this.renderer.height };
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Clear the color of the context
	     *
	     * @param {Number} r - Red value from 0 to 1
	     * @param {Number} g - Green value from 0 to 1
	     * @param {Number} b - Blue value from 0 to 1
	     * @param {Number} a - Alpha value from 0 to 1
	     * @param {PIXI.BUFFER_BITS} [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
	     *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
	     */
	    FramebufferSystem.prototype.clear = function (r, g, b, a, mask) {
	        if (mask === void 0) { mask = exports.BUFFER_BITS.COLOR | exports.BUFFER_BITS.DEPTH; }
	        var gl = this.gl;
	        // TODO clear color can be set only one right?
	        gl.clearColor(r, g, b, a);
	        gl.clear(mask);
	    };
	    /**
	     * Initialize framebuffer for this context
	     *
	     * @protected
	     * @param {PIXI.Framebuffer} framebuffer
	     * @returns {PIXI.GLFramebuffer} created GLFramebuffer
	     */
	    FramebufferSystem.prototype.initFramebuffer = function (framebuffer) {
	        var gl = this.gl;
	        var fbo = new GLFramebuffer(gl.createFramebuffer());
	        fbo.multisample = this.detectSamples(framebuffer.multisample);
	        framebuffer.glFramebuffers[this.CONTEXT_UID] = fbo;
	        this.managedFramebuffers.push(framebuffer);
	        framebuffer.disposeRunner.add(this);
	        return fbo;
	    };
	    /**
	     * Resize the framebuffer
	     *
	     * @protected
	     * @param {PIXI.Framebuffer} framebuffer
	     */
	    FramebufferSystem.prototype.resizeFramebuffer = function (framebuffer) {
	        var gl = this.gl;
	        var fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
	        if (fbo.stencil) {
	            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.stencil);
	            gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, framebuffer.width, framebuffer.height);
	        }
	        var colorTextures = framebuffer.colorTextures;
	        for (var i = 0; i < colorTextures.length; i++) {
	            this.renderer.texture.bind(colorTextures[i], 0);
	        }
	        if (framebuffer.depthTexture) {
	            this.renderer.texture.bind(framebuffer.depthTexture, 0);
	        }
	    };
	    /**
	     * Update the framebuffer
	     *
	     * @protected
	     * @param {PIXI.Framebuffer} framebuffer
	     */
	    FramebufferSystem.prototype.updateFramebuffer = function (framebuffer) {
	        var gl = this.gl;
	        var fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
	        // bind the color texture
	        var colorTextures = framebuffer.colorTextures;
	        var count = colorTextures.length;
	        if (!gl.drawBuffers) {
	            count = Math.min(count, 1);
	        }
	        if (fbo.multisample > 1) {
	            fbo.msaaBuffer = gl.createRenderbuffer();
	            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.msaaBuffer);
	            gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, gl.RGBA8, framebuffer.width, framebuffer.height);
	            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, fbo.msaaBuffer);
	        }
	        var activeTextures = [];
	        for (var i = 0; i < count; i++) {
	            if (i === 0 && fbo.multisample > 1) {
	                continue;
	            }
	            var texture = framebuffer.colorTextures[i];
	            var parentTexture = texture.parentTextureArray || texture;
	            this.renderer.texture.bind(parentTexture, 0);
	            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, texture.target, parentTexture._glTextures[this.CONTEXT_UID].texture, 0);
	            activeTextures.push(gl.COLOR_ATTACHMENT0 + i);
	        }
	        if (activeTextures.length > 1) {
	            gl.drawBuffers(activeTextures);
	        }
	        if (framebuffer.depthTexture) {
	            var writeDepthTexture = this.writeDepthTexture;
	            if (writeDepthTexture) {
	                var depthTexture = framebuffer.depthTexture;
	                this.renderer.texture.bind(depthTexture, 0);
	                gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.TEXTURE_2D, depthTexture._glTextures[this.CONTEXT_UID].texture, 0);
	            }
	        }
	        if (!fbo.stencil && (framebuffer.stencil || framebuffer.depth)) {
	            fbo.stencil = gl.createRenderbuffer();
	            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.stencil);
	            gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, framebuffer.width, framebuffer.height);
	            // TODO.. this is depth AND stencil?
	            if (!framebuffer.depthTexture) { // you can't have both, so one should take priority if enabled
	                gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, fbo.stencil);
	            }
	        }
	    };
	    /**
	     * Detects number of samples that is not more than a param but as close to it as possible
	     *
	     * @param {PIXI.MSAA_QUALITY} samples - number of samples
	     * @returns {PIXI.MSAA_QUALITY} - recommended number of samples
	     */
	    FramebufferSystem.prototype.detectSamples = function (samples) {
	        var msaaSamples = this.msaaSamples;
	        var res = exports.MSAA_QUALITY.NONE;
	        if (samples <= 1 || msaaSamples === null) {
	            return res;
	        }
	        for (var i = 0; i < msaaSamples.length; i++) {
	            if (msaaSamples[i] <= samples) {
	                res = msaaSamples[i];
	                break;
	            }
	        }
	        if (res === 1) {
	            res = exports.MSAA_QUALITY.NONE;
	        }
	        return res;
	    };
	    /**
	     * Only works with WebGL2
	     *
	     * blits framebuffer to another of the same or bigger size
	     * after that target framebuffer is bound
	     *
	     * Fails with WebGL warning if blits multisample framebuffer to different size
	     *
	     * @param {PIXI.Framebuffer} [framebuffer] - by default it blits "into itself", from renderBuffer to texture.
	     * @param {PIXI.Rectangle} [sourcePixels] - source rectangle in pixels
	     * @param {PIXI.Rectangle} [destPixels] - dest rectangle in pixels, assumed to be the same as sourcePixels
	     */
	    FramebufferSystem.prototype.blit = function (framebuffer, sourcePixels, destPixels) {
	        var _a = this, current = _a.current, renderer = _a.renderer, gl = _a.gl, CONTEXT_UID = _a.CONTEXT_UID;
	        if (renderer.context.webGLVersion !== 2) {
	            return;
	        }
	        if (!current) {
	            return;
	        }
	        var fbo = current.glFramebuffers[CONTEXT_UID];
	        if (!fbo) {
	            return;
	        }
	        if (!framebuffer) {
	            if (fbo.multisample <= 1) {
	                return;
	            }
	            if (!fbo.blitFramebuffer) {
	                fbo.blitFramebuffer = new Framebuffer(current.width, current.height);
	                fbo.blitFramebuffer.addColorTexture(0, current.colorTextures[0]);
	            }
	            framebuffer = fbo.blitFramebuffer;
	            framebuffer.width = current.width;
	            framebuffer.height = current.height;
	        }
	        if (!sourcePixels) {
	            sourcePixels = tempRectangle;
	            sourcePixels.width = current.width;
	            sourcePixels.height = current.height;
	        }
	        if (!destPixels) {
	            destPixels = sourcePixels;
	        }
	        var sameSize = sourcePixels.width === destPixels.width && sourcePixels.height === destPixels.height;
	        this.bind(framebuffer);
	        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, fbo.framebuffer);
	        gl.blitFramebuffer(sourcePixels.x, sourcePixels.y, sourcePixels.width, sourcePixels.height, destPixels.x, destPixels.y, destPixels.width, destPixels.height, gl.COLOR_BUFFER_BIT, sameSize ? gl.NEAREST : gl.LINEAR);
	    };
	    /**
	     * Disposes framebuffer
	     * @param {PIXI.Framebuffer} framebuffer - framebuffer that has to be disposed of
	     * @param {boolean} [contextLost=false] - If context was lost, we suppress all delete function calls
	     */
	    FramebufferSystem.prototype.disposeFramebuffer = function (framebuffer, contextLost) {
	        var fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
	        var gl = this.gl;
	        if (!fbo) {
	            return;
	        }
	        delete framebuffer.glFramebuffers[this.CONTEXT_UID];
	        var index = this.managedFramebuffers.indexOf(framebuffer);
	        if (index >= 0) {
	            this.managedFramebuffers.splice(index, 1);
	        }
	        framebuffer.disposeRunner.remove(this);
	        if (!contextLost) {
	            gl.deleteFramebuffer(fbo.framebuffer);
	            if (fbo.stencil) {
	                gl.deleteRenderbuffer(fbo.stencil);
	            }
	        }
	    };
	    /**
	     * Disposes all framebuffers, but not textures bound to them
	     * @param {boolean} [contextLost=false] - If context was lost, we suppress all delete function calls
	     */
	    FramebufferSystem.prototype.disposeAll = function (contextLost) {
	        var list = this.managedFramebuffers;
	        this.managedFramebuffers = [];
	        for (var i = 0; i < list.length; i++) {
	            this.disposeFramebuffer(list[i], contextLost);
	        }
	    };
	    /**
	     * Forcing creation of stencil buffer for current framebuffer, if it wasn't done before.
	     * Used by MaskSystem, when its time to use stencil mask for Graphics element.
	     *
	     * Its an alternative for public lazy `framebuffer.enableStencil`, in case we need stencil without rebind.
	     *
	     * @private
	     */
	    FramebufferSystem.prototype.forceStencil = function () {
	        var framebuffer = this.current;
	        if (!framebuffer) {
	            return;
	        }
	        var fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
	        if (!fbo || fbo.stencil) {
	            return;
	        }
	        framebuffer.enableStencil();
	        var w = framebuffer.width;
	        var h = framebuffer.height;
	        var gl = this.gl;
	        var stencil = gl.createRenderbuffer();
	        gl.bindRenderbuffer(gl.RENDERBUFFER, stencil);
	        gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, w, h);
	        fbo.stencil = stencil;
	        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, stencil);
	    };
	    /**
	     * resets framebuffer stored state, binds screen framebuffer
	     *
	     * should be called before renderTexture reset()
	     */
	    FramebufferSystem.prototype.reset = function () {
	        this.current = this.unknownFramebuffer;
	        this.viewport = new Rectangle();
	    };
	    return FramebufferSystem;
	}(System));

	var GLBuffer = /** @class */ (function () {
	    function GLBuffer(buffer) {
	        this.buffer = buffer || null;
	        this.updateID = -1;
	        this.byteLength = -1;
	        this.refCount = 0;
	    }
	    return GLBuffer;
	}());

	var byteSizeMap$1 = { 5126: 4, 5123: 2, 5121: 1 };
	/**
	 * System plugin to the renderer to manage geometry.
	 *
	 * @class
	 * @extends PIXI.System
	 * @memberof PIXI.systems
	 */
	var GeometrySystem = /** @class */ (function (_super) {
	    __extends$2(GeometrySystem, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this System works for.
	     */
	    function GeometrySystem(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        _this._activeGeometry = null;
	        _this._activeVao = null;
	        /**
	         * `true` if we has `*_vertex_array_object` extension
	         * @member {boolean}
	         * @readonly
	         */
	        _this.hasVao = true;
	        /**
	         * `true` if has `ANGLE_instanced_arrays` extension
	         * @member {boolean}
	         * @readonly
	         */
	        _this.hasInstance = true;
	        /**
	         * `true` if support `gl.UNSIGNED_INT` in `gl.drawElements` or `gl.drawElementsInstanced`
	         * @member {boolean}
	         * @readonly
	         */
	        _this.canUseUInt32ElementIndex = false;
	        /**
	         * Cache for all geometries by id, used in case renderer gets destroyed or for profiling
	         * @member {object}
	         * @readonly
	         */
	        _this.managedGeometries = {};
	        /**
	         * Cache for all buffers by id, used in case renderer gets destroyed or for profiling
	         * @member {object}
	         * @readonly
	         */
	        _this.managedBuffers = {};
	        return _this;
	    }
	    /**
	     * Sets up the renderer context and necessary buffers.
	     */
	    GeometrySystem.prototype.contextChange = function () {
	        this.disposeAll(true);
	        var gl = this.gl = this.renderer.gl;
	        var context = this.renderer.context;
	        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
	        // webgl2
	        if (context.webGLVersion !== 2) {
	            // webgl 1!
	            var nativeVaoExtension_1 = this.renderer.context.extensions.vertexArrayObject;
	            if (settings.PREFER_ENV === exports.ENV.WEBGL_LEGACY) {
	                nativeVaoExtension_1 = null;
	            }
	            if (nativeVaoExtension_1) {
	                gl.createVertexArray = function () {
	                    return nativeVaoExtension_1.createVertexArrayOES();
	                };
	                gl.bindVertexArray = function (vao) {
	                    return nativeVaoExtension_1.bindVertexArrayOES(vao);
	                };
	                gl.deleteVertexArray = function (vao) {
	                    return nativeVaoExtension_1.deleteVertexArrayOES(vao);
	                };
	            }
	            else {
	                this.hasVao = false;
	                gl.createVertexArray = function () {
	                    return null;
	                };
	                gl.bindVertexArray = function () {
	                    return null;
	                };
	                gl.deleteVertexArray = function () {
	                    return null;
	                };
	            }
	        }
	        if (context.webGLVersion !== 2) {
	            var instanceExt_1 = gl.getExtension('ANGLE_instanced_arrays');
	            if (instanceExt_1) {
	                gl.vertexAttribDivisor = function (a, b) {
	                    return instanceExt_1.vertexAttribDivisorANGLE(a, b);
	                };
	                gl.drawElementsInstanced = function (a, b, c, d, e) {
	                    return instanceExt_1.drawElementsInstancedANGLE(a, b, c, d, e);
	                };
	                gl.drawArraysInstanced = function (a, b, c, d) {
	                    return instanceExt_1.drawArraysInstancedANGLE(a, b, c, d);
	                };
	            }
	            else {
	                this.hasInstance = false;
	            }
	        }
	        this.canUseUInt32ElementIndex = context.webGLVersion === 2 || !!context.extensions.uint32ElementIndex;
	    };
	    /**
	     * Binds geometry so that is can be drawn. Creating a Vao if required
	     *
	     * @param {PIXI.Geometry} geometry - instance of geometry to bind
	     * @param {PIXI.Shader} [shader] - instance of shader to use vao for
	     */
	    GeometrySystem.prototype.bind = function (geometry, shader) {
	        shader = shader || this.renderer.shader.shader;
	        var gl = this.gl;
	        // not sure the best way to address this..
	        // currently different shaders require different VAOs for the same geometry
	        // Still mulling over the best way to solve this one..
	        // will likely need to modify the shader attribute locations at run time!
	        var vaos = geometry.glVertexArrayObjects[this.CONTEXT_UID];
	        var incRefCount = false;
	        if (!vaos) {
	            this.managedGeometries[geometry.id] = geometry;
	            geometry.disposeRunner.add(this);
	            geometry.glVertexArrayObjects[this.CONTEXT_UID] = vaos = {};
	            incRefCount = true;
	        }
	        var vao = vaos[shader.program.id] || this.initGeometryVao(geometry, shader.program, incRefCount);
	        this._activeGeometry = geometry;
	        if (this._activeVao !== vao) {
	            this._activeVao = vao;
	            if (this.hasVao) {
	                gl.bindVertexArray(vao);
	            }
	            else {
	                this.activateVao(geometry, shader.program);
	            }
	        }
	        // TODO - optimise later!
	        // don't need to loop through if nothing changed!
	        // maybe look to add an 'autoupdate' to geometry?
	        this.updateBuffers();
	    };
	    /**
	     * Reset and unbind any active VAO and geometry
	     */
	    GeometrySystem.prototype.reset = function () {
	        this.unbind();
	    };
	    /**
	     * Update buffers
	     * @protected
	     */
	    GeometrySystem.prototype.updateBuffers = function () {
	        var geometry = this._activeGeometry;
	        var gl = this.gl;
	        for (var i = 0; i < geometry.buffers.length; i++) {
	            var buffer = geometry.buffers[i];
	            var glBuffer = buffer._glBuffers[this.CONTEXT_UID];
	            if (buffer._updateID !== glBuffer.updateID) {
	                glBuffer.updateID = buffer._updateID;
	                // TODO can cache this on buffer! maybe added a getter / setter?
	                var type = buffer.index ? gl.ELEMENT_ARRAY_BUFFER : gl.ARRAY_BUFFER;
	                // TODO this could change if the VAO changes...
	                // need to come up with a better way to cache..
	                // if (this.boundBuffers[type] !== glBuffer)
	                // {
	                // this.boundBuffers[type] = glBuffer;
	                gl.bindBuffer(type, glBuffer.buffer);
	                // }
	                this._boundBuffer = glBuffer;
	                if (glBuffer.byteLength >= buffer.data.byteLength) {
	                    // offset is always zero for now!
	                    gl.bufferSubData(type, 0, buffer.data);
	                }
	                else {
	                    var drawType = buffer.static ? gl.STATIC_DRAW : gl.DYNAMIC_DRAW;
	                    glBuffer.byteLength = buffer.data.byteLength;
	                    gl.bufferData(type, buffer.data, drawType);
	                }
	            }
	        }
	    };
	    /**
	     * Check compability between a geometry and a program
	     * @protected
	     * @param {PIXI.Geometry} geometry - Geometry instance
	     * @param {PIXI.Program} program - Program instance
	     */
	    GeometrySystem.prototype.checkCompatibility = function (geometry, program) {
	        // geometry must have at least all the attributes that the shader requires.
	        var geometryAttributes = geometry.attributes;
	        var shaderAttributes = program.attributeData;
	        for (var j in shaderAttributes) {
	            if (!geometryAttributes[j]) {
	                throw new Error("shader and geometry incompatible, geometry missing the \"" + j + "\" attribute");
	            }
	        }
	    };
	    /**
	     * Takes a geometry and program and generates a unique signature for them.
	     *
	     * @param {PIXI.Geometry} geometry - to get signature from
	     * @param {PIXI.Program} program - to test geometry against
	     * @returns {String} Unique signature of the geometry and program
	     * @protected
	     */
	    GeometrySystem.prototype.getSignature = function (geometry, program) {
	        var attribs = geometry.attributes;
	        var shaderAttributes = program.attributeData;
	        var strings = ['g', geometry.id];
	        for (var i in attribs) {
	            if (shaderAttributes[i]) {
	                strings.push(i);
	            }
	        }
	        return strings.join('-');
	    };
	    /**
	     * Creates or gets Vao with the same structure as the geometry and stores it on the geometry.
	     * If vao is created, it is bound automatically.
	     *
	     * @protected
	     * @param {PIXI.Geometry} geometry - Instance of geometry to to generate Vao for
	     * @param {PIXI.Program} program - Instance of program
	     * @param {boolean} [incRefCount=false] - Increment refCount of all geometry buffers
	     */
	    GeometrySystem.prototype.initGeometryVao = function (geometry, program, incRefCount) {
	        if (incRefCount === void 0) { incRefCount = true; }
	        this.checkCompatibility(geometry, program);
	        var gl = this.gl;
	        var CONTEXT_UID = this.CONTEXT_UID;
	        var signature = this.getSignature(geometry, program);
	        var vaoObjectHash = geometry.glVertexArrayObjects[this.CONTEXT_UID];
	        var vao = vaoObjectHash[signature];
	        if (vao) {
	            // this will give us easy access to the vao
	            vaoObjectHash[program.id] = vao;
	            return vao;
	        }
	        var buffers = geometry.buffers;
	        var attributes = geometry.attributes;
	        var tempStride = {};
	        var tempStart = {};
	        for (var j in buffers) {
	            tempStride[j] = 0;
	            tempStart[j] = 0;
	        }
	        for (var j in attributes) {
	            if (!attributes[j].size && program.attributeData[j]) {
	                attributes[j].size = program.attributeData[j].size;
	            }
	            else if (!attributes[j].size) {
	                console.warn("PIXI Geometry attribute '" + j + "' size cannot be determined (likely the bound shader does not have the attribute)"); // eslint-disable-line
	            }
	            tempStride[attributes[j].buffer] += attributes[j].size * byteSizeMap$1[attributes[j].type];
	        }
	        for (var j in attributes) {
	            var attribute = attributes[j];
	            var attribSize = attribute.size;
	            if (attribute.stride === undefined) {
	                if (tempStride[attribute.buffer] === attribSize * byteSizeMap$1[attribute.type]) {
	                    attribute.stride = 0;
	                }
	                else {
	                    attribute.stride = tempStride[attribute.buffer];
	                }
	            }
	            if (attribute.start === undefined) {
	                attribute.start = tempStart[attribute.buffer];
	                tempStart[attribute.buffer] += attribSize * byteSizeMap$1[attribute.type];
	            }
	        }
	        vao = gl.createVertexArray();
	        gl.bindVertexArray(vao);
	        // first update - and create the buffers!
	        // only create a gl buffer if it actually gets
	        for (var i = 0; i < buffers.length; i++) {
	            var buffer = buffers[i];
	            if (!buffer._glBuffers[CONTEXT_UID]) {
	                buffer._glBuffers[CONTEXT_UID] = new GLBuffer(gl.createBuffer());
	                this.managedBuffers[buffer.id] = buffer;
	                buffer.disposeRunner.add(this);
	            }
	            if (incRefCount) {
	                buffer._glBuffers[CONTEXT_UID].refCount++;
	            }
	        }
	        // TODO - maybe make this a data object?
	        // lets wait to see if we need to first!
	        this.activateVao(geometry, program);
	        this._activeVao = vao;
	        // add it to the cache!
	        vaoObjectHash[program.id] = vao;
	        vaoObjectHash[signature] = vao;
	        return vao;
	    };
	    /**
	     * Disposes buffer
	     * @param {PIXI.Buffer} buffer - buffer with data
	     * @param {boolean} [contextLost=false] - If context was lost, we suppress deleteVertexArray
	     */
	    GeometrySystem.prototype.disposeBuffer = function (buffer, contextLost) {
	        if (!this.managedBuffers[buffer.id]) {
	            return;
	        }
	        delete this.managedBuffers[buffer.id];
	        var glBuffer = buffer._glBuffers[this.CONTEXT_UID];
	        var gl = this.gl;
	        buffer.disposeRunner.remove(this);
	        if (!glBuffer) {
	            return;
	        }
	        if (!contextLost) {
	            gl.deleteBuffer(glBuffer.buffer);
	        }
	        delete buffer._glBuffers[this.CONTEXT_UID];
	    };
	    /**
	     * Disposes geometry
	     * @param {PIXI.Geometry} geometry - Geometry with buffers. Only VAO will be disposed
	     * @param {boolean} [contextLost=false] - If context was lost, we suppress deleteVertexArray
	     */
	    GeometrySystem.prototype.disposeGeometry = function (geometry, contextLost) {
	        if (!this.managedGeometries[geometry.id]) {
	            return;
	        }
	        delete this.managedGeometries[geometry.id];
	        var vaos = geometry.glVertexArrayObjects[this.CONTEXT_UID];
	        var gl = this.gl;
	        var buffers = geometry.buffers;
	        geometry.disposeRunner.remove(this);
	        if (!vaos) {
	            return;
	        }
	        for (var i = 0; i < buffers.length; i++) {
	            var buf = buffers[i]._glBuffers[this.CONTEXT_UID];
	            buf.refCount--;
	            if (buf.refCount === 0 && !contextLost) {
	                this.disposeBuffer(buffers[i], contextLost);
	            }
	        }
	        if (!contextLost) {
	            for (var vaoId in vaos) {
	                // delete only signatures, everything else are copies
	                if (vaoId[0] === 'g') {
	                    var vao = vaos[vaoId];
	                    if (this._activeVao === vao) {
	                        this.unbind();
	                    }
	                    gl.deleteVertexArray(vao);
	                }
	            }
	        }
	        delete geometry.glVertexArrayObjects[this.CONTEXT_UID];
	    };
	    /**
	     * dispose all WebGL resources of all managed geometries and buffers
	     * @param {boolean} [contextLost=false] - If context was lost, we suppress `gl.delete` calls
	     */
	    GeometrySystem.prototype.disposeAll = function (contextLost) {
	        var all = Object.keys(this.managedGeometries);
	        for (var i = 0; i < all.length; i++) {
	            this.disposeGeometry(this.managedGeometries[all[i]], contextLost);
	        }
	        all = Object.keys(this.managedBuffers);
	        for (var i = 0; i < all.length; i++) {
	            this.disposeBuffer(this.managedBuffers[all[i]], contextLost);
	        }
	    };
	    /**
	     * Activate vertex array object
	     *
	     * @protected
	     * @param {PIXI.Geometry} geometry - Geometry instance
	     * @param {PIXI.Program} program - Shader program instance
	     */
	    GeometrySystem.prototype.activateVao = function (geometry, program) {
	        var gl = this.gl;
	        var CONTEXT_UID = this.CONTEXT_UID;
	        var buffers = geometry.buffers;
	        var attributes = geometry.attributes;
	        if (geometry.indexBuffer) {
	            // first update the index buffer if we have one..
	            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, geometry.indexBuffer._glBuffers[CONTEXT_UID].buffer);
	        }
	        var lastBuffer = null;
	        // add a new one!
	        for (var j in attributes) {
	            var attribute = attributes[j];
	            var buffer = buffers[attribute.buffer];
	            var glBuffer = buffer._glBuffers[CONTEXT_UID];
	            if (program.attributeData[j]) {
	                if (lastBuffer !== glBuffer) {
	                    gl.bindBuffer(gl.ARRAY_BUFFER, glBuffer.buffer);
	                    lastBuffer = glBuffer;
	                }
	                var location = program.attributeData[j].location;
	                // TODO introduce state again
	                // we can optimise this for older devices that have no VAOs
	                gl.enableVertexAttribArray(location);
	                gl.vertexAttribPointer(location, attribute.size, attribute.type || gl.FLOAT, attribute.normalized, attribute.stride, attribute.start);
	                if (attribute.instance) {
	                    // TODO calculate instance count based of this...
	                    if (this.hasInstance) {
	                        gl.vertexAttribDivisor(location, 1);
	                    }
	                    else {
	                        throw new Error('geometry error, GPU Instancing is not supported on this device');
	                    }
	                }
	            }
	        }
	    };
	    /**
	     * Draw the geometry
	     *
	     * @param {Number} type - the type primitive to render
	     * @param {Number} [size] - the number of elements to be rendered
	     * @param {Number} [start] - Starting index
	     * @param {Number} [instanceCount] - the number of instances of the set of elements to execute
	     */
	    GeometrySystem.prototype.draw = function (type, size, start, instanceCount) {
	        var gl = this.gl;
	        var geometry = this._activeGeometry;
	        // TODO.. this should not change so maybe cache the function?
	        if (geometry.indexBuffer) {
	            var byteSize = geometry.indexBuffer.data.BYTES_PER_ELEMENT;
	            var glType = byteSize === 2 ? gl.UNSIGNED_SHORT : gl.UNSIGNED_INT;
	            if (byteSize === 2 || (byteSize === 4 && this.canUseUInt32ElementIndex)) {
	                if (geometry.instanced) {
	                    /* eslint-disable max-len */
	                    gl.drawElementsInstanced(type, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize, instanceCount || 1);
	                    /* eslint-enable max-len */
	                }
	                else {
	                    /* eslint-disable max-len */
	                    gl.drawElements(type, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize);
	                    /* eslint-enable max-len */
	                }
	            }
	            else {
	                console.warn('unsupported index buffer type: uint32');
	            }
	        }
	        else if (geometry.instanced) {
	            // TODO need a better way to calculate size..
	            gl.drawArraysInstanced(type, start, size || geometry.getSize(), instanceCount || 1);
	        }
	        else {
	            gl.drawArrays(type, start, size || geometry.getSize());
	        }
	        return this;
	    };
	    /**
	     * Unbind/reset everything
	     * @protected
	     */
	    GeometrySystem.prototype.unbind = function () {
	        this.gl.bindVertexArray(null);
	        this._activeVao = null;
	        this._activeGeometry = null;
	    };
	    return GeometrySystem;
	}(System));

	/**
	 * Component for masked elements
	 *
	 * Holds mask mode and temporary data about current mask
	 *
	 * @class
	 * @memberof PIXI
	 */
	var MaskData = /** @class */ (function () {
	    /**
	     * Create MaskData
	     *
	     * @param {PIXI.DisplayObject} [maskObject=null] - object that describes the mask
	     */
	    function MaskData(maskObject) {
	        if (maskObject === void 0) { maskObject = null; }
	        /**
	         * Mask type
	         * @member {PIXI.MASK_TYPES}
	         */
	        this.type = exports.MASK_TYPES.NONE;
	        /**
	         * Whether we know the mask type beforehand
	         * @member {boolean}
	         * @default true
	         */
	        this.autoDetect = true;
	        /**
	         * Which element we use to mask
	         * @member {PIXI.DisplayObject}
	         */
	        this.maskObject = maskObject || null;
	        /**
	         * Whether it belongs to MaskSystem pool
	         * @member {boolean}
	         */
	        this.pooled = false;
	        /**
	         * Indicator of the type
	         * @member {boolean}
	         */
	        this.isMaskData = true;
	        /**
	         * Stencil counter above the mask in stack
	         * @member {number}
	         * @private
	         */
	        this._stencilCounter = 0;
	        /**
	         * Scissor counter above the mask in stack
	         * @member {number}
	         * @private
	         */
	        this._scissorCounter = 0;
	        /**
	         * Scissor operation above the mask in stack.
	         * Null if _scissorCounter is zero, rectangle instance if positive.
	         * @member {PIXI.Rectangle}
	         */
	        this._scissorRect = null;
	        /**
	         * Targeted element. Temporary variable set by MaskSystem
	         * @member {PIXI.DisplayObject}
	         * @private
	         */
	        this._target = null;
	    }
	    /**
	     * resets the mask data after popMask()
	     */
	    MaskData.prototype.reset = function () {
	        if (this.pooled) {
	            this.maskObject = null;
	            this.type = exports.MASK_TYPES.NONE;
	            this.autoDetect = true;
	        }
	        this._target = null;
	    };
	    /**
	     * copies counters from maskData above, called from pushMask()
	     * @param {PIXI.MaskData|null} maskAbove
	     */
	    MaskData.prototype.copyCountersOrReset = function (maskAbove) {
	        if (maskAbove) {
	            this._stencilCounter = maskAbove._stencilCounter;
	            this._scissorCounter = maskAbove._scissorCounter;
	            this._scissorRect = maskAbove._scissorRect;
	        }
	        else {
	            this._stencilCounter = 0;
	            this._scissorCounter = 0;
	            this._scissorRect = null;
	        }
	    };
	    return MaskData;
	}());

	/**
	 * @private
	 * @param gl {WebGLRenderingContext} The current WebGL context {WebGLProgram}
	 * @param type {Number} the type, can be either VERTEX_SHADER or FRAGMENT_SHADER
	 * @param src {string} The vertex shader source as an array of strings.
	 * @return {WebGLShader} the shader
	 */
	function compileShader(gl, type, src) {
	    var shader = gl.createShader(type);
	    gl.shaderSource(shader, src);
	    gl.compileShader(shader);
	    return shader;
	}
	/**
	 * @method compileProgram
	 * @private
	 * @memberof PIXI.glCore.shader
	 * @param gl {WebGLRenderingContext} The current WebGL context {WebGLProgram}
	 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
	 * @param fragmentSrc {string|string[]} The fragment shader source as an array of strings.
	 * @param attributeLocations {Object} An attribute location map that lets you manually set the attribute locations
	 * @return {WebGLProgram} the shader program
	 */
	function compileProgram(gl, vertexSrc, fragmentSrc, attributeLocations) {
	    var glVertShader = compileShader(gl, gl.VERTEX_SHADER, vertexSrc);
	    var glFragShader = compileShader(gl, gl.FRAGMENT_SHADER, fragmentSrc);
	    var program = gl.createProgram();
	    gl.attachShader(program, glVertShader);
	    gl.attachShader(program, glFragShader);
	    // optionally, set the attributes manually for the program rather than letting WebGL decide..
	    if (attributeLocations) {
	        for (var i in attributeLocations) {
	            gl.bindAttribLocation(program, attributeLocations[i], i);
	        }
	    }
	    gl.linkProgram(program);
	    // if linking fails, then log and cleanup
	    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
	        if (!gl.getShaderParameter(glVertShader, gl.COMPILE_STATUS)) {
	            console.warn(vertexSrc);
	            console.error(gl.getShaderInfoLog(glVertShader));
	        }
	        if (!gl.getShaderParameter(glFragShader, gl.COMPILE_STATUS)) {
	            console.warn(fragmentSrc);
	            console.error(gl.getShaderInfoLog(glFragShader));
	        }
	        console.error('Pixi.js Error: Could not initialize shader.');
	        console.error('gl.VALIDATE_STATUS', gl.getProgramParameter(program, gl.VALIDATE_STATUS));
	        console.error('gl.getError()', gl.getError());
	        // if there is a program info log, log it
	        if (gl.getProgramInfoLog(program) !== '') {
	            console.warn('Pixi.js Warning: gl.getProgramInfoLog()', gl.getProgramInfoLog(program));
	        }
	        gl.deleteProgram(program);
	        program = null;
	    }
	    // clean up some shaders
	    gl.deleteShader(glVertShader);
	    gl.deleteShader(glFragShader);
	    return program;
	}

	function booleanArray(size) {
	    var array = new Array(size);
	    for (var i = 0; i < array.length; i++) {
	        array[i] = false;
	    }
	    return array;
	}
	/**
	 * @method defaultValue
	 * @memberof PIXI.glCore.shader
	 * @param type {String} Type of value
	 * @param size {Number}
	 * @private
	 */
	function defaultValue(type, size) {
	    switch (type) {
	        case 'float':
	            return 0;
	        case 'vec2':
	            return new Float32Array(2 * size);
	        case 'vec3':
	            return new Float32Array(3 * size);
	        case 'vec4':
	            return new Float32Array(4 * size);
	        case 'int':
	        case 'sampler2D':
	        case 'sampler2DArray':
	            return 0;
	        case 'ivec2':
	            return new Int32Array(2 * size);
	        case 'ivec3':
	            return new Int32Array(3 * size);
	        case 'ivec4':
	            return new Int32Array(4 * size);
	        case 'bool':
	            return false;
	        case 'bvec2':
	            return booleanArray(2 * size);
	        case 'bvec3':
	            return booleanArray(3 * size);
	        case 'bvec4':
	            return booleanArray(4 * size);
	        case 'mat2':
	            return new Float32Array([1, 0,
	                0, 1]);
	        case 'mat3':
	            return new Float32Array([1, 0, 0,
	                0, 1, 0,
	                0, 0, 1]);
	        case 'mat4':
	            return new Float32Array([1, 0, 0, 0,
	                0, 1, 0, 0,
	                0, 0, 1, 0,
	                0, 0, 0, 1]);
	    }
	    return null;
	}

	var unknownContext = {};
	var context = unknownContext;
	/**
	 * returns a little WebGL context to use for program inspection.
	 *
	 * @static
	 * @private
	 * @returns {WebGLRenderingContext} a gl context to test with
	 */
	function getTestContext() {
	    if (context === unknownContext || (context && context.isContextLost())) {
	        var canvas = document.createElement('canvas');
	        var gl = void 0;
	        if (settings.PREFER_ENV >= exports.ENV.WEBGL2) {
	            gl = canvas.getContext('webgl2', {});
	        }
	        if (!gl) {
	            gl = canvas.getContext('webgl', {})
	                || canvas.getContext('experimental-webgl', {});
	            if (!gl) {
	                // fail, not able to get a context
	                gl = null;
	            }
	            else {
	                // for shader testing..
	                gl.getExtension('WEBGL_draw_buffers');
	            }
	        }
	        context = gl;
	    }
	    return context;
	}

	var maxFragmentPrecision;
	function getMaxFragmentPrecision() {
	    if (!maxFragmentPrecision) {
	        maxFragmentPrecision = exports.PRECISION.MEDIUM;
	        var gl = getTestContext();
	        if (gl) {
	            if (gl.getShaderPrecisionFormat) {
	                var shaderFragment = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
	                maxFragmentPrecision = shaderFragment.precision ? exports.PRECISION.HIGH : exports.PRECISION.MEDIUM;
	            }
	        }
	    }
	    return maxFragmentPrecision;
	}

	/**
	 * Sets the float precision on the shader, ensuring the device supports the request precision.
	 * If the precision is already present, it just ensures that the device is able to handle it.
	 *
	 * @private
	 * @param {string} src - The shader source
	 * @param {string} requestedPrecision - The request float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
	 * @param {string} maxSupportedPrecision - The maximum precision the shader supports.
	 *
	 * @return {string} modified shader source
	 */
	function setPrecision(src, requestedPrecision, maxSupportedPrecision) {
	    if (src.substring(0, 9) !== 'precision') {
	        // no precision supplied, so PixiJS will add the requested level.
	        var precision = requestedPrecision;
	        // If highp is requested but not supported, downgrade precision to a level all devices support.
	        if (requestedPrecision === exports.PRECISION.HIGH && maxSupportedPrecision !== exports.PRECISION.HIGH) {
	            precision = exports.PRECISION.MEDIUM;
	        }
	        return "precision " + precision + " float;\n" + src;
	    }
	    else if (maxSupportedPrecision !== exports.PRECISION.HIGH && src.substring(0, 15) === 'precision highp') {
	        // precision was supplied, but at a level this device does not support, so downgrading to mediump.
	        return src.replace('precision highp', 'precision mediump');
	    }
	    return src;
	}

	var GLSL_TO_SIZE = {
	    float: 1,
	    vec2: 2,
	    vec3: 3,
	    vec4: 4,
	    int: 1,
	    ivec2: 2,
	    ivec3: 3,
	    ivec4: 4,
	    bool: 1,
	    bvec2: 2,
	    bvec3: 3,
	    bvec4: 4,
	    mat2: 4,
	    mat3: 9,
	    mat4: 16,
	    sampler2D: 1,
	};
	/**
	 * @private
	 * @method mapSize
	 * @memberof PIXI.glCore.shader
	 * @param type {String}
	 * @return {Number}
	 */
	function mapSize(type) {
	    return GLSL_TO_SIZE[type];
	}

	var GL_TABLE = null;
	var GL_TO_GLSL_TYPES = {
	    FLOAT: 'float',
	    FLOAT_VEC2: 'vec2',
	    FLOAT_VEC3: 'vec3',
	    FLOAT_VEC4: 'vec4',
	    INT: 'int',
	    INT_VEC2: 'ivec2',
	    INT_VEC3: 'ivec3',
	    INT_VEC4: 'ivec4',
	    BOOL: 'bool',
	    BOOL_VEC2: 'bvec2',
	    BOOL_VEC3: 'bvec3',
	    BOOL_VEC4: 'bvec4',
	    FLOAT_MAT2: 'mat2',
	    FLOAT_MAT3: 'mat3',
	    FLOAT_MAT4: 'mat4',
	    SAMPLER_2D: 'sampler2D',
	    INT_SAMPLER_2D: 'sampler2D',
	    UNSIGNED_INT_SAMPLER_2D: 'sampler2D',
	    SAMPLER_CUBE: 'samplerCube',
	    INT_SAMPLER_CUBE: 'samplerCube',
	    UNSIGNED_INT_SAMPLER_CUBE: 'samplerCube',
	    SAMPLER_2D_ARRAY: 'sampler2DArray',
	    INT_SAMPLER_2D_ARRAY: 'sampler2DArray',
	    UNSIGNED_INT_SAMPLER_2D_ARRAY: 'sampler2DArray',
	};
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function mapType(gl, type) {
	    if (!GL_TABLE) {
	        var typeNames = Object.keys(GL_TO_GLSL_TYPES);
	        GL_TABLE = {};
	        for (var i = 0; i < typeNames.length; ++i) {
	            var tn = typeNames[i];
	            GL_TABLE[gl[tn]] = GL_TO_GLSL_TYPES[tn];
	        }
	    }
	    return GL_TABLE[type];
	}

	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	// Parsers, each one of these will take a look at the type of shader property and uniform.
	// if they pass the test function then the code function is called that returns a the shader upload code for that uniform.
	// Shader upload code is automagically generated with these parsers.
	// If no parser is valid then the default upload functions are used.
	// exposing Parsers means that custom upload logic can be added to pixi's shaders.
	// A good example would be a pixi rectangle can be directly set on a uniform.
	// If the shader sees it it knows how to upload the rectangle structure as a vec4
	// format is as follows:
	//
	// {
	//     test: (data, uniform) => {} <--- test is this code should be used for this uniform
	//     code: (name, uniform) => {} <--- returns the string of the piece of code that uploads the uniform
	// }
	var uniformParsers = [
	    // a float cache layer
	    {
	        test: function (data) {
	            return data.type === 'float' && data.size === 1;
	        },
	        code: function (name) {
	            return "\n            if(uv[\"" + name + "\"] !== ud[\"" + name + "\"].value)\n            {\n                ud[\"" + name + "\"].value = uv[\"" + name + "\"]\n                gl.uniform1f(ud[\"" + name + "\"].location, uv[\"" + name + "\"])\n            }\n            ";
	        },
	    },
	    // handling samplers
	    {
	        test: function (data) {
	            // eslint-disable-next-line max-len
	            return (data.type === 'sampler2D' || data.type === 'samplerCube' || data.type === 'sampler2DArray') && data.size === 1 && !data.isArray;
	        },
	        code: function (name) { return "t = syncData.textureCount++;\n\n            renderer.texture.bind(uv[\"" + name + "\"], t);\n\n            if(ud[\"" + name + "\"].value !== t)\n            {\n                ud[\"" + name + "\"].value = t;\n                gl.uniform1i(ud[\"" + name + "\"].location, t);\n; // eslint-disable-line max-len\n            }"; },
	    },
	    // uploading pixi matrix object to mat3
	    {
	        test: function (data, uniform) {
	            return data.type === 'mat3' && data.size === 1 && uniform.a !== undefined;
	        },
	        code: function (name) {
	            // TODO and some smart caching dirty ids here!
	            return "\n            gl.uniformMatrix3fv(ud[\"" + name + "\"].location, false, uv[\"" + name + "\"].toArray(true));\n            ";
	        },
	    },
	    // uploading a pixi point as a vec2 with caching layer
	    {
	        test: function (data, uniform) {
	            return data.type === 'vec2' && data.size === 1 && uniform.x !== undefined;
	        },
	        code: function (name) {
	            return "\n                cv = ud[\"" + name + "\"].value;\n                v = uv[\"" + name + "\"];\n\n                if(cv[0] !== v.x || cv[1] !== v.y)\n                {\n                    cv[0] = v.x;\n                    cv[1] = v.y;\n                    gl.uniform2f(ud[\"" + name + "\"].location, v.x, v.y);\n                }";
	        },
	    },
	    // caching layer for a vec2
	    {
	        test: function (data) {
	            return data.type === 'vec2' && data.size === 1;
	        },
	        code: function (name) {
	            return "\n                cv = ud[\"" + name + "\"].value;\n                v = uv[\"" + name + "\"];\n\n                if(cv[0] !== v[0] || cv[1] !== v[1])\n                {\n                    cv[0] = v[0];\n                    cv[1] = v[1];\n                    gl.uniform2f(ud[\"" + name + "\"].location, v[0], v[1]);\n                }\n            ";
	        },
	    },
	    // upload a pixi rectangle as a vec4 with caching layer
	    {
	        test: function (data, uniform) {
	            return data.type === 'vec4' && data.size === 1 && uniform.width !== undefined;
	        },
	        code: function (name) {
	            return "\n                cv = ud[\"" + name + "\"].value;\n                v = uv[\"" + name + "\"];\n\n                if(cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height)\n                {\n                    cv[0] = v.x;\n                    cv[1] = v.y;\n                    cv[2] = v.width;\n                    cv[3] = v.height;\n                    gl.uniform4f(ud[\"" + name + "\"].location, v.x, v.y, v.width, v.height)\n                }";
	        },
	    },
	    // a caching layer for vec4 uploading
	    {
	        test: function (data) {
	            return data.type === 'vec4' && data.size === 1;
	        },
	        code: function (name) {
	            return "\n                cv = ud[\"" + name + "\"].value;\n                v = uv[\"" + name + "\"];\n\n                if(cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])\n                {\n                    cv[0] = v[0];\n                    cv[1] = v[1];\n                    cv[2] = v[2];\n                    cv[3] = v[3];\n\n                    gl.uniform4f(ud[\"" + name + "\"].location, v[0], v[1], v[2], v[3])\n                }";
	        },
	    } ];

	// cv = CachedValue
	// v = value
	// ud = uniformData
	// uv = uniformValue
	// l = location
	var GLSL_TO_SINGLE_SETTERS_CACHED = {
	    float: "\n    if(cv !== v)\n    {\n        cv.v = v;\n        gl.uniform1f(location, v)\n    }",
	    vec2: "\n    if(cv[0] !== v[0] || cv[1] !== v[1])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        gl.uniform2f(location, v[0], v[1])\n    }",
	    vec3: "\n    if(cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n\n        gl.uniform3f(location, v[0], v[1], v[2])\n    }",
	    vec4: 'gl.uniform4f(location, v[0], v[1], v[2], v[3])',
	    int: 'gl.uniform1i(location, v)',
	    ivec2: 'gl.uniform2i(location, v[0], v[1])',
	    ivec3: 'gl.uniform3i(location, v[0], v[1], v[2])',
	    ivec4: 'gl.uniform4i(location, v[0], v[1], v[2], v[3])',
	    bool: 'gl.uniform1i(location, v)',
	    bvec2: 'gl.uniform2i(location, v[0], v[1])',
	    bvec3: 'gl.uniform3i(location, v[0], v[1], v[2])',
	    bvec4: 'gl.uniform4i(location, v[0], v[1], v[2], v[3])',
	    mat2: 'gl.uniformMatrix2fv(location, false, v)',
	    mat3: 'gl.uniformMatrix3fv(location, false, v)',
	    mat4: 'gl.uniformMatrix4fv(location, false, v)',
	    sampler2D: 'gl.uniform1i(location, v)',
	    samplerCube: 'gl.uniform1i(location, v)',
	    sampler2DArray: 'gl.uniform1i(location, v)',
	};
	var GLSL_TO_ARRAY_SETTERS = {
	    float: "gl.uniform1fv(location, v)",
	    vec2: "gl.uniform2fv(location, v)",
	    vec3: "gl.uniform3fv(location, v)",
	    vec4: 'gl.uniform4fv(location, v)',
	    mat4: 'gl.uniformMatrix4fv(location, false, v)',
	    mat3: 'gl.uniformMatrix3fv(location, false, v)',
	    mat2: 'gl.uniformMatrix2fv(location, false, v)',
	    int: 'gl.uniform1iv(location, v)',
	    ivec2: 'gl.uniform2iv(location, v)',
	    ivec3: 'gl.uniform3iv(location, v)',
	    ivec4: 'gl.uniform4iv(location, v)',
	    bool: 'gl.uniform1iv(location, v)',
	    bvec2: 'gl.uniform2iv(location, v)',
	    bvec3: 'gl.uniform3iv(location, v)',
	    bvec4: 'gl.uniform4iv(location, v)',
	    sampler2D: 'gl.uniform1iv(location, v)',
	    samplerCube: 'gl.uniform1iv(location, v)',
	    sampler2DArray: 'gl.uniform1iv(location, v)',
	};
	function generateUniformsSync(group, uniformData) {
	    var funcFragments = ["\n        var v = null;\n        var cv = null\n        var t = 0;\n        var gl = renderer.gl\n    "];
	    for (var i in group.uniforms) {
	        var data = uniformData[i];
	        if (!data) {
	            if (group.uniforms[i].group) {
	                funcFragments.push("\n                    renderer.shader.syncUniformGroup(uv[\"" + i + "\"], syncData);\n                ");
	            }
	            continue;
	        }
	        var uniform = group.uniforms[i];
	        var parsed = false;
	        for (var j = 0; j < uniformParsers.length; j++) {
	            if (uniformParsers[j].test(data, uniform)) {
	                funcFragments.push(uniformParsers[j].code(i, uniform));
	                parsed = true;
	                break;
	            }
	        }
	        if (!parsed) {
	            var templateType = (data.size === 1) ? GLSL_TO_SINGLE_SETTERS_CACHED : GLSL_TO_ARRAY_SETTERS;
	            var template = templateType[data.type].replace('location', "ud[\"" + i + "\"].location");
	            funcFragments.push("\n            cv = ud[\"" + i + "\"].value;\n            v = uv[\"" + i + "\"];\n            " + template + ";");
	        }
	    }
	    /**
	     * the introduction of syncData is to solve an issue where textures in uniform groups are not set correctly
	     * the texture count was always starting from 0 in each group. This needs to increment each time a texture is used
	     * no matter which group is being used
	     *
	     */
	    // eslint-disable-next-line no-new-func
	    return new Function('ud', 'uv', 'renderer', 'syncData', funcFragments.join('\n'));
	}

	var fragTemplate = [
	    'precision mediump float;',
	    'void main(void){',
	    'float test = 0.1;',
	    '%forloop%',
	    'gl_FragColor = vec4(0.0);',
	    '}' ].join('\n');
	function generateIfTestSrc(maxIfs) {
	    var src = '';
	    for (var i = 0; i < maxIfs; ++i) {
	        if (i > 0) {
	            src += '\nelse ';
	        }
	        if (i < maxIfs - 1) {
	            src += "if(test == " + i + ".0){}";
	        }
	    }
	    return src;
	}
	function checkMaxIfStatementsInShader(maxIfs, gl) {
	    if (maxIfs === 0) {
	        throw new Error('Invalid value of `0` passed to `checkMaxIfStatementsInShader`');
	    }
	    var shader = gl.createShader(gl.FRAGMENT_SHADER);
	    while (true) // eslint-disable-line no-constant-condition
	     {
	        var fragmentSrc = fragTemplate.replace(/%forloop%/gi, generateIfTestSrc(maxIfs));
	        gl.shaderSource(shader, fragmentSrc);
	        gl.compileShader(shader);
	        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
	            maxIfs = (maxIfs / 2) | 0;
	        }
	        else {
	            // valid!
	            break;
	        }
	    }
	    return maxIfs;
	}

	// Cache the result to prevent running this over and over
	var unsafeEval;
	/**
	 * Not all platforms allow to generate function code (e.g., `new Function`).
	 * this provides the platform-level detection.
	 *
	 * @private
	 * @returns {boolean}
	 */
	function unsafeEvalSupported() {
	    if (typeof unsafeEval === 'boolean') {
	        return unsafeEval;
	    }
	    try {
	        /* eslint-disable no-new-func */
	        var func = new Function('param1', 'param2', 'param3', 'return param1[param2] === param3;');
	        /* eslint-enable no-new-func */
	        unsafeEval = func({ a: 'b' }, 'a', 'b') === true;
	    }
	    catch (e) {
	        unsafeEval = false;
	    }
	    return unsafeEval;
	}

	var defaultFragment = "varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\n\nvoid main(void){\n   gl_FragColor *= texture2D(uSampler, vTextureCoord);\n}";

	var defaultVertex = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void){\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n   vTextureCoord = aTextureCoord;\n}\n";

	var UID$3 = 0;
	var nameCache = {};
	/**
	 * Helper class to create a shader program.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Program = /** @class */ (function () {
	    /**
	     * @param {string} [vertexSrc] - The source of the vertex shader.
	     * @param {string} [fragmentSrc] - The source of the fragment shader.
	     * @param {string} [name] - Name for shader
	     */
	    function Program(vertexSrc, fragmentSrc, name) {
	        if (name === void 0) { name = 'pixi-shader'; }
	        this.id = UID$3++;
	        /**
	         * The vertex shader.
	         *
	         * @member {string}
	         */
	        this.vertexSrc = vertexSrc || Program.defaultVertexSrc;
	        /**
	         * The fragment shader.
	         *
	         * @member {string}
	         */
	        this.fragmentSrc = fragmentSrc || Program.defaultFragmentSrc;
	        this.vertexSrc = this.vertexSrc.trim();
	        this.fragmentSrc = this.fragmentSrc.trim();
	        if (this.vertexSrc.substring(0, 8) !== '#version') {
	            name = name.replace(/\s+/g, '-');
	            if (nameCache[name]) {
	                nameCache[name]++;
	                name += "-" + nameCache[name];
	            }
	            else {
	                nameCache[name] = 1;
	            }
	            this.vertexSrc = "#define SHADER_NAME " + name + "\n" + this.vertexSrc;
	            this.fragmentSrc = "#define SHADER_NAME " + name + "\n" + this.fragmentSrc;
	            this.vertexSrc = setPrecision(this.vertexSrc, settings.PRECISION_VERTEX, exports.PRECISION.HIGH);
	            this.fragmentSrc = setPrecision(this.fragmentSrc, settings.PRECISION_FRAGMENT, getMaxFragmentPrecision());
	        }
	        // currently this does not extract structs only default types
	        this.extractData(this.vertexSrc, this.fragmentSrc);
	        // this is where we store shader references..
	        this.glPrograms = {};
	        this.syncUniforms = null;
	    }
	    /**
	     * Extracts the data for a buy creating a small test program
	     * or reading the src directly.
	     * @protected
	     *
	     * @param {string} [vertexSrc] - The source of the vertex shader.
	     * @param {string} [fragmentSrc] - The source of the fragment shader.
	     */
	    Program.prototype.extractData = function (vertexSrc, fragmentSrc) {
	        var gl = getTestContext();
	        if (gl) {
	            var program = compileProgram(gl, vertexSrc, fragmentSrc);
	            this.attributeData = this.getAttributeData(program, gl);
	            this.uniformData = this.getUniformData(program, gl);
	            gl.deleteProgram(program);
	        }
	        else {
	            this.uniformData = {};
	            this.attributeData = {};
	        }
	    };
	    /**
	     * returns the attribute data from the program
	     * @private
	     *
	     * @param {WebGLProgram} [program] - the WebGL program
	     * @param {WebGLRenderingContext} [gl] - the WebGL context
	     *
	     * @returns {object} the attribute data for this program
	     */
	    Program.prototype.getAttributeData = function (program, gl) {
	        var attributes = {};
	        var attributesArray = [];
	        var totalAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
	        for (var i = 0; i < totalAttributes; i++) {
	            var attribData = gl.getActiveAttrib(program, i);
	            var type = mapType(gl, attribData.type);
	            /*eslint-disable */
	            var data = {
	                type: type,
	                name: attribData.name,
	                size: mapSize(type),
	                location: 0,
	            };
	            /* eslint-enable */
	            attributes[attribData.name] = data;
	            attributesArray.push(data);
	        }
	        attributesArray.sort(function (a, b) { return (a.name > b.name) ? 1 : -1; }); // eslint-disable-line no-confusing-arrow
	        for (var i = 0; i < attributesArray.length; i++) {
	            attributesArray[i].location = i;
	        }
	        return attributes;
	    };
	    /**
	     * returns the uniform data from the program
	     * @private
	     *
	     * @param {webGL-program} [program] - the webgl program
	     * @param {context} [gl] - the WebGL context
	     *
	     * @returns {object} the uniform data for this program
	     */
	    Program.prototype.getUniformData = function (program, gl) {
	        var uniforms = {};
	        var totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
	        // TODO expose this as a prop?
	        // const maskRegex = new RegExp('^(projectionMatrix|uSampler|translationMatrix)$');
	        // const maskRegex = new RegExp('^(projectionMatrix|uSampler|translationMatrix)$');
	        for (var i = 0; i < totalUniforms; i++) {
	            var uniformData = gl.getActiveUniform(program, i);
	            var name = uniformData.name.replace(/\[.*?\]$/, '');
	            var isArray = uniformData.name.match(/\[.*?\]$/);
	            var type = mapType(gl, uniformData.type);
	            /*eslint-disable */
	            uniforms[name] = {
	                type: type,
	                size: uniformData.size,
	                isArray: isArray,
	                value: defaultValue(type, uniformData.size),
	            };
	            /* eslint-enable */
	        }
	        return uniforms;
	    };
	    Object.defineProperty(Program, "defaultVertexSrc", {
	        /**
	         * The default vertex shader source
	         *
	         * @static
	         * @constant
	         * @member {string}
	         */
	        get: function () {
	            return defaultVertex;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Program, "defaultFragmentSrc", {
	        /**
	         * The default fragment shader source
	         *
	         * @static
	         * @constant
	         * @member {string}
	         */
	        get: function () {
	            return defaultFragment;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * A short hand function to create a program based of a vertex and fragment shader
	     * this method will also check to see if there is a cached program.
	     *
	     * @param {string} [vertexSrc] - The source of the vertex shader.
	     * @param {string} [fragmentSrc] - The source of the fragment shader.
	     * @param {string} [name=pixi-shader] - Name for shader
	     *
	     * @returns {PIXI.Program} an shiny new Pixi shader!
	     */
	    Program.from = function (vertexSrc, fragmentSrc, name) {
	        var key = vertexSrc + fragmentSrc;
	        var program = ProgramCache[key];
	        if (!program) {
	            ProgramCache[key] = program = new Program(vertexSrc, fragmentSrc, name);
	        }
	        return program;
	    };
	    return Program;
	}());

	/**
	 * A helper class for shaders
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Shader = /** @class */ (function () {
	    /**
	     * @param {PIXI.Program} [program] - The program the shader will use.
	     * @param {object} [uniforms] - Custom uniforms to use to augment the built-in ones.
	     */
	    function Shader(program, uniforms) {
	        /**
	         * Program that the shader uses
	         *
	         * @member {PIXI.Program}
	         */
	        this.program = program;
	        // lets see whats been passed in
	        // uniforms should be converted to a uniform group
	        if (uniforms) {
	            if (uniforms instanceof UniformGroup) {
	                this.uniformGroup = uniforms;
	            }
	            else {
	                this.uniformGroup = new UniformGroup(uniforms);
	            }
	        }
	        else {
	            this.uniformGroup = new UniformGroup({});
	        }
	        // time to build some getters and setters!
	        // I guess down the line this could sort of generate an instruction list rather than use dirty ids?
	        // does the trick for now though!
	        for (var i in program.uniformData) {
	            if (this.uniformGroup.uniforms[i] instanceof Array) {
	                this.uniformGroup.uniforms[i] = new Float32Array(this.uniformGroup.uniforms[i]);
	            }
	        }
	    }
	    // TODO move to shader system..
	    Shader.prototype.checkUniformExists = function (name, group) {
	        if (group.uniforms[name]) {
	            return true;
	        }
	        for (var i in group.uniforms) {
	            var uniform = group.uniforms[i];
	            if (uniform.group) {
	                if (this.checkUniformExists(name, uniform)) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    Shader.prototype.destroy = function () {
	        // usage count on programs?
	        // remove if not used!
	        this.uniformGroup = null;
	    };
	    Object.defineProperty(Shader.prototype, "uniforms", {
	        /**
	         * Shader uniform values, shortcut for `uniformGroup.uniforms`
	         * @readonly
	         * @member {object}
	         */
	        get: function () {
	            return this.uniformGroup.uniforms;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * A short hand function to create a shader based of a vertex and fragment shader
	     *
	     * @param {string} [vertexSrc] - The source of the vertex shader.
	     * @param {string} [fragmentSrc] - The source of the fragment shader.
	     * @param {object} [uniforms] - Custom uniforms to use to augment the built-in ones.
	     *
	     * @returns {PIXI.Shader} an shiny new Pixi shader!
	     */
	    Shader.from = function (vertexSrc, fragmentSrc, uniforms) {
	        var program = Program.from(vertexSrc, fragmentSrc);
	        return new Shader(program, uniforms);
	    };
	    return Shader;
	}());

	/* eslint-disable max-len */
	var BLEND = 0;
	var OFFSET = 1;
	var CULLING = 2;
	var DEPTH_TEST = 3;
	var WINDING = 4;
	/**
	 * This is a WebGL state, and is is passed The WebGL StateManager.
	 *
	 * Each mesh rendered may require WebGL to be in a different state.
	 * For example you may want different blend mode or to enable polygon offsets
	 *
	 * @class
	 * @memberof PIXI
	 */
	var State = /** @class */ (function () {
	    function State() {
	        this.data = 0;
	        this.blendMode = exports.BLEND_MODES.NORMAL;
	        this.polygonOffset = 0;
	        this.blend = true;
	        //  this.depthTest = true;
	    }
	    Object.defineProperty(State.prototype, "blend", {
	        /**
	         * Activates blending of the computed fragment color values
	         *
	         * @member {boolean}
	         */
	        get: function () {
	            return !!(this.data & (1 << BLEND));
	        },
	        set: function (value) {
	            if (!!(this.data & (1 << BLEND)) !== value) {
	                this.data ^= (1 << BLEND);
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(State.prototype, "offsets", {
	        /**
	         * Activates adding an offset to depth values of polygon's fragments
	         *
	         * @member {boolean}
	         * @default false
	         */
	        get: function () {
	            return !!(this.data & (1 << OFFSET));
	        },
	        set: function (value) {
	            if (!!(this.data & (1 << OFFSET)) !== value) {
	                this.data ^= (1 << OFFSET);
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(State.prototype, "culling", {
	        /**
	         * Activates culling of polygons.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        get: function () {
	            return !!(this.data & (1 << CULLING));
	        },
	        set: function (value) {
	            if (!!(this.data & (1 << CULLING)) !== value) {
	                this.data ^= (1 << CULLING);
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(State.prototype, "depthTest", {
	        /**
	         * Activates depth comparisons and updates to the depth buffer.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        get: function () {
	            return !!(this.data & (1 << DEPTH_TEST));
	        },
	        set: function (value) {
	            if (!!(this.data & (1 << DEPTH_TEST)) !== value) {
	                this.data ^= (1 << DEPTH_TEST);
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(State.prototype, "clockwiseFrontFace", {
	        /**
	         * Specifies whether or not front or back-facing polygons can be culled.
	         * @member {boolean}
	         * @default false
	         */
	        get: function () {
	            return !!(this.data & (1 << WINDING));
	        },
	        set: function (value) {
	            if (!!(this.data & (1 << WINDING)) !== value) {
	                this.data ^= (1 << WINDING);
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(State.prototype, "blendMode", {
	        /**
	         * The blend mode to be applied when this state is set. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
	         * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         * @see PIXI.BLEND_MODES
	         */
	        get: function () {
	            return this._blendMode;
	        },
	        set: function (value) {
	            this.blend = (value !== exports.BLEND_MODES.NONE);
	            this._blendMode = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(State.prototype, "polygonOffset", {
	        /**
	         * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
	         *
	         * @member {number}
	         * @default 0
	         */
	        get: function () {
	            return this._polygonOffset;
	        },
	        set: function (value) {
	            this.offsets = !!value;
	            this._polygonOffset = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    State.for2d = function () {
	        var state = new State();
	        state.depthTest = false;
	        state.blend = true;
	        return state;
	    };
	    return State;
	}());

	var defaultVertex$1 = "attribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nuniform vec4 inputSize;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aVertexPosition * (outputFrame.zw * inputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n}\n";

	var defaultFragment$1 = "varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\n\nvoid main(void){\n   gl_FragColor = texture2D(uSampler, vTextureCoord);\n}\n";

	/**
	 * Filter is a special type of WebGL shader that is applied to the screen.
	 *
	 * {@link http://pixijs.io/examples/#/filters/blur-filter.js Example} of the
	 * {@link PIXI.filters.BlurFilter BlurFilter}.
	 *
	 * ### Usage
	 * Filters can be applied to any DisplayObject or Container.
	 * PixiJS' `FilterSystem` renders the container into temporary Framebuffer,
	 * then filter renders it to the screen.
	 * Multiple filters can be added to the `filters` array property and stacked on each other.
	 *
	 * ```
	 * const filter = new PIXI.Filter(myShaderVert, myShaderFrag, { myUniform: 0.5 });
	 * const container = new PIXI.Container();
	 * container.filters = [filter];
	 * ```
	 *
	 * ### Previous Version Differences
	 *
	 * In PixiJS **v3**, a filter was always applied to _whole screen_.
	 *
	 * In PixiJS **v4**, a filter can be applied _only part of the screen_.
	 * Developers had to create a set of uniforms to deal with coordinates.
	 *
	 * In PixiJS **v5** combines _both approaches_.
	 * Developers can use normal coordinates of v3 and then allow filter to use partial Framebuffers,
	 * bringing those extra uniforms into account.
	 *
	 * Also be aware that we have changed default vertex shader, please consult
	 * {@link https://github.com/pixijs/pixi.js/wiki/v5-Creating-filters Wiki}.
	 *
	 * ### Built-in Uniforms
	 *
	 * PixiJS viewport uses screen (CSS) coordinates, `(0, 0, renderer.screen.width, renderer.screen.height)`,
	 * and `projectionMatrix` uniform maps it to the gl viewport.
	 *
	 * **uSampler**
	 *
	 * The most important uniform is the input texture that container was rendered into.
	 * _Important note: as with all Framebuffers in PixiJS, both input and output are
	 * premultiplied by alpha._
	 *
	 * By default, input normalized coordinates are passed to fragment shader with `vTextureCoord`.
	 * Use it to sample the input.
	 *
	 * ```
	 * const fragment = `
	 * varying vec2 vTextureCoord;
	 * uniform sampler2D uSampler;
	 * void main(void)
	 * {
	 *    gl_FragColor = texture2D(uSampler, vTextureCoord);
	 * }
	 * `;
	 *
	 * const myFilter = new PIXI.Filter(null, fragment);
	 * ```
	 *
	 * This filter is just one uniform less than {@link PIXI.filters.AlphaFilter AlphaFilter}.
	 *
	 * **outputFrame**
	 *
	 * The `outputFrame` holds the rectangle where filter is applied in screen (CSS) coordinates.
	 * It's the same as `renderer.screen` for a fullscreen filter.
	 * Only a part of  `outputFrame.zw` size of temporary Framebuffer is used,
	 * `(0, 0, outputFrame.width, outputFrame.height)`,
	 *
	 * Filters uses this quad to normalized (0-1) space, its passed into `aVertexPosition` attribute.
	 * To calculate vertex position in screen space using normalized (0-1) space:
	 *
	 * ```
	 * vec4 filterVertexPosition( void )
	 * {
	 *     vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;
	 *     return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
	 * }
	 * ```
	 *
	 * **inputSize**
	 *
	 * Temporary framebuffer is different, it can be either the size of screen, either power-of-two.
	 * The `inputSize.xy` are size of temporary framebuffer that holds input.
	 * The `inputSize.zw` is inverted, it's a shortcut to evade division inside the shader.
	 *
	 * Set `inputSize.xy = outputFrame.zw` for a fullscreen filter.
	 *
	 * To calculate input normalized coordinate, you have to map it to filter normalized space.
	 * Multiply by `outputFrame.zw` to get input coordinate.
	 * Divide by `inputSize.xy` to get input normalized coordinate.
	 *
	 * ```
	 * vec2 filterTextureCoord( void )
	 * {
	 *     return aVertexPosition * (outputFrame.zw * inputSize.zw); // same as /inputSize.xy
	 * }
	 * ```
	 * **resolution**
	 *
	 * The `resolution` is the ratio of screen (CSS) pixels to real pixels.
	 *
	 * **inputPixel**
	 *
	 * `inputPixel.xy` is the size of framebuffer in real pixels, same as `inputSize.xy * resolution`
	 * `inputPixel.zw` is inverted `inputPixel.xy`.
	 *
	 * It's handy for filters that use neighbour pixels, like {@link PIXI.filters.FXAAFilter FXAAFilter}.
	 *
	 * **inputClamp**
	 *
	 * If you try to get info from outside of used part of Framebuffer - you'll get undefined behaviour.
	 * For displacements, coordinates has to be clamped.
	 *
	 * The `inputClamp.xy` is left-top pixel center, you may ignore it, because we use left-top part of Framebuffer
	 * `inputClamp.zw` is bottom-right pixel center.
	 *
	 * ```
	 * vec4 color = texture2D(uSampler, clamp(modifigedTextureCoord, inputClamp.xy, inputClamp.zw))
	 * ```
	 * OR
	 * ```
	 * vec4 color = texture2D(uSampler, min(modifigedTextureCoord, inputClamp.zw))
	 * ```
	 *
	 * ### Additional Information
	 *
	 * Complete documentation on Filter usage is located in the
	 * {@link https://github.com/pixijs/pixi.js/wiki/v5-Creating-filters Wiki}.
	 *
	 * Since PixiJS only had a handful of built-in filters, additional filters can be downloaded
	 * {@link https://github.com/pixijs/pixi-filters here} from the PixiJS Filters repository.
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.Shader
	 */
	var Filter = /** @class */ (function (_super) {
	    __extends$2(Filter, _super);
	    /**
	     * @param {string} [vertexSrc] - The source of the vertex shader.
	     * @param {string} [fragmentSrc] - The source of the fragment shader.
	     * @param {object} [uniforms] - Custom uniforms to use to augment the built-in ones.
	     */
	    function Filter(vertexSrc, fragmentSrc, uniforms) {
	        var _this = this;
	        var program = Program.from(vertexSrc || Filter.defaultVertexSrc, fragmentSrc || Filter.defaultFragmentSrc);
	        _this = _super.call(this, program, uniforms) || this;
	        /**
	         * The padding of the filter. Some filters require extra space to breath such as a blur.
	         * Increasing this will add extra width and height to the bounds of the object that the
	         * filter is applied to.
	         *
	         * @member {number}
	         */
	        _this.padding = 0;
	        /**
	         * The resolution of the filter. Setting this to be lower will lower the quality but
	         * increase the performance of the filter.
	         *
	         * @member {number}
	         */
	        _this.resolution = settings.FILTER_RESOLUTION;
	        /**
	         * If enabled is true the filter is applied, if false it will not.
	         *
	         * @member {boolean}
	         */
	        _this.enabled = true;
	        /**
	         * If enabled, PixiJS will fit the filter area into boundaries for better performance.
	         * Switch it off if it does not work for specific shader.
	         *
	         * @member {boolean}
	         */
	        _this.autoFit = true;
	        /**
	         * Legacy filters use position and uvs from attributes
	         * @member {boolean}
	         * @readonly
	         */
	        _this.legacy = !!_this.program.attributeData.aTextureCoord;
	        /**
	         * The WebGL state the filter requires to render
	         * @member {PIXI.State}
	         */
	        _this.state = new State();
	        return _this;
	    }
	    /**
	     * Applies the filter
	     *
	     * @param {PIXI.systems.FilterSystem} filterManager - The renderer to retrieve the filter from
	     * @param {PIXI.RenderTexture} input - The input render target.
	     * @param {PIXI.RenderTexture} output - The target to output to.
	     * @param {PIXI.CLEAR_MODES} clearMode - Should the output be cleared before rendering to it.
	     * @param {object} [currentState] - It's current state of filter.
	     *        There are some useful properties in the currentState :
	     *        target, filters, sourceFrame, destinationFrame, renderTarget, resolution
	     */
	    Filter.prototype.apply = function (filterManager, input, output, clearMode, _currentState) {
	        // do as you please!
	        filterManager.applyFilter(this, input, output, clearMode);
	        // or just do a regular render..
	    };
	    Object.defineProperty(Filter.prototype, "blendMode", {
	        /**
	         * Sets the blendmode of the filter
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         */
	        get: function () {
	            return this.state.blendMode;
	        },
	        set: function (value) {
	            this.state.blendMode = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Filter, "defaultVertexSrc", {
	        /**
	         * The default vertex shader source
	         *
	         * @static
	         * @type {string}
	         * @constant
	         */
	        get: function () {
	            return defaultVertex$1;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Filter, "defaultFragmentSrc", {
	        /**
	         * The default fragment shader source
	         *
	         * @static
	         * @type {string}
	         * @constant
	         */
	        get: function () {
	            return defaultFragment$1;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Filter;
	}(Shader));

	var vertex = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 otherMatrix;\n\nvarying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n}\n";

	var fragment = "varying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform sampler2D mask;\nuniform float alpha;\nuniform float npmAlpha;\nuniform vec4 maskClamp;\n\nvoid main(void)\n{\n    float clip = step(3.5,\n        step(maskClamp.x, vMaskCoord.x) +\n        step(maskClamp.y, vMaskCoord.y) +\n        step(vMaskCoord.x, maskClamp.z) +\n        step(vMaskCoord.y, maskClamp.w));\n\n    vec4 original = texture2D(uSampler, vTextureCoord);\n    vec4 masky = texture2D(mask, vMaskCoord);\n    float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);\n\n    original *= (alphaMul * masky.r * alpha * clip);\n\n    gl_FragColor = original;\n}\n";

	var tempMat = new Matrix();
	/**
	 * Class controls uv mapping from Texture normal space to BaseTexture normal space.
	 *
	 * Takes `trim` and `rotate` into account. May contain clamp settings for Meshes and TilingSprite.
	 *
	 * Can be used in Texture `uvMatrix` field, or separately, you can use different clamp settings on the same texture.
	 * If you want to add support for texture region of certain feature or filter, that's what you're looking for.
	 *
	 * Takes track of Texture changes through `_lastTextureID` private field.
	 * Use `update()` method call to track it from outside.
	 *
	 * @see PIXI.Texture
	 * @see PIXI.Mesh
	 * @see PIXI.TilingSprite
	 * @class
	 * @memberof PIXI
	 */
	var TextureMatrix = /** @class */ (function () {
	    /**
	     *
	     * @param {PIXI.Texture} texture - observed texture
	     * @param {number} [clampMargin] - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
	     * @constructor
	     */
	    function TextureMatrix(texture, clampMargin) {
	        this._texture = texture;
	        /**
	         * Matrix operation that converts texture region coords to texture coords
	         * @member {PIXI.Matrix}
	         * @readonly
	         */
	        this.mapCoord = new Matrix();
	        /**
	         * Clamp region for normalized coords, left-top pixel center in xy , bottom-right in zw.
	         * Calculated based on clampOffset.
	         * @member {Float32Array}
	         * @readonly
	         */
	        this.uClampFrame = new Float32Array(4);
	        /**
	         * Normalized clamp offset.
	         * Calculated based on clampOffset.
	         * @member {Float32Array}
	         * @readonly
	         */
	        this.uClampOffset = new Float32Array(2);
	        /**
	         * Tracks Texture frame changes
	         * @member {number}
	         * @protected
	         */
	        this._textureID = -1;
	        /**
	         * Tracks Texture frame changes
	         * @member {number}
	         * @protected
	         */
	        this._updateID = 0;
	        /**
	         * Changes frame clamping
	         * Works with TilingSprite and Mesh
	         * Change to 1.5 if you texture has repeated right and bottom lines, that leads to smoother borders
	         *
	         * @default 0
	         * @member {number}
	         */
	        this.clampOffset = 0;
	        /**
	         * Changes frame clamping
	         * Works with TilingSprite and Mesh
	         * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
	         *
	         * @default 0.5
	         * @member {number}
	         */
	        this.clampMargin = (typeof clampMargin === 'undefined') ? 0.5 : clampMargin;
	        /**
	         * If texture size is the same as baseTexture
	         * @member {boolean}
	         * @default false
	         * @readonly
	         */
	        this.isSimple = false;
	    }
	    Object.defineProperty(TextureMatrix.prototype, "texture", {
	        /**
	         * texture property
	         * @member {PIXI.Texture}
	         */
	        get: function () {
	            return this._texture;
	        },
	        set: function (value) {
	            this._texture = value;
	            this._textureID = -1;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Multiplies uvs array to transform
	     * @param {Float32Array} uvs - mesh uvs
	     * @param {Float32Array} [out=uvs] output
	     * @returns {Float32Array} output
	     */
	    TextureMatrix.prototype.multiplyUvs = function (uvs, out) {
	        if (out === undefined) {
	            out = uvs;
	        }
	        var mat = this.mapCoord;
	        for (var i = 0; i < uvs.length; i += 2) {
	            var x = uvs[i];
	            var y = uvs[i + 1];
	            out[i] = (x * mat.a) + (y * mat.c) + mat.tx;
	            out[i + 1] = (x * mat.b) + (y * mat.d) + mat.ty;
	        }
	        return out;
	    };
	    /**
	     * updates matrices if texture was changed
	     * @param {boolean} [forceUpdate=false] - if true, matrices will be updated any case
	     * @returns {boolean} whether or not it was updated
	     */
	    TextureMatrix.prototype.update = function (forceUpdate) {
	        var tex = this._texture;
	        if (!tex || !tex.valid) {
	            return false;
	        }
	        if (!forceUpdate
	            && this._textureID === tex._updateID) {
	            return false;
	        }
	        this._textureID = tex._updateID;
	        this._updateID++;
	        var uvs = tex._uvs;
	        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
	        var orig = tex.orig;
	        var trim = tex.trim;
	        if (trim) {
	            tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
	            this.mapCoord.append(tempMat);
	        }
	        var texBase = tex.baseTexture;
	        var frame = this.uClampFrame;
	        var margin = this.clampMargin / texBase.resolution;
	        var offset = this.clampOffset;
	        frame[0] = (tex._frame.x + margin + offset) / texBase.width;
	        frame[1] = (tex._frame.y + margin + offset) / texBase.height;
	        frame[2] = (tex._frame.x + tex._frame.width - margin + offset) / texBase.width;
	        frame[3] = (tex._frame.y + tex._frame.height - margin + offset) / texBase.height;
	        this.uClampOffset[0] = offset / texBase.realWidth;
	        this.uClampOffset[1] = offset / texBase.realHeight;
	        this.isSimple = tex._frame.width === texBase.width
	            && tex._frame.height === texBase.height
	            && tex.rotate === 0;
	        return true;
	    };
	    return TextureMatrix;
	}());

	/**
	 * This handles a Sprite acting as a mask, as opposed to a Graphic.
	 *
	 * WebGL only.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI
	 */
	var SpriteMaskFilter = /** @class */ (function (_super) {
	    __extends$2(SpriteMaskFilter, _super);
	    /**
	     * @param {PIXI.Sprite} sprite - the target sprite
	     */
	    function SpriteMaskFilter(sprite) {
	        var _this = this;
	        var maskMatrix = new Matrix();
	        _this = _super.call(this, vertex, fragment) || this;
	        sprite.renderable = false;
	        /**
	         * Sprite mask
	         * @member {PIXI.Sprite}
	         */
	        _this.maskSprite = sprite;
	        /**
	         * Mask matrix
	         * @member {PIXI.Matrix}
	         */
	        _this.maskMatrix = maskMatrix;
	        return _this;
	    }
	    /**
	     * Applies the filter
	     *
	     * @param {PIXI.systems.FilterSystem} filterManager - The renderer to retrieve the filter from
	     * @param {PIXI.RenderTexture} input - The input render target.
	     * @param {PIXI.RenderTexture} output - The target to output to.
	     * @param {PIXI.CLEAR_MODES} clearMode - Should the output be cleared before rendering to it.
	     */
	    SpriteMaskFilter.prototype.apply = function (filterManager, input, output, clearMode) {
	        var maskSprite = this.maskSprite;
	        var tex = maskSprite._texture;
	        if (!tex.valid) {
	            return;
	        }
	        if (!tex.uvMatrix) {
	            // margin = 0.0, let it bleed a bit, shader code becomes easier
	            // assuming that atlas textures were made with 1-pixel padding
	            tex.uvMatrix = new TextureMatrix(tex, 0.0);
	        }
	        tex.uvMatrix.update();
	        this.uniforms.npmAlpha = tex.baseTexture.alphaMode ? 0.0 : 1.0;
	        this.uniforms.mask = tex;
	        // get _normalized sprite texture coords_ and convert them to _normalized atlas texture coords_ with `prepend`
	        this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite)
	            .prepend(tex.uvMatrix.mapCoord);
	        this.uniforms.alpha = maskSprite.worldAlpha;
	        this.uniforms.maskClamp = tex.uvMatrix.uClampFrame;
	        filterManager.applyFilter(this, input, output, clearMode);
	    };
	    return SpriteMaskFilter;
	}(Filter));

	/**
	 * System plugin to the renderer to manage masks.
	 *
	 * @class
	 * @extends PIXI.System
	 * @memberof PIXI.systems
	 */
	var MaskSystem = /** @class */ (function (_super) {
	    __extends$2(MaskSystem, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this System works for.
	     */
	    function MaskSystem(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        /**
	         * Enable scissor
	         * @member {boolean}
	         * @readonly
	         */
	        _this.enableScissor = false;
	        /**
	         * Pool of used sprite mask filters
	         * @member {PIXI.SpriteMaskFilter[]}
	         * @readonly
	         */
	        _this.alphaMaskPool = [];
	        /**
	         * Pool of mask data
	         * @member {PIXI.MaskData[]}
	         * @readonly
	         */
	        _this.maskDataPool = [];
	        _this.maskStack = [];
	        /**
	         * Current index of alpha mask pool
	         * @member {number}
	         * @default 0
	         * @readonly
	         */
	        _this.alphaMaskIndex = 0;
	        return _this;
	    }
	    /**
	     * Changes the mask stack that is used by this System.
	     *
	     * @param {PIXI.MaskData[]} maskStack - The mask stack
	     */
	    MaskSystem.prototype.setMaskStack = function (maskStack) {
	        this.maskStack = maskStack;
	        this.renderer.scissor.setMaskStack(maskStack);
	        this.renderer.stencil.setMaskStack(maskStack);
	    };
	    /**
	     * Applies the Mask and adds it to the current filter stack.
	     * Renderer batch must be flushed beforehand.
	     *
	     * @param {PIXI.DisplayObject} target - Display Object to push the mask to
	     * @param {PIXI.MaskData|PIXI.Sprite|PIXI.Graphics|PIXI.DisplayObject} maskData - The masking data.
	     */
	    MaskSystem.prototype.push = function (target, maskDataOrTarget) {
	        var maskData = maskDataOrTarget;
	        if (!maskData.isMaskData) {
	            var d = this.maskDataPool.pop() || new MaskData();
	            d.pooled = true;
	            d.maskObject = maskDataOrTarget;
	            maskData = d;
	        }
	        if (maskData.autoDetect) {
	            this.detect(maskData);
	        }
	        maskData.copyCountersOrReset(this.maskStack[this.maskStack.length - 1]);
	        maskData._target = target;
	        switch (maskData.type) {
	            case exports.MASK_TYPES.SCISSOR:
	                this.maskStack.push(maskData);
	                this.renderer.scissor.push(maskData);
	                break;
	            case exports.MASK_TYPES.STENCIL:
	                this.maskStack.push(maskData);
	                this.renderer.stencil.push(maskData);
	                break;
	            case exports.MASK_TYPES.SPRITE:
	                maskData.copyCountersOrReset(null);
	                this.pushSpriteMask(maskData);
	                this.maskStack.push(maskData);
	                break;
	            default:
	                break;
	        }
	    };
	    /**
	     * Removes the last mask from the mask stack and doesn't return it.
	     * Renderer batch must be flushed beforehand.
	     *
	     * @param {PIXI.DisplayObject} target - Display Object to pop the mask from
	     */
	    MaskSystem.prototype.pop = function (target) {
	        var maskData = this.maskStack.pop();
	        if (!maskData || maskData._target !== target) {
	            // TODO: add an assert when we have it
	            return;
	        }
	        switch (maskData.type) {
	            case exports.MASK_TYPES.SCISSOR:
	                this.renderer.scissor.pop();
	                break;
	            case exports.MASK_TYPES.STENCIL:
	                this.renderer.stencil.pop(maskData.maskObject);
	                break;
	            case exports.MASK_TYPES.SPRITE:
	                this.popSpriteMask();
	                break;
	            default:
	                break;
	        }
	        maskData.reset();
	        if (maskData.pooled) {
	            this.maskDataPool.push(maskData);
	        }
	    };
	    /**
	     * Sets type of MaskData based on its maskObject
	     * @param {PIXI.MaskData} maskData
	     */
	    MaskSystem.prototype.detect = function (maskData) {
	        var maskObject = maskData.maskObject;
	        if (maskObject.isSprite) {
	            maskData.type = exports.MASK_TYPES.SPRITE;
	            return;
	        }
	        maskData.type = exports.MASK_TYPES.STENCIL;
	        // detect scissor in graphics
	        if (this.enableScissor
	            && maskObject.isFastRect
	            && maskObject.isFastRect()) {
	            var matrix = maskObject.worldTransform;
	            // TODO: move the check to the matrix itself
	            // we are checking that its orthogonal and x rotation is 0 90 180 or 270
	            var rotX = Math.atan2(matrix.b, matrix.a);
	            var rotXY = Math.atan2(matrix.d, matrix.c);
	            // use the nearest degree to 0.01
	            rotX = Math.round(rotX * (180 / Math.PI) * 100);
	            rotXY = Math.round(rotXY * (180 / Math.PI) * 100) - rotX;
	            rotX = ((rotX % 9000) + 9000) % 9000;
	            rotXY = ((rotXY % 18000) + 18000) % 18000;
	            if (rotX === 0 && rotXY === 9000) {
	                maskData.type = exports.MASK_TYPES.SCISSOR;
	            }
	        }
	    };
	    /**
	     * Applies the Mask and adds it to the current filter stack.
	     *
	     * @param {PIXI.MaskData} maskData - Sprite to be used as the mask
	     */
	    MaskSystem.prototype.pushSpriteMask = function (maskData) {
	        var maskObject = maskData.maskObject;
	        var target = maskData._target;
	        var alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex];
	        if (!alphaMaskFilter) {
	            alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex] = [new SpriteMaskFilter(maskObject)];
	        }
	        alphaMaskFilter[0].resolution = this.renderer.resolution;
	        alphaMaskFilter[0].maskSprite = maskObject;
	        var stashFilterArea = target.filterArea;
	        target.filterArea = maskObject.getBounds(true);
	        this.renderer.filter.push(target, alphaMaskFilter);
	        target.filterArea = stashFilterArea;
	        this.alphaMaskIndex++;
	    };
	    /**
	     * Removes the last filter from the filter stack and doesn't return it.
	     */
	    MaskSystem.prototype.popSpriteMask = function () {
	        this.renderer.filter.pop();
	        this.alphaMaskIndex--;
	    };
	    return MaskSystem;
	}(System));

	/**
	 * System plugin to the renderer to manage masks of certain type
	 *
	 * @class
	 * @extends PIXI.System
	 * @memberof PIXI.systems
	 */
	var AbstractMaskSystem = /** @class */ (function (_super) {
	    __extends$2(AbstractMaskSystem, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this System works for.
	     */
	    function AbstractMaskSystem(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        /**
	         * The mask stack
	         * @member {PIXI.MaskData[]}
	         */
	        _this.maskStack = [];
	        /**
	         * Constant for gl.enable
	         * @member {number}
	         * @private
	         */
	        _this.glConst = 0;
	        return _this;
	    }
	    /**
	     * gets count of masks of certain type
	     * @returns {number}
	     */
	    AbstractMaskSystem.prototype.getStackLength = function () {
	        return this.maskStack.length;
	    };
	    /**
	     * Changes the mask stack that is used by this System.
	     *
	     * @param {PIXI.MaskData[]} maskStack - The mask stack
	     */
	    AbstractMaskSystem.prototype.setMaskStack = function (maskStack) {
	        var gl = this.renderer.gl;
	        var curStackLen = this.getStackLength();
	        this.maskStack = maskStack;
	        var newStackLen = this.getStackLength();
	        if (newStackLen !== curStackLen) {
	            if (newStackLen === 0) {
	                gl.disable(this.glConst);
	            }
	            else {
	                gl.enable(this.glConst);
	                this._useCurrent();
	            }
	        }
	    };
	    /**
	     * Setup renderer to use the current mask data.
	     * @private
	     */
	    AbstractMaskSystem.prototype._useCurrent = function () {
	        // OVERWRITE;
	    };
	    /**
	     * Destroys the mask stack.
	     *
	     */
	    AbstractMaskSystem.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.maskStack = null;
	    };
	    return AbstractMaskSystem;
	}(System));

	/**
	 * System plugin to the renderer to manage scissor rects (used for masks).
	 *
	 * @class
	 * @extends PIXI.System
	 * @memberof PIXI.systems
	 */
	var ScissorSystem = /** @class */ (function (_super) {
	    __extends$2(ScissorSystem, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this System works for.
	     */
	    function ScissorSystem(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        _this.glConst = WebGLRenderingContext.SCISSOR_TEST;
	        return _this;
	    }
	    ScissorSystem.prototype.getStackLength = function () {
	        var maskData = this.maskStack[this.maskStack.length - 1];
	        if (maskData) {
	            return maskData._scissorCounter;
	        }
	        return 0;
	    };
	    /**
	     * Applies the Mask and adds it to the current stencil stack. @alvin
	     *
	     * @param {PIXI.MaskData} maskData - The mask data
	     */
	    ScissorSystem.prototype.push = function (maskData) {
	        var maskObject = maskData.maskObject;
	        maskObject.renderable = true;
	        var prevData = maskData._scissorRect;
	        var bounds = maskObject.getBounds(true);
	        var gl = this.renderer.gl;
	        maskObject.renderable = false;
	        if (prevData) {
	            bounds.fit(prevData);
	        }
	        else {
	            gl.enable(gl.SCISSOR_TEST);
	        }
	        maskData._scissorCounter++;
	        maskData._scissorRect = bounds;
	        this._useCurrent();
	    };
	    /**
	     * Pops scissor mask. MaskData is already removed from stack
	     */
	    ScissorSystem.prototype.pop = function () {
	        var gl = this.renderer.gl;
	        if (this.getStackLength() > 0) {
	            this._useCurrent();
	        }
	        else {
	            gl.disable(gl.SCISSOR_TEST);
	        }
	    };
	    /**
	     * Setup renderer to use the current scissor data.
	     * @private
	     */
	    ScissorSystem.prototype._useCurrent = function () {
	        var rect = this.maskStack[this.maskStack.length - 1]._scissorRect;
	        var rt = this.renderer.renderTexture.current;
	        var _a = this.renderer.projection, transform = _a.transform, sourceFrame = _a.sourceFrame, destinationFrame = _a.destinationFrame;
	        var resolution = rt ? rt.resolution : this.renderer.resolution;
	        var x = ((rect.x - sourceFrame.x) * resolution) + destinationFrame.x;
	        var y = ((rect.y - sourceFrame.y) * resolution) + destinationFrame.y;
	        var width = rect.width * resolution;
	        var height = rect.height * resolution;
	        if (transform) {
	            x += transform.tx * resolution;
	            y += transform.ty * resolution;
	        }
	        if (!rt) {
	            // flipY. In future we'll have it over renderTextures as an option
	            y = this.renderer.height - height - y;
	        }
	        this.renderer.gl.scissor(x, y, width, height);
	    };
	    return ScissorSystem;
	}(AbstractMaskSystem));

	/**
	 * System plugin to the renderer to manage stencils (used for masks).
	 *
	 * @class
	 * @extends PIXI.System
	 * @memberof PIXI.systems
	 */
	var StencilSystem = /** @class */ (function (_super) {
	    __extends$2(StencilSystem, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this System works for.
	     */
	    function StencilSystem(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        _this.glConst = WebGLRenderingContext.STENCIL_TEST;
	        return _this;
	    }
	    StencilSystem.prototype.getStackLength = function () {
	        var maskData = this.maskStack[this.maskStack.length - 1];
	        if (maskData) {
	            return maskData._stencilCounter;
	        }
	        return 0;
	    };
	    /**
	     * Applies the Mask and adds it to the current stencil stack.
	     *
	     * @param {PIXI.MaskData} maskData - The mask data
	     */
	    StencilSystem.prototype.push = function (maskData) {
	        var maskObject = maskData.maskObject;
	        var gl = this.renderer.gl;
	        var prevMaskCount = maskData._stencilCounter;
	        if (prevMaskCount === 0) {
	            // force use stencil texture in current framebuffer
	            this.renderer.framebuffer.forceStencil();
	            gl.enable(gl.STENCIL_TEST);
	        }
	        maskData._stencilCounter++;
	        // Increment the reference stencil value where the new mask overlaps with the old ones.
	        gl.colorMask(false, false, false, false);
	        gl.stencilFunc(gl.EQUAL, prevMaskCount, this._getBitwiseMask());
	        gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
	        maskObject.renderable = true;
	        maskObject.render(this.renderer);
	        this.renderer.batch.flush();
	        maskObject.renderable = false;
	        this._useCurrent();
	    };
	    /**
	     * Pops stencil mask. MaskData is already removed from stack
	     *
	     * @param {PIXI.DisplayObject} maskObject - object of popped mask data
	     */
	    StencilSystem.prototype.pop = function (maskObject) {
	        var gl = this.renderer.gl;
	        if (this.getStackLength() === 0) {
	            // the stack is empty!
	            gl.disable(gl.STENCIL_TEST);
	            gl.clear(gl.STENCIL_BUFFER_BIT);
	            gl.clearStencil(0);
	        }
	        else {
	            // Decrement the reference stencil value where the popped mask overlaps with the other ones
	            gl.colorMask(false, false, false, false);
	            gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
	            maskObject.renderable = true;
	            maskObject.render(this.renderer);
	            this.renderer.batch.flush();
	            maskObject.renderable = false;
	            this._useCurrent();
	        }
	    };
	    /**
	     * Setup renderer to use the current stencil data.
	     * @private
	     */
	    StencilSystem.prototype._useCurrent = function () {
	        var gl = this.renderer.gl;
	        gl.colorMask(true, true, true, true);
	        gl.stencilFunc(gl.EQUAL, this.getStackLength(), this._getBitwiseMask());
	        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
	    };
	    /**
	     * Fill 1s equal to the number of acitve stencil masks.
	     * @private
	     * @return {number} The bitwise mask.
	     */
	    StencilSystem.prototype._getBitwiseMask = function () {
	        return (1 << this.getStackLength()) - 1;
	    };
	    return StencilSystem;
	}(AbstractMaskSystem));

	/**
	 * System plugin to the renderer to manage the projection matrix.
	 *
	 * @class
	 * @extends PIXI.System
	 * @memberof PIXI.systems
	 */
	var ProjectionSystem = /** @class */ (function (_super) {
	    __extends$2(ProjectionSystem, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this System works for.
	     */
	    function ProjectionSystem(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        /**
	         * Destination frame
	         * @member {PIXI.Rectangle}
	         * @readonly
	         */
	        _this.destinationFrame = null;
	        /**
	         * Source frame
	         * @member {PIXI.Rectangle}
	         * @readonly
	         */
	        _this.sourceFrame = null;
	        /**
	         * Default destination frame
	         * @member {PIXI.Rectangle}
	         * @readonly
	         */
	        _this.defaultFrame = null;
	        /**
	         * Project matrix
	         * @member {PIXI.Matrix}
	         * @readonly
	         */
	        _this.projectionMatrix = new Matrix();
	        /**
	         * A transform that will be appended to the projection matrix
	         * if null, nothing will be applied
	         * @member {PIXI.Matrix}
	         */
	        _this.transform = null;
	        return _this;
	    }
	    /**
	     * Updates the projection matrix based on a projection frame (which is a rectangle).
	     *
	     * Make sure to run `renderer.framebuffer.setViewport(destinationFrame)` after calling this.
	     *
	     * @param {PIXI.Rectangle} destinationFrame - The destination frame.
	     * @param {PIXI.Rectangle} sourceFrame - The source frame.
	     * @param {Number} resolution - Resolution
	     * @param {boolean} root - If is root
	     */
	    ProjectionSystem.prototype.update = function (destinationFrame, sourceFrame, resolution, root) {
	        this.destinationFrame = destinationFrame || this.destinationFrame || this.defaultFrame;
	        this.sourceFrame = sourceFrame || this.sourceFrame || destinationFrame;
	        // Calculate object-space to clip-space projection
	        this.calculateProjection(this.destinationFrame, this.sourceFrame, resolution, root);
	        if (this.transform) {
	            this.projectionMatrix.append(this.transform);
	        }
	        var renderer = this.renderer;
	        renderer.globalUniforms.uniforms.projectionMatrix = this.projectionMatrix;
	        renderer.globalUniforms.update();
	        // this will work for now
	        // but would be sweet to stick and even on the global uniforms..
	        if (renderer.shader.shader) {
	            renderer.shader.syncUniformGroup(renderer.shader.shader.uniforms.globals);
	        }
	    };
	    /**
	     * Updates the projection matrix based on a projection frame (which is a rectangle)
	     *
	     * @param {PIXI.Rectangle} destinationFrame - The destination frame.
	     * @param {PIXI.Rectangle} sourceFrame - The source frame.
	     * @param {Number} resolution - Resolution
	     * @param {boolean} root - If is root
	     */
	    ProjectionSystem.prototype.calculateProjection = function (_destinationFrame, sourceFrame, _resolution, root) {
	        var pm = this.projectionMatrix;
	        var sign = !root ? 1 : -1;
	        pm.identity();
	        pm.a = (1 / sourceFrame.width * 2);
	        pm.d = sign * (1 / sourceFrame.height * 2);
	        pm.tx = -1 - (sourceFrame.x * pm.a);
	        pm.ty = -sign - (sourceFrame.y * pm.d);
	    };
	    /**
	     * Sets the transform of the active render target to the given matrix
	     *
	     * @param {PIXI.Matrix} matrix - The transformation matrix
	     */
	    ProjectionSystem.prototype.setTransform = function (_matrix) {
	        // this._activeRenderTarget.transform = matrix;
	    };
	    return ProjectionSystem;
	}(System));

	// Temporary rectangle for assigned sourceFrame or destinationFrame
	var tempRect = new Rectangle();
	// Temporary rectangle for renderTexture destinationFrame
	var tempRect2 = new Rectangle();
	// Temporary rectangle for passing the framebuffer viewport
	var viewportFrame = new Rectangle();
	/**
	 * System plugin to the renderer to manage render textures.
	 *
	 * Should be added after FramebufferSystem
	 *
	 * @class
	 * @extends PIXI.System
	 * @memberof PIXI.systems
	 */
	var RenderTextureSystem = /** @class */ (function (_super) {
	    __extends$2(RenderTextureSystem, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this System works for.
	     */
	    function RenderTextureSystem(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        /**
	         * The clear background color as rgba
	         * @member {number[]}
	         */
	        _this.clearColor = renderer._backgroundColorRgba;
	        // TODO move this property somewhere else!
	        /**
	         * List of masks for the StencilSystem
	         * @member {PIXI.Graphics[]}
	         * @readonly
	         */
	        _this.defaultMaskStack = [];
	        // empty render texture?
	        /**
	         * Render texture
	         * @member {PIXI.RenderTexture}
	         * @readonly
	         */
	        _this.current = null;
	        /**
	         * Source frame
	         * @member {PIXI.Rectangle}
	         * @readonly
	         */
	        _this.sourceFrame = new Rectangle();
	        /**
	         * Destination frame
	         * @member {PIXI.Rectangle}
	         * @readonly
	         */
	        _this.destinationFrame = new Rectangle();
	        return _this;
	    }
	    /**
	     * Bind the current render texture
	     *
	     * @param {PIXI.RenderTexture} [renderTexture] - RenderTexture to bind, by default its `null`, the screen
	     * @param {PIXI.Rectangle} [sourceFrame] - part of screen that is mapped to the renderTexture
	     * @param {PIXI.Rectangle} [destinationFrame] - part of renderTexture, by default it has the same size as sourceFrame
	     */
	    RenderTextureSystem.prototype.bind = function (renderTexture, sourceFrame, destinationFrame) {
	        if (renderTexture === void 0) { renderTexture = null; }
	        var renderer = this.renderer;
	        this.current = renderTexture;
	        var baseTexture;
	        var framebuffer;
	        var resolution;
	        if (renderTexture) {
	            baseTexture = renderTexture.baseTexture;
	            resolution = baseTexture.resolution;
	            if (!sourceFrame) {
	                tempRect.width = renderTexture.frame.width;
	                tempRect.height = renderTexture.frame.height;
	                sourceFrame = tempRect;
	            }
	            if (!destinationFrame) {
	                tempRect2.x = renderTexture.frame.x;
	                tempRect2.y = renderTexture.frame.y;
	                tempRect2.width = sourceFrame.width;
	                tempRect2.height = sourceFrame.height;
	                destinationFrame = tempRect2;
	            }
	            framebuffer = baseTexture.framebuffer;
	        }
	        else {
	            resolution = renderer.resolution;
	            if (!sourceFrame) {
	                tempRect.width = renderer.screen.width;
	                tempRect.height = renderer.screen.height;
	                sourceFrame = tempRect;
	            }
	            if (!destinationFrame) {
	                destinationFrame = tempRect;
	                destinationFrame.width = sourceFrame.width;
	                destinationFrame.height = sourceFrame.height;
	            }
	        }
	        viewportFrame.x = destinationFrame.x * resolution;
	        viewportFrame.y = destinationFrame.y * resolution;
	        viewportFrame.width = destinationFrame.width * resolution;
	        viewportFrame.height = destinationFrame.height * resolution;
	        this.renderer.framebuffer.bind(framebuffer, viewportFrame);
	        this.renderer.projection.update(destinationFrame, sourceFrame, resolution, !framebuffer);
	        if (renderTexture) {
	            this.renderer.mask.setMaskStack(baseTexture.maskStack);
	        }
	        else {
	            this.renderer.mask.setMaskStack(this.defaultMaskStack);
	        }
	        this.sourceFrame.copyFrom(sourceFrame);
	        this.destinationFrame.copyFrom(destinationFrame);
	    };
	    /**
	     * Erases the render texture and fills the drawing area with a colour
	     *
	     * @param {number[]} [clearColor] - The color as rgba, default to use the renderer backgroundColor
	     * @param {PIXI.BUFFER_BITS} [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
	     *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
	     * @return {PIXI.Renderer} Returns itself.
	     */
	    RenderTextureSystem.prototype.clear = function (clearColor, mask) {
	        if (this.current) {
	            clearColor = clearColor || this.current.baseTexture.clearColor;
	        }
	        else {
	            clearColor = clearColor || this.clearColor;
	        }
	        this.renderer.framebuffer.clear(clearColor[0], clearColor[1], clearColor[2], clearColor[3], mask);
	    };
	    RenderTextureSystem.prototype.resize = function () {
	        // resize the root only!
	        this.bind(null);
	    };
	    /**
	     * Resets renderTexture state
	     */
	    RenderTextureSystem.prototype.reset = function () {
	        this.bind(null);
	    };
	    return RenderTextureSystem;
	}(System));

	var IGLUniformData = /** @class */ (function () {
	    function IGLUniformData() {
	    }
	    return IGLUniformData;
	}());
	/**
	 * Helper class to create a WebGL Program
	 *
	 * @class
	 * @memberof PIXI
	 */
	var GLProgram = /** @class */ (function () {
	    /**
	     * Makes a new Pixi program
	     *
	     * @param program {WebGLProgram} webgl program
	     * @param uniformData {Object} uniforms
	     */
	    function GLProgram(program, uniformData) {
	        /**
	         * The shader program
	         *
	         * @member {WebGLProgram}
	         */
	        this.program = program;
	        /**
	         * holds the uniform data which contains uniform locations
	         * and current uniform values used for caching and preventing unneeded GPU commands
	         * @member {Object}
	         */
	        this.uniformData = uniformData;
	        /**
	         * uniformGroups holds the various upload functions for the shader. Each uniform group
	         * and program have a unique upload function generated.
	         * @member {Object}
	         */
	        this.uniformGroups = {};
	    }
	    /**
	     * Destroys this program
	     */
	    GLProgram.prototype.destroy = function () {
	        this.uniformData = null;
	        this.uniformGroups = null;
	        this.program = null;
	    };
	    return GLProgram;
	}());

	var UID$4 = 0;
	// defualt sync data so we don't create a new one each time!
	var defaultSyncData = { textureCount: 0 };
	/**
	 * System plugin to the renderer to manage shaders.
	 *
	 * @class
	 * @memberof PIXI.systems
	 * @extends PIXI.System
	 */
	var ShaderSystem = /** @class */ (function (_super) {
	    __extends$2(ShaderSystem, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this System works for.
	     */
	    function ShaderSystem(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        _this.destroyed = false;
	        // Validation check that this environment support `new Function`
	        _this.systemCheck();
	        /**
	         * The current WebGL rendering context
	         *
	         * @member {WebGLRenderingContext}
	         */
	        _this.gl = null;
	        _this.shader = null;
	        _this.program = null;
	        /**
	         * Cache to holds the generated functions. Stored against UniformObjects unique signature
	         * @type {Object}
	         * @private
	         */
	        _this.cache = {};
	        _this.id = UID$4++;
	        return _this;
	    }
	    /**
	     * Overrideable function by `@pixi/unsafe-eval` to silence
	     * throwing an error if platform doesn't support unsafe-evals.
	     *
	     * @private
	     */
	    ShaderSystem.prototype.systemCheck = function () {
	        if (!unsafeEvalSupported()) {
	            throw new Error('Current environment does not allow unsafe-eval, '
	                + 'please use @pixi/unsafe-eval module to enable support.');
	        }
	    };
	    ShaderSystem.prototype.contextChange = function (gl) {
	        this.gl = gl;
	        this.reset();
	    };
	    /**
	     * Changes the current shader to the one given in parameter
	     *
	     * @param {PIXI.Shader} shader - the new shader
	     * @param {boolean} [dontSync] - false if the shader should automatically sync its uniforms.
	     * @returns {PIXI.GLProgram} the glProgram that belongs to the shader.
	     */
	    ShaderSystem.prototype.bind = function (shader, dontSync) {
	        shader.uniforms.globals = this.renderer.globalUniforms;
	        var program = shader.program;
	        var glProgram = program.glPrograms[this.renderer.CONTEXT_UID] || this.generateShader(shader);
	        this.shader = shader;
	        // TODO - some current Pixi plugins bypass this.. so it not safe to use yet..
	        if (this.program !== program) {
	            this.program = program;
	            this.gl.useProgram(glProgram.program);
	        }
	        if (!dontSync) {
	            defaultSyncData.textureCount = 0;
	            this.syncUniformGroup(shader.uniformGroup, defaultSyncData);
	        }
	        return glProgram;
	    };
	    /**
	     * Uploads the uniforms values to the currently bound shader.
	     *
	     * @param {object} uniforms - the uniforms values that be applied to the current shader
	     */
	    ShaderSystem.prototype.setUniforms = function (uniforms) {
	        var shader = this.shader.program;
	        var glProgram = shader.glPrograms[this.renderer.CONTEXT_UID];
	        shader.syncUniforms(glProgram.uniformData, uniforms, this.renderer);
	    };
	    /* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	    /**
	     *
	     * syncs uniforms on the group
	     * @param {*} group - the uniform group to sync
	     * @param {*} [syncData] - this is data that is passed to the sync function and any nested sync functions
	     */
	    ShaderSystem.prototype.syncUniformGroup = function (group, syncData) {
	        var glProgram = this.getglProgram();
	        if (!group.static || group.dirtyId !== glProgram.uniformGroups[group.id]) {
	            glProgram.uniformGroups[group.id] = group.dirtyId;
	            this.syncUniforms(group, glProgram, syncData);
	        }
	    };
	    /**
	     * Overrideable by the @pixi/unsafe-eval package to use static
	     * syncUnforms instead.
	     *
	     * @private
	     */
	    ShaderSystem.prototype.syncUniforms = function (group, glProgram, syncData) {
	        var syncFunc = group.syncUniforms[this.shader.program.id] || this.createSyncGroups(group);
	        syncFunc(glProgram.uniformData, group.uniforms, this.renderer, syncData);
	    };
	    /* eslint-enable @typescript-eslint/explicit-module-boundary-types */
	    ShaderSystem.prototype.createSyncGroups = function (group) {
	        var id = this.getSignature(group, this.shader.program.uniformData);
	        if (!this.cache[id]) {
	            this.cache[id] = generateUniformsSync(group, this.shader.program.uniformData);
	        }
	        group.syncUniforms[this.shader.program.id] = this.cache[id];
	        return group.syncUniforms[this.shader.program.id];
	    };
	    /**
	     * Takes a uniform group and data and generates a unique signature for them.
	     *
	     * @param {PIXI.UniformGroup} group - the uniform group to get signature of
	     * @param {Object} uniformData - uniform information generated by the shader
	     * @returns {String} Unique signature of the uniform group
	     * @private
	     */
	    ShaderSystem.prototype.getSignature = function (group, uniformData) {
	        var uniforms = group.uniforms;
	        var strings = [];
	        for (var i in uniforms) {
	            strings.push(i);
	            if (uniformData[i]) {
	                strings.push(uniformData[i].type);
	            }
	        }
	        return strings.join('-');
	    };
	    /**
	     * Returns the underlying GLShade rof the currently bound shader.
	     * This can be handy for when you to have a little more control over the setting of your uniforms.
	     *
	     * @return {PIXI.GLProgram} the glProgram for the currently bound Shader for this context
	     */
	    ShaderSystem.prototype.getglProgram = function () {
	        if (this.shader) {
	            return this.shader.program.glPrograms[this.renderer.CONTEXT_UID];
	        }
	        return null;
	    };
	    /**
	     * Generates a glProgram version of the Shader provided.
	     *
	     * @private
	     * @param {PIXI.Shader} shader - the shader that the glProgram will be based on.
	     * @return {PIXI.GLProgram} A shiny new glProgram!
	     */
	    ShaderSystem.prototype.generateShader = function (shader) {
	        var gl = this.gl;
	        var program = shader.program;
	        var attribMap = {};
	        for (var i in program.attributeData) {
	            attribMap[i] = program.attributeData[i].location;
	        }
	        var shaderProgram = compileProgram(gl, program.vertexSrc, program.fragmentSrc, attribMap);
	        var uniformData = {};
	        for (var i in program.uniformData) {
	            var data = program.uniformData[i];
	            uniformData[i] = {
	                location: gl.getUniformLocation(shaderProgram, i),
	                value: defaultValue(data.type, data.size),
	            };
	        }
	        var glProgram = new GLProgram(shaderProgram, uniformData);
	        program.glPrograms[this.renderer.CONTEXT_UID] = glProgram;
	        return glProgram;
	    };
	    /**
	     * Resets ShaderSystem state, does not affect WebGL state
	     */
	    ShaderSystem.prototype.reset = function () {
	        this.program = null;
	        this.shader = null;
	    };
	    /**
	     * Destroys this System and removes all its textures
	     */
	    ShaderSystem.prototype.destroy = function () {
	        // TODO implement destroy method for ShaderSystem
	        this.destroyed = true;
	    };
	    return ShaderSystem;
	}(System));

	/**
	 * Maps gl blend combinations to WebGL.
	 *
	 * @memberof PIXI
	 * @function mapWebGLBlendModesToPixi
	 * @private
	 * @param {WebGLRenderingContext} gl - The rendering context.
	 * @param {number[][]} [array=[]] - The array to output into.
	 * @return {number[][]} Mapped modes.
	 */
	function mapWebGLBlendModesToPixi(gl, array) {
	    if (array === void 0) { array = []; }
	    // TODO - premultiply alpha would be different.
	    // add a boolean for that!
	    array[exports.BLEND_MODES.NORMAL] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.ADD] = [gl.ONE, gl.ONE];
	    array[exports.BLEND_MODES.MULTIPLY] = [gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.SCREEN] = [gl.ONE, gl.ONE_MINUS_SRC_COLOR, gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.OVERLAY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.DARKEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.LIGHTEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.COLOR_DODGE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.COLOR_BURN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.HARD_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.SOFT_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.DIFFERENCE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.EXCLUSION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.HUE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.SATURATION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.COLOR] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.LUMINOSITY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.NONE] = [0, 0];
	    // not-premultiplied blend modes
	    array[exports.BLEND_MODES.NORMAL_NPM] = [gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.ADD_NPM] = [gl.SRC_ALPHA, gl.ONE, gl.ONE, gl.ONE];
	    array[exports.BLEND_MODES.SCREEN_NPM] = [gl.SRC_ALPHA, gl.ONE_MINUS_SRC_COLOR, gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	    // composite operations
	    array[exports.BLEND_MODES.SRC_IN] = [gl.DST_ALPHA, gl.ZERO];
	    array[exports.BLEND_MODES.SRC_OUT] = [gl.ONE_MINUS_DST_ALPHA, gl.ZERO];
	    array[exports.BLEND_MODES.SRC_ATOP] = [gl.DST_ALPHA, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.DST_OVER] = [gl.ONE_MINUS_DST_ALPHA, gl.ONE];
	    array[exports.BLEND_MODES.DST_IN] = [gl.ZERO, gl.SRC_ALPHA];
	    array[exports.BLEND_MODES.DST_OUT] = [gl.ZERO, gl.ONE_MINUS_SRC_ALPHA];
	    array[exports.BLEND_MODES.DST_ATOP] = [gl.ONE_MINUS_DST_ALPHA, gl.SRC_ALPHA];
	    array[exports.BLEND_MODES.XOR] = [gl.ONE_MINUS_DST_ALPHA, gl.ONE_MINUS_SRC_ALPHA];
	    // SUBTRACT from flash
	    array[exports.BLEND_MODES.SUBTRACT] = [gl.ONE, gl.ONE, gl.ONE, gl.ONE, gl.FUNC_REVERSE_SUBTRACT, gl.FUNC_ADD];
	    return array;
	}

	var BLEND$1 = 0;
	var OFFSET$1 = 1;
	var CULLING$1 = 2;
	var DEPTH_TEST$1 = 3;
	var WINDING$1 = 4;
	/**
	 * System plugin to the renderer to manage WebGL state machines.
	 *
	 * @class
	 * @extends PIXI.System
	 * @memberof PIXI.systems
	 */
	var StateSystem = /** @class */ (function (_super) {
	    __extends$2(StateSystem, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this System works for.
	     */
	    function StateSystem(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        /**
	         * GL context
	         * @member {WebGLRenderingContext}
	         * @readonly
	         */
	        _this.gl = null;
	        /**
	         * State ID
	         * @member {number}
	         * @readonly
	         */
	        _this.stateId = 0;
	        /**
	         * Polygon offset
	         * @member {number}
	         * @readonly
	         */
	        _this.polygonOffset = 0;
	        /**
	         * Blend mode
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NONE
	         * @readonly
	         */
	        _this.blendMode = exports.BLEND_MODES.NONE;
	        /**
	         * Whether current blend equation is different
	         * @member {boolean}
	         * @protected
	         */
	        _this._blendEq = false;
	        /**
	         * Collection of calls
	         * @member {function[]}
	         * @readonly
	         */
	        _this.map = [];
	        // map functions for when we set state..
	        _this.map[BLEND$1] = _this.setBlend;
	        _this.map[OFFSET$1] = _this.setOffset;
	        _this.map[CULLING$1] = _this.setCullFace;
	        _this.map[DEPTH_TEST$1] = _this.setDepthTest;
	        _this.map[WINDING$1] = _this.setFrontFace;
	        /**
	         * Collection of check calls
	         * @member {function[]}
	         * @readonly
	         */
	        _this.checks = [];
	        /**
	         * Default WebGL State
	         * @member {PIXI.State}
	         * @readonly
	         */
	        _this.defaultState = new State();
	        _this.defaultState.blend = true;
	        return _this;
	    }
	    StateSystem.prototype.contextChange = function (gl) {
	        this.gl = gl;
	        this.blendModes = mapWebGLBlendModesToPixi(gl);
	        this.set(this.defaultState);
	        this.reset();
	    };
	    /**
	     * Sets the current state
	     *
	     * @param {*} state - The state to set.
	     */
	    StateSystem.prototype.set = function (state) {
	        state = state || this.defaultState;
	        // TODO maybe to an object check? ( this.state === state )?
	        if (this.stateId !== state.data) {
	            var diff = this.stateId ^ state.data;
	            var i = 0;
	            // order from least to most common
	            while (diff) {
	                if (diff & 1) {
	                    // state change!
	                    this.map[i].call(this, !!(state.data & (1 << i)));
	                }
	                diff = diff >> 1;
	                i++;
	            }
	            this.stateId = state.data;
	        }
	        // based on the above settings we check for specific modes..
	        // for example if blend is active we check and set the blend modes
	        // or of polygon offset is active we check the poly depth.
	        for (var i = 0; i < this.checks.length; i++) {
	            this.checks[i](this, state);
	        }
	    };
	    /**
	     * Sets the state, when previous state is unknown
	     *
	     * @param {*} state - The state to set
	     */
	    StateSystem.prototype.forceState = function (state) {
	        state = state || this.defaultState;
	        for (var i = 0; i < this.map.length; i++) {
	            this.map[i].call(this, !!(state.data & (1 << i)));
	        }
	        for (var i = 0; i < this.checks.length; i++) {
	            this.checks[i](this, state);
	        }
	        this.stateId = state.data;
	    };
	    /**
	     * Enables or disabled blending.
	     *
	     * @param {boolean} value - Turn on or off webgl blending.
	     */
	    StateSystem.prototype.setBlend = function (value) {
	        this.updateCheck(StateSystem.checkBlendMode, value);
	        this.gl[value ? 'enable' : 'disable'](this.gl.BLEND);
	    };
	    /**
	     * Enables or disable polygon offset fill
	     *
	     * @param {boolean} value - Turn on or off webgl polygon offset testing.
	     */
	    StateSystem.prototype.setOffset = function (value) {
	        this.updateCheck(StateSystem.checkPolygonOffset, value);
	        this.gl[value ? 'enable' : 'disable'](this.gl.POLYGON_OFFSET_FILL);
	    };
	    /**
	     * Sets whether to enable or disable depth test.
	     *
	     * @param {boolean} value - Turn on or off webgl depth testing.
	     */
	    StateSystem.prototype.setDepthTest = function (value) {
	        this.gl[value ? 'enable' : 'disable'](this.gl.DEPTH_TEST);
	    };
	    /**
	     * Sets whether to enable or disable cull face.
	     *
	     * @param {boolean} value - Turn on or off webgl cull face.
	     */
	    StateSystem.prototype.setCullFace = function (value) {
	        this.gl[value ? 'enable' : 'disable'](this.gl.CULL_FACE);
	    };
	    /**
	     * Sets the gl front face.
	     *
	     * @param {boolean} value - true is clockwise and false is counter-clockwise
	     */
	    StateSystem.prototype.setFrontFace = function (value) {
	        this.gl.frontFace(this.gl[value ? 'CW' : 'CCW']);
	    };
	    /**
	     * Sets the blend mode.
	     *
	     * @param {number} value - The blend mode to set to.
	     */
	    StateSystem.prototype.setBlendMode = function (value) {
	        if (value === this.blendMode) {
	            return;
	        }
	        this.blendMode = value;
	        var mode = this.blendModes[value];
	        var gl = this.gl;
	        if (mode.length === 2) {
	            gl.blendFunc(mode[0], mode[1]);
	        }
	        else {
	            gl.blendFuncSeparate(mode[0], mode[1], mode[2], mode[3]);
	        }
	        if (mode.length === 6) {
	            this._blendEq = true;
	            gl.blendEquationSeparate(mode[4], mode[5]);
	        }
	        else if (this._blendEq) {
	            this._blendEq = false;
	            gl.blendEquationSeparate(gl.FUNC_ADD, gl.FUNC_ADD);
	        }
	    };
	    /**
	     * Sets the polygon offset.
	     *
	     * @param {number} value - the polygon offset
	     * @param {number} scale - the polygon offset scale
	     */
	    StateSystem.prototype.setPolygonOffset = function (value, scale) {
	        this.gl.polygonOffset(value, scale);
	    };
	    // used
	    /**
	     * Resets all the logic and disables the vaos
	     */
	    StateSystem.prototype.reset = function () {
	        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);
	        this.forceState(this.defaultState);
	        this._blendEq = true;
	        this.blendMode = -1;
	        this.setBlendMode(0);
	    };
	    /**
	     * checks to see which updates should be checked based on which settings have been activated.
	     * For example, if blend is enabled then we should check the blend modes each time the state is changed
	     * or if polygon fill is activated then we need to check if the polygon offset changes.
	     * The idea is that we only check what we have too.
	     *
	     * @param {Function} func - the checking function to add or remove
	     * @param {boolean} value - should the check function be added or removed.
	     */
	    StateSystem.prototype.updateCheck = function (func, value) {
	        var index = this.checks.indexOf(func);
	        if (value && index === -1) {
	            this.checks.push(func);
	        }
	        else if (!value && index !== -1) {
	            this.checks.splice(index, 1);
	        }
	    };
	    /**
	     * A private little wrapper function that we call to check the blend mode.
	     *
	     * @static
	     * @private
	     * @param {PIXI.StateSystem} System - the System to perform the state check on
	     * @param {PIXI.State} state - the state that the blendMode will pulled from
	     */
	    StateSystem.checkBlendMode = function (system, state) {
	        system.setBlendMode(state.blendMode);
	    };
	    /**
	     * A private little wrapper function that we call to check the polygon offset.
	     *
	     * @static
	     * @private
	     * @param {PIXI.StateSystem} System - the System to perform the state check on
	     * @param {PIXI.State} state - the state that the blendMode will pulled from
	     */
	    StateSystem.checkPolygonOffset = function (system, state) {
	        system.setPolygonOffset(1, state.polygonOffset);
	    };
	    return StateSystem;
	}(System));

	/**
	 * System plugin to the renderer to manage texture garbage collection on the GPU,
	 * ensuring that it does not get clogged up with textures that are no longer being used.
	 *
	 * @class
	 * @memberof PIXI.systems
	 * @extends PIXI.System
	 */
	var TextureGCSystem = /** @class */ (function (_super) {
	    __extends$2(TextureGCSystem, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this System works for.
	     */
	    function TextureGCSystem(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        /**
	         * Count
	         * @member {number}
	         * @readonly
	         */
	        _this.count = 0;
	        /**
	         * Check count
	         * @member {number}
	         * @readonly
	         */
	        _this.checkCount = 0;
	        /**
	         * Maximum idle time, in seconds
	         * @member {number}
	         * @see PIXI.settings.GC_MAX_IDLE
	         */
	        _this.maxIdle = settings.GC_MAX_IDLE;
	        /**
	         * Maximum number of item to check
	         * @member {number}
	         * @see PIXI.settings.GC_MAX_CHECK_COUNT
	         */
	        _this.checkCountMax = settings.GC_MAX_CHECK_COUNT;
	        /**
	         * Current garabage collection mode
	         * @member {PIXI.GC_MODES}
	         * @see PIXI.settings.GC_MODE
	         */
	        _this.mode = settings.GC_MODE;
	        return _this;
	    }
	    /**
	     * Checks to see when the last time a texture was used
	     * if the texture has not been used for a specified amount of time it will be removed from the GPU
	     */
	    TextureGCSystem.prototype.postrender = function () {
	        if (!this.renderer.renderingToScreen) {
	            return;
	        }
	        this.count++;
	        if (this.mode === exports.GC_MODES.MANUAL) {
	            return;
	        }
	        this.checkCount++;
	        if (this.checkCount > this.checkCountMax) {
	            this.checkCount = 0;
	            this.run();
	        }
	    };
	    /**
	     * Checks to see when the last time a texture was used
	     * if the texture has not been used for a specified amount of time it will be removed from the GPU
	     */
	    TextureGCSystem.prototype.run = function () {
	        var tm = this.renderer.texture;
	        var managedTextures = tm.managedTextures;
	        var wasRemoved = false;
	        for (var i = 0; i < managedTextures.length; i++) {
	            var texture = managedTextures[i];
	            // only supports non generated textures at the moment!
	            if (!texture.framebuffer && this.count - texture.touched > this.maxIdle) {
	                tm.destroyTexture(texture, true);
	                managedTextures[i] = null;
	                wasRemoved = true;
	            }
	        }
	        if (wasRemoved) {
	            var j = 0;
	            for (var i = 0; i < managedTextures.length; i++) {
	                if (managedTextures[i] !== null) {
	                    managedTextures[j++] = managedTextures[i];
	                }
	            }
	            managedTextures.length = j;
	        }
	    };
	    /**
	     * Removes all the textures within the specified displayObject and its children from the GPU
	     *
	     * @param {PIXI.DisplayObject} displayObject - the displayObject to remove the textures from.
	     */
	    TextureGCSystem.prototype.unload = function (displayObject) {
	        var tm = this.renderer.texture;
	        var texture = displayObject._texture;
	        // only destroy non generated textures
	        if (texture && !texture.framebuffer) {
	            tm.destroyTexture(texture);
	        }
	        for (var i = displayObject.children.length - 1; i >= 0; i--) {
	            this.unload(displayObject.children[i]);
	        }
	    };
	    return TextureGCSystem;
	}(System));

	/**
	 * Internal texture for WebGL context
	 * @class
	 * @memberof PIXI
	 */
	var GLTexture = /** @class */ (function () {
	    function GLTexture(texture) {
	        /**
	         * The WebGL texture
	         * @member {WebGLTexture}
	         */
	        this.texture = texture;
	        /**
	         * Width of texture that was used in texImage2D
	         * @member {number}
	         */
	        this.width = -1;
	        /**
	         * Height of texture that was used in texImage2D
	         * @member {number}
	         */
	        this.height = -1;
	        /**
	         * Texture contents dirty flag
	         * @member {number}
	         */
	        this.dirtyId = -1;
	        /**
	         * Texture style dirty flag
	         * @member {number}
	         */
	        this.dirtyStyleId = -1;
	        /**
	         * Whether mip levels has to be generated
	         * @member {boolean}
	         */
	        this.mipmap = false;
	        /**
	         * WrapMode copied from baseTexture
	         * @member {number}
	         */
	        this.wrapMode = 33071;
	        /**
	         * Type copied from baseTexture
	         * @member {number}
	         */
	        this.type = 6408;
	        /**
	         * Type copied from baseTexture
	         * @member {number}
	         */
	        this.internalFormat = 5121;
	    }
	    return GLTexture;
	}());

	/**
	 * System plugin to the renderer to manage textures.
	 *
	 * @class
	 * @extends PIXI.System
	 * @memberof PIXI.systems
	 */
	var TextureSystem = /** @class */ (function (_super) {
	    __extends$2(TextureSystem, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this System works for.
	     */
	    function TextureSystem(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        // TODO set to max textures...
	        /**
	         * Bound textures
	         * @member {PIXI.BaseTexture[]}
	         * @readonly
	         */
	        _this.boundTextures = [];
	        /**
	         * Current location
	         * @member {number}
	         * @readonly
	         */
	        _this.currentLocation = -1;
	        /**
	         * List of managed textures
	         * @member {PIXI.BaseTexture[]}
	         * @readonly
	         */
	        _this.managedTextures = [];
	        /**
	         * Did someone temper with textures state? We'll overwrite them when we need to unbind something.
	         * @member {boolean}
	         * @private
	         */
	        _this._unknownBoundTextures = false;
	        /**
	         * BaseTexture value that shows that we don't know what is bound
	         * @member {PIXI.BaseTexture}
	         * @readonly
	         */
	        _this.unknownTexture = new BaseTexture();
	        return _this;
	    }
	    /**
	     * Sets up the renderer context and necessary buffers.
	     */
	    TextureSystem.prototype.contextChange = function () {
	        var gl = this.gl = this.renderer.gl;
	        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
	        this.webGLVersion = this.renderer.context.webGLVersion;
	        var maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
	        this.boundTextures.length = maxTextures;
	        for (var i = 0; i < maxTextures; i++) {
	            this.boundTextures[i] = null;
	        }
	        // TODO move this.. to a nice make empty textures class..
	        this.emptyTextures = {};
	        var emptyTexture2D = new GLTexture(gl.createTexture());
	        gl.bindTexture(gl.TEXTURE_2D, emptyTexture2D.texture);
	        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array(4));
	        this.emptyTextures[gl.TEXTURE_2D] = emptyTexture2D;
	        this.emptyTextures[gl.TEXTURE_CUBE_MAP] = new GLTexture(gl.createTexture());
	        gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.emptyTextures[gl.TEXTURE_CUBE_MAP].texture);
	        for (var i = 0; i < 6; i++) {
	            gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
	        }
	        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
	        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
	        for (var i = 0; i < this.boundTextures.length; i++) {
	            this.bind(null, i);
	        }
	    };
	    /**
	     * Bind a texture to a specific location
	     *
	     * If you want to unbind something, please use `unbind(texture)` instead of `bind(null, textureLocation)`
	     *
	     * @param {PIXI.Texture|PIXI.BaseTexture} texture_ - Texture to bind
	     * @param {number} [location=0] - Location to bind at
	     */
	    TextureSystem.prototype.bind = function (texture, location) {
	        if (location === void 0) { location = 0; }
	        var gl = this.gl;
	        if (texture) {
	            texture = texture.castToBaseTexture();
	            if (texture.parentTextureArray) {
	                // cannot bind partial texture
	                // TODO: report a warning
	                return;
	            }
	            if (texture.valid) {
	                texture.touched = this.renderer.textureGC.count;
	                var glTexture = texture._glTextures[this.CONTEXT_UID] || this.initTexture(texture);
	                if (this.boundTextures[location] !== texture) {
	                    if (this.currentLocation !== location) {
	                        this.currentLocation = location;
	                        gl.activeTexture(gl.TEXTURE0 + location);
	                    }
	                    gl.bindTexture(texture.target, glTexture.texture);
	                }
	                if (glTexture.dirtyId !== texture.dirtyId) {
	                    if (this.currentLocation !== location) {
	                        this.currentLocation = location;
	                        gl.activeTexture(gl.TEXTURE0 + location);
	                    }
	                    this.updateTexture(texture);
	                }
	                this.boundTextures[location] = texture;
	            }
	        }
	        else {
	            if (this.currentLocation !== location) {
	                this.currentLocation = location;
	                gl.activeTexture(gl.TEXTURE0 + location);
	            }
	            gl.bindTexture(gl.TEXTURE_2D, this.emptyTextures[gl.TEXTURE_2D].texture);
	            this.boundTextures[location] = null;
	        }
	    };
	    /**
	     * Resets texture location and bound textures
	     *
	     * Actual `bind(null, i)` calls will be performed at next `unbind()` call
	     */
	    TextureSystem.prototype.reset = function () {
	        this._unknownBoundTextures = true;
	        this.currentLocation = -1;
	        for (var i = 0; i < this.boundTextures.length; i++) {
	            this.boundTextures[i] = this.unknownTexture;
	        }
	    };
	    /**
	     * Unbind a texture
	     * @param {PIXI.BaseTexture} texture - Texture to bind
	     */
	    TextureSystem.prototype.unbind = function (texture) {
	        var _a = this, gl = _a.gl, boundTextures = _a.boundTextures;
	        if (this._unknownBoundTextures) {
	            this._unknownBoundTextures = false;
	            // someone changed webGL state,
	            // we have to be sure that our texture does not appear in multi-texture renderer samplers
	            for (var i = 0; i < boundTextures.length; i++) {
	                if (boundTextures[i] === this.unknownTexture) {
	                    this.bind(null, i);
	                }
	            }
	        }
	        for (var i = 0; i < boundTextures.length; i++) {
	            if (boundTextures[i] === texture) {
	                if (this.currentLocation !== i) {
	                    gl.activeTexture(gl.TEXTURE0 + i);
	                    this.currentLocation = i;
	                }
	                gl.bindTexture(texture.target, this.emptyTextures[texture.target].texture);
	                boundTextures[i] = null;
	            }
	        }
	    };
	    /**
	     * Initialize a texture
	     *
	     * @private
	     * @param {PIXI.BaseTexture} texture - Texture to initialize
	     */
	    TextureSystem.prototype.initTexture = function (texture) {
	        var glTexture = new GLTexture(this.gl.createTexture());
	        // guarantee an update..
	        glTexture.dirtyId = -1;
	        texture._glTextures[this.CONTEXT_UID] = glTexture;
	        this.managedTextures.push(texture);
	        texture.on('dispose', this.destroyTexture, this);
	        return glTexture;
	    };
	    TextureSystem.prototype.initTextureType = function (texture, glTexture) {
	        glTexture.internalFormat = texture.format;
	        glTexture.type = texture.type;
	        if (this.webGLVersion !== 2) {
	            return;
	        }
	        var gl = this.renderer.gl;
	        if (texture.type === gl.FLOAT
	            && texture.format === gl.RGBA) {
	            glTexture.internalFormat = gl.RGBA32F;
	        }
	        // that's WebGL1 HALF_FLOAT_OES
	        // we have to convert it to WebGL HALF_FLOAT
	        if (texture.type === exports.TYPES.HALF_FLOAT) {
	            glTexture.type = gl.HALF_FLOAT;
	        }
	        if (glTexture.type === gl.HALF_FLOAT
	            && texture.format === gl.RGBA) {
	            glTexture.internalFormat = gl.RGBA16F;
	        }
	    };
	    /**
	     * Update a texture
	     *
	     * @private
	     * @param {PIXI.BaseTexture} texture - Texture to initialize
	     */
	    TextureSystem.prototype.updateTexture = function (texture) {
	        var glTexture = texture._glTextures[this.CONTEXT_UID];
	        if (!glTexture) {
	            return;
	        }
	        var renderer = this.renderer;
	        this.initTextureType(texture, glTexture);
	        if (texture.resource && texture.resource.upload(renderer, texture, glTexture)) { ; }
	        else {
	            // default, renderTexture-like logic
	            var width = texture.realWidth;
	            var height = texture.realHeight;
	            var gl = renderer.gl;
	            if (glTexture.width !== width
	                || glTexture.height !== height
	                || glTexture.dirtyId < 0) {
	                glTexture.width = width;
	                glTexture.height = height;
	                gl.texImage2D(texture.target, 0, glTexture.internalFormat, width, height, 0, texture.format, glTexture.type, null);
	            }
	        }
	        // lets only update what changes..
	        if (texture.dirtyStyleId !== glTexture.dirtyStyleId) {
	            this.updateTextureStyle(texture);
	        }
	        glTexture.dirtyId = texture.dirtyId;
	    };
	    /**
	     * Deletes the texture from WebGL
	     *
	     * @private
	     * @param {PIXI.BaseTexture|PIXI.Texture} texture_ - the texture to destroy
	     * @param {boolean} [skipRemove=false] - Whether to skip removing the texture from the TextureManager.
	     */
	    TextureSystem.prototype.destroyTexture = function (texture, skipRemove) {
	        var gl = this.gl;
	        texture = texture.castToBaseTexture();
	        if (texture._glTextures[this.CONTEXT_UID]) {
	            this.unbind(texture);
	            gl.deleteTexture(texture._glTextures[this.CONTEXT_UID].texture);
	            texture.off('dispose', this.destroyTexture, this);
	            delete texture._glTextures[this.CONTEXT_UID];
	            if (!skipRemove) {
	                var i = this.managedTextures.indexOf(texture);
	                if (i !== -1) {
	                    removeItems(this.managedTextures, i, 1);
	                }
	            }
	        }
	    };
	    /**
	     * Update texture style such as mipmap flag
	     *
	     * @private
	     * @param {PIXI.BaseTexture} texture - Texture to update
	     */
	    TextureSystem.prototype.updateTextureStyle = function (texture) {
	        var glTexture = texture._glTextures[this.CONTEXT_UID];
	        if (!glTexture) {
	            return;
	        }
	        if ((texture.mipmap === exports.MIPMAP_MODES.POW2 || this.webGLVersion !== 2) && !texture.isPowerOfTwo) {
	            glTexture.mipmap = false;
	        }
	        else {
	            glTexture.mipmap = texture.mipmap >= 1;
	        }
	        if (this.webGLVersion !== 2 && !texture.isPowerOfTwo) {
	            glTexture.wrapMode = exports.WRAP_MODES.CLAMP;
	        }
	        else {
	            glTexture.wrapMode = texture.wrapMode;
	        }
	        if (texture.resource && texture.resource.style(this.renderer, texture, glTexture)) { ; }
	        else {
	            this.setStyle(texture, glTexture);
	        }
	        glTexture.dirtyStyleId = texture.dirtyStyleId;
	    };
	    /**
	     * Set style for texture
	     *
	     * @private
	     * @param {PIXI.BaseTexture} texture - Texture to update
	     * @param {PIXI.GLTexture} glTexture
	     */
	    TextureSystem.prototype.setStyle = function (texture, glTexture) {
	        var gl = this.gl;
	        if (glTexture.mipmap) {
	            gl.generateMipmap(texture.target);
	        }
	        gl.texParameteri(texture.target, gl.TEXTURE_WRAP_S, glTexture.wrapMode);
	        gl.texParameteri(texture.target, gl.TEXTURE_WRAP_T, glTexture.wrapMode);
	        if (glTexture.mipmap) {
	            /* eslint-disable max-len */
	            gl.texParameteri(texture.target, gl.TEXTURE_MIN_FILTER, texture.scaleMode === exports.SCALE_MODES.LINEAR ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST_MIPMAP_NEAREST);
	            /* eslint-disable max-len */
	            var anisotropicExt = this.renderer.context.extensions.anisotropicFiltering;
	            if (anisotropicExt && texture.anisotropicLevel > 0 && texture.scaleMode === exports.SCALE_MODES.LINEAR) {
	                var level = Math.min(texture.anisotropicLevel, gl.getParameter(anisotropicExt.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
	                gl.texParameterf(texture.target, anisotropicExt.TEXTURE_MAX_ANISOTROPY_EXT, level);
	            }
	        }
	        else {
	            gl.texParameteri(texture.target, gl.TEXTURE_MIN_FILTER, texture.scaleMode === exports.SCALE_MODES.LINEAR ? gl.LINEAR : gl.NEAREST);
	        }
	        gl.texParameteri(texture.target, gl.TEXTURE_MAG_FILTER, texture.scaleMode === exports.SCALE_MODES.LINEAR ? gl.LINEAR : gl.NEAREST);
	    };
	    return TextureSystem;
	}(System));

	/**
	 * Systems are individual components to the Renderer pipeline.
	 * @namespace PIXI.systems
	 */

	var systems = ({
	    FilterSystem: FilterSystem,
	    BatchSystem: BatchSystem,
	    ContextSystem: ContextSystem,
	    FramebufferSystem: FramebufferSystem,
	    GeometrySystem: GeometrySystem,
	    MaskSystem: MaskSystem,
	    ScissorSystem: ScissorSystem,
	    StencilSystem: StencilSystem,
	    ProjectionSystem: ProjectionSystem,
	    RenderTextureSystem: RenderTextureSystem,
	    ShaderSystem: ShaderSystem,
	    StateSystem: StateSystem,
	    TextureGCSystem: TextureGCSystem,
	    TextureSystem: TextureSystem
	});

	var tempMatrix = new Matrix();
	/**
	 * The AbstractRenderer is the base for a PixiJS Renderer. It is extended by the {@link PIXI.CanvasRenderer}
	 * and {@link PIXI.Renderer} which can be used for rendering a PixiJS scene.
	 *
	 * @abstract
	 * @class
	 * @extends PIXI.utils.EventEmitter
	 * @memberof PIXI
	 */
	var AbstractRenderer = /** @class */ (function (_super) {
	    __extends$2(AbstractRenderer, _super);
	    /**
	     * @param {string} system - The name of the system this renderer is for.
	     * @param {object} [options] - The optional renderer parameters.
	     * @param {number} [options.width=800] - The width of the screen.
	     * @param {number} [options.height=600] - The height of the screen.
	     * @param {HTMLCanvasElement} [options.view] - The canvas to use as a view, optional.
	     * @param {boolean} [options.transparent=false] - If the render view is transparent.
	     * @param {boolean} [options.autoDensity=false] - Resizes renderer view in CSS pixels to allow for
	     *   resolutions other than 1.
	     * @param {boolean} [options.antialias=false] - Sets antialias
	     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer. The
	     *  resolution of the renderer retina would be 2.
	     * @param {boolean} [options.preserveDrawingBuffer=false] - Enables drawing buffer preservation,
	     *  enable this if you need to call toDataUrl on the WebGL context.
	     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	     *      not before the new render pass.
	     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	     *  (shown if not transparent).
	     */
	    function AbstractRenderer(type, options) {
	        if (type === void 0) { type = exports.RENDERER_TYPE.UNKNOWN; }
	        var _this = _super.call(this) || this;
	        // Add the default render options
	        options = Object.assign({}, settings.RENDER_OPTIONS, options);
	        // Deprecation notice for renderer roundPixels option
	        if (options.roundPixels) {
	            settings.ROUND_PIXELS = options.roundPixels;
	            deprecation('5.0.0', 'Renderer roundPixels option is deprecated, please use PIXI.settings.ROUND_PIXELS', 2);
	        }
	        /**
	         * The supplied constructor options.
	         *
	         * @member {Object}
	         * @readOnly
	         */
	        _this.options = options;
	        /**
	         * The type of the renderer.
	         *
	         * @member {number}
	         * @default PIXI.RENDERER_TYPE.UNKNOWN
	         * @see PIXI.RENDERER_TYPE
	         */
	        _this.type = type;
	        /**
	         * Measurements of the screen. (0, 0, screenWidth, screenHeight).
	         *
	         * Its safe to use as filterArea or hitArea for the whole stage.
	         *
	         * @member {PIXI.Rectangle}
	         */
	        _this.screen = new Rectangle(0, 0, options.width, options.height);
	        /**
	         * The canvas element that everything is drawn to.
	         *
	         * @member {HTMLCanvasElement}
	         */
	        _this.view = options.view || document.createElement('canvas');
	        /**
	         * The resolution / device pixel ratio of the renderer.
	         *
	         * @member {number}
	         * @default 1
	         */
	        _this.resolution = options.resolution || settings.RESOLUTION;
	        /**
	         * Whether the render view is transparent.
	         *
	         * @member {boolean}
	         */
	        _this.transparent = options.transparent;
	        /**
	         * Whether CSS dimensions of canvas view should be resized to screen dimensions automatically.
	         *
	         * @member {boolean}
	         */
	        _this.autoDensity = options.autoDensity || options.autoResize || false;
	        // autoResize is deprecated, provides fallback support
	        /**
	         * The value of the preserveDrawingBuffer flag affects whether or not the contents of
	         * the stencil buffer is retained after rendering.
	         *
	         * @member {boolean}
	         */
	        _this.preserveDrawingBuffer = options.preserveDrawingBuffer;
	        /**
	         * This sets if the CanvasRenderer will clear the canvas or not before the new render pass.
	         * If the scene is NOT transparent PixiJS will use a canvas sized fillRect operation every
	         * frame to set the canvas background color. If the scene is transparent PixiJS will use clearRect
	         * to clear the canvas every frame. Disable this by setting this to false. For example, if
	         * your game has a canvas filling background image you often don't need this set.
	         *
	         * @member {boolean}
	         * @default
	         */
	        _this.clearBeforeRender = options.clearBeforeRender;
	        /**
	         * The background color as a number.
	         *
	         * @member {number}
	         * @protected
	         */
	        _this._backgroundColor = 0x000000;
	        /**
	         * The background color as an [R, G, B] array.
	         *
	         * @member {number[]}
	         * @protected
	         */
	        _this._backgroundColorRgba = [0, 0, 0, 0];
	        /**
	         * The background color as a string.
	         *
	         * @member {string}
	         * @protected
	         */
	        _this._backgroundColorString = '#000000';
	        _this.backgroundColor = options.backgroundColor || _this._backgroundColor; // run bg color setter
	        /**
	         * The last root object that the renderer tried to render.
	         *
	         * @member {PIXI.DisplayObject}
	         * @protected
	         */
	        _this._lastObjectRendered = null;
	        /**
	         * Collection of plugins.
	         * @readonly
	         * @member {object}
	         */
	        _this.plugins = {};
	        return _this;
	    }
	    /**
	     * Initialize the plugins.
	     *
	     * @protected
	     * @param {object} staticMap - The dictionary of statically saved plugins.
	     */
	    AbstractRenderer.prototype.initPlugins = function (staticMap) {
	        for (var o in staticMap) {
	            this.plugins[o] = new (staticMap[o])(this);
	        }
	    };
	    Object.defineProperty(AbstractRenderer.prototype, "width", {
	        /**
	         * Same as view.width, actual number of pixels in the canvas by horizontal.
	         *
	         * @member {number}
	         * @readonly
	         * @default 800
	         */
	        get: function () {
	            return this.view.width;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(AbstractRenderer.prototype, "height", {
	        /**
	         * Same as view.height, actual number of pixels in the canvas by vertical.
	         *
	         * @member {number}
	         * @readonly
	         * @default 600
	         */
	        get: function () {
	            return this.view.height;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Resizes the screen and canvas to the specified width and height.
	     * Canvas dimensions are multiplied by resolution.
	     *
	     * @param {number} screenWidth - The new width of the screen.
	     * @param {number} screenHeight - The new height of the screen.
	     */
	    AbstractRenderer.prototype.resize = function (screenWidth, screenHeight) {
	        this.screen.width = screenWidth;
	        this.screen.height = screenHeight;
	        this.view.width = screenWidth * this.resolution;
	        this.view.height = screenHeight * this.resolution;
	        if (this.autoDensity) {
	            this.view.style.width = screenWidth + "px";
	            this.view.style.height = screenHeight + "px";
	        }
	        /**
	         * Fired after view has been resized.
	         *
	         * @event PIXI.Renderer#resize
	         * @param {number} screenWidth - The new width of the screen.
	         * @param {number} screenHeight - The new height of the screen.
	         */
	        this.emit('resize', screenWidth, screenHeight);
	    };
	    /**
	     * Useful function that returns a texture of the display object that can then be used to create sprites
	     * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
	     *
	     * @param {PIXI.DisplayObject} displayObject - The displayObject the object will be generated from.
	     * @param {PIXI.SCALE_MODES} scaleMode - The scale mode of the texture.
	     * @param {number} resolution - The resolution / device pixel ratio of the texture being generated.
	     * @param {PIXI.Rectangle} [region] - The region of the displayObject, that shall be rendered,
	     *        if no region is specified, defaults to the local bounds of the displayObject.
	     * @return {PIXI.RenderTexture} A texture of the graphics object.
	     */
	    AbstractRenderer.prototype.generateTexture = function (displayObject, scaleMode, resolution, region) {
	        region = region || displayObject.getLocalBounds(null, true);
	        // minimum texture size is 1x1, 0x0 will throw an error
	        if (region.width === 0)
	            { region.width = 1; }
	        if (region.height === 0)
	            { region.height = 1; }
	        var renderTexture = RenderTexture.create({
	            width: region.width | 0,
	            height: region.height | 0,
	            scaleMode: scaleMode,
	            resolution: resolution,
	        });
	        tempMatrix.tx = -region.x;
	        tempMatrix.ty = -region.y;
	        this.render(displayObject, renderTexture, false, tempMatrix, !!displayObject.parent);
	        return renderTexture;
	    };
	    /**
	     * Removes everything from the renderer and optionally removes the Canvas DOM element.
	     *
	     * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
	     */
	    AbstractRenderer.prototype.destroy = function (removeView) {
	        for (var o in this.plugins) {
	            this.plugins[o].destroy();
	            this.plugins[o] = null;
	        }
	        if (removeView && this.view.parentNode) {
	            this.view.parentNode.removeChild(this.view);
	        }
	        var thisAny = this;
	        // null-ing all objects, that's a tradition!
	        thisAny.plugins = null;
	        thisAny.type = exports.RENDERER_TYPE.UNKNOWN;
	        thisAny.view = null;
	        thisAny.screen = null;
	        thisAny._tempDisplayObjectParent = null;
	        thisAny.options = null;
	        this._backgroundColorRgba = null;
	        this._backgroundColorString = null;
	        this._lastObjectRendered = null;
	    };
	    Object.defineProperty(AbstractRenderer.prototype, "backgroundColor", {
	        /**
	         * The background color to fill if not transparent
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._backgroundColor;
	        },
	        set: function (value) {
	            this._backgroundColor = value;
	            this._backgroundColorString = hex2string(value);
	            hex2rgb(value, this._backgroundColorRgba);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return AbstractRenderer;
	}(eventemitter3));

	/**
	 * The Renderer draws the scene and all its content onto a WebGL enabled canvas.
	 *
	 * This renderer should be used for browsers that support WebGL.
	 *
	 * This renderer works by automatically managing WebGLBatchesm, so no need for Sprite Batches or Sprite Clouds.
	 * Don't forget to add the view to your DOM or you will not see anything!
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.AbstractRenderer
	 */
	var Renderer = /** @class */ (function (_super) {
	    __extends$2(Renderer, _super);
	    /**
	     * @param {object} [options] - The optional renderer parameters.
	     * @param {number} [options.width=800] - The width of the screen.
	     * @param {number} [options.height=600] - The height of the screen.
	     * @param {HTMLCanvasElement} [options.view] - The canvas to use as a view, optional.
	     * @param {boolean} [options.transparent=false] - If the render view is transparent.
	     * @param {boolean} [options.autoDensity=false] - Resizes renderer view in CSS pixels to allow for
	     *   resolutions other than 1.
	     * @param {boolean} [options.antialias=false] - Sets antialias. If not available natively then FXAA
	     *  antialiasing is used.
	     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer.
	     *  The resolution of the renderer retina would be 2.
	     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear
	     *  the canvas or not before the new render pass. If you wish to set this to false, you *must* set
	     *  preserveDrawingBuffer to `true`.
	     * @param {boolean} [options.preserveDrawingBuffer=false] - Enables drawing buffer preservation,
	     *  enable this if you need to call toDataUrl on the WebGL context.
	     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	     *  (shown if not transparent).
	     * @param {string} [options.powerPreference] - Parameter passed to WebGL context, set to "high-performance"
	     *  for devices with dual graphics card.
	     * @param {object} [options.context] - If WebGL context already exists, all parameters must be taken from it.
	     * @public
	     */
	    function Renderer(options) {
	        var _this = _super.call(this, exports.RENDERER_TYPE.WEBGL, options) || this;
	        // the options will have been modified here in the super constructor with pixi's default settings..
	        options = _this.options;
	        /**
	         * WebGL context, set by the contextSystem (this.context)
	         *
	         * @readonly
	         * @member {WebGLRenderingContext}
	         */
	        _this.gl = null;
	        _this.CONTEXT_UID = 0;
	        // TODO legacy!
	        /**
	         * Internal signal instances of **runner**, these
	         * are assigned to each system created.
	         * @see PIXI.Runner
	         * @name PIXI.Renderer#runners
	         * @private
	         * @type {object}
	         * @readonly
	         * @property {PIXI.Runner} destroy - Destroy runner
	         * @property {PIXI.Runner} contextChange - Context change runner
	         * @property {PIXI.Runner} reset - Reset runner
	         * @property {PIXI.Runner} update - Update runner
	         * @property {PIXI.Runner} postrender - Post-render runner
	         * @property {PIXI.Runner} prerender - Pre-render runner
	         * @property {PIXI.Runner} resize - Resize runner
	         */
	        _this.runners = {
	            destroy: new Runner('destroy'),
	            contextChange: new Runner('contextChange'),
	            reset: new Runner('reset'),
	            update: new Runner('update'),
	            postrender: new Runner('postrender'),
	            prerender: new Runner('prerender'),
	            resize: new Runner('resize'),
	        };
	        /**
	         * Global uniforms
	         * @member {PIXI.UniformGroup}
	         */
	        _this.globalUniforms = new UniformGroup({
	            projectionMatrix: new Matrix(),
	        }, true);
	        /**
	         * Mask system instance
	         * @member {PIXI.systems.MaskSystem} mask
	         * @memberof PIXI.Renderer#
	         * @readonly
	         */
	        _this.addSystem(MaskSystem, 'mask')
	            /**
	             * Context system instance
	             * @member {PIXI.systems.ContextSystem} context
	             * @memberof PIXI.Renderer#
	             * @readonly
	             */
	            .addSystem(ContextSystem, 'context')
	            /**
	             * State system instance
	             * @member {PIXI.systems.StateSystem} state
	             * @memberof PIXI.Renderer#
	             * @readonly
	             */
	            .addSystem(StateSystem, 'state')
	            /**
	             * Shader system instance
	             * @member {PIXI.systems.ShaderSystem} shader
	             * @memberof PIXI.Renderer#
	             * @readonly
	             */
	            .addSystem(ShaderSystem, 'shader')
	            /**
	             * Texture system instance
	             * @member {PIXI.systems.TextureSystem} texture
	             * @memberof PIXI.Renderer#
	             * @readonly
	             */
	            .addSystem(TextureSystem, 'texture')
	            /**
	             * Geometry system instance
	             * @member {PIXI.systems.GeometrySystem} geometry
	             * @memberof PIXI.Renderer#
	             * @readonly
	             */
	            .addSystem(GeometrySystem, 'geometry')
	            /**
	             * Framebuffer system instance
	             * @member {PIXI.systems.FramebufferSystem} framebuffer
	             * @memberof PIXI.Renderer#
	             * @readonly
	             */
	            .addSystem(FramebufferSystem, 'framebuffer')
	            /**
	             * Scissor system instance
	             * @member {PIXI.systems.ScissorSystem} scissor
	             * @memberof PIXI.Renderer#
	             * @readonly
	             */
	            .addSystem(ScissorSystem, 'scissor')
	            /**
	             * Stencil system instance
	             * @member {PIXI.systems.StencilSystem} stencil
	             * @memberof PIXI.Renderer#
	             * @readonly
	             */
	            .addSystem(StencilSystem, 'stencil')
	            /**
	             * Projection system instance
	             * @member {PIXI.systems.ProjectionSystem} projection
	             * @memberof PIXI.Renderer#
	             * @readonly
	             */
	            .addSystem(ProjectionSystem, 'projection')
	            /**
	             * Texture garbage collector system instance
	             * @member {PIXI.systems.TextureGCSystem} textureGC
	             * @memberof PIXI.Renderer#
	             * @readonly
	             */
	            .addSystem(TextureGCSystem, 'textureGC')
	            /**
	             * Filter system instance
	             * @member {PIXI.systems.FilterSystem} filter
	             * @memberof PIXI.Renderer#
	             * @readonly
	             */
	            .addSystem(FilterSystem, 'filter')
	            /**
	             * RenderTexture system instance
	             * @member {PIXI.systems.RenderTextureSystem} renderTexture
	             * @memberof PIXI.Renderer#
	             * @readonly
	             */
	            .addSystem(RenderTextureSystem, 'renderTexture')
	            /**
	             * Batch system instance
	             * @member {PIXI.systems.BatchSystem} batch
	             * @memberof PIXI.Renderer#
	             * @readonly
	             */
	            .addSystem(BatchSystem, 'batch');
	        _this.initPlugins(Renderer.__plugins);
	        /**
	         * The options passed in to create a new WebGL context.
	         */
	        if (options.context) {
	            _this.context.initFromContext(options.context);
	        }
	        else {
	            _this.context.initFromOptions({
	                alpha: !!_this.transparent,
	                antialias: options.antialias,
	                premultipliedAlpha: _this.transparent && _this.transparent !== 'notMultiplied',
	                stencil: true,
	                preserveDrawingBuffer: options.preserveDrawingBuffer,
	                powerPreference: _this.options.powerPreference,
	            });
	        }
	        /**
	         * Flag if we are rendering to the screen vs renderTexture
	         * @member {boolean}
	         * @readonly
	         * @default true
	         */
	        _this.renderingToScreen = true;
	        sayHello(_this.context.webGLVersion === 2 ? 'WebGL 2' : 'WebGL 1');
	        _this.resize(_this.options.width, _this.options.height);
	        return _this;
	    }
	    /**
	     * Create renderer if WebGL is available. Overrideable
	     * by the **@pixi/canvas-renderer** package to allow fallback.
	     * throws error if WebGL is not available.
	     * @static
	     * @private
	     */
	    Renderer.create = function (options) {
	        if (isWebGLSupported()) {
	            return new Renderer(options);
	        }
	        throw new Error('WebGL unsupported in this browser, use "pixi.js-legacy" for fallback canvas2d support.');
	    };
	    /**
	     * Add a new system to the renderer.
	     * @param {Function} ClassRef - Class reference
	     * @param {string} [name] - Property name for system, if not specified
	     *        will use a static `name` property on the class itself. This
	     *        name will be assigned as s property on the Renderer so make
	     *        sure it doesn't collide with properties on Renderer.
	     * @return {PIXI.Renderer} Return instance of renderer
	     */
	    Renderer.prototype.addSystem = function (ClassRef, name) {
	        if (!name) {
	            name = ClassRef.name;
	        }
	        var system = new ClassRef(this);
	        if (this[name]) {
	            throw new Error("Whoops! The name \"" + name + "\" is already in use");
	        }
	        this[name] = system;
	        for (var i in this.runners) {
	            this.runners[i].add(system);
	        }
	        /**
	         * Fired after rendering finishes.
	         *
	         * @event PIXI.Renderer#postrender
	         */
	        /**
	         * Fired before rendering starts.
	         *
	         * @event PIXI.Renderer#prerender
	         */
	        /**
	         * Fired when the WebGL context is set.
	         *
	         * @event PIXI.Renderer#context
	         * @param {WebGLRenderingContext} gl - WebGL context.
	         */
	        return this;
	    };
	    /**
	     * Renders the object to its WebGL view
	     *
	     * @param {PIXI.DisplayObject} displayObject - The object to be rendered.
	     * @param {PIXI.RenderTexture} [renderTexture] - The render texture to render to.
	     * @param {boolean} [clear=true] - Should the canvas be cleared before the new render.
	     * @param {PIXI.Matrix} [transform] - A transform to apply to the render texture before rendering.
	     * @param {boolean} [skipUpdateTransform=false] - Should we skip the update transform pass?
	     */
	    Renderer.prototype.render = function (displayObject, renderTexture, clear, transform, skipUpdateTransform) {
	        // can be handy to know!
	        this.renderingToScreen = !renderTexture;
	        this.runners.prerender.emit();
	        this.emit('prerender');
	        // apply a transform at a GPU level
	        this.projection.transform = transform;
	        // no point rendering if our context has been blown up!
	        if (this.context.isLost) {
	            return;
	        }
	        if (!renderTexture) {
	            this._lastObjectRendered = displayObject;
	        }
	        if (!skipUpdateTransform) {
	            // update the scene graph
	            var cacheParent = displayObject.enableTempParent();
	            displayObject.updateTransform();
	            displayObject.disableTempParent(cacheParent);
	            // displayObject.hitArea = //TODO add a temp hit area
	        }
	        this.renderTexture.bind(renderTexture);
	        this.batch.currentRenderer.start();
	        if (clear !== undefined ? clear : this.clearBeforeRender) {
	            this.renderTexture.clear();
	        }
	        displayObject.render(this);
	        // apply transform..
	        this.batch.currentRenderer.flush();
	        if (renderTexture) {
	            renderTexture.baseTexture.update();
	        }
	        this.runners.postrender.emit();
	        // reset transform after render
	        this.projection.transform = null;
	        this.emit('postrender');
	    };
	    /**
	     * Resizes the WebGL view to the specified width and height.
	     *
	     * @param {number} screenWidth - The new width of the screen.
	     * @param {number} screenHeight - The new height of the screen.
	     */
	    Renderer.prototype.resize = function (screenWidth, screenHeight) {
	        _super.prototype.resize.call(this, screenWidth, screenHeight);
	        this.runners.resize.emit(screenWidth, screenHeight);
	    };
	    /**
	     * Resets the WebGL state so you can render things however you fancy!
	     *
	     * @return {PIXI.Renderer} Returns itself.
	     */
	    Renderer.prototype.reset = function () {
	        this.runners.reset.emit();
	        return this;
	    };
	    /**
	     * Clear the frame buffer
	     */
	    Renderer.prototype.clear = function () {
	        this.renderTexture.bind();
	        this.renderTexture.clear();
	    };
	    /**
	     * Removes everything from the renderer (event listeners, spritebatch, etc...)
	     *
	     * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
	     *  See: https://github.com/pixijs/pixi.js/issues/2233
	     */
	    Renderer.prototype.destroy = function (removeView) {
	        this.runners.destroy.emit();
	        for (var r in this.runners) {
	            this.runners[r].destroy();
	        }
	        // call base destroy
	        _super.prototype.destroy.call(this, removeView);
	        // TODO nullify all the managers..
	        this.gl = null;
	    };
	    /**
	     * Adds a plugin to the renderer.
	     *
	     * @method
	     * @param {string} pluginName - The name of the plugin.
	     * @param {Function} ctor - The constructor function or class for the plugin.
	     */
	    Renderer.registerPlugin = function (pluginName, ctor) {
	        Renderer.__plugins = Renderer.__plugins || {};
	        Renderer.__plugins[pluginName] = ctor;
	    };
	    return Renderer;
	}(AbstractRenderer));

	/**
	 * This helper function will automatically detect which renderer you should be using.
	 * WebGL is the preferred renderer as it is a lot faster. If WebGL is not supported by
	 * the browser then this function will return a canvas renderer
	 *
	 * @memberof PIXI
	 * @function autoDetectRenderer
	 * @param {object} [options] - The optional renderer parameters
	 * @param {number} [options.width=800] - the width of the renderers view
	 * @param {number} [options.height=600] - the height of the renderers view
	 * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	 * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	 * @param {boolean} [options.autoDensity=false] - Resizes renderer view in CSS pixels to allow for
	 *   resolutions other than 1
	 * @param {boolean} [options.antialias=false] - sets antialias
	 * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation, enable this if you
	 *  need to call toDataUrl on the webgl context
	 * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	 *  (shown if not transparent).
	 * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	 *   not before the new render pass.
	 * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer, retina would be 2
	 * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present, this
	 *   option only is available when using **pixi.js-legacy** or **@pixi/canvas-renderer** modules, otherwise
	 *   it is ignored.
	 * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
	 *  for devices with dual graphics card **webgl only**
	 * @return {PIXI.Renderer|PIXI.CanvasRenderer} Returns WebGL renderer if available, otherwise CanvasRenderer
	 */
	function autoDetectRenderer(options) {
	    return Renderer.create(options);
	}

	var _default = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}";

	var defaultFilter = "attribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nuniform vec4 inputSize;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aVertexPosition * (outputFrame.zw * inputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n}\n";

	/**
	 * Used by the batcher to draw batches.
	 * Each one of these contains all information required to draw a bound geometry.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var BatchDrawCall = /** @class */ (function () {
	    function BatchDrawCall() {
	        this.texArray = null;
	        this.blend = 0;
	        this.type = exports.DRAW_MODES.TRIANGLES;
	        this.start = 0;
	        this.size = 0;
	        /**
	         * data for uniforms or custom webgl state
	         * @member {object}
	         */
	        this.data = null;
	    }
	    return BatchDrawCall;
	}());

	/**
	 * Used by the batcher to build texture batches.
	 * Holds list of textures and their respective locations.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var BatchTextureArray = /** @class */ (function () {
	    function BatchTextureArray() {
	        /**
	         * inside textures array
	         * @member {PIXI.BaseTexture[]}
	         */
	        this.elements = [];
	        /**
	         * Respective locations for textures
	         * @member {number[]}
	         */
	        this.ids = [];
	        /**
	         * number of filled elements
	         * @member {number}
	         */
	        this.count = 0;
	    }
	    BatchTextureArray.prototype.clear = function () {
	        for (var i = 0; i < this.count; i++) {
	            this.elements[i] = null;
	        }
	        this.count = 0;
	    };
	    return BatchTextureArray;
	}());

	/**
	 * Flexible wrapper around `ArrayBuffer` that also provides
	 * typed array views on demand.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var ViewableBuffer = /** @class */ (function () {
	    /**
	     * @param {number} size - The size of the buffer in bytes.
	     */
	    function ViewableBuffer(size) {
	        /**
	         * Underlying `ArrayBuffer` that holds all the data
	         * and is of capacity `size`.
	         *
	         * @member {ArrayBuffer}
	         */
	        this.rawBinaryData = new ArrayBuffer(size);
	        /**
	         * View on the raw binary data as a `Uint32Array`.
	         *
	         * @member {Uint32Array}
	         */
	        this.uint32View = new Uint32Array(this.rawBinaryData);
	        /**
	         * View on the raw binary data as a `Float32Array`.
	         *
	         * @member {Float32Array}
	         */
	        this.float32View = new Float32Array(this.rawBinaryData);
	    }
	    Object.defineProperty(ViewableBuffer.prototype, "int8View", {
	        /**
	         * View on the raw binary data as a `Int8Array`.
	         *
	         * @member {Int8Array}
	         */
	        get: function () {
	            if (!this._int8View) {
	                this._int8View = new Int8Array(this.rawBinaryData);
	            }
	            return this._int8View;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ViewableBuffer.prototype, "uint8View", {
	        /**
	         * View on the raw binary data as a `Uint8Array`.
	         *
	         * @member {Uint8Array}
	         */
	        get: function () {
	            if (!this._uint8View) {
	                this._uint8View = new Uint8Array(this.rawBinaryData);
	            }
	            return this._uint8View;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ViewableBuffer.prototype, "int16View", {
	        /**
	         * View on the raw binary data as a `Int16Array`.
	         *
	         * @member {Int16Array}
	         */
	        get: function () {
	            if (!this._int16View) {
	                this._int16View = new Int16Array(this.rawBinaryData);
	            }
	            return this._int16View;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ViewableBuffer.prototype, "uint16View", {
	        /**
	         * View on the raw binary data as a `Uint16Array`.
	         *
	         * @member {Uint16Array}
	         */
	        get: function () {
	            if (!this._uint16View) {
	                this._uint16View = new Uint16Array(this.rawBinaryData);
	            }
	            return this._uint16View;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ViewableBuffer.prototype, "int32View", {
	        /**
	         * View on the raw binary data as a `Int32Array`.
	         *
	         * @member {Int32Array}
	         */
	        get: function () {
	            if (!this._int32View) {
	                this._int32View = new Int32Array(this.rawBinaryData);
	            }
	            return this._int32View;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Returns the view of the given type.
	     *
	     * @param {string} type - One of `int8`, `uint8`, `int16`,
	     *    `uint16`, `int32`, `uint32`, and `float32`.
	     * @return {object} typed array of given type
	     */
	    ViewableBuffer.prototype.view = function (type) {
	        return this[type + "View"];
	    };
	    /**
	     * Destroys all buffer references. Do not use after calling
	     * this.
	     */
	    ViewableBuffer.prototype.destroy = function () {
	        this.rawBinaryData = null;
	        this._int8View = null;
	        this._uint8View = null;
	        this._int16View = null;
	        this._uint16View = null;
	        this._int32View = null;
	        this.uint32View = null;
	        this.float32View = null;
	    };
	    ViewableBuffer.sizeOf = function (type) {
	        switch (type) {
	            case 'int8':
	            case 'uint8':
	                return 1;
	            case 'int16':
	            case 'uint16':
	                return 2;
	            case 'int32':
	            case 'uint32':
	            case 'float32':
	                return 4;
	            default:
	                throw new Error(type + " isn't a valid view type");
	        }
	    };
	    return ViewableBuffer;
	}());

	/**
	 * Renderer dedicated to drawing and batching sprites.
	 *
	 * This is the default batch renderer. It buffers objects
	 * with texture-based geometries and renders them in
	 * batches. It uploads multiple textures to the GPU to
	 * reduce to the number of draw calls.
	 *
	 * @class
	 * @protected
	 * @memberof PIXI
	 * @extends PIXI.ObjectRenderer
	 */
	var AbstractBatchRenderer = /** @class */ (function (_super) {
	    __extends$2(AbstractBatchRenderer, _super);
	    /**
	     * This will hook onto the renderer's `contextChange`
	     * and `prerender` signals.
	     *
	     * @param {PIXI.Renderer} renderer - The renderer this works for.
	     */
	    function AbstractBatchRenderer(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        /**
	         * This is used to generate a shader that can
	         * color each vertex based on a `aTextureId`
	         * attribute that points to an texture in `uSampler`.
	         *
	         * This enables the objects with different textures
	         * to be drawn in the same draw call.
	         *
	         * You can customize your shader by creating your
	         * custom shader generator.
	         *
	         * @member {PIXI.BatchShaderGenerator}
	         * @protected
	         */
	        _this.shaderGenerator = null;
	        /**
	         * The class that represents the geometry of objects
	         * that are going to be batched with this.
	         *
	         * @member {object}
	         * @default PIXI.BatchGeometry
	         * @protected
	         */
	        _this.geometryClass = null;
	        /**
	         * Size of data being buffered per vertex in the
	         * attribute buffers (in floats). By default, the
	         * batch-renderer plugin uses 6:
	         *
	         * | aVertexPosition | 2 |
	         * |-----------------|---|
	         * | aTextureCoords  | 2 |
	         * | aColor          | 1 |
	         * | aTextureId      | 1 |
	         *
	         * @member {number}
	         * @readonly
	         */
	        _this.vertexSize = null;
	        /**
	         * The WebGL state in which this renderer will work.
	         *
	         * @member {PIXI.State}
	         * @readonly
	         */
	        _this.state = State.for2d();
	        /**
	         * The number of bufferable objects before a flush
	         * occurs automatically.
	         *
	         * @member {number}
	         * @default settings.SPRITE_BATCH_SIZE * 4
	         */
	        _this.size = settings.SPRITE_BATCH_SIZE * 4;
	        /**
	         * Total count of all vertices used by the currently
	         * buffered objects.
	         *
	         * @member {number}
	         * @private
	         */
	        _this._vertexCount = 0;
	        /**
	         * Total count of all indices used by the currently
	         * buffered objects.
	         *
	         * @member {number}
	         * @private
	         */
	        _this._indexCount = 0;
	        /**
	         * Buffer of objects that are yet to be rendered.
	         *
	         * @member {PIXI.DisplayObject[]}
	         * @private
	         */
	        _this._bufferedElements = [];
	        /**
	         * Data for texture batch builder, helps to save a bit of CPU on a pass.
	         * @type {PIXI.BaseTexture[]}
	         * @private
	         */
	        _this._bufferedTextures = [];
	        /**
	         * Number of elements that are buffered and are
	         * waiting to be flushed.
	         *
	         * @member {number}
	         * @private
	         */
	        _this._bufferSize = 0;
	        /**
	         * This shader is generated by `this.shaderGenerator`.
	         *
	         * It is generated specifically to handle the required
	         * number of textures being batched together.
	         *
	         * @member {PIXI.Shader}
	         * @protected
	         */
	        _this._shader = null;
	        /**
	         * Pool of `this.geometryClass` geometry objects
	         * that store buffers. They are used to pass data
	         * to the shader on each draw call.
	         *
	         * These are never re-allocated again, unless a
	         * context change occurs; however, the pool may
	         * be expanded if required.
	         *
	         * @member {PIXI.Geometry[]}
	         * @private
	         * @see PIXI.AbstractBatchRenderer.contextChange
	         */
	        _this._packedGeometries = [];
	        /**
	         * Size of `this._packedGeometries`. It can be expanded
	         * if more than `this._packedGeometryPoolSize` flushes
	         * occur in a single frame.
	         *
	         * @member {number}
	         * @private
	         */
	        _this._packedGeometryPoolSize = 2;
	        /**
	         * A flush may occur multiple times in a single
	         * frame. On iOS devices or when
	         * `settings.CAN_UPLOAD_SAME_BUFFER` is false, the
	         * batch renderer does not upload data to the same
	         * `WebGLBuffer` for performance reasons.
	         *
	         * This is the index into `packedGeometries` that points to
	         * geometry holding the most recent buffers.
	         *
	         * @member {number}
	         * @private
	         */
	        _this._flushId = 0;
	        /**
	         * Pool of `ViewableBuffer` objects that are sorted in
	         * order of increasing size. The flush method uses
	         * the buffer with the least size above the amount
	         * it requires. These are used for passing attributes.
	         *
	         * The first buffer has a size of 8; each subsequent
	         * buffer has double capacity of its previous.
	         *
	         * @member {PIXI.ViewableBuffer[]}
	         * @private
	         * @see PIXI.AbstractBatchRenderer#getAttributeBuffer
	         */
	        _this._aBuffers = {};
	        /**
	         * Pool of `Uint16Array` objects that are sorted in
	         * order of increasing size. The flush method uses
	         * the buffer with the least size above the amount
	         * it requires. These are used for passing indices.
	         *
	         * The first buffer has a size of 12; each subsequent
	         * buffer has double capacity of its previous.
	         *
	         * @member {Uint16Array[]}
	         * @private
	         * @see PIXI.AbstractBatchRenderer#getIndexBuffer
	         */
	        _this._iBuffers = {};
	        /**
	         * Maximum number of textures that can be uploaded to
	         * the GPU under the current context. It is initialized
	         * properly in `this.contextChange`.
	         *
	         * @member {number}
	         * @see PIXI.AbstractBatchRenderer#contextChange
	         * @readonly
	         */
	        _this.MAX_TEXTURES = 1;
	        _this.renderer.on('prerender', _this.onPrerender, _this);
	        renderer.runners.contextChange.add(_this);
	        _this._dcIndex = 0;
	        _this._aIndex = 0;
	        _this._iIndex = 0;
	        _this._attributeBuffer = null;
	        _this._indexBuffer = null;
	        _this._tempBoundTextures = [];
	        return _this;
	    }
	    /**
	     * Handles the `contextChange` signal.
	     *
	     * It calculates `this.MAX_TEXTURES` and allocating the
	     * packed-geometry object pool.
	     */
	    AbstractBatchRenderer.prototype.contextChange = function () {
	        var gl = this.renderer.gl;
	        if (settings.PREFER_ENV === exports.ENV.WEBGL_LEGACY) {
	            this.MAX_TEXTURES = 1;
	        }
	        else {
	            // step 1: first check max textures the GPU can handle.
	            this.MAX_TEXTURES = Math.min(gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS), settings.SPRITE_MAX_TEXTURES);
	            // step 2: check the maximum number of if statements the shader can have too..
	            this.MAX_TEXTURES = checkMaxIfStatementsInShader(this.MAX_TEXTURES, gl);
	        }
	        this._shader = this.shaderGenerator.generateShader(this.MAX_TEXTURES);
	        // we use the second shader as the first one depending on your browser
	        // may omit aTextureId as it is not used by the shader so is optimized out.
	        for (var i = 0; i < this._packedGeometryPoolSize; i++) {
	            /* eslint-disable max-len */
	            this._packedGeometries[i] = new (this.geometryClass)();
	        }
	        this.initFlushBuffers();
	    };
	    /**
	     * Makes sure that static and dynamic flush pooled objects have correct dimensions
	     */
	    AbstractBatchRenderer.prototype.initFlushBuffers = function () {
	        var _drawCallPool = AbstractBatchRenderer._drawCallPool, _textureArrayPool = AbstractBatchRenderer._textureArrayPool;
	        // max draw calls
	        var MAX_SPRITES = this.size / 4;
	        // max texture arrays
	        var MAX_TA = Math.floor(MAX_SPRITES / this.MAX_TEXTURES) + 1;
	        while (_drawCallPool.length < MAX_SPRITES) {
	            _drawCallPool.push(new BatchDrawCall());
	        }
	        while (_textureArrayPool.length < MAX_TA) {
	            _textureArrayPool.push(new BatchTextureArray());
	        }
	        for (var i = 0; i < this.MAX_TEXTURES; i++) {
	            this._tempBoundTextures[i] = null;
	        }
	    };
	    /**
	     * Handles the `prerender` signal.
	     *
	     * It ensures that flushes start from the first geometry
	     * object again.
	     */
	    AbstractBatchRenderer.prototype.onPrerender = function () {
	        this._flushId = 0;
	    };
	    /**
	     * Buffers the "batchable" object. It need not be rendered
	     * immediately.
	     *
	     * @param {PIXI.DisplayObject} element - the element to render when
	     *    using this renderer
	     */
	    AbstractBatchRenderer.prototype.render = function (element) {
	        if (!element._texture.valid) {
	            return;
	        }
	        if (this._vertexCount + (element.vertexData.length / 2) > this.size) {
	            this.flush();
	        }
	        this._vertexCount += element.vertexData.length / 2;
	        this._indexCount += element.indices.length;
	        this._bufferedTextures[this._bufferSize] = element._texture.baseTexture;
	        this._bufferedElements[this._bufferSize++] = element;
	    };
	    AbstractBatchRenderer.prototype.buildTexturesAndDrawCalls = function () {
	        var _a = this, textures = _a._bufferedTextures, MAX_TEXTURES = _a.MAX_TEXTURES;
	        var textureArrays = AbstractBatchRenderer._textureArrayPool;
	        var batch = this.renderer.batch;
	        var boundTextures = this._tempBoundTextures;
	        var touch = this.renderer.textureGC.count;
	        var TICK = ++BaseTexture._globalBatch;
	        var countTexArrays = 0;
	        var texArray = textureArrays[0];
	        var start = 0;
	        batch.copyBoundTextures(boundTextures, MAX_TEXTURES);
	        for (var i = 0; i < this._bufferSize; ++i) {
	            var tex = textures[i];
	            textures[i] = null;
	            if (tex._batchEnabled === TICK) {
	                continue;
	            }
	            if (texArray.count >= MAX_TEXTURES) {
	                batch.boundArray(texArray, boundTextures, TICK, MAX_TEXTURES);
	                this.buildDrawCalls(texArray, start, i);
	                start = i;
	                texArray = textureArrays[++countTexArrays];
	                ++TICK;
	            }
	            tex._batchEnabled = TICK;
	            tex.touched = touch;
	            texArray.elements[texArray.count++] = tex;
	        }
	        if (texArray.count > 0) {
	            batch.boundArray(texArray, boundTextures, TICK, MAX_TEXTURES);
	            this.buildDrawCalls(texArray, start, this._bufferSize);
	            ++countTexArrays;
	            ++TICK;
	        }
	        // Clean-up
	        for (var i = 0; i < boundTextures.length; i++) {
	            boundTextures[i] = null;
	        }
	        BaseTexture._globalBatch = TICK;
	    };
	    /**
	     * Populating drawcalls for rendering
	     *
	     * @param {PIXI.BatchTextureArray} texArray
	     * @param {number} start
	     * @param {number} finish
	     */
	    AbstractBatchRenderer.prototype.buildDrawCalls = function (texArray, start, finish) {
	        var _a = this, elements = _a._bufferedElements, _attributeBuffer = _a._attributeBuffer, _indexBuffer = _a._indexBuffer, vertexSize = _a.vertexSize;
	        var drawCalls = AbstractBatchRenderer._drawCallPool;
	        var dcIndex = this._dcIndex;
	        var aIndex = this._aIndex;
	        var iIndex = this._iIndex;
	        var drawCall = drawCalls[dcIndex];
	        drawCall.start = this._iIndex;
	        drawCall.texArray = texArray;
	        for (var i = start; i < finish; ++i) {
	            var sprite = elements[i];
	            var tex = sprite._texture.baseTexture;
	            var spriteBlendMode = premultiplyBlendMode[tex.alphaMode ? 1 : 0][sprite.blendMode];
	            elements[i] = null;
	            if (start < i && drawCall.blend !== spriteBlendMode) {
	                drawCall.size = iIndex - drawCall.start;
	                start = i;
	                drawCall = drawCalls[++dcIndex];
	                drawCall.texArray = texArray;
	                drawCall.start = iIndex;
	            }
	            this.packInterleavedGeometry(sprite, _attributeBuffer, _indexBuffer, aIndex, iIndex);
	            aIndex += sprite.vertexData.length / 2 * vertexSize;
	            iIndex += sprite.indices.length;
	            drawCall.blend = spriteBlendMode;
	        }
	        if (start < finish) {
	            drawCall.size = iIndex - drawCall.start;
	            ++dcIndex;
	        }
	        this._dcIndex = dcIndex;
	        this._aIndex = aIndex;
	        this._iIndex = iIndex;
	    };
	    /**
	     * Bind textures for current rendering
	     *
	     * @param {PIXI.BatchTextureArray} texArray
	     */
	    AbstractBatchRenderer.prototype.bindAndClearTexArray = function (texArray) {
	        var textureSystem = this.renderer.texture;
	        for (var j = 0; j < texArray.count; j++) {
	            textureSystem.bind(texArray.elements[j], texArray.ids[j]);
	            texArray.elements[j] = null;
	        }
	        texArray.count = 0;
	    };
	    AbstractBatchRenderer.prototype.updateGeometry = function () {
	        var _a = this, packedGeometries = _a._packedGeometries, attributeBuffer = _a._attributeBuffer, indexBuffer = _a._indexBuffer;
	        if (!settings.CAN_UPLOAD_SAME_BUFFER) { /* Usually on iOS devices, where the browser doesn't
	            like uploads to the same buffer in a single frame. */
	            if (this._packedGeometryPoolSize <= this._flushId) {
	                this._packedGeometryPoolSize++;
	                packedGeometries[this._flushId] = new (this.geometryClass)();
	            }
	            packedGeometries[this._flushId]._buffer.update(attributeBuffer.rawBinaryData);
	            packedGeometries[this._flushId]._indexBuffer.update(indexBuffer);
	            this.renderer.geometry.bind(packedGeometries[this._flushId]);
	            this.renderer.geometry.updateBuffers();
	            this._flushId++;
	        }
	        else {
	            // lets use the faster option, always use buffer number 0
	            packedGeometries[this._flushId]._buffer.update(attributeBuffer.rawBinaryData);
	            packedGeometries[this._flushId]._indexBuffer.update(indexBuffer);
	            this.renderer.geometry.updateBuffers();
	        }
	    };
	    AbstractBatchRenderer.prototype.drawBatches = function () {
	        var dcCount = this._dcIndex;
	        var _a = this.renderer, gl = _a.gl, stateSystem = _a.state;
	        var drawCalls = AbstractBatchRenderer._drawCallPool;
	        var curTexArray = null;
	        // Upload textures and do the draw calls
	        for (var i = 0; i < dcCount; i++) {
	            var _b = drawCalls[i], texArray = _b.texArray, type = _b.type, size = _b.size, start = _b.start, blend = _b.blend;
	            if (curTexArray !== texArray) {
	                curTexArray = texArray;
	                this.bindAndClearTexArray(texArray);
	            }
	            this.state.blendMode = blend;
	            stateSystem.set(this.state);
	            gl.drawElements(type, size, gl.UNSIGNED_SHORT, start * 2);
	        }
	    };
	    /**
	     * Renders the content _now_ and empties the current batch.
	     */
	    AbstractBatchRenderer.prototype.flush = function () {
	        if (this._vertexCount === 0) {
	            return;
	        }
	        this._attributeBuffer = this.getAttributeBuffer(this._vertexCount);
	        this._indexBuffer = this.getIndexBuffer(this._indexCount);
	        this._aIndex = 0;
	        this._iIndex = 0;
	        this._dcIndex = 0;
	        this.buildTexturesAndDrawCalls();
	        this.updateGeometry();
	        this.drawBatches();
	        // reset elements buffer for the next flush
	        this._bufferSize = 0;
	        this._vertexCount = 0;
	        this._indexCount = 0;
	    };
	    /**
	     * Starts a new sprite batch.
	     */
	    AbstractBatchRenderer.prototype.start = function () {
	        this.renderer.state.set(this.state);
	        this.renderer.shader.bind(this._shader);
	        if (settings.CAN_UPLOAD_SAME_BUFFER) {
	            // bind buffer #0, we don't need others
	            this.renderer.geometry.bind(this._packedGeometries[this._flushId]);
	        }
	    };
	    /**
	     * Stops and flushes the current batch.
	     */
	    AbstractBatchRenderer.prototype.stop = function () {
	        this.flush();
	    };
	    /**
	     * Destroys this `AbstractBatchRenderer`. It cannot be used again.
	     */
	    AbstractBatchRenderer.prototype.destroy = function () {
	        for (var i = 0; i < this._packedGeometryPoolSize; i++) {
	            if (this._packedGeometries[i]) {
	                this._packedGeometries[i].destroy();
	            }
	        }
	        this.renderer.off('prerender', this.onPrerender, this);
	        this._aBuffers = null;
	        this._iBuffers = null;
	        this._packedGeometries = null;
	        this._attributeBuffer = null;
	        this._indexBuffer = null;
	        if (this._shader) {
	            this._shader.destroy();
	            this._shader = null;
	        }
	        _super.prototype.destroy.call(this);
	    };
	    /**
	     * Fetches an attribute buffer from `this._aBuffers` that
	     * can hold atleast `size` floats.
	     *
	     * @param {number} size - minimum capacity required
	     * @return {ViewableBuffer} - buffer than can hold atleast `size` floats
	     * @private
	     */
	    AbstractBatchRenderer.prototype.getAttributeBuffer = function (size) {
	        // 8 vertices is enough for 2 quads
	        var roundedP2 = nextPow2(Math.ceil(size / 8));
	        var roundedSizeIndex = log2(roundedP2);
	        var roundedSize = roundedP2 * 8;
	        if (this._aBuffers.length <= roundedSizeIndex) {
	            this._iBuffers.length = roundedSizeIndex + 1;
	        }
	        var buffer = this._aBuffers[roundedSize];
	        if (!buffer) {
	            this._aBuffers[roundedSize] = buffer = new ViewableBuffer(roundedSize * this.vertexSize * 4);
	        }
	        return buffer;
	    };
	    /**
	     * Fetches an index buffer from `this._iBuffers` that can
	     * have at least `size` capacity.
	     *
	     * @param {number} size - minimum required capacity
	     * @return {Uint16Array} - buffer that can fit `size`
	     *    indices.
	     * @private
	     */
	    AbstractBatchRenderer.prototype.getIndexBuffer = function (size) {
	        // 12 indices is enough for 2 quads
	        var roundedP2 = nextPow2(Math.ceil(size / 12));
	        var roundedSizeIndex = log2(roundedP2);
	        var roundedSize = roundedP2 * 12;
	        if (this._iBuffers.length <= roundedSizeIndex) {
	            this._iBuffers.length = roundedSizeIndex + 1;
	        }
	        var buffer = this._iBuffers[roundedSizeIndex];
	        if (!buffer) {
	            this._iBuffers[roundedSizeIndex] = buffer = new Uint16Array(roundedSize);
	        }
	        return buffer;
	    };
	    /**
	     * Takes the four batching parameters of `element`, interleaves
	     * and pushes them into the batching attribute/index buffers given.
	     *
	     * It uses these properties: `vertexData` `uvs`, `textureId` and
	     * `indicies`. It also uses the "tint" of the base-texture, if
	     * present.
	     *
	     * @param {PIXI.Sprite} element - element being rendered
	     * @param {PIXI.ViewableBuffer} attributeBuffer - attribute buffer.
	     * @param {Uint16Array} indexBuffer - index buffer
	     * @param {number} aIndex - number of floats already in the attribute buffer
	     * @param {number} iIndex - number of indices already in `indexBuffer`
	     */
	    AbstractBatchRenderer.prototype.packInterleavedGeometry = function (element, attributeBuffer, indexBuffer, aIndex, iIndex) {
	        var uint32View = attributeBuffer.uint32View, float32View = attributeBuffer.float32View;
	        var packedVertices = aIndex / this.vertexSize;
	        var uvs = element.uvs;
	        var indicies = element.indices;
	        var vertexData = element.vertexData;
	        var textureId = element._texture.baseTexture._batchLocation;
	        var alpha = Math.min(element.worldAlpha, 1.0);
	        var argb = (alpha < 1.0
	            && element._texture.baseTexture.alphaMode)
	            ? premultiplyTint(element._tintRGB, alpha)
	            : element._tintRGB + (alpha * 255 << 24);
	        // lets not worry about tint! for now..
	        for (var i = 0; i < vertexData.length; i += 2) {
	            float32View[aIndex++] = vertexData[i];
	            float32View[aIndex++] = vertexData[i + 1];
	            float32View[aIndex++] = uvs[i];
	            float32View[aIndex++] = uvs[i + 1];
	            uint32View[aIndex++] = argb;
	            float32View[aIndex++] = textureId;
	        }
	        for (var i = 0; i < indicies.length; i++) {
	            indexBuffer[iIndex++] = packedVertices + indicies[i];
	        }
	    };
	    /**
	     * Pool of `BatchDrawCall` objects that `flush` used
	     * to create "batches" of the objects being rendered.
	     *
	     * These are never re-allocated again.
	     * Shared between all batch renderers because it can be only one "flush" working at the moment.
	     *
	     * @static
	     * @member {PIXI.BatchDrawCall[]}
	     */
	    AbstractBatchRenderer._drawCallPool = [];
	    /**
	     * Pool of `BatchDrawCall` objects that `flush` used
	     * to create "batches" of the objects being rendered.
	     *
	     * These are never re-allocated again.
	     * Shared between all batch renderers because it can be only one "flush" working at the moment.
	     *
	     * @static
	     * @member {PIXI.BatchTextureArray[]}
	     */
	    AbstractBatchRenderer._textureArrayPool = [];
	    return AbstractBatchRenderer;
	}(ObjectRenderer));

	/**
	 * Helper that generates batching multi-texture shader. Use it with your new BatchRenderer
	 *
	 * @class
	 * @memberof PIXI
	 */
	var BatchShaderGenerator = /** @class */ (function () {
	    /**
	     * @param {string} vertexSrc - Vertex shader
	     * @param {string} fragTemplate - Fragment shader template
	     */
	    function BatchShaderGenerator(vertexSrc, fragTemplate) {
	        /**
	         * Reference to the vertex shader source.
	         *
	         * @member {string}
	         */
	        this.vertexSrc = vertexSrc;
	        /**
	         * Reference to the fragement shader template. Must contain "%count%" and "%forloop%".
	         *
	         * @member {string}
	         */
	        this.fragTemplate = fragTemplate;
	        this.programCache = {};
	        this.defaultGroupCache = {};
	        if (fragTemplate.indexOf('%count%') < 0) {
	            throw new Error('Fragment template must contain "%count%".');
	        }
	        if (fragTemplate.indexOf('%forloop%') < 0) {
	            throw new Error('Fragment template must contain "%forloop%".');
	        }
	    }
	    BatchShaderGenerator.prototype.generateShader = function (maxTextures) {
	        if (!this.programCache[maxTextures]) {
	            var sampleValues = new Int32Array(maxTextures);
	            for (var i = 0; i < maxTextures; i++) {
	                sampleValues[i] = i;
	            }
	            this.defaultGroupCache[maxTextures] = UniformGroup.from({ uSamplers: sampleValues }, true);
	            var fragmentSrc = this.fragTemplate;
	            fragmentSrc = fragmentSrc.replace(/%count%/gi, "" + maxTextures);
	            fragmentSrc = fragmentSrc.replace(/%forloop%/gi, this.generateSampleSrc(maxTextures));
	            this.programCache[maxTextures] = new Program(this.vertexSrc, fragmentSrc);
	        }
	        var uniforms = {
	            tint: new Float32Array([1, 1, 1, 1]),
	            translationMatrix: new Matrix(),
	            default: this.defaultGroupCache[maxTextures],
	        };
	        return new Shader(this.programCache[maxTextures], uniforms);
	    };
	    BatchShaderGenerator.prototype.generateSampleSrc = function (maxTextures) {
	        var src = '';
	        src += '\n';
	        src += '\n';
	        for (var i = 0; i < maxTextures; i++) {
	            if (i > 0) {
	                src += '\nelse ';
	            }
	            if (i < maxTextures - 1) {
	                src += "if(vTextureId < " + i + ".5)";
	            }
	            src += '\n{';
	            src += "\n\tcolor = texture2D(uSamplers[" + i + "], vTextureCoord);";
	            src += '\n}';
	        }
	        src += '\n';
	        src += '\n';
	        return src;
	    };
	    return BatchShaderGenerator;
	}());

	/**
	 * Geometry used to batch standard PIXI content (e.g. Mesh, Sprite, Graphics objects).
	 *
	 * @class
	 * @memberof PIXI
	 */
	var BatchGeometry = /** @class */ (function (_super) {
	    __extends$2(BatchGeometry, _super);
	    /**
	     * @param {boolean} [_static=false] - Optimization flag, where `false`
	     *        is updated every frame, `true` doesn't change frame-to-frame.
	     */
	    function BatchGeometry(_static) {
	        if (_static === void 0) { _static = false; }
	        var _this = _super.call(this) || this;
	        /**
	         * Buffer used for position, color, texture IDs
	         *
	         * @member {PIXI.Buffer}
	         * @protected
	         */
	        _this._buffer = new Buffer(null, _static, false);
	        /**
	         * Index buffer data
	         *
	         * @member {PIXI.Buffer}
	         * @protected
	         */
	        _this._indexBuffer = new Buffer(null, _static, true);
	        _this.addAttribute('aVertexPosition', _this._buffer, 2, false, exports.TYPES.FLOAT)
	            .addAttribute('aTextureCoord', _this._buffer, 2, false, exports.TYPES.FLOAT)
	            .addAttribute('aColor', _this._buffer, 4, true, exports.TYPES.UNSIGNED_BYTE)
	            .addAttribute('aTextureId', _this._buffer, 1, true, exports.TYPES.FLOAT)
	            .addIndex(_this._indexBuffer);
	        return _this;
	    }
	    return BatchGeometry;
	}(Geometry));

	var defaultVertex$2 = "precision highp float;\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\nattribute float aTextureId;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform vec4 tint;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying float vTextureId;\n\nvoid main(void){\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vTextureId = aTextureId;\n    vColor = aColor * tint;\n}\n";

	var defaultFragment$2 = "varying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying float vTextureId;\nuniform sampler2D uSamplers[%count%];\n\nvoid main(void){\n    vec4 color;\n    %forloop%\n    gl_FragColor = color * vColor;\n}\n";

	/**
	 * @class
	 * @memberof PIXI
	 * @hideconstructor
	 */
	var BatchPluginFactory = /** @class */ (function () {
	    function BatchPluginFactory() {
	    }
	    /**
	     * Create a new BatchRenderer plugin for Renderer. this convenience can provide an easy way
	     * to extend BatchRenderer with all the necessary pieces.
	     * @example
	     * const fragment = `
	     * varying vec2 vTextureCoord;
	     * varying vec4 vColor;
	     * varying float vTextureId;
	     * uniform sampler2D uSamplers[%count%];
	     *
	     * void main(void){
	     *     vec4 color;
	     *     %forloop%
	     *     gl_FragColor = vColor * vec4(color.a - color.rgb, color.a);
	     * }
	     * `;
	     * const InvertBatchRenderer = PIXI.BatchPluginFactory.create({ fragment });
	     * PIXI.Renderer.registerPlugin('invert', InvertBatchRenderer);
	     * const sprite = new PIXI.Sprite();
	     * sprite.pluginName = 'invert';
	     *
	     * @static
	     * @param {object} [options]
	     * @param {string} [options.vertex=PIXI.BatchPluginFactory.defaultVertexSrc] - Vertex shader source
	     * @param {string} [options.fragment=PIXI.BatchPluginFactory.defaultFragmentTemplate] - Fragment shader template
	     * @param {number} [options.vertexSize=6] - Vertex size
	     * @param {object} [options.geometryClass=PIXI.BatchGeometry]
	     * @return {*} New batch renderer plugin
	     */
	    BatchPluginFactory.create = function (options) {
	        var _a = Object.assign({
	            vertex: defaultVertex$2,
	            fragment: defaultFragment$2,
	            geometryClass: BatchGeometry,
	            vertexSize: 6,
	        }, options), vertex = _a.vertex, fragment = _a.fragment, vertexSize = _a.vertexSize, geometryClass = _a.geometryClass;
	        return /** @class */ (function (_super) {
	            __extends$2(BatchPlugin, _super);
	            function BatchPlugin(renderer) {
	                var _this = _super.call(this, renderer) || this;
	                _this.shaderGenerator = new BatchShaderGenerator(vertex, fragment);
	                _this.geometryClass = geometryClass;
	                _this.vertexSize = vertexSize;
	                return _this;
	            }
	            return BatchPlugin;
	        }(AbstractBatchRenderer));
	    };
	    Object.defineProperty(BatchPluginFactory, "defaultVertexSrc", {
	        /**
	         * The default vertex shader source
	         *
	         * @static
	         * @type {string}
	         * @constant
	         */
	        get: function () {
	            return defaultVertex$2;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BatchPluginFactory, "defaultFragmentTemplate", {
	        /**
	         * The default fragment shader source
	         *
	         * @static
	         * @type {string}
	         * @constant
	         */
	        get: function () {
	            return defaultFragment$2;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return BatchPluginFactory;
	}());
	// Setup the default BatchRenderer plugin, this is what
	// we'll actually export at the root level
	var BatchRenderer = BatchPluginFactory.create();

	/*!
	 * @pixi/app - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/app is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * Convenience class to create a new PIXI application.
	 *
	 * This class automatically creates the renderer, ticker and root container.
	 *
	 * @example
	 * // Create the application
	 * const app = new PIXI.Application();
	 *
	 * // Add the view to the DOM
	 * document.body.appendChild(app.view);
	 *
	 * // ex, add display objects
	 * app.stage.addChild(PIXI.Sprite.from('something.png'));
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Application = /** @class */ (function () {
	    /**
	     * @param {object} [options] - The optional renderer parameters.
	     * @param {boolean} [options.autoStart=true] - Automatically starts the rendering after the construction.
	     *     **Note**: Setting this parameter to false does NOT stop the shared ticker even if you set
	     *     options.sharedTicker to true in case that it is already started. Stop it by your own.
	     * @param {number} [options.width=800] - The width of the renderers view.
	     * @param {number} [options.height=600] - The height of the renderers view.
	     * @param {HTMLCanvasElement} [options.view] - The canvas to use as a view, optional.
	     * @param {boolean} [options.transparent=false] - If the render view is transparent.
	     * @param {boolean} [options.autoDensity=false] - Resizes renderer view in CSS pixels to allow for
	     *   resolutions other than 1.
	     * @param {boolean} [options.antialias=false] - Sets antialias
	     * @param {boolean} [options.preserveDrawingBuffer=false] - Enables drawing buffer preservation, enable this if you
	     *  need to call toDataUrl on the WebGL context.
	     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer, retina would be 2.
	     * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present, this
	     *   option only is available when using **pixi.js-legacy** or **@pixi/canvas-renderer** modules, otherwise
	     *   it is ignored.
	     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	     *  (shown if not transparent).
	     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	     *   not before the new render pass.
	     * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
	     *  for devices with dual graphics card. **(WebGL only)**.
	     * @param {boolean} [options.sharedTicker=false] - `true` to use PIXI.Ticker.shared, `false` to create new ticker.
	     *  If set to false, you cannot register a handler to occur before anything that runs on the shared ticker.
	     *  The system ticker will always run before both the shared ticker and the app ticker.
	     * @param {boolean} [options.sharedLoader=false] - `true` to use PIXI.Loader.shared, `false` to create new Loader.
	     * @param {Window|HTMLElement} [options.resizeTo] - Element to automatically resize stage to.
	     */
	    function Application(options) {
	        var _this = this;
	        // The default options
	        options = Object.assign({
	            forceCanvas: false,
	        }, options);
	        /**
	         * WebGL renderer if available, otherwise CanvasRenderer.
	         * @member {PIXI.Renderer|PIXI.CanvasRenderer}
	         */
	        this.renderer = autoDetectRenderer(options);
	        /**
	         * The root display container that's rendered.
	         * @member {PIXI.Container}
	         */
	        this.stage = new Container();
	        // install plugins here
	        Application._plugins.forEach(function (plugin) {
	            plugin.init.call(_this, options);
	        });
	    }
	    /**
	     * Register a middleware plugin for the application
	     * @static
	     * @param {PIXI.Application.Plugin} plugin - Plugin being installed
	     */
	    Application.registerPlugin = function (plugin) {
	        Application._plugins.push(plugin);
	    };
	    /**
	     * Render the current stage.
	     */
	    Application.prototype.render = function () {
	        // TODO: Since CanvasRenderer has not been converted this function thinks it takes DisplayObject & PIXI.DisplayObject
	        // This can be fixed when CanvasRenderer is converted.
	        this.renderer.render(this.stage);
	    };
	    Object.defineProperty(Application.prototype, "view", {
	        /**
	         * Reference to the renderer's canvas element.
	         * @member {HTMLCanvasElement}
	         * @readonly
	         */
	        get: function () {
	            return this.renderer.view;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Application.prototype, "screen", {
	        /**
	         * Reference to the renderer's screen rectangle. Its safe to use as `filterArea` or `hitArea` for the whole screen.
	         * @member {PIXI.Rectangle}
	         * @readonly
	         */
	        get: function () {
	            return this.renderer.screen;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Destroy and don't use after this.
	     * @param {Boolean} [removeView=false] - Automatically remove canvas from DOM.
	     * @param {object|boolean} [stageOptions] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [stageOptions.children=false] - if set to true, all the children will have their destroy
	     *  method called as well. 'stageOptions' will be passed on to those calls.
	     * @param {boolean} [stageOptions.texture=false] - Only used for child Sprites if stageOptions.children is set
	     *  to true. Should it destroy the texture of the child sprite
	     * @param {boolean} [stageOptions.baseTexture=false] - Only used for child Sprites if stageOptions.children is set
	     *  to true. Should it destroy the base texture of the child sprite
	     */
	    Application.prototype.destroy = function (removeView, stageOptions) {
	        var _this = this;
	        // Destroy plugins in the opposite order
	        // which they were constructed
	        var plugins = Application._plugins.slice(0);
	        plugins.reverse();
	        plugins.forEach(function (plugin) {
	            plugin.destroy.call(_this);
	        });
	        this.stage.destroy(stageOptions);
	        this.stage = null;
	        this.renderer.destroy(removeView);
	        this.renderer = null;
	    };
	    return Application;
	}());
	/**
	 * @memberof PIXI.Application
	 * @typedef {object} Plugin
	 * @property {function} init - Called when Application is constructed, scoped to Application instance.
	 *  Passes in `options` as the only argument, which are Application constructor options.
	 * @property {function} destroy - Called when destroying Application, scoped to Application instance
	 */
	/**
	 * Collection of installed plugins.
	 * @static
	 * @private
	 * @type {PIXI.Application.Plugin[]}
	 */
	Application._plugins = [];

	/**
	 * Middleware for for Application's resize functionality
	 * @private
	 * @class
	 */
	var ResizePlugin = /** @class */ (function () {
	    function ResizePlugin() {
	    }
	    /**
	     * Initialize the plugin with scope of application instance
	     * @static
	     * @private
	     * @param {object} [options] - See application options
	     */
	    ResizePlugin.init = function (options) {
	        var _this = this;
	        /**
	         * The HTML element or window to automatically resize the
	         * renderer's view element to match width and height.
	         * @type {Window|HTMLElement}
	         * @name resizeTo
	         * @memberof PIXI.Application#
	         */
	        Object.defineProperty(this, 'resizeTo', {
	            set: function (dom) {
	                window.removeEventListener('resize', this.queueResize);
	                this._resizeTo = dom;
	                if (dom) {
	                    window.addEventListener('resize', this.queueResize);
	                    this.resize();
	                }
	            },
	            get: function () {
	                return this._resizeTo;
	            },
	        });
	        /**
	         * Resize is throttled, so it's
	         * safe to call this multiple times per frame and it'll
	         * only be called once.
	         * @method PIXI.Application#queueResize
	         */
	        this.queueResize = function () {
	            if (!_this._resizeTo) {
	                return;
	            }
	            _this.cancelResize();
	            // // Throttle resize events per raf
	            _this._resizeId = requestAnimationFrame(function () { return _this.resize(); });
	        };
	        /**
	         * Cancel the resize queue.
	         * @method PIXI.Application#cancelResize
	         * @private
	         */
	        this.cancelResize = function () {
	            if (_this._resizeId) {
	                cancelAnimationFrame(_this._resizeId);
	                _this._resizeId = null;
	            }
	        };
	        /**
	         * Execute an immediate resize on the renderer, this is not
	         * throttled and can be expensive to call many times in a row.
	         * Will resize only if `resizeTo` property is set.
	         * @method PIXI.Application#resize
	         */
	        this.resize = function () {
	            if (!_this._resizeTo) {
	                return;
	            }
	            // clear queue resize
	            _this.cancelResize();
	            var width;
	            var height;
	            // Resize to the window
	            if (_this._resizeTo === window) {
	                width = window.innerWidth;
	                height = window.innerHeight;
	            }
	            // Resize to other HTML entities
	            else {
	                var _a = _this._resizeTo, clientWidth = _a.clientWidth, clientHeight = _a.clientHeight;
	                width = clientWidth;
	                height = clientHeight;
	            }
	            _this.renderer.resize(width, height);
	        };
	        // On resize
	        this._resizeId = null;
	        this._resizeTo = null;
	        this.resizeTo = options.resizeTo || null;
	    };
	    /**
	     * Clean up the ticker, scoped to application
	     * @static
	     * @private
	     */
	    ResizePlugin.destroy = function () {
	        window.removeEventListener('resize', this.queueResize);
	        this.cancelResize();
	        this.cancelResize = null;
	        this.queueResize = null;
	        this.resizeTo = null;
	        this.resize = null;
	    };
	    return ResizePlugin;
	}());

	Application.registerPlugin(ResizePlugin);

	/*!
	 * @pixi/extract - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/extract is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	var TEMP_RECT = new Rectangle();
	var BYTES_PER_PIXEL = 4;
	/**
	 * This class provides renderer-specific plugins for exporting content from a renderer.
	 * For instance, these plugins can be used for saving an Image, Canvas element or for exporting the raw image data (pixels).
	 *
	 * Do not instantiate these plugins directly. It is available from the `renderer.plugins` property.
	 * See {@link PIXI.CanvasRenderer#plugins} or {@link PIXI.Renderer#plugins}.
	 * @example
	 * // Create a new app (will auto-add extract plugin to renderer)
	 * const app = new PIXI.Application();
	 *
	 * // Draw a red circle
	 * const graphics = new PIXI.Graphics()
	 *     .beginFill(0xFF0000)
	 *     .drawCircle(0, 0, 50);
	 *
	 * // Render the graphics as an HTMLImageElement
	 * const image = app.renderer.plugins.extract.image(graphics);
	 * document.body.appendChild(image);
	 * @class
	 * @memberof PIXI
	 */
	var Extract = /** @class */ (function () {
	    /**
	     * @param {PIXI.Renderer} renderer - A reference to the current renderer
	     */
	    function Extract(renderer) {
	        this.renderer = renderer;
	        /**
	         * Collection of methods for extracting data (image, pixels, etc.) from a display object or render texture
	         *
	         * @member {PIXI.Extract} extract
	         * @memberof PIXI.Renderer#
	         * @see PIXI.Extract
	         */
	        renderer.extract = this;
	    }
	    /**
	     * Will return a HTML Image of the target
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use the main renderer
	     * @param {string} [format] - Image format, e.g. "image/jpeg" or "image/webp".
	     * @param {number} [quality] - JPEG or Webp compression from 0 to 1. Default is 0.92.
	     * @return {HTMLImageElement} HTML Image of the target
	     */
	    Extract.prototype.image = function (target, format, quality) {
	        var image = new Image();
	        image.src = this.base64(target, format, quality);
	        return image;
	    };
	    /**
	     * Will return a a base64 encoded string of this target. It works by calling
	     *  `Extract.getCanvas` and then running toDataURL on that.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use the main renderer
	     * @param {string} [format] - Image format, e.g. "image/jpeg" or "image/webp".
	     * @param {number} [quality] - JPEG or Webp compression from 0 to 1. Default is 0.92.
	     * @return {string} A base64 encoded string of the texture.
	     */
	    Extract.prototype.base64 = function (target, format, quality) {
	        return this.canvas(target).toDataURL(format, quality);
	    };
	    /**
	     * Creates a Canvas element, renders this target to it and then returns it.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use the main renderer
	     * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
	     */
	    Extract.prototype.canvas = function (target) {
	        var renderer = this.renderer;
	        var resolution;
	        var frame;
	        var flipY = false;
	        var renderTexture;
	        var generated = false;
	        if (target) {
	            if (target instanceof RenderTexture) {
	                renderTexture = target;
	            }
	            else {
	                renderTexture = this.renderer.generateTexture(target);
	                generated = true;
	            }
	        }
	        if (renderTexture) {
	            resolution = renderTexture.baseTexture.resolution;
	            frame = renderTexture.frame;
	            flipY = false;
	            renderer.renderTexture.bind(renderTexture);
	        }
	        else {
	            resolution = this.renderer.resolution;
	            flipY = true;
	            frame = TEMP_RECT;
	            frame.width = this.renderer.width;
	            frame.height = this.renderer.height;
	            renderer.renderTexture.bind(null);
	        }
	        var width = Math.floor((frame.width * resolution) + 1e-4);
	        var height = Math.floor((frame.height * resolution) + 1e-4);
	        var canvasBuffer = new CanvasRenderTarget(width, height, 1);
	        var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);
	        // read pixels to the array
	        var gl = renderer.gl;
	        gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
	        // add the pixels to the canvas
	        var canvasData = canvasBuffer.context.getImageData(0, 0, width, height);
	        Extract.arrayPostDivide(webglPixels, canvasData.data);
	        canvasBuffer.context.putImageData(canvasData, 0, 0);
	        // pulling pixels
	        if (flipY) {
	            var target_1 = new CanvasRenderTarget(canvasBuffer.width, canvasBuffer.height, 1);
	            target_1.context.scale(1, -1);
	            // we can't render to itself because we should be empty before render.
	            target_1.context.drawImage(canvasBuffer.canvas, 0, -height);
	            canvasBuffer.destroy();
	            canvasBuffer = target_1;
	        }
	        if (generated) {
	            renderTexture.destroy(true);
	        }
	        // send the canvas back..
	        return canvasBuffer.canvas;
	    };
	    /**
	     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
	     * order, with integer values between 0 and 255 (included).
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use the main renderer
	     * @return {Uint8Array} One-dimensional array containing the pixel data of the entire texture
	     */
	    Extract.prototype.pixels = function (target) {
	        var renderer = this.renderer;
	        var resolution;
	        var frame;
	        var renderTexture;
	        var generated = false;
	        if (target) {
	            if (target instanceof RenderTexture) {
	                renderTexture = target;
	            }
	            else {
	                renderTexture = this.renderer.generateTexture(target);
	                generated = true;
	            }
	        }
	        if (renderTexture) {
	            resolution = renderTexture.baseTexture.resolution;
	            frame = renderTexture.frame;
	            // bind the buffer
	            renderer.renderTexture.bind(renderTexture);
	        }
	        else {
	            resolution = renderer.resolution;
	            frame = TEMP_RECT;
	            frame.width = renderer.width;
	            frame.height = renderer.height;
	            renderer.renderTexture.bind(null);
	        }
	        var width = frame.width * resolution;
	        var height = frame.height * resolution;
	        var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);
	        // read pixels to the array
	        var gl = renderer.gl;
	        gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
	        if (generated) {
	            renderTexture.destroy(true);
	        }
	        Extract.arrayPostDivide(webglPixels, webglPixels);
	        return webglPixels;
	    };
	    /**
	     * Destroys the extract
	     *
	     */
	    Extract.prototype.destroy = function () {
	        this.renderer.extract = null;
	        this.renderer = null;
	    };
	    /**
	     * Takes premultiplied pixel data and produces regular pixel data
	     *
	     * @private
	     * @param pixels {number[] | Uint8Array | Uint8ClampedArray} array of pixel data
	     * @param out {number[] | Uint8Array | Uint8ClampedArray} output array
	     */
	    Extract.arrayPostDivide = function (pixels, out) {
	        for (var i = 0; i < pixels.length; i += 4) {
	            var alpha = out[i + 3] = pixels[i + 3];
	            if (alpha !== 0) {
	                out[i] = Math.round(Math.min(pixels[i] * 255.0 / alpha, 255.0));
	                out[i + 1] = Math.round(Math.min(pixels[i + 1] * 255.0 / alpha, 255.0));
	                out[i + 2] = Math.round(Math.min(pixels[i + 2] * 255.0 / alpha, 255.0));
	            }
	            else {
	                out[i] = pixels[i];
	                out[i + 1] = pixels[i + 1];
	                out[i + 2] = pixels[i + 2];
	            }
	        }
	    };
	    return Extract;
	}());

	'use strict';

	function parseURI (str, opts) {
	  if (!str) { return undefined }

	  opts = opts || {};

	  var o = {
	    key: [
	      'source',
	      'protocol',
	      'authority',
	      'userInfo',
	      'user',
	      'password',
	      'host',
	      'port',
	      'relative',
	      'path',
	      'directory',
	      'file',
	      'query',
	      'anchor'
	    ],
	    q: {
	      name: 'queryKey',
	      parser: /(?:^|&)([^&=]*)=?([^&]*)/g
	    },
	    parser: {
	      strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
	      loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
	    }
	  };

	  var m = o.parser[opts.strictMode ? 'strict' : 'loose'].exec(str);
	  var uri = {};
	  var i = 14;

	  while (i--) { uri[o.key[i]] = m[i] || ''; }

	  uri[o.q.name] = {};
	  uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
	    if ($1) { uri[o.q.name][$1] = $2; }
	  });

	  return uri
	}

	var parseUri = parseURI;

	var miniSignals = createCommonjsModule(function (module, exports) {
	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) { descriptor.writable = true; } Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) { defineProperties(Constructor.prototype, protoProps); } if (staticProps) { defineProperties(Constructor, staticProps); } return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var MiniSignalBinding = (function () {
	  function MiniSignalBinding(fn, once, thisArg) {
	    if (once === undefined) { once = false; }

	    _classCallCheck(this, MiniSignalBinding);

	    this._fn = fn;
	    this._once = once;
	    this._thisArg = thisArg;
	    this._next = this._prev = this._owner = null;
	  }

	  _createClass(MiniSignalBinding, [{
	    key: 'detach',
	    value: function detach() {
	      if (this._owner === null) { return false; }
	      this._owner.detach(this);
	      return true;
	    }
	  }]);

	  return MiniSignalBinding;
	})();

	function _addMiniSignalBinding(self, node) {
	  if (!self._head) {
	    self._head = node;
	    self._tail = node;
	  } else {
	    self._tail._next = node;
	    node._prev = self._tail;
	    self._tail = node;
	  }

	  node._owner = self;

	  return node;
	}

	var MiniSignal = (function () {
	  function MiniSignal() {
	    _classCallCheck(this, MiniSignal);

	    this._head = this._tail = undefined;
	  }

	  _createClass(MiniSignal, [{
	    key: 'handlers',
	    value: function handlers() {
	      var exists = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

	      var node = this._head;

	      if (exists) { return !!node; }

	      var ee = [];

	      while (node) {
	        ee.push(node);
	        node = node._next;
	      }

	      return ee;
	    }
	  }, {
	    key: 'has',
	    value: function has(node) {
	      if (!(node instanceof MiniSignalBinding)) {
	        throw new Error('MiniSignal#has(): First arg must be a MiniSignalBinding object.');
	      }

	      return node._owner === this;
	    }
	  }, {
	    key: 'dispatch',
	    value: function dispatch() {
	      var arguments$1 = arguments;

	      var node = this._head;

	      if (!node) { return false; }

	      while (node) {
	        if (node._once) { this.detach(node); }
	        node._fn.apply(node._thisArg, arguments$1);
	        node = node._next;
	      }

	      return true;
	    }
	  }, {
	    key: 'add',
	    value: function add(fn) {
	      var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

	      if (typeof fn !== 'function') {
	        throw new Error('MiniSignal#add(): First arg must be a Function.');
	      }
	      return _addMiniSignalBinding(this, new MiniSignalBinding(fn, false, thisArg));
	    }
	  }, {
	    key: 'once',
	    value: function once(fn) {
	      var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

	      if (typeof fn !== 'function') {
	        throw new Error('MiniSignal#once(): First arg must be a Function.');
	      }
	      return _addMiniSignalBinding(this, new MiniSignalBinding(fn, true, thisArg));
	    }
	  }, {
	    key: 'detach',
	    value: function detach(node) {
	      if (!(node instanceof MiniSignalBinding)) {
	        throw new Error('MiniSignal#detach(): First arg must be a MiniSignalBinding object.');
	      }
	      if (node._owner !== this) { return this; }

	      if (node._prev) { node._prev._next = node._next; }
	      if (node._next) { node._next._prev = node._prev; }

	      if (node === this._head) {
	        this._head = node._next;
	        if (node._next === null) {
	          this._tail = null;
	        }
	      } else if (node === this._tail) {
	        this._tail = node._prev;
	        this._tail._next = null;
	      }

	      node._owner = null;
	      return this;
	    }
	  }, {
	    key: 'detachAll',
	    value: function detachAll() {
	      var node = this._head;
	      if (!node) { return this; }

	      this._head = this._tail = null;

	      while (node) {
	        node._owner = null;
	        node = node._next;
	      }
	      return this;
	    }
	  }]);

	  return MiniSignal;
	})();

	MiniSignal.MiniSignalBinding = MiniSignalBinding;

	exports['default'] = MiniSignal;
	module.exports = exports['default'];
	});

	var Signal = unwrapExports(miniSignals);

	/*!
	 * resource-loader - v3.0.1
	 * https://github.com/pixijs/pixi-sound
	 * Compiled Tue, 02 Jul 2019 14:06:18 UTC
	 *
	 * resource-loader is licensed under the MIT license.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * Smaller version of the async library constructs.
	 *
	 * @namespace async
	 */

	/**
	 * Noop function
	 *
	 * @ignore
	 * @function
	 * @memberof async
	 */
	function _noop() {}
	/* empty */

	/**
	 * Iterates an array in series.
	 *
	 * @memberof async
	 * @function eachSeries
	 * @param {Array.<*>} array - Array to iterate.
	 * @param {function} iterator - Function to call for each element.
	 * @param {function} callback - Function to call when done, or on error.
	 * @param {boolean} [deferNext=false] - Break synchronous each loop by calling next with a setTimeout of 1.
	 */


	function eachSeries(array, iterator, callback, deferNext) {
	  var i = 0;
	  var len = array.length;

	  (function next(err) {
	    if (err || i === len) {
	      if (callback) {
	        callback(err);
	      }

	      return;
	    }

	    if (deferNext) {
	      setTimeout(function () {
	        iterator(array[i++], next);
	      }, 1);
	    } else {
	      iterator(array[i++], next);
	    }
	  })();
	}
	/**
	 * Ensures a function is only called once.
	 *
	 * @ignore
	 * @memberof async
	 * @param {function} fn - The function to wrap.
	 * @return {function} The wrapping function.
	 */

	function onlyOnce(fn) {
	  return function onceWrapper() {
	    if (fn === null) {
	      throw new Error('Callback was already called.');
	    }

	    var callFn = fn;
	    fn = null;
	    callFn.apply(this, arguments);
	  };
	}
	/**
	 * Async queue implementation,
	 *
	 * @memberof async
	 * @function queue
	 * @param {function} worker - The worker function to call for each task.
	 * @param {number} concurrency - How many workers to run in parrallel.
	 * @return {*} The async queue object.
	 */


	function queue(worker, concurrency) {
	  if (concurrency == null) {
	    // eslint-disable-line no-eq-null,eqeqeq
	    concurrency = 1;
	  } else if (concurrency === 0) {
	    throw new Error('Concurrency must not be zero');
	  }

	  var workers = 0;
	  var q = {
	    _tasks: [],
	    concurrency: concurrency,
	    saturated: _noop,
	    unsaturated: _noop,
	    buffer: concurrency / 4,
	    empty: _noop,
	    drain: _noop,
	    error: _noop,
	    started: false,
	    paused: false,
	    push: function push(data, callback) {
	      _insert(data, false, callback);
	    },
	    kill: function kill() {
	      workers = 0;
	      q.drain = _noop;
	      q.started = false;
	      q._tasks = [];
	    },
	    unshift: function unshift(data, callback) {
	      _insert(data, true, callback);
	    },
	    process: function process() {
	      while (!q.paused && workers < q.concurrency && q._tasks.length) {
	        var task = q._tasks.shift();

	        if (q._tasks.length === 0) {
	          q.empty();
	        }

	        workers += 1;

	        if (workers === q.concurrency) {
	          q.saturated();
	        }

	        worker(task.data, onlyOnce(_next(task)));
	      }
	    },
	    length: function length() {
	      return q._tasks.length;
	    },
	    running: function running() {
	      return workers;
	    },
	    idle: function idle() {
	      return q._tasks.length + workers === 0;
	    },
	    pause: function pause() {
	      if (q.paused === true) {
	        return;
	      }

	      q.paused = true;
	    },
	    resume: function resume() {
	      if (q.paused === false) {
	        return;
	      }

	      q.paused = false; // Need to call q.process once per concurrent
	      // worker to preserve full concurrency after pause

	      for (var w = 1; w <= q.concurrency; w++) {
	        q.process();
	      }
	    }
	  };

	  function _insert(data, insertAtFront, callback) {
	    if (callback != null && typeof callback !== 'function') {
	      // eslint-disable-line no-eq-null,eqeqeq
	      throw new Error('task callback must be a function');
	    }

	    q.started = true;

	    if (data == null && q.idle()) {
	      // eslint-disable-line no-eq-null,eqeqeq
	      // call drain immediately if there are no tasks
	      setTimeout(function () {
	        return q.drain();
	      }, 1);
	      return;
	    }

	    var item = {
	      data: data,
	      callback: typeof callback === 'function' ? callback : _noop
	    };

	    if (insertAtFront) {
	      q._tasks.unshift(item);
	    } else {
	      q._tasks.push(item);
	    }

	    setTimeout(function () {
	      return q.process();
	    }, 1);
	  }

	  function _next(task) {
	    return function next() {
	      workers -= 1;
	      task.callback.apply(task, arguments);

	      if (arguments[0] != null) {
	        // eslint-disable-line no-eq-null,eqeqeq
	        q.error(arguments[0], task.data);
	      }

	      if (workers <= q.concurrency - q.buffer) {
	        q.unsaturated();
	      }

	      if (q.idle()) {
	        q.drain();
	      }

	      q.process();
	    };
	  }

	  return q;
	}

	var async = ({
	    eachSeries: eachSeries,
	    queue: queue
	});

	// a simple in-memory cache for resources
	var cache = {};
	/**
	 * A simple in-memory cache for resource.
	 *
	 * @memberof middleware
	 * @function caching
	 * @example
	 * import { Loader, middleware } from 'resource-loader';
	 * const loader = new Loader();
	 * loader.use(middleware.caching);
	 * @param {Resource} resource - Current Resource
	 * @param {function} next - Callback when complete
	 */

	function caching(resource, next) {
	  var _this = this;

	  // if cached, then set data and complete the resource
	  if (cache[resource.url]) {
	    resource.data = cache[resource.url];
	    resource.complete(); // marks resource load complete and stops processing before middlewares
	  } // if not cached, wait for complete and store it in the cache.
	  else {
	      resource.onComplete.once(function () {
	        return cache[_this.url] = _this.data;
	      });
	    }

	  next();
	}

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) { descriptor.writable = true; }
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) { _defineProperties(Constructor.prototype, protoProps); }
	  if (staticProps) { _defineProperties(Constructor, staticProps); }
	  return Constructor;
	}

	var useXdr = !!(window.XDomainRequest && !('withCredentials' in new XMLHttpRequest()));
	var tempAnchor$1 = null; // some status constants

	var STATUS_NONE = 0;
	var STATUS_OK = 200;
	var STATUS_EMPTY = 204;
	var STATUS_IE_BUG_EMPTY = 1223;
	var STATUS_TYPE_OK = 2; // noop

	function _noop$1() {}
	/* empty */

	/**
	 * Manages the state and loading of a resource and all child resources.
	 *
	 * @class
	 */


	var Resource$1 =
	/*#__PURE__*/
	function () {
	  /**
	   * Sets the load type to be used for a specific extension.
	   *
	   * @static
	   * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
	   * @param {Resource.LOAD_TYPE} loadType - The load type to set it to.
	   */
	  Resource.setExtensionLoadType = function setExtensionLoadType(extname, loadType) {
	    setExtMap(Resource._loadTypeMap, extname, loadType);
	  }
	  /**
	   * Sets the load type to be used for a specific extension.
	   *
	   * @static
	   * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
	   * @param {Resource.XHR_RESPONSE_TYPE} xhrType - The xhr type to set it to.
	   */
	  ;

	  Resource.setExtensionXhrType = function setExtensionXhrType(extname, xhrType) {
	    setExtMap(Resource._xhrTypeMap, extname, xhrType);
	  }
	  /**
	   * @param {string} name - The name of the resource to load.
	   * @param {string|string[]} url - The url for this resource, for audio/video loads you can pass
	   *      an array of sources.
	   * @param {object} [options] - The options for the load.
	   * @param {string|boolean} [options.crossOrigin] - Is this request cross-origin? Default is to
	   *      determine automatically.
	   * @param {number} [options.timeout=0] - A timeout in milliseconds for the load. If the load takes
	   *      longer than this time it is cancelled and the load is considered a failure. If this value is
	   *      set to `0` then there is no explicit timeout.
	   * @param {Resource.LOAD_TYPE} [options.loadType=Resource.LOAD_TYPE.XHR] - How should this resource
	   *      be loaded?
	   * @param {Resource.XHR_RESPONSE_TYPE} [options.xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] - How
	   *      should the data being loaded be interpreted when using XHR?
	   * @param {Resource.IMetadata} [options.metadata] - Extra configuration for middleware and the Resource object.
	   */
	  ;

	  function Resource(name, url, options) {
	    if (typeof name !== 'string' || typeof url !== 'string') {
	      throw new Error('Both name and url are required for constructing a resource.');
	    }

	    options = options || {};
	    /**
	     * The state flags of this resource.
	     *
	     * @private
	     * @member {number}
	     */

	    this._flags = 0; // set data url flag, needs to be set early for some _determineX checks to work.

	    this._setFlag(Resource.STATUS_FLAGS.DATA_URL, url.indexOf('data:') === 0);
	    /**
	     * The name of this resource.
	     *
	     * @readonly
	     * @member {string}
	     */


	    this.name = name;
	    /**
	     * The url used to load this resource.
	     *
	     * @readonly
	     * @member {string}
	     */

	    this.url = url;
	    /**
	     * The extension used to load this resource.
	     *
	     * @readonly
	     * @member {string}
	     */

	    this.extension = this._getExtension();
	    /**
	     * The data that was loaded by the resource.
	     *
	     * @member {any}
	     */

	    this.data = null;
	    /**
	     * Is this request cross-origin? If unset, determined automatically.
	     *
	     * @member {string}
	     */

	    this.crossOrigin = options.crossOrigin === true ? 'anonymous' : options.crossOrigin;
	    /**
	     * A timeout in milliseconds for the load. If the load takes longer than this time
	     * it is cancelled and the load is considered a failure. If this value is set to `0`
	     * then there is no explicit timeout.
	     *
	     * @member {number}
	     */

	    this.timeout = options.timeout || 0;
	    /**
	     * The method of loading to use for this resource.
	     *
	     * @member {Resource.LOAD_TYPE}
	     */

	    this.loadType = options.loadType || this._determineLoadType();
	    /**
	     * The type used to load the resource via XHR. If unset, determined automatically.
	     *
	     * @member {string}
	     */

	    this.xhrType = options.xhrType;
	    /**
	     * Extra info for middleware, and controlling specifics about how the resource loads.
	     *
	     * Note that if you pass in a `loadElement`, the Resource class takes ownership of it.
	     * Meaning it will modify it as it sees fit.
	     *
	     * @member {Resource.IMetadata}
	     */

	    this.metadata = options.metadata || {};
	    /**
	     * The error that occurred while loading (if any).
	     *
	     * @readonly
	     * @member {Error}
	     */

	    this.error = null;
	    /**
	     * The XHR object that was used to load this resource. This is only set
	     * when `loadType` is `Resource.LOAD_TYPE.XHR`.
	     *
	     * @readonly
	     * @member {XMLHttpRequest}
	     */

	    this.xhr = null;
	    /**
	     * The child resources this resource owns.
	     *
	     * @readonly
	     * @member {Resource[]}
	     */

	    this.children = [];
	    /**
	     * The resource type.
	     *
	     * @readonly
	     * @member {Resource.TYPE}
	     */

	    this.type = Resource.TYPE.UNKNOWN;
	    /**
	     * The progress chunk owned by this resource.
	     *
	     * @readonly
	     * @member {number}
	     */

	    this.progressChunk = 0;
	    /**
	     * The `dequeue` method that will be used a storage place for the async queue dequeue method
	     * used privately by the loader.
	     *
	     * @private
	     * @member {function}
	     */

	    this._dequeue = _noop$1;
	    /**
	     * Used a storage place for the on load binding used privately by the loader.
	     *
	     * @private
	     * @member {function}
	     */

	    this._onLoadBinding = null;
	    /**
	     * The timer for element loads to check if they timeout.
	     *
	     * @private
	     * @member {number}
	     */

	    this._elementTimer = 0;
	    /**
	     * The `complete` function bound to this resource's context.
	     *
	     * @private
	     * @member {function}
	     */

	    this._boundComplete = this.complete.bind(this);
	    /**
	     * The `_onError` function bound to this resource's context.
	     *
	     * @private
	     * @member {function}
	     */

	    this._boundOnError = this._onError.bind(this);
	    /**
	     * The `_onProgress` function bound to this resource's context.
	     *
	     * @private
	     * @member {function}
	     */

	    this._boundOnProgress = this._onProgress.bind(this);
	    /**
	     * The `_onTimeout` function bound to this resource's context.
	     *
	     * @private
	     * @member {function}
	     */

	    this._boundOnTimeout = this._onTimeout.bind(this); // xhr callbacks

	    this._boundXhrOnError = this._xhrOnError.bind(this);
	    this._boundXhrOnTimeout = this._xhrOnTimeout.bind(this);
	    this._boundXhrOnAbort = this._xhrOnAbort.bind(this);
	    this._boundXhrOnLoad = this._xhrOnLoad.bind(this);
	    /**
	     * Dispatched when the resource beings to load.
	     *
	     * The callback looks like {@link Resource.OnStartSignal}.
	     *
	     * @member {Signal<Resource.OnStartSignal>}
	     */

	    this.onStart = new Signal();
	    /**
	     * Dispatched each time progress of this resource load updates.
	     * Not all resources types and loader systems can support this event
	     * so sometimes it may not be available. If the resource
	     * is being loaded on a modern browser, using XHR, and the remote server
	     * properly sets Content-Length headers, then this will be available.
	     *
	     * The callback looks like {@link Resource.OnProgressSignal}.
	     *
	     * @member {Signal<Resource.OnProgressSignal>}
	     */

	    this.onProgress = new Signal();
	    /**
	     * Dispatched once this resource has loaded, if there was an error it will
	     * be in the `error` property.
	     *
	     * The callback looks like {@link Resource.OnCompleteSignal}.
	     *
	     * @member {Signal<Resource.OnCompleteSignal>}
	     */

	    this.onComplete = new Signal();
	    /**
	     * Dispatched after this resource has had all the *after* middleware run on it.
	     *
	     * The callback looks like {@link Resource.OnCompleteSignal}.
	     *
	     * @member {Signal<Resource.OnCompleteSignal>}
	     */

	    this.onAfterMiddleware = new Signal();
	  }
	  /**
	   * When the resource starts to load.
	   *
	   * @memberof Resource
	   * @callback OnStartSignal
	   * @param {Resource} resource - The resource that the event happened on.
	   */

	  /**
	   * When the resource reports loading progress.
	   *
	   * @memberof Resource
	   * @callback OnProgressSignal
	   * @param {Resource} resource - The resource that the event happened on.
	   * @param {number} percentage - The progress of the load in the range [0, 1].
	   */

	  /**
	   * When the resource finishes loading.
	   *
	   * @memberof Resource
	   * @callback OnCompleteSignal
	   * @param {Resource} resource - The resource that the event happened on.
	   */

	  /**
	   * @memberof Resource
	   * @typedef {object} IMetadata
	   * @property {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [loadElement=null] - The
	   *      element to use for loading, instead of creating one.
	   * @property {boolean} [skipSource=false] - Skips adding source(s) to the load element. This
	   *      is useful if you want to pass in a `loadElement` that you already added load sources to.
	   * @property {string|string[]} [mimeType] - The mime type to use for the source element
	   *      of a video/audio elment. If the urls are an array, you can pass this as an array as well
	   *      where each index is the mime type to use for the corresponding url index.
	   */

	  /**
	   * Stores whether or not this url is a data url.
	   *
	   * @readonly
	   * @member {boolean}
	   */


	  var _proto = Resource.prototype;

	  /**
	   * Marks the resource as complete.
	   *
	   */
	  _proto.complete = function complete() {
	    this._clearEvents();

	    this._finish();
	  }
	  /**
	   * Aborts the loading of this resource, with an optional message.
	   *
	   * @param {string} message - The message to use for the error
	   */
	  ;

	  _proto.abort = function abort(message) {
	    // abort can be called multiple times, ignore subsequent calls.
	    if (this.error) {
	      return;
	    } // store error


	    this.error = new Error(message); // clear events before calling aborts

	    this._clearEvents(); // abort the actual loading


	    if (this.xhr) {
	      this.xhr.abort();
	    } else if (this.xdr) {
	      this.xdr.abort();
	    } else if (this.data) {
	      // single source
	      if (this.data.src) {
	        this.data.src = Resource.EMPTY_GIF;
	      } // multi-source
	      else {
	          while (this.data.firstChild) {
	            this.data.removeChild(this.data.firstChild);
	          }
	        }
	    } // done now.


	    this._finish();
	  }
	  /**
	   * Kicks off loading of this resource. This method is asynchronous.
	   *
	   * @param {Resource.OnCompleteSignal} [cb] - Optional callback to call once the resource is loaded.
	   */
	  ;

	  _proto.load = function load(cb) {
	    var _this = this;

	    if (this.isLoading) {
	      return;
	    }

	    if (this.isComplete) {
	      if (cb) {
	        setTimeout(function () {
	          return cb(_this);
	        }, 1);
	      }

	      return;
	    } else if (cb) {
	      this.onComplete.once(cb);
	    }

	    this._setFlag(Resource.STATUS_FLAGS.LOADING, true);

	    this.onStart.dispatch(this); // if unset, determine the value

	    if (this.crossOrigin === false || typeof this.crossOrigin !== 'string') {
	      this.crossOrigin = this._determineCrossOrigin(this.url);
	    }

	    switch (this.loadType) {
	      case Resource.LOAD_TYPE.IMAGE:
	        this.type = Resource.TYPE.IMAGE;

	        this._loadElement('image');

	        break;

	      case Resource.LOAD_TYPE.AUDIO:
	        this.type = Resource.TYPE.AUDIO;

	        this._loadSourceElement('audio');

	        break;

	      case Resource.LOAD_TYPE.VIDEO:
	        this.type = Resource.TYPE.VIDEO;

	        this._loadSourceElement('video');

	        break;

	      case Resource.LOAD_TYPE.XHR:
	      /* falls through */

	      default:
	        if (useXdr && this.crossOrigin) {
	          this._loadXdr();
	        } else {
	          this._loadXhr();
	        }

	        break;
	    }
	  }
	  /**
	   * Checks if the flag is set.
	   *
	   * @private
	   * @param {number} flag - The flag to check.
	   * @return {boolean} True if the flag is set.
	   */
	  ;

	  _proto._hasFlag = function _hasFlag(flag) {
	    return (this._flags & flag) !== 0;
	  }
	  /**
	   * (Un)Sets the flag.
	   *
	   * @private
	   * @param {number} flag - The flag to (un)set.
	   * @param {boolean} value - Whether to set or (un)set the flag.
	   */
	  ;

	  _proto._setFlag = function _setFlag(flag, value) {
	    this._flags = value ? this._flags | flag : this._flags & ~flag;
	  }
	  /**
	   * Clears all the events from the underlying loading source.
	   *
	   * @private
	   */
	  ;

	  _proto._clearEvents = function _clearEvents() {
	    clearTimeout(this._elementTimer);

	    if (this.data && this.data.removeEventListener) {
	      this.data.removeEventListener('error', this._boundOnError, false);
	      this.data.removeEventListener('load', this._boundComplete, false);
	      this.data.removeEventListener('progress', this._boundOnProgress, false);
	      this.data.removeEventListener('canplaythrough', this._boundComplete, false);
	    }

	    if (this.xhr) {
	      if (this.xhr.removeEventListener) {
	        this.xhr.removeEventListener('error', this._boundXhrOnError, false);
	        this.xhr.removeEventListener('timeout', this._boundXhrOnTimeout, false);
	        this.xhr.removeEventListener('abort', this._boundXhrOnAbort, false);
	        this.xhr.removeEventListener('progress', this._boundOnProgress, false);
	        this.xhr.removeEventListener('load', this._boundXhrOnLoad, false);
	      } else {
	        this.xhr.onerror = null;
	        this.xhr.ontimeout = null;
	        this.xhr.onprogress = null;
	        this.xhr.onload = null;
	      }
	    }
	  }
	  /**
	   * Finalizes the load.
	   *
	   * @private
	   */
	  ;

	  _proto._finish = function _finish() {
	    if (this.isComplete) {
	      throw new Error('Complete called again for an already completed resource.');
	    }

	    this._setFlag(Resource.STATUS_FLAGS.COMPLETE, true);

	    this._setFlag(Resource.STATUS_FLAGS.LOADING, false);

	    this.onComplete.dispatch(this);
	  }
	  /**
	   * Loads this resources using an element that has a single source,
	   * like an HTMLImageElement.
	   *
	   * @private
	   * @param {string} type - The type of element to use.
	   */
	  ;

	  _proto._loadElement = function _loadElement(type) {
	    if (this.metadata.loadElement) {
	      this.data = this.metadata.loadElement;
	    } else if (type === 'image' && typeof window.Image !== 'undefined') {
	      this.data = new Image();
	    } else {
	      this.data = document.createElement(type);
	    }

	    if (this.crossOrigin) {
	      this.data.crossOrigin = this.crossOrigin;
	    }

	    if (!this.metadata.skipSource) {
	      this.data.src = this.url;
	    }

	    this.data.addEventListener('error', this._boundOnError, false);
	    this.data.addEventListener('load', this._boundComplete, false);
	    this.data.addEventListener('progress', this._boundOnProgress, false);

	    if (this.timeout) {
	      this._elementTimer = setTimeout(this._boundOnTimeout, this.timeout);
	    }
	  }
	  /**
	   * Loads this resources using an element that has multiple sources,
	   * like an HTMLAudioElement or HTMLVideoElement.
	   *
	   * @private
	   * @param {string} type - The type of element to use.
	   */
	  ;

	  _proto._loadSourceElement = function _loadSourceElement(type) {
	    if (this.metadata.loadElement) {
	      this.data = this.metadata.loadElement;
	    } else if (type === 'audio' && typeof window.Audio !== 'undefined') {
	      this.data = new Audio();
	    } else {
	      this.data = document.createElement(type);
	    }

	    if (this.data === null) {
	      this.abort("Unsupported element: " + type);
	      return;
	    }

	    if (this.crossOrigin) {
	      this.data.crossOrigin = this.crossOrigin;
	    }

	    if (!this.metadata.skipSource) {
	      // support for CocoonJS Canvas+ runtime, lacks document.createElement('source')
	      if (navigator.isCocoonJS) {
	        this.data.src = Array.isArray(this.url) ? this.url[0] : this.url;
	      } else if (Array.isArray(this.url)) {
	        var mimeTypes = this.metadata.mimeType;

	        for (var i = 0; i < this.url.length; ++i) {
	          this.data.appendChild(this._createSource(type, this.url[i], Array.isArray(mimeTypes) ? mimeTypes[i] : mimeTypes));
	        }
	      } else {
	        var _mimeTypes = this.metadata.mimeType;
	        this.data.appendChild(this._createSource(type, this.url, Array.isArray(_mimeTypes) ? _mimeTypes[0] : _mimeTypes));
	      }
	    }

	    this.data.addEventListener('error', this._boundOnError, false);
	    this.data.addEventListener('load', this._boundComplete, false);
	    this.data.addEventListener('progress', this._boundOnProgress, false);
	    this.data.addEventListener('canplaythrough', this._boundComplete, false);
	    this.data.load();

	    if (this.timeout) {
	      this._elementTimer = setTimeout(this._boundOnTimeout, this.timeout);
	    }
	  }
	  /**
	   * Loads this resources using an XMLHttpRequest.
	   *
	   * @private
	   */
	  ;

	  _proto._loadXhr = function _loadXhr() {
	    // if unset, determine the value
	    if (typeof this.xhrType !== 'string') {
	      this.xhrType = this._determineXhrType();
	    }

	    var xhr = this.xhr = new XMLHttpRequest(); // set the request type and url

	    xhr.open('GET', this.url, true);
	    xhr.timeout = this.timeout; // load json as text and parse it ourselves. We do this because some browsers
	    // *cough* safari *cough* can't deal with it.

	    if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON || this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
	      xhr.responseType = Resource.XHR_RESPONSE_TYPE.TEXT;
	    } else {
	      xhr.responseType = this.xhrType;
	    }

	    xhr.addEventListener('error', this._boundXhrOnError, false);
	    xhr.addEventListener('timeout', this._boundXhrOnTimeout, false);
	    xhr.addEventListener('abort', this._boundXhrOnAbort, false);
	    xhr.addEventListener('progress', this._boundOnProgress, false);
	    xhr.addEventListener('load', this._boundXhrOnLoad, false);
	    xhr.send();
	  }
	  /**
	   * Loads this resources using an XDomainRequest. This is here because we need to support IE9 (gross).
	   *
	   * @private
	   */
	  ;

	  _proto._loadXdr = function _loadXdr() {
	    // if unset, determine the value
	    if (typeof this.xhrType !== 'string') {
	      this.xhrType = this._determineXhrType();
	    }

	    var xdr = this.xhr = new XDomainRequest(); // eslint-disable-line no-undef
	    // XDomainRequest has a few quirks. Occasionally it will abort requests
	    // A way to avoid this is to make sure ALL callbacks are set even if not used
	    // More info here: http://stackoverflow.com/questions/15786966/xdomainrequest-aborts-post-on-ie-9

	    xdr.timeout = this.timeout || 5000; // XDR needs a timeout value or it breaks in IE9

	    xdr.onerror = this._boundXhrOnError;
	    xdr.ontimeout = this._boundXhrOnTimeout;
	    xdr.onprogress = this._boundOnProgress;
	    xdr.onload = this._boundXhrOnLoad;
	    xdr.open('GET', this.url, true); // Note: The xdr.send() call is wrapped in a timeout to prevent an
	    // issue with the interface where some requests are lost if multiple
	    // XDomainRequests are being sent at the same time.
	    // Some info here: https://github.com/photonstorm/phaser/issues/1248

	    setTimeout(function () {
	      return xdr.send();
	    }, 1);
	  }
	  /**
	   * Creates a source used in loading via an element.
	   *
	   * @private
	   * @param {string} type - The element type (video or audio).
	   * @param {string} url - The source URL to load from.
	   * @param {string} [mime] - The mime type of the video
	   * @return {HTMLSourceElement} The source element.
	   */
	  ;

	  _proto._createSource = function _createSource(type, url, mime) {
	    if (!mime) {
	      mime = type + "/" + this._getExtension(url);
	    }

	    var source = document.createElement('source');
	    source.src = url;
	    source.type = mime;
	    return source;
	  }
	  /**
	   * Called if a load errors out.
	   *
	   * @param {Event} event - The error event from the element that emits it.
	   * @private
	   */
	  ;

	  _proto._onError = function _onError(event) {
	    this.abort("Failed to load element using: " + event.target.nodeName);
	  }
	  /**
	   * Called if a load progress event fires for an element or xhr/xdr.
	   *
	   * @private
	   * @param {XMLHttpRequestProgressEvent|Event} event - Progress event.
	   */
	  ;

	  _proto._onProgress = function _onProgress(event) {
	    if (event && event.lengthComputable) {
	      this.onProgress.dispatch(this, event.loaded / event.total);
	    }
	  }
	  /**
	   * Called if a timeout event fires for an element.
	   *
	   * @private
	   */
	  ;

	  _proto._onTimeout = function _onTimeout() {
	    this.abort("Load timed out.");
	  }
	  /**
	   * Called if an error event fires for xhr/xdr.
	   *
	   * @private
	   */
	  ;

	  _proto._xhrOnError = function _xhrOnError() {
	    var xhr = this.xhr;
	    this.abort(reqType(xhr) + " Request failed. Status: " + xhr.status + ", text: \"" + xhr.statusText + "\"");
	  }
	  /**
	   * Called if an error event fires for xhr/xdr.
	   *
	   * @private
	   */
	  ;

	  _proto._xhrOnTimeout = function _xhrOnTimeout() {
	    var xhr = this.xhr;
	    this.abort(reqType(xhr) + " Request timed out.");
	  }
	  /**
	   * Called if an abort event fires for xhr/xdr.
	   *
	   * @private
	   */
	  ;

	  _proto._xhrOnAbort = function _xhrOnAbort() {
	    var xhr = this.xhr;
	    this.abort(reqType(xhr) + " Request was aborted by the user.");
	  }
	  /**
	   * Called when data successfully loads from an xhr/xdr request.
	   *
	   * @private
	   * @param {XMLHttpRequestLoadEvent|Event} event - Load event
	   */
	  ;

	  _proto._xhrOnLoad = function _xhrOnLoad() {
	    var xhr = this.xhr;
	    var text = '';
	    var status = typeof xhr.status === 'undefined' ? STATUS_OK : xhr.status; // XDR has no `.status`, assume 200.
	    // responseText is accessible only if responseType is '' or 'text' and on older browsers

	    if (xhr.responseType === '' || xhr.responseType === 'text' || typeof xhr.responseType === 'undefined') {
	      text = xhr.responseText;
	    } // status can be 0 when using the `file://` protocol so we also check if a response is set.
	    // If it has a response, we assume 200; otherwise a 0 status code with no contents is an aborted request.


	    if (status === STATUS_NONE && (text.length > 0 || xhr.responseType === Resource.XHR_RESPONSE_TYPE.BUFFER)) {
	      status = STATUS_OK;
	    } // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	    else if (status === STATUS_IE_BUG_EMPTY) {
	        status = STATUS_EMPTY;
	      }

	    var statusType = status / 100 | 0;

	    if (statusType === STATUS_TYPE_OK) {
	      // if text, just return it
	      if (this.xhrType === Resource.XHR_RESPONSE_TYPE.TEXT) {
	        this.data = text;
	        this.type = Resource.TYPE.TEXT;
	      } // if json, parse into json object
	      else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON) {
	          try {
	            this.data = JSON.parse(text);
	            this.type = Resource.TYPE.JSON;
	          } catch (e) {
	            this.abort("Error trying to parse loaded json: " + e);
	            return;
	          }
	        } // if xml, parse into an xml document or div element
	        else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
	            try {
	              if (window.DOMParser) {
	                var domparser = new DOMParser();
	                this.data = domparser.parseFromString(text, 'text/xml');
	              } else {
	                var div = document.createElement('div');
	                div.innerHTML = text;
	                this.data = div;
	              }

	              this.type = Resource.TYPE.XML;
	            } catch (e) {
	              this.abort("Error trying to parse loaded xml: " + e);
	              return;
	            }
	          } // other types just return the response
	          else {
	              this.data = xhr.response || text;
	            }
	    } else {
	      this.abort("[" + xhr.status + "] " + xhr.statusText + ": " + xhr.responseURL);
	      return;
	    }

	    this.complete();
	  }
	  /**
	   * Sets the `crossOrigin` property for this resource based on if the url
	   * for this resource is cross-origin. If crossOrigin was manually set, this
	   * function does nothing.
	   *
	   * @private
	   * @param {string} url - The url to test.
	   * @param {object} [loc=window.location] - The location object to test against.
	   * @return {string} The crossOrigin value to use (or empty string for none).
	   */
	  ;

	  _proto._determineCrossOrigin = function _determineCrossOrigin(url, loc) {
	    // data: and javascript: urls are considered same-origin
	    if (url.indexOf('data:') === 0) {
	      return '';
	    } // A sandboxed iframe without the 'allow-same-origin' attribute will have a special
	    // origin designed not to match window.location.origin, and will always require
	    // crossOrigin requests regardless of whether the location matches.


	    if (window.origin !== window.location.origin) {
	      return 'anonymous';
	    } // default is window.location


	    loc = loc || window.location;

	    if (!tempAnchor$1) {
	      tempAnchor$1 = document.createElement('a');
	    } // let the browser determine the full href for the url of this resource and then
	    // parse with the node url lib, we can't use the properties of the anchor element
	    // because they don't work in IE9 :(


	    tempAnchor$1.href = url;
	    url = parseUri(tempAnchor$1.href, {
	      strictMode: true
	    });
	    var samePort = !url.port && loc.port === '' || url.port === loc.port;
	    var protocol = url.protocol ? url.protocol + ":" : ''; // if cross origin

	    if (url.host !== loc.hostname || !samePort || protocol !== loc.protocol) {
	      return 'anonymous';
	    }

	    return '';
	  }
	  /**
	   * Determines the responseType of an XHR request based on the extension of the
	   * resource being loaded.
	   *
	   * @private
	   * @return {Resource.XHR_RESPONSE_TYPE} The responseType to use.
	   */
	  ;

	  _proto._determineXhrType = function _determineXhrType() {
	    return Resource._xhrTypeMap[this.extension] || Resource.XHR_RESPONSE_TYPE.TEXT;
	  }
	  /**
	   * Determines the loadType of a resource based on the extension of the
	   * resource being loaded.
	   *
	   * @private
	   * @return {Resource.LOAD_TYPE} The loadType to use.
	   */
	  ;

	  _proto._determineLoadType = function _determineLoadType() {
	    return Resource._loadTypeMap[this.extension] || Resource.LOAD_TYPE.XHR;
	  }
	  /**
	   * Extracts the extension (sans '.') of the file being loaded by the resource.
	   *
	   * @private
	   * @return {string} The extension.
	   */
	  ;

	  _proto._getExtension = function _getExtension() {
	    var url = this.url;
	    var ext = '';

	    if (this.isDataUrl) {
	      var slashIndex = url.indexOf('/');
	      ext = url.substring(slashIndex + 1, url.indexOf(';', slashIndex));
	    } else {
	      var queryStart = url.indexOf('?');
	      var hashStart = url.indexOf('#');
	      var index = Math.min(queryStart > -1 ? queryStart : url.length, hashStart > -1 ? hashStart : url.length);
	      url = url.substring(0, index);
	      ext = url.substring(url.lastIndexOf('.') + 1);
	    }

	    return ext.toLowerCase();
	  }
	  /**
	   * Determines the mime type of an XHR request based on the responseType of
	   * resource being loaded.
	   *
	   * @private
	   * @param {Resource.XHR_RESPONSE_TYPE} type - The type to get a mime type for.
	   * @return {string} The mime type to use.
	   */
	  ;

	  _proto._getMimeFromXhrType = function _getMimeFromXhrType(type) {
	    switch (type) {
	      case Resource.XHR_RESPONSE_TYPE.BUFFER:
	        return 'application/octet-binary';

	      case Resource.XHR_RESPONSE_TYPE.BLOB:
	        return 'application/blob';

	      case Resource.XHR_RESPONSE_TYPE.DOCUMENT:
	        return 'application/xml';

	      case Resource.XHR_RESPONSE_TYPE.JSON:
	        return 'application/json';

	      case Resource.XHR_RESPONSE_TYPE.DEFAULT:
	      case Resource.XHR_RESPONSE_TYPE.TEXT:
	      /* falls through */

	      default:
	        return 'text/plain';
	    }
	  };

	  _createClass(Resource, [{
	    key: "isDataUrl",
	    get: function get() {
	      return this._hasFlag(Resource.STATUS_FLAGS.DATA_URL);
	    }
	    /**
	     * Describes if this resource has finished loading. Is true when the resource has completely
	     * loaded.
	     *
	     * @readonly
	     * @member {boolean}
	     */

	  }, {
	    key: "isComplete",
	    get: function get() {
	      return this._hasFlag(Resource.STATUS_FLAGS.COMPLETE);
	    }
	    /**
	     * Describes if this resource is currently loading. Is true when the resource starts loading,
	     * and is false again when complete.
	     *
	     * @readonly
	     * @member {boolean}
	     */

	  }, {
	    key: "isLoading",
	    get: function get() {
	      return this._hasFlag(Resource.STATUS_FLAGS.LOADING);
	    }
	  }]);

	  return Resource;
	}();
	/**
	 * The types of resources a resource could represent.
	 *
	 * @static
	 * @readonly
	 * @enum {number}
	 */


	Resource$1.STATUS_FLAGS = {
	  NONE: 0,
	  DATA_URL: 1 << 0,
	  COMPLETE: 1 << 1,
	  LOADING: 1 << 2
	};
	/**
	 * The types of resources a resource could represent.
	 *
	 * @static
	 * @readonly
	 * @enum {number}
	 */

	Resource$1.TYPE = {
	  UNKNOWN: 0,
	  JSON: 1,
	  XML: 2,
	  IMAGE: 3,
	  AUDIO: 4,
	  VIDEO: 5,
	  TEXT: 6
	};
	/**
	 * The types of loading a resource can use.
	 *
	 * @static
	 * @readonly
	 * @enum {number}
	 */

	Resource$1.LOAD_TYPE = {
	  /** Uses XMLHttpRequest to load the resource. */
	  XHR: 1,

	  /** Uses an `Image` object to load the resource. */
	  IMAGE: 2,

	  /** Uses an `Audio` object to load the resource. */
	  AUDIO: 3,

	  /** Uses a `Video` object to load the resource. */
	  VIDEO: 4
	};
	/**
	 * The XHR ready states, used internally.
	 *
	 * @static
	 * @readonly
	 * @enum {string}
	 */

	Resource$1.XHR_RESPONSE_TYPE = {
	  /** string */
	  DEFAULT: 'text',

	  /** ArrayBuffer */
	  BUFFER: 'arraybuffer',

	  /** Blob */
	  BLOB: 'blob',

	  /** Document */
	  DOCUMENT: 'document',

	  /** Object */
	  JSON: 'json',

	  /** String */
	  TEXT: 'text'
	};
	Resource$1._loadTypeMap = {
	  // images
	  gif: Resource$1.LOAD_TYPE.IMAGE,
	  png: Resource$1.LOAD_TYPE.IMAGE,
	  bmp: Resource$1.LOAD_TYPE.IMAGE,
	  jpg: Resource$1.LOAD_TYPE.IMAGE,
	  jpeg: Resource$1.LOAD_TYPE.IMAGE,
	  tif: Resource$1.LOAD_TYPE.IMAGE,
	  tiff: Resource$1.LOAD_TYPE.IMAGE,
	  webp: Resource$1.LOAD_TYPE.IMAGE,
	  tga: Resource$1.LOAD_TYPE.IMAGE,
	  svg: Resource$1.LOAD_TYPE.IMAGE,
	  'svg+xml': Resource$1.LOAD_TYPE.IMAGE,
	  // for SVG data urls
	  // audio
	  mp3: Resource$1.LOAD_TYPE.AUDIO,
	  ogg: Resource$1.LOAD_TYPE.AUDIO,
	  wav: Resource$1.LOAD_TYPE.AUDIO,
	  // videos
	  mp4: Resource$1.LOAD_TYPE.VIDEO,
	  webm: Resource$1.LOAD_TYPE.VIDEO
	};
	Resource$1._xhrTypeMap = {
	  // xml
	  xhtml: Resource$1.XHR_RESPONSE_TYPE.DOCUMENT,
	  html: Resource$1.XHR_RESPONSE_TYPE.DOCUMENT,
	  htm: Resource$1.XHR_RESPONSE_TYPE.DOCUMENT,
	  xml: Resource$1.XHR_RESPONSE_TYPE.DOCUMENT,
	  tmx: Resource$1.XHR_RESPONSE_TYPE.DOCUMENT,
	  svg: Resource$1.XHR_RESPONSE_TYPE.DOCUMENT,
	  // This was added to handle Tiled Tileset XML, but .tsx is also a TypeScript React Component.
	  // Since it is way less likely for people to be loading TypeScript files instead of Tiled files,
	  // this should probably be fine.
	  tsx: Resource$1.XHR_RESPONSE_TYPE.DOCUMENT,
	  // images
	  gif: Resource$1.XHR_RESPONSE_TYPE.BLOB,
	  png: Resource$1.XHR_RESPONSE_TYPE.BLOB,
	  bmp: Resource$1.XHR_RESPONSE_TYPE.BLOB,
	  jpg: Resource$1.XHR_RESPONSE_TYPE.BLOB,
	  jpeg: Resource$1.XHR_RESPONSE_TYPE.BLOB,
	  tif: Resource$1.XHR_RESPONSE_TYPE.BLOB,
	  tiff: Resource$1.XHR_RESPONSE_TYPE.BLOB,
	  webp: Resource$1.XHR_RESPONSE_TYPE.BLOB,
	  tga: Resource$1.XHR_RESPONSE_TYPE.BLOB,
	  // json
	  json: Resource$1.XHR_RESPONSE_TYPE.JSON,
	  // text
	  text: Resource$1.XHR_RESPONSE_TYPE.TEXT,
	  txt: Resource$1.XHR_RESPONSE_TYPE.TEXT,
	  // fonts
	  ttf: Resource$1.XHR_RESPONSE_TYPE.BUFFER,
	  otf: Resource$1.XHR_RESPONSE_TYPE.BUFFER
	}; // We can't set the `src` attribute to empty string, so on abort we set it to this 1px transparent gif

	Resource$1.EMPTY_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
	/**
	 * Quick helper to set a value on one of the extension maps. Ensures there is no
	 * dot at the start of the extension.
	 *
	 * @ignore
	 * @param {object} map - The map to set on.
	 * @param {string} extname - The extension (or key) to set.
	 * @param {number} val - The value to set.
	 */

	function setExtMap(map, extname, val) {
	  if (extname && extname.indexOf('.') === 0) {
	    extname = extname.substring(1);
	  }

	  if (!extname) {
	    return;
	  }

	  map[extname] = val;
	}
	/**
	 * Quick helper to get string xhr type.
	 *
	 * @ignore
	 * @param {XMLHttpRequest|XDomainRequest} xhr - The request to check.
	 * @return {string} The type.
	 */


	function reqType(xhr) {
	  return xhr.toString().replace('object ', '');
	}

	var _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	/**
	 * Encodes binary into base64.
	 *
	 * @function encodeBinary
	 * @param {string} input The input data to encode.
	 * @returns {string} The encoded base64 string
	 */

	function encodeBinary(input) {
	  var output = '';
	  var inx = 0;

	  while (inx < input.length) {
	    // Fill byte buffer array
	    var bytebuffer = [0, 0, 0];
	    var encodedCharIndexes = [0, 0, 0, 0];

	    for (var jnx = 0; jnx < bytebuffer.length; ++jnx) {
	      if (inx < input.length) {
	        // throw away high-order byte, as documented at:
	        // https://developer.mozilla.org/En/Using_XMLHttpRequest#Handling_binary_data
	        bytebuffer[jnx] = input.charCodeAt(inx++) & 0xff;
	      } else {
	        bytebuffer[jnx] = 0;
	      }
	    } // Get each encoded character, 6 bits at a time
	    // index 1: first 6 bits


	    encodedCharIndexes[0] = bytebuffer[0] >> 2; // index 2: second 6 bits (2 least significant bits from input byte 1 + 4 most significant bits from byte 2)

	    encodedCharIndexes[1] = (bytebuffer[0] & 0x3) << 4 | bytebuffer[1] >> 4; // index 3: third 6 bits (4 least significant bits from input byte 2 + 2 most significant bits from byte 3)

	    encodedCharIndexes[2] = (bytebuffer[1] & 0x0f) << 2 | bytebuffer[2] >> 6; // index 3: forth 6 bits (6 least significant bits from input byte 3)

	    encodedCharIndexes[3] = bytebuffer[2] & 0x3f; // Determine whether padding happened, and adjust accordingly

	    var paddingBytes = inx - (input.length - 1);

	    switch (paddingBytes) {
	      case 2:
	        // Set last 2 characters to padding char
	        encodedCharIndexes[3] = 64;
	        encodedCharIndexes[2] = 64;
	        break;

	      case 1:
	        // Set last character to padding char
	        encodedCharIndexes[3] = 64;
	        break;

	      default:
	        break;
	      // No padding - proceed
	    } // Now we will grab each appropriate character out of our keystring
	    // based on our index array and append it to the output string


	    for (var _jnx = 0; _jnx < encodedCharIndexes.length; ++_jnx) {
	      output += _keyStr.charAt(encodedCharIndexes[_jnx]);
	    }
	  }

	  return output;
	}

	var Url$1 = window.URL || window.webkitURL;
	/**
	 * A middleware for transforming XHR loaded Blobs into more useful objects
	 *
	 * @memberof middleware
	 * @function parsing
	 * @example
	 * import { Loader, middleware } from 'resource-loader';
	 * const loader = new Loader();
	 * loader.use(middleware.parsing);
	 * @param {Resource} resource - Current Resource
	 * @param {function} next - Callback when complete
	 */

	function parsing(resource, next) {
	  if (!resource.data) {
	    next();
	    return;
	  } // if this was an XHR load of a blob


	  if (resource.xhr && resource.xhrType === Resource$1.XHR_RESPONSE_TYPE.BLOB) {
	    // if there is no blob support we probably got a binary string back
	    if (!window.Blob || typeof resource.data === 'string') {
	      var type = resource.xhr.getResponseHeader('content-type'); // this is an image, convert the binary string into a data url

	      if (type && type.indexOf('image') === 0) {
	        resource.data = new Image();
	        resource.data.src = "data:" + type + ";base64," + encodeBinary(resource.xhr.responseText);
	        resource.type = Resource$1.TYPE.IMAGE; // wait until the image loads and then callback

	        resource.data.onload = function () {
	          resource.data.onload = null;
	          next();
	        }; // next will be called on load


	        return;
	      }
	    } // if content type says this is an image, then we should transform the blob into an Image object
	    else if (resource.data.type.indexOf('image') === 0) {
	        var src = Url$1.createObjectURL(resource.data);
	        resource.blob = resource.data;
	        resource.data = new Image();
	        resource.data.src = src;
	        resource.type = Resource$1.TYPE.IMAGE; // cleanup the no longer used blob after the image loads
	        // TODO: Is this correct? Will the image be invalid after revoking?

	        resource.data.onload = function () {
	          Url$1.revokeObjectURL(src);
	          resource.data.onload = null;
	          next();
	        }; // next will be called on load.


	        return;
	      }
	  }

	  next();
	}

	/**
	 * @namespace middleware
	 */

	var index$1 = ({
	    caching: caching,
	    parsing: parsing
	});

	var MAX_PROGRESS = 100;
	var rgxExtractUrlHash = /(#[\w-]+)?$/;
	/**
	 * Manages the state and loading of multiple resources to load.
	 *
	 * @class
	 */

	var Loader =
	/*#__PURE__*/
	function () {
	  /**
	   * @param {string} [baseUrl=''] - The base url for all resources loaded by this loader.
	   * @param {number} [concurrency=10] - The number of resources to load concurrently.
	   */
	  function Loader(baseUrl, concurrency) {
	    var _this = this;

	    if (baseUrl === void 0) {
	      baseUrl = '';
	    }

	    if (concurrency === void 0) {
	      concurrency = 10;
	    }

	    /**
	     * The base url for all resources loaded by this loader.
	     *
	     * @member {string}
	     */
	    this.baseUrl = baseUrl;
	    /**
	     * The progress percent of the loader going through the queue.
	     *
	     * @member {number}
	     * @default 0
	     */

	    this.progress = 0;
	    /**
	     * Loading state of the loader, true if it is currently loading resources.
	     *
	     * @member {boolean}
	     * @default false
	     */

	    this.loading = false;
	    /**
	     * A querystring to append to every URL added to the loader.
	     *
	     * This should be a valid query string *without* the question-mark (`?`). The loader will
	     * also *not* escape values for you. Make sure to escape your parameters with
	     * [`encodeURIComponent`](https://mdn.io/encodeURIComponent) before assigning this property.
	     *
	     * @example
	     * const loader = new Loader();
	     *
	     * loader.defaultQueryString = 'user=me&password=secret';
	     *
	     * // This will request 'image.png?user=me&password=secret'
	     * loader.add('image.png').load();
	     *
	     * loader.reset();
	     *
	     * // This will request 'image.png?v=1&user=me&password=secret'
	     * loader.add('iamge.png?v=1').load();
	     *
	     * @member {string}
	     * @default ''
	     */

	    this.defaultQueryString = '';
	    /**
	     * The middleware to run before loading each resource.
	     *
	     * @private
	     * @member {function[]}
	     */

	    this._beforeMiddleware = [];
	    /**
	     * The middleware to run after loading each resource.
	     *
	     * @private
	     * @member {function[]}
	     */

	    this._afterMiddleware = [];
	    /**
	     * The tracks the resources we are currently completing parsing for.
	     *
	     * @private
	     * @member {Resource[]}
	     */

	    this._resourcesParsing = [];
	    /**
	     * The `_loadResource` function bound with this object context.
	     *
	     * @private
	     * @member {function}
	     * @param {Resource} r - The resource to load
	     * @param {Function} d - The dequeue function
	     * @return {undefined}
	     */

	    this._boundLoadResource = function (r, d) {
	      return _this._loadResource(r, d);
	    };
	    /**
	     * The resources waiting to be loaded.
	     *
	     * @private
	     * @member {Resource[]}
	     */


	    this._queue = queue(this._boundLoadResource, concurrency);

	    this._queue.pause();
	    /**
	     * All the resources for this loader keyed by name.
	     *
	     * @member {object<string, Resource>}
	     */


	    this.resources = {};
	    /**
	     * Dispatched once per loaded or errored resource.
	     *
	     * The callback looks like {@link Loader.OnProgressSignal}.
	     *
	     * @member {Signal<Loader.OnProgressSignal>}
	     */

	    this.onProgress = new Signal();
	    /**
	     * Dispatched once per errored resource.
	     *
	     * The callback looks like {@link Loader.OnErrorSignal}.
	     *
	     * @member {Signal<Loader.OnErrorSignal>}
	     */

	    this.onError = new Signal();
	    /**
	     * Dispatched once per loaded resource.
	     *
	     * The callback looks like {@link Loader.OnLoadSignal}.
	     *
	     * @member {Signal<Loader.OnLoadSignal>}
	     */

	    this.onLoad = new Signal();
	    /**
	     * Dispatched when the loader begins to process the queue.
	     *
	     * The callback looks like {@link Loader.OnStartSignal}.
	     *
	     * @member {Signal<Loader.OnStartSignal>}
	     */

	    this.onStart = new Signal();
	    /**
	     * Dispatched when the queued resources all load.
	     *
	     * The callback looks like {@link Loader.OnCompleteSignal}.
	     *
	     * @member {Signal<Loader.OnCompleteSignal>}
	     */

	    this.onComplete = new Signal(); // Add default before middleware

	    for (var i = 0; i < Loader._defaultBeforeMiddleware.length; ++i) {
	      this.pre(Loader._defaultBeforeMiddleware[i]);
	    } // Add default after middleware


	    for (var _i = 0; _i < Loader._defaultAfterMiddleware.length; ++_i) {
	      this.use(Loader._defaultAfterMiddleware[_i]);
	    }
	  }
	  /**
	   * When the progress changes the loader and resource are disaptched.
	   *
	   * @memberof Loader
	   * @callback OnProgressSignal
	   * @param {Loader} loader - The loader the progress is advancing on.
	   * @param {Resource} resource - The resource that has completed or failed to cause the progress to advance.
	   */

	  /**
	   * When an error occurrs the loader and resource are disaptched.
	   *
	   * @memberof Loader
	   * @callback OnErrorSignal
	   * @param {Loader} loader - The loader the error happened in.
	   * @param {Resource} resource - The resource that caused the error.
	   */

	  /**
	   * When a load completes the loader and resource are disaptched.
	   *
	   * @memberof Loader
	   * @callback OnLoadSignal
	   * @param {Loader} loader - The loader that laoded the resource.
	   * @param {Resource} resource - The resource that has completed loading.
	   */

	  /**
	   * When the loader starts loading resources it dispatches this callback.
	   *
	   * @memberof Loader
	   * @callback OnStartSignal
	   * @param {Loader} loader - The loader that has started loading resources.
	   */

	  /**
	   * When the loader completes loading resources it dispatches this callback.
	   *
	   * @memberof Loader
	   * @callback OnCompleteSignal
	   * @param {Loader} loader - The loader that has finished loading resources.
	   */

	  /**
	   * Options for a call to `.add()`.
	   *
	   * @see Loader#add
	   *
	   * @typedef {object} IAddOptions
	   * @property {string} [name] - The name of the resource to load, if not passed the url is used.
	   * @property {string} [key] - Alias for `name`.
	   * @property {string} [url] - The url for this resource, relative to the baseUrl of this loader.
	   * @property {string|boolean} [crossOrigin] - Is this request cross-origin? Default is to
	   *      determine automatically.
	   * @property {number} [timeout=0] - A timeout in milliseconds for the load. If the load takes
	   *      longer than this time it is cancelled and the load is considered a failure. If this value is
	   *      set to `0` then there is no explicit timeout.
	   * @property {Resource.LOAD_TYPE} [loadType=Resource.LOAD_TYPE.XHR] - How should this resource
	   *      be loaded?
	   * @property {Resource.XHR_RESPONSE_TYPE} [xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] - How
	   *      should the data being loaded be interpreted when using XHR?
	   * @property {Resource.OnCompleteSignal} [onComplete] - Callback to add an an onComplete signal istener.
	   * @property {Resource.OnCompleteSignal} [callback] - Alias for `onComplete`.
	   * @property {Resource.IMetadata} [metadata] - Extra configuration for middleware and the Resource object.
	   */

	  /* eslint-disable require-jsdoc,valid-jsdoc */

	  /**
	   * Adds a resource (or multiple resources) to the loader queue.
	   *
	   * This function can take a wide variety of different parameters. The only thing that is always
	   * required the url to load. All the following will work:
	   *
	   * ```js
	   * loader
	   *     // normal param syntax
	   *     .add('key', 'http://...', function () {})
	   *     .add('http://...', function () {})
	   *     .add('http://...')
	   *
	   *     // object syntax
	   *     .add({
	   *         name: 'key2',
	   *         url: 'http://...'
	   *     }, function () {})
	   *     .add({
	   *         url: 'http://...'
	   *     }, function () {})
	   *     .add({
	   *         name: 'key3',
	   *         url: 'http://...'
	   *         onComplete: function () {}
	   *     })
	   *     .add({
	   *         url: 'https://...',
	   *         onComplete: function () {},
	   *         crossOrigin: true
	   *     })
	   *
	   *     // you can also pass an array of objects or urls or both
	   *     .add([
	   *         { name: 'key4', url: 'http://...', onComplete: function () {} },
	   *         { url: 'http://...', onComplete: function () {} },
	   *         'http://...'
	   *     ])
	   *
	   *     // and you can use both params and options
	   *     .add('key', 'http://...', { crossOrigin: true }, function () {})
	   *     .add('http://...', { crossOrigin: true }, function () {});
	   * ```
	   *
	   * @function
	   * @variation 1
	   * @param {string} name - The name of the resource to load.
	   * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
	   * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
	   * @return {this} Returns itself.
	   */

	  /**
	  * @function
	  * @variation 2
	  * @param {string} name - The name of the resource to load.
	  * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
	  * @param {IAddOptions} [options] - The options for the load.
	  * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
	  * @return {this} Returns itself.
	  */

	  /**
	  * @function
	  * @variation 3
	  * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
	  * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
	  * @return {this} Returns itself.
	  */

	  /**
	  * @function
	  * @variation 4
	  * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
	  * @param {IAddOptions} [options] - The options for the load.
	  * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
	  * @return {this} Returns itself.
	  */

	  /**
	  * @function
	  * @variation 5
	  * @param {IAddOptions} options - The options for the load. This object must contain a `url` property.
	  * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
	  * @return {this} Returns itself.
	  */

	  /**
	  * @function
	  * @variation 6
	  * @param {Array<IAddOptions|string>} resources - An array of resources to load, where each is
	  *      either an object with the options or a string url. If you pass an object, it must contain a `url` property.
	  * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
	  * @return {this} Returns itself.
	  */


	  var _proto = Loader.prototype;

	  _proto.add = function add(name, url, options, cb) {
	    // special case of an array of objects or urls
	    if (Array.isArray(name)) {
	      for (var i = 0; i < name.length; ++i) {
	        this.add(name[i]);
	      }

	      return this;
	    } // if an object is passed instead of params


	    if (typeof name === 'object') {
	      cb = url || name.callback || name.onComplete;
	      options = name;
	      url = name.url;
	      name = name.name || name.key || name.url;
	    } // case where no name is passed shift all args over by one.


	    if (typeof url !== 'string') {
	      cb = options;
	      options = url;
	      url = name;
	    } // now that we shifted make sure we have a proper url.


	    if (typeof url !== 'string') {
	      throw new Error('No url passed to add resource to loader.');
	    } // options are optional so people might pass a function and no options


	    if (typeof options === 'function') {
	      cb = options;
	      options = null;
	    } // if loading already you can only add resources that have a parent.


	    if (this.loading && (!options || !options.parentResource)) {
	      throw new Error('Cannot add resources while the loader is running.');
	    } // check if resource already exists.


	    if (this.resources[name]) {
	      throw new Error("Resource named \"" + name + "\" already exists.");
	    } // add base url if this isn't an absolute url


	    url = this._prepareUrl(url); // create the store the resource

	    this.resources[name] = new Resource$1(name, url, options);

	    if (typeof cb === 'function') {
	      this.resources[name].onAfterMiddleware.once(cb);
	    } // if actively loading, make sure to adjust progress chunks for that parent and its children


	    if (this.loading) {
	      var parent = options.parentResource;
	      var incompleteChildren = [];

	      for (var _i2 = 0; _i2 < parent.children.length; ++_i2) {
	        if (!parent.children[_i2].isComplete) {
	          incompleteChildren.push(parent.children[_i2]);
	        }
	      }

	      var fullChunk = parent.progressChunk * (incompleteChildren.length + 1); // +1 for parent

	      var eachChunk = fullChunk / (incompleteChildren.length + 2); // +2 for parent & new child

	      parent.children.push(this.resources[name]);
	      parent.progressChunk = eachChunk;

	      for (var _i3 = 0; _i3 < incompleteChildren.length; ++_i3) {
	        incompleteChildren[_i3].progressChunk = eachChunk;
	      }

	      this.resources[name].progressChunk = eachChunk;
	    } // add the resource to the queue


	    this._queue.push(this.resources[name]);

	    return this;
	  }
	  /* eslint-enable require-jsdoc,valid-jsdoc */

	  /**
	   * Sets up a middleware function that will run *before* the
	   * resource is loaded.
	   *
	   * @param {function} fn - The middleware function to register.
	   * @return {this} Returns itself.
	   */
	  ;

	  _proto.pre = function pre(fn) {
	    this._beforeMiddleware.push(fn);

	    return this;
	  }
	  /**
	   * Sets up a middleware function that will run *after* the
	   * resource is loaded.
	   *
	   * @param {function} fn - The middleware function to register.
	   * @return {this} Returns itself.
	   */
	  ;

	  _proto.use = function use(fn) {
	    this._afterMiddleware.push(fn);

	    return this;
	  }
	  /**
	   * Resets the queue of the loader to prepare for a new load.
	   *
	   * @return {this} Returns itself.
	   */
	  ;

	  _proto.reset = function reset() {
	    this.progress = 0;
	    this.loading = false;

	    this._queue.kill();

	    this._queue.pause(); // abort all resource loads


	    for (var k in this.resources) {
	      var res = this.resources[k];

	      if (res._onLoadBinding) {
	        res._onLoadBinding.detach();
	      }

	      if (res.isLoading) {
	        res.abort();
	      }
	    }

	    this.resources = {};
	    return this;
	  }
	  /**
	   * Starts loading the queued resources.
	   *
	   * @param {function} [cb] - Optional callback that will be bound to the `complete` event.
	   * @return {this} Returns itself.
	   */
	  ;

	  _proto.load = function load(cb) {
	    // register complete callback if they pass one
	    if (typeof cb === 'function') {
	      this.onComplete.once(cb);
	    } // if the queue has already started we are done here


	    if (this.loading) {
	      return this;
	    }

	    if (this._queue.idle()) {
	      this._onStart();

	      this._onComplete();
	    } else {
	      // distribute progress chunks
	      var numTasks = this._queue._tasks.length;
	      var chunk = MAX_PROGRESS / numTasks;

	      for (var i = 0; i < this._queue._tasks.length; ++i) {
	        this._queue._tasks[i].data.progressChunk = chunk;
	      } // notify we are starting


	      this._onStart(); // start loading


	      this._queue.resume();
	    }

	    return this;
	  }
	  /**
	   * The number of resources to load concurrently.
	   *
	   * @member {number}
	   * @default 10
	   */
	  ;

	  /**
	   * Prepares a url for usage based on the configuration of this object
	   *
	   * @private
	   * @param {string} url - The url to prepare.
	   * @return {string} The prepared url.
	   */
	  _proto._prepareUrl = function _prepareUrl(url) {
	    var parsedUrl = parseUri(url, {
	      strictMode: true
	    });
	    var result; // absolute url, just use it as is.

	    if (parsedUrl.protocol || !parsedUrl.path || url.indexOf('//') === 0) {
	      result = url;
	    } // if baseUrl doesn't end in slash and url doesn't start with slash, then add a slash inbetween
	    else if (this.baseUrl.length && this.baseUrl.lastIndexOf('/') !== this.baseUrl.length - 1 && url.charAt(0) !== '/') {
	        result = this.baseUrl + "/" + url;
	      } else {
	        result = this.baseUrl + url;
	      } // if we need to add a default querystring, there is a bit more work


	    if (this.defaultQueryString) {
	      var hash = rgxExtractUrlHash.exec(result)[0];
	      result = result.substr(0, result.length - hash.length);

	      if (result.indexOf('?') !== -1) {
	        result += "&" + this.defaultQueryString;
	      } else {
	        result += "?" + this.defaultQueryString;
	      }

	      result += hash;
	    }

	    return result;
	  }
	  /**
	   * Loads a single resource.
	   *
	   * @private
	   * @param {Resource} resource - The resource to load.
	   * @param {function} dequeue - The function to call when we need to dequeue this item.
	   */
	  ;

	  _proto._loadResource = function _loadResource(resource, dequeue) {
	    var _this2 = this;

	    resource._dequeue = dequeue; // run before middleware

	    eachSeries(this._beforeMiddleware, function (fn, next) {
	      fn.call(_this2, resource, function () {
	        // if the before middleware marks the resource as complete,
	        // break and don't process any more before middleware
	        next(resource.isComplete ? {} : null);
	      });
	    }, function () {
	      if (resource.isComplete) {
	        _this2._onLoad(resource);
	      } else {
	        resource._onLoadBinding = resource.onComplete.once(_this2._onLoad, _this2);
	        resource.load();
	      }
	    }, true);
	  }
	  /**
	   * Called once loading has started.
	   *
	   * @private
	   */
	  ;

	  _proto._onStart = function _onStart() {
	    this.progress = 0;
	    this.loading = true;
	    this.onStart.dispatch(this);
	  }
	  /**
	   * Called once each resource has loaded.
	   *
	   * @private
	   */
	  ;

	  _proto._onComplete = function _onComplete() {
	    this.progress = MAX_PROGRESS;
	    this.loading = false;
	    this.onComplete.dispatch(this, this.resources);
	  }
	  /**
	   * Called each time a resources is loaded.
	   *
	   * @private
	   * @param {Resource} resource - The resource that was loaded
	   */
	  ;

	  _proto._onLoad = function _onLoad(resource) {
	    var _this3 = this;

	    resource._onLoadBinding = null; // remove this resource from the async queue, and add it to our list of resources that are being parsed

	    this._resourcesParsing.push(resource);

	    resource._dequeue(); // run all the after middleware for this resource


	    eachSeries(this._afterMiddleware, function (fn, next) {
	      fn.call(_this3, resource, next);
	    }, function () {
	      resource.onAfterMiddleware.dispatch(resource);
	      _this3.progress = Math.min(MAX_PROGRESS, _this3.progress + resource.progressChunk);

	      _this3.onProgress.dispatch(_this3, resource);

	      if (resource.error) {
	        _this3.onError.dispatch(resource.error, _this3, resource);
	      } else {
	        _this3.onLoad.dispatch(_this3, resource);
	      }

	      _this3._resourcesParsing.splice(_this3._resourcesParsing.indexOf(resource), 1); // do completion check


	      if (_this3._queue.idle() && _this3._resourcesParsing.length === 0) {
	        _this3._onComplete();
	      }
	    }, true);
	  };

	  _createClass(Loader, [{
	    key: "concurrency",
	    get: function get() {
	      return this._queue.concurrency;
	    } // eslint-disable-next-line require-jsdoc
	    ,
	    set: function set(concurrency) {
	      this._queue.concurrency = concurrency;
	    }
	  }]);

	  return Loader;
	}();
	/**
	 * A default array of middleware to run before loading each resource.
	 * Each of these middlewares are added to any new Loader instances when they are created.
	 *
	 * @private
	 * @member {function[]}
	 */


	Loader._defaultBeforeMiddleware = [];
	/**
	 * A default array of middleware to run after loading each resource.
	 * Each of these middlewares are added to any new Loader instances when they are created.
	 *
	 * @private
	 * @member {function[]}
	 */

	Loader._defaultAfterMiddleware = [];
	/**
	 * Sets up a middleware function that will run *before* the
	 * resource is loaded.
	 *
	 * @static
	 * @param {function} fn - The middleware function to register.
	 * @return {Loader} Returns itself.
	 */

	Loader.pre = function LoaderPreStatic(fn) {
	  Loader._defaultBeforeMiddleware.push(fn);

	  return Loader;
	};
	/**
	 * Sets up a middleware function that will run *after* the
	 * resource is loaded.
	 *
	 * @static
	 * @param {function} fn - The middleware function to register.
	 * @return {Loader} Returns itself.
	 */


	Loader.use = function LoaderUseStatic(fn) {
	  Loader._defaultAfterMiddleware.push(fn);

	  return Loader;
	};

	/*!
	 * @pixi/loaders - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/loaders is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	* Reference to **{@link https://github.com/englercj/resource-loader
	* resource-loader}**'s Resource class.
	* @see http://englercj.github.io/resource-loader/Resource.html
	* @class LoaderResource
	* @memberof PIXI
	*/
	var LoaderResource = Resource$1;

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$3 = function(d, b) {
	    extendStatics$3 = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$3(d, b);
	};

	function __extends$3(d, b) {
	    extendStatics$3(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	/**
	 * Loader plugin for handling Texture resources.
	 * @class
	 * @memberof PIXI
	 * @implements PIXI.ILoaderPlugin
	 */
	var TextureLoader = /** @class */ (function () {
	    function TextureLoader() {
	    }
	    /**
	     * Called after a resource is loaded.
	     * @see PIXI.Loader.loaderMiddleware
	     * @param {PIXI.LoaderResource} resource
	     * @param {function} next
	     */
	    TextureLoader.use = function (resource, next) {
	        // create a new texture if the data is an Image object
	        if (resource.data && resource.type === Resource$1.TYPE.IMAGE) {
	            resource.texture = Texture.fromLoader(resource.data, resource.url, resource.name);
	        }
	        next();
	    };
	    return TextureLoader;
	}());

	/**
	 * The new loader, extends Resource Loader by Chad Engler: https://github.com/englercj/resource-loader
	 *
	 * ```js
	 * const loader = PIXI.Loader.shared; // PixiJS exposes a premade instance for you to use.
	 * //or
	 * const loader = new PIXI.Loader(); // you can also create your own if you want
	 *
	 * const sprites = {};
	 *
	 * // Chainable `add` to enqueue a resource
	 * loader.add('bunny', 'data/bunny.png')
	 *       .add('spaceship', 'assets/spritesheet.json');
	 * loader.add('scoreFont', 'assets/score.fnt');
	 *
	 * // Chainable `pre` to add a middleware that runs for each resource, *before* loading that resource.
	 * // This is useful to implement custom caching modules (using filesystem, indexeddb, memory, etc).
	 * loader.pre(cachingMiddleware);
	 *
	 * // Chainable `use` to add a middleware that runs for each resource, *after* loading that resource.
	 * // This is useful to implement custom parsing modules (like spritesheet parsers, spine parser, etc).
	 * loader.use(parsingMiddleware);
	 *
	 * // The `load` method loads the queue of resources, and calls the passed in callback called once all
	 * // resources have loaded.
	 * loader.load((loader, resources) => {
	 *     // resources is an object where the key is the name of the resource loaded and the value is the resource object.
	 *     // They have a couple default properties:
	 *     // - `url`: The URL that the resource was loaded from
	 *     // - `error`: The error that happened when trying to load (if any)
	 *     // - `data`: The raw data that was loaded
	 *     // also may contain other properties based on the middleware that runs.
	 *     sprites.bunny = new PIXI.TilingSprite(resources.bunny.texture);
	 *     sprites.spaceship = new PIXI.TilingSprite(resources.spaceship.texture);
	 *     sprites.scoreFont = new PIXI.TilingSprite(resources.scoreFont.texture);
	 * });
	 *
	 * // throughout the process multiple signals can be dispatched.
	 * loader.onProgress.add(() => {}); // called once per loaded/errored file
	 * loader.onError.add(() => {}); // called once per errored file
	 * loader.onLoad.add(() => {}); // called once per loaded file
	 * loader.onComplete.add(() => {}); // called once when the queued resources all load.
	 * ```
	 *
	 * @see https://github.com/englercj/resource-loader
	 *
	 * @class Loader
	 * @memberof PIXI
	 * @param {string} [baseUrl=''] - The base url for all resources loaded by this loader.
	 * @param {number} [concurrency=10] - The number of resources to load concurrently.
	 */
	var Loader$1 = /** @class */ (function (_super) {
	    __extends$3(Loader, _super);
	    function Loader(baseUrl, concurrency) {
	        var _this = _super.call(this, baseUrl, concurrency) || this;
	        for (var i = 0; i < Loader._plugins.length; ++i) {
	            var plugin = Loader._plugins[i];
	            var pre = plugin.pre, use = plugin.use;
	            if (pre) {
	                _this.pre(pre);
	            }
	            if (use) {
	                _this.use(use);
	            }
	        }
	        /**
	         * If this loader cannot be destroyed.
	         * @member {boolean}
	         * @default false
	         * @private
	         */
	        _this._protected = false;
	        return _this;
	    }
	    /**
	     * Destroy the loader, removes references.
	     * @memberof PIXI.Loader#
	     * @method destroy
	     * @public
	     */
	    Loader.prototype.destroy = function () {
	        if (!this._protected) {
	            this.reset();
	        }
	    };
	    Object.defineProperty(Loader, "shared", {
	        /**
	         * A premade instance of the loader that can be used to load resources.
	         * @name shared
	         * @type {PIXI.Loader}
	         * @static
	         * @memberof PIXI.Loader
	         */
	        get: function () {
	            var shared = Loader._shared;
	            if (!shared) {
	                shared = new Loader();
	                shared._protected = true;
	                Loader._shared = shared;
	            }
	            return shared;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Adds a Loader plugin for the global shared loader and all
	     * new Loader instances created.
	     *
	     * @static
	     * @method registerPlugin
	     * @memberof PIXI.Loader
	     * @param {PIXI.ILoaderPlugin} plugin - The plugin to add
	     * @return {PIXI.Loader} Reference to PIXI.Loader for chaining
	     */
	    Loader.registerPlugin = function (plugin) {
	        Loader._plugins.push(plugin);
	        if (plugin.add) {
	            plugin.add();
	        }
	        return Loader;
	    };
	    /**
	     * Collection of all installed `use` middleware for Loader.
	     *
	     * @static
	     * @member {Array<PIXI.ILoaderPlugin>} _plugins
	     * @memberof PIXI.Loader
	     * @private
	     */
	    Loader._plugins = [];
	    return Loader;
	}(Loader));
	// parse any blob into more usable objects (e.g. Image)
	Loader$1.registerPlugin({ use: index$1.parsing });
	// parse any Image objects into textures
	Loader$1.registerPlugin(TextureLoader);
	/**
	 * Plugin to be installed for handling specific Loader resources.
	 *
	 * @memberof PIXI
	 * @typedef {object} ILoaderPlugin
	 * @property {function} [add] - Function to call immediate after registering plugin.
	 * @property {PIXI.Loader.loaderMiddleware} [pre] - Middleware function to run before load, the
	 *           arguments for this are `(resource, next)`
	 * @property {PIXI.Loader.loaderMiddleware} [use] - Middleware function to run after load, the
	 *           arguments for this are `(resource, next)`
	 */
	/**
	 * @memberof PIXI.Loader
	 * @typedef {object} ICallbackID
	 */
	/**
	 * @memberof PIXI.Loader
	 * @typedef {function} ISignalCallback
	 * @param {function} callback - Callback function
	 * @param {object} [context] - Context
	 * @returns {ICallbackID} - CallbackID
	 */
	/**
	 * @memberof PIXI.Loader
	 * @typedef {function} ISignalDetach
	 * @param {ICallbackID} id - CallbackID returned by `add`/`once` methods
	 */
	/**
	 * @memberof PIXI.Loader
	 * @typedef ILoaderSignal
	 * @property {ISignalCallback} add - Register callback
	 * @property {ISignalCallback} once - Register oneshot callback
	 * @property {ISignalDetach} detach - Detach specific callback by ID
	 */
	/**
	 * @memberof PIXI.Loader
	 * @callback loaderMiddleware
	 * @param {PIXI.LoaderResource} resource
	 * @param {function} next
	 */
	/**
	 * @memberof PIXI.Loader#
	 * @description Dispatched when the loader begins to loading process.
	 * @member {PIXI.Loader.ILoaderSignal} onStart
	 */
	/**
	 * @memberof PIXI.Loader#
	 * @description Dispatched once per loaded or errored resource.
	 * @member {PIXI.Loader.ILoaderSignal} onProgress
	 */
	/**
	 * @memberof PIXI.Loader#
	 * @description Dispatched once per errored resource.
	 * @member {PIXI.Loader.ILoaderSignal} onError
	 */
	/**
	 * @memberof PIXI.Loader#
	 * @description Dispatched once per loaded resource.
	 * @member {PIXI.Loader.ILoaderSignal} onLoad
	 */
	/**
	 * @memberof PIXI.Loader#
	 * @description Dispatched when completely loaded all resources.
	 * @member {PIXI.Loader.ILoaderSignal} onComplete
	 */

	/**
	 * Application plugin for supporting loader option. Installing the LoaderPlugin
	 * is not necessary if using **pixi.js** or **pixi.js-legacy**.
	 * @example
	 * import {AppLoaderPlugin} from '@pixi/loaders';
	 * import {Application} from '@pixi/app';
	 * Application.registerPlugin(AppLoaderPlugin);
	 * @class
	 * @memberof PIXI
	 */
	var AppLoaderPlugin = /** @class */ (function () {
	    function AppLoaderPlugin() {
	    }
	    /**
	     * Called on application constructor
	     * @param {object} options
	     * @private
	     */
	    AppLoaderPlugin.init = function (options) {
	        options = Object.assign({
	            sharedLoader: false,
	        }, options);
	        /**
	         * Loader instance to help with asset loading.
	         * @name PIXI.Application#loader
	         * @type {PIXI.Loader}
	         * @readonly
	         */
	        this.loader = options.sharedLoader ? Loader$1.shared : new Loader$1();
	    };
	    /**
	     * Called when application destroyed
	     * @private
	     */
	    AppLoaderPlugin.destroy = function () {
	        if (this.loader) {
	            this.loader.destroy();
	            this.loader = null;
	        }
	    };
	    return AppLoaderPlugin;
	}());

	/*!
	 * @pixi/particles - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/particles is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$4 = function(d, b) {
	    extendStatics$4 = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$4(d, b);
	};

	function __extends$4(d, b) {
	    extendStatics$4(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	/**
	 * The ParticleContainer class is a really fast version of the Container built solely for speed,
	 * so use when you need a lot of sprites or particles.
	 *
	 * The tradeoff of the ParticleContainer is that most advanced functionality will not work.
	 * ParticleContainer implements the basic object transform (position, scale, rotation)
	 * and some advanced functionality like tint (as of v4.5.6).
	 *
	 * Other more advanced functionality like masking, children, filters, etc will not work on sprites in this batch.
	 *
	 * It's extremely easy to use:
	 * ```js
	 * let container = new ParticleContainer();
	 *
	 * for (let i = 0; i < 100; ++i)
	 * {
	 *     let sprite = PIXI.Sprite.from("myImage.png");
	 *     container.addChild(sprite);
	 * }
	 * ```
	 *
	 * And here you have a hundred sprites that will be rendered at the speed of light.
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI
	 */
	var ParticleContainer = /** @class */ (function (_super) {
	    __extends$4(ParticleContainer, _super);
	    /**
	     * @param {number} [maxSize=1500] - The maximum number of particles that can be rendered by the container.
	     *  Affects size of allocated buffers.
	     * @param {object} [properties] - The properties of children that should be uploaded to the gpu and applied.
	     * @param {boolean} [properties.vertices=false] - When true, vertices be uploaded and applied.
	     *                  if sprite's ` scale/anchor/trim/frame/orig` is dynamic, please set `true`.
	     * @param {boolean} [properties.position=true] - When true, position be uploaded and applied.
	     * @param {boolean} [properties.rotation=false] - When true, rotation be uploaded and applied.
	     * @param {boolean} [properties.uvs=false] - When true, uvs be uploaded and applied.
	     * @param {boolean} [properties.tint=false] - When true, alpha and tint be uploaded and applied.
	     * @param {number} [batchSize=16384] - Number of particles per batch. If less than maxSize, it uses maxSize instead.
	     * @param {boolean} [autoResize=false] - If true, container allocates more batches in case
	     *  there are more than `maxSize` particles.
	     */
	    function ParticleContainer(maxSize, properties, batchSize, autoResize) {
	        if (maxSize === void 0) { maxSize = 1500; }
	        if (batchSize === void 0) { batchSize = 16384; }
	        if (autoResize === void 0) { autoResize = false; }
	        var _this = _super.call(this) || this;
	        // Making sure the batch size is valid
	        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
	        // so max number of particles is 65536 / 4 = 16384
	        var maxBatchSize = 16384;
	        if (batchSize > maxBatchSize) {
	            batchSize = maxBatchSize;
	        }
	        /**
	         * Set properties to be dynamic (true) / static (false)
	         *
	         * @member {boolean[]}
	         * @private
	         */
	        _this._properties = [false, true, false, false, false];
	        /**
	         * @member {number}
	         * @private
	         */
	        _this._maxSize = maxSize;
	        /**
	         * @member {number}
	         * @private
	         */
	        _this._batchSize = batchSize;
	        /**
	         * @member {Array<PIXI.Buffer>}
	         * @private
	         */
	        _this._buffers = null;
	        /**
	         * for every batch stores _updateID corresponding to the last change in that batch
	         * @member {number[]}
	         * @private
	         */
	        _this._bufferUpdateIDs = [];
	        /**
	         * when child inserted, removed or changes position this number goes up
	         * @member {number[]}
	         * @private
	         */
	        _this._updateID = 0;
	        /**
	         * @member {boolean}
	         *
	         */
	        _this.interactiveChildren = false;
	        /**
	         * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL`
	         * to reset the blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         * @see PIXI.BLEND_MODES
	         */
	        _this.blendMode = exports.BLEND_MODES.NORMAL;
	        /**
	         * If true, container allocates more batches in case there are more than `maxSize` particles.
	         * @member {boolean}
	         * @default false
	         */
	        _this.autoResize = autoResize;
	        /**
	         * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
	         * Advantages can include sharper image quality (like text) and faster rendering on canvas.
	         * The main disadvantage is movement of objects may appear less smooth.
	         * Default to true here as performance is usually the priority for particles.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.roundPixels = true;
	        /**
	         * The texture used to render the children.
	         *
	         * @readonly
	         * @member {PIXI.BaseTexture}
	         */
	        _this.baseTexture = null;
	        _this.setProperties(properties);
	        /**
	         * The tint applied to the container.
	         * This is a hex value. A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @private
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        _this._tint = 0;
	        _this.tintRgb = new Float32Array(4);
	        _this.tint = 0xFFFFFF;
	        return _this;
	    }
	    /**
	     * Sets the private properties array to dynamic / static based on the passed properties object
	     *
	     * @param {object} properties - The properties to be uploaded
	     */
	    ParticleContainer.prototype.setProperties = function (properties) {
	        if (properties) {
	            this._properties[0] = 'vertices' in properties || 'scale' in properties
	                ? !!properties.vertices || !!properties.scale : this._properties[0];
	            this._properties[1] = 'position' in properties ? !!properties.position : this._properties[1];
	            this._properties[2] = 'rotation' in properties ? !!properties.rotation : this._properties[2];
	            this._properties[3] = 'uvs' in properties ? !!properties.uvs : this._properties[3];
	            this._properties[4] = 'tint' in properties || 'alpha' in properties
	                ? !!properties.tint || !!properties.alpha : this._properties[4];
	        }
	    };
	    /**
	     * Updates the object transform for rendering
	     *
	     * @private
	     */
	    ParticleContainer.prototype.updateTransform = function () {
	        // TODO don't need to!
	        this.displayObjectUpdateTransform();
	    };
	    Object.defineProperty(ParticleContainer.prototype, "tint", {
	        /**
	         * The tint applied to the container. This is a hex value.
	         * A value of 0xFFFFFF will remove any tint effect.
	         ** IMPORTANT: This is a WebGL only feature and will be ignored by the canvas renderer.
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        get: function () {
	            return this._tint;
	        },
	        set: function (value) {
	            this._tint = value;
	            hex2rgb(value, this.tintRgb);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Renders the container using the WebGL renderer
	     *
	     * @private
	     * @param {PIXI.Renderer} renderer - The webgl renderer
	     */
	    ParticleContainer.prototype.render = function (renderer) {
	        var _this = this;
	        if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) {
	            return;
	        }
	        if (!this.baseTexture) {
	            this.baseTexture = this.children[0]._texture.baseTexture;
	            if (!this.baseTexture.valid) {
	                this.baseTexture.once('update', function () { return _this.onChildrenChange(0); });
	            }
	        }
	        renderer.batch.setObjectRenderer(renderer.plugins.particle);
	        renderer.plugins.particle.render(this);
	    };
	    /**
	     * Set the flag that static data should be updated to true
	     *
	     * @private
	     * @param {number} smallestChildIndex - The smallest child index
	     */
	    ParticleContainer.prototype.onChildrenChange = function (smallestChildIndex) {
	        var bufferIndex = Math.floor(smallestChildIndex / this._batchSize);
	        while (this._bufferUpdateIDs.length < bufferIndex) {
	            this._bufferUpdateIDs.push(0);
	        }
	        this._bufferUpdateIDs[bufferIndex] = ++this._updateID;
	    };
	    ParticleContainer.prototype.dispose = function () {
	        if (this._buffers) {
	            for (var i = 0; i < this._buffers.length; ++i) {
	                this._buffers[i].destroy();
	            }
	            this._buffers = null;
	        }
	    };
	    /**
	     * Destroys the container
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their
	     *  destroy method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the texture of the child sprite
	     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the base texture of the child sprite
	     */
	    ParticleContainer.prototype.destroy = function (options) {
	        _super.prototype.destroy.call(this, options);
	        this.dispose();
	        this._properties = null;
	        this._buffers = null;
	        this._bufferUpdateIDs = null;
	    };
	    return ParticleContainer;
	}(Container));

	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that
	 * they now share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's ParticleBuffer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleBuffer.java
	 */
	/**
	 * The particle buffer manages the static and dynamic buffers for a particle container.
	 *
	 * @class
	 * @private
	 * @memberof PIXI
	 */
	var ParticleBuffer = /** @class */ (function () {
	    /**
	     * @private
	     * @param {object} properties - The properties to upload.
	     * @param {boolean[]} dynamicPropertyFlags - Flags for which properties are dynamic.
	     * @param {number} size - The size of the batch.
	     */
	    function ParticleBuffer(properties, dynamicPropertyFlags, size) {
	        this.geometry = new Geometry();
	        this.indexBuffer = null;
	        /**
	         * The number of particles the buffer can hold
	         *
	         * @private
	         * @member {number}
	         */
	        this.size = size;
	        /**
	         * A list of the properties that are dynamic.
	         *
	         * @private
	         * @member {object[]}
	         */
	        this.dynamicProperties = [];
	        /**
	         * A list of the properties that are static.
	         *
	         * @private
	         * @member {object[]}
	         */
	        this.staticProperties = [];
	        for (var i = 0; i < properties.length; ++i) {
	            var property = properties[i];
	            // Make copy of properties object so that when we edit the offset it doesn't
	            // change all other instances of the object literal
	            property = {
	                attributeName: property.attributeName,
	                size: property.size,
	                uploadFunction: property.uploadFunction,
	                type: property.type || exports.TYPES.FLOAT,
	                offset: property.offset,
	            };
	            if (dynamicPropertyFlags[i]) {
	                this.dynamicProperties.push(property);
	            }
	            else {
	                this.staticProperties.push(property);
	            }
	        }
	        this.staticStride = 0;
	        this.staticBuffer = null;
	        this.staticData = null;
	        this.staticDataUint32 = null;
	        this.dynamicStride = 0;
	        this.dynamicBuffer = null;
	        this.dynamicData = null;
	        this.dynamicDataUint32 = null;
	        this._updateID = 0;
	        this.initBuffers();
	    }
	    /**
	     * Sets up the renderer context and necessary buffers.
	     *
	     * @private
	     */
	    ParticleBuffer.prototype.initBuffers = function () {
	        var geometry = this.geometry;
	        var dynamicOffset = 0;
	        /**
	         * Holds the indices of the geometry (quads) to draw
	         *
	         * @member {Uint16Array}
	         * @private
	         */
	        this.indexBuffer = new Buffer(createIndicesForQuads(this.size), true, true);
	        geometry.addIndex(this.indexBuffer);
	        this.dynamicStride = 0;
	        for (var i = 0; i < this.dynamicProperties.length; ++i) {
	            var property = this.dynamicProperties[i];
	            property.offset = dynamicOffset;
	            dynamicOffset += property.size;
	            this.dynamicStride += property.size;
	        }
	        var dynBuffer = new ArrayBuffer(this.size * this.dynamicStride * 4 * 4);
	        this.dynamicData = new Float32Array(dynBuffer);
	        this.dynamicDataUint32 = new Uint32Array(dynBuffer);
	        this.dynamicBuffer = new Buffer(this.dynamicData, false, false);
	        // static //
	        var staticOffset = 0;
	        this.staticStride = 0;
	        for (var i = 0; i < this.staticProperties.length; ++i) {
	            var property = this.staticProperties[i];
	            property.offset = staticOffset;
	            staticOffset += property.size;
	            this.staticStride += property.size;
	        }
	        var statBuffer = new ArrayBuffer(this.size * this.staticStride * 4 * 4);
	        this.staticData = new Float32Array(statBuffer);
	        this.staticDataUint32 = new Uint32Array(statBuffer);
	        this.staticBuffer = new Buffer(this.staticData, true, false);
	        for (var i = 0; i < this.dynamicProperties.length; ++i) {
	            var property = this.dynamicProperties[i];
	            geometry.addAttribute(property.attributeName, this.dynamicBuffer, 0, property.type === exports.TYPES.UNSIGNED_BYTE, property.type, this.dynamicStride * 4, property.offset * 4);
	        }
	        for (var i = 0; i < this.staticProperties.length; ++i) {
	            var property = this.staticProperties[i];
	            geometry.addAttribute(property.attributeName, this.staticBuffer, 0, property.type === exports.TYPES.UNSIGNED_BYTE, property.type, this.staticStride * 4, property.offset * 4);
	        }
	    };
	    /**
	     * Uploads the dynamic properties.
	     *
	     * @private
	     * @param {PIXI.DisplayObject[]} children - The children to upload.
	     * @param {number} startIndex - The index to start at.
	     * @param {number} amount - The number to upload.
	     */
	    ParticleBuffer.prototype.uploadDynamic = function (children, startIndex, amount) {
	        for (var i = 0; i < this.dynamicProperties.length; i++) {
	            var property = this.dynamicProperties[i];
	            property.uploadFunction(children, startIndex, amount, property.type === exports.TYPES.UNSIGNED_BYTE ? this.dynamicDataUint32 : this.dynamicData, this.dynamicStride, property.offset);
	        }
	        this.dynamicBuffer._updateID++;
	    };
	    /**
	     * Uploads the static properties.
	     *
	     * @private
	     * @param {PIXI.DisplayObject[]} children - The children to upload.
	     * @param {number} startIndex - The index to start at.
	     * @param {number} amount - The number to upload.
	     */
	    ParticleBuffer.prototype.uploadStatic = function (children, startIndex, amount) {
	        for (var i = 0; i < this.staticProperties.length; i++) {
	            var property = this.staticProperties[i];
	            property.uploadFunction(children, startIndex, amount, property.type === exports.TYPES.UNSIGNED_BYTE ? this.staticDataUint32 : this.staticData, this.staticStride, property.offset);
	        }
	        this.staticBuffer._updateID++;
	    };
	    /**
	     * Destroys the ParticleBuffer.
	     *
	     * @private
	     */
	    ParticleBuffer.prototype.destroy = function () {
	        this.indexBuffer = null;
	        this.dynamicProperties = null;
	        this.dynamicBuffer = null;
	        this.dynamicData = null;
	        this.dynamicDataUint32 = null;
	        this.staticProperties = null;
	        this.staticBuffer = null;
	        this.staticData = null;
	        this.staticDataUint32 = null;
	        // all buffers are destroyed inside geometry
	        this.geometry.destroy();
	    };
	    return ParticleBuffer;
	}());

	var fragment$1 = "varying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nuniform sampler2D uSampler;\n\nvoid main(void){\n    vec4 color = texture2D(uSampler, vTextureCoord) * vColor;\n    gl_FragColor = color;\n}";

	var vertex$1 = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\n\nattribute vec2 aPositionCoord;\nattribute float aRotation;\n\nuniform mat3 translationMatrix;\nuniform vec4 uColor;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nvoid main(void){\n    float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);\n    float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);\n\n    vec2 v = vec2(x, y);\n    v = v + aPositionCoord;\n\n    gl_Position = vec4((translationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vColor = aColor * uColor;\n}\n";

	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
	 * share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's ParticleRenderer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleRenderer.java
	 */
	/**
	 * Renderer for Particles that is designer for speed over feature set.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var ParticleRenderer = /** @class */ (function (_super) {
	    __extends$4(ParticleRenderer, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - The renderer this sprite batch works for.
	     */
	    function ParticleRenderer(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
	        // so max number of particles is 65536 / 4 = 16384
	        // and max number of element in the index buffer is 16384 * 6 = 98304
	        // Creating a full index buffer, overhead is 98304 * 2 = 196Ko
	        // let numIndices = 98304;
	        /**
	         * The default shader that is used if a sprite doesn't have a more specific one.
	         *
	         * @member {PIXI.Shader}
	         */
	        _this.shader = null;
	        _this.properties = null;
	        _this.tempMatrix = new Matrix();
	        _this.properties = [
	            // verticesData
	            {
	                attributeName: 'aVertexPosition',
	                size: 2,
	                uploadFunction: _this.uploadVertices,
	                offset: 0,
	            },
	            // positionData
	            {
	                attributeName: 'aPositionCoord',
	                size: 2,
	                uploadFunction: _this.uploadPosition,
	                offset: 0,
	            },
	            // rotationData
	            {
	                attributeName: 'aRotation',
	                size: 1,
	                uploadFunction: _this.uploadRotation,
	                offset: 0,
	            },
	            // uvsData
	            {
	                attributeName: 'aTextureCoord',
	                size: 2,
	                uploadFunction: _this.uploadUvs,
	                offset: 0,
	            },
	            // tintData
	            {
	                attributeName: 'aColor',
	                size: 1,
	                type: exports.TYPES.UNSIGNED_BYTE,
	                uploadFunction: _this.uploadTint,
	                offset: 0,
	            } ];
	        _this.shader = Shader.from(vertex$1, fragment$1, {});
	        /**
	         * The WebGL state in which this renderer will work.
	         *
	         * @member {PIXI.State}
	         * @readonly
	         */
	        _this.state = State.for2d();
	        return _this;
	    }
	    /**
	     * Renders the particle container object.
	     *
	     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
	     */
	    ParticleRenderer.prototype.render = function (container) {
	        var children = container.children;
	        var maxSize = container._maxSize;
	        var batchSize = container._batchSize;
	        var renderer = this.renderer;
	        var totalChildren = children.length;
	        if (totalChildren === 0) {
	            return;
	        }
	        else if (totalChildren > maxSize && !container.autoResize) {
	            totalChildren = maxSize;
	        }
	        var buffers = container._buffers;
	        if (!buffers) {
	            buffers = container._buffers = this.generateBuffers(container);
	        }
	        var baseTexture = children[0]._texture.baseTexture;
	        // if the uvs have not updated then no point rendering just yet!
	        this.state.blendMode = correctBlendMode(container.blendMode, baseTexture.alphaMode);
	        renderer.state.set(this.state);
	        var gl = renderer.gl;
	        var m = container.worldTransform.copyTo(this.tempMatrix);
	        m.prepend(renderer.globalUniforms.uniforms.projectionMatrix);
	        this.shader.uniforms.translationMatrix = m.toArray(true);
	        this.shader.uniforms.uColor = premultiplyRgba(container.tintRgb, container.worldAlpha, this.shader.uniforms.uColor, baseTexture.alphaMode);
	        this.shader.uniforms.uSampler = baseTexture;
	        this.renderer.shader.bind(this.shader);
	        var updateStatic = false;
	        // now lets upload and render the buffers..
	        for (var i = 0, j = 0; i < totalChildren; i += batchSize, j += 1) {
	            var amount = (totalChildren - i);
	            if (amount > batchSize) {
	                amount = batchSize;
	            }
	            if (j >= buffers.length) {
	                buffers.push(this._generateOneMoreBuffer(container));
	            }
	            var buffer = buffers[j];
	            // we always upload the dynamic
	            buffer.uploadDynamic(children, i, amount);
	            var bid = container._bufferUpdateIDs[j] || 0;
	            updateStatic = updateStatic || (buffer._updateID < bid);
	            // we only upload the static content when we have to!
	            if (updateStatic) {
	                buffer._updateID = container._updateID;
	                buffer.uploadStatic(children, i, amount);
	            }
	            // bind the buffer
	            renderer.geometry.bind(buffer.geometry);
	            gl.drawElements(gl.TRIANGLES, amount * 6, gl.UNSIGNED_SHORT, 0);
	        }
	    };
	    /**
	     * Creates one particle buffer for each child in the container we want to render and updates internal properties
	     *
	     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
	     * @return {PIXI.ParticleBuffer[]} The buffers
	     * @private
	     */
	    ParticleRenderer.prototype.generateBuffers = function (container) {
	        var buffers = [];
	        var size = container._maxSize;
	        var batchSize = container._batchSize;
	        var dynamicPropertyFlags = container._properties;
	        for (var i = 0; i < size; i += batchSize) {
	            buffers.push(new ParticleBuffer(this.properties, dynamicPropertyFlags, batchSize));
	        }
	        return buffers;
	    };
	    /**
	     * Creates one more particle buffer, because container has autoResize feature
	     *
	     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
	     * @return {PIXI.ParticleBuffer} generated buffer
	     * @private
	     */
	    ParticleRenderer.prototype._generateOneMoreBuffer = function (container) {
	        var batchSize = container._batchSize;
	        var dynamicPropertyFlags = container._properties;
	        return new ParticleBuffer(this.properties, dynamicPropertyFlags, batchSize);
	    };
	    /**
	     * Uploads the vertices.
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their vertices uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */
	    ParticleRenderer.prototype.uploadVertices = function (children, startIndex, amount, array, stride, offset) {
	        var w0 = 0;
	        var w1 = 0;
	        var h0 = 0;
	        var h1 = 0;
	        for (var i = 0; i < amount; ++i) {
	            var sprite = children[startIndex + i];
	            var texture = sprite._texture;
	            var sx = sprite.scale.x;
	            var sy = sprite.scale.y;
	            var trim = texture.trim;
	            var orig = texture.orig;
	            if (trim) {
	                // if the sprite is trimmed and is not a tilingsprite then we need to add the
	                // extra space before transforming the sprite coords..
	                w1 = trim.x - (sprite.anchor.x * orig.width);
	                w0 = w1 + trim.width;
	                h1 = trim.y - (sprite.anchor.y * orig.height);
	                h0 = h1 + trim.height;
	            }
	            else {
	                w0 = (orig.width) * (1 - sprite.anchor.x);
	                w1 = (orig.width) * -sprite.anchor.x;
	                h0 = orig.height * (1 - sprite.anchor.y);
	                h1 = orig.height * -sprite.anchor.y;
	            }
	            array[offset] = w1 * sx;
	            array[offset + 1] = h1 * sy;
	            array[offset + stride] = w0 * sx;
	            array[offset + stride + 1] = h1 * sy;
	            array[offset + (stride * 2)] = w0 * sx;
	            array[offset + (stride * 2) + 1] = h0 * sy;
	            array[offset + (stride * 3)] = w1 * sx;
	            array[offset + (stride * 3) + 1] = h0 * sy;
	            offset += stride * 4;
	        }
	    };
	    /**
	     * Uploads the position.
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their positions uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */
	    ParticleRenderer.prototype.uploadPosition = function (children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; i++) {
	            var spritePosition = children[startIndex + i].position;
	            array[offset] = spritePosition.x;
	            array[offset + 1] = spritePosition.y;
	            array[offset + stride] = spritePosition.x;
	            array[offset + stride + 1] = spritePosition.y;
	            array[offset + (stride * 2)] = spritePosition.x;
	            array[offset + (stride * 2) + 1] = spritePosition.y;
	            array[offset + (stride * 3)] = spritePosition.x;
	            array[offset + (stride * 3) + 1] = spritePosition.y;
	            offset += stride * 4;
	        }
	    };
	    /**
	     * Uploads the rotation.
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their rotation uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */
	    ParticleRenderer.prototype.uploadRotation = function (children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; i++) {
	            var spriteRotation = children[startIndex + i].rotation;
	            array[offset] = spriteRotation;
	            array[offset + stride] = spriteRotation;
	            array[offset + (stride * 2)] = spriteRotation;
	            array[offset + (stride * 3)] = spriteRotation;
	            offset += stride * 4;
	        }
	    };
	    /**
	     * Uploads the Uvs
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their rotation uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */
	    ParticleRenderer.prototype.uploadUvs = function (children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; ++i) {
	            var textureUvs = children[startIndex + i]._texture._uvs;
	            if (textureUvs) {
	                array[offset] = textureUvs.x0;
	                array[offset + 1] = textureUvs.y0;
	                array[offset + stride] = textureUvs.x1;
	                array[offset + stride + 1] = textureUvs.y1;
	                array[offset + (stride * 2)] = textureUvs.x2;
	                array[offset + (stride * 2) + 1] = textureUvs.y2;
	                array[offset + (stride * 3)] = textureUvs.x3;
	                array[offset + (stride * 3) + 1] = textureUvs.y3;
	                offset += stride * 4;
	            }
	            else {
	                // TODO you know this can be easier!
	                array[offset] = 0;
	                array[offset + 1] = 0;
	                array[offset + stride] = 0;
	                array[offset + stride + 1] = 0;
	                array[offset + (stride * 2)] = 0;
	                array[offset + (stride * 2) + 1] = 0;
	                array[offset + (stride * 3)] = 0;
	                array[offset + (stride * 3) + 1] = 0;
	                offset += stride * 4;
	            }
	        }
	    };
	    /**
	     * Uploads the tint.
	     *
	     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
	     * @param {number} startIndex - the index to start from in the children array
	     * @param {number} amount - the amount of children that will have their rotation uploaded
	     * @param {number[]} array - The vertices to upload.
	     * @param {number} stride - Stride to use for iteration.
	     * @param {number} offset - Offset to start at.
	     */
	    ParticleRenderer.prototype.uploadTint = function (children, startIndex, amount, array, stride, offset) {
	        for (var i = 0; i < amount; ++i) {
	            var sprite = children[startIndex + i];
	            var premultiplied = sprite._texture.baseTexture.alphaMode > 0;
	            var alpha = sprite.alpha;
	            // we dont call extra function if alpha is 1.0, that's faster
	            var argb = alpha < 1.0 && premultiplied
	                ? premultiplyTint(sprite._tintRGB, alpha) : sprite._tintRGB + (alpha * 255 << 24);
	            array[offset] = argb;
	            array[offset + stride] = argb;
	            array[offset + (stride * 2)] = argb;
	            array[offset + (stride * 3)] = argb;
	            offset += stride * 4;
	        }
	    };
	    /**
	     * Destroys the ParticleRenderer.
	     */
	    ParticleRenderer.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        if (this.shader) {
	            this.shader.destroy();
	            this.shader = null;
	        }
	        this.tempMatrix = null;
	    };
	    return ParticleRenderer;
	}(ObjectRenderer));

	/*!
	 * @pixi/graphics - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/graphics is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * Supported line joints in `PIXI.LineStyle` for graphics.
	 *
	 * @see PIXI.Graphics#lineStyle
	 * @see https://graphicdesign.stackexchange.com/questions/59018/what-is-a-bevel-join-of-two-lines-exactly-illustrator
	 *
	 * @name LINE_JOIN
	 * @memberof PIXI
	 * @static
	 * @enum {string}
	 * @property {string} MITER - 'miter': make a sharp corner where outer part of lines meet
	 * @property {string} BEVEL - 'bevel': add a square butt at each end of line segment and fill the triangle at turn
	 * @property {string} ROUND - 'round': add an arc at the joint
	 */

	(function (LINE_JOIN) {
	    LINE_JOIN["MITER"] = "miter";
	    LINE_JOIN["BEVEL"] = "bevel";
	    LINE_JOIN["ROUND"] = "round";
	})(exports.LINE_JOIN || (exports.LINE_JOIN = {}));
	/**
	 * Support line caps in `PIXI.LineStyle` for graphics.
	 *
	 * @see PIXI.Graphics#lineStyle
	 *
	 * @name LINE_CAP
	 * @memberof PIXI
	 * @static
	 * @enum {string}
	 * @property {string} BUTT - 'butt': don't add any cap at line ends (leaves orthogonal edges)
	 * @property {string} ROUND - 'round': add semicircle at ends
	 * @property {string} SQUARE - 'square': add square at end (like `BUTT` except more length at end)
	 */

	(function (LINE_CAP) {
	    LINE_CAP["BUTT"] = "butt";
	    LINE_CAP["ROUND"] = "round";
	    LINE_CAP["SQUARE"] = "square";
	})(exports.LINE_CAP || (exports.LINE_CAP = {}));
	/**
	 * Graphics curves resolution settings. If `adaptive` flag is set to `true`,
	 * the resolution is calculated based on the curve's length to ensure better visual quality.
	 * Adaptive draw works with `bezierCurveTo` and `quadraticCurveTo`.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name GRAPHICS_CURVES
	 * @type {object}
	 * @property {boolean} adaptive=false - flag indicating if the resolution should be adaptive
	 * @property {number} maxLength=10 - maximal length of a single segment of the curve (if adaptive = false, ignored)
	 * @property {number} minSegments=8 - minimal number of segments in the curve (if adaptive = false, ignored)
	 * @property {number} maxSegments=2048 - maximal number of segments in the curve (if adaptive = false, ignored)
	 */
	var GRAPHICS_CURVES = {
	    adaptive: true,
	    maxLength: 10,
	    minSegments: 8,
	    maxSegments: 2048,
	    epsilon: 0.0001,
	    _segmentsCount: function (length, defaultSegments) {
	        if (defaultSegments === void 0) { defaultSegments = 20; }
	        if (!this.adaptive || !length || isNaN(length)) {
	            return defaultSegments;
	        }
	        var result = Math.ceil(length / this.maxLength);
	        if (result < this.minSegments) {
	            result = this.minSegments;
	        }
	        else if (result > this.maxSegments) {
	            result = this.maxSegments;
	        }
	        return result;
	    },
	};

	/**
	 * Fill style object for Graphics.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var FillStyle = /** @class */ (function () {
	    function FillStyle() {
	        /**
	         * The hex color value used when coloring the Graphics object.
	         *
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        this.color = 0xFFFFFF;
	        /**
	         * The alpha value used when filling the Graphics object.
	         *
	         * @member {number}
	         * @default 1
	         */
	        this.alpha = 1.0;
	        /**
	         * The texture to be used for the fill.
	         *
	         * @member {PIXI.Texture}
	         * @default 0
	         */
	        this.texture = Texture.WHITE;
	        /**
	         * The transform aplpied to the texture.
	         *
	         * @member {PIXI.Matrix}
	         * @default null
	         */
	        this.matrix = null;
	        /**
	         * If the current fill is visible.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        this.visible = false;
	        this.reset();
	    }
	    /**
	     * Clones the object
	     *
	     * @return {PIXI.FillStyle}
	     */
	    FillStyle.prototype.clone = function () {
	        var obj = new FillStyle();
	        obj.color = this.color;
	        obj.alpha = this.alpha;
	        obj.texture = this.texture;
	        obj.matrix = this.matrix;
	        obj.visible = this.visible;
	        return obj;
	    };
	    /**
	     * Reset
	     */
	    FillStyle.prototype.reset = function () {
	        this.color = 0xFFFFFF;
	        this.alpha = 1;
	        this.texture = Texture.WHITE;
	        this.matrix = null;
	        this.visible = false;
	    };
	    /**
	     * Destroy and don't use after this
	     */
	    FillStyle.prototype.destroy = function () {
	        this.texture = null;
	        this.matrix = null;
	    };
	    return FillStyle;
	}());

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$5 = function(d, b) {
	    extendStatics$5 = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$5(d, b);
	};

	function __extends$5(d, b) {
	    extendStatics$5(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	/**
	 * Builds a polygon to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the WebGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the WebGL-specific information to create nativeLines
	 */
	var buildPoly = {
	    build: function (graphicsData) {
	        graphicsData.points = graphicsData.shape.points.slice();
	    },
	    triangulate: function (graphicsData, graphicsGeometry) {
	        var points = graphicsData.points;
	        var holes = graphicsData.holes;
	        var verts = graphicsGeometry.points;
	        var indices = graphicsGeometry.indices;
	        if (points.length >= 6) {
	            var holeArray = [];
	            // Process holes..
	            for (var i = 0; i < holes.length; i++) {
	                var hole = holes[i];
	                holeArray.push(points.length / 2);
	                points = points.concat(hole.points);
	            }
	            // sort color
	            var triangles = earcut_1(points, holeArray, 2);
	            if (!triangles) {
	                return;
	            }
	            var vertPos = verts.length / 2;
	            for (var i = 0; i < triangles.length; i += 3) {
	                indices.push(triangles[i] + vertPos);
	                indices.push(triangles[i + 1] + vertPos);
	                indices.push(triangles[i + 2] + vertPos);
	            }
	            for (var i = 0; i < points.length; i++) {
	                verts.push(points[i]);
	            }
	        }
	    },
	};

	// for type only
	/**
	 * Builds a circle to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object to draw
	 * @param {object} webGLData - an object containing all the WebGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the WebGL-specific information to create nativeLines
	 */
	var buildCircle = {
	    build: function (graphicsData) {
	        // need to convert points to a nice regular data
	        var circleData = graphicsData.shape;
	        var points = graphicsData.points;
	        var x = circleData.x;
	        var y = circleData.y;
	        var width;
	        var height;
	        points.length = 0;
	        // TODO - bit hacky??
	        if (graphicsData.type === exports.SHAPES.CIRC) {
	            width = circleData.radius;
	            height = circleData.radius;
	        }
	        else {
	            var ellipseData = graphicsData.shape;
	            width = ellipseData.width;
	            height = ellipseData.height;
	        }
	        if (width === 0 || height === 0) {
	            return;
	        }
	        var totalSegs = Math.floor(30 * Math.sqrt(circleData.radius))
	            || Math.floor(15 * Math.sqrt(width + height));
	        totalSegs /= 2.3;
	        var seg = (Math.PI * 2) / totalSegs;
	        for (var i = 0; i < totalSegs - 0.5; i++) {
	            points.push(x + (Math.sin(-seg * i) * width), y + (Math.cos(-seg * i) * height));
	        }
	        points.push(points[0], points[1]);
	    },
	    triangulate: function (graphicsData, graphicsGeometry) {
	        var points = graphicsData.points;
	        var verts = graphicsGeometry.points;
	        var indices = graphicsGeometry.indices;
	        var vertPos = verts.length / 2;
	        var center = vertPos;
	        var circle = (graphicsData.shape);
	        var matrix = graphicsData.matrix;
	        var x = circle.x;
	        var y = circle.y;
	        // Push center (special point)
	        verts.push(graphicsData.matrix ? (matrix.a * x) + (matrix.c * y) + matrix.tx : x, graphicsData.matrix ? (matrix.b * x) + (matrix.d * y) + matrix.ty : y);
	        for (var i = 0; i < points.length; i += 2) {
	            verts.push(points[i], points[i + 1]);
	            // add some uvs
	            indices.push(vertPos++, center, vertPos);
	        }
	    },
	};

	/**
	 * Builds a rectangle to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the WebGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the WebGL-specific information to create nativeLines
	 */
	var buildRectangle = {
	    build: function (graphicsData) {
	        // --- //
	        // need to convert points to a nice regular data
	        //
	        var rectData = graphicsData.shape;
	        var x = rectData.x;
	        var y = rectData.y;
	        var width = rectData.width;
	        var height = rectData.height;
	        var points = graphicsData.points;
	        points.length = 0;
	        points.push(x, y, x + width, y, x + width, y + height, x, y + height);
	    },
	    triangulate: function (graphicsData, graphicsGeometry) {
	        var points = graphicsData.points;
	        var verts = graphicsGeometry.points;
	        var vertPos = verts.length / 2;
	        verts.push(points[0], points[1], points[2], points[3], points[6], points[7], points[4], points[5]);
	        graphicsGeometry.indices.push(vertPos, vertPos + 1, vertPos + 2, vertPos + 1, vertPos + 2, vertPos + 3);
	    },
	};

	/**
	 * Calculate a single point for a quadratic bezier curve.
	 * Utility function used by quadraticBezierCurve.
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {number} n1 - first number
	 * @param {number} n2 - second number
	 * @param {number} perc - percentage
	 * @return {number} the result
	 *
	 */
	function getPt(n1, n2, perc) {
	    var diff = n2 - n1;
	    return n1 + (diff * perc);
	}
	/**
	 * Calculate the points for a quadratic bezier curve. (helper function..)
	 * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {number} fromX - Origin point x
	 * @param {number} fromY - Origin point x
	 * @param {number} cpX - Control point x
	 * @param {number} cpY - Control point y
	 * @param {number} toX - Destination point x
	 * @param {number} toY - Destination point y
	 * @param {number[]} [out=[]] - The output array to add points into. If not passed, a new array is created.
	 * @return {number[]} an array of points
	 */
	function quadraticBezierCurve(fromX, fromY, cpX, cpY, toX, toY, out) {
	    if (out === void 0) { out = []; }
	    var n = 20;
	    var points = out;
	    var xa = 0;
	    var ya = 0;
	    var xb = 0;
	    var yb = 0;
	    var x = 0;
	    var y = 0;
	    for (var i = 0, j = 0; i <= n; ++i) {
	        j = i / n;
	        // The Green Line
	        xa = getPt(fromX, cpX, j);
	        ya = getPt(fromY, cpY, j);
	        xb = getPt(cpX, toX, j);
	        yb = getPt(cpY, toY, j);
	        // The Black Dot
	        x = getPt(xa, xb, j);
	        y = getPt(ya, yb, j);
	        points.push(x, y);
	    }
	    return points;
	}
	/**
	 * Builds a rounded rectangle to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {object} webGLData - an object containing all the WebGL-specific information to create this shape
	 * @param {object} webGLDataNativeLines - an object containing all the WebGL-specific information to create nativeLines
	 */
	var buildRoundedRectangle = {
	    build: function (graphicsData) {
	        var rrectData = graphicsData.shape;
	        var points = graphicsData.points;
	        var x = rrectData.x;
	        var y = rrectData.y;
	        var width = rrectData.width;
	        var height = rrectData.height;
	        // Don't allow negative radius or greater than half the smallest width
	        var radius = Math.max(0, Math.min(rrectData.radius, Math.min(width, height) / 2));
	        points.length = 0;
	        // No radius, do a simple rectangle
	        if (!radius) {
	            points.push(x, y, x + width, y, x + width, y + height, x, y + height);
	        }
	        else {
	            quadraticBezierCurve(x, y + radius, x, y, x + radius, y, points);
	            quadraticBezierCurve(x + width - radius, y, x + width, y, x + width, y + radius, points);
	            quadraticBezierCurve(x + width, y + height - radius, x + width, y + height, x + width - radius, y + height, points);
	            quadraticBezierCurve(x + radius, y + height, x, y + height, x, y + height - radius, points);
	        }
	        // this tiny number deals with the issue that occurs when points overlap and earcut fails to triangulate the item.
	        // TODO - fix this properly, this is not very elegant.. but it works for now.
	    },
	    triangulate: function (graphicsData, graphicsGeometry) {
	        var points = graphicsData.points;
	        var verts = graphicsGeometry.points;
	        var indices = graphicsGeometry.indices;
	        var vecPos = verts.length / 2;
	        var triangles = earcut_1(points, null, 2);
	        for (var i = 0, j = triangles.length; i < j; i += 3) {
	            indices.push(triangles[i] + vecPos);
	            //     indices.push(triangles[i] + vecPos);
	            indices.push(triangles[i + 1] + vecPos);
	            //   indices.push(triangles[i + 2] + vecPos);
	            indices.push(triangles[i + 2] + vecPos);
	        }
	        for (var i = 0, j = points.length; i < j; i++) {
	            verts.push(points[i], points[++i]);
	        }
	    },
	};

	/**
	 * Buffers vertices to draw a square cap.
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {number} x - X-coord of end point
	 * @param {number} y - Y-coord of end point
	 * @param {number} nx - X-coord of line normal pointing inside
	 * @param {number} ny - Y-coord of line normal pointing inside
	 * @param {Array<number>} verts - vertex buffer
	 * @returns {}
	 */
	function square(x, y, nx, ny, innerWeight, outerWeight, clockwise, /* rotation for square (true at left end, false at right end) */ verts) {
	    var ix = x - (nx * innerWeight);
	    var iy = y - (ny * innerWeight);
	    var ox = x + (nx * outerWeight);
	    var oy = y + (ny * outerWeight);
	    /* Rotate nx,ny for extension vector */
	    var exx;
	    var eyy;
	    if (clockwise) {
	        exx = ny;
	        eyy = -nx;
	    }
	    else {
	        exx = -ny;
	        eyy = nx;
	    }
	    /* [i|0]x,y extended at cap */
	    var eix = ix + exx;
	    var eiy = iy + eyy;
	    var eox = ox + exx;
	    var eoy = oy + eyy;
	    /* Square itself must be inserted clockwise*/
	    verts.push(eix, eiy);
	    verts.push(eox, eoy);
	    return 2;
	}
	/**
	 * Buffers vertices to draw an arc at the line joint or cap.
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {number} cx - X-coord of center
	 * @param {number} cy - Y-coord of center
	 * @param {number} sx - X-coord of arc start
	 * @param {number} sy - Y-coord of arc start
	 * @param {number} ex - X-coord of arc end
	 * @param {number} ey - Y-coord of arc end
	 * @param {Array<number>} verts - buffer of vertices
	 * @param {boolean} clockwise - orientation of vertices
	 * @returns {number} - no. of vertices pushed
	 */
	function round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
	    var cx2p0x = sx - cx;
	    var cy2p0y = sy - cy;
	    var angle0 = Math.atan2(cx2p0x, cy2p0y);
	    var angle1 = Math.atan2(ex - cx, ey - cy);
	    if (clockwise && angle0 < angle1) {
	        angle0 += Math.PI * 2;
	    }
	    else if (!clockwise && angle0 > angle1) {
	        angle1 += Math.PI * 2;
	    }
	    var startAngle = angle0;
	    var angleDiff = angle1 - angle0;
	    var absAngleDiff = Math.abs(angleDiff);
	    /* if (absAngleDiff >= PI_LBOUND && absAngleDiff <= PI_UBOUND)
	    {
	        const r1x = cx - nxtPx;
	        const r1y = cy - nxtPy;

	        if (r1x === 0)
	        {
	            if (r1y > 0)
	            {
	                angleDiff = -angleDiff;
	            }
	        }
	        else if (r1x >= -GRAPHICS_CURVES.epsilon)
	        {
	            angleDiff = -angleDiff;
	        }
	    }*/
	    var radius = Math.sqrt((cx2p0x * cx2p0x) + (cy2p0y * cy2p0y));
	    var segCount = ((15 * absAngleDiff * Math.sqrt(radius) / Math.PI) >> 0) + 1;
	    var angleInc = angleDiff / segCount;
	    startAngle += angleInc;
	    if (clockwise) {
	        verts.push(cx, cy);
	        verts.push(sx, sy);
	        for (var i = 1, angle = startAngle; i < segCount; i++, angle += angleInc) {
	            verts.push(cx, cy);
	            verts.push(cx + ((Math.sin(angle) * radius)), cy + ((Math.cos(angle) * radius)));
	        }
	        verts.push(cx, cy);
	        verts.push(ex, ey);
	    }
	    else {
	        verts.push(sx, sy);
	        verts.push(cx, cy);
	        for (var i = 1, angle = startAngle; i < segCount; i++, angle += angleInc) {
	            verts.push(cx + ((Math.sin(angle) * radius)), cy + ((Math.cos(angle) * radius)));
	            verts.push(cx, cy);
	        }
	        verts.push(ex, ey);
	        verts.push(cx, cy);
	    }
	    return segCount * 2;
	}
	/**
	 * Builds a line to draw using the polygon method.
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.GraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {PIXI.GraphicsGeometry} graphicsGeometry - Geometry where to append output
	 */
	function buildNonNativeLine(graphicsData, graphicsGeometry) {
	    var shape = graphicsData.shape;
	    var points = graphicsData.points || shape.points.slice();
	    var eps = graphicsGeometry.closePointEps;
	    if (points.length === 0) {
	        return;
	    }
	    // if the line width is an odd number add 0.5 to align to a whole pixel
	    // commenting this out fixes #711 and #1620
	    // if (graphicsData.lineWidth%2)
	    // {
	    //     for (i = 0; i < points.length; i++)
	    //     {
	    //         points[i] += 0.5;
	    //     }
	    // }
	    var style = graphicsData.lineStyle;
	    // get first and last point.. figure out the middle!
	    var firstPoint = new Point(points[0], points[1]);
	    var lastPoint = new Point(points[points.length - 2], points[points.length - 1]);
	    var closedShape = shape.type !== exports.SHAPES.POLY || shape.closeStroke;
	    var closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps
	        && Math.abs(firstPoint.y - lastPoint.y) < eps;
	    // if the first point is the last point - gonna have issues :)
	    if (closedShape) {
	        // need to clone as we are going to slightly modify the shape..
	        points = points.slice();
	        if (closedPath) {
	            points.pop();
	            points.pop();
	            lastPoint.set(points[points.length - 2], points[points.length - 1]);
	        }
	        var midPointX = (firstPoint.x + lastPoint.x) * 0.5;
	        var midPointY = (lastPoint.y + firstPoint.y) * 0.5;
	        points.unshift(midPointX, midPointY);
	        points.push(midPointX, midPointY);
	    }
	    var verts = graphicsGeometry.points;
	    var length = points.length / 2;
	    var indexCount = points.length;
	    var indexStart = verts.length / 2;
	    // Max. inner and outer width
	    var width = style.width / 2;
	    var widthSquared = width * width;
	    var miterLimitSquared = style.miterLimit * style.miterLimit;
	    /* Line segments of interest where (x1,y1) forms the corner. */
	    var x0 = points[0];
	    var y0 = points[1];
	    var x1 = points[2];
	    var y1 = points[3];
	    var x2 = 0;
	    var y2 = 0;
	    /* perp[?](x|y) = the line normal with magnitude lineWidth. */
	    var perpx = -(y0 - y1);
	    var perpy = x0 - x1;
	    var perp1x = 0;
	    var perp1y = 0;
	    var dist = Math.sqrt((perpx * perpx) + (perpy * perpy));
	    perpx /= dist;
	    perpy /= dist;
	    perpx *= width;
	    perpy *= width;
	    var ratio = style.alignment; // 0.5;
	    var innerWeight = (1 - ratio) * 2;
	    var outerWeight = ratio * 2;
	    if (!closedShape) {
	        if (style.cap === exports.LINE_CAP.ROUND) {
	            indexCount += round(x0 - (perpx * (innerWeight - outerWeight) * 0.5), y0 - (perpy * (innerWeight - outerWeight) * 0.5), x0 - (perpx * innerWeight), y0 - (perpy * innerWeight), x0 + (perpx * outerWeight), y0 + (perpy * outerWeight), verts, true) + 2;
	        }
	        else if (style.cap === exports.LINE_CAP.SQUARE) {
	            indexCount += square(x0, y0, perpx, perpy, innerWeight, outerWeight, true, verts);
	        }
	    }
	    // Push first point (below & above vertices)
	    verts.push(x0 - (perpx * innerWeight), y0 - (perpy * innerWeight));
	    verts.push(x0 + (perpx * outerWeight), y0 + (perpy * outerWeight));
	    for (var i = 1; i < length - 1; ++i) {
	        x0 = points[(i - 1) * 2];
	        y0 = points[((i - 1) * 2) + 1];
	        x1 = points[i * 2];
	        y1 = points[(i * 2) + 1];
	        x2 = points[(i + 1) * 2];
	        y2 = points[((i + 1) * 2) + 1];
	        perpx = -(y0 - y1);
	        perpy = x0 - x1;
	        dist = Math.sqrt((perpx * perpx) + (perpy * perpy));
	        perpx /= dist;
	        perpy /= dist;
	        perpx *= width;
	        perpy *= width;
	        perp1x = -(y1 - y2);
	        perp1y = x1 - x2;
	        dist = Math.sqrt((perp1x * perp1x) + (perp1y * perp1y));
	        perp1x /= dist;
	        perp1y /= dist;
	        perp1x *= width;
	        perp1y *= width;
	        /* d[x|y](0|1) = the component displacment between points p(0,1|1,2) */
	        var dx0 = x1 - x0;
	        var dy0 = y0 - y1;
	        var dx1 = x1 - x2;
	        var dy1 = y2 - y1;
	        /* +ve if internal angle counterclockwise, -ve if internal angle clockwise. */
	        var cross = (dy0 * dx1) - (dy1 * dx0);
	        var clockwise = (cross < 0);
	        /* Going nearly straight? */
	        if (Math.abs(cross) < 0.1) {
	            verts.push(x1 - (perpx * innerWeight), y1 - (perpy * innerWeight));
	            verts.push(x1 + (perpx * outerWeight), y1 + (perpy * outerWeight));
	            continue;
	        }
	        /* p[x|y] is the miter point. pdist is the distance between miter point and p1. */
	        var c1 = ((-perpx + x0) * (-perpy + y1)) - ((-perpx + x1) * (-perpy + y0));
	        var c2 = ((-perp1x + x2) * (-perp1y + y1)) - ((-perp1x + x1) * (-perp1y + y2));
	        var px = ((dx0 * c2) - (dx1 * c1)) / cross;
	        var py = ((dy1 * c1) - (dy0 * c2)) / cross;
	        var pdist = ((px - x1) * (px - x1)) + ((py - y1) * (py - y1));
	        /* Inner miter point */
	        var imx = x1 + ((px - x1) * innerWeight);
	        var imy = y1 + ((py - y1) * innerWeight);
	        /* Outer miter point */
	        var omx = x1 - ((px - x1) * outerWeight);
	        var omy = y1 - ((py - y1) * outerWeight);
	        /* Is the inside miter point too far away, creating a spike? */
	        var smallerInsideSegmentSq = Math.min((dx0 * dx0) + (dy0 * dy0), (dx1 * dx1) + (dy1 * dy1));
	        var insideWeight = clockwise ? innerWeight : outerWeight;
	        var smallerInsideDiagonalSq = smallerInsideSegmentSq + (insideWeight * insideWeight * widthSquared);
	        var insideMiterOk = pdist <= smallerInsideDiagonalSq;
	        if (insideMiterOk) {
	            if (style.join === exports.LINE_JOIN.BEVEL || pdist / widthSquared > miterLimitSquared) {
	                if (clockwise) /* rotating at inner angle */ {
	                    verts.push(imx, imy); // inner miter point
	                    verts.push(x1 + (perpx * outerWeight), y1 + (perpy * outerWeight)); // first segment's outer vertex
	                    verts.push(imx, imy); // inner miter point
	                    verts.push(x1 + (perp1x * outerWeight), y1 + (perp1y * outerWeight)); // second segment's outer vertex
	                }
	                else /* rotating at outer angle */ {
	                    verts.push(x1 - (perpx * innerWeight), y1 - (perpy * innerWeight)); // first segment's inner vertex
	                    verts.push(omx, omy); // outer miter point
	                    verts.push(x1 - (perp1x * innerWeight), y1 - (perp1y * innerWeight)); // second segment's outer vertex
	                    verts.push(omx, omy); // outer miter point
	                }
	                indexCount += 2;
	            }
	            else if (style.join === exports.LINE_JOIN.ROUND) {
	                if (clockwise) /* arc is outside */ {
	                    verts.push(imx, imy);
	                    verts.push(x1 + (perpx * outerWeight), y1 + (perpy * outerWeight));
	                    indexCount += round(x1, y1, x1 + (perpx * outerWeight), y1 + (perpy * outerWeight), x1 + (perp1x * outerWeight), y1 + (perp1y * outerWeight), verts, true) + 4;
	                    verts.push(imx, imy);
	                    verts.push(x1 + (perp1x * outerWeight), y1 + (perp1y * outerWeight));
	                }
	                else /* arc is inside */ {
	                    verts.push(x1 - (perpx * innerWeight), y1 - (perpy * innerWeight));
	                    verts.push(omx, omy);
	                    indexCount += round(x1, y1, x1 - (perpx * innerWeight), y1 - (perpy * innerWeight), x1 - (perp1x * innerWeight), y1 - (perp1y * innerWeight), verts, false) + 4;
	                    verts.push(x1 - (perp1x * innerWeight), y1 - (perp1y * innerWeight));
	                    verts.push(omx, omy);
	                }
	            }
	            else {
	                verts.push(imx, imy);
	                verts.push(omx, omy);
	            }
	        }
	        else // inside miter is NOT ok
	         {
	            verts.push(x1 - (perpx * innerWeight), y1 - (perpy * innerWeight)); // first segment's inner vertex
	            verts.push(x1 + (perpx * outerWeight), y1 + (perpy * outerWeight)); // first segment's outer vertex
	            if (style.join === exports.LINE_JOIN.BEVEL || pdist / widthSquared > miterLimitSquared) { ; }
	            else if (style.join === exports.LINE_JOIN.ROUND) {
	                if (clockwise) /* arc is outside */ {
	                    indexCount += round(x1, y1, x1 + (perpx * outerWeight), y1 + (perpy * outerWeight), x1 + (perp1x * outerWeight), y1 + (perp1y * outerWeight), verts, true) + 2;
	                }
	                else /* arc is inside */ {
	                    indexCount += round(x1, y1, x1 - (perpx * innerWeight), y1 - (perpy * innerWeight), x1 - (perp1x * innerWeight), y1 - (perp1y * innerWeight), verts, false) + 2;
	                }
	            }
	            else {
	                if (clockwise) {
	                    verts.push(omx, omy); // inner miter point
	                    verts.push(omx, omy); // inner miter point
	                }
	                else {
	                    verts.push(imx, imy); // outer miter point
	                    verts.push(imx, imy); // outer miter point
	                }
	                indexCount += 2;
	            }
	            verts.push(x1 - (perp1x * innerWeight), y1 - (perp1y * innerWeight)); // second segment's inner vertex
	            verts.push(x1 + (perp1x * outerWeight), y1 + (perp1y * outerWeight)); // second segment's outer vertex
	            indexCount += 2;
	        }
	    }
	    x0 = points[(length - 2) * 2];
	    y0 = points[((length - 2) * 2) + 1];
	    x1 = points[(length - 1) * 2];
	    y1 = points[((length - 1) * 2) + 1];
	    perpx = -(y0 - y1);
	    perpy = x0 - x1;
	    dist = Math.sqrt((perpx * perpx) + (perpy * perpy));
	    perpx /= dist;
	    perpy /= dist;
	    perpx *= width;
	    perpy *= width;
	    verts.push(x1 - (perpx * innerWeight), y1 - (perpy * innerWeight));
	    verts.push(x1 + (perpx * outerWeight), y1 + (perpy * outerWeight));
	    if (!closedShape) {
	        if (style.cap === exports.LINE_CAP.ROUND) {
	            indexCount += round(x1 - (perpx * (innerWeight - outerWeight) * 0.5), y1 - (perpy * (innerWeight - outerWeight) * 0.5), x1 - (perpx * innerWeight), y1 - (perpy * innerWeight), x1 + (perpx * outerWeight), y1 + (perpy * outerWeight), verts, false) + 2;
	        }
	        else if (style.cap === exports.LINE_CAP.SQUARE) {
	            indexCount += square(x1, y1, perpx, perpy, innerWeight, outerWeight, false, verts);
	        }
	    }
	    var indices = graphicsGeometry.indices;
	    var eps2 = GRAPHICS_CURVES.epsilon * GRAPHICS_CURVES.epsilon;
	    // indices.push(indexStart);
	    for (var i = indexStart; i < indexCount + indexStart - 2; ++i) {
	        x0 = verts[(i * 2)];
	        y0 = verts[(i * 2) + 1];
	        x1 = verts[(i + 1) * 2];
	        y1 = verts[((i + 1) * 2) + 1];
	        x2 = verts[(i + 2) * 2];
	        y2 = verts[((i + 2) * 2) + 1];
	        /* Skip zero area triangles */
	        if (Math.abs((x0 * (y1 - y2)) + (x1 * (y2 - y0)) + (x2 * (y0 - y1))) < eps2) {
	            continue;
	        }
	        indices.push(i, i + 1, i + 2);
	    }
	}
	/**
	 * Builds a line to draw using the gl.drawArrays(gl.LINES) method
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.GraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {PIXI.GraphicsGeometry} graphicsGeometry - Geometry where to append output
	 */
	function buildNativeLine(graphicsData, graphicsGeometry) {
	    var i = 0;
	    var shape = graphicsData.shape;
	    var points = graphicsData.points || shape.points;
	    var closedShape = shape.type !== exports.SHAPES.POLY || shape.closeStroke;
	    if (points.length === 0)
	        { return; }
	    var verts = graphicsGeometry.points;
	    var indices = graphicsGeometry.indices;
	    var length = points.length / 2;
	    var startIndex = verts.length / 2;
	    var currentIndex = startIndex;
	    verts.push(points[0], points[1]);
	    for (i = 1; i < length; i++) {
	        verts.push(points[i * 2], points[(i * 2) + 1]);
	        indices.push(currentIndex, currentIndex + 1);
	        currentIndex++;
	    }
	    if (closedShape) {
	        indices.push(currentIndex, startIndex);
	    }
	}
	/**
	 * Builds a line to draw
	 *
	 * Ignored from docs since it is not directly exposed.
	 *
	 * @ignore
	 * @private
	 * @param {PIXI.GraphicsData} graphicsData - The graphics object containing all the necessary properties
	 * @param {PIXI.GraphicsGeometry} graphicsGeometry - Geometry where to append output
	 */
	function buildLine(graphicsData, graphicsGeometry) {
	    if (graphicsData.lineStyle.native) {
	        buildNativeLine(graphicsData, graphicsGeometry);
	    }
	    else {
	        buildNonNativeLine(graphicsData, graphicsGeometry);
	    }
	}

	/**
	 * Draw a star shape with an arbitrary number of points.
	 *
	 * @class
	 * @extends PIXI.Polygon
	 * @memberof PIXI.graphicsUtils
	 * @param {number} x - Center X position of the star
	 * @param {number} y - Center Y position of the star
	 * @param {number} points - The number of points of the star, must be > 1
	 * @param {number} radius - The outer radius of the star
	 * @param {number} [innerRadius] - The inner radius between points, default half `radius`
	 * @param {number} [rotation=0] - The rotation of the star in radians, where 0 is vertical
	 * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	 */
	var Star = /** @class */ (function (_super) {
	    __extends$5(Star, _super);
	    function Star(x, y, points, radius, innerRadius, rotation) {
	        if (rotation === void 0) { rotation = 0; }
	        var _this = this;
	        innerRadius = innerRadius || radius / 2;
	        var startAngle = (-1 * Math.PI / 2) + rotation;
	        var len = points * 2;
	        var delta = PI_2 / len;
	        var polygon = [];
	        for (var i = 0; i < len; i++) {
	            var r = i % 2 ? innerRadius : radius;
	            var angle = (i * delta) + startAngle;
	            polygon.push(x + (r * Math.cos(angle)), y + (r * Math.sin(angle)));
	        }
	        _this = _super.call(this, polygon) || this;
	        return _this;
	    }
	    return Star;
	}(Polygon));

	/**
	 * Utilities for arc curves
	 * @class
	 * @private
	 */
	var ArcUtils = /** @class */ (function () {
	    function ArcUtils() {
	    }
	    /**
	     * The arcTo() method creates an arc/curve between two tangents on the canvas.
	     *
	     * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
	     *
	     * @private
	     * @param {number} x1 - The x-coordinate of the beginning of the arc
	     * @param {number} y1 - The y-coordinate of the beginning of the arc
	     * @param {number} x2 - The x-coordinate of the end of the arc
	     * @param {number} y2 - The y-coordinate of the end of the arc
	     * @param {number} radius - The radius of the arc
	     * @return {object} If the arc length is valid, return center of circle, radius and other info otherwise `null`.
	     */
	    ArcUtils.curveTo = function (x1, y1, x2, y2, radius, points) {
	        var fromX = points[points.length - 2];
	        var fromY = points[points.length - 1];
	        var a1 = fromY - y1;
	        var b1 = fromX - x1;
	        var a2 = y2 - y1;
	        var b2 = x2 - x1;
	        var mm = Math.abs((a1 * b2) - (b1 * a2));
	        if (mm < 1.0e-8 || radius === 0) {
	            if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) {
	                points.push(x1, y1);
	            }
	            return null;
	        }
	        var dd = (a1 * a1) + (b1 * b1);
	        var cc = (a2 * a2) + (b2 * b2);
	        var tt = (a1 * a2) + (b1 * b2);
	        var k1 = radius * Math.sqrt(dd) / mm;
	        var k2 = radius * Math.sqrt(cc) / mm;
	        var j1 = k1 * tt / dd;
	        var j2 = k2 * tt / cc;
	        var cx = (k1 * b2) + (k2 * b1);
	        var cy = (k1 * a2) + (k2 * a1);
	        var px = b1 * (k2 + j1);
	        var py = a1 * (k2 + j1);
	        var qx = b2 * (k1 + j2);
	        var qy = a2 * (k1 + j2);
	        var startAngle = Math.atan2(py - cy, px - cx);
	        var endAngle = Math.atan2(qy - cy, qx - cx);
	        return {
	            cx: (cx + x1),
	            cy: (cy + y1),
	            radius: radius,
	            startAngle: startAngle,
	            endAngle: endAngle,
	            anticlockwise: (b1 * a2 > b2 * a1),
	        };
	    };
	    /* eslint-disable max-len */
	    /**
	     * The arc method creates an arc/curve (used to create circles, or parts of circles).
	     *
	     * @private
	     * @param {number} startX - Start x location of arc
	     * @param {number} startY - Start y location of arc
	     * @param {number} cx - The x-coordinate of the center of the circle
	     * @param {number} cy - The y-coordinate of the center of the circle
	     * @param {number} radius - The radius of the circle
	     * @param {number} startAngle - The starting angle, in radians (0 is at the 3 o'clock position
	     *  of the arc's circle)
	     * @param {number} endAngle - The ending angle, in radians
	     * @param {boolean} anticlockwise - Specifies whether the drawing should be
	     *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
	     *  indicates counter-clockwise.
	     * @param {number[]} points - Collection of points to add to
	     */
	    ArcUtils.arc = function (_startX, _startY, cx, cy, radius, startAngle, endAngle, _anticlockwise, points) {
	        var sweep = endAngle - startAngle;
	        var n = GRAPHICS_CURVES._segmentsCount(Math.abs(sweep) * radius, Math.ceil(Math.abs(sweep) / PI_2) * 40);
	        var theta = (sweep) / (n * 2);
	        var theta2 = theta * 2;
	        var cTheta = Math.cos(theta);
	        var sTheta = Math.sin(theta);
	        var segMinus = n - 1;
	        var remainder = (segMinus % 1) / segMinus;
	        for (var i = 0; i <= segMinus; ++i) {
	            var real = i + (remainder * i);
	            var angle = ((theta) + startAngle + (theta2 * real));
	            var c = Math.cos(angle);
	            var s = -Math.sin(angle);
	            points.push((((cTheta * c) + (sTheta * s)) * radius) + cx, (((cTheta * -s) + (sTheta * c)) * radius) + cy);
	        }
	    };
	    return ArcUtils;
	}());

	/**
	 * Utilities for bezier curves
	 * @class
	 * @private
	 */
	var BezierUtils = /** @class */ (function () {
	    function BezierUtils() {
	    }
	    /**
	     * Calculate length of bezier curve.
	     * Analytical solution is impossible, since it involves an integral that does not integrate in general.
	     * Therefore numerical solution is used.
	     *
	     * @private
	     * @param {number} fromX - Starting point x
	     * @param {number} fromY - Starting point y
	     * @param {number} cpX - Control point x
	     * @param {number} cpY - Control point y
	     * @param {number} cpX2 - Second Control point x
	     * @param {number} cpY2 - Second Control point y
	     * @param {number} toX - Destination point x
	     * @param {number} toY - Destination point y
	     * @return {number} Length of bezier curve
	     */
	    BezierUtils.curveLength = function (fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY) {
	        var n = 10;
	        var result = 0.0;
	        var t = 0.0;
	        var t2 = 0.0;
	        var t3 = 0.0;
	        var nt = 0.0;
	        var nt2 = 0.0;
	        var nt3 = 0.0;
	        var x = 0.0;
	        var y = 0.0;
	        var dx = 0.0;
	        var dy = 0.0;
	        var prevX = fromX;
	        var prevY = fromY;
	        for (var i = 1; i <= n; ++i) {
	            t = i / n;
	            t2 = t * t;
	            t3 = t2 * t;
	            nt = (1.0 - t);
	            nt2 = nt * nt;
	            nt3 = nt2 * nt;
	            x = (nt3 * fromX) + (3.0 * nt2 * t * cpX) + (3.0 * nt * t2 * cpX2) + (t3 * toX);
	            y = (nt3 * fromY) + (3.0 * nt2 * t * cpY) + (3 * nt * t2 * cpY2) + (t3 * toY);
	            dx = prevX - x;
	            dy = prevY - y;
	            prevX = x;
	            prevY = y;
	            result += Math.sqrt((dx * dx) + (dy * dy));
	        }
	        return result;
	    };
	    /**
	     * Calculate the points for a bezier curve and then draws it.
	     *
	     * Ignored from docs since it is not directly exposed.
	     *
	     * @ignore
	     * @param {number} cpX - Control point x
	     * @param {number} cpY - Control point y
	     * @param {number} cpX2 - Second Control point x
	     * @param {number} cpY2 - Second Control point y
	     * @param {number} toX - Destination point x
	     * @param {number} toY - Destination point y
	     * @param {number[]} points - Path array to push points into
	     */
	    BezierUtils.curveTo = function (cpX, cpY, cpX2, cpY2, toX, toY, points) {
	        var fromX = points[points.length - 2];
	        var fromY = points[points.length - 1];
	        points.length -= 2;
	        var n = GRAPHICS_CURVES._segmentsCount(BezierUtils.curveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY));
	        var dt = 0;
	        var dt2 = 0;
	        var dt3 = 0;
	        var t2 = 0;
	        var t3 = 0;
	        points.push(fromX, fromY);
	        for (var i = 1, j = 0; i <= n; ++i) {
	            j = i / n;
	            dt = (1 - j);
	            dt2 = dt * dt;
	            dt3 = dt2 * dt;
	            t2 = j * j;
	            t3 = t2 * j;
	            points.push((dt3 * fromX) + (3 * dt2 * j * cpX) + (3 * dt * t2 * cpX2) + (t3 * toX), (dt3 * fromY) + (3 * dt2 * j * cpY) + (3 * dt * t2 * cpY2) + (t3 * toY));
	        }
	    };
	    return BezierUtils;
	}());

	/**
	 * Utilities for quadratic curves
	 * @class
	 * @private
	 */
	var QuadraticUtils = /** @class */ (function () {
	    function QuadraticUtils() {
	    }
	    /**
	     * Calculate length of quadratic curve
	     * @see {@link http://www.malczak.linuxpl.com/blog/quadratic-bezier-curve-length/}
	     * for the detailed explanation of math behind this.
	     *
	     * @private
	     * @param {number} fromX - x-coordinate of curve start point
	     * @param {number} fromY - y-coordinate of curve start point
	     * @param {number} cpX - x-coordinate of curve control point
	     * @param {number} cpY - y-coordinate of curve control point
	     * @param {number} toX - x-coordinate of curve end point
	     * @param {number} toY - y-coordinate of curve end point
	     * @return {number} Length of quadratic curve
	     */
	    QuadraticUtils.curveLength = function (fromX, fromY, cpX, cpY, toX, toY) {
	        var ax = fromX - (2.0 * cpX) + toX;
	        var ay = fromY - (2.0 * cpY) + toY;
	        var bx = (2.0 * cpX) - (2.0 * fromX);
	        var by = (2.0 * cpY) - (2.0 * fromY);
	        var a = 4.0 * ((ax * ax) + (ay * ay));
	        var b = 4.0 * ((ax * bx) + (ay * by));
	        var c = (bx * bx) + (by * by);
	        var s = 2.0 * Math.sqrt(a + b + c);
	        var a2 = Math.sqrt(a);
	        var a32 = 2.0 * a * a2;
	        var c2 = 2.0 * Math.sqrt(c);
	        var ba = b / a2;
	        return ((a32 * s)
	            + (a2 * b * (s - c2))
	            + (((4.0 * c * a) - (b * b))
	                * Math.log(((2.0 * a2) + ba + s) / (ba + c2)))) / (4.0 * a32);
	    };
	    /**
	     * Calculate the points for a quadratic bezier curve and then draws it.
	     * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
	     *
	     * @private
	     * @param {number} cpX - Control point x
	     * @param {number} cpY - Control point y
	     * @param {number} toX - Destination point x
	     * @param {number} toY - Destination point y
	     * @param {number[]} points - Points to add segments to.
	     */
	    QuadraticUtils.curveTo = function (cpX, cpY, toX, toY, points) {
	        var fromX = points[points.length - 2];
	        var fromY = points[points.length - 1];
	        var n = GRAPHICS_CURVES._segmentsCount(QuadraticUtils.curveLength(fromX, fromY, cpX, cpY, toX, toY));
	        var xa = 0;
	        var ya = 0;
	        for (var i = 1; i <= n; ++i) {
	            var j = i / n;
	            xa = fromX + ((cpX - fromX) * j);
	            ya = fromY + ((cpY - fromY) * j);
	            points.push(xa + (((cpX + ((toX - cpX) * j)) - xa) * j), ya + (((cpY + ((toY - cpY) * j)) - ya) * j));
	        }
	    };
	    return QuadraticUtils;
	}());

	/**
	 * A structure to hold interim batch objects for Graphics.
	 * @class
	 * @memberof PIXI.graphicsUtils
	 */
	var BatchPart = /** @class */ (function () {
	    function BatchPart() {
	        this.reset();
	    }
	    /**
	     * Begin batch part
	     *
	     * @param {PIXI.FillStyle | PIXI.LineStyle} style
	     * @param {number} startIndex
	     * @param {number} attribStart
	     */
	    BatchPart.prototype.begin = function (style, startIndex, attribStart) {
	        this.reset();
	        this.style = style;
	        this.start = startIndex;
	        this.attribStart = attribStart;
	    };
	    /**
	     * End batch part
	     *
	     * @param {number} endIndex
	     * @param {number} endAttrib
	     */
	    BatchPart.prototype.end = function (endIndex, endAttrib) {
	        this.attribSize = endAttrib - this.attribStart;
	        this.size = endIndex - this.start;
	    };
	    BatchPart.prototype.reset = function () {
	        this.style = null;
	        this.size = 0;
	        this.start = 0;
	        this.attribStart = 0;
	        this.attribSize = 0;
	    };
	    return BatchPart;
	}());

	/**
	 * Generalized convenience utilities for Graphics.
	 *
	 * @namespace graphicsUtils
	 * @memberof PIXI
	 */
	var _a;
	/**
	 * Map of fill commands for each shape type.
	 *
	 * @memberof PIXI.graphicsUtils
	 * @member {Object} FILL_COMMANDS
	 */
	var FILL_COMMANDS = (_a = {},
	    _a[exports.SHAPES.POLY] = buildPoly,
	    _a[exports.SHAPES.CIRC] = buildCircle,
	    _a[exports.SHAPES.ELIP] = buildCircle,
	    _a[exports.SHAPES.RECT] = buildRectangle,
	    _a[exports.SHAPES.RREC] = buildRoundedRectangle,
	    _a);
	/**
	 * Batch pool, stores unused batches for preventing allocations.
	 *
	 * @memberof PIXI.graphicsUtils
	 * @member {Array<PIXI.graphicsUtils.BatchPart>} BATCH_POOL
	 */
	var BATCH_POOL = [];
	/**
	 * Draw call pool, stores unused draw calls for preventing allocations.
	 *
	 * @memberof PIXI.graphicsUtils
	 * @member {Array<PIXI.BatchDrawCall>} DRAW_CALL_POOL
	 */
	var DRAW_CALL_POOL = [];

	var index$2 = ({
	    buildPoly: buildPoly,
	    buildCircle: buildCircle,
	    buildRectangle: buildRectangle,
	    buildRoundedRectangle: buildRoundedRectangle,
	    FILL_COMMANDS: FILL_COMMANDS,
	    BATCH_POOL: BATCH_POOL,
	    DRAW_CALL_POOL: DRAW_CALL_POOL,
	    buildLine: buildLine,
	    Star: Star,
	    ArcUtils: ArcUtils,
	    BezierUtils: BezierUtils,
	    QuadraticUtils: QuadraticUtils,
	    BatchPart: BatchPart
	});

	/**
	 * A class to contain data useful for Graphics objects
	 *
	 * @class
	 * @memberof PIXI
	 */
	var GraphicsData = /** @class */ (function () {
	    /**
	     *
	     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
	     * @param {PIXI.FillStyle} [fillStyle] - the width of the line to draw
	     * @param {PIXI.LineStyle} [lineStyle] - the color of the line to draw
	     * @param {PIXI.Matrix} [matrix] - Transform matrix
	     */
	    function GraphicsData(shape, fillStyle, lineStyle, matrix) {
	        if (fillStyle === void 0) { fillStyle = null; }
	        if (lineStyle === void 0) { lineStyle = null; }
	        if (matrix === void 0) { matrix = null; }
	        /**
	         * The shape object to draw.
	         * @member {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle}
	         */
	        this.shape = shape;
	        /**
	         * The style of the line.
	         * @member {PIXI.LineStyle}
	         */
	        this.lineStyle = lineStyle;
	        /**
	         * The style of the fill.
	         * @member {PIXI.FillStyle}
	         */
	        this.fillStyle = fillStyle;
	        /**
	         * The transform matrix.
	         * @member {PIXI.Matrix}
	         */
	        this.matrix = matrix;
	        /**
	         * The type of the shape, see the Const.Shapes file for all the existing types,
	         * @member {number}
	         */
	        this.type = shape.type;
	        /**
	         * The collection of points.
	         * @member {number[]}
	         */
	        this.points = [];
	        /**
	         * The collection of holes.
	         * @member {PIXI.GraphicsData[]}
	         */
	        this.holes = [];
	    }
	    /**
	     * Creates a new GraphicsData object with the same values as this one.
	     *
	     * @return {PIXI.GraphicsData} Cloned GraphicsData object
	     */
	    GraphicsData.prototype.clone = function () {
	        return new GraphicsData(this.shape, this.fillStyle, this.lineStyle, this.matrix);
	    };
	    /**
	     * Destroys the Graphics data.
	     *
	     */
	    GraphicsData.prototype.destroy = function () {
	        this.shape = null;
	        this.holes.length = 0;
	        this.holes = null;
	        this.points.length = 0;
	        this.points = null;
	        this.lineStyle = null;
	        this.fillStyle = null;
	    };
	    return GraphicsData;
	}());

	var tmpPoint = new Point();
	var tmpBounds = new Bounds();
	/**
	 * The Graphics class contains methods used to draw primitive shapes such as lines, circles and
	 * rectangles to the display, and to color and fill them.
	 *
	 * GraphicsGeometry is designed to not be continually updating the geometry since it's expensive
	 * to re-tesselate using **earcut**. Consider using {@link PIXI.Mesh} for this use-case, it's much faster.
	 *
	 * @class
	 * @extends PIXI.BatchGeometry
	 * @memberof PIXI
	 */
	var GraphicsGeometry = /** @class */ (function (_super) {
	    __extends$5(GraphicsGeometry, _super);
	    function GraphicsGeometry() {
	        var _this = _super.call(this) || this;
	        _this.uvsFloat32 = null;
	        _this.indicesUint16 = null;
	        /**
	         * An array of points to draw, 2 numbers per point
	         *
	         * @member {number[]}
	         * @protected
	         */
	        _this.points = [];
	        /**
	         * The collection of colors
	         *
	         * @member {number[]}
	         * @protected
	         */
	        _this.colors = [];
	        /**
	         * The UVs collection
	         *
	         * @member {number[]}
	         * @protected
	         */
	        _this.uvs = [];
	        /**
	         * The indices of the vertices
	         *
	         * @member {number[]}
	         * @protected
	         */
	        _this.indices = [];
	        /**
	         * Reference to the texture IDs.
	         *
	         * @member {number[]}
	         * @protected
	         */
	        _this.textureIds = [];
	        /**
	         * The collection of drawn shapes.
	         *
	         * @member {PIXI.GraphicsData[]}
	         * @protected
	         */
	        _this.graphicsData = [];
	        /**
	         * Used to detect if the graphics object has changed.
	         *
	         * @member {number}
	         * @protected
	         */
	        _this.dirty = 0;
	        /**
	         * Batches need to regenerated if the geometry is updated.
	         *
	         * @member {number}
	         * @protected
	         */
	        _this.batchDirty = -1;
	        /**
	         * Used to check if the cache is dirty.
	         *
	         * @member {number}
	         * @protected
	         */
	        _this.cacheDirty = -1;
	        /**
	         * Used to detect if we cleared the graphicsData.
	         *
	         * @member {number}
	         * @default 0
	         * @protected
	         */
	        _this.clearDirty = 0;
	        /**
	         * List of current draw calls drived from the batches.
	         *
	         * @member {object[]}
	         * @protected
	         */
	        _this.drawCalls = [];
	        /**
	         * Intermediate abstract format sent to batch system.
	         * Can be converted to drawCalls or to batchable objects.
	         *
	         * @member {PIXI.graphicsUtils.BatchPart[]}
	         * @protected
	         */
	        _this.batches = [];
	        /**
	         * Index of the last batched shape in the stack of calls.
	         *
	         * @member {number}
	         * @protected
	         */
	        _this.shapeIndex = 0;
	        /**
	         * Cached bounds.
	         *
	         * @member {PIXI.Bounds}
	         * @protected
	         */
	        _this._bounds = new Bounds();
	        /**
	         * The bounds dirty flag.
	         *
	         * @member {number}
	         * @protected
	         */
	        _this.boundsDirty = -1;
	        /**
	         * Padding to add to the bounds.
	         *
	         * @member {number}
	         * @default 0
	         */
	        _this.boundsPadding = 0;
	        _this.batchable = false;
	        _this.indicesUint16 = null;
	        _this.uvsFloat32 = null;
	        /**
	         * Minimal distance between points that are considered different.
	         * Affects line tesselation.
	         *
	         * @member {number}
	         */
	        _this.closePointEps = 1e-4;
	        return _this;
	    }
	    Object.defineProperty(GraphicsGeometry.prototype, "bounds", {
	        /**
	         * Get the current bounds of the graphic geometry.
	         *
	         * @member {PIXI.Bounds}
	         * @readonly
	         */
	        get: function () {
	            if (this.boundsDirty !== this.dirty) {
	                this.boundsDirty = this.dirty;
	                this.calculateBounds();
	            }
	            return this._bounds;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Call if you changed graphicsData manually.
	     * Empties all batch buffers.
	     */
	    GraphicsGeometry.prototype.invalidate = function () {
	        this.boundsDirty = -1;
	        this.dirty++;
	        this.batchDirty++;
	        this.shapeIndex = 0;
	        this.points.length = 0;
	        this.colors.length = 0;
	        this.uvs.length = 0;
	        this.indices.length = 0;
	        this.textureIds.length = 0;
	        for (var i = 0; i < this.drawCalls.length; i++) {
	            this.drawCalls[i].texArray.clear();
	            DRAW_CALL_POOL.push(this.drawCalls[i]);
	        }
	        this.drawCalls.length = 0;
	        for (var i = 0; i < this.batches.length; i++) {
	            var batchPart = this.batches[i];
	            batchPart.reset();
	            BATCH_POOL.push(batchPart);
	        }
	        this.batches.length = 0;
	    };
	    /**
	     * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
	     *
	     * @return {PIXI.GraphicsGeometry} This GraphicsGeometry object. Good for chaining method calls
	     */
	    GraphicsGeometry.prototype.clear = function () {
	        if (this.graphicsData.length > 0) {
	            this.invalidate();
	            this.clearDirty++;
	            this.graphicsData.length = 0;
	        }
	        return this;
	    };
	    /**
	     * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
	     *
	     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
	     * @param {PIXI.FillStyle} fillStyle - Defines style of the fill.
	     * @param {PIXI.LineStyle} lineStyle - Defines style of the lines.
	     * @param {PIXI.Matrix} matrix - Transform applied to the points of the shape.
	     * @return {PIXI.GraphicsGeometry} Returns geometry for chaining.
	     */
	    GraphicsGeometry.prototype.drawShape = function (shape, fillStyle, lineStyle, matrix) {
	        if (fillStyle === void 0) { fillStyle = null; }
	        if (lineStyle === void 0) { lineStyle = null; }
	        if (matrix === void 0) { matrix = null; }
	        var data = new GraphicsData(shape, fillStyle, lineStyle, matrix);
	        this.graphicsData.push(data);
	        this.dirty++;
	        return this;
	    };
	    /**
	     * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
	     *
	     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
	     * @param {PIXI.Matrix} matrix - Transform applied to the points of the shape.
	     * @return {PIXI.GraphicsGeometry} Returns geometry for chaining.
	     */
	    GraphicsGeometry.prototype.drawHole = function (shape, matrix) {
	        if (matrix === void 0) { matrix = null; }
	        if (!this.graphicsData.length) {
	            return null;
	        }
	        var data = new GraphicsData(shape, null, null, matrix);
	        var lastShape = this.graphicsData[this.graphicsData.length - 1];
	        data.lineStyle = lastShape.lineStyle;
	        lastShape.holes.push(data);
	        this.dirty++;
	        return this;
	    };
	    /**
	     * Destroys the GraphicsGeometry object.
	     *
	     */
	    GraphicsGeometry.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        // destroy each of the GraphicsData objects
	        for (var i = 0; i < this.graphicsData.length; ++i) {
	            this.graphicsData[i].destroy();
	        }
	        this.points.length = 0;
	        this.points = null;
	        this.colors.length = 0;
	        this.colors = null;
	        this.uvs.length = 0;
	        this.uvs = null;
	        this.indices.length = 0;
	        this.indices = null;
	        this.indexBuffer.destroy();
	        this.indexBuffer = null;
	        this.graphicsData.length = 0;
	        this.graphicsData = null;
	        this.drawCalls.length = 0;
	        this.drawCalls = null;
	        this.batches.length = 0;
	        this.batches = null;
	        this._bounds = null;
	    };
	    /**
	     * Check to see if a point is contained within this geometry.
	     *
	     * @param {PIXI.IPointData} point - Point to check if it's contained.
	     * @return {Boolean} `true` if the point is contained within geometry.
	     */
	    GraphicsGeometry.prototype.containsPoint = function (point) {
	        var graphicsData = this.graphicsData;
	        for (var i = 0; i < graphicsData.length; ++i) {
	            var data = graphicsData[i];
	            if (!data.fillStyle.visible) {
	                continue;
	            }
	            // only deal with fills..
	            if (data.shape) {
	                if (data.matrix) {
	                    data.matrix.applyInverse(point, tmpPoint);
	                }
	                else {
	                    tmpPoint.copyFrom(point);
	                }
	                if (data.shape.contains(tmpPoint.x, tmpPoint.y)) {
	                    var hitHole = false;
	                    if (data.holes) {
	                        for (var i_1 = 0; i_1 < data.holes.length; i_1++) {
	                            var hole = data.holes[i_1];
	                            if (hole.shape.contains(tmpPoint.x, tmpPoint.y)) {
	                                hitHole = true;
	                                break;
	                            }
	                        }
	                    }
	                    if (!hitHole) {
	                        return true;
	                    }
	                }
	            }
	        }
	        return false;
	    };
	    /**
	     * Generates intermediate batch data. Either gets converted to drawCalls
	     * or used to convert to batch objects directly by the Graphics object.
	     *
	     * @param {boolean} [aloow32Indices] - Allow using 32-bit indices for preventings artefacts when more that 65535 vertices
	     */
	    GraphicsGeometry.prototype.updateBatches = function (allow32Indices) {
	        if (!this.graphicsData.length) {
	            this.batchable = true;
	            return;
	        }
	        if (!this.validateBatching()) {
	            return;
	        }
	        this.cacheDirty = this.dirty;
	        var uvs = this.uvs;
	        var graphicsData = this.graphicsData;
	        var batchPart = null;
	        var currentStyle = null;
	        if (this.batches.length > 0) {
	            batchPart = this.batches[this.batches.length - 1];
	            currentStyle = batchPart.style;
	        }
	        for (var i = this.shapeIndex; i < graphicsData.length; i++) {
	            this.shapeIndex++;
	            var data = graphicsData[i];
	            var fillStyle = data.fillStyle;
	            var lineStyle = data.lineStyle;
	            var command = FILL_COMMANDS[data.type];
	            // build out the shapes points..
	            command.build(data);
	            if (data.matrix) {
	                this.transformPoints(data.points, data.matrix);
	            }
	            for (var j = 0; j < 2; j++) {
	                var style = (j === 0) ? fillStyle : lineStyle;
	                if (!style.visible)
	                    { continue; }
	                var nextTexture = style.texture.baseTexture;
	                var index_1 = this.indices.length;
	                var attribIndex = this.points.length / 2;
	                nextTexture.wrapMode = exports.WRAP_MODES.REPEAT;
	                if (j === 0) {
	                    this.processFill(data);
	                }
	                else {
	                    this.processLine(data);
	                }
	                var size = (this.points.length / 2) - attribIndex;
	                if (size === 0)
	                    { continue; }
	                // close batch if style is different
	                if (batchPart && !this._compareStyles(currentStyle, style)) {
	                    batchPart.end(index_1, attribIndex);
	                    batchPart = null;
	                }
	                // spawn new batch if its first batch or previous was closed
	                if (!batchPart) {
	                    batchPart = BATCH_POOL.pop() || new BatchPart();
	                    batchPart.begin(style, index_1, attribIndex);
	                    this.batches.push(batchPart);
	                    currentStyle = style;
	                }
	                this.addUvs(this.points, uvs, style.texture, attribIndex, size, style.matrix);
	            }
	        }
	        var index = this.indices.length;
	        var attrib = this.points.length / 2;
	        if (batchPart) {
	            batchPart.end(index, attrib);
	        }
	        if (this.batches.length === 0) {
	            // there are no visible styles in GraphicsData
	            // its possible that someone wants Graphics just for the bounds
	            this.batchable = true;
	            return;
	        }
	        // prevent allocation when length is same as buffer
	        if (this.indicesUint16 && this.indices.length === this.indicesUint16.length) {
	            this.indicesUint16.set(this.indices);
	        }
	        else {
	            var need32 = attrib > 0xffff && allow32Indices;
	            this.indicesUint16 = need32 ? new Uint32Array(this.indices) : new Uint16Array(this.indices);
	        }
	        // TODO make this a const..
	        this.batchable = this.isBatchable();
	        if (this.batchable) {
	            this.packBatches();
	        }
	        else {
	            this.buildDrawCalls();
	        }
	    };
	    /**
	     * Affinity check
	     *
	     * @param {PIXI.FillStyle | PIXI.LineStyle} styleA
	     * @param {PIXI.FillStyle | PIXI.LineStyle} styleB
	     */
	    GraphicsGeometry.prototype._compareStyles = function (styleA, styleB) {
	        if (!styleA || !styleB) {
	            return false;
	        }
	        if (styleA.texture.baseTexture !== styleB.texture.baseTexture) {
	            return false;
	        }
	        if (styleA.color + styleA.alpha !== styleB.color + styleB.alpha) {
	            return false;
	        }
	        if (!!styleA.native !== !!styleB.native) {
	            return false;
	        }
	        return true;
	    };
	    /**
	     * Test geometry for batching process.
	     *
	     * @protected
	     */
	    GraphicsGeometry.prototype.validateBatching = function () {
	        if (this.dirty === this.cacheDirty || !this.graphicsData.length) {
	            return false;
	        }
	        for (var i = 0, l = this.graphicsData.length; i < l; i++) {
	            var data = this.graphicsData[i];
	            var fill = data.fillStyle;
	            var line = data.lineStyle;
	            if (fill && !fill.texture.baseTexture.valid)
	                { return false; }
	            if (line && !line.texture.baseTexture.valid)
	                { return false; }
	        }
	        return true;
	    };
	    /**
	     * Offset the indices so that it works with the batcher.
	     *
	     * @protected
	     */
	    GraphicsGeometry.prototype.packBatches = function () {
	        this.batchDirty++;
	        this.uvsFloat32 = new Float32Array(this.uvs);
	        var batches = this.batches;
	        for (var i = 0, l = batches.length; i < l; i++) {
	            var batch = batches[i];
	            for (var j = 0; j < batch.size; j++) {
	                var index = batch.start + j;
	                this.indicesUint16[index] = this.indicesUint16[index] - batch.attribStart;
	            }
	        }
	    };
	    /**
	     * Checks to see if this graphics geometry can be batched.
	     * Currently it needs to be small enough and not contain any native lines.
	     *
	     * @protected
	     */
	    GraphicsGeometry.prototype.isBatchable = function () {
	        // prevent heavy mesh batching
	        if (this.points.length > 0xffff * 2) {
	            return false;
	        }
	        var batches = this.batches;
	        for (var i = 0; i < batches.length; i++) {
	            if (batches[i].style.native) {
	                return false;
	            }
	        }
	        return (this.points.length < GraphicsGeometry.BATCHABLE_SIZE * 2);
	    };
	    /**
	     * Converts intermediate batches data to drawCalls.
	     *
	     * @protected
	     */
	    GraphicsGeometry.prototype.buildDrawCalls = function () {
	        var TICK = ++BaseTexture._globalBatch;
	        for (var i = 0; i < this.drawCalls.length; i++) {
	            this.drawCalls[i].texArray.clear();
	            DRAW_CALL_POOL.push(this.drawCalls[i]);
	        }
	        this.drawCalls.length = 0;
	        var colors = this.colors;
	        var textureIds = this.textureIds;
	        var currentGroup = DRAW_CALL_POOL.pop();
	        if (!currentGroup) {
	            currentGroup = new BatchDrawCall();
	            currentGroup.texArray = new BatchTextureArray();
	        }
	        currentGroup.texArray.count = 0;
	        currentGroup.start = 0;
	        currentGroup.size = 0;
	        currentGroup.type = exports.DRAW_MODES.TRIANGLES;
	        var textureCount = 0;
	        var currentTexture = null;
	        var textureId = 0;
	        var native = false;
	        var drawMode = exports.DRAW_MODES.TRIANGLES;
	        var index = 0;
	        this.drawCalls.push(currentGroup);
	        // TODO - this can be simplified
	        for (var i = 0; i < this.batches.length; i++) {
	            var data = this.batches[i];
	            // TODO add some full on MAX_TEXTURE CODE..
	            var MAX_TEXTURES = 8;
	            // Forced cast for checking `native` without errors
	            var style = data.style;
	            var nextTexture = style.texture.baseTexture;
	            if (native !== !!style.native) {
	                native = !!style.native;
	                drawMode = native ? exports.DRAW_MODES.LINES : exports.DRAW_MODES.TRIANGLES;
	                // force the batch to break!
	                currentTexture = null;
	                textureCount = MAX_TEXTURES;
	                TICK++;
	            }
	            if (currentTexture !== nextTexture) {
	                currentTexture = nextTexture;
	                if (nextTexture._batchEnabled !== TICK) {
	                    if (textureCount === MAX_TEXTURES) {
	                        TICK++;
	                        textureCount = 0;
	                        if (currentGroup.size > 0) {
	                            currentGroup = DRAW_CALL_POOL.pop();
	                            if (!currentGroup) {
	                                currentGroup = new BatchDrawCall();
	                                currentGroup.texArray = new BatchTextureArray();
	                            }
	                            this.drawCalls.push(currentGroup);
	                        }
	                        currentGroup.start = index;
	                        currentGroup.size = 0;
	                        currentGroup.texArray.count = 0;
	                        currentGroup.type = drawMode;
	                    }
	                    // TODO add this to the render part..
	                    // Hack! Because texture has protected `touched`
	                    nextTexture.touched = 1; // touch;
	                    nextTexture._batchEnabled = TICK;
	                    nextTexture._batchLocation = textureCount;
	                    nextTexture.wrapMode = 10497;
	                    currentGroup.texArray.elements[currentGroup.texArray.count++] = nextTexture;
	                    textureCount++;
	                }
	            }
	            currentGroup.size += data.size;
	            index += data.size;
	            textureId = nextTexture._batchLocation;
	            this.addColors(colors, style.color, style.alpha, data.attribSize, data.attribStart);
	            this.addTextureIds(textureIds, textureId, data.attribSize, data.attribStart);
	        }
	        BaseTexture._globalBatch = TICK;
	        // upload..
	        // merge for now!
	        this.packAttributes();
	    };
	    /**
	     * Packs attributes to single buffer.
	     *
	     * @protected
	     */
	    GraphicsGeometry.prototype.packAttributes = function () {
	        var verts = this.points;
	        var uvs = this.uvs;
	        var colors = this.colors;
	        var textureIds = this.textureIds;
	        // verts are 2 positions.. so we * by 3 as there are 6 properties.. then 4 cos its bytes
	        var glPoints = new ArrayBuffer(verts.length * 3 * 4);
	        var f32 = new Float32Array(glPoints);
	        var u32 = new Uint32Array(glPoints);
	        var p = 0;
	        for (var i = 0; i < verts.length / 2; i++) {
	            f32[p++] = verts[i * 2];
	            f32[p++] = verts[(i * 2) + 1];
	            f32[p++] = uvs[i * 2];
	            f32[p++] = uvs[(i * 2) + 1];
	            u32[p++] = colors[i];
	            f32[p++] = textureIds[i];
	        }
	        this._buffer.update(glPoints);
	        this._indexBuffer.update(this.indicesUint16);
	    };
	    /**
	     * Process fill part of Graphics.
	     *
	     * @param {PIXI.GraphicsData} data
	     * @protected
	     */
	    GraphicsGeometry.prototype.processFill = function (data) {
	        if (data.holes.length) {
	            this.processHoles(data.holes);
	            buildPoly.triangulate(data, this);
	        }
	        else {
	            var command = FILL_COMMANDS[data.type];
	            command.triangulate(data, this);
	        }
	    };
	    /**
	     * Process line part of Graphics.
	     *
	     * @param {PIXI.GraphicsData} data
	     * @protected
	     */
	    GraphicsGeometry.prototype.processLine = function (data) {
	        buildLine(data, this);
	        for (var i = 0; i < data.holes.length; i++) {
	            buildLine(data.holes[i], this);
	        }
	    };
	    /**
	     * Process the holes data.
	     *
	     * @param {PIXI.GraphicsData[]} holes - Holes to render
	     * @protected
	     */
	    GraphicsGeometry.prototype.processHoles = function (holes) {
	        for (var i = 0; i < holes.length; i++) {
	            var hole = holes[i];
	            var command = FILL_COMMANDS[hole.type];
	            command.build(hole);
	            if (hole.matrix) {
	                this.transformPoints(hole.points, hole.matrix);
	            }
	        }
	    };
	    /**
	     * Update the local bounds of the object. Expensive to use performance-wise.
	     *
	     * @protected
	     */
	    GraphicsGeometry.prototype.calculateBounds = function () {
	        var bounds = this._bounds;
	        var sequenceBounds = tmpBounds;
	        var curMatrix = Matrix.IDENTITY;
	        this._bounds.clear();
	        sequenceBounds.clear();
	        for (var i = 0; i < this.graphicsData.length; i++) {
	            var data = this.graphicsData[i];
	            var shape = data.shape;
	            var type = data.type;
	            var lineStyle = data.lineStyle;
	            var nextMatrix = data.matrix || Matrix.IDENTITY;
	            var lineWidth = 0.0;
	            if (lineStyle && lineStyle.visible) {
	                var alignment = lineStyle.alignment;
	                lineWidth = lineStyle.width;
	                if (type === exports.SHAPES.POLY) {
	                    lineWidth = lineWidth * (0.5 + Math.abs(0.5 - alignment));
	                }
	                else {
	                    lineWidth = lineWidth * Math.max(0, alignment);
	                }
	            }
	            if (curMatrix !== nextMatrix) {
	                if (!sequenceBounds.isEmpty()) {
	                    bounds.addBoundsMatrix(sequenceBounds, curMatrix);
	                    sequenceBounds.clear();
	                }
	                curMatrix = nextMatrix;
	            }
	            if (type === exports.SHAPES.RECT || type === exports.SHAPES.RREC) {
	                var rect = shape;
	                sequenceBounds.addFramePad(rect.x, rect.y, rect.x + rect.width, rect.y + rect.height, lineWidth, lineWidth);
	            }
	            else if (type === exports.SHAPES.CIRC) {
	                var circle = shape;
	                sequenceBounds.addFramePad(circle.x, circle.y, circle.x, circle.y, circle.radius + lineWidth, circle.radius + lineWidth);
	            }
	            else if (type === exports.SHAPES.ELIP) {
	                var ellipse = shape;
	                sequenceBounds.addFramePad(ellipse.x, ellipse.y, ellipse.x, ellipse.y, ellipse.width + lineWidth, ellipse.height + lineWidth);
	            }
	            else {
	                var poly = shape;
	                // adding directly to the bounds
	                bounds.addVerticesMatrix(curMatrix, poly.points, 0, poly.points.length, lineWidth, lineWidth);
	            }
	        }
	        if (!sequenceBounds.isEmpty()) {
	            bounds.addBoundsMatrix(sequenceBounds, curMatrix);
	        }
	        bounds.pad(this.boundsPadding, this.boundsPadding);
	    };
	    /**
	     * Transform points using matrix.
	     *
	     * @protected
	     * @param {number[]} points - Points to transform
	     * @param {PIXI.Matrix} matrix - Transform matrix
	     */
	    GraphicsGeometry.prototype.transformPoints = function (points, matrix) {
	        for (var i = 0; i < points.length / 2; i++) {
	            var x = points[(i * 2)];
	            var y = points[(i * 2) + 1];
	            points[(i * 2)] = (matrix.a * x) + (matrix.c * y) + matrix.tx;
	            points[(i * 2) + 1] = (matrix.b * x) + (matrix.d * y) + matrix.ty;
	        }
	    };
	    /**
	     * Add colors.
	     *
	     * @protected
	     * @param {number[]} colors - List of colors to add to
	     * @param {number} color - Color to add
	     * @param {number} alpha - Alpha to use
	     * @param {number} size - Number of colors to add
	     * @param {number} offset
	     */
	    GraphicsGeometry.prototype.addColors = function (colors, color, alpha, size, offset) {
	        if (offset === void 0) { offset = 0; }
	        // TODO use the premultiply bits Ivan added
	        var rgb = (color >> 16) + (color & 0xff00) + ((color & 0xff) << 16);
	        var rgba = premultiplyTint(rgb, alpha);
	        colors.length = Math.max(colors.length, offset + size);
	        for (var i = 0; i < size; i++) {
	            colors[offset + i] = rgba;
	        }
	    };
	    /**
	     * Add texture id that the shader/fragment wants to use.
	     *
	     * @protected
	     * @param {number[]} textureIds
	     * @param {number} id
	     * @param {number} size
	     * @param {number} offset
	     */
	    GraphicsGeometry.prototype.addTextureIds = function (textureIds, id, size, offset) {
	        if (offset === void 0) { offset = 0; }
	        textureIds.length = Math.max(textureIds.length, offset + size);
	        for (var i = 0; i < size; i++) {
	            textureIds[offset + i] = id;
	        }
	    };
	    /**
	     * Generates the UVs for a shape.
	     *
	     * @protected
	     * @param {number[]} verts - Vertices
	     * @param {number[]} uvs - UVs
	     * @param {PIXI.Texture} texture - Reference to Texture
	     * @param {number} start - Index buffer start index.
	     * @param {number} size - The size/length for index buffer.
	     * @param {PIXI.Matrix} [matrix] - Optional transform for all points.
	     */
	    GraphicsGeometry.prototype.addUvs = function (verts, uvs, texture, start, size, matrix) {
	        if (matrix === void 0) { matrix = null; }
	        var index = 0;
	        var uvsStart = uvs.length;
	        var frame = texture.frame;
	        while (index < size) {
	            var x = verts[(start + index) * 2];
	            var y = verts[((start + index) * 2) + 1];
	            if (matrix) {
	                var nx = (matrix.a * x) + (matrix.c * y) + matrix.tx;
	                y = (matrix.b * x) + (matrix.d * y) + matrix.ty;
	                x = nx;
	            }
	            index++;
	            uvs.push(x / frame.width, y / frame.height);
	        }
	        var baseTexture = texture.baseTexture;
	        if (frame.width < baseTexture.width
	            || frame.height < baseTexture.height) {
	            this.adjustUvs(uvs, texture, uvsStart, size);
	        }
	    };
	    /**
	     * Modify uvs array according to position of texture region
	     * Does not work with rotated or trimmed textures
	     *
	     * @param {number[]} uvs - array
	     * @param {PIXI.Texture} texture - region
	     * @param {number} start - starting index for uvs
	     * @param {number} size - how many points to adjust
	     */
	    GraphicsGeometry.prototype.adjustUvs = function (uvs, texture, start, size) {
	        var baseTexture = texture.baseTexture;
	        var eps = 1e-6;
	        var finish = start + (size * 2);
	        var frame = texture.frame;
	        var scaleX = frame.width / baseTexture.width;
	        var scaleY = frame.height / baseTexture.height;
	        var offsetX = frame.x / frame.width;
	        var offsetY = frame.y / frame.height;
	        var minX = Math.floor(uvs[start] + eps);
	        var minY = Math.floor(uvs[start + 1] + eps);
	        for (var i = start + 2; i < finish; i += 2) {
	            minX = Math.min(minX, Math.floor(uvs[i] + eps));
	            minY = Math.min(minY, Math.floor(uvs[i + 1] + eps));
	        }
	        offsetX -= minX;
	        offsetY -= minY;
	        for (var i = start; i < finish; i += 2) {
	            uvs[i] = (uvs[i] + offsetX) * scaleX;
	            uvs[i + 1] = (uvs[i + 1] + offsetY) * scaleY;
	        }
	    };
	    /**
	     * The maximum number of points to consider an object "batchable",
	     * able to be batched by the renderer's batch system.
	     *
	     * @memberof PIXI.GraphicsGeometry
	     * @static
	     * @member {number} BATCHABLE_SIZE
	     * @default 100
	     */
	    GraphicsGeometry.BATCHABLE_SIZE = 100;
	    return GraphicsGeometry;
	}(BatchGeometry));

	/**
	 * Represents the line style for Graphics.
	 * @memberof PIXI
	 * @class
	 * @extends PIXI.FillStyle
	 */
	var LineStyle = /** @class */ (function (_super) {
	    __extends$5(LineStyle, _super);
	    function LineStyle() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * The width (thickness) of any lines drawn.
	         *
	         * @member {number}
	         * @default 0
	         */
	        _this.width = 0;
	        /**
	         * The alignment of any lines drawn (0.5 = middle, 1 = outer, 0 = inner).
	         *
	         * @member {number}
	         * @default 0.5
	         */
	        _this.alignment = 0.5;
	        /**
	         * If true the lines will be draw using LINES instead of TRIANGLE_STRIP
	         *
	         * @member {boolean}
	         * @default false
	         */
	        _this.native = false;
	        /**
	         * Line cap style.
	         *
	         * @member {PIXI.LINE_CAP}
	         * @default PIXI.LINE_CAP.BUTT
	         */
	        _this.cap = exports.LINE_CAP.BUTT;
	        /**
	         * Line join style.
	         *
	         * @member {PIXI.LINE_JOIN}
	         * @default PIXI.LINE_JOIN.MITER
	         */
	        _this.join = exports.LINE_JOIN.MITER;
	        /**
	         * Miter limit.
	         *
	         * @member {number}
	         * @default 10
	         */
	        _this.miterLimit = 10;
	        return _this;
	    }
	    /**
	     * Clones the object
	     *
	     * @return {PIXI.LineStyle}
	     */
	    LineStyle.prototype.clone = function () {
	        var obj = new LineStyle();
	        obj.color = this.color;
	        obj.alpha = this.alpha;
	        obj.texture = this.texture;
	        obj.matrix = this.matrix;
	        obj.visible = this.visible;
	        obj.width = this.width;
	        obj.alignment = this.alignment;
	        obj.native = this.native;
	        obj.cap = this.cap;
	        obj.join = this.join;
	        obj.miterLimit = this.miterLimit;
	        return obj;
	    };
	    /**
	     * Reset the line style to default.
	     */
	    LineStyle.prototype.reset = function () {
	        _super.prototype.reset.call(this);
	        // Override default line style color
	        this.color = 0x0;
	        this.alignment = 0.5;
	        this.width = 0;
	        this.native = false;
	    };
	    return LineStyle;
	}(FillStyle));

	var temp = new Float32Array(3);
	// a default shaders map used by graphics..
	var DEFAULT_SHADERS = {};
	/**
	 * The Graphics class contains methods used to draw primitive shapes such as lines, circles and
	 * rectangles to the display, and to color and fill them.
	 *
	 * Note that because Graphics can share a GraphicsGeometry with other instances,
	 * it is necessary to call `destroy()` to properly dereference the underlying
	 * GraphicsGeometry and avoid a memory leak. Alternatively, keep using the same
	 * Graphics instance and call `clear()` between redraws.
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI
	 */
	var Graphics = /** @class */ (function (_super) {
	    __extends$5(Graphics, _super);
	    /**
	     * @param {PIXI.GraphicsGeometry} [geometry=null] - Geometry to use, if omitted
	     *        will create a new GraphicsGeometry instance.
	     */
	    function Graphics(geometry) {
	        if (geometry === void 0) { geometry = null; }
	        var _this = _super.call(this) || this;
	        _this._geometry = geometry || new GraphicsGeometry();
	        _this._geometry.refCount++;
	        /**
	         * Represents the vertex and fragment shaders that processes the geometry and runs on the GPU.
	         * Can be shared between multiple Graphics objects.
	         *
	         * @member {PIXI.Shader}
	         */
	        _this.shader = null;
	        /**
	         * Represents the WebGL state the Graphics required to render, excludes shader and geometry. E.g.,
	         * blend mode, culling, depth testing, direction of rendering triangles, backface, etc.
	         *
	         * @member {PIXI.State}
	         */
	        _this.state = State.for2d();
	        /**
	         * Current fill style
	         *
	         * @member {PIXI.FillStyle}
	         * @protected
	         */
	        _this._fillStyle = new FillStyle();
	        /**
	         * Current line style
	         *
	         * @member {PIXI.LineStyle}
	         * @protected
	         */
	        _this._lineStyle = new LineStyle();
	        /**
	         * Current shape transform matrix.
	         *
	         * @member {PIXI.Matrix}
	         * @protected
	         */
	        _this._matrix = null;
	        /**
	         * Current hole mode is enabled.
	         *
	         * @member {boolean}
	         * @default false
	         * @protected
	         */
	        _this._holeMode = false;
	        /**
	         * Current path
	         *
	         * @member {PIXI.Polygon}
	         * @protected
	         */
	        _this.currentPath = null;
	        /**
	         * When cacheAsBitmap is set to true the graphics object will be rendered as if it was a sprite.
	         * This is useful if your graphics element does not change often, as it will speed up the rendering
	         * of the object in exchange for taking up texture memory. It is also useful if you need the graphics
	         * object to be anti-aliased, because it will be rendered using canvas. This is not recommended if
	         * you are constantly redrawing the graphics element.
	         *
	         * @name cacheAsBitmap
	         * @member {boolean}
	         * @memberof PIXI.Graphics#
	         * @default false
	         */
	        /**
	         * A collections of batches! These can be drawn by the renderer batch system.
	         *
	         * @protected
	         * @member {object[]}
	         */
	        _this.batches = [];
	        /**
	         * Update dirty for limiting calculating tints for batches.
	         *
	         * @protected
	         * @member {number}
	         * @default -1
	         */
	        _this.batchTint = -1;
	        /**
	         * Update dirty for limiting calculating batches.
	         *
	         * @protected
	         * @member {number}
	         * @default -1
	         */
	        _this.batchDirty = -1;
	        /**
	         * Copy of the object vertex data.
	         *
	         * @protected
	         * @member {Float32Array}
	         */
	        _this.vertexData = null;
	        /**
	         * Renderer plugin for batching
	         *
	         * @member {string}
	         * @default 'batch'
	         */
	        _this.pluginName = 'batch';
	        _this._transformID = -1;
	        // Set default
	        _this.tint = 0xFFFFFF;
	        _this.blendMode = exports.BLEND_MODES.NORMAL;
	        return _this;
	    }
	    Object.defineProperty(Graphics.prototype, "geometry", {
	        /**
	         * Includes vertex positions, face indices, normals, colors, UVs, and
	         * custom attributes within buffers, reducing the cost of passing all
	         * this data to the GPU. Can be shared between multiple Mesh or Graphics objects.
	         *
	         * @member {PIXI.GraphicsGeometry}
	         * @readonly
	         */
	        get: function () {
	            return this._geometry;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Creates a new Graphics object with the same values as this one.
	     * Note that only the geometry of the object is cloned, not its transform (position,scale,etc)
	     *
	     * @return {PIXI.Graphics} A clone of the graphics object
	     */
	    Graphics.prototype.clone = function () {
	        this.finishPoly();
	        return new Graphics(this._geometry);
	    };
	    Object.defineProperty(Graphics.prototype, "blendMode", {
	        get: function () {
	            return this.state.blendMode;
	        },
	        /**
	         * The blend mode to be applied to the graphic shape. Apply a value of
	         * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL;
	         * @see PIXI.BLEND_MODES
	         */
	        set: function (value) {
	            this.state.blendMode = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Graphics.prototype, "tint", {
	        /**
	         * The tint applied to the graphic shape. This is a hex value. A value of
	         * 0xFFFFFF will remove any tint effect.
	         *
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        get: function () {
	            return this._tint;
	        },
	        set: function (value) {
	            this._tint = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Graphics.prototype, "fill", {
	        /**
	         * The current fill style.
	         *
	         * @member {PIXI.FillStyle}
	         * @readonly
	         */
	        get: function () {
	            return this._fillStyle;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Graphics.prototype, "line", {
	        /**
	         * The current line style.
	         *
	         * @member {PIXI.LineStyle}
	         * @readonly
	         */
	        get: function () {
	            return this._lineStyle;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Specifies the line style used for subsequent calls to Graphics methods such as the lineTo()
	     * method or the drawCircle() method.
	     *
	     * @method PIXI.Graphics#lineStyle
	     * @param {number} [width=0] - width of the line to draw, will update the objects stored style
	     * @param {number} [color=0x0] - color of the line to draw, will update the objects stored style
	     * @param {number} [alpha=1] - alpha of the line to draw, will update the objects stored style
	     * @param {number} [alignment=0.5] - alignment of the line to draw, (0 = inner, 0.5 = middle, 1 = outter)
	     * @param {boolean} [native=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    /**
	     * Specifies the line style used for subsequent calls to Graphics methods such as the lineTo()
	     * method or the drawCircle() method.
	     *
	     * @param {object} [options] - Line style options
	     * @param {number} [options.width=0] - width of the line to draw, will update the objects stored style
	     * @param {number} [options.color=0x0] - color of the line to draw, will update the objects stored style
	     * @param {number} [options.alpha=1] - alpha of the line to draw, will update the objects stored style
	     * @param {number} [options.alignment=0.5] - alignment of the line to draw, (0 = inner, 0.5 = middle, 1 = outter)
	     * @param {boolean} [options.native=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
	     * @param {PIXI.LINE_CAP}[options.cap=PIXI.LINE_CAP.BUTT] - line cap style
	     * @param {PIXI.LINE_JOIN}[options.join=PIXI.LINE_JOIN.MITER] - line join style
	     * @param {number}[options.miterLimit=10] - miter limit ratio
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.lineStyle = function (options) {
	        if (options === void 0) { options = null; }
	        // Support non-object params: (width, color, alpha, alignment, native)
	        if (typeof options === 'number') {
	            // eslint-disable-next-line
	            var args = arguments;
	            options = {
	                width: args[0] || 0,
	                color: args[1] || 0x0,
	                alpha: args[2] !== undefined ? args[2] : 1,
	                alignment: args[3] !== undefined ? args[3] : 0.5,
	                native: !!args[4],
	            };
	        }
	        return this.lineTextureStyle(options);
	    };
	    /**
	     * Like line style but support texture for line fill.
	     *
	     * @param {object} [options] - Collection of options for setting line style.
	     * @param {number} [options.width=0] - width of the line to draw, will update the objects stored style
	     * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to use
	     * @param {number} [options.color=0x0] - color of the line to draw, will update the objects stored style.
	     *  Default 0xFFFFFF if texture present.
	     * @param {number} [options.alpha=1] - alpha of the line to draw, will update the objects stored style
	     * @param {PIXI.Matrix} [options.matrix=null] - Texture matrix to transform texture
	     * @param {number} [options.alignment=0.5] - alignment of the line to draw, (0 = inner, 0.5 = middle, 1 = outter)
	     * @param {boolean} [options.native=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
	     * @param {PIXI.LINE_CAP}[options.cap=PIXI.LINE_CAP.BUTT] - line cap style
	     * @param {PIXI.LINE_JOIN}[options.join=PIXI.LINE_JOIN.MITER] - line join style
	     * @param {number}[options.miterLimit=10] - miter limit ratio
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.lineTextureStyle = function (options) {
	        // backward compatibility with params: (width, texture,
	        // color, alpha, matrix, alignment, native)
	        if (typeof options === 'number') {
	            deprecation('v5.2.0', 'Please use object-based options for Graphics#lineTextureStyle');
	            // eslint-disable-next-line
	            var _a = arguments, width = _a[0], texture = _a[1], color = _a[2], alpha = _a[3], matrix = _a[4], alignment = _a[5], native = _a[6];
	            options = { width: width, texture: texture, color: color, alpha: alpha, matrix: matrix, alignment: alignment, native: native };
	            // Remove undefined keys
	            Object.keys(options).forEach(function (key) { return options[key] === undefined && delete options[key]; });
	        }
	        // Apply defaults
	        options = Object.assign({
	            width: 0,
	            texture: Texture.WHITE,
	            color: (options && options.texture) ? 0xFFFFFF : 0x0,
	            alpha: 1,
	            matrix: null,
	            alignment: 0.5,
	            native: false,
	            cap: exports.LINE_CAP.BUTT,
	            join: exports.LINE_JOIN.MITER,
	            miterLimit: 10,
	        }, options);
	        if (this.currentPath) {
	            this.startPoly();
	        }
	        var visible = options.width > 0 && options.alpha > 0;
	        if (!visible) {
	            this._lineStyle.reset();
	        }
	        else {
	            if (options.matrix) {
	                options.matrix = options.matrix.clone();
	                options.matrix.invert();
	            }
	            Object.assign(this._lineStyle, { visible: visible }, options);
	        }
	        return this;
	    };
	    /**
	     * Start a polygon object internally
	     * @protected
	     */
	    Graphics.prototype.startPoly = function () {
	        if (this.currentPath) {
	            var points = this.currentPath.points;
	            var len = this.currentPath.points.length;
	            if (len > 2) {
	                this.drawShape(this.currentPath);
	                this.currentPath = new Polygon();
	                this.currentPath.closeStroke = false;
	                this.currentPath.points.push(points[len - 2], points[len - 1]);
	            }
	        }
	        else {
	            this.currentPath = new Polygon();
	            this.currentPath.closeStroke = false;
	        }
	    };
	    /**
	     * Finish the polygon object.
	     * @protected
	     */
	    Graphics.prototype.finishPoly = function () {
	        if (this.currentPath) {
	            if (this.currentPath.points.length > 2) {
	                this.drawShape(this.currentPath);
	                this.currentPath = null;
	            }
	            else {
	                this.currentPath.points.length = 0;
	            }
	        }
	    };
	    /**
	     * Moves the current drawing position to x, y.
	     *
	     * @param {number} x - the X coordinate to move to
	     * @param {number} y - the Y coordinate to move to
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.moveTo = function (x, y) {
	        this.startPoly();
	        this.currentPath.points[0] = x;
	        this.currentPath.points[1] = y;
	        return this;
	    };
	    /**
	     * Draws a line using the current line style from the current drawing position to (x, y);
	     * The current drawing position is then set to (x, y).
	     *
	     * @param {number} x - the X coordinate to draw to
	     * @param {number} y - the Y coordinate to draw to
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.lineTo = function (x, y) {
	        if (!this.currentPath) {
	            this.moveTo(0, 0);
	        }
	        // remove duplicates..
	        var points = this.currentPath.points;
	        var fromX = points[points.length - 2];
	        var fromY = points[points.length - 1];
	        if (fromX !== x || fromY !== y) {
	            points.push(x, y);
	        }
	        return this;
	    };
	    /**
	     * Initialize the curve
	     *
	     * @protected
	     * @param {number} [x=0]
	     * @param {number} [y=0]
	     */
	    Graphics.prototype._initCurve = function (x, y) {
	        if (x === void 0) { x = 0; }
	        if (y === void 0) { y = 0; }
	        if (this.currentPath) {
	            if (this.currentPath.points.length === 0) {
	                this.currentPath.points = [x, y];
	            }
	        }
	        else {
	            this.moveTo(x, y);
	        }
	    };
	    /**
	     * Calculate the points for a quadratic bezier curve and then draws it.
	     * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
	     *
	     * @param {number} cpX - Control point x
	     * @param {number} cpY - Control point y
	     * @param {number} toX - Destination point x
	     * @param {number} toY - Destination point y
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.quadraticCurveTo = function (cpX, cpY, toX, toY) {
	        this._initCurve();
	        var points = this.currentPath.points;
	        if (points.length === 0) {
	            this.moveTo(0, 0);
	        }
	        QuadraticUtils.curveTo(cpX, cpY, toX, toY, points);
	        return this;
	    };
	    /**
	     * Calculate the points for a bezier curve and then draws it.
	     *
	     * @param {number} cpX - Control point x
	     * @param {number} cpY - Control point y
	     * @param {number} cpX2 - Second Control point x
	     * @param {number} cpY2 - Second Control point y
	     * @param {number} toX - Destination point x
	     * @param {number} toY - Destination point y
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.bezierCurveTo = function (cpX, cpY, cpX2, cpY2, toX, toY) {
	        this._initCurve();
	        BezierUtils.curveTo(cpX, cpY, cpX2, cpY2, toX, toY, this.currentPath.points);
	        return this;
	    };
	    /**
	     * The arcTo() method creates an arc/curve between two tangents on the canvas.
	     *
	     * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
	     *
	     * @param {number} x1 - The x-coordinate of the first tangent point of the arc
	     * @param {number} y1 - The y-coordinate of the first tangent point of the arc
	     * @param {number} x2 - The x-coordinate of the end of the arc
	     * @param {number} y2 - The y-coordinate of the end of the arc
	     * @param {number} radius - The radius of the arc
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.arcTo = function (x1, y1, x2, y2, radius) {
	        this._initCurve(x1, y1);
	        var points = this.currentPath.points;
	        var result = ArcUtils.curveTo(x1, y1, x2, y2, radius, points);
	        if (result) {
	            var cx = result.cx, cy = result.cy, radius_1 = result.radius, startAngle = result.startAngle, endAngle = result.endAngle, anticlockwise = result.anticlockwise;
	            this.arc(cx, cy, radius_1, startAngle, endAngle, anticlockwise);
	        }
	        return this;
	    };
	    /**
	     * The arc method creates an arc/curve (used to create circles, or parts of circles).
	     *
	     * @param {number} cx - The x-coordinate of the center of the circle
	     * @param {number} cy - The y-coordinate of the center of the circle
	     * @param {number} radius - The radius of the circle
	     * @param {number} startAngle - The starting angle, in radians (0 is at the 3 o'clock position
	     *  of the arc's circle)
	     * @param {number} endAngle - The ending angle, in radians
	     * @param {boolean} [anticlockwise=false] - Specifies whether the drawing should be
	     *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
	     *  indicates counter-clockwise.
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.arc = function (cx, cy, radius, startAngle, endAngle, anticlockwise) {
	        if (anticlockwise === void 0) { anticlockwise = false; }
	        if (startAngle === endAngle) {
	            return this;
	        }
	        if (!anticlockwise && endAngle <= startAngle) {
	            endAngle += PI_2;
	        }
	        else if (anticlockwise && startAngle <= endAngle) {
	            startAngle += PI_2;
	        }
	        var sweep = endAngle - startAngle;
	        if (sweep === 0) {
	            return this;
	        }
	        var startX = cx + (Math.cos(startAngle) * radius);
	        var startY = cy + (Math.sin(startAngle) * radius);
	        var eps = this._geometry.closePointEps;
	        // If the currentPath exists, take its points. Otherwise call `moveTo` to start a path.
	        var points = this.currentPath ? this.currentPath.points : null;
	        if (points) {
	            // TODO: make a better fix.
	            // We check how far our start is from the last existing point
	            var xDiff = Math.abs(points[points.length - 2] - startX);
	            var yDiff = Math.abs(points[points.length - 1] - startY);
	            if (xDiff < eps && yDiff < eps) { ; }
	            else {
	                points.push(startX, startY);
	            }
	        }
	        else {
	            this.moveTo(startX, startY);
	            points = this.currentPath.points;
	        }
	        ArcUtils.arc(startX, startY, cx, cy, radius, startAngle, endAngle, anticlockwise, points);
	        return this;
	    };
	    /**
	     * Specifies a simple one-color fill that subsequent calls to other Graphics methods
	     * (such as lineTo() or drawCircle()) use when drawing.
	     *
	     * @param {number} [color=0] - the color of the fill
	     * @param {number} [alpha=1] - the alpha of the fill
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.beginFill = function (color, alpha) {
	        if (color === void 0) { color = 0; }
	        if (alpha === void 0) { alpha = 1; }
	        return this.beginTextureFill({ texture: Texture.WHITE, color: color, alpha: alpha });
	    };
	    /**
	     * Begin the texture fill
	     *
	     * @param {object} [options] - Object object.
	     * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to fill
	     * @param {number} [options.color=0xffffff] - Background to fill behind texture
	     * @param {number} [options.alpha=1] - Alpha of fill
	     * @param {PIXI.Matrix} [options.matrix=null] - Transform matrix
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.beginTextureFill = function (options) {
	        // backward compatibility with params: (texture, color, alpha, matrix)
	        if (options instanceof Texture) {
	            deprecation('v5.2.0', 'Please use object-based options for Graphics#beginTextureFill');
	            // eslint-disable-next-line
	            var _a = arguments, texture = _a[0], color = _a[1], alpha = _a[2], matrix = _a[3];
	            options = { texture: texture, color: color, alpha: alpha, matrix: matrix };
	            // Remove undefined keys
	            Object.keys(options).forEach(function (key) { return options[key] === undefined && delete options[key]; });
	        }
	        // Apply defaults
	        options = Object.assign({
	            texture: Texture.WHITE,
	            color: 0xFFFFFF,
	            alpha: 1,
	            matrix: null,
	        }, options);
	        if (this.currentPath) {
	            this.startPoly();
	        }
	        var visible = options.alpha > 0;
	        if (!visible) {
	            this._fillStyle.reset();
	        }
	        else {
	            if (options.matrix) {
	                options.matrix = options.matrix.clone();
	                options.matrix.invert();
	            }
	            Object.assign(this._fillStyle, { visible: visible }, options);
	        }
	        return this;
	    };
	    /**
	     * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
	     *
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.endFill = function () {
	        this.finishPoly();
	        this._fillStyle.reset();
	        return this;
	    };
	    /**
	     * Draws a rectangle shape.
	     *
	     * @param {number} x - The X coord of the top-left of the rectangle
	     * @param {number} y - The Y coord of the top-left of the rectangle
	     * @param {number} width - The width of the rectangle
	     * @param {number} height - The height of the rectangle
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.drawRect = function (x, y, width, height) {
	        return this.drawShape(new Rectangle(x, y, width, height));
	    };
	    /**
	     * Draw a rectangle shape with rounded/beveled corners.
	     *
	     * @param {number} x - The X coord of the top-left of the rectangle
	     * @param {number} y - The Y coord of the top-left of the rectangle
	     * @param {number} width - The width of the rectangle
	     * @param {number} height - The height of the rectangle
	     * @param {number} radius - Radius of the rectangle corners
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.drawRoundedRect = function (x, y, width, height, radius) {
	        return this.drawShape(new RoundedRectangle(x, y, width, height, radius));
	    };
	    /**
	     * Draws a circle.
	     *
	     * @param {number} x - The X coordinate of the center of the circle
	     * @param {number} y - The Y coordinate of the center of the circle
	     * @param {number} radius - The radius of the circle
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.drawCircle = function (x, y, radius) {
	        return this.drawShape(new Circle(x, y, radius));
	    };
	    /**
	     * Draws an ellipse.
	     *
	     * @param {number} x - The X coordinate of the center of the ellipse
	     * @param {number} y - The Y coordinate of the center of the ellipse
	     * @param {number} width - The half width of the ellipse
	     * @param {number} height - The half height of the ellipse
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.drawEllipse = function (x, y, width, height) {
	        return this.drawShape(new Ellipse(x, y, width, height));
	    };
	    /**
	     * Draws a polygon using the given path.
	     *
	     * @param {number[]|PIXI.Point[]|PIXI.Polygon} path - The path data used to construct the polygon.
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.drawPolygon = function () {
	        var arguments$1 = arguments;

	        var path = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            path[_i] = arguments$1[_i];
	        }
	        var points;
	        var closeStroke = true; // !!this._fillStyle;
	        var poly = path[0];
	        // check if data has points..
	        if (poly.points) {
	            closeStroke = poly.closeStroke;
	            points = poly.points;
	        }
	        else if (Array.isArray(path[0])) {
	            points = path[0];
	        }
	        else {
	            points = path;
	        }
	        var shape = new Polygon(points);
	        shape.closeStroke = closeStroke;
	        this.drawShape(shape);
	        return this;
	    };
	    /**
	     * Draw any shape.
	     *
	     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - Shape to draw
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.drawShape = function (shape) {
	        if (!this._holeMode) {
	            this._geometry.drawShape(shape, this._fillStyle.clone(), this._lineStyle.clone(), this._matrix);
	        }
	        else {
	            this._geometry.drawHole(shape, this._matrix);
	        }
	        return this;
	    };
	    /**
	     * Draw a star shape with an arbitrary number of points.
	     *
	     * @param {number} x - Center X position of the star
	     * @param {number} y - Center Y position of the star
	     * @param {number} points - The number of points of the star, must be > 1
	     * @param {number} radius - The outer radius of the star
	     * @param {number} [innerRadius] - The inner radius between points, default half `radius`
	     * @param {number} [rotation=0] - The rotation of the star in radians, where 0 is vertical
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.drawStar = function (x, y, points, radius, innerRadius, rotation) {
	        if (rotation === void 0) { rotation = 0; }
	        return this.drawPolygon(new Star(x, y, points, radius, innerRadius, rotation));
	    };
	    /**
	     * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
	     *
	     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
	     */
	    Graphics.prototype.clear = function () {
	        this._geometry.clear();
	        this._lineStyle.reset();
	        this._fillStyle.reset();
	        this._boundsID++;
	        this._matrix = null;
	        this._holeMode = false;
	        this.currentPath = null;
	        return this;
	    };
	    /**
	     * True if graphics consists of one rectangle, and thus, can be drawn like a Sprite and
	     * masked with gl.scissor.
	     *
	     * @returns {boolean} True if only 1 rect.
	     */
	    Graphics.prototype.isFastRect = function () {
	        var data = this._geometry.graphicsData;
	        return data.length === 1
	            && data[0].shape.type === exports.SHAPES.RECT
	            && !(data[0].lineStyle.visible && data[0].lineStyle.width);
	    };
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @protected
	     * @param {PIXI.Renderer} renderer - The renderer
	     */
	    Graphics.prototype._render = function (renderer) {
	        this.finishPoly();
	        var geometry = this._geometry;
	        var hasuint32 = renderer.context.supports.uint32Indices;
	        // batch part..
	        // batch it!
	        geometry.updateBatches(hasuint32);
	        if (geometry.batchable) {
	            if (this.batchDirty !== geometry.batchDirty) {
	                this._populateBatches();
	            }
	            this._renderBatched(renderer);
	        }
	        else {
	            // no batching...
	            renderer.batch.flush();
	            this._renderDirect(renderer);
	        }
	    };
	    /**
	     * Populating batches for rendering
	     *
	     * @protected
	     */
	    Graphics.prototype._populateBatches = function () {
	        var geometry = this._geometry;
	        var blendMode = this.blendMode;
	        var len = geometry.batches.length;
	        this.batchTint = -1;
	        this._transformID = -1;
	        this.batchDirty = geometry.batchDirty;
	        this.batches.length = len;
	        this.vertexData = new Float32Array(geometry.points);
	        for (var i = 0; i < len; i++) {
	            var gI = geometry.batches[i];
	            var color = gI.style.color;
	            var vertexData = new Float32Array(this.vertexData.buffer, gI.attribStart * 4 * 2, gI.attribSize * 2);
	            var uvs = new Float32Array(geometry.uvsFloat32.buffer, gI.attribStart * 4 * 2, gI.attribSize * 2);
	            var indices = new Uint16Array(geometry.indicesUint16.buffer, gI.start * 2, gI.size);
	            var batch = {
	                vertexData: vertexData,
	                blendMode: blendMode,
	                indices: indices,
	                uvs: uvs,
	                _batchRGB: hex2rgb(color),
	                _tintRGB: color,
	                _texture: gI.style.texture,
	                alpha: gI.style.alpha,
	                worldAlpha: 1
	            };
	            this.batches[i] = batch;
	        }
	    };
	    /**
	     * Renders the batches using the BathedRenderer plugin
	     *
	     * @protected
	     * @param {PIXI.Renderer} renderer - The renderer
	     */
	    Graphics.prototype._renderBatched = function (renderer) {
	        if (!this.batches.length) {
	            return;
	        }
	        renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]);
	        this.calculateVertices();
	        this.calculateTints();
	        for (var i = 0, l = this.batches.length; i < l; i++) {
	            var batch = this.batches[i];
	            batch.worldAlpha = this.worldAlpha * batch.alpha;
	            renderer.plugins[this.pluginName].render(batch);
	        }
	    };
	    /**
	     * Renders the graphics direct
	     *
	     * @protected
	     * @param {PIXI.Renderer} renderer - The renderer
	     */
	    Graphics.prototype._renderDirect = function (renderer) {
	        var shader = this._resolveDirectShader(renderer);
	        var geometry = this._geometry;
	        var tint = this.tint;
	        var worldAlpha = this.worldAlpha;
	        var uniforms = shader.uniforms;
	        var drawCalls = geometry.drawCalls;
	        // lets set the transfomr
	        uniforms.translationMatrix = this.transform.worldTransform;
	        // and then lets set the tint..
	        uniforms.tint[0] = (((tint >> 16) & 0xFF) / 255) * worldAlpha;
	        uniforms.tint[1] = (((tint >> 8) & 0xFF) / 255) * worldAlpha;
	        uniforms.tint[2] = ((tint & 0xFF) / 255) * worldAlpha;
	        uniforms.tint[3] = worldAlpha;
	        // the first draw call, we can set the uniforms of the shader directly here.
	        // this means that we can tack advantage of the sync function of pixi!
	        // bind and sync uniforms..
	        // there is a way to optimise this..
	        renderer.shader.bind(shader);
	        renderer.geometry.bind(geometry, shader);
	        // set state..
	        renderer.state.set(this.state);
	        // then render the rest of them...
	        for (var i = 0, l = drawCalls.length; i < l; i++) {
	            this._renderDrawCallDirect(renderer, geometry.drawCalls[i]);
	        }
	    };
	    /**
	     * Renders specific DrawCall
	     *
	     * @param {PIXI.Renderer} renderer
	     * @param {PIXI.BatchDrawCall} drawCall
	     */
	    Graphics.prototype._renderDrawCallDirect = function (renderer, drawCall) {
	        var texArray = drawCall.texArray, type = drawCall.type, size = drawCall.size, start = drawCall.start;
	        var groupTextureCount = texArray.count;
	        for (var j = 0; j < groupTextureCount; j++) {
	            renderer.texture.bind(texArray.elements[j], j);
	        }
	        renderer.geometry.draw(type, size, start);
	    };
	    /**
	     * Resolves shader for direct rendering
	     *
	     * @protected
	     * @param {PIXI.Renderer} renderer - The renderer
	     */
	    Graphics.prototype._resolveDirectShader = function (renderer) {
	        var shader = this.shader;
	        var pluginName = this.pluginName;
	        if (!shader) {
	            // if there is no shader here, we can use the default shader.
	            // and that only gets created if we actually need it..
	            // but may be more than one plugins for graphics
	            if (!DEFAULT_SHADERS[pluginName]) {
	                var MAX_TEXTURES = renderer.plugins.batch.MAX_TEXTURES;
	                var sampleValues = new Int32Array(MAX_TEXTURES);
	                for (var i = 0; i < MAX_TEXTURES; i++) {
	                    sampleValues[i] = i;
	                }
	                var uniforms = {
	                    tint: new Float32Array([1, 1, 1, 1]),
	                    translationMatrix: new Matrix(),
	                    default: UniformGroup.from({ uSamplers: sampleValues }, true),
	                };
	                var program = renderer.plugins[pluginName]._shader.program;
	                DEFAULT_SHADERS[pluginName] = new Shader(program, uniforms);
	            }
	            shader = DEFAULT_SHADERS[pluginName];
	        }
	        return shader;
	    };
	    /**
	     * Retrieves the bounds of the graphic shape as a rectangle object
	     *
	     * @protected
	     */
	    Graphics.prototype._calculateBounds = function () {
	        this.finishPoly();
	        var geometry = this._geometry;
	        // skipping when graphics is empty, like a container
	        if (!geometry.graphicsData.length) {
	            return;
	        }
	        var _a = geometry.bounds, minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
	        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
	    };
	    /**
	     * Tests if a point is inside this graphics object
	     *
	     * @param {PIXI.IPointData} point - the point to test
	     * @return {boolean} the result of the test
	     */
	    Graphics.prototype.containsPoint = function (point) {
	        this.worldTransform.applyInverse(point, Graphics._TEMP_POINT);
	        return this._geometry.containsPoint(Graphics._TEMP_POINT);
	    };
	    /**
	     * Recalcuate the tint by applying tin to batches using Graphics tint.
	     * @protected
	     */
	    Graphics.prototype.calculateTints = function () {
	        if (this.batchTint !== this.tint) {
	            this.batchTint = this.tint;
	            var tintRGB = hex2rgb(this.tint, temp);
	            for (var i = 0; i < this.batches.length; i++) {
	                var batch = this.batches[i];
	                var batchTint = batch._batchRGB;
	                var r = (tintRGB[0] * batchTint[0]) * 255;
	                var g = (tintRGB[1] * batchTint[1]) * 255;
	                var b = (tintRGB[2] * batchTint[2]) * 255;
	                // TODO Ivan, can this be done in one go?
	                var color = (r << 16) + (g << 8) + (b | 0);
	                batch._tintRGB = (color >> 16)
	                    + (color & 0xff00)
	                    + ((color & 0xff) << 16);
	            }
	        }
	    };
	    /**
	     * If there's a transform update or a change to the shape of the
	     * geometry, recaculate the vertices.
	     * @protected
	     */
	    Graphics.prototype.calculateVertices = function () {
	        var wtID = this.transform._worldID;
	        if (this._transformID === wtID) {
	            return;
	        }
	        this._transformID = wtID;
	        var wt = this.transform.worldTransform;
	        var a = wt.a;
	        var b = wt.b;
	        var c = wt.c;
	        var d = wt.d;
	        var tx = wt.tx;
	        var ty = wt.ty;
	        var data = this._geometry.points; // batch.vertexDataOriginal;
	        var vertexData = this.vertexData;
	        var count = 0;
	        for (var i = 0; i < data.length; i += 2) {
	            var x = data[i];
	            var y = data[i + 1];
	            vertexData[count++] = (a * x) + (c * y) + tx;
	            vertexData[count++] = (d * y) + (b * x) + ty;
	        }
	    };
	    /**
	     * Closes the current path.
	     *
	     * @return {PIXI.Graphics} Returns itself.
	     */
	    Graphics.prototype.closePath = function () {
	        var currentPath = this.currentPath;
	        if (currentPath) {
	            // we don't need to add extra point in the end because buildLine will take care of that
	            currentPath.closeStroke = true;
	        }
	        return this;
	    };
	    /**
	     * Apply a matrix to the positional data.
	     *
	     * @param {PIXI.Matrix} matrix - Matrix to use for transform current shape.
	     * @return {PIXI.Graphics} Returns itself.
	     */
	    Graphics.prototype.setMatrix = function (matrix) {
	        this._matrix = matrix;
	        return this;
	    };
	    /**
	     * Begin adding holes to the last draw shape
	     * IMPORTANT: holes must be fully inside a shape to work
	     * Also weirdness ensues if holes overlap!
	     * Ellipses, Circles, Rectangles and Rounded Rectangles cannot be holes or host for holes in CanvasRenderer,
	     * please use `moveTo` `lineTo`, `quadraticCurveTo` if you rely on pixi-legacy bundle.
	     * @return {PIXI.Graphics} Returns itself.
	     */
	    Graphics.prototype.beginHole = function () {
	        this.finishPoly();
	        this._holeMode = true;
	        return this;
	    };
	    /**
	     * End adding holes to the last draw shape
	     * @return {PIXI.Graphics} Returns itself.
	     */
	    Graphics.prototype.endHole = function () {
	        this.finishPoly();
	        this._holeMode = false;
	        return this;
	    };
	    /**
	     * Destroys the Graphics object.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all
	     *  options have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have
	     *  their destroy method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the texture of the child sprite
	     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
	     *  Should it destroy the base texture of the child sprite
	     */
	    Graphics.prototype.destroy = function (options) {
	        this._geometry.refCount--;
	        if (this._geometry.refCount === 0) {
	            this._geometry.dispose();
	        }
	        this._matrix = null;
	        this.currentPath = null;
	        this._lineStyle.destroy();
	        this._lineStyle = null;
	        this._fillStyle.destroy();
	        this._fillStyle = null;
	        this._geometry = null;
	        this.shader = null;
	        this.vertexData = null;
	        this.batches.length = 0;
	        this.batches = null;
	        _super.prototype.destroy.call(this, options);
	    };
	    /**
	     * Temporary point to use for containsPoint
	     *
	     * @static
	     * @private
	     * @member {PIXI.Point}
	     */
	    Graphics._TEMP_POINT = new Point();
	    return Graphics;
	}(Container));

	/*!
	 * @pixi/sprite - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/sprite is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$6 = function(d, b) {
	    extendStatics$6 = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$6(d, b);
	};

	function __extends$6(d, b) {
	    extendStatics$6(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	var tempPoint = new Point();
	var indices = new Uint16Array([0, 1, 2, 0, 2, 3]);
	/**
	 * The Sprite object is the base for all textured objects that are rendered to the screen
	*
	 * A sprite can be created directly from an image like this:
	 *
	 * ```js
	 * let sprite = PIXI.Sprite.from('assets/image.png');
	 * ```
	 *
	 * The more efficient way to create sprites is using a {@link PIXI.Spritesheet},
	 * as swapping base textures when rendering to the screen is inefficient.
	 *
	 * ```js
	 * PIXI.Loader.shared.add("assets/spritesheet.json").load(setup);
	 *
	 * function setup() {
	 *   let sheet = PIXI.Loader.shared.resources["assets/spritesheet.json"].spritesheet;
	 *   let sprite = new PIXI.Sprite(sheet.textures["image.png"]);
	 *   ...
	 * }
	 * ```
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI
	 */
	var Sprite = /** @class */ (function (_super) {
	    __extends$6(Sprite, _super);
	    /**
	     * @param {PIXI.Texture} [texture] - The texture for this sprite.
	     */
	    function Sprite(texture) {
	        var _this = _super.call(this) || this;
	        /**
	         * The anchor point defines the normalized coordinates
	         * in the texture that map to the position of this
	         * sprite.
	         *
	         * By default, this is `(0,0)` (or `texture.defaultAnchor`
	         * if you have modified that), which means the position
	         * `(x,y)` of this `Sprite` will be the top-left corner.
	         *
	         * Note: Updating `texture.defaultAnchor` after
	         * constructing a `Sprite` does _not_ update its anchor.
	         *
	         * {@link https://docs.cocos2d-x.org/cocos2d-x/en/sprites/manipulation.html}
	         *
	         * @default `texture.defaultAnchor`
	         * @member {PIXI.ObservablePoint}
	         * @private
	         */
	        _this._anchor = new ObservablePoint(_this._onAnchorUpdate, _this, (texture ? texture.defaultAnchor.x : 0), (texture ? texture.defaultAnchor.y : 0));
	        /**
	         * The texture that the sprite is using
	         *
	         * @private
	         * @member {PIXI.Texture}
	         */
	        _this._texture = null;
	        /**
	         * The width of the sprite (this is initially set by the texture)
	         *
	         * @protected
	         * @member {number}
	         */
	        _this._width = 0;
	        /**
	         * The height of the sprite (this is initially set by the texture)
	         *
	         * @protected
	         * @member {number}
	         */
	        _this._height = 0;
	        /**
	         * The tint applied to the sprite. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @private
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        _this._tint = null;
	        /**
	         * The tint applied to the sprite. This is a RGB value. A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @private
	         * @member {number}
	         * @default 16777215
	         */
	        _this._tintRGB = null;
	        _this.tint = 0xFFFFFF;
	        /**
	         * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         * @see PIXI.BLEND_MODES
	         */
	        _this.blendMode = exports.BLEND_MODES.NORMAL;
	        /**
	         * Cached tint value so we can tell when the tint is changed.
	         * Value is used for 2d CanvasRenderer.
	         *
	         * @protected
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        _this._cachedTint = 0xFFFFFF;
	        /**
	         * this is used to store the uvs data of the sprite, assigned at the same time
	         * as the vertexData in calculateVertices()
	         *
	         * @private
	         * @member {Float32Array}
	         */
	        _this.uvs = null;
	        // call texture setter
	        _this.texture = texture || Texture.EMPTY;
	        /**
	         * this is used to store the vertex data of the sprite (basically a quad)
	         *
	         * @private
	         * @member {Float32Array}
	         */
	        _this.vertexData = new Float32Array(8);
	        /**
	         * This is used to calculate the bounds of the object IF it is a trimmed sprite
	         *
	         * @private
	         * @member {Float32Array}
	         */
	        _this.vertexTrimmedData = null;
	        _this._transformID = -1;
	        _this._textureID = -1;
	        _this._transformTrimmedID = -1;
	        _this._textureTrimmedID = -1;
	        // Batchable stuff..
	        // TODO could make this a mixin?
	        _this.indices = indices;
	        /**
	         * Plugin that is responsible for rendering this element.
	         * Allows to customize the rendering process without overriding '_render' & '_renderCanvas' methods.
	         *
	         * @member {string}
	         * @default 'batch'
	         */
	        _this.pluginName = 'batch';
	        /**
	         * used to fast check if a sprite is.. a sprite!
	         * @member {boolean}
	         */
	        _this.isSprite = true;
	        /**
	         * Internal roundPixels field
	         *
	         * @member {boolean}
	         * @private
	         */
	        _this._roundPixels = settings.ROUND_PIXELS;
	        return _this;
	    }
	    /**
	     * When the texture is updated, this event will fire to update the scale and frame
	     *
	     * @protected
	     */
	    Sprite.prototype._onTextureUpdate = function () {
	        this._textureID = -1;
	        this._textureTrimmedID = -1;
	        this._cachedTint = 0xFFFFFF;
	        // so if _width is 0 then width was not set..
	        if (this._width) {
	            this.scale.x = sign$1(this.scale.x) * this._width / this._texture.orig.width;
	        }
	        if (this._height) {
	            this.scale.y = sign$1(this.scale.y) * this._height / this._texture.orig.height;
	        }
	    };
	    /**
	     * Called when the anchor position updates.
	     *
	     * @private
	     */
	    Sprite.prototype._onAnchorUpdate = function () {
	        this._transformID = -1;
	        this._transformTrimmedID = -1;
	    };
	    /**
	     * calculates worldTransform * vertices, store it in vertexData
	     */
	    Sprite.prototype.calculateVertices = function () {
	        var texture = this._texture;
	        if (this._transformID === this.transform._worldID && this._textureID === texture._updateID) {
	            return;
	        }
	        // update texture UV here, because base texture can be changed without calling `_onTextureUpdate`
	        if (this._textureID !== texture._updateID) {
	            this.uvs = this._texture._uvs.uvsFloat32;
	        }
	        this._transformID = this.transform._worldID;
	        this._textureID = texture._updateID;
	        // set the vertex data
	        var wt = this.transform.worldTransform;
	        var a = wt.a;
	        var b = wt.b;
	        var c = wt.c;
	        var d = wt.d;
	        var tx = wt.tx;
	        var ty = wt.ty;
	        var vertexData = this.vertexData;
	        var trim = texture.trim;
	        var orig = texture.orig;
	        var anchor = this._anchor;
	        var w0 = 0;
	        var w1 = 0;
	        var h0 = 0;
	        var h1 = 0;
	        if (trim) {
	            // if the sprite is trimmed and is not a tilingsprite then we need to add the extra
	            // space before transforming the sprite coords.
	            w1 = trim.x - (anchor._x * orig.width);
	            w0 = w1 + trim.width;
	            h1 = trim.y - (anchor._y * orig.height);
	            h0 = h1 + trim.height;
	        }
	        else {
	            w1 = -anchor._x * orig.width;
	            w0 = w1 + orig.width;
	            h1 = -anchor._y * orig.height;
	            h0 = h1 + orig.height;
	        }
	        // xy
	        vertexData[0] = (a * w1) + (c * h1) + tx;
	        vertexData[1] = (d * h1) + (b * w1) + ty;
	        // xy
	        vertexData[2] = (a * w0) + (c * h1) + tx;
	        vertexData[3] = (d * h1) + (b * w0) + ty;
	        // xy
	        vertexData[4] = (a * w0) + (c * h0) + tx;
	        vertexData[5] = (d * h0) + (b * w0) + ty;
	        // xy
	        vertexData[6] = (a * w1) + (c * h0) + tx;
	        vertexData[7] = (d * h0) + (b * w1) + ty;
	        if (this._roundPixels) {
	            var resolution = settings.RESOLUTION;
	            for (var i = 0; i < vertexData.length; ++i) {
	                vertexData[i] = Math.round((vertexData[i] * resolution | 0) / resolution);
	            }
	        }
	    };
	    /**
	     * calculates worldTransform * vertices for a non texture with a trim. store it in vertexTrimmedData
	     * This is used to ensure that the true width and height of a trimmed texture is respected
	     */
	    Sprite.prototype.calculateTrimmedVertices = function () {
	        if (!this.vertexTrimmedData) {
	            this.vertexTrimmedData = new Float32Array(8);
	        }
	        else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID) {
	            return;
	        }
	        this._transformTrimmedID = this.transform._worldID;
	        this._textureTrimmedID = this._texture._updateID;
	        // lets do some special trim code!
	        var texture = this._texture;
	        var vertexData = this.vertexTrimmedData;
	        var orig = texture.orig;
	        var anchor = this._anchor;
	        // lets calculate the new untrimmed bounds..
	        var wt = this.transform.worldTransform;
	        var a = wt.a;
	        var b = wt.b;
	        var c = wt.c;
	        var d = wt.d;
	        var tx = wt.tx;
	        var ty = wt.ty;
	        var w1 = -anchor._x * orig.width;
	        var w0 = w1 + orig.width;
	        var h1 = -anchor._y * orig.height;
	        var h0 = h1 + orig.height;
	        // xy
	        vertexData[0] = (a * w1) + (c * h1) + tx;
	        vertexData[1] = (d * h1) + (b * w1) + ty;
	        // xy
	        vertexData[2] = (a * w0) + (c * h1) + tx;
	        vertexData[3] = (d * h1) + (b * w0) + ty;
	        // xy
	        vertexData[4] = (a * w0) + (c * h0) + tx;
	        vertexData[5] = (d * h0) + (b * w0) + ty;
	        // xy
	        vertexData[6] = (a * w1) + (c * h0) + tx;
	        vertexData[7] = (d * h0) + (b * w1) + ty;
	    };
	    /**
	    *
	    * Renders the object using the WebGL renderer
	    *
	    * @protected
	    * @param {PIXI.Renderer} renderer - The webgl renderer to use.
	    */
	    Sprite.prototype._render = function (renderer) {
	        this.calculateVertices();
	        renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]);
	        renderer.plugins[this.pluginName].render(this);
	    };
	    /**
	     * Updates the bounds of the sprite.
	     *
	     * @protected
	     */
	    Sprite.prototype._calculateBounds = function () {
	        var trim = this._texture.trim;
	        var orig = this._texture.orig;
	        // First lets check to see if the current texture has a trim..
	        if (!trim || (trim.width === orig.width && trim.height === orig.height)) {
	            // no trim! lets use the usual calculations..
	            this.calculateVertices();
	            this._bounds.addQuad(this.vertexData);
	        }
	        else {
	            // lets calculate a special trimmed bounds...
	            this.calculateTrimmedVertices();
	            this._bounds.addQuad(this.vertexTrimmedData);
	        }
	    };
	    /**
	     * Gets the local bounds of the sprite object.
	     *
	     * @param {PIXI.Rectangle} [rect] - The output rectangle.
	     * @return {PIXI.Rectangle} The bounds.
	     */
	    Sprite.prototype.getLocalBounds = function (rect) {
	        // we can do a fast local bounds if the sprite has no children!
	        if (this.children.length === 0) {
	            this._bounds.minX = this._texture.orig.width * -this._anchor._x;
	            this._bounds.minY = this._texture.orig.height * -this._anchor._y;
	            this._bounds.maxX = this._texture.orig.width * (1 - this._anchor._x);
	            this._bounds.maxY = this._texture.orig.height * (1 - this._anchor._y);
	            if (!rect) {
	                if (!this._localBoundsRect) {
	                    this._localBoundsRect = new Rectangle();
	                }
	                rect = this._localBoundsRect;
	            }
	            return this._bounds.getRectangle(rect);
	        }
	        return _super.prototype.getLocalBounds.call(this, rect);
	    };
	    /**
	     * Tests if a point is inside this sprite
	     *
	     * @param {PIXI.IPointData} point - the point to test
	     * @return {boolean} the result of the test
	     */
	    Sprite.prototype.containsPoint = function (point) {
	        this.worldTransform.applyInverse(point, tempPoint);
	        var width = this._texture.orig.width;
	        var height = this._texture.orig.height;
	        var x1 = -width * this.anchor.x;
	        var y1 = 0;
	        if (tempPoint.x >= x1 && tempPoint.x < x1 + width) {
	            y1 = -height * this.anchor.y;
	            if (tempPoint.y >= y1 && tempPoint.y < y1 + height) {
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * Destroys this sprite and optionally its texture and children
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
	     *      method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
	     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
	     */
	    Sprite.prototype.destroy = function (options) {
	        _super.prototype.destroy.call(this, options);
	        this._texture.off('update', this._onTextureUpdate, this);
	        this._anchor = null;
	        var destroyTexture = typeof options === 'boolean' ? options : options && options.texture;
	        if (destroyTexture) {
	            var destroyBaseTexture = typeof options === 'boolean' ? options : options && options.baseTexture;
	            this._texture.destroy(!!destroyBaseTexture);
	        }
	        this._texture = null;
	    };
	    // some helper functions..
	    /**
	     * Helper function that creates a new sprite based on the source you provide.
	     * The source can be - frame id, image url, video url, canvas element, video element, base texture
	     *
	     * @static
	     * @param {string|PIXI.Texture|HTMLCanvasElement|HTMLVideoElement} source - Source to create texture from
	     * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
	     * @return {PIXI.Sprite} The newly created sprite
	     */
	    Sprite.from = function (source, options) {
	        var texture = (source instanceof Texture)
	            ? source
	            : Texture.from(source, options);
	        return new Sprite(texture);
	    };
	    Object.defineProperty(Sprite.prototype, "roundPixels", {
	        get: function () {
	            return this._roundPixels;
	        },
	        /**
	         * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
	         * Advantages can include sharper image quality (like text) and faster rendering on canvas.
	         * The main disadvantage is movement of objects may appear less smooth.
	         * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
	         *
	         * @member {boolean}
	         * @default false
	         */
	        set: function (value) {
	            if (this._roundPixels !== value) {
	                this._transformID = -1;
	            }
	            this._roundPixels = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Sprite.prototype, "width", {
	        /**
	         * The width of the sprite, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	        get: function () {
	            return Math.abs(this.scale.x) * this._texture.orig.width;
	        },
	        set: function (value) {
	            var s = sign$1(this.scale.x) || 1;
	            this.scale.x = s * value / this._texture.orig.width;
	            this._width = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Sprite.prototype, "height", {
	        /**
	         * The height of the sprite, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	        get: function () {
	            return Math.abs(this.scale.y) * this._texture.orig.height;
	        },
	        set: function (value) {
	            var s = sign$1(this.scale.y) || 1;
	            this.scale.y = s * value / this._texture.orig.height;
	            this._height = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Sprite.prototype, "anchor", {
	        /**
	         * The anchor sets the origin point of the sprite. The default value is taken from the {@link PIXI.Texture|Texture}
	         * and passed to the constructor.
	         *
	         * The default is `(0,0)`, this means the sprite's origin is the top left.
	         *
	         * Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
	         *
	         * Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
	         *
	         * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
	         *
	         * @example
	         * const sprite = new PIXI.Sprite(texture);
	         * sprite.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        get: function () {
	            return this._anchor;
	        },
	        set: function (value) {
	            this._anchor.copyFrom(value);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Sprite.prototype, "tint", {
	        /**
	         * The tint applied to the sprite. This is a hex value.
	         * A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        get: function () {
	            return this._tint;
	        },
	        set: function (value) {
	            this._tint = value;
	            this._tintRGB = (value >> 16) + (value & 0xff00) + ((value & 0xff) << 16);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Sprite.prototype, "texture", {
	        /**
	         * The texture that the sprite is using
	         *
	         * @member {PIXI.Texture}
	         */
	        get: function () {
	            return this._texture;
	        },
	        set: function (value) {
	            if (this._texture === value) {
	                return;
	            }
	            if (this._texture) {
	                this._texture.off('update', this._onTextureUpdate, this);
	            }
	            this._texture = value || Texture.EMPTY;
	            this._cachedTint = 0xFFFFFF;
	            this._textureID = -1;
	            this._textureTrimmedID = -1;
	            if (value) {
	                // wait for the texture to load
	                if (value.baseTexture.valid) {
	                    this._onTextureUpdate();
	                }
	                else {
	                    value.once('update', this._onTextureUpdate, this);
	                }
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Sprite;
	}(Container));

	/*!
	 * @pixi/text - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/text is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$7 = function(d, b) {
	    extendStatics$7 = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$7(d, b);
	};

	function __extends$7(d, b) {
	    extendStatics$7(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	/**
	 * Constants that define the type of gradient on text.
	 *
	 * @static
	 * @constant
	 * @name TEXT_GRADIENT
	 * @memberof PIXI
	 * @type {object}
	 * @property {number} LINEAR_VERTICAL Vertical gradient
	 * @property {number} LINEAR_HORIZONTAL Linear gradient
	 */

	(function (TEXT_GRADIENT) {
	    TEXT_GRADIENT[TEXT_GRADIENT["LINEAR_VERTICAL"] = 0] = "LINEAR_VERTICAL";
	    TEXT_GRADIENT[TEXT_GRADIENT["LINEAR_HORIZONTAL"] = 1] = "LINEAR_HORIZONTAL";
	})(exports.TEXT_GRADIENT || (exports.TEXT_GRADIENT = {}));

	// disabling eslint for now, going to rewrite this in v5
	var defaultStyle = {
	    align: 'left',
	    breakWords: false,
	    dropShadow: false,
	    dropShadowAlpha: 1,
	    dropShadowAngle: Math.PI / 6,
	    dropShadowBlur: 0,
	    dropShadowColor: 'black',
	    dropShadowDistance: 5,
	    fill: 'black',
	    fillGradientType: exports.TEXT_GRADIENT.LINEAR_VERTICAL,
	    fillGradientStops: [],
	    fontFamily: 'Arial',
	    fontSize: 26,
	    fontStyle: 'normal',
	    fontVariant: 'normal',
	    fontWeight: 'normal',
	    letterSpacing: 0,
	    lineHeight: 0,
	    lineJoin: 'miter',
	    miterLimit: 10,
	    padding: 0,
	    stroke: 'black',
	    strokeThickness: 0,
	    textBaseline: 'alphabetic',
	    trim: false,
	    whiteSpace: 'pre',
	    wordWrap: false,
	    wordWrapWidth: 100,
	    leading: 0,
	};
	var genericFontFamilies = [
	    'serif',
	    'sans-serif',
	    'monospace',
	    'cursive',
	    'fantasy',
	    'system-ui' ];
	/**
	 * A TextStyle Object contains information to decorate a Text objects.
	 *
	 * An instance can be shared between multiple Text objects; then changing the style will update all text objects using it.
	 *
	 * A tool can be used to generate a text style [here](https://pixijs.io/pixi-text-style).
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TextStyle = /** @class */ (function () {
	    /**
	     * @param {object} [style] - The style parameters
	     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'),
	     *  does not affect single line text
	     * @param {boolean} [style.breakWords=false] - Indicates if lines can be wrapped within words, it
	     *  needs wordWrap to be set to true
	     * @param {boolean} [style.dropShadow=false] - Set a drop shadow for the text
	     * @param {number} [style.dropShadowAlpha=1] - Set alpha for the drop shadow
	     * @param {number} [style.dropShadowAngle=Math.PI/6] - Set a angle of the drop shadow
	     * @param {number} [style.dropShadowBlur=0] - Set a shadow blur radius
	     * @param {string|number} [style.dropShadowColor='black'] - A fill style to be used on the dropshadow e.g 'red', '#00FF00'
	     * @param {number} [style.dropShadowDistance=5] - Set a distance of the drop shadow
	     * @param {string|string[]|number|number[]|CanvasGradient|CanvasPattern} [style.fill='black'] - A canvas
	     *  fillstyle that will be used on the text e.g 'red', '#00FF00'. Can be an array to create a gradient
	     *  eg ['#000000','#FFFFFF']
	     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
	     * @param {number} [style.fillGradientType=PIXI.TEXT_GRADIENT.LINEAR_VERTICAL] - If fill is an array of colours
	     *  to create a gradient, this can change the type/direction of the gradient. See {@link PIXI.TEXT_GRADIENT}
	     * @param {number[]} [style.fillGradientStops] - If fill is an array of colours to create a gradient, this array can set
	     * the stop points (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
	     * @param {string|string[]} [style.fontFamily='Arial'] - The font family
	     * @param {number|string} [style.fontSize=26] - The font size (as a number it converts to px, but as a string,
	     *  equivalents are '26px','20pt','160%' or '1.6em')
	     * @param {string} [style.fontStyle='normal'] - The font style ('normal', 'italic' or 'oblique')
	     * @param {string} [style.fontVariant='normal'] - The font variant ('normal' or 'small-caps')
	     * @param {string} [style.fontWeight='normal'] - The font weight ('normal', 'bold', 'bolder', 'lighter' and '100',
	     *  '200', '300', '400', '500', '600', '700', '800' or '900')
	     * @param {number} [style.leading=0] - The space between lines
	     * @param {number} [style.letterSpacing=0] - The amount of spacing between letters, default is 0
	     * @param {number} [style.lineHeight] - The line height, a number that represents the vertical space that a letter uses
	     * @param {string} [style.lineJoin='miter'] - The lineJoin property sets the type of corner created, it can resolve
	     *      spiked text issues. Possible values "miter" (creates a sharp corner), "round" (creates a round corner) or "bevel"
	     *      (creates a squared corner).
	     * @param {number} [style.miterLimit=10] - The miter limit to use when using the 'miter' lineJoin mode. This can reduce
	     *      or increase the spikiness of rendered text.
	     * @param {number} [style.padding=0] - Occasionally some fonts are cropped. Adding some padding will prevent this from
	     *     happening by adding padding to all sides of the text.
	     * @param {string|number} [style.stroke='black'] - A canvas fillstyle that will be used on the text stroke
	     *  e.g 'blue', '#FCFF00'
	     * @param {number} [style.strokeThickness=0] - A number that represents the thickness of the stroke.
	     *  Default is 0 (no stroke)
	     * @param {boolean} [style.trim=false] - Trim transparent borders
	     * @param {string} [style.textBaseline='alphabetic'] - The baseline of the text that is rendered.
	     * @param {string} [style.whiteSpace='pre'] - Determines whether newlines & spaces are collapsed or preserved "normal"
	     *      (collapse, collapse), "pre" (preserve, preserve) | "pre-line" (preserve, collapse). It needs wordWrap to be set to true
	     * @param {boolean} [style.wordWrap=false] - Indicates if word wrap should be used
	     * @param {number} [style.wordWrapWidth=100] - The width at which text will wrap, it needs wordWrap to be set to true
	     */
	    function TextStyle(style) {
	        this.styleID = 0;
	        this.reset();
	        deepCopyProperties(this, style, style);
	    }
	    /**
	     * Creates a new TextStyle object with the same values as this one.
	     * Note that the only the properties of the object are cloned.
	     *
	     * @return {PIXI.TextStyle} New cloned TextStyle object
	     */
	    TextStyle.prototype.clone = function () {
	        var clonedProperties = {};
	        deepCopyProperties(clonedProperties, this, defaultStyle);
	        return new TextStyle(clonedProperties);
	    };
	    /**
	     * Resets all properties to the defaults specified in TextStyle.prototype._default
	     */
	    TextStyle.prototype.reset = function () {
	        deepCopyProperties(this, defaultStyle, defaultStyle);
	    };
	    Object.defineProperty(TextStyle.prototype, "align", {
	        /**
	         * Alignment for multiline text ('left', 'center' or 'right'), does not affect single line text
	         *
	         * @member {string}
	         */
	        get: function () {
	            return this._align;
	        },
	        set: function (align) {
	            if (this._align !== align) {
	                this._align = align;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "breakWords", {
	        /**
	         * Indicates if lines can be wrapped within words, it needs wordWrap to be set to true
	         *
	         * @member {boolean}
	         */
	        get: function () {
	            return this._breakWords;
	        },
	        set: function (breakWords) {
	            if (this._breakWords !== breakWords) {
	                this._breakWords = breakWords;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "dropShadow", {
	        /**
	         * Set a drop shadow for the text
	         *
	         * @member {boolean}
	         */
	        get: function () {
	            return this._dropShadow;
	        },
	        set: function (dropShadow) {
	            if (this._dropShadow !== dropShadow) {
	                this._dropShadow = dropShadow;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "dropShadowAlpha", {
	        /**
	         * Set alpha for the drop shadow
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._dropShadowAlpha;
	        },
	        set: function (dropShadowAlpha) {
	            if (this._dropShadowAlpha !== dropShadowAlpha) {
	                this._dropShadowAlpha = dropShadowAlpha;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "dropShadowAngle", {
	        /**
	         * Set a angle of the drop shadow
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._dropShadowAngle;
	        },
	        set: function (dropShadowAngle) {
	            if (this._dropShadowAngle !== dropShadowAngle) {
	                this._dropShadowAngle = dropShadowAngle;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "dropShadowBlur", {
	        /**
	         * Set a shadow blur radius
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._dropShadowBlur;
	        },
	        set: function (dropShadowBlur) {
	            if (this._dropShadowBlur !== dropShadowBlur) {
	                this._dropShadowBlur = dropShadowBlur;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "dropShadowColor", {
	        /**
	         * A fill style to be used on the dropshadow e.g 'red', '#00FF00'
	         *
	         * @member {string|number}
	         */
	        get: function () {
	            return this._dropShadowColor;
	        },
	        set: function (dropShadowColor) {
	            var outputColor = getColor(dropShadowColor);
	            if (this._dropShadowColor !== outputColor) {
	                this._dropShadowColor = outputColor;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "dropShadowDistance", {
	        /**
	         * Set a distance of the drop shadow
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._dropShadowDistance;
	        },
	        set: function (dropShadowDistance) {
	            if (this._dropShadowDistance !== dropShadowDistance) {
	                this._dropShadowDistance = dropShadowDistance;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "fill", {
	        /**
	         * A canvas fillstyle that will be used on the text e.g 'red', '#00FF00'.
	         * Can be an array to create a gradient eg ['#000000','#FFFFFF']
	         * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
	         *
	         * @member {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
	         */
	        get: function () {
	            return this._fill;
	        },
	        set: function (fill) {
	            // TODO: Can't have different types for getter and setter. The getter shouldn't have the number type as
	            //       the setter converts to string. See this thread for more details:
	            //       https://github.com/microsoft/TypeScript/issues/2521
	            // TODO: Not sure if getColor works properly with CanvasGradient and/or CanvasPattern, can't pass in
	            //       without casting here.
	            var outputColor = getColor(fill);
	            if (this._fill !== outputColor) {
	                this._fill = outputColor;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "fillGradientType", {
	        /**
	         * If fill is an array of colours to create a gradient, this can change the type/direction of the gradient.
	         * See {@link PIXI.TEXT_GRADIENT}
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._fillGradientType;
	        },
	        set: function (fillGradientType) {
	            if (this._fillGradientType !== fillGradientType) {
	                this._fillGradientType = fillGradientType;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "fillGradientStops", {
	        /**
	         * If fill is an array of colours to create a gradient, this array can set the stop points
	         * (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
	         *
	         * @member {number[]}
	         */
	        get: function () {
	            return this._fillGradientStops;
	        },
	        set: function (fillGradientStops) {
	            if (!areArraysEqual(this._fillGradientStops, fillGradientStops)) {
	                this._fillGradientStops = fillGradientStops;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "fontFamily", {
	        /**
	         * The font family
	         *
	         * @member {string|string[]}
	         */
	        get: function () {
	            return this._fontFamily;
	        },
	        set: function (fontFamily) {
	            if (this.fontFamily !== fontFamily) {
	                this._fontFamily = fontFamily;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "fontSize", {
	        /**
	         * The font size
	         * (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em')
	         *
	         * @member {number|string}
	         */
	        get: function () {
	            return this._fontSize;
	        },
	        set: function (fontSize) {
	            if (this._fontSize !== fontSize) {
	                this._fontSize = fontSize;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "fontStyle", {
	        /**
	         * The font style
	         * ('normal', 'italic' or 'oblique')
	         *
	         * @member {string}
	         */
	        get: function () {
	            return this._fontStyle;
	        },
	        set: function (fontStyle) {
	            if (this._fontStyle !== fontStyle) {
	                this._fontStyle = fontStyle;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "fontVariant", {
	        /**
	         * The font variant
	         * ('normal' or 'small-caps')
	         *
	         * @member {string}
	         */
	        get: function () {
	            return this._fontVariant;
	        },
	        set: function (fontVariant) {
	            if (this._fontVariant !== fontVariant) {
	                this._fontVariant = fontVariant;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "fontWeight", {
	        /**
	         * The font weight
	         * ('normal', 'bold', 'bolder', 'lighter' and '100', '200', '300', '400', '500', '600', '700', 800' or '900')
	         *
	         * @member {string}
	         */
	        get: function () {
	            return this._fontWeight;
	        },
	        set: function (fontWeight) {
	            if (this._fontWeight !== fontWeight) {
	                this._fontWeight = fontWeight;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "letterSpacing", {
	        /**
	         * The amount of spacing between letters, default is 0
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._letterSpacing;
	        },
	        set: function (letterSpacing) {
	            if (this._letterSpacing !== letterSpacing) {
	                this._letterSpacing = letterSpacing;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "lineHeight", {
	        /**
	         * The line height, a number that represents the vertical space that a letter uses
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._lineHeight;
	        },
	        set: function (lineHeight) {
	            if (this._lineHeight !== lineHeight) {
	                this._lineHeight = lineHeight;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "leading", {
	        /**
	         * The space between lines
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._leading;
	        },
	        set: function (leading) {
	            if (this._leading !== leading) {
	                this._leading = leading;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "lineJoin", {
	        /**
	         * The lineJoin property sets the type of corner created, it can resolve spiked text issues.
	         * Default is 'miter' (creates a sharp corner).
	         *
	         * @member {string}
	         */
	        get: function () {
	            return this._lineJoin;
	        },
	        set: function (lineJoin) {
	            if (this._lineJoin !== lineJoin) {
	                this._lineJoin = lineJoin;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "miterLimit", {
	        /**
	         * The miter limit to use when using the 'miter' lineJoin mode
	         * This can reduce or increase the spikiness of rendered text.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._miterLimit;
	        },
	        set: function (miterLimit) {
	            if (this._miterLimit !== miterLimit) {
	                this._miterLimit = miterLimit;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "padding", {
	        /**
	         * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
	         * by adding padding to all sides of the text.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._padding;
	        },
	        set: function (padding) {
	            if (this._padding !== padding) {
	                this._padding = padding;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "stroke", {
	        /**
	         * A canvas fillstyle that will be used on the text stroke
	         * e.g 'blue', '#FCFF00'
	         *
	         * @member {string|number}
	         */
	        get: function () {
	            return this._stroke;
	        },
	        set: function (stroke) {
	            // TODO: Can't have different types for getter and setter. The getter shouldn't have the number type as
	            //       the setter converts to string. See this thread for more details:
	            //       https://github.com/microsoft/TypeScript/issues/2521
	            var outputColor = getColor(stroke);
	            if (this._stroke !== outputColor) {
	                this._stroke = outputColor;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "strokeThickness", {
	        /**
	         * A number that represents the thickness of the stroke.
	         * Default is 0 (no stroke)
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._strokeThickness;
	        },
	        set: function (strokeThickness) {
	            if (this._strokeThickness !== strokeThickness) {
	                this._strokeThickness = strokeThickness;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "textBaseline", {
	        /**
	         * The baseline of the text that is rendered.
	         *
	         * @member {string}
	         */
	        get: function () {
	            return this._textBaseline;
	        },
	        set: function (textBaseline) {
	            if (this._textBaseline !== textBaseline) {
	                this._textBaseline = textBaseline;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "trim", {
	        /**
	         * Trim transparent borders
	         *
	         * @member {boolean}
	         */
	        get: function () {
	            return this._trim;
	        },
	        set: function (trim) {
	            if (this._trim !== trim) {
	                this._trim = trim;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "whiteSpace", {
	        /**
	         * How newlines and spaces should be handled.
	         * Default is 'pre' (preserve, preserve).
	         *
	         *  value       | New lines     |   Spaces
	         *  ---         | ---           |   ---
	         * 'normal'     | Collapse      |   Collapse
	         * 'pre'        | Preserve      |   Preserve
	         * 'pre-line'   | Preserve      |   Collapse
	         *
	         * @member {string}
	         */
	        get: function () {
	            return this._whiteSpace;
	        },
	        set: function (whiteSpace) {
	            if (this._whiteSpace !== whiteSpace) {
	                this._whiteSpace = whiteSpace;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "wordWrap", {
	        /**
	         * Indicates if word wrap should be used
	         *
	         * @member {boolean}
	         */
	        get: function () {
	            return this._wordWrap;
	        },
	        set: function (wordWrap) {
	            if (this._wordWrap !== wordWrap) {
	                this._wordWrap = wordWrap;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TextStyle.prototype, "wordWrapWidth", {
	        /**
	         * The width at which text will wrap, it needs wordWrap to be set to true
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._wordWrapWidth;
	        },
	        set: function (wordWrapWidth) {
	            if (this._wordWrapWidth !== wordWrapWidth) {
	                this._wordWrapWidth = wordWrapWidth;
	                this.styleID++;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Generates a font style string to use for `TextMetrics.measureFont()`.
	     *
	     * @return {string} Font style string, for passing to `TextMetrics.measureFont()`
	     */
	    TextStyle.prototype.toFontString = function () {
	        // build canvas api font setting from individual components. Convert a numeric this.fontSize to px
	        var fontSizeString = (typeof this.fontSize === 'number') ? this.fontSize + "px" : this.fontSize;
	        // Clean-up fontFamily property by quoting each font name
	        // this will support font names with spaces
	        var fontFamilies = this.fontFamily;
	        if (!Array.isArray(this.fontFamily)) {
	            fontFamilies = this.fontFamily.split(',');
	        }
	        for (var i = fontFamilies.length - 1; i >= 0; i--) {
	            // Trim any extra white-space
	            var fontFamily = fontFamilies[i].trim();
	            // Check if font already contains strings
	            if (!(/([\"\'])[^\'\"]+\1/).test(fontFamily) && genericFontFamilies.indexOf(fontFamily) < 0) {
	                fontFamily = "\"" + fontFamily + "\"";
	            }
	            fontFamilies[i] = fontFamily;
	        }
	        return this.fontStyle + " " + this.fontVariant + " " + this.fontWeight + " " + fontSizeString + " " + fontFamilies.join(',');
	    };
	    return TextStyle;
	}());
	/**
	 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
	 * @private
	 * @param {string|number} color
	 * @return {string} The color as a string.
	 */
	function getSingleColor(color) {
	    if (typeof color === 'number') {
	        return hex2string(color);
	    }
	    else if (typeof color === 'string') {
	        if (color.indexOf('0x') === 0) {
	            color = color.replace('0x', '#');
	        }
	    }
	    return color;
	}
	function getColor(color) {
	    if (!Array.isArray(color)) {
	        return getSingleColor(color);
	    }
	    else {
	        for (var i = 0; i < color.length; ++i) {
	            color[i] = getSingleColor(color[i]);
	        }
	        return color;
	    }
	}
	/**
	 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
	 * This version can also convert array of colors
	 * @private
	 * @param {Array} array1 - First array to compare
	 * @param {Array} array2 - Second array to compare
	 * @return {boolean} Do the arrays contain the same values in the same order
	 */
	function areArraysEqual(array1, array2) {
	    if (!Array.isArray(array1) || !Array.isArray(array2)) {
	        return false;
	    }
	    if (array1.length !== array2.length) {
	        return false;
	    }
	    for (var i = 0; i < array1.length; ++i) {
	        if (array1[i] !== array2[i]) {
	            return false;
	        }
	    }
	    return true;
	}
	/**
	 * Utility function to ensure that object properties are copied by value, and not by reference
	 * @private
	 * @param {Object} target - Target object to copy properties into
	 * @param {Object} source - Source object for the properties to copy
	 * @param {string} propertyObj - Object containing properties names we want to loop over
	 */
	function deepCopyProperties(target, source, propertyObj) {
	    for (var prop in propertyObj) {
	        if (Array.isArray(source[prop])) {
	            target[prop] = source[prop].slice();
	        }
	        else {
	            target[prop] = source[prop];
	        }
	    }
	}

	/**
	 * The TextMetrics object represents the measurement of a block of text with a specified style.
	 *
	 * ```js
	 * let style = new PIXI.TextStyle({fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'})
	 * let textMetrics = PIXI.TextMetrics.measureText('Your text', style)
	 * ```
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TextMetrics = /** @class */ (function () {
	    /**
	     * @param {string} text - the text that was measured
	     * @param {PIXI.TextStyle} style - the style that was measured
	     * @param {number} width - the measured width of the text
	     * @param {number} height - the measured height of the text
	     * @param {string[]} lines - an array of the lines of text broken by new lines and wrapping if specified in style
	     * @param {number[]} lineWidths - an array of the line widths for each line matched to `lines`
	     * @param {number} lineHeight - the measured line height for this style
	     * @param {number} maxLineWidth - the maximum line width for all measured lines
	     * @param {Object} fontProperties - the font properties object from TextMetrics.measureFont
	     */
	    function TextMetrics(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties) {
	        /**
	         * The text that was measured
	         *
	         * @member {string}
	         */
	        this.text = text;
	        /**
	         * The style that was measured
	         *
	         * @member {PIXI.TextStyle}
	         */
	        this.style = style;
	        /**
	         * The measured width of the text
	         *
	         * @member {number}
	         */
	        this.width = width;
	        /**
	         * The measured height of the text
	         *
	         * @member {number}
	         */
	        this.height = height;
	        /**
	         * An array of lines of the text broken by new lines and wrapping is specified in style
	         *
	         * @member {string[]}
	         */
	        this.lines = lines;
	        /**
	         * An array of the line widths for each line matched to `lines`
	         *
	         * @member {number[]}
	         */
	        this.lineWidths = lineWidths;
	        /**
	         * The measured line height for this style
	         *
	         * @member {number}
	         */
	        this.lineHeight = lineHeight;
	        /**
	         * The maximum line width for all measured lines
	         *
	         * @member {number}
	         */
	        this.maxLineWidth = maxLineWidth;
	        /**
	         * The font properties object from TextMetrics.measureFont
	         *
	         * @member {PIXI.IFontMetrics}
	         */
	        this.fontProperties = fontProperties;
	    }
	    /**
	     * Measures the supplied string of text and returns a Rectangle.
	     *
	     * @param {string} text - the text to measure.
	     * @param {PIXI.TextStyle} style - the text style to use for measuring
	     * @param {boolean} [wordWrap] - optional override for if word-wrap should be applied to the text.
	     * @param {HTMLCanvasElement} [canvas] - optional specification of the canvas to use for measuring.
	     * @return {PIXI.TextMetrics} measured width and height of the text.
	     */
	    TextMetrics.measureText = function (text, style, wordWrap, canvas) {
	        if (canvas === void 0) { canvas = TextMetrics._canvas; }
	        wordWrap = (wordWrap === undefined || wordWrap === null) ? style.wordWrap : wordWrap;
	        var font = style.toFontString();
	        var fontProperties = TextMetrics.measureFont(font);
	        // fallback in case UA disallow canvas data extraction
	        // (toDataURI, getImageData functions)
	        if (fontProperties.fontSize === 0) {
	            fontProperties.fontSize = style.fontSize;
	            fontProperties.ascent = style.fontSize;
	        }
	        var context = canvas.getContext('2d');
	        context.font = font;
	        var outputText = wordWrap ? TextMetrics.wordWrap(text, style, canvas) : text;
	        var lines = outputText.split(/(?:\r\n|\r|\n)/);
	        var lineWidths = new Array(lines.length);
	        var maxLineWidth = 0;
	        for (var i = 0; i < lines.length; i++) {
	            var lineWidth = context.measureText(lines[i]).width + ((lines[i].length - 1) * style.letterSpacing);
	            lineWidths[i] = lineWidth;
	            maxLineWidth = Math.max(maxLineWidth, lineWidth);
	        }
	        var width = maxLineWidth + style.strokeThickness;
	        if (style.dropShadow) {
	            width += style.dropShadowDistance;
	        }
	        var lineHeight = style.lineHeight || fontProperties.fontSize + style.strokeThickness;
	        var height = Math.max(lineHeight, fontProperties.fontSize + style.strokeThickness)
	            + ((lines.length - 1) * (lineHeight + style.leading));
	        if (style.dropShadow) {
	            height += style.dropShadowDistance;
	        }
	        return new TextMetrics(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
	    };
	    /**
	     * Applies newlines to a string to have it optimally fit into the horizontal
	     * bounds set by the Text object's wordWrapWidth property.
	     *
	     * @private
	     * @param {string} text - String to apply word wrapping to
	     * @param {PIXI.TextStyle} style - the style to use when wrapping
	     * @param {HTMLCanvasElement} [canvas] - optional specification of the canvas to use for measuring.
	     * @return {string} New string with new lines applied where required
	     */
	    TextMetrics.wordWrap = function (text, style, canvas) {
	        if (canvas === void 0) { canvas = TextMetrics._canvas; }
	        var context = canvas.getContext('2d');
	        var width = 0;
	        var line = '';
	        var lines = '';
	        var cache = Object.create(null);
	        var letterSpacing = style.letterSpacing, whiteSpace = style.whiteSpace;
	        // How to handle whitespaces
	        var collapseSpaces = TextMetrics.collapseSpaces(whiteSpace);
	        var collapseNewlines = TextMetrics.collapseNewlines(whiteSpace);
	        // whether or not spaces may be added to the beginning of lines
	        var canPrependSpaces = !collapseSpaces;
	        // There is letterSpacing after every char except the last one
	        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!
	        // so for convenience the above needs to be compared to width + 1 extra letterSpace
	        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!_
	        // ________________________________________________
	        // And then the final space is simply no appended to each line
	        var wordWrapWidth = style.wordWrapWidth + letterSpacing;
	        // break text into words, spaces and newline chars
	        var tokens = TextMetrics.tokenize(text);
	        for (var i = 0; i < tokens.length; i++) {
	            // get the word, space or newlineChar
	            var token = tokens[i];
	            // if word is a new line
	            if (TextMetrics.isNewline(token)) {
	                // keep the new line
	                if (!collapseNewlines) {
	                    lines += TextMetrics.addLine(line);
	                    canPrependSpaces = !collapseSpaces;
	                    line = '';
	                    width = 0;
	                    continue;
	                }
	                // if we should collapse new lines
	                // we simply convert it into a space
	                token = ' ';
	            }
	            // if we should collapse repeated whitespaces
	            if (collapseSpaces) {
	                // check both this and the last tokens for spaces
	                var currIsBreakingSpace = TextMetrics.isBreakingSpace(token);
	                var lastIsBreakingSpace = TextMetrics.isBreakingSpace(line[line.length - 1]);
	                if (currIsBreakingSpace && lastIsBreakingSpace) {
	                    continue;
	                }
	            }
	            // get word width from cache if possible
	            var tokenWidth = TextMetrics.getFromCache(token, letterSpacing, cache, context);
	            // word is longer than desired bounds
	            if (tokenWidth > wordWrapWidth) {
	                // if we are not already at the beginning of a line
	                if (line !== '') {
	                    // start newlines for overflow words
	                    lines += TextMetrics.addLine(line);
	                    line = '';
	                    width = 0;
	                }
	                // break large word over multiple lines
	                if (TextMetrics.canBreakWords(token, style.breakWords)) {
	                    // break word into characters
	                    var characters = TextMetrics.wordWrapSplit(token);
	                    // loop the characters
	                    for (var j = 0; j < characters.length; j++) {
	                        var char = characters[j];
	                        var k = 1;
	                        // we are not at the end of the token
	                        while (characters[j + k]) {
	                            var nextChar = characters[j + k];
	                            var lastChar = char[char.length - 1];
	                            // should not split chars
	                            if (!TextMetrics.canBreakChars(lastChar, nextChar, token, j, style.breakWords)) {
	                                // combine chars & move forward one
	                                char += nextChar;
	                            }
	                            else {
	                                break;
	                            }
	                            k++;
	                        }
	                        j += char.length - 1;
	                        var characterWidth = TextMetrics.getFromCache(char, letterSpacing, cache, context);
	                        if (characterWidth + width > wordWrapWidth) {
	                            lines += TextMetrics.addLine(line);
	                            canPrependSpaces = false;
	                            line = '';
	                            width = 0;
	                        }
	                        line += char;
	                        width += characterWidth;
	                    }
	                }
	                // run word out of the bounds
	                else {
	                    // if there are words in this line already
	                    // finish that line and start a new one
	                    if (line.length > 0) {
	                        lines += TextMetrics.addLine(line);
	                        line = '';
	                        width = 0;
	                    }
	                    var isLastToken = i === tokens.length - 1;
	                    // give it its own line if it's not the end
	                    lines += TextMetrics.addLine(token, !isLastToken);
	                    canPrependSpaces = false;
	                    line = '';
	                    width = 0;
	                }
	            }
	            // word could fit
	            else {
	                // word won't fit because of existing words
	                // start a new line
	                if (tokenWidth + width > wordWrapWidth) {
	                    // if its a space we don't want it
	                    canPrependSpaces = false;
	                    // add a new line
	                    lines += TextMetrics.addLine(line);
	                    // start a new line
	                    line = '';
	                    width = 0;
	                }
	                // don't add spaces to the beginning of lines
	                if (line.length > 0 || !TextMetrics.isBreakingSpace(token) || canPrependSpaces) {
	                    // add the word to the current line
	                    line += token;
	                    // update width counter
	                    width += tokenWidth;
	                }
	            }
	        }
	        lines += TextMetrics.addLine(line, false);
	        return lines;
	    };
	    /**
	     * Convienience function for logging each line added during the wordWrap
	     * method
	     *
	     * @private
	     * @param  {string}   line        - The line of text to add
	     * @param  {boolean}  newLine     - Add new line character to end
	     * @return {string}  A formatted line
	     */
	    TextMetrics.addLine = function (line, newLine) {
	        if (newLine === void 0) { newLine = true; }
	        line = TextMetrics.trimRight(line);
	        line = (newLine) ? line + "\n" : line;
	        return line;
	    };
	    /**
	     * Gets & sets the widths of calculated characters in a cache object
	     *
	     * @private
	     * @param  {string}                    key            - The key
	     * @param  {number}                    letterSpacing  - The letter spacing
	     * @param  {object}                    cache          - The cache
	     * @param  {CanvasRenderingContext2D}  context        - The canvas context
	     * @return {number}                    The from cache.
	     */
	    TextMetrics.getFromCache = function (key, letterSpacing, cache, context) {
	        var width = cache[key];
	        if (typeof width !== 'number') {
	            var spacing = ((key.length) * letterSpacing);
	            width = context.measureText(key).width + spacing;
	            cache[key] = width;
	        }
	        return width;
	    };
	    /**
	     * Determines whether we should collapse breaking spaces
	     *
	     * @private
	     * @param  {string}   whiteSpace - The TextStyle property whiteSpace
	     * @return {boolean}  should collapse
	     */
	    TextMetrics.collapseSpaces = function (whiteSpace) {
	        return (whiteSpace === 'normal' || whiteSpace === 'pre-line');
	    };
	    /**
	     * Determines whether we should collapse newLine chars
	     *
	     * @private
	     * @param  {string}   whiteSpace - The white space
	     * @return {boolean}  should collapse
	     */
	    TextMetrics.collapseNewlines = function (whiteSpace) {
	        return (whiteSpace === 'normal');
	    };
	    /**
	     * trims breaking whitespaces from string
	     *
	     * @private
	     * @param  {string}  text - The text
	     * @return {string}  trimmed string
	     */
	    TextMetrics.trimRight = function (text) {
	        if (typeof text !== 'string') {
	            return '';
	        }
	        for (var i = text.length - 1; i >= 0; i--) {
	            var char = text[i];
	            if (!TextMetrics.isBreakingSpace(char)) {
	                break;
	            }
	            text = text.slice(0, -1);
	        }
	        return text;
	    };
	    /**
	     * Determines if char is a newline.
	     *
	     * @private
	     * @param  {string}  char - The character
	     * @return {boolean}  True if newline, False otherwise.
	     */
	    TextMetrics.isNewline = function (char) {
	        if (typeof char !== 'string') {
	            return false;
	        }
	        return (TextMetrics._newlines.indexOf(char.charCodeAt(0)) >= 0);
	    };
	    /**
	     * Determines if char is a breaking whitespace.
	     *
	     * @private
	     * @param  {string}  char - The character
	     * @return {boolean}  True if whitespace, False otherwise.
	     */
	    TextMetrics.isBreakingSpace = function (char) {
	        if (typeof char !== 'string') {
	            return false;
	        }
	        return (TextMetrics._breakingSpaces.indexOf(char.charCodeAt(0)) >= 0);
	    };
	    /**
	     * Splits a string into words, breaking-spaces and newLine characters
	     *
	     * @private
	     * @param  {string}  text - The text
	     * @return {string[]}  A tokenized array
	     */
	    TextMetrics.tokenize = function (text) {
	        var tokens = [];
	        var token = '';
	        if (typeof text !== 'string') {
	            return tokens;
	        }
	        for (var i = 0; i < text.length; i++) {
	            var char = text[i];
	            if (TextMetrics.isBreakingSpace(char) || TextMetrics.isNewline(char)) {
	                if (token !== '') {
	                    tokens.push(token);
	                    token = '';
	                }
	                tokens.push(char);
	                continue;
	            }
	            token += char;
	        }
	        if (token !== '') {
	            tokens.push(token);
	        }
	        return tokens;
	    };
	    /**
	     * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
	     *
	     * It allows one to customise which words should break
	     * Examples are if the token is CJK or numbers.
	     * It must return a boolean.
	     *
	     * @param  {string}  token       - The token
	     * @param  {boolean}  breakWords - The style attr break words
	     * @return {boolean} whether to break word or not
	     */
	    TextMetrics.canBreakWords = function (_token, breakWords) {
	        return breakWords;
	    };
	    /**
	     * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
	     *
	     * It allows one to determine whether a pair of characters
	     * should be broken by newlines
	     * For example certain characters in CJK langs or numbers.
	     * It must return a boolean.
	     *
	     * @param  {string}  char        - The character
	     * @param  {string}  nextChar    - The next character
	     * @param  {string}  token       - The token/word the characters are from
	     * @param  {number}  index       - The index in the token of the char
	     * @param  {boolean}  breakWords - The style attr break words
	     * @return {boolean} whether to break word or not
	     */
	    TextMetrics.canBreakChars = function (_char, _nextChar, _token, _index, _breakWords) {
	        return true;
	    };
	    /**
	     * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
	     *
	     * It is called when a token (usually a word) has to be split into separate pieces
	     * in order to determine the point to break a word.
	     * It must return an array of characters.
	     *
	     * @example
	     * // Correctly splits emojis, eg "ðŸ¤ªðŸ¤ª" will result in two element array, each with one emoji.
	     * TextMetrics.wordWrapSplit = (token) => [...token];
	     *
	     * @param  {string}  token - The token to split
	     * @return {string[]} The characters of the token
	     */
	    TextMetrics.wordWrapSplit = function (token) {
	        return token.split('');
	    };
	    /**
	     * Calculates the ascent, descent and fontSize of a given font-style
	     *
	     * @static
	     * @param {string} font - String representing the style of the font
	     * @return {PIXI.IFontMetrics} Font properties object
	     */
	    TextMetrics.measureFont = function (font) {
	        // as this method is used for preparing assets, don't recalculate things if we don't need to
	        if (TextMetrics._fonts[font]) {
	            return TextMetrics._fonts[font];
	        }
	        var properties = {
	            ascent: 0,
	            descent: 0,
	            fontSize: 0,
	        };
	        var canvas = TextMetrics._canvas;
	        var context = TextMetrics._context;
	        context.font = font;
	        var metricsString = TextMetrics.METRICS_STRING + TextMetrics.BASELINE_SYMBOL;
	        var width = Math.ceil(context.measureText(metricsString).width);
	        var baseline = Math.ceil(context.measureText(TextMetrics.BASELINE_SYMBOL).width);
	        var height = 2 * baseline;
	        baseline = baseline * TextMetrics.BASELINE_MULTIPLIER | 0;
	        canvas.width = width;
	        canvas.height = height;
	        context.fillStyle = '#f00';
	        context.fillRect(0, 0, width, height);
	        context.font = font;
	        context.textBaseline = 'alphabetic';
	        context.fillStyle = '#000';
	        context.fillText(metricsString, 0, baseline);
	        var imagedata = context.getImageData(0, 0, width, height).data;
	        var pixels = imagedata.length;
	        var line = width * 4;
	        var i = 0;
	        var idx = 0;
	        var stop = false;
	        // ascent. scan from top to bottom until we find a non red pixel
	        for (i = 0; i < baseline; ++i) {
	            for (var j = 0; j < line; j += 4) {
	                if (imagedata[idx + j] !== 255) {
	                    stop = true;
	                    break;
	                }
	            }
	            if (!stop) {
	                idx += line;
	            }
	            else {
	                break;
	            }
	        }
	        properties.ascent = baseline - i;
	        idx = pixels - line;
	        stop = false;
	        // descent. scan from bottom to top until we find a non red pixel
	        for (i = height; i > baseline; --i) {
	            for (var j = 0; j < line; j += 4) {
	                if (imagedata[idx + j] !== 255) {
	                    stop = true;
	                    break;
	                }
	            }
	            if (!stop) {
	                idx -= line;
	            }
	            else {
	                break;
	            }
	        }
	        properties.descent = i - baseline;
	        properties.fontSize = properties.ascent + properties.descent;
	        TextMetrics._fonts[font] = properties;
	        return properties;
	    };
	    /**
	     * Clear font metrics in metrics cache.
	     *
	     * @static
	     * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
	     */
	    TextMetrics.clearMetrics = function (font) {
	        if (font === void 0) { font = ''; }
	        if (font) {
	            delete TextMetrics._fonts[font];
	        }
	        else {
	            TextMetrics._fonts = {};
	        }
	    };
	    return TextMetrics;
	}());
	/**
	 * Internal return object for {@link PIXI.TextMetrics.measureFont `TextMetrics.measureFont`}.
	 *
	 * @typedef {object} FontMetrics
	 * @property {number} ascent - The ascent distance
	 * @property {number} descent - The descent distance
	 * @property {number} fontSize - Font size from ascent to descent
	 * @memberof PIXI.TextMetrics
	 * @private
	 */
	var canvas = (function () {
	    try {
	        // OffscreenCanvas2D measureText can be up to 40% faster.
	        var c = new OffscreenCanvas(0, 0);
	        var context = c.getContext('2d');
	        if (context && context.measureText) {
	            return c;
	        }
	        return document.createElement('canvas');
	    }
	    catch (ex) {
	        return document.createElement('canvas');
	    }
	})();
	canvas.width = canvas.height = 10;
	/**
	 * Cached canvas element for measuring text
	 *
	 * @memberof PIXI.TextMetrics
	 * @type {HTMLCanvasElement}
	 * @private
	 */
	TextMetrics._canvas = canvas;
	/**
	 * Cache for context to use.
	 *
	 * @memberof PIXI.TextMetrics
	 * @type {CanvasRenderingContext2D}
	 * @private
	 */
	TextMetrics._context = canvas.getContext('2d');
	/**
	 * Cache of {@see PIXI.TextMetrics.FontMetrics} objects.
	 *
	 * @memberof PIXI.TextMetrics
	 * @type {Object}
	 * @private
	 */
	TextMetrics._fonts = {};
	/**
	 * String used for calculate font metrics.
	 * These characters are all tall to help calculate the height required for text.
	 *
	 * @static
	 * @memberof PIXI.TextMetrics
	 * @name METRICS_STRING
	 * @type {string}
	 * @default |Ã‰qÃ…
	 */
	TextMetrics.METRICS_STRING = '|Ã‰qÃ…';
	/**
	 * Baseline symbol for calculate font metrics.
	 *
	 * @static
	 * @memberof PIXI.TextMetrics
	 * @name BASELINE_SYMBOL
	 * @type {string}
	 * @default M
	 */
	TextMetrics.BASELINE_SYMBOL = 'M';
	/**
	 * Baseline multiplier for calculate font metrics.
	 *
	 * @static
	 * @memberof PIXI.TextMetrics
	 * @name BASELINE_MULTIPLIER
	 * @type {number}
	 * @default 1.4
	 */
	TextMetrics.BASELINE_MULTIPLIER = 1.4;
	/**
	 * Cache of new line chars.
	 *
	 * @memberof PIXI.TextMetrics
	 * @type {number[]}
	 * @private
	 */
	TextMetrics._newlines = [
	    0x000A,
	    0x000D ];
	/**
	 * Cache of breaking spaces.
	 *
	 * @memberof PIXI.TextMetrics
	 * @type {number[]}
	 * @private
	 */
	TextMetrics._breakingSpaces = [
	    0x0009,
	    0x0020,
	    0x2000,
	    0x2001,
	    0x2002,
	    0x2003,
	    0x2004,
	    0x2005,
	    0x2006,
	    0x2008,
	    0x2009,
	    0x200A,
	    0x205F,
	    0x3000 ];
	/**
	 * A number, or a string containing a number.
	 *
	 * @memberof PIXI
	 * @typedef IFontMetrics
	 * @property {number} ascent - Font ascent
	 * @property {number} descent - Font descent
	 * @property {number} fontSize - Font size
	 */

	var defaultDestroyOptions = {
	    texture: true,
	    children: false,
	    baseTexture: true,
	};
	/**
	 * A Text Object will create a line or multiple lines of text.
	 *
	 * The text is created using the [Canvas API](https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API).
	 *
	 * The primary advantage of this class over BitmapText is that you have great control over the style of the next,
	 * which you can change at runtime.
	 *
	 * The primary disadvantages is that each piece of text has it's own texture, which can use more memory.
	 * When text changes, this texture has to be re-generated and re-uploaded to the GPU, taking up time.
	 *
	 * To split a line you can use '\n' in your text string, or, on the `style` object,
	 * change its `wordWrap` property to true and and give the `wordWrapWidth` property a value.
	 *
	 * A Text can be created directly from a string and a style object,
	 * which can be generated [here](https://pixijs.io/pixi-text-style).
	 *
	 * ```js
	 * let text = new PIXI.Text('This is a PixiJS text',{fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'});
	 * ```
	 *
	 * @class
	 * @extends PIXI.Sprite
	 * @memberof PIXI
	 */
	var Text = /** @class */ (function (_super) {
	    __extends$7(Text, _super);
	    /**
	     * @param {string} text - The string that you would like the text to display
	     * @param {object|PIXI.TextStyle} [style] - The style parameters
	     * @param {HTMLCanvasElement} [canvas] - The canvas element for drawing text
	     */
	    function Text(text, style, canvas) {
	        var _this = this;
	        var ownCanvas = false;
	        if (!canvas) {
	            canvas = document.createElement('canvas');
	            ownCanvas = true;
	        }
	        canvas.width = 3;
	        canvas.height = 3;
	        var texture = Texture.from(canvas);
	        texture.orig = new Rectangle();
	        texture.trim = new Rectangle();
	        _this = _super.call(this, texture) || this;
	        /**
	         * Keep track if this Text object created it's own canvas
	         * element (`true`) or uses the constructor argument (`false`).
	         * Used to workaround a GC issues with Safari < 13 when
	         * destroying Text. See `destroy` for more info.
	         *
	         * @member {boolean}
	         * @private
	         */
	        _this._ownCanvas = ownCanvas;
	        /**
	         * The canvas element that everything is drawn to
	         *
	         * @member {HTMLCanvasElement}
	         */
	        _this.canvas = canvas;
	        /**
	         * The canvas 2d context that everything is drawn with
	         * @member {CanvasRenderingContext2D}
	         */
	        _this.context = _this.canvas.getContext('2d');
	        /**
	         * The resolution / device pixel ratio of the canvas.
	         * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
	         * @member {number}
	         * @default 1
	         */
	        _this._resolution = settings.RESOLUTION;
	        _this._autoResolution = true;
	        /**
	         * Private tracker for the current text.
	         *
	         * @member {string}
	         * @private
	         */
	        _this._text = null;
	        /**
	         * Private tracker for the current style.
	         *
	         * @member {object}
	         * @private
	         */
	        _this._style = null;
	        /**
	         * Private listener to track style changes.
	         *
	         * @member {Function}
	         * @private
	         */
	        _this._styleListener = null;
	        /**
	         * Private tracker for the current font.
	         *
	         * @member {string}
	         * @private
	         */
	        _this._font = '';
	        _this.text = text;
	        _this.style = style;
	        _this.localStyleID = -1;
	        return _this;
	    }
	    /**
	     * Renders text to its canvas, and updates its texture.
	     * By default this is used internally to ensure the texture is correct before rendering,
	     * but it can be used called externally, for example from this class to 'pre-generate' the texture from a piece of text,
	     * and then shared across multiple Sprites.
	     *
	     * @param {boolean} respectDirty - Whether to abort updating the text if the Text isn't dirty and the function is called.
	     */
	    Text.prototype.updateText = function (respectDirty) {
	        var style = this._style;
	        // check if style has changed..
	        if (this.localStyleID !== style.styleID) {
	            this.dirty = true;
	            this.localStyleID = style.styleID;
	        }
	        if (!this.dirty && respectDirty) {
	            return;
	        }
	        this._font = this._style.toFontString();
	        var context = this.context;
	        var measured = TextMetrics.measureText(this._text || ' ', this._style, this._style.wordWrap, this.canvas);
	        var width = measured.width;
	        var height = measured.height;
	        var lines = measured.lines;
	        var lineHeight = measured.lineHeight;
	        var lineWidths = measured.lineWidths;
	        var maxLineWidth = measured.maxLineWidth;
	        var fontProperties = measured.fontProperties;
	        this.canvas.width = Math.ceil((Math.max(1, width) + (style.padding * 2)) * this._resolution);
	        this.canvas.height = Math.ceil((Math.max(1, height) + (style.padding * 2)) * this._resolution);
	        context.scale(this._resolution, this._resolution);
	        context.clearRect(0, 0, this.canvas.width, this.canvas.height);
	        context.font = this._font;
	        context.lineWidth = style.strokeThickness;
	        context.textBaseline = style.textBaseline;
	        context.lineJoin = style.lineJoin;
	        context.miterLimit = style.miterLimit;
	        var linePositionX;
	        var linePositionY;
	        // require 2 passes if a shadow; the first to draw the drop shadow, the second to draw the text
	        var passesCount = style.dropShadow ? 2 : 1;
	        // For v4, we drew text at the colours of the drop shadow underneath the normal text. This gave the correct zIndex,
	        // but features such as alpha and shadowblur did not look right at all, since we were using actual text as a shadow.
	        //
	        // For v5.0.0, we moved over to just use the canvas API for drop shadows, which made them look much nicer and more
	        // visually please, but now because the stroke is drawn and then the fill, drop shadows would appear on both the fill
	        // and the stroke; and fill drop shadows would appear over the top of the stroke.
	        //
	        // For v5.1.1, the new route is to revert to v4 style of drawing text first to get the drop shadows underneath normal
	        // text, but instead drawing text in the correct location, we'll draw it off screen (-paddingY), and then adjust the
	        // drop shadow so only that appears on screen (+paddingY). Now we'll have the correct draw order of the shadow
	        // beneath the text, whilst also having the proper text shadow styling.
	        for (var i = 0; i < passesCount; ++i) {
	            var isShadowPass = style.dropShadow && i === 0;
	            // we only want the drop shadow, so put text way off-screen
	            var dsOffsetText = isShadowPass ? Math.ceil(Math.max(1, height) + (style.padding * 2)) : 0;
	            var dsOffsetShadow = dsOffsetText * this._resolution;
	            if (isShadowPass) {
	                // On Safari, text with gradient and drop shadows together do not position correctly
	                // if the scale of the canvas is not 1: https://bugs.webkit.org/show_bug.cgi?id=197689
	                // Therefore we'll set the styles to be a plain black whilst generating this drop shadow
	                context.fillStyle = 'black';
	                context.strokeStyle = 'black';
	                var dropShadowColor = style.dropShadowColor;
	                var rgb = hex2rgb(typeof dropShadowColor === 'number' ? dropShadowColor : string2hex(dropShadowColor));
	                context.shadowColor = "rgba(" + rgb[0] * 255 + "," + rgb[1] * 255 + "," + rgb[2] * 255 + "," + style.dropShadowAlpha + ")";
	                context.shadowBlur = style.dropShadowBlur;
	                context.shadowOffsetX = Math.cos(style.dropShadowAngle) * style.dropShadowDistance;
	                context.shadowOffsetY = (Math.sin(style.dropShadowAngle) * style.dropShadowDistance) + dsOffsetShadow;
	            }
	            else {
	                // set canvas text styles
	                context.fillStyle = this._generateFillStyle(style, lines, measured);
	                // TODO: Can't have different types for getter and setter. The getter shouldn't have the number type as
	                //       the setter converts to string. See this thread for more details:
	                //       https://github.com/microsoft/TypeScript/issues/2521
	                context.strokeStyle = style.stroke;
	                context.shadowColor = 'black';
	                context.shadowBlur = 0;
	                context.shadowOffsetX = 0;
	                context.shadowOffsetY = 0;
	            }
	            // draw lines line by line
	            for (var i_1 = 0; i_1 < lines.length; i_1++) {
	                linePositionX = style.strokeThickness / 2;
	                linePositionY = ((style.strokeThickness / 2) + (i_1 * lineHeight)) + fontProperties.ascent;
	                if (style.align === 'right') {
	                    linePositionX += maxLineWidth - lineWidths[i_1];
	                }
	                else if (style.align === 'center') {
	                    linePositionX += (maxLineWidth - lineWidths[i_1]) / 2;
	                }
	                if (style.stroke && style.strokeThickness) {
	                    this.drawLetterSpacing(lines[i_1], linePositionX + style.padding, linePositionY + style.padding - dsOffsetText, true);
	                }
	                if (style.fill) {
	                    this.drawLetterSpacing(lines[i_1], linePositionX + style.padding, linePositionY + style.padding - dsOffsetText);
	                }
	            }
	        }
	        this.updateTexture();
	    };
	    /**
	     * Render the text with letter-spacing.
	     * @param {string} text - The text to draw
	     * @param {number} x - Horizontal position to draw the text
	     * @param {number} y - Vertical position to draw the text
	     * @param {boolean} [isStroke=false] - Is this drawing for the outside stroke of the
	     *  text? If not, it's for the inside fill
	     * @private
	     */
	    Text.prototype.drawLetterSpacing = function (text, x, y, isStroke) {
	        if (isStroke === void 0) { isStroke = false; }
	        var style = this._style;
	        // letterSpacing of 0 means normal
	        var letterSpacing = style.letterSpacing;
	        if (letterSpacing === 0) {
	            if (isStroke) {
	                this.context.strokeText(text, x, y);
	            }
	            else {
	                this.context.fillText(text, x, y);
	            }
	            return;
	        }
	        var currentPosition = x;
	        // Using Array.from correctly splits characters whilst keeping emoji together.
	        // This is not supported on IE as it requires ES6, so regular text splitting occurs.
	        // This also doesn't account for emoji that are multiple emoji put together to make something else.
	        // Handling all of this would require a big library itself.
	        // https://medium.com/@giltayar/iterating-over-emoji-characters-the-es6-way-f06e4589516
	        // https://github.com/orling/grapheme-splitter
	        var stringArray = Array.from ? Array.from(text) : text.split('');
	        var previousWidth = this.context.measureText(text).width;
	        var currentWidth = 0;
	        for (var i = 0; i < stringArray.length; ++i) {
	            var currentChar = stringArray[i];
	            if (isStroke) {
	                this.context.strokeText(currentChar, currentPosition, y);
	            }
	            else {
	                this.context.fillText(currentChar, currentPosition, y);
	            }
	            currentWidth = this.context.measureText(text.substring(i + 1)).width;
	            currentPosition += previousWidth - currentWidth + letterSpacing;
	            previousWidth = currentWidth;
	        }
	    };
	    /**
	     * Updates texture size based on canvas size
	     *
	     * @private
	     */
	    Text.prototype.updateTexture = function () {
	        var canvas = this.canvas;
	        if (this._style.trim) {
	            var trimmed = trimCanvas(canvas);
	            if (trimmed.data) {
	                canvas.width = trimmed.width;
	                canvas.height = trimmed.height;
	                this.context.putImageData(trimmed.data, 0, 0);
	            }
	        }
	        var texture = this._texture;
	        var style = this._style;
	        var padding = style.trim ? 0 : style.padding;
	        var baseTexture = texture.baseTexture;
	        texture.trim.width = texture._frame.width = Math.ceil(canvas.width / this._resolution);
	        texture.trim.height = texture._frame.height = Math.ceil(canvas.height / this._resolution);
	        texture.trim.x = -padding;
	        texture.trim.y = -padding;
	        texture.orig.width = texture._frame.width - (padding * 2);
	        texture.orig.height = texture._frame.height - (padding * 2);
	        // call sprite onTextureUpdate to update scale if _width or _height were set
	        this._onTextureUpdate();
	        baseTexture.setRealSize(canvas.width, canvas.height, this._resolution);
	        // Recursively updates transform of all objects from the root to this one
	        this._recursivePostUpdateTransform();
	        this.dirty = false;
	    };
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @protected
	     * @param {PIXI.Renderer} renderer - The renderer
	     */
	    Text.prototype._render = function (renderer) {
	        if (this._autoResolution && this._resolution !== renderer.resolution) {
	            this._resolution = renderer.resolution;
	            this.dirty = true;
	        }
	        this.updateText(true);
	        _super.prototype._render.call(this, renderer);
	    };
	    /**
	     * Gets the local bounds of the text object.
	     *
	     * @param {PIXI.Rectangle} rect - The output rectangle.
	     * @return {PIXI.Rectangle} The bounds.
	     */
	    Text.prototype.getLocalBounds = function (rect) {
	        this.updateText(true);
	        return _super.prototype.getLocalBounds.call(this, rect);
	    };
	    /**
	     * calculates the bounds of the Text as a rectangle. The bounds calculation takes the worldTransform into account.
	     * @protected
	     */
	    Text.prototype._calculateBounds = function () {
	        this.updateText(true);
	        this.calculateVertices();
	        // if we have already done this on THIS frame.
	        this._bounds.addQuad(this.vertexData);
	    };
	    /**
	     * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
	     *
	     * @private
	     * @param {object} style - The style.
	     * @param {string[]} lines - The lines of text.
	     * @return {string|number|CanvasGradient} The fill style
	     */
	    Text.prototype._generateFillStyle = function (style, lines, metrics) {
	        // TODO: Can't have different types for getter and setter. The getter shouldn't have the number type as
	        //       the setter converts to string. See this thread for more details:
	        //       https://github.com/microsoft/TypeScript/issues/2521
	        var fillStyle = style.fill;
	        if (!Array.isArray(fillStyle)) {
	            return fillStyle;
	        }
	        else if (fillStyle.length === 1) {
	            return fillStyle[0];
	        }
	        // the gradient will be evenly spaced out according to how large the array is.
	        // ['#FF0000', '#00FF00', '#0000FF'] would created stops at 0.25, 0.5 and 0.75
	        var gradient;
	        // a dropshadow will enlarge the canvas and result in the gradient being
	        // generated with the incorrect dimensions
	        var dropShadowCorrection = (style.dropShadow) ? style.dropShadowDistance : 0;
	        // should also take padding into account, padding can offset the gradient
	        var padding = style.padding || 0;
	        var width = Math.ceil(this.canvas.width / this._resolution) - dropShadowCorrection - (padding * 2);
	        var height = Math.ceil(this.canvas.height / this._resolution) - dropShadowCorrection - (padding * 2);
	        // make a copy of the style settings, so we can manipulate them later
	        var fill = fillStyle.slice();
	        var fillGradientStops = style.fillGradientStops.slice();
	        // wanting to evenly distribute the fills. So an array of 4 colours should give fills of 0.25, 0.5 and 0.75
	        if (!fillGradientStops.length) {
	            var lengthPlus1 = fill.length + 1;
	            for (var i = 1; i < lengthPlus1; ++i) {
	                fillGradientStops.push(i / lengthPlus1);
	            }
	        }
	        // stop the bleeding of the last gradient on the line above to the top gradient of the this line
	        // by hard defining the first gradient colour at point 0, and last gradient colour at point 1
	        fill.unshift(fillStyle[0]);
	        fillGradientStops.unshift(0);
	        fill.push(fillStyle[fillStyle.length - 1]);
	        fillGradientStops.push(1);
	        if (style.fillGradientType === exports.TEXT_GRADIENT.LINEAR_VERTICAL) {
	            // start the gradient at the top center of the canvas, and end at the bottom middle of the canvas
	            gradient = this.context.createLinearGradient(width / 2, padding, width / 2, height + padding);
	            // we need to repeat the gradient so that each individual line of text has the same vertical gradient effect
	            // ['#FF0000', '#00FF00', '#0000FF'] over 2 lines would create stops at 0.125, 0.25, 0.375, 0.625, 0.75, 0.875
	            // There's potential for floating point precision issues at the seams between gradient repeats.
	            // The loop below generates the stops in order, so track the last generated one to prevent
	            // floating point precision from making us go the teeniest bit backwards, resulting in
	            // the first and last colors getting swapped.
	            var lastIterationStop = 0;
	            // Actual height of the text itself, not counting spacing for lineHeight/leading/dropShadow etc
	            var textHeight = metrics.fontProperties.fontSize + style.strokeThickness;
	            // textHeight, but as a 0-1 size in global gradient stop space
	            var gradStopLineHeight = textHeight / height;
	            for (var i = 0; i < lines.length; i++) {
	                var thisLineTop = metrics.lineHeight * i;
	                for (var j = 0; j < fill.length; j++) {
	                    // 0-1 stop point for the current line, multiplied to global space afterwards
	                    var lineStop = 0;
	                    if (typeof fillGradientStops[j] === 'number') {
	                        lineStop = fillGradientStops[j];
	                    }
	                    else {
	                        lineStop = j / fill.length;
	                    }
	                    var globalStop = (thisLineTop / height) + (lineStop * gradStopLineHeight);
	                    // Prevent color stop generation going backwards from floating point imprecision
	                    var clampedStop = Math.max(lastIterationStop, globalStop);
	                    clampedStop = Math.min(clampedStop, 1); // Cap at 1 as well for safety's sake to avoid a possible throw.
	                    gradient.addColorStop(clampedStop, fill[j]);
	                    lastIterationStop = clampedStop;
	                }
	            }
	        }
	        else {
	            // start the gradient at the center left of the canvas, and end at the center right of the canvas
	            gradient = this.context.createLinearGradient(padding, height / 2, width + padding, height / 2);
	            // can just evenly space out the gradients in this case, as multiple lines makes no difference
	            // to an even left to right gradient
	            var totalIterations = fill.length + 1;
	            var currentIteration = 1;
	            for (var i = 0; i < fill.length; i++) {
	                var stop = void 0;
	                if (typeof fillGradientStops[i] === 'number') {
	                    stop = fillGradientStops[i];
	                }
	                else {
	                    stop = currentIteration / totalIterations;
	                }
	                gradient.addColorStop(stop, fill[i]);
	                currentIteration++;
	            }
	        }
	        return gradient;
	    };
	    /**
	     * Destroys this text object.
	     * Note* Unlike a Sprite, a Text object will automatically destroy its baseTexture and texture as
	     * the majority of the time the texture will not be shared with any other Sprites.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their
	     *  destroy method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=true] - Should it destroy the current texture of the sprite as well
	     * @param {boolean} [options.baseTexture=true] - Should it destroy the base texture of the sprite as well
	     */
	    Text.prototype.destroy = function (options) {
	        if (typeof options === 'boolean') {
	            options = { children: options };
	        }
	        options = Object.assign({}, defaultDestroyOptions, options);
	        _super.prototype.destroy.call(this, options);
	        // set canvas width and height to 0 to workaround memory leak in Safari < 13
	        // https://stackoverflow.com/questions/52532614/total-canvas-memory-use-exceeds-the-maximum-limit-safari-12
	        if (this._ownCanvas) {
	            this.canvas.height = this.canvas.width = 0;
	        }
	        // make sure to reset the the context and canvas.. dont want this hanging around in memory!
	        this.context = null;
	        this.canvas = null;
	        this._style = null;
	    };
	    Object.defineProperty(Text.prototype, "width", {
	        /**
	         * The width of the Text, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	        get: function () {
	            this.updateText(true);
	            return Math.abs(this.scale.x) * this._texture.orig.width;
	        },
	        set: function (value) {
	            this.updateText(true);
	            var s = sign$1(this.scale.x) || 1;
	            this.scale.x = s * value / this._texture.orig.width;
	            this._width = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Text.prototype, "height", {
	        /**
	         * The height of the Text, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	        get: function () {
	            this.updateText(true);
	            return Math.abs(this.scale.y) * this._texture.orig.height;
	        },
	        set: function (value) {
	            this.updateText(true);
	            var s = sign$1(this.scale.y) || 1;
	            this.scale.y = s * value / this._texture.orig.height;
	            this._height = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Text.prototype, "style", {
	        /**
	         * Set the style of the text. Set up an event listener to listen for changes on the style
	         * object and mark the text as dirty.
	         *
	         * @member {object|PIXI.TextStyle}
	         */
	        get: function () {
	            // TODO: Can't have different types for getter and setter. The getter shouldn't have the ITextStyle
	            //       since the setter creates the TextStyle. See this thread for more details:
	            //       https://github.com/microsoft/TypeScript/issues/2521
	            return this._style;
	        },
	        set: function (style) {
	            style = style || {};
	            if (style instanceof TextStyle) {
	                this._style = style;
	            }
	            else {
	                this._style = new TextStyle(style);
	            }
	            this.localStyleID = -1;
	            this.dirty = true;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Text.prototype, "text", {
	        /**
	         * Set the copy for the text object. To split a line you can use '\n'.
	         *
	         * @member {string}
	         */
	        get: function () {
	            return this._text;
	        },
	        set: function (text) {
	            text = String(text === null || text === undefined ? '' : text);
	            if (this._text === text) {
	                return;
	            }
	            this._text = text;
	            this.dirty = true;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Text.prototype, "resolution", {
	        /**
	         * The resolution / device pixel ratio of the canvas.
	         * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
	         * @member {number}
	         * @default 1
	         */
	        get: function () {
	            return this._resolution;
	        },
	        set: function (value) {
	            this._autoResolution = false;
	            if (this._resolution === value) {
	                return;
	            }
	            this._resolution = value;
	            this.dirty = true;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Text;
	}(Sprite));

	/*!
	 * @pixi/prepare - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/prepare is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * Default number of uploads per frame using prepare plugin.
	 *
	 * @static
	 * @memberof PIXI.settings
	 * @name UPLOADS_PER_FRAME
	 * @type {number}
	 * @default 4
	 */
	settings.UPLOADS_PER_FRAME = 4;

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$8 = function(d, b) {
	    extendStatics$8 = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$8(d, b);
	};

	function __extends$8(d, b) {
	    extendStatics$8(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	/**
	 * CountLimiter limits the number of items handled by a {@link PIXI.BasePrepare} to a specified
	 * number of items per frame.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var CountLimiter = /** @class */ (function () {
	    /**
	     * @param {number} maxItemsPerFrame - The maximum number of items that can be prepared each frame.
	     */
	    function CountLimiter(maxItemsPerFrame) {
	        /**
	         * The maximum number of items that can be prepared each frame.
	         * @type {number}
	         * @private
	         */
	        this.maxItemsPerFrame = maxItemsPerFrame;
	        /**
	         * The number of items that can be prepared in the current frame.
	         * @type {number}
	         * @private
	         */
	        this.itemsLeft = 0;
	    }
	    /**
	     * Resets any counting properties to start fresh on a new frame.
	     */
	    CountLimiter.prototype.beginFrame = function () {
	        this.itemsLeft = this.maxItemsPerFrame;
	    };
	    /**
	     * Checks to see if another item can be uploaded. This should only be called once per item.
	     * @return {boolean} If the item is allowed to be uploaded.
	     */
	    CountLimiter.prototype.allowedToUpload = function () {
	        return this.itemsLeft-- > 0;
	    };
	    return CountLimiter;
	}());

	/**
	 * Built-in hook to find multiple textures from objects like AnimatedSprites.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Texture object was found.
	 */
	function findMultipleBaseTextures(item, queue) {
	    var result = false;
	    // Objects with multiple textures
	    if (item && item._textures && item._textures.length) {
	        for (var i = 0; i < item._textures.length; i++) {
	            if (item._textures[i] instanceof Texture) {
	                var baseTexture = item._textures[i].baseTexture;
	                if (queue.indexOf(baseTexture) === -1) {
	                    queue.push(baseTexture);
	                    result = true;
	                }
	            }
	        }
	    }
	    return result;
	}
	/**
	 * Built-in hook to find BaseTextures from Texture.
	 *
	 * @private
	 * @param {PIXI.Texture} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Texture object was found.
	 */
	function findBaseTexture(item, queue) {
	    if (item.baseTexture instanceof BaseTexture) {
	        var texture = item.baseTexture;
	        if (queue.indexOf(texture) === -1) {
	            queue.push(texture);
	        }
	        return true;
	    }
	    return false;
	}
	/**
	 * Built-in hook to find textures from objects.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Texture object was found.
	 */
	function findTexture(item, queue) {
	    if (item._texture && item._texture instanceof Texture) {
	        var texture = item._texture.baseTexture;
	        if (queue.indexOf(texture) === -1) {
	            queue.push(texture);
	        }
	        return true;
	    }
	    return false;
	}
	/**
	 * Built-in hook to draw PIXI.Text to its texture.
	 *
	 * @private
	 * @param {PIXI.AbstractRenderer|PIXI.BasePrepare} helper - Not used by this upload handler
	 * @param {PIXI.DisplayObject} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	function drawText(_helper, item) {
	    if (item instanceof Text) {
	        // updating text will return early if it is not dirty
	        item.updateText(true);
	        return true;
	    }
	    return false;
	}
	/**
	 * Built-in hook to calculate a text style for a PIXI.Text object.
	 *
	 * @private
	 * @param {PIXI.AbstractRenderer|PIXI.BasePrepare} helper - Not used by this upload handler
	 * @param {PIXI.DisplayObject} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	function calculateTextStyle(_helper, item) {
	    if (item instanceof TextStyle) {
	        var font = item.toFontString();
	        TextMetrics.measureFont(font);
	        return true;
	    }
	    return false;
	}
	/**
	 * Built-in hook to find Text objects.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Text object was found.
	 */
	function findText(item, queue) {
	    if (item instanceof Text) {
	        // push the text style to prepare it - this can be really expensive
	        if (queue.indexOf(item.style) === -1) {
	            queue.push(item.style);
	        }
	        // also push the text object so that we can render it (to canvas/texture) if needed
	        if (queue.indexOf(item) === -1) {
	            queue.push(item);
	        }
	        // also push the Text's texture for upload to GPU
	        var texture = item._texture.baseTexture;
	        if (queue.indexOf(texture) === -1) {
	            queue.push(texture);
	        }
	        return true;
	    }
	    return false;
	}
	/**
	 * Built-in hook to find TextStyle objects.
	 *
	 * @private
	 * @param {PIXI.TextStyle} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.TextStyle object was found.
	 */
	function findTextStyle(item, queue) {
	    if (item instanceof TextStyle) {
	        if (queue.indexOf(item) === -1) {
	            queue.push(item);
	        }
	        return true;
	    }
	    return false;
	}
	/**
	 * The prepare manager provides functionality to upload content to the GPU.
	 *
	 * BasePrepare handles basic queuing functionality and is extended by
	 * {@link PIXI.Prepare} and {@link PIXI.CanvasPrepare}
	 * to provide preparation capabilities specific to their respective renderers.
	 *
	 * @example
	 * // Create a sprite
	 * const sprite = PIXI.Sprite.from('something.png');
	 *
	 * // Load object into GPU
	 * app.renderer.plugins.prepare.upload(sprite, () => {
	 *
	 *     //Texture(s) has been uploaded to GPU
	 *     app.stage.addChild(sprite);
	 *
	 * })
	 *
	 * @abstract
	 * @class
	 * @memberof PIXI
	 */
	var BasePrepare = /** @class */ (function () {
	    /**
	     * @param {PIXI.AbstractRenderer} renderer - A reference to the current renderer
	     */
	    function BasePrepare(renderer) {
	        var _this = this;
	        /**
	         * The limiter to be used to control how quickly items are prepared.
	         * @type {PIXI.CountLimiter|PIXI.TimeLimiter}
	         */
	        this.limiter = new CountLimiter(settings.UPLOADS_PER_FRAME);
	        /**
	         * Reference to the renderer.
	         * @type {PIXI.AbstractRenderer}
	         * @protected
	         */
	        this.renderer = renderer;
	        /**
	         * The only real difference between CanvasPrepare and Prepare is what they pass
	         * to upload hooks. That different parameter is stored here.
	         * @type {object}
	         * @protected
	         */
	        this.uploadHookHelper = null;
	        /**
	         * Collection of items to uploads at once.
	         * @type {Array<*>}
	         * @private
	         */
	        this.queue = [];
	        /**
	         * Collection of additional hooks for finding assets.
	         * @type {Array<Function>}
	         * @private
	         */
	        this.addHooks = [];
	        /**
	         * Collection of additional hooks for processing assets.
	         * @type {Array<Function>}
	         * @private
	         */
	        this.uploadHooks = [];
	        /**
	         * Callback to call after completed.
	         * @type {Array<Function>}
	         * @private
	         */
	        this.completes = [];
	        /**
	         * If prepare is ticking (running).
	         * @type {boolean}
	         * @private
	         */
	        this.ticking = false;
	        /**
	         * 'bound' call for prepareItems().
	         * @type {Function}
	         * @private
	         */
	        this.delayedTick = function () {
	            // unlikely, but in case we were destroyed between tick() and delayedTick()
	            if (!_this.queue) {
	                return;
	            }
	            _this.prepareItems();
	        };
	        // hooks to find the correct texture
	        this.registerFindHook(findText);
	        this.registerFindHook(findTextStyle);
	        this.registerFindHook(findMultipleBaseTextures);
	        this.registerFindHook(findBaseTexture);
	        this.registerFindHook(findTexture);
	        // upload hooks
	        this.registerUploadHook(drawText);
	        this.registerUploadHook(calculateTextStyle);
	    }
	    /**
	     * Upload all the textures and graphics to the GPU.
	     *
	     * @param {Function|PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text} item -
	     *        Either the container or display object to search for items to upload, the items to upload themselves,
	     *        or the callback function, if items have been added using `prepare.add`.
	     * @param {Function} [done] - Optional callback when all queued uploads have completed
	     */
	    BasePrepare.prototype.upload = function (item, done) {
	        if (typeof item === 'function') {
	            done = item;
	            item = null;
	        }
	        // If a display object, search for items
	        // that we could upload
	        if (item) {
	            this.add(item);
	        }
	        // Get the items for upload from the display
	        if (this.queue.length) {
	            if (done) {
	                this.completes.push(done);
	            }
	            if (!this.ticking) {
	                this.ticking = true;
	                Ticker.system.addOnce(this.tick, this, exports.UPDATE_PRIORITY.UTILITY);
	            }
	        }
	        else if (done) {
	            done();
	        }
	    };
	    /**
	     * Handle tick update
	     *
	     * @private
	     */
	    BasePrepare.prototype.tick = function () {
	        setTimeout(this.delayedTick, 0);
	    };
	    /**
	     * Actually prepare items. This is handled outside of the tick because it will take a while
	     * and we do NOT want to block the current animation frame from rendering.
	     *
	     * @private
	     */
	    BasePrepare.prototype.prepareItems = function () {
	        this.limiter.beginFrame();
	        // Upload the graphics
	        while (this.queue.length && this.limiter.allowedToUpload()) {
	            var item = this.queue[0];
	            var uploaded = false;
	            if (item && !item._destroyed) {
	                for (var i = 0, len = this.uploadHooks.length; i < len; i++) {
	                    if (this.uploadHooks[i](this.uploadHookHelper, item)) {
	                        this.queue.shift();
	                        uploaded = true;
	                        break;
	                    }
	                }
	            }
	            if (!uploaded) {
	                this.queue.shift();
	            }
	        }
	        // We're finished
	        if (!this.queue.length) {
	            this.ticking = false;
	            var completes = this.completes.slice(0);
	            this.completes.length = 0;
	            for (var i = 0, len = completes.length; i < len; i++) {
	                completes[i]();
	            }
	        }
	        else {
	            // if we are not finished, on the next rAF do this again
	            Ticker.system.addOnce(this.tick, this, exports.UPDATE_PRIORITY.UTILITY);
	        }
	    };
	    /**
	     * Adds hooks for finding items.
	     *
	     * @param {Function} addHook - Function call that takes two parameters: `item:*, queue:Array`
	     *          function must return `true` if it was able to add item to the queue.
	     * @return {this} Instance of plugin for chaining.
	     */
	    BasePrepare.prototype.registerFindHook = function (addHook) {
	        if (addHook) {
	            this.addHooks.push(addHook);
	        }
	        return this;
	    };
	    /**
	     * Adds hooks for uploading items.
	     *
	     * @param {Function} uploadHook - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
	     *          function must return `true` if it was able to handle upload of item.
	     * @return {this} Instance of plugin for chaining.
	     */
	    BasePrepare.prototype.registerUploadHook = function (uploadHook) {
	        if (uploadHook) {
	            this.uploadHooks.push(uploadHook);
	        }
	        return this;
	    };
	    /**
	     * Manually add an item to the uploading queue.
	     *
	     * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text|*} item - Object to
	     *        add to the queue
	     * @return {this} Instance of plugin for chaining.
	     */
	    BasePrepare.prototype.add = function (item) {
	        // Add additional hooks for finding elements on special
	        // types of objects that
	        for (var i = 0, len = this.addHooks.length; i < len; i++) {
	            if (this.addHooks[i](item, this.queue)) {
	                break;
	            }
	        }
	        // Get children recursively
	        if (item instanceof Container) {
	            for (var i = item.children.length - 1; i >= 0; i--) {
	                this.add(item.children[i]);
	            }
	        }
	        return this;
	    };
	    /**
	     * Destroys the plugin, don't use after this.
	     *
	     */
	    BasePrepare.prototype.destroy = function () {
	        if (this.ticking) {
	            Ticker.system.remove(this.tick, this);
	        }
	        this.ticking = false;
	        this.addHooks = null;
	        this.uploadHooks = null;
	        this.renderer = null;
	        this.completes = null;
	        this.queue = null;
	        this.limiter = null;
	        this.uploadHookHelper = null;
	    };
	    return BasePrepare;
	}());

	/**
	 * Built-in hook to upload PIXI.Texture objects to the GPU.
	 *
	 * @private
	 * @param {PIXI.Renderer} renderer - instance of the webgl renderer
	 * @param {PIXI.BaseTexture} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	function uploadBaseTextures(renderer, item) {
	    if (item instanceof BaseTexture) {
	        // if the texture already has a GL texture, then the texture has been prepared or rendered
	        // before now. If the texture changed, then the changer should be calling texture.update() which
	        // reuploads the texture without need for preparing it again
	        if (!item._glTextures[renderer.CONTEXT_UID]) {
	            renderer.texture.bind(item);
	        }
	        return true;
	    }
	    return false;
	}
	/**
	 * Built-in hook to upload PIXI.Graphics to the GPU.
	 *
	 * @private
	 * @param {PIXI.Renderer} renderer - instance of the webgl renderer
	 * @param {PIXI.DisplayObject} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	function uploadGraphics(renderer, item) {
	    if (!(item instanceof Graphics)) {
	        return false;
	    }
	    var geometry = item.geometry;
	    // update dirty graphics to get batches
	    item.finishPoly();
	    geometry.updateBatches();
	    var batches = geometry.batches;
	    // upload all textures found in styles
	    for (var i = 0; i < batches.length; i++) {
	        var texture = batches[i].style.texture;
	        if (texture) {
	            uploadBaseTextures(renderer, texture.baseTexture);
	        }
	    }
	    // if its not batchable - update vao for particular shader
	    if (!geometry.batchable) {
	        renderer.geometry.bind(geometry, item._resolveDirectShader(renderer));
	    }
	    return true;
	}
	/**
	 * Built-in hook to find graphics.
	 *
	 * @private
	 * @param {PIXI.DisplayObject} item - Display object to check
	 * @param {Array<*>} queue - Collection of items to upload
	 * @return {boolean} if a PIXI.Graphics object was found.
	 */
	function findGraphics(item, queue) {
	    if (item instanceof Graphics) {
	        queue.push(item);
	        return true;
	    }
	    return false;
	}
	/**
	 * The prepare plugin provides renderer-specific plugins for pre-rendering DisplayObjects. These plugins are useful for
	 * asynchronously preparing and uploading to the GPU assets, textures, graphics waiting to be displayed.
	 *
	 * Do not instantiate this plugin directly. It is available from the `renderer.plugins` property.
	 * See {@link PIXI.CanvasRenderer#plugins} or {@link PIXI.Renderer#plugins}.
	 * @example
	 * // Create a new application
	 * const app = new PIXI.Application();
	 * document.body.appendChild(app.view);
	 *
	 * // Don't start rendering right away
	 * app.stop();
	 *
	 * // create a display object
	 * const rect = new PIXI.Graphics()
	 *     .beginFill(0x00ff00)
	 *     .drawRect(40, 40, 200, 200);
	 *
	 * // Add to the stage
	 * app.stage.addChild(rect);
	 *
	 * // Don't start rendering until the graphic is uploaded to the GPU
	 * app.renderer.plugins.prepare.upload(app.stage, () => {
	 *     app.start();
	 * });
	 *
	 * @class
	 * @extends PIXI.BasePrepare
	 * @memberof PIXI
	 */
	var Prepare = /** @class */ (function (_super) {
	    __extends$8(Prepare, _super);
	    /**
	     * @param {PIXI.Renderer} renderer - A reference to the current renderer
	     */
	    function Prepare(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        _this.uploadHookHelper = _this.renderer;
	        // Add textures and graphics to upload
	        _this.registerFindHook(findGraphics);
	        _this.registerUploadHook(uploadBaseTextures);
	        _this.registerUploadHook(uploadGraphics);
	        return _this;
	    }
	    return Prepare;
	}(BasePrepare));

	/**
	 * TimeLimiter limits the number of items handled by a {@link PIXI.BasePrepare} to a specified
	 * number of milliseconds per frame.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var TimeLimiter = /** @class */ (function () {
	    /**
	     * @param {number} maxMilliseconds - The maximum milliseconds that can be spent preparing items each frame.
	     */
	    function TimeLimiter(maxMilliseconds) {
	        /**
	         * The maximum milliseconds that can be spent preparing items each frame.
	         * @type {number}
	         * @private
	         */
	        this.maxMilliseconds = maxMilliseconds;
	        /**
	         * The start time of the current frame.
	         * @type {number}
	         * @private
	         */
	        this.frameStart = 0;
	    }
	    /**
	     * Resets any counting properties to start fresh on a new frame.
	     */
	    TimeLimiter.prototype.beginFrame = function () {
	        this.frameStart = Date.now();
	    };
	    /**
	     * Checks to see if another item can be uploaded. This should only be called once per item.
	     * @return {boolean} If the item is allowed to be uploaded.
	     */
	    TimeLimiter.prototype.allowedToUpload = function () {
	        return Date.now() - this.frameStart < this.maxMilliseconds;
	    };
	    return TimeLimiter;
	}());

	/*!
	 * @pixi/spritesheet - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/spritesheet is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * Utility class for maintaining reference to a collection
	 * of Textures on a single Spritesheet.
	 *
	 * To access a sprite sheet from your code pass its JSON data file to Pixi's loader:
	 *
	 * ```js
	 * PIXI.Loader.shared.add("images/spritesheet.json").load(setup);
	 *
	 * function setup() {
	 *   let sheet = PIXI.Loader.shared.resources["images/spritesheet.json"].spritesheet;
	 *   ...
	 * }
	 * ```
	 * With the `sheet.textures` you can create Sprite objects,`sheet.animations` can be used to create an AnimatedSprite.
	 *
	 * Sprite sheets can be packed using tools like {@link https://codeandweb.com/texturepacker|TexturePacker},
	 * {@link https://renderhjs.net/shoebox/|Shoebox} or {@link https://github.com/krzysztof-o/spritesheet.js|Spritesheet.js}.
	 * Default anchor points (see {@link PIXI.Texture#defaultAnchor}) and grouping of animation sprites are currently only
	 * supported by TexturePacker.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var Spritesheet = /** @class */ (function () {
	    /**
	     * @param {PIXI.BaseTexture|PIXI.Texture} baseTexture - Reference to the source BaseTexture object.
	     * @param {Object} data - Spritesheet image data.
	     * @param {string} [resolutionFilename] - The filename to consider when determining
	     *        the resolution of the spritesheet. If not provided, the imageUrl will
	     *        be used on the BaseTexture.
	     */
	    function Spritesheet(texture, data, resolutionFilename) {
	        if (resolutionFilename === void 0) { resolutionFilename = null; }
	        /**
	         * Reference to original source image from the Loader. This reference is retained so we
	         * can destroy the Texture later on. It is never used internally.
	         * @type {PIXI.Texture}
	         * @private
	         */
	        this._texture = texture instanceof Texture ? texture : null;
	        /**
	         * Reference to ths source texture.
	         * @type {PIXI.BaseTexture}
	         */
	        this.baseTexture = texture instanceof BaseTexture ? texture : this._texture.baseTexture;
	        /**
	         * A map containing all textures of the sprite sheet.
	         * Can be used to create a {@link PIXI.Sprite|Sprite}:
	         * ```js
	         * new PIXI.Sprite(sheet.textures["image.png"]);
	         * ```
	         * @member {Object}
	         */
	        this.textures = {};
	        /**
	         * A map containing the textures for each animation.
	         * Can be used to create an {@link PIXI.AnimatedSprite|AnimatedSprite}:
	         * ```js
	         * new PIXI.AnimatedSprite(sheet.animations["anim_name"])
	         * ```
	         * @member {Object}
	         */
	        this.animations = {};
	        /**
	         * Reference to the original JSON data.
	         * @type {Object}
	         */
	        this.data = data;
	        var resource = this.baseTexture.resource;
	        /**
	         * The resolution of the spritesheet.
	         * @type {number}
	         */
	        this.resolution = this._updateResolution(resolutionFilename || (resource ? resource.url : null));
	        /**
	         * Map of spritesheet frames.
	         * @type {Object}
	         * @private
	         */
	        this._frames = this.data.frames;
	        /**
	         * Collection of frame names.
	         * @type {string[]}
	         * @private
	         */
	        this._frameKeys = Object.keys(this._frames);
	        /**
	         * Current batch index being processed.
	         * @type {number}
	         * @private
	         */
	        this._batchIndex = 0;
	        /**
	         * Callback when parse is completed.
	         * @type {Function}
	         * @private
	         */
	        this._callback = null;
	    }
	    /**
	     * Generate the resolution from the filename or fallback
	     * to the meta.scale field of the JSON data.
	     *
	     * @private
	     * @param {string} resolutionFilename - The filename to use for resolving
	     *        the default resolution.
	     * @return {number} Resolution to use for spritesheet.
	     */
	    Spritesheet.prototype._updateResolution = function (resolutionFilename) {
	        if (resolutionFilename === void 0) { resolutionFilename = null; }
	        var scale = this.data.meta.scale;
	        // Use a defaultValue of `null` to check if a url-based resolution is set
	        var resolution = getResolutionOfUrl(resolutionFilename, null);
	        // No resolution found via URL
	        if (resolution === null) {
	            // Use the scale value or default to 1
	            resolution = scale !== undefined ? parseFloat(scale) : 1;
	        }
	        // For non-1 resolutions, update baseTexture
	        if (resolution !== 1) {
	            this.baseTexture.setResolution(resolution);
	        }
	        return resolution;
	    };
	    /**
	     * Parser spritesheet from loaded data. This is done asynchronously
	     * to prevent creating too many Texture within a single process.
	     *
	     * @param {Function} callback - Callback when complete returns
	     *        a map of the Textures for this spritesheet.
	     */
	    Spritesheet.prototype.parse = function (callback) {
	        this._batchIndex = 0;
	        this._callback = callback;
	        if (this._frameKeys.length <= Spritesheet.BATCH_SIZE) {
	            this._processFrames(0);
	            this._processAnimations();
	            this._parseComplete();
	        }
	        else {
	            this._nextBatch();
	        }
	    };
	    /**
	     * Process a batch of frames
	     *
	     * @private
	     * @param {number} initialFrameIndex - The index of frame to start.
	     */
	    Spritesheet.prototype._processFrames = function (initialFrameIndex) {
	        var frameIndex = initialFrameIndex;
	        var maxFrames = Spritesheet.BATCH_SIZE;
	        while (frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length) {
	            var i = this._frameKeys[frameIndex];
	            var data = this._frames[i];
	            var rect = data.frame;
	            if (rect) {
	                var frame = null;
	                var trim = null;
	                var sourceSize = data.trimmed !== false && data.sourceSize
	                    ? data.sourceSize : data.frame;
	                var orig = new Rectangle(0, 0, Math.floor(sourceSize.w) / this.resolution, Math.floor(sourceSize.h) / this.resolution);
	                if (data.rotated) {
	                    frame = new Rectangle(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.h) / this.resolution, Math.floor(rect.w) / this.resolution);
	                }
	                else {
	                    frame = new Rectangle(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
	                }
	                //  Check to see if the sprite is trimmed
	                if (data.trimmed !== false && data.spriteSourceSize) {
	                    trim = new Rectangle(Math.floor(data.spriteSourceSize.x) / this.resolution, Math.floor(data.spriteSourceSize.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
	                }
	                this.textures[i] = new Texture(this.baseTexture, frame, orig, trim, data.rotated ? 2 : 0, data.anchor);
	                // lets also add the frame to pixi's global cache for 'from' and 'fromLoader' functions
	                Texture.addToCache(this.textures[i], i);
	            }
	            frameIndex++;
	        }
	    };
	    /**
	     * Parse animations config
	     *
	     * @private
	     */
	    Spritesheet.prototype._processAnimations = function () {
	        var animations = this.data.animations || {};
	        for (var animName in animations) {
	            this.animations[animName] = [];
	            for (var i = 0; i < animations[animName].length; i++) {
	                var frameName = animations[animName][i];
	                this.animations[animName].push(this.textures[frameName]);
	            }
	        }
	    };
	    /**
	     * The parse has completed.
	     *
	     * @private
	     */
	    Spritesheet.prototype._parseComplete = function () {
	        var callback = this._callback;
	        this._callback = null;
	        this._batchIndex = 0;
	        callback.call(this, this.textures);
	    };
	    /**
	     * Begin the next batch of textures.
	     *
	     * @private
	     */
	    Spritesheet.prototype._nextBatch = function () {
	        var _this = this;
	        this._processFrames(this._batchIndex * Spritesheet.BATCH_SIZE);
	        this._batchIndex++;
	        setTimeout(function () {
	            if (_this._batchIndex * Spritesheet.BATCH_SIZE < _this._frameKeys.length) {
	                _this._nextBatch();
	            }
	            else {
	                _this._processAnimations();
	                _this._parseComplete();
	            }
	        }, 0);
	    };
	    /**
	     * Destroy Spritesheet and don't use after this.
	     *
	     * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
	     */
	    Spritesheet.prototype.destroy = function (destroyBase) {
	        var _a;
	        if (destroyBase === void 0) { destroyBase = false; }
	        for (var i in this.textures) {
	            this.textures[i].destroy();
	        }
	        this._frames = null;
	        this._frameKeys = null;
	        this.data = null;
	        this.textures = null;
	        if (destroyBase) {
	            (_a = this._texture) === null || _a === void 0 ? void 0 : _a.destroy();
	            this.baseTexture.destroy();
	        }
	        this._texture = null;
	        this.baseTexture = null;
	    };
	    /**
	     * The maximum number of Textures to build per process.
	     *
	     * @type {number}
	     * @default 1000
	     */
	    Spritesheet.BATCH_SIZE = 1000;
	    return Spritesheet;
	}());

	/**
	 * {@link PIXI.Loader Loader} middleware for loading texture atlases that have been created with
	 * TexturePacker or similar JSON-based spritesheet.
	 *
	 * This middleware automatically generates Texture resources.
	 *
	 * @class
	 * @memberof PIXI
	 * @implements PIXI.ILoaderPlugin
	 */
	var SpritesheetLoader = /** @class */ (function () {
	    function SpritesheetLoader() {
	    }
	    /**
	     * Called after a resource is loaded.
	     * @see PIXI.Loader.loaderMiddleware
	     * @param {PIXI.LoaderResource} resource
	     * @param {function} next
	     */
	    SpritesheetLoader.use = function (resource, next) {
	        // because this is middleware, it execute in loader context. `this` = loader
	        var loader = this;
	        var imageResourceName = resource.name + "_image";
	        // skip if no data, its not json, it isn't spritesheet data, or the image resource already exists
	        if (!resource.data
	            || resource.type !== LoaderResource.TYPE.JSON
	            || !resource.data.frames
	            || loader.resources[imageResourceName]) {
	            next();
	            return;
	        }
	        var loadOptions = {
	            crossOrigin: resource.crossOrigin,
	            metadata: resource.metadata.imageMetadata,
	            parentResource: resource,
	        };
	        var resourcePath = SpritesheetLoader.getResourcePath(resource, loader.baseUrl);
	        // load the image for this sheet
	        loader.add(imageResourceName, resourcePath, loadOptions, function onImageLoad(res) {
	            if (res.error) {
	                next(res.error);
	                return;
	            }
	            var spritesheet = new Spritesheet(res.texture, resource.data, resource.url);
	            spritesheet.parse(function () {
	                resource.spritesheet = spritesheet;
	                resource.textures = spritesheet.textures;
	                next();
	            });
	        });
	    };
	    /**
	     * Get the spritesheets root path
	     * @param {PIXI.LoaderResource} resource - Resource to check path
	     * @param {string} baseUrl - Base root url
	     */
	    SpritesheetLoader.getResourcePath = function (resource, baseUrl) {
	        // Prepend url path unless the resource image is a data url
	        if (resource.isDataUrl) {
	            return resource.data.meta.image;
	        }
	        return url.resolve(resource.url.replace(baseUrl, ''), resource.data.meta.image);
	    };
	    return SpritesheetLoader;
	}());

	/*!
	 * @pixi/sprite-tiling - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/sprite-tiling is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$9 = function(d, b) {
	    extendStatics$9 = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$9(d, b);
	};

	function __extends$9(d, b) {
	    extendStatics$9(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	var tempPoint$1 = new Point();
	/**
	 * A tiling sprite is a fast way of rendering a tiling image
	 *
	 * @class
	 * @extends PIXI.Sprite
	 * @memberof PIXI
	 */
	var TilingSprite = /** @class */ (function (_super) {
	    __extends$9(TilingSprite, _super);
	    /**
	     * @param {PIXI.Texture} texture - the texture of the tiling sprite
	     * @param {number} [width=100] - the width of the tiling sprite
	     * @param {number} [height=100] - the height of the tiling sprite
	     */
	    function TilingSprite(texture, width, height) {
	        if (width === void 0) { width = 100; }
	        if (height === void 0) { height = 100; }
	        var _this = _super.call(this, texture) || this;
	        /**
	         * Tile transform
	         *
	         * @member {PIXI.Transform}
	         */
	        _this.tileTransform = new Transform();
	        /**
	         * The with of the tiling sprite
	         *
	         * @member {number}
	         * @private
	         */
	        _this._width = width;
	        /**
	         * The height of the tiling sprite
	         *
	         * @member {number}
	         * @private
	         */
	        _this._height = height;
	        /**
	         * matrix that is applied to UV to get the coords in Texture normalized space to coords in BaseTexture space
	         *
	         * @member {PIXI.TextureMatrix}
	         */
	        _this.uvMatrix = _this.texture.uvMatrix || new TextureMatrix(texture);
	        /**
	         * Plugin that is responsible for rendering this element.
	         * Allows to customize the rendering process without overriding '_render' method.
	         *
	         * @member {string}
	         * @default 'tilingSprite'
	         */
	        _this.pluginName = 'tilingSprite';
	        /**
	         * Whether or not anchor affects uvs
	         *
	         * @member {boolean}
	         * @default false
	         */
	        _this.uvRespectAnchor = false;
	        return _this;
	    }
	    Object.defineProperty(TilingSprite.prototype, "clampMargin", {
	        /**
	         * Changes frame clamping in corresponding textureTransform, shortcut
	         * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
	         *
	         * @default 0.5
	         * @member {number}
	         */
	        get: function () {
	            return this.uvMatrix.clampMargin;
	        },
	        set: function (value) {
	            this.uvMatrix.clampMargin = value;
	            this.uvMatrix.update(true);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TilingSprite.prototype, "tileScale", {
	        /**
	         * The scaling of the image that is being tiled
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        get: function () {
	            return this.tileTransform.scale;
	        },
	        set: function (value) {
	            this.tileTransform.scale.copyFrom(value);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TilingSprite.prototype, "tilePosition", {
	        /**
	         * The offset of the image that is being tiled
	         *
	         * @member {PIXI.ObservablePoint}
	         */
	        get: function () {
	            return this.tileTransform.position;
	        },
	        set: function (value) {
	            this.tileTransform.position.copyFrom(value);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * @protected
	     */
	    TilingSprite.prototype._onTextureUpdate = function () {
	        if (this.uvMatrix) {
	            this.uvMatrix.texture = this._texture;
	        }
	        this._cachedTint = 0xFFFFFF;
	    };
	    /**
	     * Renders the object using the WebGL renderer
	     *
	     * @protected
	     * @param {PIXI.Renderer} renderer - The renderer
	     */
	    TilingSprite.prototype._render = function (renderer) {
	        // tweak our texture temporarily..
	        var texture = this._texture;
	        if (!texture || !texture.valid) {
	            return;
	        }
	        this.tileTransform.updateLocalTransform();
	        this.uvMatrix.update();
	        renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]);
	        renderer.plugins[this.pluginName].render(this);
	    };
	    /**
	     * Updates the bounds of the tiling sprite.
	     *
	     * @protected
	     */
	    TilingSprite.prototype._calculateBounds = function () {
	        var minX = this._width * -this._anchor._x;
	        var minY = this._height * -this._anchor._y;
	        var maxX = this._width * (1 - this._anchor._x);
	        var maxY = this._height * (1 - this._anchor._y);
	        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
	    };
	    /**
	     * Gets the local bounds of the sprite object.
	     *
	     * @param {PIXI.Rectangle} rect - The output rectangle.
	     * @return {PIXI.Rectangle} The bounds.
	     */
	    TilingSprite.prototype.getLocalBounds = function (rect) {
	        // we can do a fast local bounds if the sprite has no children!
	        if (this.children.length === 0) {
	            this._bounds.minX = this._width * -this._anchor._x;
	            this._bounds.minY = this._height * -this._anchor._y;
	            this._bounds.maxX = this._width * (1 - this._anchor._x);
	            this._bounds.maxY = this._height * (1 - this._anchor._y);
	            if (!rect) {
	                if (!this._localBoundsRect) {
	                    this._localBoundsRect = new Rectangle();
	                }
	                rect = this._localBoundsRect;
	            }
	            return this._bounds.getRectangle(rect);
	        }
	        return _super.prototype.getLocalBounds.call(this, rect);
	    };
	    /**
	     * Checks if a point is inside this tiling sprite.
	     *
	     * @param {PIXI.IPointData} point - the point to check
	     * @return {boolean} Whether or not the sprite contains the point.
	     */
	    TilingSprite.prototype.containsPoint = function (point) {
	        this.worldTransform.applyInverse(point, tempPoint$1);
	        var width = this._width;
	        var height = this._height;
	        var x1 = -width * this.anchor._x;
	        if (tempPoint$1.x >= x1 && tempPoint$1.x < x1 + width) {
	            var y1 = -height * this.anchor._y;
	            if (tempPoint$1.y >= y1 && tempPoint$1.y < y1 + height) {
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * Destroys this sprite and optionally its texture and children
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
	     *      method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
	     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
	     */
	    TilingSprite.prototype.destroy = function (options) {
	        _super.prototype.destroy.call(this, options);
	        this.tileTransform = null;
	        this.uvMatrix = null;
	    };
	    /**
	     * Helper function that creates a new tiling sprite based on the source you provide.
	     * The source can be - frame id, image url, video url, canvas element, video element, base texture
	     *
	     * @static
	     * @param {string|PIXI.Texture|HTMLCanvasElement|HTMLVideoElement} source - Source to create texture from
	     * @param {Object} options - See {@link PIXI.BaseTexture}'s constructor for options.
	     * @param {number} options.width - required width of the tiling sprite
	     * @param {number} options.height - required height of the tiling sprite
	     * @return {PIXI.TilingSprite} The newly created texture
	     */
	    TilingSprite.from = function (source, options) {
	        // Deprecated
	        if (typeof options === 'number') {
	            deprecation('5.3.0', 'TilingSprite.from use options instead of width and height args');
	            // eslint-disable-next-line prefer-rest-params
	            options = { width: options, height: arguments[2] };
	        }
	        return new TilingSprite(Texture.from(source, options), options.width, options.height);
	    };
	    Object.defineProperty(TilingSprite.prototype, "width", {
	        /**
	         * The width of the sprite, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._width;
	        },
	        set: function (value) {
	            this._width = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(TilingSprite.prototype, "height", {
	        /**
	         * The height of the TilingSprite, setting this will actually modify the scale to achieve the value set
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._height;
	        },
	        set: function (value) {
	            this._height = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return TilingSprite;
	}(Sprite));

	var vertex$2 = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n";

	var fragment$2 = "varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\nuniform mat3 uMapCoord;\nuniform vec4 uClampFrame;\nuniform vec2 uClampOffset;\n\nvoid main(void)\n{\n    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);\n    coord = (uMapCoord * vec3(coord, 1.0)).xy;\n    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);\n\n    vec4 texSample = texture2D(uSampler, coord);\n    gl_FragColor = texSample * uColor;\n}\n";

	var fragmentSimple = "varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\n\nvoid main(void)\n{\n    vec4 texSample = texture2D(uSampler, vTextureCoord);\n    gl_FragColor = texSample * uColor;\n}\n";

	var tempMat$1 = new Matrix();
	/**
	 * WebGL renderer plugin for tiling sprites
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.ObjectRenderer
	 */
	var TilingSpriteRenderer = /** @class */ (function (_super) {
	    __extends$9(TilingSpriteRenderer, _super);
	    /**
	     * constructor for renderer
	     *
	     * @param {PIXI.Renderer} renderer - The renderer this tiling awesomeness works for.
	     */
	    function TilingSpriteRenderer(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        var uniforms = { globals: _this.renderer.globalUniforms };
	        _this.shader = Shader.from(vertex$2, fragment$2, uniforms);
	        _this.simpleShader = Shader.from(vertex$2, fragmentSimple, uniforms);
	        _this.quad = new QuadUv();
	        /**
	         * The WebGL state in which this renderer will work.
	         *
	         * @member {PIXI.State}
	         * @readonly
	         */
	        _this.state = State.for2d();
	        return _this;
	    }
	    /**
	     *
	     * @param {PIXI.TilingSprite} ts - tilingSprite to be rendered
	     */
	    TilingSpriteRenderer.prototype.render = function (ts) {
	        var renderer = this.renderer;
	        var quad = this.quad;
	        var vertices = quad.vertices;
	        vertices[0] = vertices[6] = (ts._width) * -ts.anchor.x;
	        vertices[1] = vertices[3] = ts._height * -ts.anchor.y;
	        vertices[2] = vertices[4] = (ts._width) * (1.0 - ts.anchor.x);
	        vertices[5] = vertices[7] = ts._height * (1.0 - ts.anchor.y);
	        if (ts.uvRespectAnchor) {
	            vertices = quad.uvs;
	            vertices[0] = vertices[6] = -ts.anchor.x;
	            vertices[1] = vertices[3] = -ts.anchor.y;
	            vertices[2] = vertices[4] = 1.0 - ts.anchor.x;
	            vertices[5] = vertices[7] = 1.0 - ts.anchor.y;
	        }
	        quad.invalidate();
	        var tex = ts._texture;
	        var baseTex = tex.baseTexture;
	        var lt = ts.tileTransform.localTransform;
	        var uv = ts.uvMatrix;
	        var isSimple = baseTex.isPowerOfTwo
	            && tex.frame.width === baseTex.width && tex.frame.height === baseTex.height;
	        // auto, force repeat wrapMode for big tiling textures
	        if (isSimple) {
	            if (!baseTex._glTextures[renderer.CONTEXT_UID]) {
	                if (baseTex.wrapMode === exports.WRAP_MODES.CLAMP) {
	                    baseTex.wrapMode = exports.WRAP_MODES.REPEAT;
	                }
	            }
	            else {
	                isSimple = baseTex.wrapMode !== exports.WRAP_MODES.CLAMP;
	            }
	        }
	        var shader = isSimple ? this.simpleShader : this.shader;
	        var w = tex.width;
	        var h = tex.height;
	        var W = ts._width;
	        var H = ts._height;
	        tempMat$1.set(lt.a * w / W, lt.b * w / H, lt.c * h / W, lt.d * h / H, lt.tx / W, lt.ty / H);
	        // that part is the same as above:
	        // tempMat.identity();
	        // tempMat.scale(tex.width, tex.height);
	        // tempMat.prepend(lt);
	        // tempMat.scale(1.0 / ts._width, 1.0 / ts._height);
	        tempMat$1.invert();
	        if (isSimple) {
	            tempMat$1.prepend(uv.mapCoord);
	        }
	        else {
	            shader.uniforms.uMapCoord = uv.mapCoord.toArray(true);
	            shader.uniforms.uClampFrame = uv.uClampFrame;
	            shader.uniforms.uClampOffset = uv.uClampOffset;
	        }
	        shader.uniforms.uTransform = tempMat$1.toArray(true);
	        shader.uniforms.uColor = premultiplyTintToRgba(ts.tint, ts.worldAlpha, shader.uniforms.uColor, baseTex.alphaMode);
	        shader.uniforms.translationMatrix = ts.transform.worldTransform.toArray(true);
	        shader.uniforms.uSampler = tex;
	        renderer.shader.bind(shader);
	        renderer.geometry.bind(quad);
	        this.state.blendMode = correctBlendMode(ts.blendMode, baseTex.alphaMode);
	        renderer.state.set(this.state);
	        renderer.geometry.draw(this.renderer.gl.TRIANGLES, 6, 0);
	    };
	    return TilingSpriteRenderer;
	}(ObjectRenderer));

	/*!
	 * @pixi/mesh - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/mesh is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$a = function(d, b) {
	    extendStatics$a = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$a(d, b);
	};

	function __extends$a(d, b) {
	    extendStatics$a(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	/**
	 * Class controls cache for UV mapping from Texture normal space to BaseTexture normal space.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var MeshBatchUvs = /** @class */ (function () {
	    /**
	     * @param {PIXI.Buffer} uvBuffer - Buffer with normalized uv's
	     * @param {PIXI.TextureMatrix} uvMatrix - Material UV matrix
	     */
	    function MeshBatchUvs(uvBuffer, uvMatrix) {
	        /**
	         * Buffer with normalized UV's
	         * @member {PIXI.Buffer}
	         */
	        this.uvBuffer = uvBuffer;
	        /**
	         * Material UV matrix
	         * @member {PIXI.TextureMatrix}
	         */
	        this.uvMatrix = uvMatrix;
	        /**
	         * UV Buffer data
	         * @member {Float32Array}
	         * @readonly
	         */
	        this.data = null;
	        this._bufferUpdateId = -1;
	        this._textureUpdateId = -1;
	        this._updateID = 0;
	    }
	    /**
	     * updates
	     *
	     * @param {boolean} [forceUpdate] - force the update
	     */
	    MeshBatchUvs.prototype.update = function (forceUpdate) {
	        if (!forceUpdate
	            && this._bufferUpdateId === this.uvBuffer._updateID
	            && this._textureUpdateId === this.uvMatrix._updateID) {
	            return;
	        }
	        this._bufferUpdateId = this.uvBuffer._updateID;
	        this._textureUpdateId = this.uvMatrix._updateID;
	        var data = this.uvBuffer.data;
	        if (!this.data || this.data.length !== data.length) {
	            this.data = new Float32Array(data.length);
	        }
	        this.uvMatrix.multiplyUvs(data, this.data);
	        this._updateID++;
	    };
	    return MeshBatchUvs;
	}());

	var tempPoint$2 = new Point();
	var tempPolygon = new Polygon();
	/**
	 * Base mesh class.
	 *
	 * This class empowers you to have maximum flexibility to render any kind of WebGL visuals you can think of.
	 * This class assumes a certain level of WebGL knowledge.
	 * If you know a bit this should abstract enough away to make you life easier!
	 *
	 * Pretty much ALL WebGL can be broken down into the following:
	 * - Geometry - The structure and data for the mesh. This can include anything from positions, uvs, normals, colors etc..
	 * - Shader - This is the shader that PixiJS will render the geometry with (attributes in the shader must match the geometry)
	 * - State - This is the state of WebGL required to render the mesh.
	 *
	 * Through a combination of the above elements you can render anything you want, 2D or 3D!
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI
	 */
	var Mesh = /** @class */ (function (_super) {
	    __extends$a(Mesh, _super);
	    /**
	     * @param {PIXI.Geometry} geometry - the geometry the mesh will use
	     * @param {PIXI.MeshMaterial} shader - the shader the mesh will use
	     * @param {PIXI.State} [state] - the state that the WebGL context is required to be in to render the mesh
	     *        if no state is provided, uses {@link PIXI.State.for2d} to create a 2D state for PixiJS.
	     * @param {number} [drawMode=PIXI.DRAW_MODES.TRIANGLES] - the drawMode, can be any of the PIXI.DRAW_MODES consts
	     */
	    function Mesh(geometry, shader, state, drawMode) {
	        if (drawMode === void 0) { drawMode = exports.DRAW_MODES.TRIANGLES; }
	        var _this = _super.call(this) || this;
	        /**
	         * Includes vertex positions, face indices, normals, colors, UVs, and
	         * custom attributes within buffers, reducing the cost of passing all
	         * this data to the GPU. Can be shared between multiple Mesh objects.
	         * @member {PIXI.Geometry}
	         * @readonly
	         */
	        _this.geometry = geometry;
	        geometry.refCount++;
	        /**
	         * Represents the vertex and fragment shaders that processes the geometry and runs on the GPU.
	         * Can be shared between multiple Mesh objects.
	         * @member {PIXI.Shader|PIXI.MeshMaterial}
	         */
	        _this.shader = shader;
	        /**
	         * Represents the WebGL state the Mesh required to render, excludes shader and geometry. E.g.,
	         * blend mode, culling, depth testing, direction of rendering triangles, backface, etc.
	         * @member {PIXI.State}
	         */
	        _this.state = state || State.for2d();
	        /**
	         * The way the Mesh should be drawn, can be any of the {@link PIXI.DRAW_MODES} constants.
	         *
	         * @member {number}
	         * @see PIXI.DRAW_MODES
	         */
	        _this.drawMode = drawMode;
	        /**
	         * Typically the index of the IndexBuffer where to start drawing.
	         * @member {number}
	         * @default 0
	         */
	        _this.start = 0;
	        /**
	         * How much of the geometry to draw, by default `0` renders everything.
	         * @member {number}
	         * @default 0
	         */
	        _this.size = 0;
	        /**
	         * thease are used as easy access for batching
	         * @member {Float32Array}
	         * @private
	         */
	        _this.uvs = null;
	        /**
	         * thease are used as easy access for batching
	         * @member {Uint16Array}
	         * @private
	         */
	        _this.indices = null;
	        /**
	         * this is the caching layer used by the batcher
	         * @member {Float32Array}
	         * @private
	         */
	        _this.vertexData = new Float32Array(1);
	        /**
	         * If geometry is changed used to decide to re-transform
	         * the vertexData.
	         * @member {number}
	         * @private
	         */
	        _this.vertexDirty = 0;
	        _this._transformID = -1;
	        /**
	         * Internal roundPixels field
	         *
	         * @member {boolean}
	         * @private
	         */
	        _this._roundPixels = settings.ROUND_PIXELS;
	        /**
	         * Batched UV's are cached for atlas textures
	         * @member {PIXI.MeshBatchUvs}
	         * @private
	         */
	        _this.batchUvs = null;
	        return _this;
	    }
	    Object.defineProperty(Mesh.prototype, "uvBuffer", {
	        /**
	         * To change mesh uv's, change its uvBuffer data and increment its _updateID.
	         * @member {PIXI.Buffer}
	         * @readonly
	         */
	        get: function () {
	            return this.geometry.buffers[1];
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Mesh.prototype, "verticesBuffer", {
	        /**
	         * To change mesh vertices, change its uvBuffer data and increment its _updateID.
	         * Incrementing _updateID is optional because most of Mesh objects do it anyway.
	         * @member {PIXI.Buffer}
	         * @readonly
	         */
	        get: function () {
	            return this.geometry.buffers[0];
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Mesh.prototype, "material", {
	        get: function () {
	            return this.shader;
	        },
	        /**
	         * Alias for {@link PIXI.Mesh#shader}.
	         * @member {PIXI.MeshMaterial}
	         */
	        set: function (value) {
	            this.shader = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Mesh.prototype, "blendMode", {
	        get: function () {
	            return this.state.blendMode;
	        },
	        /**
	         * The blend mode to be applied to the Mesh. Apply a value of
	         * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL;
	         * @see PIXI.BLEND_MODES
	         */
	        set: function (value) {
	            this.state.blendMode = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Mesh.prototype, "roundPixels", {
	        get: function () {
	            return this._roundPixels;
	        },
	        /**
	         * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
	         * Advantages can include sharper image quality (like text) and faster rendering on canvas.
	         * The main disadvantage is movement of objects may appear less smooth.
	         * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
	         *
	         * @member {boolean}
	         * @default false
	         */
	        set: function (value) {
	            if (this._roundPixels !== value) {
	                this._transformID = -1;
	            }
	            this._roundPixels = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Mesh.prototype, "tint", {
	        /**
	         * The multiply tint applied to the Mesh. This is a hex value. A value of
	         * `0xFFFFFF` will remove any tint effect.
	         *
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        get: function () {
	            return this.shader.tint;
	        },
	        set: function (value) {
	            this.shader.tint = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Mesh.prototype, "texture", {
	        /**
	         * The texture that the Mesh uses.
	         *
	         * @member {PIXI.Texture}
	         */
	        get: function () {
	            return this.shader.texture;
	        },
	        set: function (value) {
	            this.shader.texture = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Standard renderer draw.
	     * @protected
	     * @param {PIXI.Renderer} renderer - Instance to renderer.
	     */
	    Mesh.prototype._render = function (renderer) {
	        // set properties for batching..
	        // TODO could use a different way to grab verts?
	        var vertices = this.geometry.buffers[0].data;
	        // TODO benchmark check for attribute size..
	        if (this.shader.batchable
	            && this.drawMode === exports.DRAW_MODES.TRIANGLES
	            && vertices.length < Mesh.BATCHABLE_SIZE * 2) {
	            this._renderToBatch(renderer);
	        }
	        else {
	            this._renderDefault(renderer);
	        }
	    };
	    /**
	     * Standard non-batching way of rendering.
	     * @protected
	     * @param {PIXI.Renderer} renderer - Instance to renderer.
	     */
	    Mesh.prototype._renderDefault = function (renderer) {
	        var shader = this.shader;
	        shader.alpha = this.worldAlpha;
	        if (shader.update) {
	            shader.update();
	        }
	        renderer.batch.flush();
	        if (shader.program.uniformData.translationMatrix) {
	            shader.uniforms.translationMatrix = this.transform.worldTransform.toArray(true);
	        }
	        // bind and sync uniforms..
	        renderer.shader.bind(shader);
	        // set state..
	        renderer.state.set(this.state);
	        // bind the geometry...
	        renderer.geometry.bind(this.geometry, shader);
	        // then render it
	        renderer.geometry.draw(this.drawMode, this.size, this.start, this.geometry.instanceCount);
	    };
	    /**
	     * Rendering by using the Batch system.
	     * @protected
	     * @param {PIXI.Renderer} renderer - Instance to renderer.
	     */
	    Mesh.prototype._renderToBatch = function (renderer) {
	        var geometry = this.geometry;
	        if (this.shader.uvMatrix) {
	            this.shader.uvMatrix.update();
	            this.calculateUvs();
	        }
	        // set properties for batching..
	        this.calculateVertices();
	        this.indices = geometry.indexBuffer.data;
	        this._tintRGB = this.shader._tintRGB;
	        this._texture = this.shader.texture;
	        var pluginName = this.material.pluginName;
	        renderer.batch.setObjectRenderer(renderer.plugins[pluginName]);
	        renderer.plugins[pluginName].render(this);
	    };
	    /**
	     * Updates vertexData field based on transform and vertices
	     */
	    Mesh.prototype.calculateVertices = function () {
	        var geometry = this.geometry;
	        var vertices = geometry.buffers[0].data;
	        if (geometry.vertexDirtyId === this.vertexDirty && this._transformID === this.transform._worldID) {
	            return;
	        }
	        this._transformID = this.transform._worldID;
	        if (this.vertexData.length !== vertices.length) {
	            this.vertexData = new Float32Array(vertices.length);
	        }
	        var wt = this.transform.worldTransform;
	        var a = wt.a;
	        var b = wt.b;
	        var c = wt.c;
	        var d = wt.d;
	        var tx = wt.tx;
	        var ty = wt.ty;
	        var vertexData = this.vertexData;
	        for (var i = 0; i < vertexData.length / 2; i++) {
	            var x = vertices[(i * 2)];
	            var y = vertices[(i * 2) + 1];
	            vertexData[(i * 2)] = (a * x) + (c * y) + tx;
	            vertexData[(i * 2) + 1] = (b * x) + (d * y) + ty;
	        }
	        if (this._roundPixels) {
	            var resolution = settings.RESOLUTION;
	            for (var i = 0; i < vertexData.length; ++i) {
	                vertexData[i] = Math.round((vertexData[i] * resolution | 0) / resolution);
	            }
	        }
	        this.vertexDirty = geometry.vertexDirtyId;
	    };
	    /**
	     * Updates uv field based on from geometry uv's or batchUvs
	     */
	    Mesh.prototype.calculateUvs = function () {
	        var geomUvs = this.geometry.buffers[1];
	        if (!this.shader.uvMatrix.isSimple) {
	            if (!this.batchUvs) {
	                this.batchUvs = new MeshBatchUvs(geomUvs, this.shader.uvMatrix);
	            }
	            this.batchUvs.update();
	            this.uvs = this.batchUvs.data;
	        }
	        else {
	            this.uvs = geomUvs.data;
	        }
	    };
	    /**
	     * Updates the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
	     * there must be a aVertexPosition attribute present in the geometry for bounds to be calculated correctly.
	     *
	     * @protected
	     */
	    Mesh.prototype._calculateBounds = function () {
	        this.calculateVertices();
	        this._bounds.addVertexData(this.vertexData, 0, this.vertexData.length);
	    };
	    /**
	     * Tests if a point is inside this mesh. Works only for PIXI.DRAW_MODES.TRIANGLES.
	     *
	     * @param {PIXI.IPointData} point - the point to test
	     * @return {boolean} the result of the test
	     */
	    Mesh.prototype.containsPoint = function (point) {
	        if (!this.getBounds().contains(point.x, point.y)) {
	            return false;
	        }
	        this.worldTransform.applyInverse(point, tempPoint$2);
	        var vertices = this.geometry.getBuffer('aVertexPosition').data;
	        var points = tempPolygon.points;
	        var indices = this.geometry.getIndex().data;
	        var len = indices.length;
	        var step = this.drawMode === 4 ? 3 : 1;
	        for (var i = 0; i + 2 < len; i += step) {
	            var ind0 = indices[i] * 2;
	            var ind1 = indices[i + 1] * 2;
	            var ind2 = indices[i + 2] * 2;
	            points[0] = vertices[ind0];
	            points[1] = vertices[ind0 + 1];
	            points[2] = vertices[ind1];
	            points[3] = vertices[ind1 + 1];
	            points[4] = vertices[ind2];
	            points[5] = vertices[ind2 + 1];
	            if (tempPolygon.contains(tempPoint$2.x, tempPoint$2.y)) {
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * Destroys the Mesh object.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all
	     *  options have been set to that value
	     * @param {boolean} [options.children=false] - if set to true, all the children will have
	     *  their destroy method called as well. 'options' will be passed on to those calls.
	     */
	    Mesh.prototype.destroy = function (options) {
	        _super.prototype.destroy.call(this, options);
	        this.geometry.refCount--;
	        if (this.geometry.refCount === 0) {
	            this.geometry.dispose();
	        }
	        this.geometry = null;
	        this.shader = null;
	        this.state = null;
	        this.uvs = null;
	        this.indices = null;
	        this.vertexData = null;
	    };
	    /**
	     * The maximum number of vertices to consider batchable. Generally, the complexity
	     * of the geometry.
	     * @memberof PIXI.Mesh
	     * @static
	     * @member {number} BATCHABLE_SIZE
	     */
	    Mesh.BATCHABLE_SIZE = 100;
	    return Mesh;
	}(Container));

	var fragment$3 = "varying vec2 vTextureCoord;\nuniform vec4 uColor;\n\nuniform sampler2D uSampler;\n\nvoid main(void)\n{\n    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;\n}\n";

	var vertex$3 = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTextureMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;\n}\n";

	/**
	 * Slightly opinionated default shader for PixiJS 2D objects.
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.Shader
	 */
	var MeshMaterial = /** @class */ (function (_super) {
	    __extends$a(MeshMaterial, _super);
	    /**
	     * @param {PIXI.Texture} uSampler - Texture that material uses to render.
	     * @param {object} [options] - Additional options
	     * @param {number} [options.alpha=1] - Default alpha.
	     * @param {number} [options.tint=0xFFFFFF] - Default tint.
	     * @param {string} [options.pluginName='batch'] - Renderer plugin for batching.
	     * @param {PIXI.Program} [options.program=0xFFFFFF] - Custom program.
	     * @param {object} [options.uniforms] - Custom uniforms.
	     */
	    function MeshMaterial(uSampler, options) {
	        var _this = this;
	        var uniforms = {
	            uSampler: uSampler,
	            alpha: 1,
	            uTextureMatrix: Matrix.IDENTITY,
	            uColor: new Float32Array([1, 1, 1, 1]),
	        };
	        // Set defaults
	        options = Object.assign({
	            tint: 0xFFFFFF,
	            alpha: 1,
	            pluginName: 'batch',
	        }, options);
	        if (options.uniforms) {
	            Object.assign(uniforms, options.uniforms);
	        }
	        _this = _super.call(this, options.program || Program.from(vertex$3, fragment$3), uniforms) || this;
	        /**
	         * Only do update if tint or alpha changes.
	         * @member {boolean}
	         * @private
	         * @default false
	         */
	        _this._colorDirty = false;
	        /**
	         * TextureMatrix instance for this Mesh, used to track Texture changes
	         *
	         * @member {PIXI.TextureMatrix}
	         * @readonly
	         */
	        _this.uvMatrix = new TextureMatrix(uSampler);
	        /**
	         * `true` if shader can be batch with the renderer's batch system.
	         * @member {boolean}
	         * @default true
	         */
	        _this.batchable = options.program === undefined;
	        /**
	         * Renderer plugin for batching
	         *
	         * @member {string}
	         * @default 'batch'
	         */
	        _this.pluginName = options.pluginName;
	        _this.tint = options.tint;
	        _this.alpha = options.alpha;
	        return _this;
	    }
	    Object.defineProperty(MeshMaterial.prototype, "texture", {
	        /**
	         * Reference to the texture being rendered.
	         * @member {PIXI.Texture}
	         */
	        get: function () {
	            return this.uniforms.uSampler;
	        },
	        set: function (value) {
	            if (this.uniforms.uSampler !== value) {
	                this.uniforms.uSampler = value;
	                this.uvMatrix.texture = value;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(MeshMaterial.prototype, "alpha", {
	        get: function () {
	            return this._alpha;
	        },
	        /**
	         * This gets automatically set by the object using this.
	         *
	         * @default 1
	         * @member {number}
	         */
	        set: function (value) {
	            if (value === this._alpha)
	                { return; }
	            this._alpha = value;
	            this._colorDirty = true;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(MeshMaterial.prototype, "tint", {
	        get: function () {
	            return this._tint;
	        },
	        /**
	         * Multiply tint for the material.
	         * @member {number}
	         * @default 0xFFFFFF
	         */
	        set: function (value) {
	            if (value === this._tint)
	                { return; }
	            this._tint = value;
	            this._tintRGB = (value >> 16) + (value & 0xff00) + ((value & 0xff) << 16);
	            this._colorDirty = true;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Gets called automatically by the Mesh. Intended to be overridden for custom
	     * MeshMaterial objects.
	     */
	    MeshMaterial.prototype.update = function () {
	        if (this._colorDirty) {
	            this._colorDirty = false;
	            var baseTexture = this.texture.baseTexture;
	            premultiplyTintToRgba(this._tint, this._alpha, this.uniforms.uColor, baseTexture.alphaMode);
	        }
	        if (this.uvMatrix.update()) {
	            this.uniforms.uTextureMatrix = this.uvMatrix.mapCoord;
	        }
	    };
	    return MeshMaterial;
	}(Shader));

	/**
	 * Standard 2D geometry used in PixiJS.
	 *
	 * Geometry can be defined without passing in a style or data if required.
	 *
	 * ```js
	 * const geometry = new PIXI.Geometry();
	 *
	 * geometry.addAttribute('positions', [0, 0, 100, 0, 100, 100, 0, 100], 2);
	 * geometry.addAttribute('uvs', [0,0,1,0,1,1,0,1], 2);
	 * geometry.addIndex([0,1,2,1,3,2]);
	 *
	 * ```
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.Geometry
	 */
	var MeshGeometry = /** @class */ (function (_super) {
	    __extends$a(MeshGeometry, _super);
	    /**
	     * @param {Float32Array|number[]} [vertices] - Positional data on geometry.
	     * @param {Float32Array|number[]} [uvs] - Texture UVs.
	     * @param {Uint16Array|number[]} [index] - IndexBuffer
	     */
	    function MeshGeometry(vertices, uvs, index) {
	        var _this = _super.call(this) || this;
	        var verticesBuffer = new Buffer(vertices);
	        var uvsBuffer = new Buffer(uvs, true);
	        var indexBuffer = new Buffer(index, true, true);
	        _this.addAttribute('aVertexPosition', verticesBuffer, 2, false, exports.TYPES.FLOAT)
	            .addAttribute('aTextureCoord', uvsBuffer, 2, false, exports.TYPES.FLOAT)
	            .addIndex(indexBuffer);
	        /**
	         * Dirty flag to limit update calls on Mesh. For example,
	         * limiting updates on a single Mesh instance with a shared Geometry
	         * within the render loop.
	         * @private
	         * @member {number}
	         * @default -1
	         */
	        _this._updateId = -1;
	        return _this;
	    }
	    Object.defineProperty(MeshGeometry.prototype, "vertexDirtyId", {
	        /**
	         * If the vertex position is updated.
	         * @member {number}
	         * @readonly
	         * @private
	         */
	        get: function () {
	            return this.buffers[0]._updateID;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return MeshGeometry;
	}(Geometry));

	/*!
	 * @pixi/text-bitmap - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/text-bitmap is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$b = function(d, b) {
	    extendStatics$b = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$b(d, b);
	};

	function __extends$b(d, b) {
	    extendStatics$b(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	/* eslint-disable max-len */
	/**
	 * Normalized parsed data from .fnt files.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var BitmapFontData = /** @class */ (function () {
	    function BitmapFontData() {
	        /**
	         * @member {PIXI.IBitmapFontDataInfo[]}
	         * @readOnly
	         */
	        this.info = [];
	        /**
	         * @member {PIXI.IBitmapFontDataCommon[]}
	         * @readOnly
	         */
	        this.common = [];
	        /**
	         * @member {PIXI.IBitmapFontDataPage[]}
	         * @readOnly
	         */
	        this.page = [];
	        /**
	         * @member {PIXI.IBitmapFontDataChar[]}
	         * @readOnly
	         */
	        this.char = [];
	        /**
	         * @member {PIXI.IBitmapFontDataKerning[]}
	         * @readOnly
	         */
	        this.kerning = [];
	    }
	    return BitmapFontData;
	}());
	/**
	 * @memberof PIXI
	 * @typedef {object} IBitmapFontDataInfo
	 * @property {string} face
	 * @property {number} size
	 */
	/**
	 * @memberof PIXI
	 * @typedef {object} IBitmapFontDataCommon
	 * @property {number} lineHeight
	 */
	/**
	 * @memberof PIXI
	 * @typedef {object} IBitmapFontDataPage
	 * @property {number} id
	 * @property {string} file
	 */
	/**
	 * @memberof PIXI
	 * @typedef {object} IBitmapFontDataChar
	 * @property {string} id
	 * @property {number} page
	 * @property {number} x
	 * @property {number} y
	 * @property {number} width
	 * @property {number} height
	 * @property {number} xoffset
	 * @property {number} yoffset
	 * @property {number} xadvance
	 */
	/**
	 * @memberof PIXI
	 * @typedef {object} IBitmapFontDataKerning
	 * @property {number} first
	 * @property {number} second
	 * @property {number} amount
	 */

	/**
	 * BitmapFont format that's Text-based.
	 *
	 * @class
	 * @private
	 */
	var TextFormat = /** @class */ (function () {
	    function TextFormat() {
	    }
	    /**
	     * Check if resource refers to txt font data.
	     *
	     * @static
	     * @private
	     * @param {any} data
	     * @return {boolean} True if resource could be treated as font data, false otherwise.
	     */
	    TextFormat.test = function (data) {
	        return typeof data === 'string' && data.indexOf('info face=') === 0;
	    };
	    /**
	     * Convert text font data to a javascript object.
	     *
	     * @static
	     * @private
	     * @param {string} txt - Raw string data to be converted
	     * @return {PIXI.BitmapFontData} Parsed font data
	     */
	    TextFormat.parse = function (txt) {
	        // Retrieve data item
	        var items = txt.match(/^[a-z]+\s+.+$/gm);
	        var rawData = {
	            info: [],
	            common: [],
	            page: [],
	            char: [],
	            chars: [],
	            kerning: [],
	            kernings: [],
	        };
	        for (var i in items) {
	            // Extract item name
	            var name = items[i].match(/^[a-z]+/gm)[0];
	            // Extract item attribute list as string ex.: "width=10"
	            var attributeList = items[i].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm);
	            // Convert attribute list into an object
	            var itemData = {};
	            for (var i_1 in attributeList) {
	                // Split key-value pairs
	                var split = attributeList[i_1].split('=');
	                var key = split[0];
	                // Remove eventual quotes from value
	                var strValue = split[1].replace(/"/gm, '');
	                // Try to convert value into float
	                var floatValue = parseFloat(strValue);
	                // Use string value case float value is NaN
	                var value = isNaN(floatValue) ? strValue : floatValue;
	                itemData[key] = value;
	            }
	            // Push current item to the resulting data
	            rawData[name].push(itemData);
	        }
	        var font = new BitmapFontData();
	        rawData.info.forEach(function (info) { return font.info.push({
	            face: info.face,
	            size: parseInt(info.size, 10),
	        }); });
	        rawData.common.forEach(function (common) { return font.common.push({
	            lineHeight: parseInt(common.lineHeight, 10),
	        }); });
	        rawData.page.forEach(function (page) { return font.page.push({
	            id: parseInt(page.id, 10),
	            file: page.file,
	        }); });
	        rawData.char.forEach(function (char) { return font.char.push({
	            id: parseInt(char.id, 10),
	            page: parseInt(char.page, 10),
	            x: parseInt(char.x, 10),
	            y: parseInt(char.y, 10),
	            width: parseInt(char.width, 10),
	            height: parseInt(char.height, 10),
	            xoffset: parseInt(char.xoffset, 10),
	            yoffset: parseInt(char.yoffset, 10),
	            xadvance: parseInt(char.xadvance, 10),
	        }); });
	        rawData.kerning.forEach(function (kerning) { return font.kerning.push({
	            first: parseInt(kerning.first, 10),
	            second: parseInt(kerning.second, 10),
	            amount: parseInt(kerning.amount, 10),
	        }); });
	        return font;
	    };
	    return TextFormat;
	}());

	/**
	 * BitmapFont format that's XML-based.
	 *
	 * @class
	 * @private
	 */
	var XMLFormat = /** @class */ (function () {
	    function XMLFormat() {
	    }
	    /**
	     * Check if resource refers to xml font data.
	     *
	     * @static
	     * @private
	     * @param {any} data
	     * @return {boolean} True if resource could be treated as font data, false otherwise.
	     */
	    XMLFormat.test = function (data) {
	        return data instanceof XMLDocument
	            && data.getElementsByTagName('page').length
	            && data.getElementsByTagName('info')[0].getAttribute('face') !== null;
	    };
	    /**
	     * Convert the XML into BitmapFontData that we can use.
	     *
	     * @static
	     * @private
	     * @param {XMLDocument} xml
	     * @return {BitmapFontData} Data to use for BitmapFont
	     */
	    XMLFormat.parse = function (xml) {
	        var data = new BitmapFontData();
	        var info = xml.getElementsByTagName('info');
	        var common = xml.getElementsByTagName('common');
	        var page = xml.getElementsByTagName('page');
	        var char = xml.getElementsByTagName('char');
	        var kerning = xml.getElementsByTagName('kerning');
	        for (var i = 0; i < info.length; i++) {
	            data.info.push({
	                face: info[i].getAttribute('face'),
	                size: parseInt(info[i].getAttribute('size'), 10),
	            });
	        }
	        for (var i = 0; i < common.length; i++) {
	            data.common.push({
	                lineHeight: parseInt(common[i].getAttribute('lineHeight'), 10),
	            });
	        }
	        for (var i = 0; i < page.length; i++) {
	            data.page.push({
	                id: parseInt(page[i].getAttribute('id'), 10) || 0,
	                file: page[i].getAttribute('file'),
	            });
	        }
	        for (var i = 0; i < char.length; i++) {
	            var letter = char[i];
	            data.char.push({
	                id: parseInt(letter.getAttribute('id'), 10),
	                page: parseInt(letter.getAttribute('page'), 10) || 0,
	                x: parseInt(letter.getAttribute('x'), 10),
	                y: parseInt(letter.getAttribute('y'), 10),
	                width: parseInt(letter.getAttribute('width'), 10),
	                height: parseInt(letter.getAttribute('height'), 10),
	                xoffset: parseInt(letter.getAttribute('xoffset'), 10),
	                yoffset: parseInt(letter.getAttribute('yoffset'), 10),
	                xadvance: parseInt(letter.getAttribute('xadvance'), 10),
	            });
	        }
	        for (var i = 0; i < kerning.length; i++) {
	            data.kerning.push({
	                first: parseInt(kerning[i].getAttribute('first'), 10),
	                second: parseInt(kerning[i].getAttribute('second'), 10),
	                amount: parseInt(kerning[i].getAttribute('amount'), 10),
	            });
	        }
	        return data;
	    };
	    return XMLFormat;
	}());

	/**
	 * BitmapFont format that's XML-based.
	 *
	 * @class
	 * @private
	 */
	var XMLStringFormat = /** @class */ (function () {
	    function XMLStringFormat() {
	    }
	    /**
	     * Check if resource refers to text xml font data.
	     *
	     * @static
	     * @private
	     * @param {any} data
	     * @return {boolean} True if resource could be treated as font data, false otherwise.
	     */
	    XMLStringFormat.test = function (data) {
	        if (typeof data === 'string' && data.indexOf('<font>') > -1) {
	            var xml = new self.DOMParser().parseFromString(data, 'text/xml');
	            return XMLFormat.test(xml);
	        }
	        return false;
	    };
	    /**
	     * Convert the text XML into BitmapFontData that we can use.
	     *
	     * @static
	     * @private
	     * @param {string} xmlTxt
	     * @return {BitmapFontData} Data to use for BitmapFont
	     */
	    XMLStringFormat.parse = function (xmlTxt) {
	        var xml = new window.DOMParser().parseFromString(xmlTxt, 'text/xml');
	        return XMLFormat.parse(xml);
	    };
	    return XMLStringFormat;
	}());

	// Registered formats, maybe make this extensible in the future?
	var formats = [
	    TextFormat,
	    XMLFormat,
	    XMLStringFormat ];
	/**
	 * Auto-detect BitmapFont parsing format based on data.
	 * @private
	 * @param {any} data - Data to detect format
	 * @return {any} Format or null
	 */
	function autoDetectFormat(data) {
	    for (var i = 0; i < formats.length; i++) {
	        if (formats[i].test(data)) {
	            return formats[i];
	        }
	    }
	    return null;
	}

	// TODO: Prevent code duplication b/w generateFillStyle & Text#generateFillStyle
	/**
	 * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
	 *
	 * @private
	 * @param {object} style - The style.
	 * @param {string[]} lines - The lines of text.
	 * @return {string|number|CanvasGradient} The fill style
	 */
	function generateFillStyle(canvas, context, style, resolution, lines, metrics) {
	    // TODO: Can't have different types for getter and setter. The getter shouldn't have the number type as
	    //       the setter converts to string. See this thread for more details:
	    //       https://github.com/microsoft/TypeScript/issues/2521
	    var fillStyle = style.fill;
	    if (!Array.isArray(fillStyle)) {
	        return fillStyle;
	    }
	    else if (fillStyle.length === 1) {
	        return fillStyle[0];
	    }
	    // the gradient will be evenly spaced out according to how large the array is.
	    // ['#FF0000', '#00FF00', '#0000FF'] would created stops at 0.25, 0.5 and 0.75
	    var gradient;
	    // a dropshadow will enlarge the canvas and result in the gradient being
	    // generated with the incorrect dimensions
	    var dropShadowCorrection = (style.dropShadow) ? style.dropShadowDistance : 0;
	    // should also take padding into account, padding can offset the gradient
	    var padding = style.padding || 0;
	    var width = Math.ceil(canvas.width / resolution) - dropShadowCorrection - (padding * 2);
	    var height = Math.ceil(canvas.height / resolution) - dropShadowCorrection - (padding * 2);
	    // make a copy of the style settings, so we can manipulate them later
	    var fill = fillStyle.slice();
	    var fillGradientStops = style.fillGradientStops.slice();
	    // wanting to evenly distribute the fills. So an array of 4 colours should give fills of 0.25, 0.5 and 0.75
	    if (!fillGradientStops.length) {
	        var lengthPlus1 = fill.length + 1;
	        for (var i = 1; i < lengthPlus1; ++i) {
	            fillGradientStops.push(i / lengthPlus1);
	        }
	    }
	    // stop the bleeding of the last gradient on the line above to the top gradient of the this line
	    // by hard defining the first gradient colour at point 0, and last gradient colour at point 1
	    fill.unshift(fillStyle[0]);
	    fillGradientStops.unshift(0);
	    fill.push(fillStyle[fillStyle.length - 1]);
	    fillGradientStops.push(1);
	    if (style.fillGradientType === exports.TEXT_GRADIENT.LINEAR_VERTICAL) {
	        // start the gradient at the top center of the canvas, and end at the bottom middle of the canvas
	        gradient = context.createLinearGradient(width / 2, padding, width / 2, height + padding);
	        // we need to repeat the gradient so that each individual line of text has the same vertical gradient effect
	        // ['#FF0000', '#00FF00', '#0000FF'] over 2 lines would create stops at 0.125, 0.25, 0.375, 0.625, 0.75, 0.875
	        // There's potential for floating point precision issues at the seams between gradient repeats.
	        // The loop below generates the stops in order, so track the last generated one to prevent
	        // floating point precision from making us go the teeniest bit backwards, resulting in
	        // the first and last colors getting swapped.
	        var lastIterationStop = 0;
	        // Actual height of the text itself, not counting spacing for lineHeight/leading/dropShadow etc
	        var textHeight = metrics.fontProperties.fontSize + style.strokeThickness;
	        // textHeight, but as a 0-1 size in global gradient stop space
	        var gradStopLineHeight = textHeight / height;
	        for (var i = 0; i < lines.length; i++) {
	            var thisLineTop = metrics.lineHeight * i;
	            for (var j = 0; j < fill.length; j++) {
	                // 0-1 stop point for the current line, multiplied to global space afterwards
	                var lineStop = 0;
	                if (typeof fillGradientStops[j] === 'number') {
	                    lineStop = fillGradientStops[j];
	                }
	                else {
	                    lineStop = j / fill.length;
	                }
	                var globalStop = (thisLineTop / height) + (lineStop * gradStopLineHeight);
	                // Prevent color stop generation going backwards from floating point imprecision
	                var clampedStop = Math.max(lastIterationStop, globalStop);
	                clampedStop = Math.min(clampedStop, 1); // Cap at 1 as well for safety's sake to avoid a possible throw.
	                gradient.addColorStop(clampedStop, fill[j]);
	                lastIterationStop = clampedStop;
	            }
	        }
	    }
	    else {
	        // start the gradient at the center left of the canvas, and end at the center right of the canvas
	        gradient = context.createLinearGradient(padding, height / 2, width + padding, height / 2);
	        // can just evenly space out the gradients in this case, as multiple lines makes no difference
	        // to an even left to right gradient
	        var totalIterations = fill.length + 1;
	        var currentIteration = 1;
	        for (var i = 0; i < fill.length; i++) {
	            var stop = void 0;
	            if (typeof fillGradientStops[i] === 'number') {
	                stop = fillGradientStops[i];
	            }
	            else {
	                stop = currentIteration / totalIterations;
	            }
	            gradient.addColorStop(stop, fill[i]);
	            currentIteration++;
	        }
	    }
	    return gradient;
	}

	// TODO: Prevent code duplication b/w drawGlyph & Text#updateText
	/**
	 * Draws the glyph `metrics.text` on the given canvas.
	 *
	 * Ignored because not directly exposed.
	 *
	 * @ignore
	 * @param {HTMLCanvasElement} canvas
	 * @param {CanvasRenderingContext2D} context
	 * @param {TextMetrics} metrics
	 * @param {number} x
	 * @param {number} y
	 * @param {number} resolution
	 * @param {TextStyle} style
	 */
	function drawGlyph(canvas, context, metrics, x, y, resolution, style) {
	    var char = metrics.text;
	    var fontProperties = metrics.fontProperties;
	    context.translate(x, y);
	    context.scale(resolution, resolution);
	    var tx = style.strokeThickness / 2;
	    var ty = -(style.strokeThickness / 2);
	    context.font = style.toFontString();
	    context.lineWidth = style.strokeThickness;
	    context.textBaseline = style.textBaseline;
	    context.lineJoin = style.lineJoin;
	    context.miterLimit = style.miterLimit;
	    // set canvas text styles
	    context.fillStyle = generateFillStyle(canvas, context, style, resolution, [char], metrics);
	    context.strokeStyle = style.stroke;
	    context.font = style.toFontString();
	    context.lineWidth = style.strokeThickness;
	    context.textBaseline = style.textBaseline;
	    context.lineJoin = style.lineJoin;
	    context.miterLimit = style.miterLimit;
	    // set canvas text styles
	    context.fillStyle = generateFillStyle(canvas, context, style, resolution, [char], metrics);
	    context.strokeStyle = style.stroke;
	    var dropShadowColor = style.dropShadowColor;
	    var rgb = hex2rgb(typeof dropShadowColor === 'number' ? dropShadowColor : string2hex(dropShadowColor));
	    if (style.dropShadow) {
	        context.shadowColor = "rgba(" + rgb[0] * 255 + "," + rgb[1] * 255 + "," + rgb[2] * 255 + "," + style.dropShadowAlpha + ")";
	        context.shadowBlur = style.dropShadowBlur;
	        context.shadowOffsetX = Math.cos(style.dropShadowAngle) * style.dropShadowDistance;
	        context.shadowOffsetY = Math.sin(style.dropShadowAngle) * style.dropShadowDistance;
	    }
	    else {
	        context.shadowColor = 'black';
	        context.shadowBlur = 0;
	        context.shadowOffsetX = 0;
	        context.shadowOffsetY = 0;
	    }
	    if (style.stroke && style.strokeThickness) {
	        context.strokeText(char, tx, ty + metrics.lineHeight - fontProperties.descent);
	    }
	    if (style.fill) {
	        context.fillText(char, tx, ty + metrics.lineHeight - fontProperties.descent);
	    }
	    context.setTransform(1, 0, 0, 1, 0, 0); // defaults needed for older browsers (e.g. Opera 29)
	    context.fillStyle = 'rgba(0, 0, 0, 0)';
	}

	/**
	 * Processes the passed character set data and returns a flattened array of all the characters.
	 *
	 * Ignored because not directly exposed.
	 *
	 * @ignore
	 * @param {string | string[] | string[][] } chars
	 * @returns {string[]}
	 */
	function resolveCharacters(chars) {
	    // Split the chars string into individual characters
	    if (typeof chars === 'string') {
	        chars = [chars];
	    }
	    // Handle an array of characters+ranges
	    var result = [];
	    for (var i = 0, j = chars.length; i < j; i++) {
	        var item = chars[i];
	        // Handle range delimited by start/end chars
	        if (Array.isArray(item)) {
	            if (item.length !== 2) {
	                throw new Error("[BitmapFont]: Invalid character range length, expecting 2 got " + item.length + ".");
	            }
	            var startCode = item[0].charCodeAt(0);
	            var endCode = item[1].charCodeAt(0);
	            if (endCode < startCode) {
	                throw new Error('[BitmapFont]: Invalid character range.');
	            }
	            for (var i_1 = startCode, j_1 = endCode; i_1 <= j_1; i_1++) {
	                result.push(String.fromCharCode(i_1));
	            }
	        }
	        // Handle a character set string
	        else {
	            result.push.apply(result, item.split(''));
	        }
	    }
	    if (result.length === 0) {
	        throw new Error('[BitmapFont]: Empty set when resolving characters.');
	    }
	    return result;
	}

	/**
	 * BitmapFont represents a typeface available for use with the BitmapText class. Use the `install`
	 * method for adding a font to be used.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var BitmapFont = /** @class */ (function () {
	    /**
	     * @param {PIXI.BitmapFontData} data
	     * @param {PIXI.Texture[]|Object.<string, PIXI.Texture>} textures
	     * @param {boolean} [ownsTextures] - Setting to `true` will destroy page textures
	     *        when the font is uninstalled.
	     */
	    function BitmapFont(data, textures, ownsTextures) {
	        var info = data.info[0];
	        var common = data.common[0];
	        var page = data.page[0];
	        var res = getResolutionOfUrl(page.file);
	        var pageTextures = {};
	        this._ownsTextures = ownsTextures;
	        /**
	         * The name of the font face.
	         *
	         * @member {string}
	         * @readonly
	         */
	        this.font = info.face;
	        /**
	         * The size of the font face in pixels.
	         *
	         * @member {number}
	         * @readonly
	         */
	        this.size = info.size;
	        /**
	         * The line-height of the font face in pixels.
	         *
	         * @member {number}
	         * @readonly
	         */
	        this.lineHeight = common.lineHeight / res;
	        /**
	         * The map of characters by character code.
	         *
	         * @member {object}
	         * @readonly
	         */
	        this.chars = {};
	        /**
	         * The map of base page textures (i.e., sheets of glyphs).
	         *
	         * @member {object}
	         * @readonly
	         * @private
	         */
	        this.pageTextures = pageTextures;
	        // Convert the input Texture, Textures or object
	        // into a page Texture lookup by "id"
	        for (var i = 0; i < data.page.length; i++) {
	            var _a = data.page[i], id = _a.id, file = _a.file;
	            pageTextures[id] = textures instanceof Array
	                ? textures[i] : textures[file];
	        }
	        // parse letters
	        for (var i = 0; i < data.char.length; i++) {
	            var _b = data.char[i], id = _b.id, page_1 = _b.page;
	            var _c = data.char[i], x = _c.x, y = _c.y, width = _c.width, height = _c.height, xoffset = _c.xoffset, yoffset = _c.yoffset, xadvance = _c.xadvance;
	            x /= res;
	            y /= res;
	            width /= res;
	            height /= res;
	            xoffset /= res;
	            yoffset /= res;
	            xadvance /= res;
	            var rect = new Rectangle(x + (pageTextures[page_1].frame.x / res), y + (pageTextures[page_1].frame.y / res), width, height);
	            this.chars[id] = {
	                xOffset: xoffset,
	                yOffset: yoffset,
	                xAdvance: xadvance,
	                kerning: {},
	                texture: new Texture(pageTextures[page_1].baseTexture, rect),
	                page: page_1,
	            };
	        }
	        // parse kernings
	        for (var i = 0; i < data.kerning.length; i++) {
	            var _d = data.kerning[i], first = _d.first, second = _d.second, amount = _d.amount;
	            first /= res;
	            second /= res;
	            amount /= res;
	            if (this.chars[second]) {
	                this.chars[second].kerning[first] = amount;
	            }
	        }
	    }
	    /**
	     * Remove references to created glyph textures.
	     */
	    BitmapFont.prototype.destroy = function () {
	        for (var id in this.chars) {
	            this.chars[id].texture.destroy();
	            this.chars[id].texture = null;
	        }
	        for (var id in this.pageTextures) {
	            if (this._ownsTextures) {
	                this.pageTextures[id].destroy(true);
	            }
	            this.pageTextures[id] = null;
	        }
	        // Set readonly null.
	        this.chars = null;
	        this.pageTextures = null;
	    };
	    /**
	     * Register a new bitmap font.
	     *
	     * @static
	     * @param {XMLDocument|string|PIXI.BitmapFontData} data - The
	     *        characters map that could be provided as xml or raw string.
	     * @param {Object.<string, PIXI.Texture>|PIXI.Texture|PIXI.Texture[]}
	     *        textures - List of textures for each page.
	     * @param {boolean} managedTexture - Set to `true` to destroy page textures
	     *        when the font is uninstalled. By default fonts created with
	     *        `BitmapFont.from` or from the `BitmapFontLoader` are `true`.
	     * @return {PIXI.BitmapFont} Result font object with font, size, lineHeight
	     *         and char fields.
	     */
	    BitmapFont.install = function (data, textures, ownsTextures) {
	        var fontData;
	        if (data instanceof BitmapFontData) {
	            fontData = data;
	        }
	        else {
	            var format = autoDetectFormat(data);
	            if (!format) {
	                throw new Error('Unrecognized data format for font.');
	            }
	            fontData = format.parse(data);
	        }
	        // Single texture, convert to list
	        if (textures instanceof Texture) {
	            textures = [textures];
	        }
	        var font = new BitmapFont(fontData, textures, ownsTextures);
	        BitmapFont.available[font.font] = font;
	        return font;
	    };
	    /**
	     * Remove bitmap font by name.
	     *
	     * @static
	     * @param {string} name - Name of the font to uninstall.
	     */
	    BitmapFont.uninstall = function (name) {
	        var font = BitmapFont.available[name];
	        if (!font) {
	            throw new Error("No font found named '" + name + "'");
	        }
	        font.destroy();
	        delete BitmapFont.available[name];
	    };
	    /**
	     * Generates a bitmap-font for the given style and character set. This does not support
	     * kernings yet. With `style` properties, only the following non-layout properties are used:
	     *
	     * - {@link PIXI.TextStyle#dropShadow|dropShadow}
	     * - {@link PIXI.TextStyle#dropShadowDistance|dropShadowDistance}
	     * - {@link PIXI.TextStyle#dropShadowColor|dropShadowColor}
	     * - {@link PIXI.TextStyle#dropShadowBlur|dropShadowBlur}
	     * - {@link PIXI.TextStyle#dropShadowAngle|dropShadowAngle}
	     * - {@link PIXI.TextStyle#fill|fill}
	     * - {@link PIXI.TextStyle#fillGradientStops|fillGradientStops}
	     * - {@link PIXI.TextStyle#fillGradientType|fillGradientType}
	     * - {@link PIXI.TextStyle#fontFamily|fontFamily}
	     * - {@link PIXI.TextStyle#fontSize|fontSize}
	     * - {@link PIXI.TextStyle#fontVariant|fontVariant}
	     * - {@link PIXI.TextStyle#fontWeight|fontWeight}
	     * - {@link PIXI.TextStyle#lineJoin|lineJoin}
	     * - {@link PIXI.TextStyle#miterLimit|miterLimit}
	     * - {@link PIXI.TextStyle#stroke|stroke}
	     * - {@link PIXI.TextStyle#strokeThickness|strokeThickness}
	     * - {@link PIXI.TextStyle#textBaseline|textBaseline}
	     *
	     * @param {string} name - The name of the custom font to use with BitmapText.
	     * @param {object|PIXI.TextStyle} [style] - Style options to render with BitmapFont.
	     * @param {PIXI.IBitmapFontOptions} [options] - Setup options for font or name of the font.
	     * @param {string|string[]|string[][]} [options.chars=PIXI.BitmapFont.ALPHANUMERIC] - characters included
	     *      in the font set. You can also use ranges. For example, `[['a', 'z'], ['A', 'Z'], "!@#$%^&*()~{}[] "]`.
	     *      Don't forget to include spaces ' ' in your character set!
	     * @param {number} [options.resolution=1] - Render resolution for glyphs.
	     * @param {number} [options.textureWidth=512] - Optional width of atlas, smaller values to reduce memory.
	     * @param {number} [options.textureHeight=512] - Optional height of atlas, smaller values to reduce memory.
	     * @param {number} [options.padding=4] - Padding between glyphs on texture atlas.
	     * @return {PIXI.BitmapFont} Font generated by style options.
	     * @static
	     * @example
	     * PIXI.BitmapFont.from("TitleFont", {
	     *     fontFamily: "Arial",
	     *     fontSize: 12,
	     *     strokeThickness: 2,
	     *     fill: "purple"
	     * });
	     *
	     * const title = new PIXI.BitmapText("This is the title", { fontName: "TitleFont" });
	     */
	    BitmapFont.from = function (name, textStyle, options) {
	        if (!name) {
	            throw new Error('[BitmapFont] Property `name` is required.');
	        }
	        var _a = Object.assign({}, BitmapFont.defaultOptions, options), chars = _a.chars, padding = _a.padding, resolution = _a.resolution, textureWidth = _a.textureWidth, textureHeight = _a.textureHeight;
	        var charsList = resolveCharacters(chars);
	        var style = textStyle instanceof TextStyle ? textStyle : new TextStyle(textStyle);
	        var lineWidth = textureWidth;
	        var fontData = new BitmapFontData();
	        fontData.info[0] = {
	            face: style.fontFamily,
	            size: style.fontSize,
	        };
	        fontData.common[0] = {
	            lineHeight: style.fontSize,
	        };
	        var positionX = 0;
	        var positionY = 0;
	        var canvas;
	        var context;
	        var baseTexture;
	        var maxCharHeight = 0;
	        var textures = [];
	        for (var i = 0; i < charsList.length; i++) {
	            if (!canvas) {
	                canvas = document.createElement('canvas');
	                canvas.width = textureWidth;
	                canvas.height = textureHeight;
	                context = canvas.getContext('2d');
	                baseTexture = new BaseTexture(canvas, { resolution: resolution });
	                textures.push(new Texture(baseTexture));
	                fontData.page.push({
	                    id: textures.length - 1,
	                    file: '',
	                });
	            }
	            // Measure glyph dimensions
	            var metrics = TextMetrics.measureText(charsList[i], style, false, canvas);
	            var width = metrics.width;
	            var height = Math.ceil(metrics.height);
	            // This is ugly - but italics are given more space so they don't overlap
	            var textureGlyphWidth = Math.ceil((style.fontStyle === 'italic' ? 2 : 1) * width);
	            // Can't fit char anymore: next canvas please!
	            if (positionY >= textureHeight - (height * resolution)) {
	                if (positionY === 0) {
	                    // We don't want user debugging an infinite loop (or do we? :)
	                    throw new Error("[BitmapFont] textureHeight " + textureHeight + "px is "
	                        + ("too small for " + style.fontSize + "px fonts"));
	                }
	                --i;
	                // Create new atlas once current has filled up
	                canvas = null;
	                context = null;
	                baseTexture = null;
	                positionY = 0;
	                positionX = 0;
	                maxCharHeight = 0;
	                continue;
	            }
	            maxCharHeight = Math.max(height + metrics.fontProperties.descent, maxCharHeight);
	            // Wrap line once full row has been rendered
	            if ((textureGlyphWidth * resolution) + positionX >= lineWidth) {
	                --i;
	                positionY += maxCharHeight * resolution;
	                positionY = Math.ceil(positionY);
	                positionX = 0;
	                maxCharHeight = 0;
	                continue;
	            }
	            drawGlyph(canvas, context, metrics, positionX, positionY, resolution, style);
	            // Unique (numeric) ID mapping to this glyph
	            var id = metrics.text.charCodeAt(0);
	            // Create a texture holding just the glyph
	            fontData.char.push({
	                id: id,
	                page: textures.length - 1,
	                x: positionX / resolution,
	                y: positionY / resolution,
	                width: textureGlyphWidth,
	                height: height,
	                xoffset: 0,
	                yoffset: 0,
	                xadvance: Math.ceil(width
	                    - (style.dropShadow ? style.dropShadowDistance : 0)
	                    - (style.stroke ? style.strokeThickness : 0)),
	            });
	            positionX += (textureGlyphWidth + (2 * padding)) * resolution;
	            positionX = Math.ceil(positionX);
	        }
	        var font = new BitmapFont(fontData, textures, true);
	        // Make it easier to replace a font
	        if (BitmapFont.available[name] !== undefined) {
	            BitmapFont.uninstall(name);
	        }
	        BitmapFont.available[name] = font;
	        return font;
	    };
	    /**
	     * This character set includes all the letters in the alphabet (both lower- and upper- case).
	     * @readonly
	     * @static
	     * @member {string[][]}
	     * @example
	     * BitmapFont.from("ExampleFont", style, { chars: BitmapFont.ALPHA })
	     */
	    BitmapFont.ALPHA = [['a', 'z'], ['A', 'Z'], ' '];
	    /**
	     * This character set includes all decimal digits (from 0 to 9).
	     * @readonly
	     * @static
	     * @member {string[][]}
	     * @example
	     * BitmapFont.from("ExampleFont", style, { chars: BitmapFont.NUMERIC })
	     */
	    BitmapFont.NUMERIC = [['0', '9']];
	    /**
	     * This character set is the union of `BitmapFont.ALPHA` and `BitmapFont.NUMERIC`.
	     * @readonly
	     * @static
	     * @member {string[][]}
	     */
	    BitmapFont.ALPHANUMERIC = [['a', 'z'], ['A', 'Z'], ['0', '9'], ' '];
	    /**
	     * This character set consists of all the ASCII table.
	     * @readonly
	     * @static
	     * @member {string[][]}
	     * @see http://www.asciitable.com/
	     */
	    BitmapFont.ASCII = [[' ', '~']];
	    /**
	     * Collection of default options when using `BitmapFont.from`.
	     *
	     * @readonly
	     * @static
	     * @member {PIXI.IBitmapFontOptions}
	     * @property {number} resolution=1
	     * @property {number} textureWidth=512
	     * @property {number} textureHeight=512
	     * @property {number} padding=4
	     * @property {string|string[]|string[][]} chars=PIXI.BitmapFont.ALPHANUMERIC
	     */
	    BitmapFont.defaultOptions = {
	        resolution: 1,
	        textureWidth: 512,
	        textureHeight: 512,
	        padding: 4,
	        chars: BitmapFont.ALPHANUMERIC,
	    };
	    /**
	     * Collection of available/installed fonts.
	     *
	     * @readonly
	     * @static
	     * @member {Object.<string, PIXI.BitmapFont>}
	     */
	    BitmapFont.available = {};
	    return BitmapFont;
	}());
	/**
	 * @memberof PIXI
	 * @interface IBitmapFontOptions
	 * @property {string | string[] | string[][]} [chars=PIXI.BitmapFont.ALPHANUMERIC] - the character set to generate
	 * @property {number} [resolution=1] - the resolution for rendering
	 * @property {number} [padding=4] - the padding between glyphs in the atlas
	 * @property {number} [textureWidth=512] - the width of the texture atlas
	 * @property {number} [textureHeight=512] - the height of the texture atlas
	 */

	var pageMeshDataPool = [];
	var charRenderDataPool = [];
	/**
	 * A BitmapText object will create a line or multiple lines of text using bitmap font.
	 *
	 * The primary advantage of this class over Text is that all of your textures are pre-generated and loading,
	 * meaning that rendering is fast, and changing text has no performance implications.
	 *
	 * Supporting character sets other than latin, such as CJK languages, may be impractical due to the number of characters.
	 *
	 * To split a line you can use '\n', '\r' or '\r\n' in your string.
	 *
	 * PixiJS can auto-generate fonts on-the-fly using BitmapFont or use fnt files provided by:
	 * http://www.angelcode.com/products/bmfont/ for Windows or
	 * http://www.bmglyph.com/ for Mac.
	 *
	 * A BitmapText can only be created when the font is loaded.
	 *
	 * ```js
	 * // in this case the font is in a file called 'desyrel.fnt'
	 * let bitmapText = new PIXI.BitmapText("text using a fancy font!", {font: "35px Desyrel", align: "right"});
	 * ```
	 *
	 * @class
	 * @extends PIXI.Container
	 * @memberof PIXI
	 */
	var BitmapText = /** @class */ (function (_super) {
	    __extends$b(BitmapText, _super);
	    /**
	     * @param {string} text - A string that you would like the text to display.
	     * @param {object} style - The style parameters.
	     * @param {string} style.fontName - The installed BitmapFont name.
	     * @param {number} [style.fontSize] - The size of the font in pixels, e.g. 24. If undefined,
	     *.     this will default to the BitmapFont size.
	     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'),
	     *      does not affect single line text.
	     * @param {number} [style.tint=0xFFFFFF] - The tint color.
	     * @param {number} [style.letterSpacing=0] - The amount of spacing between letters.
	     * @param {number} [style.maxWidth=0] - The max width of the text before line wrapping.
	     */
	    function BitmapText(text, style) {
	        if (style === void 0) { style = {}; }
	        var _this = _super.call(this) || this;
	        _this._tint = 0xFFFFFF;
	        if (style.font) {
	            deprecation('5.3.0', 'PIXI.BitmapText constructor style.font property is deprecated.');
	            _this._upgradeStyle(style);
	        }
	        // Apply the defaults
	        var _a = Object.assign({}, BitmapText.styleDefaults, style), align = _a.align, tint = _a.tint, maxWidth = _a.maxWidth, letterSpacing = _a.letterSpacing, fontName = _a.fontName, fontSize = _a.fontSize;
	        if (!BitmapFont.available[fontName]) {
	            throw new Error("Missing BitmapFont \"" + fontName + "\"");
	        }
	        /**
	         * Collection of page mesh data.
	         *
	         * @member {object}
	         * @private
	         */
	        _this._activePagesMeshData = [];
	        /**
	         * Private tracker for the width of the overall text
	         *
	         * @member {number}
	         * @private
	         */
	        _this._textWidth = 0;
	        /**
	         * Private tracker for the height of the overall text
	         *
	         * @member {number}
	         * @private
	         */
	        _this._textHeight = 0;
	        /**
	         * Private tracker for the current text align.
	         *
	         * @member {string}
	         * @private
	         */
	        _this._align = align;
	        /**
	         * Private tracker for the current tint.
	         *
	         * @member {number}
	         * @private
	         */
	        _this._tint = tint;
	        /**
	         * Private tracker for the current font name.
	         *
	         * @member {string}
	         * @private
	         */
	        _this._fontName = fontName;
	        /**
	         * Private tracker for the current font size.
	         *
	         * @member {number}
	         * @private
	         */
	        _this._fontSize = fontSize || BitmapFont.available[fontName].size;
	        /**
	         * Private tracker for the current text.
	         *
	         * @member {string}
	         * @private
	         */
	        _this._text = text;
	        /**
	         * The max width of this bitmap text in pixels. If the text provided is longer than the
	         * value provided, line breaks will be automatically inserted in the last whitespace.
	         * Disable by setting value to 0
	         *
	         * @member {number}
	         * @private
	         */
	        _this._maxWidth = maxWidth;
	        /**
	         * The max line height. This is useful when trying to use the total height of the Text,
	         * ie: when trying to vertically align. (Internally used)
	         *
	         * @member {number}
	         * @private
	         */
	        _this._maxLineHeight = 0;
	        /**
	         * Letter spacing. This is useful for setting the space between characters.
	         * @member {number}
	         * @private
	         */
	        _this._letterSpacing = letterSpacing;
	        /**
	         * Text anchor. read-only
	         *
	         * @member {PIXI.ObservablePoint}
	         * @private
	         */
	        _this._anchor = new ObservablePoint(function () { _this.dirty = true; }, _this, 0, 0);
	        /**
	         * If true PixiJS will Math.floor() x/y values when rendering
	         *
	         * @member {boolean}
	         * @default PIXI.settings.ROUND_PIXELS
	         */
	        _this._roundPixels = settings.ROUND_PIXELS;
	        /**
	         * Set to `true` if the BitmapText needs to be redrawn.
	         *
	         * @member {boolean}
	         */
	        _this.dirty = true;
	        /**
	         * Cached char texture is destroyed when BitmapText is destroyed
	         * @member {Record<number, Texture>}
	         * @private
	         */
	        _this._textureCache = {};
	        return _this;
	    }
	    /**
	     * Renders text and updates it when needed. This should only be called
	     * if the BitmapFont is regenerated.
	     */
	    BitmapText.prototype.updateText = function () {
	        var _a;
	        var data = BitmapFont.available[this._fontName];
	        var scale = this._fontSize / data.size;
	        var pos = new Point();
	        var chars = [];
	        var lineWidths = [];
	        var text = this._text.replace(/(?:\r\n|\r)/g, '\n') || ' ';
	        var textLength = text.length;
	        var maxWidth = this._maxWidth * data.size / this._fontSize;
	        var prevCharCode = null;
	        var lastLineWidth = 0;
	        var maxLineWidth = 0;
	        var line = 0;
	        var lastBreakPos = -1;
	        var lastBreakWidth = 0;
	        var spacesRemoved = 0;
	        var maxLineHeight = 0;
	        for (var i = 0; i < textLength; i++) {
	            var charCode = text.charCodeAt(i);
	            var char = text.charAt(i);
	            if ((/(?:\s)/).test(char)) {
	                lastBreakPos = i;
	                lastBreakWidth = lastLineWidth;
	            }
	            if (char === '\r' || char === '\n') {
	                lineWidths.push(lastLineWidth);
	                maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
	                ++line;
	                ++spacesRemoved;
	                pos.x = 0;
	                pos.y += data.lineHeight;
	                prevCharCode = null;
	                continue;
	            }
	            var charData = data.chars[charCode];
	            if (!charData) {
	                continue;
	            }
	            if (prevCharCode && charData.kerning[prevCharCode]) {
	                pos.x += charData.kerning[prevCharCode];
	            }
	            var charRenderData = charRenderDataPool.pop() || {
	                texture: Texture.EMPTY,
	                line: 0,
	                charCode: 0,
	                position: new Point(),
	            };
	            charRenderData.texture = charData.texture;
	            charRenderData.line = line;
	            charRenderData.charCode = charCode;
	            charRenderData.position.x = pos.x + charData.xOffset + (this._letterSpacing / 2);
	            charRenderData.position.y = pos.y + charData.yOffset;
	            chars.push(charRenderData);
	            pos.x += charData.xAdvance + this._letterSpacing;
	            lastLineWidth = pos.x;
	            maxLineHeight = Math.max(maxLineHeight, (charData.yOffset + charData.texture.height));
	            prevCharCode = charCode;
	            if (lastBreakPos !== -1 && maxWidth > 0 && pos.x > maxWidth) {
	                ++spacesRemoved;
	                removeItems(chars, 1 + lastBreakPos - spacesRemoved, 1 + i - lastBreakPos);
	                i = lastBreakPos;
	                lastBreakPos = -1;
	                lineWidths.push(lastBreakWidth);
	                maxLineWidth = Math.max(maxLineWidth, lastBreakWidth);
	                line++;
	                pos.x = 0;
	                pos.y += data.lineHeight;
	                prevCharCode = null;
	            }
	        }
	        var lastChar = text.charAt(text.length - 1);
	        if (lastChar !== '\r' && lastChar !== '\n') {
	            if ((/(?:\s)/).test(lastChar)) {
	                lastLineWidth = lastBreakWidth;
	            }
	            lineWidths.push(lastLineWidth);
	            maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
	        }
	        var lineAlignOffsets = [];
	        for (var i = 0; i <= line; i++) {
	            var alignOffset = 0;
	            if (this._align === 'right') {
	                alignOffset = maxLineWidth - lineWidths[i];
	            }
	            else if (this._align === 'center') {
	                alignOffset = (maxLineWidth - lineWidths[i]) / 2;
	            }
	            lineAlignOffsets.push(alignOffset);
	        }
	        var lenChars = chars.length;
	        var pagesMeshData = {};
	        var newPagesMeshData = [];
	        var activePagesMeshData = this._activePagesMeshData;
	        for (var i = 0; i < activePagesMeshData.length; i++) {
	            pageMeshDataPool.push(activePagesMeshData[i]);
	        }
	        for (var i = 0; i < lenChars; i++) {
	            var texture = chars[i].texture;
	            var baseTextureUid = texture.baseTexture.uid;
	            if (!pagesMeshData[baseTextureUid]) {
	                var pageMeshData = pageMeshDataPool.pop();
	                if (!pageMeshData) {
	                    var geometry = new MeshGeometry();
	                    var material = new MeshMaterial(Texture.EMPTY);
	                    var mesh = new Mesh(geometry, material);
	                    pageMeshData = {
	                        index: 0,
	                        indexCount: 0,
	                        vertexCount: 0,
	                        uvsCount: 0,
	                        total: 0,
	                        mesh: mesh,
	                        vertices: null,
	                        uvs: null,
	                        indices: null,
	                    };
	                }
	                // reset data..
	                pageMeshData.index = 0;
	                pageMeshData.indexCount = 0;
	                pageMeshData.vertexCount = 0;
	                pageMeshData.uvsCount = 0;
	                pageMeshData.total = 0;
	                // TODO need to get page texture here somehow..
	                var _textureCache = this._textureCache;
	                _textureCache[baseTextureUid] = _textureCache[baseTextureUid] || new Texture(texture.baseTexture);
	                pageMeshData.mesh.texture = _textureCache[baseTextureUid];
	                pageMeshData.mesh.tint = this._tint;
	                newPagesMeshData.push(pageMeshData);
	                pagesMeshData[baseTextureUid] = pageMeshData;
	            }
	            pagesMeshData[baseTextureUid].total++;
	        }
	        // lets find any previously active pageMeshDatas that are no longer required for
	        // the updated text (if any), removed and return them to the pool.
	        for (var i = 0; i < activePagesMeshData.length; i++) {
	            if (newPagesMeshData.indexOf(activePagesMeshData[i]) === -1) {
	                this.removeChild(activePagesMeshData[i].mesh);
	            }
	        }
	        // next lets add any new meshes, that have not yet been added to this BitmapText
	        // we only add if its not already a child of this BitmapObject
	        for (var i = 0; i < newPagesMeshData.length; i++) {
	            if (newPagesMeshData[i].mesh.parent !== this) {
	                this.addChild(newPagesMeshData[i].mesh);
	            }
	        }
	        // active page mesh datas are set to be the new pages added.
	        this._activePagesMeshData = newPagesMeshData;
	        for (var i in pagesMeshData) {
	            var pageMeshData = pagesMeshData[i];
	            var total = pageMeshData.total;
	            // lets only allocate new buffers if we can fit the new text in the current ones..
	            // unless that is, we will be batching. Currently batching dose not respect the size property of mesh
	            if (!(((_a = pageMeshData.indices) === null || _a === void 0 ? void 0 : _a.length) > 6 * total) || pageMeshData.vertices.length < Mesh.BATCHABLE_SIZE * 2) {
	                pageMeshData.vertices = new Float32Array(4 * 2 * total);
	                pageMeshData.uvs = new Float32Array(4 * 2 * total);
	                pageMeshData.indices = new Uint16Array(6 * total);
	            }
	            else {
	                var total_1 = pageMeshData.total;
	                var vertices = pageMeshData.vertices;
	                // Clear the garbage at the end of the vertices buffer. This will prevent the bounds miscalculation.
	                for (var i_1 = total_1 * 4 * 2; i_1 < vertices.length; i_1++) {
	                    vertices[i_1] = 0;
	                }
	            }
	            // as a buffer maybe bigger than the current word, we set the size of the meshMaterial
	            // to match the number of letters needed
	            pageMeshData.mesh.size = 6 * total;
	        }
	        for (var i = 0; i < lenChars; i++) {
	            var char = chars[i];
	            var offset = char.position.x + lineAlignOffsets[char.line];
	            if (this._roundPixels) {
	                offset = Math.round(offset);
	            }
	            var xPos = offset * scale;
	            var yPos = char.position.y * scale;
	            var texture = char.texture;
	            var pageMesh = pagesMeshData[texture.baseTexture.uid];
	            var textureFrame = texture.frame;
	            var textureUvs = texture._uvs;
	            var index = pageMesh.index++;
	            pageMesh.indices[(index * 6) + 0] = 0 + (index * 4);
	            pageMesh.indices[(index * 6) + 1] = 1 + (index * 4);
	            pageMesh.indices[(index * 6) + 2] = 2 + (index * 4);
	            pageMesh.indices[(index * 6) + 3] = 0 + (index * 4);
	            pageMesh.indices[(index * 6) + 4] = 2 + (index * 4);
	            pageMesh.indices[(index * 6) + 5] = 3 + (index * 4);
	            pageMesh.vertices[(index * 8) + 0] = xPos;
	            pageMesh.vertices[(index * 8) + 1] = yPos;
	            pageMesh.vertices[(index * 8) + 2] = xPos + (textureFrame.width * scale);
	            pageMesh.vertices[(index * 8) + 3] = yPos;
	            pageMesh.vertices[(index * 8) + 4] = xPos + (textureFrame.width * scale);
	            pageMesh.vertices[(index * 8) + 5] = yPos + (textureFrame.height * scale);
	            pageMesh.vertices[(index * 8) + 6] = xPos;
	            pageMesh.vertices[(index * 8) + 7] = yPos + (textureFrame.height * scale);
	            pageMesh.uvs[(index * 8) + 0] = textureUvs.x0;
	            pageMesh.uvs[(index * 8) + 1] = textureUvs.y0;
	            pageMesh.uvs[(index * 8) + 2] = textureUvs.x1;
	            pageMesh.uvs[(index * 8) + 3] = textureUvs.y1;
	            pageMesh.uvs[(index * 8) + 4] = textureUvs.x2;
	            pageMesh.uvs[(index * 8) + 5] = textureUvs.y2;
	            pageMesh.uvs[(index * 8) + 6] = textureUvs.x3;
	            pageMesh.uvs[(index * 8) + 7] = textureUvs.y3;
	        }
	        this._textWidth = maxLineWidth * scale;
	        this._textHeight = (pos.y + data.lineHeight) * scale;
	        for (var i in pagesMeshData) {
	            var pageMeshData = pagesMeshData[i];
	            // apply anchor
	            if (this.anchor.x !== 0 || this.anchor.y !== 0) {
	                var vertexCount = 0;
	                var anchorOffsetX = this._textWidth * this.anchor.x;
	                var anchorOffsetY = this._textHeight * this.anchor.y;
	                for (var i_2 = 0; i_2 < pageMeshData.total; i_2++) {
	                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
	                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
	                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
	                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
	                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
	                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
	                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
	                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
	                }
	            }
	            this._maxLineHeight = maxLineHeight * scale;
	            var vertexBuffer = pageMeshData.mesh.geometry.getBuffer('aVertexPosition');
	            var textureBuffer = pageMeshData.mesh.geometry.getBuffer('aTextureCoord');
	            var indexBuffer = pageMeshData.mesh.geometry.getIndex();
	            vertexBuffer.data = pageMeshData.vertices;
	            textureBuffer.data = pageMeshData.uvs;
	            indexBuffer.data = pageMeshData.indices;
	            vertexBuffer.update();
	            textureBuffer.update();
	            indexBuffer.update();
	        }
	        for (var i = 0; i < chars.length; i++) {
	            charRenderDataPool.push(chars[i]);
	        }
	    };
	    /**
	     * Updates the transform of this object
	     *
	     * @private
	     */
	    BitmapText.prototype.updateTransform = function () {
	        this.validate();
	        this.containerUpdateTransform();
	    };
	    /**
	     * Validates text before calling parent's getLocalBounds
	     *
	     * @return {PIXI.Rectangle} The rectangular bounding area
	     */
	    BitmapText.prototype.getLocalBounds = function () {
	        this.validate();
	        return _super.prototype.getLocalBounds.call(this);
	    };
	    /**
	     * Updates text when needed
	     *
	     * @private
	     */
	    BitmapText.prototype.validate = function () {
	        if (this.dirty) {
	            this.updateText();
	            this.dirty = false;
	        }
	    };
	    Object.defineProperty(BitmapText.prototype, "tint", {
	        /**
	         * The tint of the BitmapText object.
	         *
	         * @member {number}
	         * @default 0xffffff
	         */
	        get: function () {
	            return this._tint;
	        },
	        set: function (value) {
	            if (this._tint === value)
	                { return; }
	            this._tint = value;
	            for (var i = 0; i < this._activePagesMeshData.length; i++) {
	                this._activePagesMeshData[i].mesh.tint = value;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BitmapText.prototype, "align", {
	        /**
	         * The alignment of the BitmapText object.
	         *
	         * @member {string}
	         * @default 'left'
	         */
	        get: function () {
	            return this._align;
	        },
	        set: function (value) {
	            if (this._align !== value) {
	                this._align = value;
	                this.dirty = true;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BitmapText.prototype, "fontName", {
	        /**
	         * The name of the BitmapFont.
	         *
	         * @member {string}
	         */
	        get: function () {
	            return this._fontName;
	        },
	        set: function (value) {
	            if (!BitmapFont.available[value]) {
	                throw new Error("Missing BitmapFont \"" + value + "\"");
	            }
	            if (this._fontName !== value) {
	                this._fontName = value;
	                this.dirty = true;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BitmapText.prototype, "fontSize", {
	        /**
	         * The size of the font to display.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._fontSize;
	        },
	        set: function (value) {
	            if (this._fontSize !== value) {
	                this._fontSize = value;
	                this.dirty = true;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BitmapText.prototype, "anchor", {
	        /**
	         * The anchor sets the origin point of the text.
	         *
	         * The default is `(0,0)`, this means the text's origin is the top left.
	         *
	         * Setting the anchor to `(0.5,0.5)` means the text's origin is centered.
	         *
	         * Setting the anchor to `(1,1)` would mean the text's origin point will be the bottom right corner.
	         *
	         * @member {PIXI.Point | number}
	         */
	        get: function () {
	            return this._anchor;
	        },
	        set: function (value) {
	            if (typeof value === 'number') {
	                this._anchor.set(value);
	            }
	            else {
	                this._anchor.copyFrom(value);
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BitmapText.prototype, "text", {
	        /**
	         * The text of the BitmapText object.
	         *
	         * @member {string}
	         */
	        get: function () {
	            return this._text;
	        },
	        set: function (text) {
	            text = String(text === null || text === undefined ? '' : text);
	            if (this._text === text) {
	                return;
	            }
	            this._text = text;
	            this.dirty = true;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BitmapText.prototype, "maxWidth", {
	        /**
	         * The max width of this bitmap text in pixels. If the text provided is longer than the
	         * value provided, line breaks will be automatically inserted in the last whitespace.
	         * Disable by setting the value to 0.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._maxWidth;
	        },
	        set: function (value) {
	            if (this._maxWidth === value) {
	                return;
	            }
	            this._maxWidth = value;
	            this.dirty = true;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BitmapText.prototype, "maxLineHeight", {
	        /**
	         * The max line height. This is useful when trying to use the total height of the Text,
	         * i.e. when trying to vertically align.
	         *
	         * @member {number}
	         * @readonly
	         */
	        get: function () {
	            this.validate();
	            return this._maxLineHeight;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BitmapText.prototype, "textWidth", {
	        /**
	         * The width of the overall text, different from fontSize,
	         * which is defined in the style object.
	         *
	         * @member {number}
	         * @readonly
	         */
	        get: function () {
	            this.validate();
	            return this._textWidth;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BitmapText.prototype, "letterSpacing", {
	        /**
	         * Additional space between characters.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._letterSpacing;
	        },
	        set: function (value) {
	            if (this._letterSpacing !== value) {
	                this._letterSpacing = value;
	                this.dirty = true;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BitmapText.prototype, "roundPixels", {
	        /**
	         * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
	         * Advantages can include sharper image quality (like text) and faster rendering on canvas.
	         * The main disadvantage is movement of objects may appear less smooth.
	         * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
	         *
	         * @member {boolean}
	         * @default PIXI.settings.ROUND_PIXELS
	         */
	        get: function () {
	            return this._roundPixels;
	        },
	        set: function (value) {
	            if (value !== this._roundPixels) {
	                this._roundPixels = value;
	                this.dirty = true;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BitmapText.prototype, "textHeight", {
	        /**
	         * The height of the overall text, different from fontSize,
	         * which is defined in the style object.
	         *
	         * @member {number}
	         * @readonly
	         */
	        get: function () {
	            this.validate();
	            return this._textHeight;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * For backward compatibility, convert old style.font constructor param to fontName & fontSize properties.
	     *
	     * @private
	     * @deprecated since 5.3.0
	     */
	    BitmapText.prototype._upgradeStyle = function (style) {
	        if (typeof style.font === 'string') {
	            var valueSplit = style.font.split(' ');
	            style.fontName = valueSplit.length === 1
	                ? valueSplit[0]
	                : valueSplit.slice(1).join(' ');
	            if (valueSplit.length >= 2) {
	                style.fontSize = parseInt(valueSplit[0], 10);
	            }
	        }
	        else {
	            style.fontName = style.font.name;
	            style.fontSize = typeof style.font.size === 'number'
	                ? style.font.size
	                : parseInt(style.font.size, 10);
	        }
	    };
	    BitmapText.prototype.destroy = function (options) {
	        var _textureCache = this._textureCache;
	        for (var id in _textureCache) {
	            var texture = _textureCache[id];
	            texture.destroy();
	            delete _textureCache[id];
	        }
	        this._textureCache = null;
	        _super.prototype.destroy.call(this, options);
	    };
	    /**
	     * Register a bitmap font with data and a texture.
	     *
	     * @deprecated since 5.3.0
	     * @see PIXI.BitmapFont.install
	     * @static
	     */
	    BitmapText.registerFont = function (data, textures) {
	        deprecation('5.3.0', 'PIXI.BitmapText.registerFont is deprecated, use PIXI.BitmapFont.install');
	        return BitmapFont.install(data, textures);
	    };
	    Object.defineProperty(BitmapText, "fonts", {
	        /**
	         * Get the list of installed fonts.
	         *
	         * @see PIXI.BitmapFont.available
	         * @deprecated since 5.3.0
	         * @static
	         * @readonly
	         * @member {Object.<string, PIXI.BitmapFont>}
	         */
	        get: function () {
	            deprecation('5.3.0', 'PIXI.BitmapText.fonts is deprecated, use PIXI.BitmapFont.available');
	            return BitmapFont.available;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    BitmapText.styleDefaults = {
	        align: 'left',
	        tint: 0xFFFFFF,
	        maxWidth: 0,
	        letterSpacing: 0,
	    };
	    return BitmapText;
	}(Container));

	/**
	 * {@link PIXI.Loader Loader} middleware for loading
	 * bitmap-based fonts suitable for using with {@link PIXI.BitmapText}.
	 * @class
	 * @memberof PIXI
	 * @implements PIXI.ILoaderPlugin
	 */
	var BitmapFontLoader = /** @class */ (function () {
	    function BitmapFontLoader() {
	    }
	    /**
	     * Called when the plugin is installed.
	     *
	     * @see PIXI.Loader.registerPlugin
	     */
	    BitmapFontLoader.add = function () {
	        LoaderResource.setExtensionXhrType('fnt', LoaderResource.XHR_RESPONSE_TYPE.TEXT);
	    };
	    /**
	     * Called after a resource is loaded.
	     * @see PIXI.Loader.loaderMiddleware
	     * @param {PIXI.LoaderResource} resource
	     * @param {function} next
	     */
	    BitmapFontLoader.use = function (resource, next) {
	        var format = autoDetectFormat(resource.data);
	        // Resource was not recognised as any of the expected font data format
	        if (!format) {
	            next();
	            return;
	        }
	        var baseUrl = BitmapFontLoader.getBaseUrl(this, resource);
	        var data = format.parse(resource.data);
	        var textures = {};
	        // Handle completed, when the number of textures
	        // load is the same number as references in the fnt file
	        var completed = function (page) {
	            textures[page.metadata.pageFile] = page.texture;
	            if (Object.keys(textures).length === data.page.length) {
	                resource.bitmapFont = BitmapFont.install(data, textures, true);
	                next();
	            }
	        };
	        for (var i = 0; i < data.page.length; ++i) {
	            var pageFile = data.page[i].file;
	            var url = baseUrl + pageFile;
	            var exists = false;
	            // incase the image is loaded outside
	            // using the same loader, resource will be available
	            for (var name in this.resources) {
	                var bitmapResource = this.resources[name];
	                if (bitmapResource.url === url) {
	                    bitmapResource.metadata.pageFile = pageFile;
	                    if (bitmapResource.texture) {
	                        completed(bitmapResource);
	                    }
	                    else {
	                        bitmapResource.onAfterMiddleware.add(completed);
	                    }
	                    exists = true;
	                    break;
	                }
	            }
	            // texture is not loaded, we'll attempt to add
	            // it to the load and add the texture to the list
	            if (!exists) {
	                // Standard loading options for images
	                var options = {
	                    crossOrigin: resource.crossOrigin,
	                    loadType: LoaderResource.LOAD_TYPE.IMAGE,
	                    metadata: Object.assign({ pageFile: pageFile }, resource.metadata.imageMetadata),
	                    parentResource: resource,
	                };
	                this.add(url, options, completed);
	            }
	        }
	    };
	    /**
	     * Get folder path from a resource
	     * @private
	     * @param {PIXI.Loader} loader
	     * @param {PIXI.LoaderResource} resource
	     * @return {string}
	     */
	    BitmapFontLoader.getBaseUrl = function (loader, resource) {
	        var resUrl = !resource.isDataUrl ? BitmapFontLoader.dirname(resource.url) : '';
	        if (resource.isDataUrl) {
	            if (resUrl === '.') {
	                resUrl = '';
	            }
	            if (loader.baseUrl && resUrl) {
	                // if baseurl has a trailing slash then add one to resUrl so the replace works below
	                if (loader.baseUrl.charAt(loader.baseUrl.length - 1) === '/') {
	                    resUrl += '/';
	                }
	            }
	        }
	        // remove baseUrl from resUrl
	        resUrl = resUrl.replace(loader.baseUrl, '');
	        // if there is an resUrl now, it needs a trailing slash. Ensure that it does if the string isn't empty.
	        if (resUrl && resUrl.charAt(resUrl.length - 1) !== '/') {
	            resUrl += '/';
	        }
	        return resUrl;
	    };
	    /**
	     * Replacement for NodeJS's path.dirname
	     * @private
	     * @param {string} url - Path to get directory for
	     */
	    BitmapFontLoader.dirname = function (url) {
	        var dir = url
	            .replace(/\\/g, '/') // convert windows notation to UNIX notation, URL-safe because it's a forbidden character
	            .replace(/\/$/, '') // replace trailing slash
	            .replace(/\/[^\/]*$/, ''); // remove everything after the last
	        // File request is relative, use current directory
	        if (dir === url) {
	            return '.';
	        }
	        // Started with a slash
	        else if (dir === '') {
	            return '/';
	        }
	        return dir;
	    };
	    return BitmapFontLoader;
	}());

	/*!
	 * @pixi/filter-alpha - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/filter-alpha is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$c = function(d, b) {
	    extendStatics$c = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$c(d, b);
	};

	function __extends$c(d, b) {
	    extendStatics$c(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	var fragment$4 = "varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform float uAlpha;\n\nvoid main(void)\n{\n   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;\n}\n";

	/**
	 * Simplest filter - applies alpha.
	 *
	 * Use this instead of Container's alpha property to avoid visual layering of individual elements.
	 * AlphaFilter applies alpha evenly across the entire display object and any opaque elements it contains.
	 * If elements are not opaque, they will blend with each other anyway.
	 *
	 * Very handy if you want to use common features of all filters:
	 *
	 * 1. Assign a blendMode to this filter, blend all elements inside display object with background.
	 *
	 * 2. To use clipping in display coordinates, assign a filterArea to the same container that has this filter.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var AlphaFilter = /** @class */ (function (_super) {
	    __extends$c(AlphaFilter, _super);
	    /**
	     * @param {number} [alpha=1] - Amount of alpha from 0 to 1, where 0 is transparent
	     */
	    function AlphaFilter(alpha) {
	        if (alpha === void 0) { alpha = 1.0; }
	        var _this = _super.call(this, _default, fragment$4, { uAlpha: 1 }) || this;
	        _this.alpha = alpha;
	        return _this;
	    }
	    Object.defineProperty(AlphaFilter.prototype, "alpha", {
	        /**
	         * Coefficient for alpha multiplication
	         *
	         * @member {number}
	         * @default 1
	         */
	        get: function () {
	            return this.uniforms.uAlpha;
	        },
	        set: function (value) {
	            this.uniforms.uAlpha = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return AlphaFilter;
	}(Filter));

	/*!
	 * @pixi/filter-blur - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/filter-blur is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$d = function(d, b) {
	    extendStatics$d = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$d(d, b);
	};

	function __extends$d(d, b) {
	    extendStatics$d(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	var vertTemplate = "\n    attribute vec2 aVertexPosition;\n\n    uniform mat3 projectionMatrix;\n\n    uniform float strength;\n\n    varying vec2 vBlurTexCoords[%size%];\n\n    uniform vec4 inputSize;\n    uniform vec4 outputFrame;\n\n    vec4 filterVertexPosition( void )\n    {\n        vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n        return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n    }\n\n    vec2 filterTextureCoord( void )\n    {\n        return aVertexPosition * (outputFrame.zw * inputSize.zw);\n    }\n\n    void main(void)\n    {\n        gl_Position = filterVertexPosition();\n\n        vec2 textureCoord = filterTextureCoord();\n        %blur%\n    }";
	function generateBlurVertSource(kernelSize, x) {
	    var halfLength = Math.ceil(kernelSize / 2);
	    var vertSource = vertTemplate;
	    var blurLoop = '';
	    var template;
	    if (x) {
	        template = 'vBlurTexCoords[%index%] =  textureCoord + vec2(%sampleIndex% * strength, 0.0);';
	    }
	    else {
	        template = 'vBlurTexCoords[%index%] =  textureCoord + vec2(0.0, %sampleIndex% * strength);';
	    }
	    for (var i = 0; i < kernelSize; i++) {
	        var blur = template.replace('%index%', i.toString());
	        blur = blur.replace('%sampleIndex%', i - (halfLength - 1) + ".0");
	        blurLoop += blur;
	        blurLoop += '\n';
	    }
	    vertSource = vertSource.replace('%blur%', blurLoop);
	    vertSource = vertSource.replace('%size%', kernelSize.toString());
	    return vertSource;
	}

	var GAUSSIAN_VALUES = {
	    5: [0.153388, 0.221461, 0.250301],
	    7: [0.071303, 0.131514, 0.189879, 0.214607],
	    9: [0.028532, 0.067234, 0.124009, 0.179044, 0.20236],
	    11: [0.0093, 0.028002, 0.065984, 0.121703, 0.175713, 0.198596],
	    13: [0.002406, 0.009255, 0.027867, 0.065666, 0.121117, 0.174868, 0.197641],
	    15: [0.000489, 0.002403, 0.009246, 0.02784, 0.065602, 0.120999, 0.174697, 0.197448],
	};
	var fragTemplate$1 = [
	    'varying vec2 vBlurTexCoords[%size%];',
	    'uniform sampler2D uSampler;',
	    'void main(void)',
	    '{',
	    '    gl_FragColor = vec4(0.0);',
	    '    %blur%',
	    '}' ].join('\n');
	function generateBlurFragSource(kernelSize) {
	    var kernel = GAUSSIAN_VALUES[kernelSize];
	    var halfLength = kernel.length;
	    var fragSource = fragTemplate$1;
	    var blurLoop = '';
	    var template = 'gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;';
	    var value;
	    for (var i = 0; i < kernelSize; i++) {
	        var blur = template.replace('%index%', i.toString());
	        value = i;
	        if (i >= halfLength) {
	            value = kernelSize - i - 1;
	        }
	        blur = blur.replace('%value%', kernel[value].toString());
	        blurLoop += blur;
	        blurLoop += '\n';
	    }
	    fragSource = fragSource.replace('%blur%', blurLoop);
	    fragSource = fragSource.replace('%size%', kernelSize.toString());
	    return fragSource;
	}

	/**
	 * Different types of environments for WebGL.
	 *
	 * @static
	 * @memberof PIXI
	 * @name ENV
	 * @enum {number}
	 * @property {number} WEBGL_LEGACY - Used for older v1 WebGL devices. PixiJS will aim to ensure compatibility
	 *  with older / less advanced devices. If you experience unexplained flickering prefer this environment.
	 * @property {number} WEBGL - Version 1 of WebGL
	 * @property {number} WEBGL2 - Version 2 of WebGL
	 */
	var ENV;
	(function (ENV) {
	    ENV[ENV["WEBGL_LEGACY"] = 0] = "WEBGL_LEGACY";
	    ENV[ENV["WEBGL"] = 1] = "WEBGL";
	    ENV[ENV["WEBGL2"] = 2] = "WEBGL2";
	})(ENV || (ENV = {}));
	/**
	 * Constant to identify the Renderer Type.
	 *
	 * @static
	 * @memberof PIXI
	 * @name RENDERER_TYPE
	 * @enum {number}
	 * @property {number} UNKNOWN - Unknown render type.
	 * @property {number} WEBGL - WebGL render type.
	 * @property {number} CANVAS - Canvas render type.
	 */
	var RENDERER_TYPE;
	(function (RENDERER_TYPE) {
	    RENDERER_TYPE[RENDERER_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
	    RENDERER_TYPE[RENDERER_TYPE["WEBGL"] = 1] = "WEBGL";
	    RENDERER_TYPE[RENDERER_TYPE["CANVAS"] = 2] = "CANVAS";
	})(RENDERER_TYPE || (RENDERER_TYPE = {}));
	/**
	 * Bitwise OR of masks that indicate the buffers to be cleared.
	 *
	 * @static
	 * @memberof PIXI
	 * @name BUFFER_BITS
	 * @enum {number}
	 * @property {number} COLOR - Indicates the buffers currently enabled for color writing.
	 * @property {number} DEPTH - Indicates the depth buffer.
	 * @property {number} STENCIL - Indicates the stencil buffer.
	 */
	var BUFFER_BITS;
	(function (BUFFER_BITS) {
	    BUFFER_BITS[BUFFER_BITS["COLOR"] = 16384] = "COLOR";
	    BUFFER_BITS[BUFFER_BITS["DEPTH"] = 256] = "DEPTH";
	    BUFFER_BITS[BUFFER_BITS["STENCIL"] = 1024] = "STENCIL";
	})(BUFFER_BITS || (BUFFER_BITS = {}));
	/**
	 * Various blend modes supported by PIXI.
	 *
	 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
	 * Anything else will silently act like NORMAL.
	 *
	 * @memberof PIXI
	 * @name BLEND_MODES
	 * @enum {number}
	 * @property {number} NORMAL
	 * @property {number} ADD
	 * @property {number} MULTIPLY
	 * @property {number} SCREEN
	 * @property {number} OVERLAY
	 * @property {number} DARKEN
	 * @property {number} LIGHTEN
	 * @property {number} COLOR_DODGE
	 * @property {number} COLOR_BURN
	 * @property {number} HARD_LIGHT
	 * @property {number} SOFT_LIGHT
	 * @property {number} DIFFERENCE
	 * @property {number} EXCLUSION
	 * @property {number} HUE
	 * @property {number} SATURATION
	 * @property {number} COLOR
	 * @property {number} LUMINOSITY
	 * @property {number} NORMAL_NPM
	 * @property {number} ADD_NPM
	 * @property {number} SCREEN_NPM
	 * @property {number} NONE
	 * @property {number} SRC_IN
	 * @property {number} SRC_OUT
	 * @property {number} SRC_ATOP
	 * @property {number} DST_OVER
	 * @property {number} DST_IN
	 * @property {number} DST_OUT
	 * @property {number} DST_ATOP
	 * @property {number} SUBTRACT
	 * @property {number} SRC_OVER
	 * @property {number} ERASE
	 * @property {number} XOR
	 */
	var BLEND_MODES;
	(function (BLEND_MODES) {
	    BLEND_MODES[BLEND_MODES["NORMAL"] = 0] = "NORMAL";
	    BLEND_MODES[BLEND_MODES["ADD"] = 1] = "ADD";
	    BLEND_MODES[BLEND_MODES["MULTIPLY"] = 2] = "MULTIPLY";
	    BLEND_MODES[BLEND_MODES["SCREEN"] = 3] = "SCREEN";
	    BLEND_MODES[BLEND_MODES["OVERLAY"] = 4] = "OVERLAY";
	    BLEND_MODES[BLEND_MODES["DARKEN"] = 5] = "DARKEN";
	    BLEND_MODES[BLEND_MODES["LIGHTEN"] = 6] = "LIGHTEN";
	    BLEND_MODES[BLEND_MODES["COLOR_DODGE"] = 7] = "COLOR_DODGE";
	    BLEND_MODES[BLEND_MODES["COLOR_BURN"] = 8] = "COLOR_BURN";
	    BLEND_MODES[BLEND_MODES["HARD_LIGHT"] = 9] = "HARD_LIGHT";
	    BLEND_MODES[BLEND_MODES["SOFT_LIGHT"] = 10] = "SOFT_LIGHT";
	    BLEND_MODES[BLEND_MODES["DIFFERENCE"] = 11] = "DIFFERENCE";
	    BLEND_MODES[BLEND_MODES["EXCLUSION"] = 12] = "EXCLUSION";
	    BLEND_MODES[BLEND_MODES["HUE"] = 13] = "HUE";
	    BLEND_MODES[BLEND_MODES["SATURATION"] = 14] = "SATURATION";
	    BLEND_MODES[BLEND_MODES["COLOR"] = 15] = "COLOR";
	    BLEND_MODES[BLEND_MODES["LUMINOSITY"] = 16] = "LUMINOSITY";
	    BLEND_MODES[BLEND_MODES["NORMAL_NPM"] = 17] = "NORMAL_NPM";
	    BLEND_MODES[BLEND_MODES["ADD_NPM"] = 18] = "ADD_NPM";
	    BLEND_MODES[BLEND_MODES["SCREEN_NPM"] = 19] = "SCREEN_NPM";
	    BLEND_MODES[BLEND_MODES["NONE"] = 20] = "NONE";
	    BLEND_MODES[BLEND_MODES["SRC_OVER"] = 0] = "SRC_OVER";
	    BLEND_MODES[BLEND_MODES["SRC_IN"] = 21] = "SRC_IN";
	    BLEND_MODES[BLEND_MODES["SRC_OUT"] = 22] = "SRC_OUT";
	    BLEND_MODES[BLEND_MODES["SRC_ATOP"] = 23] = "SRC_ATOP";
	    BLEND_MODES[BLEND_MODES["DST_OVER"] = 24] = "DST_OVER";
	    BLEND_MODES[BLEND_MODES["DST_IN"] = 25] = "DST_IN";
	    BLEND_MODES[BLEND_MODES["DST_OUT"] = 26] = "DST_OUT";
	    BLEND_MODES[BLEND_MODES["DST_ATOP"] = 27] = "DST_ATOP";
	    BLEND_MODES[BLEND_MODES["ERASE"] = 26] = "ERASE";
	    BLEND_MODES[BLEND_MODES["SUBTRACT"] = 28] = "SUBTRACT";
	    BLEND_MODES[BLEND_MODES["XOR"] = 29] = "XOR";
	})(BLEND_MODES || (BLEND_MODES = {}));
	/**
	 * Various webgl draw modes. These can be used to specify which GL drawMode to use
	 * under certain situations and renderers.
	 *
	 * @memberof PIXI
	 * @static
	 * @name DRAW_MODES
	 * @enum {number}
	 * @property {number} POINTS
	 * @property {number} LINES
	 * @property {number} LINE_LOOP
	 * @property {number} LINE_STRIP
	 * @property {number} TRIANGLES
	 * @property {number} TRIANGLE_STRIP
	 * @property {number} TRIANGLE_FAN
	 */
	var DRAW_MODES;
	(function (DRAW_MODES) {
	    DRAW_MODES[DRAW_MODES["POINTS"] = 0] = "POINTS";
	    DRAW_MODES[DRAW_MODES["LINES"] = 1] = "LINES";
	    DRAW_MODES[DRAW_MODES["LINE_LOOP"] = 2] = "LINE_LOOP";
	    DRAW_MODES[DRAW_MODES["LINE_STRIP"] = 3] = "LINE_STRIP";
	    DRAW_MODES[DRAW_MODES["TRIANGLES"] = 4] = "TRIANGLES";
	    DRAW_MODES[DRAW_MODES["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
	    DRAW_MODES[DRAW_MODES["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
	})(DRAW_MODES || (DRAW_MODES = {}));
	/**
	 * Various GL texture/resources formats.
	 *
	 * @memberof PIXI
	 * @static
	 * @name FORMATS
	 * @enum {number}
	 * @property {number} RGBA=6408
	 * @property {number} RGB=6407
	 * @property {number} ALPHA=6406
	 * @property {number} LUMINANCE=6409
	 * @property {number} LUMINANCE_ALPHA=6410
	 * @property {number} DEPTH_COMPONENT=6402
	 * @property {number} DEPTH_STENCIL=34041
	 */
	var FORMATS;
	(function (FORMATS) {
	    FORMATS[FORMATS["RGBA"] = 6408] = "RGBA";
	    FORMATS[FORMATS["RGB"] = 6407] = "RGB";
	    FORMATS[FORMATS["ALPHA"] = 6406] = "ALPHA";
	    FORMATS[FORMATS["LUMINANCE"] = 6409] = "LUMINANCE";
	    FORMATS[FORMATS["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
	    FORMATS[FORMATS["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
	    FORMATS[FORMATS["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
	})(FORMATS || (FORMATS = {}));
	/**
	 * Various GL target types.
	 *
	 * @memberof PIXI
	 * @static
	 * @name TARGETS
	 * @enum {number}
	 * @property {number} TEXTURE_2D=3553
	 * @property {number} TEXTURE_CUBE_MAP=34067
	 * @property {number} TEXTURE_2D_ARRAY=35866
	 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_X=34069
	 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_X=34070
	 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Y=34071
	 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Y=34072
	 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Z=34073
	 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Z=34074
	 */
	var TARGETS;
	(function (TARGETS) {
	    TARGETS[TARGETS["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
	    TARGETS[TARGETS["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
	    TARGETS[TARGETS["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
	    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
	    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
	    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
	    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
	    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
	    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
	})(TARGETS || (TARGETS = {}));
	/**
	 * Various GL data format types.
	 *
	 * @memberof PIXI
	 * @static
	 * @name TYPES
	 * @enum {number}
	 * @property {number} UNSIGNED_BYTE=5121
	 * @property {number} UNSIGNED_SHORT=5123
	 * @property {number} UNSIGNED_SHORT_5_6_5=33635
	 * @property {number} UNSIGNED_SHORT_4_4_4_4=32819
	 * @property {number} UNSIGNED_SHORT_5_5_5_1=32820
	 * @property {number} FLOAT=5126
	 * @property {number} HALF_FLOAT=36193
	 */
	var TYPES;
	(function (TYPES) {
	    TYPES[TYPES["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
	    TYPES[TYPES["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
	    TYPES[TYPES["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
	    TYPES[TYPES["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
	    TYPES[TYPES["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
	    TYPES[TYPES["FLOAT"] = 5126] = "FLOAT";
	    TYPES[TYPES["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
	})(TYPES || (TYPES = {}));
	/**
	 * The scale modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
	 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
	 *
	 * @memberof PIXI
	 * @static
	 * @name SCALE_MODES
	 * @enum {number}
	 * @property {number} LINEAR Smooth scaling
	 * @property {number} NEAREST Pixelating scaling
	 */
	var SCALE_MODES;
	(function (SCALE_MODES) {
	    SCALE_MODES[SCALE_MODES["NEAREST"] = 0] = "NEAREST";
	    SCALE_MODES[SCALE_MODES["LINEAR"] = 1] = "LINEAR";
	})(SCALE_MODES || (SCALE_MODES = {}));
	/**
	 * The wrap modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
	 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
	 * If the texture is non power of two then clamp will be used regardless as WebGL can
	 * only use REPEAT if the texture is po2.
	 *
	 * This property only affects WebGL.
	 *
	 * @name WRAP_MODES
	 * @memberof PIXI
	 * @static
	 * @enum {number}
	 * @property {number} CLAMP - The textures uvs are clamped
	 * @property {number} REPEAT - The texture uvs tile and repeat
	 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
	 */
	var WRAP_MODES;
	(function (WRAP_MODES) {
	    WRAP_MODES[WRAP_MODES["CLAMP"] = 33071] = "CLAMP";
	    WRAP_MODES[WRAP_MODES["REPEAT"] = 10497] = "REPEAT";
	    WRAP_MODES[WRAP_MODES["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
	})(WRAP_MODES || (WRAP_MODES = {}));
	/**
	 * Mipmap filtering modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.MIPMAP_TEXTURES} affects default texture filtering.
	 * Mipmaps are generated for a baseTexture if its `mipmap` field is `ON`,
	 * or its `POW2` and texture dimensions are powers of 2.
	 * Due to platform restriction, `ON` option will work like `POW2` for webgl-1.
	 *
	 * This property only affects WebGL.
	 *
	 * @name MIPMAP_MODES
	 * @memberof PIXI
	 * @static
	 * @enum {number}
	 * @property {number} OFF - No mipmaps
	 * @property {number} POW2 - Generate mipmaps if texture dimensions are pow2
	 * @property {number} ON - Always generate mipmaps
	 */
	var MIPMAP_MODES;
	(function (MIPMAP_MODES) {
	    MIPMAP_MODES[MIPMAP_MODES["OFF"] = 0] = "OFF";
	    MIPMAP_MODES[MIPMAP_MODES["POW2"] = 1] = "POW2";
	    MIPMAP_MODES[MIPMAP_MODES["ON"] = 2] = "ON";
	})(MIPMAP_MODES || (MIPMAP_MODES = {}));
	/**
	 * How to treat textures with premultiplied alpha
	 *
	 * @name ALPHA_MODES
	 * @memberof PIXI
	 * @static
	 * @enum {number}
	 * @property {number} NO_PREMULTIPLIED_ALPHA - Source is not premultiplied, leave it like that.
	 *  Option for compressed and data textures that are created from typed arrays.
	 * @property {number} PREMULTIPLY_ON_UPLOAD - Source is not premultiplied, premultiply on upload.
	 *  Default option, used for all loaded images.
	 * @property {number} PREMULTIPLIED_ALPHA - Source is already premultiplied
	 *  Example: spine atlases with `_pma` suffix.
	 * @property {number} NPM - Alias for NO_PREMULTIPLIED_ALPHA.
	 * @property {number} UNPACK - Default option, alias for PREMULTIPLY_ON_UPLOAD.
	 * @property {number} PMA - Alias for PREMULTIPLIED_ALPHA.
	 */
	var ALPHA_MODES;
	(function (ALPHA_MODES) {
	    ALPHA_MODES[ALPHA_MODES["NPM"] = 0] = "NPM";
	    ALPHA_MODES[ALPHA_MODES["UNPACK"] = 1] = "UNPACK";
	    ALPHA_MODES[ALPHA_MODES["PMA"] = 2] = "PMA";
	    ALPHA_MODES[ALPHA_MODES["NO_PREMULTIPLIED_ALPHA"] = 0] = "NO_PREMULTIPLIED_ALPHA";
	    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ON_UPLOAD"] = 1] = "PREMULTIPLY_ON_UPLOAD";
	    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ALPHA"] = 2] = "PREMULTIPLY_ALPHA";
	})(ALPHA_MODES || (ALPHA_MODES = {}));
	/**
	 * How to clear renderTextures in filter
	 *
	 * @name CLEAR_MODES
	 * @memberof PIXI
	 * @static
	 * @enum {number}
	 * @property {number} BLEND - Preserve the information in the texture, blend above
	 * @property {number} CLEAR - Must use `gl.clear` operation
	 * @property {number} BLIT - Clear or blit it, depends on device and level of paranoia
	 * @property {number} NO - Alias for BLEND, same as `false` in earlier versions
	 * @property {number} YES - Alias for CLEAR, same as `true` in earlier versions
	 * @property {number} AUTO - Alias for BLIT
	 */
	var CLEAR_MODES;
	(function (CLEAR_MODES) {
	    CLEAR_MODES[CLEAR_MODES["NO"] = 0] = "NO";
	    CLEAR_MODES[CLEAR_MODES["YES"] = 1] = "YES";
	    CLEAR_MODES[CLEAR_MODES["AUTO"] = 2] = "AUTO";
	    CLEAR_MODES[CLEAR_MODES["BLEND"] = 0] = "BLEND";
	    CLEAR_MODES[CLEAR_MODES["CLEAR"] = 1] = "CLEAR";
	    CLEAR_MODES[CLEAR_MODES["BLIT"] = 2] = "BLIT";
	})(CLEAR_MODES || (CLEAR_MODES = {}));
	/**
	 * The gc modes that are supported by pixi.
	 *
	 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
	 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
	 * used for a specified period of time they will be removed from the GPU. They will of course
	 * be uploaded again when they are required. This is a silent behind the scenes process that
	 * should ensure that the GPU does not  get filled up.
	 *
	 * Handy for mobile devices!
	 * This property only affects WebGL.
	 *
	 * @name GC_MODES
	 * @enum {number}
	 * @static
	 * @memberof PIXI
	 * @property {number} AUTO - Garbage collection will happen periodically automatically
	 * @property {number} MANUAL - Garbage collection will need to be called manually
	 */
	var GC_MODES;
	(function (GC_MODES) {
	    GC_MODES[GC_MODES["AUTO"] = 0] = "AUTO";
	    GC_MODES[GC_MODES["MANUAL"] = 1] = "MANUAL";
	})(GC_MODES || (GC_MODES = {}));
	/**
	 * Constants that specify float precision in shaders.
	 *
	 * @name PRECISION
	 * @memberof PIXI
	 * @constant
	 * @static
	 * @enum {string}
	 * @property {string} LOW='lowp'
	 * @property {string} MEDIUM='mediump'
	 * @property {string} HIGH='highp'
	 */
	var PRECISION;
	(function (PRECISION) {
	    PRECISION["LOW"] = "lowp";
	    PRECISION["MEDIUM"] = "mediump";
	    PRECISION["HIGH"] = "highp";
	})(PRECISION || (PRECISION = {}));
	/**
	 * Constants for mask implementations.
	 * We use `type` suffix because it leads to very different behaviours
	 *
	 * @name MASK_TYPES
	 * @memberof PIXI
	 * @static
	 * @enum {number}
	 * @property {number} NONE - Mask is ignored
	 * @property {number} SCISSOR - Scissor mask, rectangle on screen, cheap
	 * @property {number} STENCIL - Stencil mask, 1-bit, medium, works only if renderer supports stencil
	 * @property {number} SPRITE - Mask that uses SpriteMaskFilter, uses temporary RenderTexture
	 */
	var MASK_TYPES;
	(function (MASK_TYPES) {
	    MASK_TYPES[MASK_TYPES["NONE"] = 0] = "NONE";
	    MASK_TYPES[MASK_TYPES["SCISSOR"] = 1] = "SCISSOR";
	    MASK_TYPES[MASK_TYPES["STENCIL"] = 2] = "STENCIL";
	    MASK_TYPES[MASK_TYPES["SPRITE"] = 3] = "SPRITE";
	})(MASK_TYPES || (MASK_TYPES = {}));
	/**
	 * Constants for multi-sampling antialiasing.
	 *
	 * @see PIXI.Framebuffer#multisample
	 *
	 * @name MSAA_QUALITY
	 * @memberof PIXI
	 * @static
	 * @enum {number}
	 * @property {number} NONE - No multisampling for this renderTexture
	 * @property {number} LOW - Try 2 samples
	 * @property {number} MEDIUM - Try 4 samples
	 * @property {number} HIGH - Try 8 samples
	 */
	var MSAA_QUALITY;
	(function (MSAA_QUALITY) {
	    MSAA_QUALITY[MSAA_QUALITY["NONE"] = 0] = "NONE";
	    MSAA_QUALITY[MSAA_QUALITY["LOW"] = 2] = "LOW";
	    MSAA_QUALITY[MSAA_QUALITY["MEDIUM"] = 4] = "MEDIUM";
	    MSAA_QUALITY[MSAA_QUALITY["HIGH"] = 8] = "HIGH";
	})(MSAA_QUALITY || (MSAA_QUALITY = {}));

	/**
	 * The BlurFilterPass applies a horizontal or vertical Gaussian blur to an object.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var BlurFilterPass = /** @class */ (function (_super) {
	    __extends$d(BlurFilterPass, _super);
	    /**
	     * @param {boolean} horizontal - Do pass along the x-axis (`true`) or y-axis (`false`).
	     * @param {number} [strength=8] - The strength of the blur filter.
	     * @param {number} [quality=4] - The quality of the blur filter.
	     * @param {number} [resolution=PIXI.settings.FILTER_RESOLUTION] - The resolution of the blur filter.
	     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
	     */
	    function BlurFilterPass(horizontal, strength, quality, resolution, kernelSize) {
	        if (strength === void 0) { strength = 8; }
	        if (quality === void 0) { quality = 4; }
	        if (resolution === void 0) { resolution = settings.FILTER_RESOLUTION; }
	        if (kernelSize === void 0) { kernelSize = 5; }
	        var _this = this;
	        var vertSrc = generateBlurVertSource(kernelSize, horizontal);
	        var fragSrc = generateBlurFragSource(kernelSize);
	        _this = _super.call(this, 
	        // vertex shader
	        vertSrc, 
	        // fragment shader
	        fragSrc) || this;
	        _this.horizontal = horizontal;
	        _this.resolution = resolution;
	        _this._quality = 0;
	        _this.quality = quality;
	        _this.blur = strength;
	        return _this;
	    }
	    /**
	     * Applies the filter.
	     *
	     * @param {PIXI.systems.FilterSystem} filterManager - The manager.
	     * @param {PIXI.RenderTexture} input - The input target.
	     * @param {PIXI.RenderTexture} output - The output target.
	     * @param {PIXI.CLEAR_MODES} clearMode - How to clear
	     */
	    BlurFilterPass.prototype.apply = function (filterManager, input, output, clearMode) {
	        if (output) {
	            if (this.horizontal) {
	                this.uniforms.strength = (1 / output.width) * (output.width / input.width);
	            }
	            else {
	                this.uniforms.strength = (1 / output.height) * (output.height / input.height);
	            }
	        }
	        else {
	            if (this.horizontal) // eslint-disable-line
	             {
	                this.uniforms.strength = (1 / filterManager.renderer.width) * (filterManager.renderer.width / input.width);
	            }
	            else {
	                this.uniforms.strength = (1 / filterManager.renderer.height) * (filterManager.renderer.height / input.height); // eslint-disable-line
	            }
	        }
	        // screen space!
	        this.uniforms.strength *= this.strength;
	        this.uniforms.strength /= this.passes;
	        if (this.passes === 1) {
	            filterManager.applyFilter(this, input, output, clearMode);
	        }
	        else {
	            var renderTarget = filterManager.getFilterTexture();
	            var renderer = filterManager.renderer;
	            var flip = input;
	            var flop = renderTarget;
	            this.state.blend = false;
	            filterManager.applyFilter(this, flip, flop, CLEAR_MODES.CLEAR);
	            for (var i = 1; i < this.passes - 1; i++) {
	                filterManager.bindAndClear(flip, CLEAR_MODES.BLIT);
	                this.uniforms.uSampler = flop;
	                var temp = flop;
	                flop = flip;
	                flip = temp;
	                renderer.shader.bind(this);
	                renderer.geometry.draw(5);
	            }
	            this.state.blend = true;
	            filterManager.applyFilter(this, flop, output, clearMode);
	            filterManager.returnFilterTexture(renderTarget);
	        }
	    };
	    Object.defineProperty(BlurFilterPass.prototype, "blur", {
	        /**
	         * Sets the strength of both the blur.
	         *
	         * @member {number}
	         * @default 16
	         */
	        get: function () {
	            return this.strength;
	        },
	        set: function (value) {
	            this.padding = 1 + (Math.abs(value) * 2);
	            this.strength = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BlurFilterPass.prototype, "quality", {
	        /**
	         * Sets the quality of the blur by modifying the number of passes. More passes means higher
	         * quaility bluring but the lower the performance.
	         *
	         * @member {number}
	         * @default 4
	         */
	        get: function () {
	            return this._quality;
	        },
	        set: function (value) {
	            this._quality = value;
	            this.passes = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return BlurFilterPass;
	}(Filter));

	/**
	 * The BlurFilter applies a Gaussian blur to an object.
	 *
	 * The strength of the blur can be set for the x-axis and y-axis separately.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var BlurFilter = /** @class */ (function (_super) {
	    __extends$d(BlurFilter, _super);
	    /**
	     * @param {number} [strength=8] - The strength of the blur filter.
	     * @param {number} [quality=4] - The quality of the blur filter.
	     * @param {number} [resolution=PIXI.settings.FILTER_RESOLUTION] - The resolution of the blur filter.
	     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
	     */
	    function BlurFilter(strength, quality, resolution, kernelSize) {
	        if (strength === void 0) { strength = 8; }
	        if (quality === void 0) { quality = 4; }
	        if (resolution === void 0) { resolution = settings.FILTER_RESOLUTION; }
	        if (kernelSize === void 0) { kernelSize = 5; }
	        var _this = _super.call(this) || this;
	        _this.blurXFilter = new BlurFilterPass(true, strength, quality, resolution, kernelSize);
	        _this.blurYFilter = new BlurFilterPass(false, strength, quality, resolution, kernelSize);
	        _this.resolution = resolution;
	        _this.quality = quality;
	        _this.blur = strength;
	        _this.repeatEdgePixels = false;
	        return _this;
	    }
	    /**
	     * Applies the filter.
	     *
	     * @param {PIXI.systems.FilterSystem} filterManager - The manager.
	     * @param {PIXI.RenderTexture} input - The input target.
	     * @param {PIXI.RenderTexture} output - The output target.
	     * @param {PIXI.CLEAR_MODES} clearMode - How to clear
	     */
	    BlurFilter.prototype.apply = function (filterManager, input, output, clearMode) {
	        var xStrength = Math.abs(this.blurXFilter.strength);
	        var yStrength = Math.abs(this.blurYFilter.strength);
	        if (xStrength && yStrength) {
	            var renderTarget = filterManager.getFilterTexture();
	            this.blurXFilter.apply(filterManager, input, renderTarget, CLEAR_MODES.CLEAR);
	            this.blurYFilter.apply(filterManager, renderTarget, output, clearMode);
	            filterManager.returnFilterTexture(renderTarget);
	        }
	        else if (yStrength) {
	            this.blurYFilter.apply(filterManager, input, output, clearMode);
	        }
	        else {
	            this.blurXFilter.apply(filterManager, input, output, clearMode);
	        }
	    };
	    BlurFilter.prototype.updatePadding = function () {
	        if (this._repeatEdgePixels) {
	            this.padding = 0;
	        }
	        else {
	            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
	        }
	    };
	    Object.defineProperty(BlurFilter.prototype, "blur", {
	        /**
	         * Sets the strength of both the blurX and blurY properties simultaneously
	         *
	         * @member {number}
	         * @default 2
	         */
	        get: function () {
	            return this.blurXFilter.blur;
	        },
	        set: function (value) {
	            this.blurXFilter.blur = this.blurYFilter.blur = value;
	            this.updatePadding();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BlurFilter.prototype, "quality", {
	        /**
	         * Sets the number of passes for blur. More passes means higher quaility bluring.
	         *
	         * @member {number}
	         * @default 1
	         */
	        get: function () {
	            return this.blurXFilter.quality;
	        },
	        set: function (value) {
	            this.blurXFilter.quality = this.blurYFilter.quality = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BlurFilter.prototype, "blurX", {
	        /**
	         * Sets the strength of the blurX property
	         *
	         * @member {number}
	         * @default 2
	         */
	        get: function () {
	            return this.blurXFilter.blur;
	        },
	        set: function (value) {
	            this.blurXFilter.blur = value;
	            this.updatePadding();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BlurFilter.prototype, "blurY", {
	        /**
	         * Sets the strength of the blurY property
	         *
	         * @member {number}
	         * @default 2
	         */
	        get: function () {
	            return this.blurYFilter.blur;
	        },
	        set: function (value) {
	            this.blurYFilter.blur = value;
	            this.updatePadding();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BlurFilter.prototype, "blendMode", {
	        /**
	         * Sets the blendmode of the filter
	         *
	         * @member {number}
	         * @default PIXI.BLEND_MODES.NORMAL
	         */
	        get: function () {
	            return this.blurYFilter.blendMode;
	        },
	        set: function (value) {
	            this.blurYFilter.blendMode = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(BlurFilter.prototype, "repeatEdgePixels", {
	        /**
	         * If set to true the edge of the target will be clamped
	         *
	         * @member {boolean}
	         * @default false
	         */
	        get: function () {
	            return this._repeatEdgePixels;
	        },
	        set: function (value) {
	            this._repeatEdgePixels = value;
	            this.updatePadding();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return BlurFilter;
	}(Filter));

	/*!
	 * @pixi/filter-color-matrix - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/filter-color-matrix is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$e = function(d, b) {
	    extendStatics$e = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$e(d, b);
	};

	function __extends$e(d, b) {
	    extendStatics$e(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	var fragment$5 = "varying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform float m[20];\nuniform float uAlpha;\n\nvoid main(void)\n{\n    vec4 c = texture2D(uSampler, vTextureCoord);\n\n    if (uAlpha == 0.0) {\n        gl_FragColor = c;\n        return;\n    }\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (c.a > 0.0) {\n      c.rgb /= c.a;\n    }\n\n    vec4 result;\n\n    result.r = (m[0] * c.r);\n        result.r += (m[1] * c.g);\n        result.r += (m[2] * c.b);\n        result.r += (m[3] * c.a);\n        result.r += m[4];\n\n    result.g = (m[5] * c.r);\n        result.g += (m[6] * c.g);\n        result.g += (m[7] * c.b);\n        result.g += (m[8] * c.a);\n        result.g += m[9];\n\n    result.b = (m[10] * c.r);\n       result.b += (m[11] * c.g);\n       result.b += (m[12] * c.b);\n       result.b += (m[13] * c.a);\n       result.b += m[14];\n\n    result.a = (m[15] * c.r);\n       result.a += (m[16] * c.g);\n       result.a += (m[17] * c.b);\n       result.a += (m[18] * c.a);\n       result.a += m[19];\n\n    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);\n\n    // Premultiply alpha again.\n    rgb *= result.a;\n\n    gl_FragColor = vec4(rgb, result.a);\n}\n";

	/**
	 * The ColorMatrixFilter class lets you apply a 5x4 matrix transformation on the RGBA
	 * color and alpha values of every pixel on your displayObject to produce a result
	 * with a new set of RGBA color and alpha values. It's pretty powerful!
	 *
	 * ```js
	 *  let colorMatrix = new PIXI.filters.ColorMatrixFilter();
	 *  container.filters = [colorMatrix];
	 *  colorMatrix.contrast(2);
	 * ```
	 * @author ClÃ©ment Chenebault <clement@goodboydigital.com>
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var ColorMatrixFilter = /** @class */ (function (_super) {
	    __extends$e(ColorMatrixFilter, _super);
	    function ColorMatrixFilter() {
	        var _this = this;
	        var uniforms = {
	            m: new Float32Array([1, 0, 0, 0, 0,
	                0, 1, 0, 0, 0,
	                0, 0, 1, 0, 0,
	                0, 0, 0, 1, 0]),
	            uAlpha: 1,
	        };
	        _this = _super.call(this, defaultFilter, fragment$5, uniforms) || this;
	        _this.alpha = 1;
	        return _this;
	    }
	    /**
	     * Transforms current matrix and set the new one
	     *
	     * @param {number[]} matrix - 5x4 matrix
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype._loadMatrix = function (matrix, multiply) {
	        if (multiply === void 0) { multiply = false; }
	        var newMatrix = matrix;
	        if (multiply) {
	            this._multiply(newMatrix, this.uniforms.m, matrix);
	            newMatrix = this._colorMatrix(newMatrix);
	        }
	        // set the new matrix
	        this.uniforms.m = newMatrix;
	    };
	    /**
	     * Multiplies two mat5's
	     *
	     * @private
	     * @param {number[]} out - 5x4 matrix the receiving matrix
	     * @param {number[]} a - 5x4 matrix the first operand
	     * @param {number[]} b - 5x4 matrix the second operand
	     * @returns {number[]} 5x4 matrix
	     */
	    ColorMatrixFilter.prototype._multiply = function (out, a, b) {
	        // Red Channel
	        out[0] = (a[0] * b[0]) + (a[1] * b[5]) + (a[2] * b[10]) + (a[3] * b[15]);
	        out[1] = (a[0] * b[1]) + (a[1] * b[6]) + (a[2] * b[11]) + (a[3] * b[16]);
	        out[2] = (a[0] * b[2]) + (a[1] * b[7]) + (a[2] * b[12]) + (a[3] * b[17]);
	        out[3] = (a[0] * b[3]) + (a[1] * b[8]) + (a[2] * b[13]) + (a[3] * b[18]);
	        out[4] = (a[0] * b[4]) + (a[1] * b[9]) + (a[2] * b[14]) + (a[3] * b[19]) + a[4];
	        // Green Channel
	        out[5] = (a[5] * b[0]) + (a[6] * b[5]) + (a[7] * b[10]) + (a[8] * b[15]);
	        out[6] = (a[5] * b[1]) + (a[6] * b[6]) + (a[7] * b[11]) + (a[8] * b[16]);
	        out[7] = (a[5] * b[2]) + (a[6] * b[7]) + (a[7] * b[12]) + (a[8] * b[17]);
	        out[8] = (a[5] * b[3]) + (a[6] * b[8]) + (a[7] * b[13]) + (a[8] * b[18]);
	        out[9] = (a[5] * b[4]) + (a[6] * b[9]) + (a[7] * b[14]) + (a[8] * b[19]) + a[9];
	        // Blue Channel
	        out[10] = (a[10] * b[0]) + (a[11] * b[5]) + (a[12] * b[10]) + (a[13] * b[15]);
	        out[11] = (a[10] * b[1]) + (a[11] * b[6]) + (a[12] * b[11]) + (a[13] * b[16]);
	        out[12] = (a[10] * b[2]) + (a[11] * b[7]) + (a[12] * b[12]) + (a[13] * b[17]);
	        out[13] = (a[10] * b[3]) + (a[11] * b[8]) + (a[12] * b[13]) + (a[13] * b[18]);
	        out[14] = (a[10] * b[4]) + (a[11] * b[9]) + (a[12] * b[14]) + (a[13] * b[19]) + a[14];
	        // Alpha Channel
	        out[15] = (a[15] * b[0]) + (a[16] * b[5]) + (a[17] * b[10]) + (a[18] * b[15]);
	        out[16] = (a[15] * b[1]) + (a[16] * b[6]) + (a[17] * b[11]) + (a[18] * b[16]);
	        out[17] = (a[15] * b[2]) + (a[16] * b[7]) + (a[17] * b[12]) + (a[18] * b[17]);
	        out[18] = (a[15] * b[3]) + (a[16] * b[8]) + (a[17] * b[13]) + (a[18] * b[18]);
	        out[19] = (a[15] * b[4]) + (a[16] * b[9]) + (a[17] * b[14]) + (a[18] * b[19]) + a[19];
	        return out;
	    };
	    /**
	     * Create a Float32 Array and normalize the offset component to 0-1
	     *
	     * @private
	     * @param {number[]} matrix - 5x4 matrix
	     * @return {number[]} 5x4 matrix with all values between 0-1
	     */
	    ColorMatrixFilter.prototype._colorMatrix = function (matrix) {
	        // Create a Float32 Array and normalize the offset component to 0-1
	        var m = new Float32Array(matrix);
	        m[4] /= 255;
	        m[9] /= 255;
	        m[14] /= 255;
	        m[19] /= 255;
	        return m;
	    };
	    /**
	     * Adjusts brightness
	     *
	     * @param {number} b - value of the brigthness (0-1, where 0 is black)
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.brightness = function (b, multiply) {
	        var matrix = [
	            b, 0, 0, 0, 0,
	            0, b, 0, 0, 0,
	            0, 0, b, 0, 0,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Set the matrices in grey scales
	     *
	     * @param {number} scale - value of the grey (0-1, where 0 is black)
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.greyscale = function (scale, multiply) {
	        var matrix = [
	            scale, scale, scale, 0, 0,
	            scale, scale, scale, 0, 0,
	            scale, scale, scale, 0, 0,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Set the black and white matrice.
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.blackAndWhite = function (multiply) {
	        var matrix = [
	            0.3, 0.6, 0.1, 0, 0,
	            0.3, 0.6, 0.1, 0, 0,
	            0.3, 0.6, 0.1, 0, 0,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Set the hue property of the color
	     *
	     * @param {number} rotation - in degrees
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.hue = function (rotation, multiply) {
	        rotation = (rotation || 0) / 180 * Math.PI;
	        var cosR = Math.cos(rotation);
	        var sinR = Math.sin(rotation);
	        var sqrt = Math.sqrt;
	        /* a good approximation for hue rotation
	         This matrix is far better than the versions with magic luminance constants
	         formerly used here, but also used in the starling framework (flash) and known from this
	         old part of the internet: quasimondo.com/archives/000565.php

	         This new matrix is based on rgb cube rotation in space. Look here for a more descriptive
	         implementation as a shader not a general matrix:
	         https://github.com/evanw/glfx.js/blob/58841c23919bd59787effc0333a4897b43835412/src/filters/adjust/huesaturation.js

	         This is the source for the code:
	         see http://stackoverflow.com/questions/8507885/shift-hue-of-an-rgb-color/8510751#8510751
	         */
	        var w = 1 / 3;
	        var sqrW = sqrt(w); // weight is
	        var a00 = cosR + ((1.0 - cosR) * w);
	        var a01 = (w * (1.0 - cosR)) - (sqrW * sinR);
	        var a02 = (w * (1.0 - cosR)) + (sqrW * sinR);
	        var a10 = (w * (1.0 - cosR)) + (sqrW * sinR);
	        var a11 = cosR + (w * (1.0 - cosR));
	        var a12 = (w * (1.0 - cosR)) - (sqrW * sinR);
	        var a20 = (w * (1.0 - cosR)) - (sqrW * sinR);
	        var a21 = (w * (1.0 - cosR)) + (sqrW * sinR);
	        var a22 = cosR + (w * (1.0 - cosR));
	        var matrix = [
	            a00, a01, a02, 0, 0,
	            a10, a11, a12, 0, 0,
	            a20, a21, a22, 0, 0,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Set the contrast matrix, increase the separation between dark and bright
	     * Increase contrast : shadows darker and highlights brighter
	     * Decrease contrast : bring the shadows up and the highlights down
	     *
	     * @param {number} amount - value of the contrast (0-1)
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.contrast = function (amount, multiply) {
	        var v = (amount || 0) + 1;
	        var o = -0.5 * (v - 1);
	        var matrix = [
	            v, 0, 0, 0, o,
	            0, v, 0, 0, o,
	            0, 0, v, 0, o,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Set the saturation matrix, increase the separation between colors
	     * Increase saturation : increase contrast, brightness, and sharpness
	     *
	     * @param {number} amount - The saturation amount (0-1)
	     * @param {boolean} [multiply] - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.saturate = function (amount, multiply) {
	        if (amount === void 0) { amount = 0; }
	        var x = (amount * 2 / 3) + 1;
	        var y = ((x - 1) * -0.5);
	        var matrix = [
	            x, y, y, 0, 0,
	            y, x, y, 0, 0,
	            y, y, x, 0, 0,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Desaturate image (remove color)
	     *
	     * Call the saturate function
	     *
	     */
	    ColorMatrixFilter.prototype.desaturate = function () {
	        this.saturate(-1);
	    };
	    /**
	     * Negative image (inverse of classic rgb matrix)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.negative = function (multiply) {
	        var matrix = [
	            -1, 0, 0, 1, 0,
	            0, -1, 0, 1, 0,
	            0, 0, -1, 1, 0,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Sepia image
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.sepia = function (multiply) {
	        var matrix = [
	            0.393, 0.7689999, 0.18899999, 0, 0,
	            0.349, 0.6859999, 0.16799999, 0, 0,
	            0.272, 0.5339999, 0.13099999, 0, 0,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.technicolor = function (multiply) {
	        var matrix = [
	            1.9125277891456083, -0.8545344976951645, -0.09155508482755585, 0, 11.793603434377337,
	            -0.3087833385928097, 1.7658908555458428, -0.10601743074722245, 0, -70.35205161461398,
	            -0.231103377548616, -0.7501899197440212, 1.847597816108189, 0, 30.950940869491138,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Polaroid filter
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.polaroid = function (multiply) {
	        var matrix = [
	            1.438, -0.062, -0.062, 0, 0,
	            -0.122, 1.378, -0.122, 0, 0,
	            -0.016, -0.016, 1.483, 0, 0,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Filter who transforms : Red -> Blue and Blue -> Red
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.toBGR = function (multiply) {
	        var matrix = [
	            0, 0, 1, 0, 0,
	            0, 1, 0, 0, 0,
	            1, 0, 0, 0, 0,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.kodachrome = function (multiply) {
	        var matrix = [
	            1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502,
	            -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203,
	            -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Brown delicious browni filter (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.browni = function (multiply) {
	        var matrix = [
	            0.5997023498159715, 0.34553243048391263, -0.2708298674538042, 0, 47.43192855600873,
	            -0.037703249837783157, 0.8609577587992641, 0.15059552388459913, 0, -36.96841498319127,
	            0.24113635128153335, -0.07441037908422492, 0.44972182064877153, 0, -7.562075277591283,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Vintage filter (thanks Dominic Szablewski)
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.vintage = function (multiply) {
	        var matrix = [
	            0.6279345635605994, 0.3202183420819367, -0.03965408211312453, 0, 9.651285835294123,
	            0.02578397704808868, 0.6441188644374771, 0.03259127616149294, 0, 7.462829176470591,
	            0.0466055556782719, -0.0851232987247891, 0.5241648018700465, 0, 5.159190588235296,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * We don't know exactly what it does, kind of gradient map, but funny to play with!
	     *
	     * @param {number} desaturation - Tone values.
	     * @param {number} toned - Tone values.
	     * @param {number} lightColor - Tone values, example: `0xFFE580`
	     * @param {number} darkColor - Tone values, example: `0xFFE580`
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.colorTone = function (desaturation, toned, lightColor, darkColor, multiply) {
	        desaturation = desaturation || 0.2;
	        toned = toned || 0.15;
	        lightColor = lightColor || 0xFFE580;
	        darkColor = darkColor || 0x338000;
	        var lR = ((lightColor >> 16) & 0xFF) / 255;
	        var lG = ((lightColor >> 8) & 0xFF) / 255;
	        var lB = (lightColor & 0xFF) / 255;
	        var dR = ((darkColor >> 16) & 0xFF) / 255;
	        var dG = ((darkColor >> 8) & 0xFF) / 255;
	        var dB = (darkColor & 0xFF) / 255;
	        var matrix = [
	            0.3, 0.59, 0.11, 0, 0,
	            lR, lG, lB, desaturation, 0,
	            dR, dG, dB, toned, 0,
	            lR - dR, lG - dG, lB - dB, 0, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Night effect
	     *
	     * @param {number} intensity - The intensity of the night effect.
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.night = function (intensity, multiply) {
	        intensity = intensity || 0.1;
	        var matrix = [
	            intensity * (-2.0), -intensity, 0, 0, 0,
	            -intensity, 0, intensity, 0, 0,
	            0, intensity, intensity * 2.0, 0, 0,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Predator effect
	     *
	     * Erase the current matrix by setting a new indepent one
	     *
	     * @param {number} amount - how much the predator feels his future victim
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.predator = function (amount, multiply) {
	        var matrix = [
	            // row 1
	            11.224130630493164 * amount,
	            -4.794486999511719 * amount,
	            -2.8746118545532227 * amount,
	            0 * amount,
	            0.40342438220977783 * amount,
	            // row 2
	            -3.6330697536468506 * amount,
	            9.193157196044922 * amount,
	            -2.951810836791992 * amount,
	            0 * amount,
	            -1.316135048866272 * amount,
	            // row 3
	            -3.2184197902679443 * amount,
	            -4.2375030517578125 * amount,
	            7.476448059082031 * amount,
	            0 * amount,
	            0.8044459223747253 * amount,
	            // row 4
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * LSD effect
	     *
	     * Multiply the current matrix
	     *
	     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
	     *  just set the current matrix with @param matrix
	     */
	    ColorMatrixFilter.prototype.lsd = function (multiply) {
	        var matrix = [
	            2, -0.4, 0.5, 0, 0,
	            -0.5, 2, -0.4, 0, 0,
	            -0.4, -0.5, 3, 0, 0,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, multiply);
	    };
	    /**
	     * Erase the current matrix by setting the default one
	     *
	     */
	    ColorMatrixFilter.prototype.reset = function () {
	        var matrix = [
	            1, 0, 0, 0, 0,
	            0, 1, 0, 0, 0,
	            0, 0, 1, 0, 0,
	            0, 0, 0, 1, 0 ];
	        this._loadMatrix(matrix, false);
	    };
	    Object.defineProperty(ColorMatrixFilter.prototype, "matrix", {
	        /**
	         * The matrix of the color matrix filter
	         *
	         * @member {number[]}
	         * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
	         */
	        get: function () {
	            return this.uniforms.m;
	        },
	        set: function (value) {
	            this.uniforms.m = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ColorMatrixFilter.prototype, "alpha", {
	        /**
	         * The opacity value to use when mixing the original and resultant colors.
	         *
	         * When the value is 0, the original color is used without modification.
	         * When the value is 1, the result color is used.
	         * When in the range (0, 1) the color is interpolated between the original and result by this amount.
	         *
	         * @member {number}
	         * @default 1
	         */
	        get: function () {
	            return this.uniforms.uAlpha;
	        },
	        set: function (value) {
	            this.uniforms.uAlpha = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return ColorMatrixFilter;
	}(Filter));
	// Americanized alias
	ColorMatrixFilter.prototype.grayscale = ColorMatrixFilter.prototype.greyscale;

	/*!
	 * @pixi/filter-displacement - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/filter-displacement is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$f = function(d, b) {
	    extendStatics$f = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$f(d, b);
	};

	function __extends$f(d, b) {
	    extendStatics$f(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	var fragment$6 = "varying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform vec2 scale;\nuniform mat2 rotation;\nuniform sampler2D uSampler;\nuniform sampler2D mapSampler;\n\nuniform highp vec4 inputSize;\nuniform vec4 inputClamp;\n\nvoid main(void)\n{\n  vec4 map =  texture2D(mapSampler, vFilterCoord);\n\n  map -= 0.5;\n  map.xy = scale * inputSize.zw * (rotation * map.xy);\n\n  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), inputClamp.xy, inputClamp.zw));\n}\n";

	var vertex$4 = "attribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\nuniform mat3 filterMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec2 vFilterCoord;\n\nuniform vec4 inputSize;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aVertexPosition * (outputFrame.zw * inputSize.zw);\n}\n\nvoid main(void)\n{\n\tgl_Position = filterVertexPosition();\n\tvTextureCoord = filterTextureCoord();\n\tvFilterCoord = ( filterMatrix * vec3( vTextureCoord, 1.0)  ).xy;\n}\n";

	/**
	 * The DisplacementFilter class uses the pixel values from the specified texture
	 * (called the displacement map) to perform a displacement of an object.
	 *
	 * You can use this filter to apply all manor of crazy warping effects.
	 * Currently the `r` property of the texture is used to offset the `x`
	 * and the `g` property of the texture is used to offset the `y`.
	 *
	 * The way it works is it uses the values of the displacement map to look up the
	 * correct pixels to output. This means it's not technically moving the original.
	 * Instead, it's starting at the output and asking "which pixel from the original goes here".
	 * For example, if a displacement map pixel has `red = 1` and the filter scale is `20`,
	 * this filter will output the pixel approximately 20 pixels to the right of the original.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var DisplacementFilter = /** @class */ (function (_super) {
	    __extends$f(DisplacementFilter, _super);
	    /**
	     * @param {PIXI.Sprite} sprite - The sprite used for the displacement map. (make sure its added to the scene!)
	     * @param {number} [scale] - The scale of the displacement
	     */
	    function DisplacementFilter(sprite, scale) {
	        var _this = this;
	        var maskMatrix = new Matrix();
	        sprite.renderable = false;
	        _this = _super.call(this, vertex$4, fragment$6, {
	            mapSampler: sprite._texture,
	            filterMatrix: maskMatrix,
	            scale: { x: 1, y: 1 },
	            rotation: new Float32Array([1, 0, 0, 1]),
	        }) || this;
	        _this.maskSprite = sprite;
	        _this.maskMatrix = maskMatrix;
	        if (scale === null || scale === undefined) {
	            scale = 20;
	        }
	        /**
	         * scaleX, scaleY for displacements
	         * @member {PIXI.Point}
	         */
	        _this.scale = new Point(scale, scale);
	        return _this;
	    }
	    /**
	     * Applies the filter.
	     *
	     * @param {PIXI.systems.FilterSystem} filterManager - The manager.
	     * @param {PIXI.RenderTexture} input - The input target.
	     * @param {PIXI.RenderTexture} output - The output target.
	     * @param {PIXI.CLEAR_MODES} clearMode - clearMode.
	     */
	    DisplacementFilter.prototype.apply = function (filterManager, input, output, clearMode) {
	        // fill maskMatrix with _normalized sprite texture coords_
	        this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite);
	        this.uniforms.scale.x = this.scale.x;
	        this.uniforms.scale.y = this.scale.y;
	        // Extract rotation from world transform
	        var wt = this.maskSprite.worldTransform;
	        var lenX = Math.sqrt((wt.a * wt.a) + (wt.b * wt.b));
	        var lenY = Math.sqrt((wt.c * wt.c) + (wt.d * wt.d));
	        if (lenX !== 0 && lenY !== 0) {
	            this.uniforms.rotation[0] = wt.a / lenX;
	            this.uniforms.rotation[1] = wt.b / lenX;
	            this.uniforms.rotation[2] = wt.c / lenY;
	            this.uniforms.rotation[3] = wt.d / lenY;
	        }
	        // draw the filter...
	        filterManager.applyFilter(this, input, output, clearMode);
	    };
	    Object.defineProperty(DisplacementFilter.prototype, "map", {
	        /**
	         * The texture used for the displacement map. Must be power of 2 sized texture.
	         *
	         * @member {PIXI.Texture}
	         */
	        get: function () {
	            return this.uniforms.mapSampler;
	        },
	        set: function (value) {
	            this.uniforms.mapSampler = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return DisplacementFilter;
	}(Filter));

	/*!
	 * @pixi/filter-fxaa - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/filter-fxaa is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$g = function(d, b) {
	    extendStatics$g = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$g(d, b);
	};

	function __extends$g(d, b) {
	    extendStatics$g(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	var vertex$5 = "\nattribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nvarying vec2 vFragCoord;\n\nuniform vec4 inputPixel;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvoid texcoords(vec2 fragCoord, vec2 inverseVP,\n               out vec2 v_rgbNW, out vec2 v_rgbNE,\n               out vec2 v_rgbSW, out vec2 v_rgbSE,\n               out vec2 v_rgbM) {\n    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;\n    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;\n    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;\n    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;\n    v_rgbM = vec2(fragCoord * inverseVP);\n}\n\nvoid main(void) {\n\n   gl_Position = filterVertexPosition();\n\n   vFragCoord = aVertexPosition * outputFrame.zw;\n\n   texcoords(vFragCoord, inputPixel.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n}\n";

	var fragment$7 = "varying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nvarying vec2 vFragCoord;\nuniform sampler2D uSampler;\nuniform highp vec4 inputPixel;\n\n\n/**\n Basic FXAA implementation based on the code on geeks3d.com with the\n modification that the texture2DLod stuff was removed since it's\n unsupported by WebGL.\n\n --\n\n From:\n https://github.com/mitsuhiko/webgl-meincraft\n\n Copyright (c) 2011 by Armin Ronacher.\n\n Some rights reserved.\n\n Redistribution and use in source and binary forms, with or without\n modification, are permitted provided that the following conditions are\n met:\n\n * Redistributions of source code must retain the above copyright\n notice, this list of conditions and the following disclaimer.\n\n * Redistributions in binary form must reproduce the above\n copyright notice, this list of conditions and the following\n disclaimer in the documentation and/or other materials provided\n with the distribution.\n\n * The names of the contributors may not be used to endorse or\n promote products derived from this software without specific\n prior written permission.\n\n THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS\n \"AS IS\" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT\n LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR\n A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT\n OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,\n SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT\n LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,\n DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY\n THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\n OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n */\n\n#ifndef FXAA_REDUCE_MIN\n#define FXAA_REDUCE_MIN   (1.0/ 128.0)\n#endif\n#ifndef FXAA_REDUCE_MUL\n#define FXAA_REDUCE_MUL   (1.0 / 8.0)\n#endif\n#ifndef FXAA_SPAN_MAX\n#define FXAA_SPAN_MAX     8.0\n#endif\n\n//optimized version for mobile, where dependent\n//texture reads can be a bottleneck\nvec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 inverseVP,\n          vec2 v_rgbNW, vec2 v_rgbNE,\n          vec2 v_rgbSW, vec2 v_rgbSE,\n          vec2 v_rgbM) {\n    vec4 color;\n    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;\n    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;\n    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;\n    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;\n    vec4 texColor = texture2D(tex, v_rgbM);\n    vec3 rgbM  = texColor.xyz;\n    vec3 luma = vec3(0.299, 0.587, 0.114);\n    float lumaNW = dot(rgbNW, luma);\n    float lumaNE = dot(rgbNE, luma);\n    float lumaSW = dot(rgbSW, luma);\n    float lumaSE = dot(rgbSE, luma);\n    float lumaM  = dot(rgbM,  luma);\n    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));\n    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));\n\n    mediump vec2 dir;\n    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));\n    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));\n\n    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *\n                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);\n\n    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);\n    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),\n              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),\n                  dir * rcpDirMin)) * inverseVP;\n\n    vec3 rgbA = 0.5 * (\n                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +\n                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);\n    vec3 rgbB = rgbA * 0.5 + 0.25 * (\n                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +\n                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);\n\n    float lumaB = dot(rgbB, luma);\n    if ((lumaB < lumaMin) || (lumaB > lumaMax))\n        color = vec4(rgbA, texColor.a);\n    else\n        color = vec4(rgbB, texColor.a);\n    return color;\n}\n\nvoid main() {\n\n      vec4 color;\n\n      color = fxaa(uSampler, vFragCoord, inputPixel.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n\n      gl_FragColor = color;\n}\n";

	/**
	 * Basic FXAA (Fast Approximate Anti-Aliasing) implementation based on the code on geeks3d.com
	 * with the modification that the texture2DLod stuff was removed since it is unsupported by WebGL.
	 *
	 * @see https://github.com/mitsuhiko/webgl-meincraft
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 *
	 */
	var FXAAFilter = /** @class */ (function (_super) {
	    __extends$g(FXAAFilter, _super);
	    function FXAAFilter() {
	        // TODO - needs work
	        return _super.call(this, vertex$5, fragment$7) || this;
	    }
	    return FXAAFilter;
	}(Filter));

	/*!
	 * @pixi/filter-noise - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/filter-noise is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$h = function(d, b) {
	    extendStatics$h = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$h(d, b);
	};

	function __extends$h(d, b) {
	    extendStatics$h(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	var fragment$8 = "precision highp float;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nuniform float uNoise;\nuniform float uSeed;\nuniform sampler2D uSampler;\n\nfloat rand(vec2 co)\n{\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main()\n{\n    vec4 color = texture2D(uSampler, vTextureCoord);\n    float randomValue = rand(gl_FragCoord.xy * uSeed);\n    float diff = (randomValue - 0.5) * uNoise;\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (color.a > 0.0) {\n        color.rgb /= color.a;\n    }\n\n    color.r += diff;\n    color.g += diff;\n    color.b += diff;\n\n    // Premultiply alpha again.\n    color.rgb *= color.a;\n\n    gl_FragColor = color;\n}\n";

	/**
	 * @author Vico @vicocotea
	 * original filter: https://github.com/evanw/glfx.js/blob/master/src/filters/adjust/noise.js
	 */
	/**
	 * A Noise effect filter.
	 *
	 * @class
	 * @extends PIXI.Filter
	 * @memberof PIXI.filters
	 */
	var NoiseFilter = /** @class */ (function (_super) {
	    __extends$h(NoiseFilter, _super);
	    /**
	     * @param {number} [noise=0.5] - The noise intensity, should be a normalized value in the range [0, 1].
	     * @param {number} [seed] - A random seed for the noise generation. Default is `Math.random()`.
	     */
	    function NoiseFilter(noise, seed) {
	        if (noise === void 0) { noise = 0.5; }
	        if (seed === void 0) { seed = Math.random(); }
	        var _this = _super.call(this, defaultFilter, fragment$8, {
	            uNoise: 0,
	            uSeed: 0,
	        }) || this;
	        _this.noise = noise;
	        _this.seed = seed;
	        return _this;
	    }
	    Object.defineProperty(NoiseFilter.prototype, "noise", {
	        /**
	         * The amount of noise to apply, this value should be in the range (0, 1].
	         *
	         * @member {number}
	         * @default 0.5
	         */
	        get: function () {
	            return this.uniforms.uNoise;
	        },
	        set: function (value) {
	            this.uniforms.uNoise = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(NoiseFilter.prototype, "seed", {
	        /**
	         * A seed value to apply to the random noise generation. `Math.random()` is a good value to use.
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this.uniforms.uSeed;
	        },
	        set: function (value) {
	            this.uniforms.uSeed = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return NoiseFilter;
	}(Filter));

	/*!
	 * @pixi/mixin-cache-as-bitmap - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/mixin-cache-as-bitmap is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	var _tempMatrix = new Matrix();
	DisplayObject.prototype._cacheAsBitmap = false;
	DisplayObject.prototype._cacheData = null;
	// figured there's no point adding ALL the extra variables to prototype.
	// this model can hold the information needed. This can also be generated on demand as
	// most objects are not cached as bitmaps.
	/**
	 * @class
	 * @ignore
	 */
	var CacheData = /** @class */ (function () {
	    function CacheData() {
	        this.textureCacheId = null;
	        this.originalRender = null;
	        this.originalRenderCanvas = null;
	        this.originalCalculateBounds = null;
	        this.originalGetLocalBounds = null;
	        this.originalUpdateTransform = null;
	        this.originalDestroy = null;
	        this.originalMask = null;
	        this.originalFilterArea = null;
	        this.originalContainsPoint = null;
	        this.sprite = null;
	    }
	    return CacheData;
	}());
	Object.defineProperties(DisplayObject.prototype, {
	    /**
	     * Set this to true if you want this display object to be cached as a bitmap.
	     * This basically takes a snap shot of the display object as it is at that moment. It can
	     * provide a performance benefit for complex static displayObjects.
	     * To remove simply set this property to `false`
	     *
	     * IMPORTANT GOTCHA - Make sure that all your textures are preloaded BEFORE setting this property to true
	     * as it will take a snapshot of what is currently there. If the textures have not loaded then they will not appear.
	     *
	     * @member {boolean}
	     * @memberof PIXI.DisplayObject#
	     */
	    cacheAsBitmap: {
	        get: function () {
	            return this._cacheAsBitmap;
	        },
	        set: function (value) {
	            if (this._cacheAsBitmap === value) {
	                return;
	            }
	            this._cacheAsBitmap = value;
	            var data;
	            if (value) {
	                if (!this._cacheData) {
	                    this._cacheData = new CacheData();
	                }
	                data = this._cacheData;
	                data.originalRender = this.render;
	                data.originalRenderCanvas = this.renderCanvas;
	                data.originalUpdateTransform = this.updateTransform;
	                data.originalCalculateBounds = this.calculateBounds;
	                data.originalGetLocalBounds = this.getLocalBounds;
	                data.originalDestroy = this.destroy;
	                data.originalContainsPoint = this.containsPoint;
	                data.originalMask = this._mask;
	                data.originalFilterArea = this.filterArea;
	                this.render = this._renderCached;
	                this.renderCanvas = this._renderCachedCanvas;
	                this.destroy = this._cacheAsBitmapDestroy;
	            }
	            else {
	                data = this._cacheData;
	                if (data.sprite) {
	                    this._destroyCachedDisplayObject();
	                }
	                this.render = data.originalRender;
	                this.renderCanvas = data.originalRenderCanvas;
	                this.calculateBounds = data.originalCalculateBounds;
	                this.getLocalBounds = data.originalGetLocalBounds;
	                this.destroy = data.originalDestroy;
	                this.updateTransform = data.originalUpdateTransform;
	                this.containsPoint = data.originalContainsPoint;
	                this._mask = data.originalMask;
	                this.filterArea = data.originalFilterArea;
	            }
	        },
	    },
	});
	/**
	 * Renders a cached version of the sprite with WebGL
	 *
	 * @private
	 * @function _renderCached
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.Renderer} renderer - the WebGL renderer
	 */
	DisplayObject.prototype._renderCached = function _renderCached(renderer) {
	    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	        return;
	    }
	    this._initCachedDisplayObject(renderer);
	    this._cacheData.sprite.transform._worldID = this.transform._worldID;
	    this._cacheData.sprite.worldAlpha = this.worldAlpha;
	    this._cacheData.sprite._render(renderer);
	};
	/**
	 * Prepares the WebGL renderer to cache the sprite
	 *
	 * @private
	 * @function _initCachedDisplayObject
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.Renderer} renderer - the WebGL renderer
	 */
	DisplayObject.prototype._initCachedDisplayObject = function _initCachedDisplayObject(renderer) {
	    if (this._cacheData && this._cacheData.sprite) {
	        return;
	    }
	    // make sure alpha is set to 1 otherwise it will get rendered as invisible!
	    var cacheAlpha = this.alpha;
	    this.alpha = 1;
	    // first we flush anything left in the renderer (otherwise it would get rendered to the cached texture)
	    renderer.batch.flush();
	    // this.filters= [];
	    // next we find the dimensions of the untransformed object
	    // this function also calls updatetransform on all its children as part of the measuring.
	    // This means we don't need to update the transform again in this function
	    // TODO pass an object to clone too? saves having to create a new one each time!
	    var bounds = this.getLocalBounds(null, true).clone();
	    // add some padding!
	    if (this.filters) {
	        var padding = this.filters[0].padding;
	        bounds.pad(padding);
	    }
	    bounds.ceil(settings.RESOLUTION);
	    // for now we cache the current renderTarget that the WebGL renderer is currently using.
	    // this could be more elegant..
	    var cachedRenderTexture = renderer.renderTexture.current;
	    var cachedSourceFrame = renderer.renderTexture.sourceFrame.clone();
	    var cachedDestinationFrame = renderer.renderTexture.destinationFrame.clone();
	    var cachedProjectionTransform = renderer.projection.transform;
	    // We also store the filter stack - I will definitely look to change how this works a little later down the line.
	    // const stack = renderer.filterManager.filterStack;
	    // this renderTexture will be used to store the cached DisplayObject
	    var renderTexture = RenderTexture.create({ width: bounds.width, height: bounds.height });
	    var textureCacheId = "cacheAsBitmap_" + uid();
	    this._cacheData.textureCacheId = textureCacheId;
	    BaseTexture.addToCache(renderTexture.baseTexture, textureCacheId);
	    Texture.addToCache(renderTexture, textureCacheId);
	    // need to set //
	    var m = this.transform.localTransform.copyTo(_tempMatrix).invert().translate(-bounds.x, -bounds.y);
	    // set all properties to there original so we can render to a texture
	    this.render = this._cacheData.originalRender;
	    renderer.render(this, renderTexture, true, m, false);
	    // now restore the state be setting the new properties
	    renderer.projection.transform = cachedProjectionTransform;
	    renderer.renderTexture.bind(cachedRenderTexture, cachedSourceFrame, cachedDestinationFrame);
	    // renderer.filterManager.filterStack = stack;
	    this.render = this._renderCached;
	    // the rest is the same as for Canvas
	    this.updateTransform = this.displayObjectUpdateTransform;
	    this.calculateBounds = this._calculateCachedBounds;
	    this.getLocalBounds = this._getCachedLocalBounds;
	    this._mask = null;
	    this.filterArea = null;
	    // create our cached sprite
	    var cachedSprite = new Sprite(renderTexture);
	    cachedSprite.transform.worldTransform = this.transform.worldTransform;
	    cachedSprite.anchor.x = -(bounds.x / bounds.width);
	    cachedSprite.anchor.y = -(bounds.y / bounds.height);
	    cachedSprite.alpha = cacheAlpha;
	    cachedSprite._bounds = this._bounds;
	    this._cacheData.sprite = cachedSprite;
	    this.transform._parentID = -1;
	    // restore the transform of the cached sprite to avoid the nasty flicker..
	    if (!this.parent) {
	        this.enableTempParent();
	        this.updateTransform();
	        this.disableTempParent(null);
	    }
	    else {
	        this.updateTransform();
	    }
	    // map the hit test..
	    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
	};
	/**
	 * Renders a cached version of the sprite with canvas
	 *
	 * @private
	 * @function _renderCachedCanvas
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.CanvasRenderer} renderer - The canvas renderer
	 */
	DisplayObject.prototype._renderCachedCanvas = function _renderCachedCanvas(renderer) {
	    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	        return;
	    }
	    this._initCachedDisplayObjectCanvas(renderer);
	    this._cacheData.sprite.worldAlpha = this.worldAlpha;
	    this._cacheData.sprite._renderCanvas(renderer);
	};
	// TODO this can be the same as the WebGL version.. will need to do a little tweaking first though..
	/**
	 * Prepares the Canvas renderer to cache the sprite
	 *
	 * @private
	 * @function _initCachedDisplayObjectCanvas
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.CanvasRenderer} renderer - The canvas renderer
	 */
	DisplayObject.prototype._initCachedDisplayObjectCanvas = function _initCachedDisplayObjectCanvas(renderer) {
	    if (this._cacheData && this._cacheData.sprite) {
	        return;
	    }
	    // get bounds actually transforms the object for us already!
	    var bounds = this.getLocalBounds(null, true);
	    var cacheAlpha = this.alpha;
	    this.alpha = 1;
	    var cachedRenderTarget = renderer.context;
	    var cachedProjectionTransform = renderer._projTransform;
	    bounds.ceil(settings.RESOLUTION);
	    var renderTexture = RenderTexture.create({ width: bounds.width, height: bounds.height });
	    var textureCacheId = "cacheAsBitmap_" + uid();
	    this._cacheData.textureCacheId = textureCacheId;
	    BaseTexture.addToCache(renderTexture.baseTexture, textureCacheId);
	    Texture.addToCache(renderTexture, textureCacheId);
	    // need to set //
	    var m = _tempMatrix;
	    this.transform.localTransform.copyTo(m);
	    m.invert();
	    m.tx -= bounds.x;
	    m.ty -= bounds.y;
	    // m.append(this.transform.worldTransform.)
	    // set all properties to there original so we can render to a texture
	    this.renderCanvas = this._cacheData.originalRenderCanvas;
	    renderer.render(this, renderTexture, true, m, false);
	    // now restore the state be setting the new properties
	    renderer.context = cachedRenderTarget;
	    renderer._projTransform = cachedProjectionTransform;
	    this.renderCanvas = this._renderCachedCanvas;
	    // the rest is the same as for WebGL
	    this.updateTransform = this.displayObjectUpdateTransform;
	    this.calculateBounds = this._calculateCachedBounds;
	    this.getLocalBounds = this._getCachedLocalBounds;
	    this._mask = null;
	    this.filterArea = null;
	    // create our cached sprite
	    var cachedSprite = new Sprite(renderTexture);
	    cachedSprite.transform.worldTransform = this.transform.worldTransform;
	    cachedSprite.anchor.x = -(bounds.x / bounds.width);
	    cachedSprite.anchor.y = -(bounds.y / bounds.height);
	    cachedSprite.alpha = cacheAlpha;
	    cachedSprite._bounds = this._bounds;
	    this._cacheData.sprite = cachedSprite;
	    this.transform._parentID = -1;
	    // restore the transform of the cached sprite to avoid the nasty flicker..
	    if (!this.parent) {
	        this.parent = renderer._tempDisplayObjectParent;
	        this.updateTransform();
	        this.parent = null;
	    }
	    else {
	        this.updateTransform();
	    }
	    // map the hit test..
	    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
	};
	/**
	 * Calculates the bounds of the cached sprite
	 *
	 * @private
	 */
	DisplayObject.prototype._calculateCachedBounds = function _calculateCachedBounds() {
	    this._bounds.clear();
	    this._cacheData.sprite.transform._worldID = this.transform._worldID;
	    this._cacheData.sprite._calculateBounds();
	    this._bounds.updateID = this._boundsID;
	};
	/**
	 * Gets the bounds of the cached sprite.
	 *
	 * @private
	 * @return {Rectangle} The local bounds.
	 */
	DisplayObject.prototype._getCachedLocalBounds = function _getCachedLocalBounds() {
	    return this._cacheData.sprite.getLocalBounds(null);
	};
	/**
	 * Destroys the cached sprite.
	 *
	 * @private
	 */
	DisplayObject.prototype._destroyCachedDisplayObject = function _destroyCachedDisplayObject() {
	    this._cacheData.sprite._texture.destroy(true);
	    this._cacheData.sprite = null;
	    BaseTexture.removeFromCache(this._cacheData.textureCacheId);
	    Texture.removeFromCache(this._cacheData.textureCacheId);
	    this._cacheData.textureCacheId = null;
	};
	/**
	 * Destroys the cached object.
	 *
	 * @private
	 * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	 *  have been set to that value.
	 *  Used when destroying containers, see the Container.destroy method.
	 */
	DisplayObject.prototype._cacheAsBitmapDestroy = function _cacheAsBitmapDestroy(options) {
	    this.cacheAsBitmap = false;
	    this.destroy(options);
	};

	/*!
	 * @pixi/mixin-get-child-by-name - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/mixin-get-child-by-name is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * The instance name of the object.
	 *
	 * @memberof PIXI.DisplayObject#
	 * @member {string} name
	 */
	DisplayObject.prototype.name = null;
	/**
	 * Returns the display object in the container.
	 *
	 * Recursive searches are done in a preorder traversal.
	 *
	 * @method getChildByName
	 * @memberof PIXI.Container#
	 * @param {string} name - Instance name.
	 * @param {boolean}[deep=false] - Whether to search recursively
	 * @return {PIXI.DisplayObject} The child with the specified name.
	 */
	Container.prototype.getChildByName = function getChildByName(name, deep) {
	    for (var i = 0, j = this.children.length; i < j; i++) {
	        if (this.children[i].name === name) {
	            return this.children[i];
	        }
	    }
	    if (deep) {
	        for (var i = 0, j = this.children.length; i < j; i++) {
	            var child = this.children[i];
	            if (!child.getChildByName) {
	                continue;
	            }
	            var target = this.children[i].getChildByName(name, true);
	            if (target) {
	                return target;
	            }
	        }
	    }
	    return null;
	};

	/*!
	 * @pixi/mixin-get-global-position - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/mixin-get-global-position is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * Returns the global position of the displayObject. Does not depend on object scale, rotation and pivot.
	 *
	 * @method getGlobalPosition
	 * @memberof PIXI.DisplayObject#
	 * @param {PIXI.Point} [point=new PIXI.Point()] - The point to write the global value to.
	 * @param {boolean} [skipUpdate=false] - Setting to true will stop the transforms of the scene graph from
	 *  being updated. This means the calculation returned MAY be out of date BUT will give you a
	 *  nice performance boost.
	 * @return {PIXI.Point} The updated point.
	 */
	DisplayObject.prototype.getGlobalPosition = function getGlobalPosition(point, skipUpdate) {
	    if (point === void 0) { point = new Point(); }
	    if (skipUpdate === void 0) { skipUpdate = false; }
	    if (this.parent) {
	        this.parent.toGlobal(this.position, point, skipUpdate);
	    }
	    else {
	        point.x = this.position.x;
	        point.y = this.position.y;
	    }
	    return point;
	};

	/*!
	 * @pixi/mesh-extras - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/mesh-extras is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$i = function(d, b) {
	    extendStatics$i = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$i(d, b);
	};

	function __extends$i(d, b) {
	    extendStatics$i(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	var PlaneGeometry = /** @class */ (function (_super) {
	    __extends$i(PlaneGeometry, _super);
	    function PlaneGeometry(width, height, segWidth, segHeight) {
	        if (width === void 0) { width = 100; }
	        if (height === void 0) { height = 100; }
	        if (segWidth === void 0) { segWidth = 10; }
	        if (segHeight === void 0) { segHeight = 10; }
	        var _this = _super.call(this) || this;
	        _this.segWidth = segWidth;
	        _this.segHeight = segHeight;
	        _this.width = width;
	        _this.height = height;
	        _this.build();
	        return _this;
	    }
	    /**
	     * Refreshes plane coordinates
	     * @private
	     */
	    PlaneGeometry.prototype.build = function () {
	        var total = this.segWidth * this.segHeight;
	        var verts = [];
	        var uvs = [];
	        var indices = [];
	        var segmentsX = this.segWidth - 1;
	        var segmentsY = this.segHeight - 1;
	        var sizeX = (this.width) / segmentsX;
	        var sizeY = (this.height) / segmentsY;
	        for (var i = 0; i < total; i++) {
	            var x = (i % this.segWidth);
	            var y = ((i / this.segWidth) | 0);
	            verts.push(x * sizeX, y * sizeY);
	            uvs.push(x / segmentsX, y / segmentsY);
	        }
	        var totalSub = segmentsX * segmentsY;
	        for (var i = 0; i < totalSub; i++) {
	            var xpos = i % segmentsX;
	            var ypos = (i / segmentsX) | 0;
	            var value = (ypos * this.segWidth) + xpos;
	            var value2 = (ypos * this.segWidth) + xpos + 1;
	            var value3 = ((ypos + 1) * this.segWidth) + xpos;
	            var value4 = ((ypos + 1) * this.segWidth) + xpos + 1;
	            indices.push(value, value2, value3, value2, value4, value3);
	        }
	        this.buffers[0].data = new Float32Array(verts);
	        this.buffers[1].data = new Float32Array(uvs);
	        this.indexBuffer.data = new Uint16Array(indices);
	        // ensure that the changes are uploaded
	        this.buffers[0].update();
	        this.buffers[1].update();
	        this.indexBuffer.update();
	    };
	    return PlaneGeometry;
	}(MeshGeometry));

	/**
	 * RopeGeometry allows you to draw a geometry across several points and then manipulate these points.
	 *
	 * ```js
	 * for (let i = 0; i < 20; i++) {
	 *     points.push(new PIXI.Point(i * 50, 0));
	 * };
	 * const rope = new PIXI.RopeGeometry(100, points);
	 * ```
	 *
	 * @class
	 * @extends PIXI.MeshGeometry
	 * @memberof PIXI
	 *
	 */
	var RopeGeometry = /** @class */ (function (_super) {
	    __extends$i(RopeGeometry, _super);
	    /**
	     * @param {number} [width=200] - The width (i.e., thickness) of the rope.
	     * @param {PIXI.Point[]} [points] - An array of {@link PIXI.Point} objects to construct this rope.
	     * @param {number} [textureScale=0] - By default the rope texture will be stretched to match
	     *     rope length. If textureScale is positive this value will be treated as a scaling
	     *     factor and the texture will preserve its aspect ratio instead. To create a tiling rope
	     *     set baseTexture.wrapMode to {@link PIXI.WRAP_MODES.REPEAT} and use a power of two texture,
	     *     then set textureScale=1 to keep the original texture pixel size.
	     *     In order to reduce alpha channel artifacts provide a larger texture and downsample -
	     *     i.e. set textureScale=0.5 to scale it down twice.
	     */
	    function RopeGeometry(width, points, textureScale) {
	        if (width === void 0) { width = 200; }
	        if (textureScale === void 0) { textureScale = 0; }
	        var _this = _super.call(this, new Float32Array(points.length * 4), new Float32Array(points.length * 4), new Uint16Array((points.length - 1) * 6)) || this;
	        /**
	         * An array of points that determine the rope
	         * @member {PIXI.Point[]}
	         */
	        _this.points = points;
	        /**
	         * The width (i.e., thickness) of the rope.
	         * @member {number}
	         * @readOnly
	         */
	        _this._width = width;
	        /**
	         * Rope texture scale, if zero then the rope texture is stretched.
	         * @member {number}
	         * @readOnly
	         */
	        _this.textureScale = textureScale;
	        _this.build();
	        return _this;
	    }
	    Object.defineProperty(RopeGeometry.prototype, "width", {
	        /**
	         * The width (i.e., thickness) of the rope.
	         * @member {number}
	         * @readOnly
	         */
	        get: function () {
	            return this._width;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Refreshes Rope indices and uvs
	     * @private
	     */
	    RopeGeometry.prototype.build = function () {
	        var points = this.points;
	        if (!points)
	            { return; }
	        var vertexBuffer = this.getBuffer('aVertexPosition');
	        var uvBuffer = this.getBuffer('aTextureCoord');
	        var indexBuffer = this.getIndex();
	        // if too little points, or texture hasn't got UVs set yet just move on.
	        if (points.length < 1) {
	            return;
	        }
	        // if the number of points has changed we will need to recreate the arraybuffers
	        if (vertexBuffer.data.length / 4 !== points.length) {
	            vertexBuffer.data = new Float32Array(points.length * 4);
	            uvBuffer.data = new Float32Array(points.length * 4);
	            indexBuffer.data = new Uint16Array((points.length - 1) * 6);
	        }
	        var uvs = uvBuffer.data;
	        var indices = indexBuffer.data;
	        uvs[0] = 0;
	        uvs[1] = 0;
	        uvs[2] = 0;
	        uvs[3] = 1;
	        var amount = 0;
	        var prev = points[0];
	        var textureWidth = this._width * this.textureScale;
	        var total = points.length; // - 1;
	        for (var i = 0; i < total; i++) {
	            // time to do some smart drawing!
	            var index = i * 4;
	            if (this.textureScale > 0) {
	                // calculate pixel distance from previous point
	                var dx = prev.x - points[i].x;
	                var dy = prev.y - points[i].y;
	                var distance = Math.sqrt((dx * dx) + (dy * dy));
	                prev = points[i];
	                amount += distance / textureWidth;
	            }
	            else {
	                // stretch texture
	                amount = i / (total - 1);
	            }
	            uvs[index] = amount;
	            uvs[index + 1] = 0;
	            uvs[index + 2] = amount;
	            uvs[index + 3] = 1;
	        }
	        var indexCount = 0;
	        for (var i = 0; i < total - 1; i++) {
	            var index = i * 2;
	            indices[indexCount++] = index;
	            indices[indexCount++] = index + 1;
	            indices[indexCount++] = index + 2;
	            indices[indexCount++] = index + 2;
	            indices[indexCount++] = index + 1;
	            indices[indexCount++] = index + 3;
	        }
	        // ensure that the changes are uploaded
	        uvBuffer.update();
	        indexBuffer.update();
	        this.updateVertices();
	    };
	    /**
	     * refreshes vertices of Rope mesh
	     */
	    RopeGeometry.prototype.updateVertices = function () {
	        var points = this.points;
	        if (points.length < 1) {
	            return;
	        }
	        var lastPoint = points[0];
	        var nextPoint;
	        var perpX = 0;
	        var perpY = 0;
	        var vertices = this.buffers[0].data;
	        var total = points.length;
	        for (var i = 0; i < total; i++) {
	            var point = points[i];
	            var index = i * 4;
	            if (i < points.length - 1) {
	                nextPoint = points[i + 1];
	            }
	            else {
	                nextPoint = point;
	            }
	            perpY = -(nextPoint.x - lastPoint.x);
	            perpX = nextPoint.y - lastPoint.y;
	            var perpLength = Math.sqrt((perpX * perpX) + (perpY * perpY));
	            var num = this.textureScale > 0 ? this.textureScale * this._width / 2 : this._width / 2;
	            perpX /= perpLength;
	            perpY /= perpLength;
	            perpX *= num;
	            perpY *= num;
	            vertices[index] = point.x + perpX;
	            vertices[index + 1] = point.y + perpY;
	            vertices[index + 2] = point.x - perpX;
	            vertices[index + 3] = point.y - perpY;
	            lastPoint = point;
	        }
	        this.buffers[0].update();
	    };
	    RopeGeometry.prototype.update = function () {
	        if (this.textureScale > 0) {
	            this.build(); // we need to update UVs
	        }
	        else {
	            this.updateVertices();
	        }
	    };
	    return RopeGeometry;
	}(MeshGeometry));

	/**
	 * The rope allows you to draw a texture across several points and then manipulate these points
	 *
	 *```js
	 * for (let i = 0; i < 20; i++) {
	 *     points.push(new PIXI.Point(i * 50, 0));
	 * };
	 * let rope = new PIXI.SimpleRope(PIXI.Texture.from("snake.png"), points);
	 *  ```
	 *
	 * @class
	 * @extends PIXI.Mesh
	 * @memberof PIXI
	 *
	 */
	var SimpleRope = /** @class */ (function (_super) {
	    __extends$i(SimpleRope, _super);
	    /**
	     * @param {PIXI.Texture} texture - The texture to use on the rope.
	     * @param {PIXI.Point[]} points - An array of {@link PIXI.Point} objects to construct this rope.
	     * @param {number} [textureScale=0] - Optional. Positive values scale rope texture
	     * keeping its aspect ratio. You can reduce alpha channel artifacts by providing a larger texture
	     * and downsampling here. If set to zero, texture will be streched instead.
	     */
	    function SimpleRope(texture, points, textureScale) {
	        if (textureScale === void 0) { textureScale = 0; }
	        var _this = this;
	        var ropeGeometry = new RopeGeometry(texture.height, points, textureScale);
	        var meshMaterial = new MeshMaterial(texture);
	        if (textureScale > 0) {
	            // attempt to set UV wrapping, will fail on non-power of two textures
	            texture.baseTexture.wrapMode = exports.WRAP_MODES.REPEAT;
	        }
	        _this = _super.call(this, ropeGeometry, meshMaterial) || this;
	        /**
	         * re-calculate vertices by rope points each frame
	         *
	         * @member {boolean}
	         */
	        _this.autoUpdate = true;
	        return _this;
	    }
	    SimpleRope.prototype._render = function (renderer) {
	        var geometry = this.geometry;
	        if (this.autoUpdate || geometry._width !== this.shader.texture.height) {
	            geometry._width = this.shader.texture.height;
	            geometry.update();
	        }
	        _super.prototype._render.call(this, renderer);
	    };
	    return SimpleRope;
	}(Mesh));

	/**
	 * The SimplePlane allows you to draw a texture across several points and then manipulate these points
	 *
	 *```js
	 * for (let i = 0; i < 20; i++) {
	 *     points.push(new PIXI.Point(i * 50, 0));
	 * };
	 * let SimplePlane = new PIXI.SimplePlane(PIXI.Texture.from("snake.png"), points);
	 *  ```
	 *
	 * @class
	 * @extends PIXI.Mesh
	 * @memberof PIXI
	 *
	 */
	var SimplePlane = /** @class */ (function (_super) {
	    __extends$i(SimplePlane, _super);
	    /**
	     * @param {PIXI.Texture} texture - The texture to use on the SimplePlane.
	     * @param {number} verticesX - The number of vertices in the x-axis
	     * @param {number} verticesY - The number of vertices in the y-axis
	     */
	    function SimplePlane(texture, verticesX, verticesY) {
	        var _this = this;
	        var planeGeometry = new PlaneGeometry(texture.width, texture.height, verticesX, verticesY);
	        var meshMaterial = new MeshMaterial(Texture.WHITE);
	        _this = _super.call(this, planeGeometry, meshMaterial) || this;
	        // lets call the setter to ensure all necessary updates are performed
	        _this.texture = texture;
	        return _this;
	    }
	    /**
	     * Method used for overrides, to do something in case texture frame was changed.
	     * Meshes based on plane can override it and change more details based on texture.
	     */
	    SimplePlane.prototype.textureUpdated = function () {
	        this._textureID = this.shader.texture._updateID;
	        var geometry = this.geometry;
	        geometry.width = this.shader.texture.width;
	        geometry.height = this.shader.texture.height;
	        geometry.build();
	    };
	    Object.defineProperty(SimplePlane.prototype, "texture", {
	        get: function () {
	            return this.shader.texture;
	        },
	        set: function (value) {
	            // Track texture same way sprite does.
	            // For generated meshes like NineSlicePlane it can change the geometry.
	            // Unfortunately, this method might not work if you directly change texture in material.
	            if (this.shader.texture === value) {
	                return;
	            }
	            this.shader.texture = value;
	            this._textureID = -1;
	            if (value.baseTexture.valid) {
	                this.textureUpdated();
	            }
	            else {
	                value.once('update', this.textureUpdated, this);
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    SimplePlane.prototype._render = function (renderer) {
	        if (this._textureID !== this.shader.texture._updateID) {
	            this.textureUpdated();
	        }
	        _super.prototype._render.call(this, renderer);
	    };
	    SimplePlane.prototype.destroy = function (options) {
	        this.shader.texture.off('update', this.textureUpdated, this);
	        _super.prototype.destroy.call(this, options);
	    };
	    return SimplePlane;
	}(Mesh));

	/**
	 * The Simple Mesh class mimics Mesh in PixiJS v4, providing easy-to-use constructor arguments.
	 * For more robust customization, use {@link PIXI.Mesh}.
	 *
	 * @class
	 * @extends PIXI.Mesh
	 * @memberof PIXI
	 */
	var SimpleMesh = /** @class */ (function (_super) {
	    __extends$i(SimpleMesh, _super);
	    /**
	     * @param {PIXI.Texture} [texture=Texture.EMPTY] - The texture to use
	     * @param {Float32Array} [vertices] - if you want to specify the vertices
	     * @param {Float32Array} [uvs] - if you want to specify the uvs
	     * @param {Uint16Array} [indices] - if you want to specify the indices
	     * @param {number} [drawMode] - the drawMode, can be any of the Mesh.DRAW_MODES consts
	     */
	    function SimpleMesh(texture, vertices, uvs, indices, drawMode) {
	        if (texture === void 0) { texture = Texture.EMPTY; }
	        var _this = this;
	        var geometry = new MeshGeometry(vertices, uvs, indices);
	        geometry.getBuffer('aVertexPosition').static = false;
	        var meshMaterial = new MeshMaterial(texture);
	        _this = _super.call(this, geometry, meshMaterial, null, drawMode) || this;
	        /**
	         * upload vertices buffer each frame
	         * @member {boolean}
	         */
	        _this.autoUpdate = true;
	        return _this;
	    }
	    Object.defineProperty(SimpleMesh.prototype, "vertices", {
	        /**
	         * Collection of vertices data.
	         * @member {Float32Array}
	         */
	        get: function () {
	            return this.geometry.getBuffer('aVertexPosition').data;
	        },
	        set: function (value) {
	            this.geometry.getBuffer('aVertexPosition').data = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    SimpleMesh.prototype._render = function (renderer) {
	        if (this.autoUpdate) {
	            this.geometry.getBuffer('aVertexPosition').update();
	        }
	        _super.prototype._render.call(this, renderer);
	    };
	    return SimpleMesh;
	}(Mesh));

	var DEFAULT_BORDER_SIZE = 10;
	/**
	 * The NineSlicePlane allows you to stretch a texture using 9-slice scaling. The corners will remain unscaled (useful
	 * for buttons with rounded corners for example) and the other areas will be scaled horizontally and or vertically
	 *
	 *```js
	 * let Plane9 = new PIXI.NineSlicePlane(PIXI.Texture.from('BoxWithRoundedCorners.png'), 15, 15, 15, 15);
	 *  ```
	 * <pre>
	 *      A                          B
	 *    +---+----------------------+---+
	 *  C | 1 |          2           | 3 |
	 *    +---+----------------------+---+
	 *    |   |                      |   |
	 *    | 4 |          5           | 6 |
	 *    |   |                      |   |
	 *    +---+----------------------+---+
	 *  D | 7 |          8           | 9 |
	 *    +---+----------------------+---+

	 *  When changing this objects width and/or height:
	 *     areas 1 3 7 and 9 will remain unscaled.
	 *     areas 2 and 8 will be stretched horizontally
	 *     areas 4 and 6 will be stretched vertically
	 *     area 5 will be stretched both horizontally and vertically
	 * </pre>
	 *
	 * @class
	 * @extends PIXI.SimplePlane
	 * @memberof PIXI
	 *
	 */
	var NineSlicePlane = /** @class */ (function (_super) {
	    __extends$i(NineSlicePlane, _super);
	    /**
	     * @param {PIXI.Texture} texture - The texture to use on the NineSlicePlane.
	     * @param {number} [leftWidth=10] - size of the left vertical bar (A)
	     * @param {number} [topHeight=10] - size of the top horizontal bar (C)
	     * @param {number} [rightWidth=10] - size of the right vertical bar (B)
	     * @param {number} [bottomHeight=10] - size of the bottom horizontal bar (D)
	     */
	    function NineSlicePlane(texture, leftWidth, topHeight, rightWidth, bottomHeight) {
	        if (leftWidth === void 0) { leftWidth = DEFAULT_BORDER_SIZE; }
	        if (topHeight === void 0) { topHeight = DEFAULT_BORDER_SIZE; }
	        if (rightWidth === void 0) { rightWidth = DEFAULT_BORDER_SIZE; }
	        if (bottomHeight === void 0) { bottomHeight = DEFAULT_BORDER_SIZE; }
	        var _this = _super.call(this, Texture.WHITE, 4, 4) || this;
	        _this._origWidth = texture.orig.width;
	        _this._origHeight = texture.orig.height;
	        /**
	         * The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	         *
	         * @member {number}
	         * @override
	         */
	        _this._width = _this._origWidth;
	        /**
	         * The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	         *
	         * @member {number}
	         * @override
	         */
	        _this._height = _this._origHeight;
	        /**
	         * The width of the left column (a)
	         *
	         * @member {number}
	         * @private
	         */
	        _this._leftWidth = leftWidth;
	        /**
	         * The width of the right column (b)
	         *
	         * @member {number}
	         * @private
	         */
	        _this._rightWidth = rightWidth;
	        /**
	         * The height of the top row (c)
	         *
	         * @member {number}
	         * @private
	         */
	        _this._topHeight = topHeight;
	        /**
	         * The height of the bottom row (d)
	         *
	         * @member {number}
	         * @private
	         */
	        _this._bottomHeight = bottomHeight;
	        // lets call the setter to ensure all necessary updates are performed
	        _this.texture = texture;
	        return _this;
	    }
	    NineSlicePlane.prototype.textureUpdated = function () {
	        this._textureID = this.shader.texture._updateID;
	        this._refresh();
	    };
	    Object.defineProperty(NineSlicePlane.prototype, "vertices", {
	        get: function () {
	            return this.geometry.getBuffer('aVertexPosition').data;
	        },
	        set: function (value) {
	            this.geometry.getBuffer('aVertexPosition').data = value;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Updates the horizontal vertices.
	     *
	     */
	    NineSlicePlane.prototype.updateHorizontalVertices = function () {
	        var vertices = this.vertices;
	        var scale = this._getMinScale();
	        vertices[9] = vertices[11] = vertices[13] = vertices[15] = this._topHeight * scale;
	        vertices[17] = vertices[19] = vertices[21] = vertices[23] = this._height - (this._bottomHeight * scale);
	        vertices[25] = vertices[27] = vertices[29] = vertices[31] = this._height;
	    };
	    /**
	     * Updates the vertical vertices.
	     *
	     */
	    NineSlicePlane.prototype.updateVerticalVertices = function () {
	        var vertices = this.vertices;
	        var scale = this._getMinScale();
	        vertices[2] = vertices[10] = vertices[18] = vertices[26] = this._leftWidth * scale;
	        vertices[4] = vertices[12] = vertices[20] = vertices[28] = this._width - (this._rightWidth * scale);
	        vertices[6] = vertices[14] = vertices[22] = vertices[30] = this._width;
	    };
	    /**
	     * Returns the smaller of a set of vertical and horizontal scale of nine slice corners.
	     *
	     * @return {number} Smaller number of vertical and horizontal scale.
	     * @private
	     */
	    NineSlicePlane.prototype._getMinScale = function () {
	        var w = this._leftWidth + this._rightWidth;
	        var scaleW = this._width > w ? 1.0 : this._width / w;
	        var h = this._topHeight + this._bottomHeight;
	        var scaleH = this._height > h ? 1.0 : this._height / h;
	        var scale = Math.min(scaleW, scaleH);
	        return scale;
	    };
	    Object.defineProperty(NineSlicePlane.prototype, "width", {
	        /**
	         * The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._width;
	        },
	        set: function (value) {
	            this._width = value;
	            this._refresh();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(NineSlicePlane.prototype, "height", {
	        /**
	         * The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._height;
	        },
	        set: function (value) {
	            this._height = value;
	            this._refresh();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(NineSlicePlane.prototype, "leftWidth", {
	        /**
	         * The width of the left column
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._leftWidth;
	        },
	        set: function (value) {
	            this._leftWidth = value;
	            this._refresh();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(NineSlicePlane.prototype, "rightWidth", {
	        /**
	         * The width of the right column
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._rightWidth;
	        },
	        set: function (value) {
	            this._rightWidth = value;
	            this._refresh();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(NineSlicePlane.prototype, "topHeight", {
	        /**
	         * The height of the top row
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._topHeight;
	        },
	        set: function (value) {
	            this._topHeight = value;
	            this._refresh();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(NineSlicePlane.prototype, "bottomHeight", {
	        /**
	         * The height of the bottom row
	         *
	         * @member {number}
	         */
	        get: function () {
	            return this._bottomHeight;
	        },
	        set: function (value) {
	            this._bottomHeight = value;
	            this._refresh();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Refreshes NineSlicePlane coords. All of them.
	     */
	    NineSlicePlane.prototype._refresh = function () {
	        var texture = this.texture;
	        var uvs = this.geometry.buffers[1].data;
	        this._origWidth = texture.orig.width;
	        this._origHeight = texture.orig.height;
	        var _uvw = 1.0 / this._origWidth;
	        var _uvh = 1.0 / this._origHeight;
	        uvs[0] = uvs[8] = uvs[16] = uvs[24] = 0;
	        uvs[1] = uvs[3] = uvs[5] = uvs[7] = 0;
	        uvs[6] = uvs[14] = uvs[22] = uvs[30] = 1;
	        uvs[25] = uvs[27] = uvs[29] = uvs[31] = 1;
	        uvs[2] = uvs[10] = uvs[18] = uvs[26] = _uvw * this._leftWidth;
	        uvs[4] = uvs[12] = uvs[20] = uvs[28] = 1 - (_uvw * this._rightWidth);
	        uvs[9] = uvs[11] = uvs[13] = uvs[15] = _uvh * this._topHeight;
	        uvs[17] = uvs[19] = uvs[21] = uvs[23] = 1 - (_uvh * this._bottomHeight);
	        this.updateHorizontalVertices();
	        this.updateVerticalVertices();
	        this.geometry.buffers[0].update();
	        this.geometry.buffers[1].update();
	    };
	    return NineSlicePlane;
	}(SimplePlane));

	/*!
	 * @pixi/sprite-animated - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/sprite-animated is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$j = function(d, b) {
	    extendStatics$j = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$j(d, b);
	};

	function __extends$j(d, b) {
	    extendStatics$j(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	/**
	 * An AnimatedSprite is a simple way to display an animation depicted by a list of textures.
	 *
	 * ```js
	 * let alienImages = ["image_sequence_01.png","image_sequence_02.png","image_sequence_03.png","image_sequence_04.png"];
	 * let textureArray = [];
	 *
	 * for (let i=0; i < 4; i++)
	 * {
	 *      let texture = PIXI.Texture.from(alienImages[i]);
	 *      textureArray.push(texture);
	 * };
	 *
	 * let animatedSprite = new PIXI.AnimatedSprite(textureArray);
	 * ```
	 *
	 * The more efficient and simpler way to create an animated sprite is using a {@link PIXI.Spritesheet}
	 * containing the animation definitions:
	 *
	 * ```js
	 * PIXI.Loader.shared.add("assets/spritesheet.json").load(setup);
	 *
	 * function setup() {
	 *   let sheet = PIXI.Loader.shared.resources["assets/spritesheet.json"].spritesheet;
	 *   animatedSprite = new PIXI.AnimatedSprite(sheet.animations["image_sequence"]);
	 *   ...
	 * }
	 * ```
	 *
	 * @class
	 * @extends PIXI.Sprite
	 * @memberof PIXI
	 */
	var AnimatedSprite = /** @class */ (function (_super) {
	    __extends$j(AnimatedSprite, _super);
	    /**
	     * @param {PIXI.Texture[]|PIXI.AnimatedSprite.FrameObject[]} textures - An array of {@link PIXI.Texture} or frame
	     *  objects that make up the animation.
	     * @param {boolean} [autoUpdate=true] - Whether to use PIXI.Ticker.shared to auto update animation time.
	     */
	    function AnimatedSprite(textures, autoUpdate) {
	        if (autoUpdate === void 0) { autoUpdate = true; }
	        var _this = _super.call(this, textures[0] instanceof Texture ? textures[0] : textures[0].texture) || this;
	        /**
	         * @type {PIXI.Texture[]}
	         * @private
	         */
	        _this._textures = null;
	        /**
	         * @type {number[]}
	         * @private
	         */
	        _this._durations = null;
	        /**
	         * `true` uses PIXI.Ticker.shared to auto update animation time.
	         *
	         * @type {boolean}
	         * @default true
	         * @private
	         */
	        _this._autoUpdate = autoUpdate;
	        /**
	         * `true` if the instance is currently connected to PIXI.Ticker.shared to auto update animation time.
	         *
	         * @type {boolean}
	         * @default false
	         * @private
	         */
	        _this._isConnectedToTicker = false;
	        /**
	         * The speed that the AnimatedSprite will play at. Higher is faster, lower is slower.
	         *
	         * @member {number}
	         * @default 1
	         */
	        _this.animationSpeed = 1;
	        /**
	         * Whether or not the animate sprite repeats after playing.
	         *
	         * @member {boolean}
	         * @default true
	         */
	        _this.loop = true;
	        /**
	         * Update anchor to [Texture's defaultAnchor]{@link PIXI.Texture#defaultAnchor} when frame changes.
	         *
	         * Useful with [sprite sheet animations]{@link PIXI.Spritesheet#animations} created with tools.
	         * Changing anchor for each frame allows to pin sprite origin to certain moving feature
	         * of the frame (e.g. left foot).
	         *
	         * Note: Enabling this will override any previously set `anchor` on each frame change.
	         *
	         * @member {boolean}
	         * @default false
	         */
	        _this.updateAnchor = false;
	        /**
	         * User-assigned function to call when an AnimatedSprite finishes playing.
	         *
	         * @example
	         * animation.onComplete = function () {
	         *   // finished!
	         * };
	         * @member {Function}
	         */
	        _this.onComplete = null;
	        /**
	         * User-assigned function to call when an AnimatedSprite changes which texture is being rendered.
	         *
	         * @example
	         * animation.onFrameChange = function () {
	         *   // updated!
	         * };
	         * @member {Function}
	         */
	        _this.onFrameChange = null;
	        /**
	         * User-assigned function to call when `loop` is true, and an AnimatedSprite is played and
	         * loops around to start again.
	         *
	         * @example
	         * animation.onLoop = function () {
	         *   // looped!
	         * };
	         * @member {Function}
	         */
	        _this.onLoop = null;
	        /**
	         * Elapsed time since animation has been started, used internally to display current texture.
	         *
	         * @member {number}
	         * @private
	         */
	        _this._currentTime = 0;
	        _this._playing = false;
	        /**
	         * The texture index that was displayed last time
	         *
	         * @member {number}
	         * @private
	         */
	        _this._previousFrame = null;
	        _this.textures = textures;
	        return _this;
	    }
	    /**
	     * Stops the AnimatedSprite.
	     *
	     */
	    AnimatedSprite.prototype.stop = function () {
	        if (!this._playing) {
	            return;
	        }
	        this._playing = false;
	        if (this._autoUpdate && this._isConnectedToTicker) {
	            Ticker.shared.remove(this.update, this);
	            this._isConnectedToTicker = false;
	        }
	    };
	    /**
	     * Plays the AnimatedSprite.
	     *
	     */
	    AnimatedSprite.prototype.play = function () {
	        if (this._playing) {
	            return;
	        }
	        this._playing = true;
	        if (this._autoUpdate && !this._isConnectedToTicker) {
	            Ticker.shared.add(this.update, this, exports.UPDATE_PRIORITY.HIGH);
	            this._isConnectedToTicker = true;
	        }
	    };
	    /**
	     * Stops the AnimatedSprite and goes to a specific frame.
	     *
	     * @param {number} frameNumber - Frame index to stop at.
	     */
	    AnimatedSprite.prototype.gotoAndStop = function (frameNumber) {
	        this.stop();
	        var previousFrame = this.currentFrame;
	        this._currentTime = frameNumber;
	        if (previousFrame !== this.currentFrame) {
	            this.updateTexture();
	        }
	    };
	    /**
	     * Goes to a specific frame and begins playing the AnimatedSprite.
	     *
	     * @param {number} frameNumber - Frame index to start at.
	     */
	    AnimatedSprite.prototype.gotoAndPlay = function (frameNumber) {
	        var previousFrame = this.currentFrame;
	        this._currentTime = frameNumber;
	        if (previousFrame !== this.currentFrame) {
	            this.updateTexture();
	        }
	        this.play();
	    };
	    /**
	     * Updates the object transform for rendering.
	     *
	     * @param {number} deltaTime - Time since last tick.
	     */
	    AnimatedSprite.prototype.update = function (deltaTime) {
	        if (!this._playing) {
	            return;
	        }
	        var elapsed = this.animationSpeed * deltaTime;
	        var previousFrame = this.currentFrame;
	        if (this._durations !== null) {
	            var lag = this._currentTime % 1 * this._durations[this.currentFrame];
	            lag += elapsed / 60 * 1000;
	            while (lag < 0) {
	                this._currentTime--;
	                lag += this._durations[this.currentFrame];
	            }
	            var sign = Math.sign(this.animationSpeed * deltaTime);
	            this._currentTime = Math.floor(this._currentTime);
	            while (lag >= this._durations[this.currentFrame]) {
	                lag -= this._durations[this.currentFrame] * sign;
	                this._currentTime += sign;
	            }
	            this._currentTime += lag / this._durations[this.currentFrame];
	        }
	        else {
	            this._currentTime += elapsed;
	        }
	        if (this._currentTime < 0 && !this.loop) {
	            this.gotoAndStop(0);
	            if (this.onComplete) {
	                this.onComplete();
	            }
	        }
	        else if (this._currentTime >= this._textures.length && !this.loop) {
	            this.gotoAndStop(this._textures.length - 1);
	            if (this.onComplete) {
	                this.onComplete();
	            }
	        }
	        else if (previousFrame !== this.currentFrame) {
	            if (this.loop && this.onLoop) {
	                if (this.animationSpeed > 0 && this.currentFrame < previousFrame) {
	                    this.onLoop();
	                }
	                else if (this.animationSpeed < 0 && this.currentFrame > previousFrame) {
	                    this.onLoop();
	                }
	            }
	            this.updateTexture();
	        }
	    };
	    /**
	     * Updates the displayed texture to match the current frame index.
	     *
	     * @private
	     */
	    AnimatedSprite.prototype.updateTexture = function () {
	        var currentFrame = this.currentFrame;
	        if (this._previousFrame === currentFrame) {
	            return;
	        }
	        this._previousFrame = currentFrame;
	        this._texture = this._textures[currentFrame];
	        this._textureID = -1;
	        this._textureTrimmedID = -1;
	        this._cachedTint = 0xFFFFFF;
	        this.uvs = this._texture._uvs.uvsFloat32;
	        if (this.updateAnchor) {
	            this._anchor.copyFrom(this._texture.defaultAnchor);
	        }
	        if (this.onFrameChange) {
	            this.onFrameChange(this.currentFrame);
	        }
	    };
	    /**
	     * Stops the AnimatedSprite and destroys it.
	     *
	     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
	     *  have been set to that value.
	     * @param {boolean} [options.children=false] - If set to true, all the children will have their destroy
	     *      method called as well. 'options' will be passed on to those calls.
	     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well.
	     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well.
	     */
	    AnimatedSprite.prototype.destroy = function (options) {
	        this.stop();
	        _super.prototype.destroy.call(this, options);
	        this.onComplete = null;
	        this.onFrameChange = null;
	        this.onLoop = null;
	    };
	    /**
	     * A short hand way of creating an AnimatedSprite from an array of frame ids.
	     *
	     * @static
	     * @param {string[]} frames - The array of frames ids the AnimatedSprite will use as its texture frames.
	     * @return {PIXI.AnimatedSprite} The new animated sprite with the specified frames.
	     */
	    AnimatedSprite.fromFrames = function (frames) {
	        var textures = [];
	        for (var i = 0; i < frames.length; ++i) {
	            textures.push(Texture.from(frames[i]));
	        }
	        return new AnimatedSprite(textures);
	    };
	    /**
	     * A short hand way of creating an AnimatedSprite from an array of image ids.
	     *
	     * @static
	     * @param {string[]} images - The array of image urls the AnimatedSprite will use as its texture frames.
	     * @return {PIXI.AnimatedSprite} The new animate sprite with the specified images as frames.
	     */
	    AnimatedSprite.fromImages = function (images) {
	        var textures = [];
	        for (var i = 0; i < images.length; ++i) {
	            textures.push(Texture.from(images[i]));
	        }
	        return new AnimatedSprite(textures);
	    };
	    Object.defineProperty(AnimatedSprite.prototype, "totalFrames", {
	        /**
	         * The total number of frames in the AnimatedSprite. This is the same as number of textures
	         * assigned to the AnimatedSprite.
	         *
	         * @readonly
	         * @member {number}
	         * @default 0
	         */
	        get: function () {
	            return this._textures.length;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(AnimatedSprite.prototype, "textures", {
	        /**
	         * The array of textures used for this AnimatedSprite.
	         *
	         * @member {PIXI.Texture[]|PIXI.AnimatedSprite.FrameObject[]}
	         */
	        get: function () {
	            return this._textures;
	        },
	        set: function (value) {
	            if (value[0] instanceof Texture) {
	                this._textures = value;
	                this._durations = null;
	            }
	            else {
	                this._textures = [];
	                this._durations = [];
	                for (var i = 0; i < value.length; i++) {
	                    this._textures.push(value[i].texture);
	                    this._durations.push(value[i].time);
	                }
	            }
	            this._previousFrame = null;
	            this.gotoAndStop(0);
	            this.updateTexture();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(AnimatedSprite.prototype, "currentFrame", {
	        /**
	        * The AnimatedSprites current frame index.
	        *
	        * @member {number}
	        * @readonly
	        */
	        get: function () {
	            var currentFrame = Math.floor(this._currentTime) % this._textures.length;
	            if (currentFrame < 0) {
	                currentFrame += this._textures.length;
	            }
	            return currentFrame;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(AnimatedSprite.prototype, "playing", {
	        /**
	         * Indicates if the AnimatedSprite is currently playing.
	         *
	         * @member {boolean}
	         * @readonly
	         */
	        get: function () {
	            return this._playing;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(AnimatedSprite.prototype, "autoUpdate", {
	        /**
	         * Whether to use PIXI.Ticker.shared to auto update animation time
	         *
	         * @member {boolean}
	         */
	        get: function () {
	            return this._autoUpdate;
	        },
	        set: function (value) {
	            if (value !== this._autoUpdate) {
	                this._autoUpdate = value;
	                if (!this._autoUpdate && this._isConnectedToTicker) {
	                    Ticker.shared.remove(this.update, this);
	                    this._isConnectedToTicker = false;
	                }
	                else if (this._autoUpdate && !this._isConnectedToTicker && this._playing) {
	                    Ticker.shared.add(this.update, this);
	                    this._isConnectedToTicker = true;
	                }
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return AnimatedSprite;
	}(Sprite));

	/*!
	 * pixi.js - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * pixi.js is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$k = function(d, b) {
	    extendStatics$k = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$k(d, b);
	};

	function __extends$k(d, b) {
	    extendStatics$k(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	var v5 = '5.0.0';
	/**
	 * Deprecations (backward compatibilities) are automatically applied for browser bundles
	 * in the UMD module format. If using Webpack or Rollup, you'll need to apply these
	 * deprecations manually by doing something like this:
	 * @example
	 * import * as PIXI from 'pixi.js';
	 * PIXI.useDeprecated(); // MUST be bound to namespace
	 * @memberof PIXI
	 * @function useDeprecated
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function useDeprecated() {
	    // eslint-disable-next-line @typescript-eslint/no-this-alias
	    var PIXI = this;
	    Object.defineProperties(PIXI, {
	        /**
	         * @constant {RegExp|string} SVG_SIZE
	         * @memberof PIXI
	         * @see PIXI.resources.SVGResource.SVG_SIZE
	         * @deprecated since 5.0.0
	         */
	        SVG_SIZE: {
	            get: function () {
	                deprecation(v5, 'PIXI.utils.SVG_SIZE property has moved to PIXI.resources.SVGResource.SVG_SIZE');
	                return PIXI.SVGResource.SVG_SIZE;
	            },
	        },
	        /**
	         * @class PIXI.TransformStatic
	         * @deprecated since 5.0.0
	         * @see PIXI.Transform
	         */
	        TransformStatic: {
	            get: function () {
	                deprecation(v5, 'PIXI.TransformStatic class has been removed, use PIXI.Transform');
	                return PIXI.Transform;
	            },
	        },
	        /**
	         * @class PIXI.TransformBase
	         * @deprecated since 5.0.0
	         * @see PIXI.Transform
	         */
	        TransformBase: {
	            get: function () {
	                deprecation(v5, 'PIXI.TransformBase class has been removed, use PIXI.Transform');
	                return PIXI.Transform;
	            },
	        },
	        /**
	         * Constants that specify the transform type.
	         *
	         * @static
	         * @constant
	         * @name TRANSFORM_MODE
	         * @memberof PIXI
	         * @enum {number}
	         * @deprecated since 5.0.0
	         * @property {number} STATIC
	         * @property {number} DYNAMIC
	         */
	        TRANSFORM_MODE: {
	            get: function () {
	                deprecation(v5, 'PIXI.TRANSFORM_MODE property has been removed');
	                return { STATIC: 0, DYNAMIC: 1 };
	            },
	        },
	        /**
	         * @class PIXI.WebGLRenderer
	         * @see PIXI.Renderer
	         * @deprecated since 5.0.0
	         */
	        WebGLRenderer: {
	            get: function () {
	                deprecation(v5, 'PIXI.WebGLRenderer class has moved to PIXI.Renderer');
	                return PIXI.Renderer;
	            },
	        },
	        /**
	         * @class PIXI.CanvasRenderTarget
	         * @see PIXI.utils.CanvasRenderTarget
	         * @deprecated since 5.0.0
	         */
	        CanvasRenderTarget: {
	            get: function () {
	                deprecation(v5, 'PIXI.CanvasRenderTarget class has moved to PIXI.utils.CanvasRenderTarget');
	                return PIXI.utils.CanvasRenderTarget;
	            },
	        },
	        /**
	         * @memberof PIXI
	         * @name loader
	         * @type {PIXI.Loader}
	         * @see PIXI.Loader.shared
	         * @deprecated since 5.0.0
	         */
	        loader: {
	            get: function () {
	                deprecation(v5, 'PIXI.loader instance has moved to PIXI.Loader.shared');
	                return PIXI.Loader.shared;
	            },
	        },
	        /**
	         * @class PIXI.FilterManager
	         * @see PIXI.systems.FilterSystem
	         * @deprecated since 5.0.0
	         */
	        FilterManager: {
	            get: function () {
	                deprecation(v5, 'PIXI.FilterManager class has moved to PIXI.systems.FilterSystem');
	                return PIXI.systems.FilterSystem;
	            },
	        },
	        /**
	         * @namespace PIXI.CanvasTinter
	         * @see PIXI.canvasUtils
	         * @deprecated since 5.2.0
	         */
	        CanvasTinter: {
	            get: function () {
	                deprecation('5.2.0', 'PIXI.CanvasTinter namespace has moved to PIXI.canvasUtils');
	                return PIXI.canvasUtils;
	            },
	        },
	        /**
	         * @namespace PIXI.GroupD8
	         * @see PIXI.groupD8
	         * @deprecated since 5.2.0
	         */
	        GroupD8: {
	            get: function () {
	                deprecation('5.2.0', 'PIXI.GroupD8 namespace has moved to PIXI.groupD8');
	                return PIXI.groupD8;
	            },
	        },
	    });
	    /**
	     * @namespace PIXI.accessibility
	     * @see PIXI
	     * @deprecated since 5.3.0
	     */
	    PIXI.accessibility = {};
	    Object.defineProperties(PIXI.accessibility, {
	        /**
	         * @class PIXI.accessibility.AccessibilityManager
	         * @deprecated since 5.3.0
	         * @see PIXI.AccessibilityManager
	         */
	        AccessibilityManager: {
	            get: function () {
	                deprecation('5.3.0', 'PIXI.accessibility.AccessibilityManager moved to PIXI.AccessibilityManager');
	                return PIXI.AccessibilityManager;
	            },
	        },
	    });
	    /**
	     * @namespace PIXI.interaction
	     * @see PIXI
	     * @deprecated since 5.3.0
	     */
	    PIXI.interaction = {};
	    Object.defineProperties(PIXI.interaction, {
	        /**
	         * @class PIXI.interaction.InteractionManager
	         * @deprecated since 5.3.0
	         * @see PIXI.InteractionManager
	         */
	        InteractionManager: {
	            get: function () {
	                deprecation('5.3.0', 'PIXI.interaction.InteractionManager moved to PIXI.InteractionManager');
	                return PIXI.InteractionManager;
	            },
	        },
	        /**
	         * @class PIXI.interaction.InteractionData
	         * @deprecated since 5.3.0
	         * @see PIXI.InteractionData
	         */
	        InteractionData: {
	            get: function () {
	                deprecation('5.3.0', 'PIXI.interaction.InteractionData moved to PIXI.InteractionData');
	                return PIXI.InteractionData;
	            },
	        },
	        /**
	         * @class PIXI.interaction.InteractionEvent
	         * @deprecated since 5.3.0
	         * @see PIXI.InteractionEvent
	         */
	        InteractionEvent: {
	            get: function () {
	                deprecation('5.3.0', 'PIXI.interaction.InteractionEvent moved to PIXI.InteractionEvent');
	                return PIXI.InteractionEvent;
	            },
	        },
	    });
	    /**
	     * @namespace PIXI.prepare
	     * @see PIXI
	     * @deprecated since 5.2.1
	     */
	    PIXI.prepare = {};
	    Object.defineProperties(PIXI.prepare, {
	        /**
	         * @class PIXI.prepare.BasePrepare
	         * @deprecated since 5.2.1
	         * @see PIXI.BasePrepare
	         */
	        BasePrepare: {
	            get: function () {
	                deprecation('5.2.1', 'PIXI.prepare.BasePrepare moved to PIXI.BasePrepare');
	                return PIXI.BasePrepare;
	            },
	        },
	        /**
	         * @class PIXI.prepare.Prepare
	         * @deprecated since 5.2.1
	         * @see PIXI.Prepare
	         */
	        Prepare: {
	            get: function () {
	                deprecation('5.2.1', 'PIXI.prepare.Prepare moved to PIXI.Prepare');
	                return PIXI.Prepare;
	            },
	        },
	        /**
	         * @class PIXI.prepare.CanvasPrepare
	         * @deprecated since 5.2.1
	         * @see PIXI.CanvasPrepare
	         */
	        CanvasPrepare: {
	            get: function () {
	                deprecation('5.2.1', 'PIXI.prepare.CanvasPrepare moved to PIXI.CanvasPrepare');
	                return PIXI.CanvasPrepare;
	            },
	        },
	    });
	    /**
	     * @namespace PIXI.extract
	     * @see PIXI
	     * @deprecated since 5.2.1
	     */
	    PIXI.extract = {};
	    Object.defineProperties(PIXI.extract, {
	        /**
	         * @class PIXI.extract.Extract
	         * @deprecated since 5.2.1
	         * @see PIXI.Extract
	         */
	        Extract: {
	            get: function () {
	                deprecation('5.2.1', 'PIXI.extract.Extract moved to PIXI.Extract');
	                return PIXI.Extract;
	            },
	        },
	        /**
	         * @class PIXI.extract.CanvasExtract
	         * @deprecated since 5.2.1
	         * @see PIXI.CanvasExtract
	         */
	        CanvasExtract: {
	            get: function () {
	                deprecation('5.2.1', 'PIXI.extract.CanvasExtract moved to PIXI.CanvasExtract');
	                return PIXI.CanvasExtract;
	            },
	        },
	    });
	    /**
	     * This namespace has been removed. All classes previous nested
	     * under this namespace have been moved to the top-level `PIXI` object.
	     * @namespace PIXI.extras
	     * @deprecated since 5.0.0
	     */
	    PIXI.extras = {};
	    Object.defineProperties(PIXI.extras, {
	        /**
	         * @class PIXI.extras.TilingSprite
	         * @see PIXI.TilingSprite
	         * @deprecated since 5.0.0
	         */
	        TilingSprite: {
	            get: function () {
	                deprecation(v5, 'PIXI.extras.TilingSprite class has moved to PIXI.TilingSprite');
	                return PIXI.TilingSprite;
	            },
	        },
	        /**
	         * @class PIXI.extras.TilingSpriteRenderer
	         * @see PIXI.TilingSpriteRenderer
	         * @deprecated since 5.0.0
	         */
	        TilingSpriteRenderer: {
	            get: function () {
	                deprecation(v5, 'PIXI.extras.TilingSpriteRenderer class has moved to PIXI.TilingSpriteRenderer');
	                return PIXI.TilingSpriteRenderer;
	            },
	        },
	        /**
	         * @class PIXI.extras.AnimatedSprite
	         * @see PIXI.AnimatedSprite
	         * @deprecated since 5.0.0
	         */
	        AnimatedSprite: {
	            get: function () {
	                deprecation(v5, 'PIXI.extras.AnimatedSprite class has moved to PIXI.AnimatedSprite');
	                return PIXI.AnimatedSprite;
	            },
	        },
	        /**
	         * @class PIXI.extras.BitmapText
	         * @see PIXI.BitmapText
	         * @deprecated since 5.0.0
	         */
	        BitmapText: {
	            get: function () {
	                deprecation(v5, 'PIXI.extras.BitmapText class has moved to PIXI.BitmapText');
	                return PIXI.BitmapText;
	            },
	        },
	    });
	    /**
	     * @static
	     * @method PIXI.TilingSprite.fromFrame
	     * @deprecated since 5.3.0
	     * @see PIXI.TilingSprite.from
	     */
	    PIXI.TilingSprite.fromFrame = function fromFrame(frameId, width, height) {
	        deprecation('5.3.0', 'TilingSprite.fromFrame is deprecated, use TilingSprite.from');
	        return PIXI.TilingSprite.from(frameId, { width: width, height: height });
	    };
	    /**
	     * @static
	     * @method PIXI.TilingSprite.fromImage
	     * @deprecated since 5.3.0
	     * @see PIXI.TilingSprite.from
	     */
	    PIXI.TilingSprite.fromImage = function fromImage(imageId, width, height, options) {
	        if (options === void 0) { options = {}; }
	        deprecation('5.3.0', 'TilingSprite.fromImage is deprecated, use TilingSprite.from');
	        // Fallback support for crossorigin, scaleMode parameters
	        if (options && typeof options !== 'object') {
	            options = {
	                // eslint-disable-next-line prefer-rest-params
	                scaleMode: arguments[4],
	                resourceOptions: {
	                    // eslint-disable-next-line prefer-rest-params
	                    crossorigin: arguments[3],
	                },
	            };
	        }
	        options.width = width;
	        options.height = height;
	        return PIXI.TilingSprite.from(imageId, options);
	    };
	    Object.defineProperties(PIXI.utils, {
	        /**
	         * @function PIXI.utils.getSvgSize
	         * @see PIXI.resources.SVGResource.getSize
	         * @deprecated since 5.0.0
	         */
	        getSvgSize: {
	            get: function () {
	                deprecation(v5, 'PIXI.utils.getSvgSize function has moved to PIXI.resources.SVGResource.getSize');
	                return PIXI.resources.SVGResource.getSize;
	            },
	        },
	    });
	    /**
	     * All classes on this namespace have moved to the high-level `PIXI` object.
	     * @namespace PIXI.mesh
	     * @deprecated since 5.0.0
	     */
	    PIXI.mesh = {};
	    Object.defineProperties(PIXI.mesh, {
	        /**
	         * @class PIXI.mesh.Mesh
	         * @see PIXI.SimpleMesh
	         * @deprecated since 5.0.0
	         */
	        Mesh: {
	            get: function () {
	                deprecation(v5, 'PIXI.mesh.Mesh class has moved to PIXI.SimpleMesh');
	                return PIXI.SimpleMesh;
	            },
	        },
	        /**
	         * @class PIXI.mesh.NineSlicePlane
	         * @see PIXI.NineSlicePlane
	         * @deprecated since 5.0.0
	         */
	        NineSlicePlane: {
	            get: function () {
	                deprecation(v5, 'PIXI.mesh.NineSlicePlane class has moved to PIXI.NineSlicePlane');
	                return PIXI.NineSlicePlane;
	            },
	        },
	        /**
	         * @class PIXI.mesh.Plane
	         * @see PIXI.SimplePlane
	         * @deprecated since 5.0.0
	         */
	        Plane: {
	            get: function () {
	                deprecation(v5, 'PIXI.mesh.Plane class has moved to PIXI.SimplePlane');
	                return PIXI.SimplePlane;
	            },
	        },
	        /**
	         * @class PIXI.mesh.Rope
	         * @see PIXI.SimpleRope
	         * @deprecated since 5.0.0
	         */
	        Rope: {
	            get: function () {
	                deprecation(v5, 'PIXI.mesh.Rope class has moved to PIXI.SimpleRope');
	                return PIXI.SimpleRope;
	            },
	        },
	        /**
	         * @class PIXI.mesh.RawMesh
	         * @see PIXI.Mesh
	         * @deprecated since 5.0.0
	         */
	        RawMesh: {
	            get: function () {
	                deprecation(v5, 'PIXI.mesh.RawMesh class has moved to PIXI.Mesh');
	                return PIXI.Mesh;
	            },
	        },
	        /**
	         * @class PIXI.mesh.CanvasMeshRenderer
	         * @see PIXI.CanvasMeshRenderer
	         * @deprecated since 5.0.0
	         */
	        CanvasMeshRenderer: {
	            get: function () {
	                deprecation(v5, 'PIXI.mesh.CanvasMeshRenderer class has moved to PIXI.CanvasMeshRenderer');
	                return PIXI.CanvasMeshRenderer;
	            },
	        },
	        /**
	         * @class PIXI.mesh.MeshRenderer
	         * @see PIXI.MeshRenderer
	         * @deprecated since 5.0.0
	         */
	        MeshRenderer: {
	            get: function () {
	                deprecation(v5, 'PIXI.mesh.MeshRenderer class has moved to PIXI.MeshRenderer');
	                return PIXI.MeshRenderer;
	            },
	        },
	    });
	    /**
	     * This namespace has been removed and items have been moved to
	     * the top-level `PIXI` object.
	     * @namespace PIXI.particles
	     * @deprecated since 5.0.0
	     */
	    PIXI.particles = {};
	    Object.defineProperties(PIXI.particles, {
	        /**
	         * @class PIXI.particles.ParticleContainer
	         * @deprecated since 5.0.0
	         * @see PIXI.ParticleContainer
	         */
	        ParticleContainer: {
	            get: function () {
	                deprecation(v5, 'PIXI.particles.ParticleContainer class has moved to PIXI.ParticleContainer');
	                return PIXI.ParticleContainer;
	            },
	        },
	        /**
	         * @class PIXI.particles.ParticleRenderer
	         * @deprecated since 5.0.0
	         * @see PIXI.ParticleRenderer
	         */
	        ParticleRenderer: {
	            get: function () {
	                deprecation(v5, 'PIXI.particles.ParticleRenderer class has moved to PIXI.ParticleRenderer');
	                return PIXI.ParticleRenderer;
	            },
	        },
	    });
	    /**
	     * This namespace has been removed and items have been moved to
	     * the top-level `PIXI` object.
	     * @namespace PIXI.ticker
	     * @deprecated since 5.0.0
	     */
	    PIXI.ticker = {};
	    Object.defineProperties(PIXI.ticker, {
	        /**
	         * @class PIXI.ticker.Ticker
	         * @deprecated since 5.0.0
	         * @see PIXI.Ticker
	         */
	        Ticker: {
	            get: function () {
	                deprecation(v5, 'PIXI.ticker.Ticker class has moved to PIXI.Ticker');
	                return PIXI.Ticker;
	            },
	        },
	        /**
	         * @name PIXI.ticker.shared
	         * @type {PIXI.Ticker}
	         * @deprecated since 5.0.0
	         * @see PIXI.Ticker.shared
	         */
	        shared: {
	            get: function () {
	                deprecation(v5, 'PIXI.ticker.shared instance has moved to PIXI.Ticker.shared');
	                return PIXI.Ticker.shared;
	            },
	        },
	    });
	    /**
	     * All classes on this namespace have moved to the high-level `PIXI` object.
	     * @namespace PIXI.loaders
	     * @deprecated since 5.0.0
	     */
	    PIXI.loaders = {};
	    Object.defineProperties(PIXI.loaders, {
	        /**
	         * @class PIXI.loaders.Loader
	         * @see PIXI.Loader
	         * @deprecated since 5.0.0
	         */
	        Loader: {
	            get: function () {
	                deprecation(v5, 'PIXI.loaders.Loader class has moved to PIXI.Loader');
	                return PIXI.Loader;
	            },
	        },
	        /**
	         * @class PIXI.loaders.Resource
	         * @see PIXI.LoaderResource
	         * @deprecated since 5.0.0
	         */
	        Resource: {
	            get: function () {
	                deprecation(v5, 'PIXI.loaders.Resource class has moved to PIXI.LoaderResource');
	                return PIXI.LoaderResource;
	            },
	        },
	        /**
	         * @function PIXI.loaders.bitmapFontParser
	         * @see PIXI.BitmapFontLoader.use
	         * @deprecated since 5.0.0
	         */
	        bitmapFontParser: {
	            get: function () {
	                deprecation(v5, 'PIXI.loaders.bitmapFontParser function has moved to PIXI.BitmapFontLoader.use');
	                return PIXI.BitmapFontLoader.use;
	            },
	        },
	        /**
	         * @function PIXI.loaders.parseBitmapFontData
	         * @deprecated since 5.0.0
	         */
	        parseBitmapFontData: {
	            get: function () {
	                deprecation(v5, 'PIXI.loaders.parseBitmapFontData function has removed');
	            },
	        },
	        /**
	         * @function PIXI.loaders.spritesheetParser
	         * @see PIXI.SpritesheetLoader.use
	         * @deprecated since 5.0.0
	         */
	        spritesheetParser: {
	            get: function () {
	                deprecation(v5, 'PIXI.loaders.spritesheetParser function has moved to PIXI.SpritesheetLoader.use');
	                return PIXI.SpritesheetLoader.use;
	            },
	        },
	        /**
	         * @function PIXI.loaders.getResourcePath
	         * @see PIXI.SpritesheetLoader.getResourcePath
	         * @deprecated since 5.0.0
	         */
	        getResourcePath: {
	            get: function () {
	                deprecation(v5, 'PIXI.loaders.getResourcePath property has moved to PIXI.SpritesheetLoader.getResourcePath');
	                return PIXI.SpritesheetLoader.getResourcePath;
	            },
	        },
	    });
	    /**
	     * @function PIXI.loaders.Loader.addPixiMiddleware
	     * @see PIXI.Loader.registerPlugin
	     * @deprecated since 5.0.0
	     * @param {function} middleware
	     */
	    PIXI.Loader.addPixiMiddleware = function addPixiMiddleware(middleware) {
	        deprecation(v5, 'PIXI.loaders.Loader.addPixiMiddleware function is deprecated, use PIXI.loaders.Loader.registerPlugin');
	        return PIXI.loaders.Loader.registerPlugin({ use: middleware() });
	    };
	    // convenience for converting event name to signal name
	    var eventToSignal = function (event) {
	        return "on" + event.charAt(0).toUpperCase() + event.slice(1);
	    };
	    Object.assign(PIXI.Loader.prototype, {
	        /**
	         * Use the corresponding signal, e.g., event `start`` is signal `onStart`.
	         * @method PIXI.Loader#on
	         * @deprecated since 5.0.0
	         */
	        on: function (event) {
	            var signal = eventToSignal(event);
	            deprecation(v5, "PIXI.Loader#on is completely deprecated, use PIXI.Loader#" + signal + ".add");
	        },
	        /**
	         * Use the corresponding signal, e.g., event `start`` is signal `onStart`.
	         * @method PIXI.Loader#once
	         * @deprecated since 5.0.0
	         */
	        once: function (event) {
	            var signal = eventToSignal(event);
	            deprecation(v5, "PIXI.Loader#once is completely deprecated, use PIXI.Loader#" + signal + ".once");
	        },
	        /**
	         * Use the corresponding signal, e.g., event `start`` is signal `onStart`.
	         * @method PIXI.Loader#off
	         * @deprecated since 5.0.0
	         */
	        off: function (event) {
	            var signal = eventToSignal(event);
	            deprecation(v5, "PIXI.Loader#off is completely deprecated, use PIXI.Loader#" + signal + ".detach");
	        },
	    });
	    /**
	     * @class PIXI.extract.WebGLExtract
	     * @deprecated since 5.0.0
	     * @see PIXI.Extract
	     */
	    Object.defineProperty(PIXI.extract, 'WebGLExtract', {
	        get: function () {
	            deprecation(v5, 'PIXI.extract.WebGLExtract method has moved to PIXI.Extract');
	            return PIXI.Extract;
	        },
	    });
	    /**
	     * @class PIXI.prepare.WebGLPrepare
	     * @deprecated since 5.0.0
	     * @see PIXI.Prepare
	     */
	    Object.defineProperty(PIXI.prepare, 'WebGLPrepare', {
	        get: function () {
	            deprecation(v5, 'PIXI.prepare.WebGLPrepare class has moved to PIXI.Prepare');
	            return PIXI.Prepare;
	        },
	    });
	    /**
	     * @method PIXI.Container#_renderWebGL
	     * @private
	     * @deprecated since 5.0.0
	     * @see PIXI.Container#render
	     * @param {PIXI.Renderer} renderer Instance of renderer
	     */
	    PIXI.Container.prototype._renderWebGL = function _renderWebGL(renderer) {
	        deprecation(v5, 'PIXI.Container._renderWebGL method has moved to PIXI.Container._render');
	        this._render(renderer);
	    };
	    /**
	     * @method PIXI.Container#renderWebGL
	     * @deprecated since 5.0.0
	     * @see PIXI.Container#render
	     * @param {PIXI.Renderer} renderer Instance of renderer
	     */
	    PIXI.Container.prototype.renderWebGL = function renderWebGL(renderer) {
	        deprecation(v5, 'PIXI.Container.renderWebGL method has moved to PIXI.Container.render');
	        this.render(renderer);
	    };
	    /**
	     * @method PIXI.DisplayObject#renderWebGL
	     * @deprecated since 5.0.0
	     * @see PIXI.DisplayObject#render
	     * @param {PIXI.Renderer} renderer Instance of renderer
	     */
	    PIXI.DisplayObject.prototype.renderWebGL = function renderWebGL(renderer) {
	        deprecation(v5, 'PIXI.DisplayObject.renderWebGL method has moved to PIXI.DisplayObject.render');
	        this.render(renderer);
	    };
	    /**
	     * @method PIXI.Container#renderAdvancedWebGL
	     * @deprecated since 5.0.0
	     * @see PIXI.Container#renderAdvanced
	     * @param {PIXI.Renderer} renderer Instance of renderer
	     */
	    PIXI.Container.prototype.renderAdvancedWebGL = function renderAdvancedWebGL(renderer) {
	        deprecation(v5, 'PIXI.Container.renderAdvancedWebGL method has moved to PIXI.Container.renderAdvanced');
	        this.renderAdvanced(renderer);
	    };
	    Object.defineProperties(PIXI.settings, {
	        /**
	         * Default transform type.
	         *
	         * @static
	         * @deprecated since 5.0.0
	         * @memberof PIXI.settings
	         * @type {PIXI.TRANSFORM_MODE}
	         * @default PIXI.TRANSFORM_MODE.STATIC
	         */
	        TRANSFORM_MODE: {
	            get: function () {
	                deprecation(v5, 'PIXI.settings.TRANSFORM_MODE property has been removed');
	                return 0;
	            },
	            set: function () {
	                deprecation(v5, 'PIXI.settings.TRANSFORM_MODE property has been removed');
	            },
	        },
	    });
	    var BaseTextureAny = PIXI.BaseTexture;
	    /**
	     * @method loadSource
	     * @memberof PIXI.BaseTexture#
	     * @deprecated since 5.0.0
	     */
	    BaseTextureAny.prototype.loadSource = function loadSource(image) {
	        deprecation(v5, 'PIXI.BaseTexture.loadSource method has been deprecated');
	        var resource = PIXI.resources.autoDetectResource(image);
	        resource.internal = true;
	        this.setResource(resource);
	        this.update();
	    };
	    var baseTextureIdDeprecation = false;
	    Object.defineProperties(BaseTextureAny.prototype, {
	        /**
	         * @name PIXI.BaseTexture#hasLoaded
	         * @type {boolean}
	         * @deprecated since 5.0.0
	         * @readonly
	         * @see PIXI.BaseTexture#valid
	         */
	        hasLoaded: {
	            get: function () {
	                deprecation(v5, 'PIXI.BaseTexture.hasLoaded property has been removed, use PIXI.BaseTexture.valid');
	                return this.valid;
	            },
	        },
	        /**
	         * @name PIXI.BaseTexture#imageUrl
	         * @type {string}
	         * @deprecated since 5.0.0
	         * @see PIXI.resources.ImageResource#url
	         */
	        imageUrl: {
	            get: function () {
	                var _a;
	                deprecation(v5, 'PIXI.BaseTexture.imageUrl property has been removed, use PIXI.BaseTexture.resource.url');
	                return (_a = this.resource) === null || _a === void 0 ? void 0 : _a.url;
	            },
	            set: function (imageUrl) {
	                deprecation(v5, 'PIXI.BaseTexture.imageUrl property has been removed, use PIXI.BaseTexture.resource.url');
	                if (this.resource) {
	                    this.resource.url = imageUrl;
	                }
	            },
	        },
	        /**
	         * @name PIXI.BaseTexture#source
	         * @type {HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|SVGElement}
	         * @deprecated since 5.0.0
	         * @readonly
	         * @see PIXI.resources.BaseImageResource#source
	         */
	        source: {
	            get: function () {
	                deprecation(v5, 'PIXI.BaseTexture.source property has been moved, use `PIXI.BaseTexture.resource.source`');
	                return this.resource.source;
	            },
	            set: function (source) {
	                deprecation(v5, 'PIXI.BaseTexture.source property has been moved, use `PIXI.BaseTexture.resource.source` '
	                    + 'if you want to set HTMLCanvasElement. Otherwise, create new BaseTexture.');
	                if (this.resource) {
	                    this.resource.source = source;
	                }
	            },
	        },
	        /**
	         * @name PIXI.BaseTexture#premultiplyAlpha
	         * @type {boolean}
	         * @deprecated since 5.2.0
	         * @readonly
	         * @see PIXI.BaseTexture#alphaMode
	         */
	        premultiplyAlpha: {
	            get: function () {
	                deprecation('5.2.0', 'PIXI.BaseTexture.premultiplyAlpha property has been changed to `alphaMode`'
	                    + ', see `PIXI.ALPHA_MODES`');
	                return this.alphaMode !== 0;
	            },
	            set: function (value) {
	                deprecation('5.2.0', 'PIXI.BaseTexture.premultiplyAlpha property has been changed to `alphaMode`'
	                    + ', see `PIXI.ALPHA_MODES`');
	                this.alphaMode = Number(value);
	            },
	        },
	        /**
	         * Batch local field, stores current texture location
	         *
	         * @name PIXI.BaseTexture#_id
	         * @deprecated since 5.2.0
	         * @type {number}
	         * @see PIXI.BaseTexture#_batchLocation
	         */
	        _id: {
	            get: function () {
	                if (!baseTextureIdDeprecation) {
	                    // #popelyshev: That property was a hot place, I don't want to call deprecation method on it if possible
	                    deprecation('5.2.0', 'PIXI.BaseTexture._id batch local field has been changed to `_batchLocation`');
	                    baseTextureIdDeprecation = true;
	                }
	                return this._batchLocation;
	            },
	            set: function (value) {
	                this._batchLocation = value;
	            },
	        },
	    });
	    /**
	     * @method fromImage
	     * @static
	     * @memberof PIXI.BaseTexture
	     * @deprecated since 5.0.0
	     * @see PIXI.BaseTexture.from
	     */
	    BaseTextureAny.fromImage = function fromImage(canvas, crossorigin, scaleMode, scale) {
	        deprecation(v5, 'PIXI.BaseTexture.fromImage method has been replaced with PIXI.BaseTexture.from');
	        var resourceOptions = { scale: scale, crossorigin: crossorigin };
	        return BaseTextureAny.from(canvas, { scaleMode: scaleMode, resourceOptions: resourceOptions });
	    };
	    /**
	     * @method fromCanvas
	     * @static
	     * @memberof PIXI.BaseTexture
	     * @deprecated since 5.0.0
	     * @see PIXI.BaseTexture.from
	     */
	    BaseTextureAny.fromCanvas = function fromCanvas(canvas, scaleMode) {
	        deprecation(v5, 'PIXI.BaseTexture.fromCanvas method has been replaced with PIXI.BaseTexture.from');
	        return BaseTextureAny.from(canvas, { scaleMode: scaleMode });
	    };
	    /**
	     * @method fromSVG
	     * @static
	     * @memberof PIXI.BaseTexture
	     * @deprecated since 5.0.0
	     * @see PIXI.BaseTexture.from
	     */
	    BaseTextureAny.fromSVG = function fromSVG(canvas, crossorigin, scaleMode, scale) {
	        deprecation(v5, 'PIXI.BaseTexture.fromSVG method has been replaced with PIXI.BaseTexture.from');
	        var resourceOptions = { scale: scale, crossorigin: crossorigin };
	        return BaseTextureAny.from(canvas, { scaleMode: scaleMode, resourceOptions: resourceOptions });
	    };
	    Object.defineProperties(PIXI.resources.ImageResource.prototype, {
	        /**
	         * @name PIXI.resources.ImageResource#premultiplyAlpha
	         * @type {boolean}
	         * @deprecated since 5.2.0
	         * @readonly
	         * @see PIXI.resources.ImageResource#alphaMode
	         */
	        premultiplyAlpha: {
	            get: function () {
	                deprecation('5.2.0', 'PIXI.resources.ImageResource.premultiplyAlpha property '
	                    + 'has been changed to `alphaMode`, see `PIXI.ALPHA_MODES`');
	                return this.alphaMode !== 0;
	            },
	            set: function (value) {
	                deprecation('5.2.0', 'PIXI.resources.ImageResource.premultiplyAlpha property '
	                    + 'has been changed to `alphaMode`, see `PIXI.ALPHA_MODES`');
	                this.alphaMode = Number(value);
	            },
	        },
	    });
	    /**
	     * @method PIXI.Point#copy
	     * @deprecated since 5.0.0
	     * @see PIXI.Point#copyFrom
	     */
	    PIXI.Point.prototype.copy = function copy(p) {
	        deprecation(v5, 'PIXI.Point.copy method has been replaced with PIXI.Point.copyFrom');
	        return this.copyFrom(p);
	    };
	    /**
	     * @method PIXI.ObservablePoint#copy
	     * @deprecated since 5.0.0
	     * @see PIXI.ObservablePoint#copyFrom
	     */
	    PIXI.ObservablePoint.prototype.copy = function copy(p) {
	        deprecation(v5, 'PIXI.ObservablePoint.copy method has been replaced with PIXI.ObservablePoint.copyFrom');
	        return this.copyFrom(p);
	    };
	    /**
	     * @method PIXI.Rectangle#copy
	     * @deprecated since 5.0.0
	     * @see PIXI.Rectangle#copyFrom
	     */
	    PIXI.Rectangle.prototype.copy = function copy(p) {
	        deprecation(v5, 'PIXI.Rectangle.copy method has been replaced with PIXI.Rectangle.copyFrom');
	        return this.copyFrom(p);
	    };
	    /**
	     * @method PIXI.Matrix#copy
	     * @deprecated since 5.0.0
	     * @see PIXI.Matrix#copyTo
	     */
	    PIXI.Matrix.prototype.copy = function copy(p) {
	        deprecation(v5, 'PIXI.Matrix.copy method has been replaced with PIXI.Matrix.copyTo');
	        return this.copyTo(p);
	    };
	    /**
	     * @method PIXI.systems.StateSystem#setState
	     * @deprecated since 5.1.0
	     * @see PIXI.systems.StateSystem#set
	     */
	    PIXI.systems.StateSystem.prototype.setState = function setState(s) {
	        deprecation('v5.1.0', 'StateSystem.setState has been renamed to StateSystem.set');
	        return this.set(s);
	    };
	    Object.assign(PIXI.systems.FilterSystem.prototype, {
	        /**
	         * @method PIXI.FilterManager#getRenderTarget
	         * @deprecated since 5.0.0
	         * @see PIXI.systems.FilterSystem#getFilterTexture
	         */
	        getRenderTarget: function (_clear, resolution) {
	            deprecation(v5, 'PIXI.FilterManager.getRenderTarget method has been replaced with PIXI.systems.FilterSystem#getFilterTexture');
	            return this.getFilterTexture(null, resolution);
	        },
	        /**
	         * @method PIXI.FilterManager#returnRenderTarget
	         * @deprecated since 5.0.0
	         * @see PIXI.systems.FilterSystem#returnFilterTexture
	         */
	        returnRenderTarget: function (renderTexture) {
	            deprecation(v5, 'PIXI.FilterManager.returnRenderTarget method has been replaced with '
	                + 'PIXI.systems.FilterSystem.returnFilterTexture');
	            this.returnFilterTexture(renderTexture);
	        },
	        /**
	         * @method PIXI.systems.FilterSystem#calculateScreenSpaceMatrix
	         * @deprecated since 5.0.0
	         * @param {PIXI.Matrix} outputMatrix - the matrix to output to.
	         * @return {PIXI.Matrix} The mapped matrix.
	         */
	        calculateScreenSpaceMatrix: function (outputMatrix) {
	            deprecation(v5, 'PIXI.systems.FilterSystem.calculateScreenSpaceMatrix method is removed, '
	                + 'use `(vTextureCoord * inputSize.xy) + outputFrame.xy` instead');
	            var mappedMatrix = outputMatrix.identity();
	            var _a = this.activeState, sourceFrame = _a.sourceFrame, destinationFrame = _a.destinationFrame;
	            mappedMatrix.translate(sourceFrame.x / destinationFrame.width, sourceFrame.y / destinationFrame.height);
	            mappedMatrix.scale(destinationFrame.width, destinationFrame.height);
	            return mappedMatrix;
	        },
	        /**
	         * @method PIXI.systems.FilterSystem#calculateNormalizedScreenSpaceMatrix
	         * @deprecated since 5.0.0
	         * @param {PIXI.Matrix} outputMatrix - The matrix to output to.
	         * @return {PIXI.Matrix} The mapped matrix.
	         */
	        calculateNormalizedScreenSpaceMatrix: function (outputMatrix) {
	            deprecation(v5, 'PIXI.systems.FilterManager.calculateNormalizedScreenSpaceMatrix method is removed, '
	                + 'use `((vTextureCoord * inputSize.xy) + outputFrame.xy) / outputFrame.zw` instead.');
	            var _a = this.activeState, sourceFrame = _a.sourceFrame, destinationFrame = _a.destinationFrame;
	            var mappedMatrix = outputMatrix.identity();
	            mappedMatrix.translate(sourceFrame.x / destinationFrame.width, sourceFrame.y / destinationFrame.height);
	            var translateScaleX = (destinationFrame.width / sourceFrame.width);
	            var translateScaleY = (destinationFrame.height / sourceFrame.height);
	            mappedMatrix.scale(translateScaleX, translateScaleY);
	            return mappedMatrix;
	        },
	    });
	    Object.defineProperties(PIXI.RenderTexture.prototype, {
	        /**
	         * @name PIXI.RenderTexture#sourceFrame
	         * @type {PIXI.Rectangle}
	         * @deprecated since 5.0.0
	         * @readonly
	         */
	        sourceFrame: {
	            get: function () {
	                deprecation(v5, 'PIXI.RenderTexture.sourceFrame property has been removed');
	                return this.filterFrame;
	            },
	        },
	        /**
	         * @name PIXI.RenderTexture#size
	         * @type {PIXI.Rectangle}
	         * @deprecated since 5.0.0
	         * @readonly
	         */
	        size: {
	            get: function () {
	                deprecation(v5, 'PIXI.RenderTexture.size property has been removed');
	                return this._frame;
	            },
	        },
	    });
	    /**
	     * @class BlurXFilter
	     * @memberof PIXI.filters
	     * @deprecated since 5.0.0
	     * @see PIXI.filters.BlurFilterPass
	     */
	    var BlurXFilter = /** @class */ (function (_super) {
	        __extends$k(BlurXFilter, _super);
	        function BlurXFilter(strength, quality, resolution, kernelSize) {
	            var _this = this;
	            deprecation(v5, 'PIXI.filters.BlurXFilter class is deprecated, use PIXI.filters.BlurFilterPass');
	            _this = _super.call(this, true, strength, quality, resolution, kernelSize) || this;
	            return _this;
	        }
	        return BlurXFilter;
	    }(PIXI.filters.BlurFilterPass));
	    /**
	     * @class BlurYFilter
	     * @memberof PIXI.filters
	     * @deprecated since 5.0.0
	     * @see PIXI.filters.BlurFilterPass
	     */
	    var BlurYFilter = /** @class */ (function (_super) {
	        __extends$k(BlurYFilter, _super);
	        function BlurYFilter(strength, quality, resolution, kernelSize) {
	            var _this = this;
	            deprecation(v5, 'PIXI.filters.BlurYFilter class is deprecated, use PIXI.filters.BlurFilterPass');
	            _this = _super.call(this, false, strength, quality, resolution, kernelSize) || this;
	            return _this;
	        }
	        return BlurYFilter;
	    }(PIXI.filters.BlurFilterPass));
	    Object.assign(PIXI.filters, {
	        BlurXFilter: BlurXFilter,
	        BlurYFilter: BlurYFilter,
	    });
	    var SpriteAny = PIXI.Sprite, TextureAny = PIXI.Texture, GraphicsAny = PIXI.Graphics;
	    // Support for pixi.js-legacy bifurcation
	    // give users a friendly assist to use legacy
	    if (!GraphicsAny.prototype.generateCanvasTexture) {
	        GraphicsAny.prototype.generateCanvasTexture = function generateCanvasTexture() {
	            deprecation(v5, 'PIXI.Graphics.generateCanvasTexture method is only available in "pixi.js-legacy"');
	        };
	    }
	    /**
	     * @deprecated since 5.0.0
	     * @member {PIXI.Graphics} PIXI.Graphics#graphicsData
	     * @see PIXI.Graphics#geometry
	     * @readonly
	     */
	    Object.defineProperty(GraphicsAny.prototype, 'graphicsData', {
	        get: function () {
	            deprecation(v5, 'PIXI.Graphics.graphicsData property is deprecated, use PIXI.Graphics.geometry.graphicsData');
	            return this.geometry.graphicsData;
	        },
	    });
	    // Use these to deprecate all the Sprite from* methods
	    function spriteFrom(name, source, crossorigin, scaleMode) {
	        deprecation(v5, "PIXI.Sprite." + name + " method is deprecated, use PIXI.Sprite.from");
	        return SpriteAny.from(source, {
	            resourceOptions: {
	                scale: scaleMode,
	                crossorigin: crossorigin,
	            },
	        });
	    }
	    /**
	     * @deprecated since 5.0.0
	     * @see PIXI.Sprite.from
	     * @method PIXI.Sprite.fromImage
	     * @return {PIXI.Sprite}
	     */
	    SpriteAny.fromImage = spriteFrom.bind(null, 'fromImage');
	    /**
	     * @deprecated since 5.0.0
	     * @method PIXI.Sprite.fromSVG
	     * @see PIXI.Sprite.from
	     * @return {PIXI.Sprite}
	     */
	    SpriteAny.fromSVG = spriteFrom.bind(null, 'fromSVG');
	    /**
	     * @deprecated since 5.0.0
	     * @method PIXI.Sprite.fromCanvas
	     * @see PIXI.Sprite.from
	     * @return {PIXI.Sprite}
	     */
	    SpriteAny.fromCanvas = spriteFrom.bind(null, 'fromCanvas');
	    /**
	     * @deprecated since 5.0.0
	     * @method PIXI.Sprite.fromVideo
	     * @see PIXI.Sprite.from
	     * @return {PIXI.Sprite}
	     */
	    SpriteAny.fromVideo = spriteFrom.bind(null, 'fromVideo');
	    /**
	     * @deprecated since 5.0.0
	     * @method PIXI.Sprite.fromFrame
	     * @see PIXI.Sprite.from
	     * @return {PIXI.Sprite}
	     */
	    SpriteAny.fromFrame = spriteFrom.bind(null, 'fromFrame');
	    // Use these to deprecate all the Texture from* methods
	    function textureFrom(name, source, crossorigin, scaleMode) {
	        deprecation(v5, "PIXI.Texture." + name + " method is deprecated, use PIXI.Texture.from");
	        return TextureAny.from(source, {
	            resourceOptions: {
	                scale: scaleMode,
	                crossorigin: crossorigin,
	            },
	        });
	    }
	    /**
	     * @deprecated since 5.0.0
	     * @method PIXI.Texture.fromImage
	     * @see PIXI.Texture.from
	     * @return {PIXI.Texture}
	     */
	    TextureAny.fromImage = textureFrom.bind(null, 'fromImage');
	    /**
	     * @deprecated since 5.0.0
	     * @method PIXI.Texture.fromSVG
	     * @see PIXI.Texture.from
	     * @return {PIXI.Texture}
	     */
	    TextureAny.fromSVG = textureFrom.bind(null, 'fromSVG');
	    /**
	     * @deprecated since 5.0.0
	     * @method PIXI.Texture.fromCanvas
	     * @see PIXI.Texture.from
	     * @return {PIXI.Texture}
	     */
	    TextureAny.fromCanvas = textureFrom.bind(null, 'fromCanvas');
	    /**
	     * @deprecated since 5.0.0
	     * @method PIXI.Texture.fromVideo
	     * @see PIXI.Texture.from
	     * @return {PIXI.Texture}
	     */
	    TextureAny.fromVideo = textureFrom.bind(null, 'fromVideo');
	    /**
	     * @deprecated since 5.0.0
	     * @method PIXI.Texture.fromFrame
	     * @see PIXI.Texture.from
	     * @return {PIXI.Texture}
	     */
	    TextureAny.fromFrame = textureFrom.bind(null, 'fromFrame');
	    /**
	     * @deprecated since 5.0.0
	     * @member {boolean} PIXI.AbstractRenderer#autoResize
	     * @see PIXI.AbstractRenderer#autoDensity
	     */
	    Object.defineProperty(PIXI.AbstractRenderer.prototype, 'autoResize', {
	        get: function () {
	            deprecation(v5, 'PIXI.AbstractRenderer.autoResize property is deprecated, '
	                + 'use PIXI.AbstractRenderer.autoDensity');
	            return this.autoDensity;
	        },
	        set: function (value) {
	            deprecation(v5, 'PIXI.AbstractRenderer.autoResize property is deprecated, '
	                + 'use PIXI.AbstractRenderer.autoDensity');
	            this.autoDensity = value;
	        },
	    });
	    /**
	     * @deprecated since 5.0.0
	     * @member {PIXI.systems.TextureSystem} PIXI.Renderer#textureManager
	     * @see PIXI.Renderer#texture
	     */
	    Object.defineProperty(PIXI.Renderer.prototype, 'textureManager', {
	        get: function () {
	            deprecation(v5, 'PIXI.Renderer.textureManager property is deprecated, use PIXI.Renderer.texture');
	            return this.texture;
	        },
	    });
	    /**
	     * @namespace PIXI.utils.mixins
	     * @deprecated since 5.0.0
	     */
	    PIXI.utils.mixins = {
	        /**
	         * @memberof PIXI.utils.mixins
	         * @function mixin
	         * @deprecated since 5.0.0
	         */
	        mixin: function () {
	            deprecation(v5, 'PIXI.utils.mixins.mixin function is no longer available');
	        },
	        /**
	         * @memberof PIXI.utils.mixins
	         * @function delayMixin
	         * @deprecated since 5.0.0
	         */
	        delayMixin: function () {
	            deprecation(v5, 'PIXI.utils.mixins.delayMixin function is no longer available');
	        },
	        /**
	         * @memberof PIXI.utils.mixins
	         * @function performMixins
	         * @deprecated since 5.0.0
	         */
	        performMixins: function () {
	            deprecation(v5, 'PIXI.utils.mixins.performMixins function is no longer available');
	        },
	    };
	    /**
	     * @memberof PIXI.BitmapText
	     * @member {object} font
	     * @deprecated since 5.3.0
	     */
	    Object.defineProperty(PIXI.BitmapText.prototype, 'font', {
	        get: function () {
	            deprecation('5.3.0', 'PIXI.BitmapText.font property is deprecated, '
	                + 'use fontName, fontSize, tint or align properties');
	            return {
	                name: this._fontName,
	                size: this._fontSize,
	                tint: this._tint,
	                align: this._align,
	            };
	        },
	        set: function (value) {
	            deprecation('5.3.0', 'PIXI.BitmapText.font property is deprecated, '
	                + 'use fontName, fontSize, tint or align properties');
	            if (!value) {
	                return;
	            }
	            var style = { font: value };
	            this._upgradeStyle(style);
	            style.fontSize = style.fontSize || PIXI.BitmapFont.available[style.fontName].size;
	            this._fontName = style.fontName;
	            this._fontSize = style.fontSize;
	            this.dirty = true;
	        },
	    });
	}

	// Install renderer plugins
	Renderer.registerPlugin('accessibility', AccessibilityManager);
	Renderer.registerPlugin('extract', Extract);
	Renderer.registerPlugin('interaction', InteractionManager);
	Renderer.registerPlugin('particle', ParticleRenderer);
	Renderer.registerPlugin('prepare', Prepare);
	Renderer.registerPlugin('batch', BatchRenderer);
	Renderer.registerPlugin('tilingSprite', TilingSpriteRenderer);
	Loader$1.registerPlugin(BitmapFontLoader);
	Loader$1.registerPlugin(SpritesheetLoader);
	Application.registerPlugin(TickerPlugin);
	Application.registerPlugin(AppLoaderPlugin);
	/**
	 * String of the current PIXI version.
	 *
	 * @static
	 * @constant
	 * @memberof PIXI
	 * @name VERSION
	 * @type {string}
	 */
	var VERSION$1 = '5.3.11';
	/**
	 * @namespace PIXI
	 */
	/**
	 * This namespace contains WebGL-only display filters that can be applied
	 * to DisplayObjects using the {@link PIXI.DisplayObject#filters filters} property.
	 *
	 * Since PixiJS only had a handful of built-in filters, additional filters
	 * can be downloaded {@link https://github.com/pixijs/pixi-filters here} from the
	 * PixiJS Filters repository.
	 *
	 * All filters must extend {@link PIXI.Filter}.
	 *
	 * @example
	 * // Create a new application
	 * const app = new PIXI.Application();
	 *
	 * // Draw a green rectangle
	 * const rect = new PIXI.Graphics()
	 *     .beginFill(0x00ff00)
	 *     .drawRect(40, 40, 200, 200);
	 *
	 * // Add a blur filter
	 * rect.filters = [new PIXI.filters.BlurFilter()];
	 *
	 * // Display rectangle
	 * app.stage.addChild(rect);
	 * document.body.appendChild(app.view);
	 * @namespace PIXI.filters
	 */
	var filters = {
	    AlphaFilter: AlphaFilter,
	    BlurFilter: BlurFilter,
	    BlurFilterPass: BlurFilterPass,
	    ColorMatrixFilter: ColorMatrixFilter,
	    DisplacementFilter: DisplacementFilter,
	    FXAAFilter: FXAAFilter,
	    NoiseFilter: NoiseFilter,
	};

	/*!
	 * @pixi/canvas-renderer - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/canvas-renderer is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$l = function(d, b) {
	    extendStatics$l = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$l(d, b);
	};

	function __extends$l(d, b) {
	    extendStatics$l(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	/**
	 * A set of functions used to handle masking.
	 *
	 * Sprite masking is not supported on the CanvasRenderer.
	 *
	 * @class
	 * @memberof PIXI
	 */
	var CanvasMaskManager = /** @class */ (function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
	     */
	    function CanvasMaskManager(renderer) {
	        this.renderer = renderer;
	        this._foundShapes = [];
	    }
	    /**
	     * This method adds it to the current stack of masks.
	     *
	     * @param {PIXI.MaskData | PIXI.Graphics} maskData - the maskData that will be pushed
	     */
	    CanvasMaskManager.prototype.pushMask = function (maskData) {
	        var renderer = this.renderer;
	        var maskObject = (maskData.maskObject || maskData);
	        renderer.context.save();
	        // TODO support sprite alpha masks??
	        // lots of effort required. If demand is great enough..
	        var foundShapes = this._foundShapes;
	        this.recursiveFindShapes(maskObject, foundShapes);
	        if (foundShapes.length > 0) {
	            var context = renderer.context;
	            context.beginPath();
	            for (var i = 0; i < foundShapes.length; i++) {
	                var shape = foundShapes[i];
	                var transform = shape.transform.worldTransform;
	                this.renderer.setContextTransform(transform);
	                this.renderGraphicsShape(shape);
	            }
	            foundShapes.length = 0;
	            context.clip();
	        }
	    };
	    /**
	     * Renders all PIXI.Graphics shapes in a subtree.
	     *
	     * @param {PIXI.Container} container - container to scan.
	     * @param {PIXI.Graphics[]} out - where to put found shapes
	     */
	    CanvasMaskManager.prototype.recursiveFindShapes = function (container, out) {
	        if (container.geometry && container.geometry.graphicsData) {
	            out.push(container);
	        }
	        var children = container.children;
	        if (children) {
	            for (var i = 0; i < children.length; i++) {
	                this.recursiveFindShapes(children[i], out);
	            }
	        }
	    };
	    /**
	     * Renders a PIXI.Graphics shape.
	     *
	     * @param {PIXI.Graphics} graphics - The object to render.
	     */
	    CanvasMaskManager.prototype.renderGraphicsShape = function (graphics) {
	        graphics.finishPoly();
	        var context = this.renderer.context;
	        var graphicsData = graphics.geometry.graphicsData;
	        var len = graphicsData.length;
	        if (len === 0) {
	            return;
	        }
	        for (var i = 0; i < len; i++) {
	            var data = graphicsData[i];
	            var shape = data.shape;
	            if (shape.type === exports.SHAPES.POLY) {
	                var points = shape.points;
	                context.moveTo(points[0], points[1]);
	                for (var j = 1; j < points.length / 2; j++) {
	                    context.lineTo(points[j * 2], points[(j * 2) + 1]);
	                }
	                // if the first and last point are the same close the path - much neater :)
	                if (points[0] === points[points.length - 2] && points[1] === points[points.length - 1]) {
	                    context.closePath();
	                }
	            }
	            else if (shape.type === exports.SHAPES.RECT) {
	                context.rect(shape.x, shape.y, shape.width, shape.height);
	                context.closePath();
	            }
	            else if (shape.type === exports.SHAPES.CIRC) {
	                // TODO - need to be Undefined!
	                context.arc(shape.x, shape.y, shape.radius, 0, 2 * Math.PI);
	                context.closePath();
	            }
	            else if (shape.type === exports.SHAPES.ELIP) {
	                // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
	                var w = shape.width * 2;
	                var h = shape.height * 2;
	                var x = shape.x - (w / 2);
	                var y = shape.y - (h / 2);
	                var kappa = 0.5522848;
	                var ox = (w / 2) * kappa; // control point offset horizontal
	                var oy = (h / 2) * kappa; // control point offset vertical
	                var xe = x + w; // x-end
	                var ye = y + h; // y-end
	                var xm = x + (w / 2); // x-middle
	                var ym = y + (h / 2); // y-middle
	                context.moveTo(x, ym);
	                context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
	                context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
	                context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
	                context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
	                context.closePath();
	            }
	            else if (shape.type === exports.SHAPES.RREC) {
	                var rx = shape.x;
	                var ry = shape.y;
	                var width = shape.width;
	                var height = shape.height;
	                var radius = shape.radius;
	                var maxRadius = Math.min(width, height) / 2 | 0;
	                radius = radius > maxRadius ? maxRadius : radius;
	                context.moveTo(rx, ry + radius);
	                context.lineTo(rx, ry + height - radius);
	                context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
	                context.lineTo(rx + width - radius, ry + height);
	                context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
	                context.lineTo(rx + width, ry + radius);
	                context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
	                context.lineTo(rx + radius, ry);
	                context.quadraticCurveTo(rx, ry, rx, ry + radius);
	                context.closePath();
	            }
	        }
	    };
	    /**
	     * Restores the current drawing context to the state it was before the mask was applied.
	     *
	     * @param {PIXI.CanvasRenderer} renderer - The renderer context to use.
	     */
	    CanvasMaskManager.prototype.popMask = function (renderer) {
	        renderer.context.restore();
	        renderer.invalidateBlendMode();
	    };
	    /**
	     * Destroys this canvas mask manager.
	     *
	     */
	    CanvasMaskManager.prototype.destroy = function () {
	        /* empty */
	    };
	    return CanvasMaskManager;
	}());

	/**
	 * Creates a little colored canvas
	 *
	 * @ignore
	 * @param {string} color - The color to make the canvas
	 * @return {canvas} a small canvas element
	 */
	function createColoredCanvas(color) {
	    var canvas = document.createElement('canvas');
	    canvas.width = 6;
	    canvas.height = 1;
	    var context = canvas.getContext('2d');
	    context.fillStyle = color;
	    context.fillRect(0, 0, 6, 1);
	    return canvas;
	}
	/**
	 * Checks whether the Canvas BlendModes are supported by the current browser
	 *
	 * @private
	 * @return {boolean} whether they are supported
	 */
	function canUseNewCanvasBlendModes() {
	    if (typeof document === 'undefined') {
	        return false;
	    }
	    var magenta = createColoredCanvas('#ff00ff');
	    var yellow = createColoredCanvas('#ffff00');
	    var canvas = document.createElement('canvas');
	    canvas.width = 6;
	    canvas.height = 1;
	    var context = canvas.getContext('2d');
	    context.globalCompositeOperation = 'multiply';
	    context.drawImage(magenta, 0, 0);
	    context.drawImage(yellow, 2, 0);
	    var imageData = context.getImageData(2, 0, 1, 1);
	    if (!imageData) {
	        return false;
	    }
	    var data = imageData.data;
	    return (data[0] === 255 && data[1] === 0 && data[2] === 0);
	}

	/**
	 * Maps blend combinations to Canvas.
	 *
	 * @memberof PIXI
	 * @function mapCanvasBlendModesToPixi
	 * @private
	 * @param {string[]} [array=[]] - The array to output into.
	 * @return {string[]} Mapped modes.
	 */
	function mapCanvasBlendModesToPixi(array) {
	    if (array === void 0) { array = []; }
	    if (canUseNewCanvasBlendModes()) {
	        array[exports.BLEND_MODES.NORMAL] = 'source-over';
	        array[exports.BLEND_MODES.ADD] = 'lighter'; // IS THIS OK???
	        array[exports.BLEND_MODES.MULTIPLY] = 'multiply';
	        array[exports.BLEND_MODES.SCREEN] = 'screen';
	        array[exports.BLEND_MODES.OVERLAY] = 'overlay';
	        array[exports.BLEND_MODES.DARKEN] = 'darken';
	        array[exports.BLEND_MODES.LIGHTEN] = 'lighten';
	        array[exports.BLEND_MODES.COLOR_DODGE] = 'color-dodge';
	        array[exports.BLEND_MODES.COLOR_BURN] = 'color-burn';
	        array[exports.BLEND_MODES.HARD_LIGHT] = 'hard-light';
	        array[exports.BLEND_MODES.SOFT_LIGHT] = 'soft-light';
	        array[exports.BLEND_MODES.DIFFERENCE] = 'difference';
	        array[exports.BLEND_MODES.EXCLUSION] = 'exclusion';
	        array[exports.BLEND_MODES.HUE] = 'hue';
	        array[exports.BLEND_MODES.SATURATION] = 'saturate';
	        array[exports.BLEND_MODES.COLOR] = 'color';
	        array[exports.BLEND_MODES.LUMINOSITY] = 'luminosity';
	    }
	    else {
	        // this means that the browser does not support the cool new blend modes in canvas 'cough' ie 'cough'
	        array[exports.BLEND_MODES.NORMAL] = 'source-over';
	        array[exports.BLEND_MODES.ADD] = 'lighter'; // IS THIS OK???
	        array[exports.BLEND_MODES.MULTIPLY] = 'source-over';
	        array[exports.BLEND_MODES.SCREEN] = 'source-over';
	        array[exports.BLEND_MODES.OVERLAY] = 'source-over';
	        array[exports.BLEND_MODES.DARKEN] = 'source-over';
	        array[exports.BLEND_MODES.LIGHTEN] = 'source-over';
	        array[exports.BLEND_MODES.COLOR_DODGE] = 'source-over';
	        array[exports.BLEND_MODES.COLOR_BURN] = 'source-over';
	        array[exports.BLEND_MODES.HARD_LIGHT] = 'source-over';
	        array[exports.BLEND_MODES.SOFT_LIGHT] = 'source-over';
	        array[exports.BLEND_MODES.DIFFERENCE] = 'source-over';
	        array[exports.BLEND_MODES.EXCLUSION] = 'source-over';
	        array[exports.BLEND_MODES.HUE] = 'source-over';
	        array[exports.BLEND_MODES.SATURATION] = 'source-over';
	        array[exports.BLEND_MODES.COLOR] = 'source-over';
	        array[exports.BLEND_MODES.LUMINOSITY] = 'source-over';
	    }
	    // not-premultiplied, only for webgl
	    array[exports.BLEND_MODES.NORMAL_NPM] = array[exports.BLEND_MODES.NORMAL];
	    array[exports.BLEND_MODES.ADD_NPM] = array[exports.BLEND_MODES.ADD];
	    array[exports.BLEND_MODES.SCREEN_NPM] = array[exports.BLEND_MODES.SCREEN];
	    // composite operations
	    array[exports.BLEND_MODES.SRC_IN] = 'source-in';
	    array[exports.BLEND_MODES.SRC_OUT] = 'source-out';
	    array[exports.BLEND_MODES.SRC_ATOP] = 'source-atop';
	    array[exports.BLEND_MODES.DST_OVER] = 'destination-over';
	    array[exports.BLEND_MODES.DST_IN] = 'destination-in';
	    array[exports.BLEND_MODES.DST_OUT] = 'destination-out';
	    array[exports.BLEND_MODES.DST_ATOP] = 'destination-atop';
	    array[exports.BLEND_MODES.XOR] = 'xor';
	    // SUBTRACT from flash, does not exist in canvas
	    array[exports.BLEND_MODES.SUBTRACT] = 'source-over';
	    return array;
	}

	var tempMatrix$1 = new Matrix();
	/**
	 * The CanvasRenderer draws the scene and all its content onto a 2d canvas.
	 *
	 * This renderer should be used for browsers that do not support WebGL.
	 * Don't forget to add the CanvasRenderer.view to your DOM or you will not see anything!
	 *
	 * @class
	 * @memberof PIXI
	 * @extends PIXI.AbstractRenderer
	 */
	var CanvasRenderer = /** @class */ (function (_super) {
	    __extends$l(CanvasRenderer, _super);
	    /**
	     * @param {object} [options] - The optional renderer parameters
	     * @param {number} [options.width=800] - the width of the screen
	     * @param {number} [options.height=600] - the height of the screen
	     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
	     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
	     * @param {boolean} [options.autoDensity=false] - Resizes renderer view in CSS pixels to allow for
	     *   resolutions other than 1
	     * @param {boolean} [options.antialias=false] - sets antialias
	     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer. The
	     *  resolution of the renderer retina would be 2.
	     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
	     *  enable this if you need to call toDataUrl on the webgl context.
	     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
	     *      not before the new render pass.
	     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
	     *  (shown if not transparent).
	     */
	    function CanvasRenderer(options) {
	        var _this = _super.call(this, exports.RENDERER_TYPE.CANVAS, options) || this;
	        /**
	         * The root canvas 2d context that everything is drawn with.
	         *
	         * @member {CanvasRenderingContext2D}
	         */
	        _this.rootContext = _this.view.getContext('2d', { alpha: _this.transparent });
	        /**
	         * The currently active canvas 2d context (could change with renderTextures)
	         *
	         * @member {CanvasRenderingContext2D}
	         */
	        _this.context = _this.rootContext;
	        /**
	         * Boolean flag controlling canvas refresh.
	         *
	         * @member {boolean}
	         */
	        _this.refresh = true;
	        /**
	         * Instance of a CanvasMaskManager, handles masking when using the canvas renderer.
	         *
	         * @member {PIXI.CanvasMaskManager}
	         */
	        _this.maskManager = new CanvasMaskManager(_this);
	        /**
	         * The canvas property used to set the canvas smoothing property.
	         *
	         * @member {string}
	         */
	        _this.smoothProperty = 'imageSmoothingEnabled';
	        if (!_this.rootContext.imageSmoothingEnabled) {
	            var rc = _this.rootContext;
	            if (rc.webkitImageSmoothingEnabled) {
	                _this.smoothProperty = 'webkitImageSmoothingEnabled';
	            }
	            else if (rc.mozImageSmoothingEnabled) {
	                _this.smoothProperty = 'mozImageSmoothingEnabled';
	            }
	            else if (rc.oImageSmoothingEnabled) {
	                _this.smoothProperty = 'oImageSmoothingEnabled';
	            }
	            else if (rc.msImageSmoothingEnabled) {
	                _this.smoothProperty = 'msImageSmoothingEnabled';
	            }
	        }
	        _this.initPlugins(CanvasRenderer.__plugins);
	        /**
	         * Tracks the blend modes useful for this renderer.
	         *
	         * @member {object<number, string>}
	         */
	        _this.blendModes = mapCanvasBlendModesToPixi();
	        _this._activeBlendMode = null;
	        _this._outerBlend = false;
	        /**
	         * Projection transform, passed in render() stored here
	         * @type {null}
	         * @private
	         */
	        _this._projTransform = null;
	        _this.renderingToScreen = false;
	        sayHello('Canvas');
	        /**
	         * Fired after rendering finishes.
	         *
	         * @event PIXI.CanvasRenderer#postrender
	         */
	        /**
	         * Fired before rendering starts.
	         *
	         * @event PIXI.CanvasRenderer#prerender
	         */
	        _this.resize(_this.options.width, _this.options.height);
	        return _this;
	    }
	    /**
	     * Renders the object to this canvas view
	     *
	     * @param {PIXI.DisplayObject} displayObject - The object to be rendered
	     * @param {PIXI.RenderTexture} [renderTexture] - A render texture to be rendered to.
	     *  If unset, it will render to the root context.
	     * @param {boolean} [clear=this.clearBeforeRender] - Whether to clear the canvas before drawing
	     * @param {PIXI.Matrix} [transform] - A transformation to be applied
	     * @param {boolean} [skipUpdateTransform=false] - Whether to skip the update transform
	     */
	    CanvasRenderer.prototype.render = function (displayObject, renderTexture, clear, transform, skipUpdateTransform) {
	        if (!this.view) {
	            return;
	        }
	        // can be handy to know!
	        this.renderingToScreen = !renderTexture;
	        this.emit('prerender');
	        var rootResolution = this.resolution;
	        if (renderTexture) {
	            renderTexture = renderTexture.castToBaseTexture();
	            if (!renderTexture._canvasRenderTarget) {
	                renderTexture._canvasRenderTarget = new CanvasRenderTarget(renderTexture.width, renderTexture.height, renderTexture.resolution);
	                renderTexture.resource = new index.CanvasResource(renderTexture._canvasRenderTarget.canvas);
	                renderTexture.valid = true;
	            }
	            this.context = renderTexture._canvasRenderTarget.context;
	            this.resolution = renderTexture._canvasRenderTarget.resolution;
	        }
	        else {
	            this.context = this.rootContext;
	        }
	        var context = this.context;
	        this._projTransform = transform || null;
	        if (!renderTexture) {
	            this._lastObjectRendered = displayObject;
	        }
	        if (!skipUpdateTransform) {
	            // update the scene graph
	            var cacheParent = displayObject.enableTempParent();
	            displayObject.updateTransform();
	            displayObject.disableTempParent(cacheParent);
	        }
	        context.save();
	        context.setTransform(1, 0, 0, 1, 0, 0);
	        context.globalAlpha = 1;
	        this._activeBlendMode = exports.BLEND_MODES.NORMAL;
	        this._outerBlend = false;
	        context.globalCompositeOperation = this.blendModes[exports.BLEND_MODES.NORMAL];
	        if (clear !== undefined ? clear : this.clearBeforeRender) {
	            if (this.renderingToScreen) {
	                if (this.transparent) {
	                    context.clearRect(0, 0, this.width, this.height);
	                }
	                else {
	                    context.fillStyle = this._backgroundColorString;
	                    context.fillRect(0, 0, this.width, this.height);
	                }
	            }
	            else {
	                renderTexture = renderTexture;
	                renderTexture._canvasRenderTarget.clear();
	                var clearColor = renderTexture.clearColor;
	                if (clearColor[3] > 0) {
	                    context.fillStyle = hex2string(rgb2hex(clearColor));
	                    context.fillRect(0, 0, renderTexture.realWidth, renderTexture.realHeight);
	                }
	            }
	        }
	        // TODO RENDER TARGET STUFF HERE..
	        var tempContext = this.context;
	        this.context = context;
	        displayObject.renderCanvas(this);
	        this.context = tempContext;
	        context.restore();
	        this.resolution = rootResolution;
	        this._projTransform = null;
	        this.emit('postrender');
	    };
	    /**
	     * sets matrix of context
	     * called only from render() methods
	     * takes care about resolution
	     * @param {PIXI.Matrix} transform - world matrix of current element
	     * @param {boolean} [roundPixels] - whether to round (tx,ty) coords
	     * @param {number} [localResolution] - If specified, used instead of `renderer.resolution` for local scaling
	     */
	    CanvasRenderer.prototype.setContextTransform = function (transform, roundPixels, localResolution) {
	        var mat = transform;
	        var proj = this._projTransform;
	        var resolution = this.resolution;
	        localResolution = localResolution || resolution;
	        if (proj) {
	            mat = tempMatrix$1;
	            mat.copyFrom(transform);
	            mat.prepend(proj);
	        }
	        if (roundPixels) {
	            this.context.setTransform(mat.a * localResolution, mat.b * localResolution, mat.c * localResolution, mat.d * localResolution, (mat.tx * resolution) | 0, (mat.ty * resolution) | 0);
	        }
	        else {
	            this.context.setTransform(mat.a * localResolution, mat.b * localResolution, mat.c * localResolution, mat.d * localResolution, mat.tx * resolution, mat.ty * resolution);
	        }
	    };
	    /**
	     * Clear the canvas of renderer.
	     *
	     * @param {string} [clearColor] - Clear the canvas with this color, except the canvas is transparent.
	     */
	    CanvasRenderer.prototype.clear = function (clearColor) {
	        var context = this.context;
	        clearColor = clearColor || this._backgroundColorString;
	        if (!this.transparent && clearColor) {
	            context.fillStyle = clearColor;
	            context.fillRect(0, 0, this.width, this.height);
	        }
	        else {
	            context.clearRect(0, 0, this.width, this.height);
	        }
	    };
	    /**
	     * Sets the blend mode of the renderer.
	     *
	     * @param {number} blendMode - See {@link PIXI.BLEND_MODES} for valid values.
	     * @param {boolean} [readyForOuterBlend=false] - Some blendModes are dangerous, they affect outer space of sprite.
	     * Pass `true` only if you are ready to use them.
	     */
	    CanvasRenderer.prototype.setBlendMode = function (blendMode, readyForOuterBlend) {
	        var outerBlend = blendMode === exports.BLEND_MODES.SRC_IN
	            || blendMode === exports.BLEND_MODES.SRC_OUT
	            || blendMode === exports.BLEND_MODES.DST_IN
	            || blendMode === exports.BLEND_MODES.DST_ATOP;
	        if (!readyForOuterBlend && outerBlend) {
	            blendMode = exports.BLEND_MODES.NORMAL;
	        }
	        if (this._activeBlendMode === blendMode) {
	            return;
	        }
	        this._activeBlendMode = blendMode;
	        this._outerBlend = outerBlend;
	        this.context.globalCompositeOperation = this.blendModes[blendMode];
	    };
	    /**
	     * Removes everything from the renderer and optionally removes the Canvas DOM element.
	     *
	     * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
	     */
	    CanvasRenderer.prototype.destroy = function (removeView) {
	        // call the base destroy
	        _super.prototype.destroy.call(this, removeView);
	        this.context = null;
	        this.refresh = true;
	        this.maskManager.destroy();
	        this.maskManager = null;
	        this.smoothProperty = null;
	    };
	    /**
	     * Resizes the canvas view to the specified width and height.
	     *
	     * @extends PIXI.AbstractRenderer#resize
	     *
	     * @param {number} screenWidth - the new width of the screen
	     * @param {number} screenHeight - the new height of the screen
	     */
	    CanvasRenderer.prototype.resize = function (screenWidth, screenHeight) {
	        _super.prototype.resize.call(this, screenWidth, screenHeight);
	        // reset the scale mode.. oddly this seems to be reset when the canvas is resized.
	        // surely a browser bug?? Let PixiJS fix that for you..
	        if (this.smoothProperty) {
	            this.rootContext[this.smoothProperty] = (settings.SCALE_MODE === exports.SCALE_MODES.LINEAR);
	        }
	    };
	    /**
	     * Checks if blend mode has changed.
	     */
	    CanvasRenderer.prototype.invalidateBlendMode = function () {
	        this._activeBlendMode = this.blendModes.indexOf(this.context.globalCompositeOperation);
	    };
	    /**
	     * Collection of installed plugins. These are included by default in PIXI, but can be excluded
	     * by creating a custom build. Consult the README for more information about creating custom
	     * builds and excluding plugins.
	     * @name PIXI.CanvasRenderer#plugins
	     * @type {object}
	     * @readonly
	     * @property {PIXI.AccessibilityManager} accessibility Support tabbing interactive elements.
	     * @property {PIXI.CanvasExtract} extract Extract image data from renderer.
	     * @property {PIXI.InteractionManager} interaction Handles mouse, touch and pointer events.
	     * @property {PIXI.CanvasPrepare} prepare Pre-render display objects.
	     */
	    /**
	     * Adds a plugin to the renderer.
	     *
	     * @method
	     * @param {string} pluginName - The name of the plugin.
	     * @param {Function} ctor - The constructor function or class for the plugin.
	     */
	    CanvasRenderer.registerPlugin = function (pluginName, ctor) {
	        CanvasRenderer.__plugins = CanvasRenderer.__plugins || {};
	        CanvasRenderer.__plugins[pluginName] = ctor;
	    };
	    return CanvasRenderer;
	}(AbstractRenderer));

	/**
	 * Utility methods for Sprite/Texture tinting.
	 *
	 * Tinting with the CanvasRenderer involves creating a new canvas to use as a texture,
	 * so be aware of the performance implications.
	 *
	 * @namespace PIXI.canvasUtils
	 * @memberof PIXI
	 */
	var canvasUtils = {
	    canvas: null,
	    /**
	     * Basically this method just needs a sprite and a color and tints the sprite with the given color.
	     *
	     * @memberof PIXI.canvasUtils
	     * @param {PIXI.Sprite} sprite - the sprite to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @return {HTMLCanvasElement} The tinted canvas
	     */
	    getTintedCanvas: function (sprite, color) {
	        var texture = sprite.texture;
	        color = canvasUtils.roundColor(color);
	        var stringColor = "#" + ("00000" + (color | 0).toString(16)).substr(-6);
	        texture.tintCache = texture.tintCache || {};
	        var cachedCanvas = texture.tintCache[stringColor];
	        var canvas;
	        if (cachedCanvas) {
	            if (cachedCanvas.tintId === texture._updateID) {
	                return texture.tintCache[stringColor];
	            }
	            canvas = texture.tintCache[stringColor];
	        }
	        else {
	            canvas = document.createElement('canvas');
	        }
	        canvasUtils.tintMethod(texture, color, canvas);
	        canvas.tintId = texture._updateID;
	        if (canvasUtils.convertTintToImage) {
	            // is this better?
	            var tintImage = new Image();
	            tintImage.src = canvas.toDataURL();
	            texture.tintCache[stringColor] = tintImage;
	        }
	        else {
	            texture.tintCache[stringColor] = canvas;
	        }
	        return canvas;
	    },
	    /**
	     * Basically this method just needs a sprite and a color and tints the sprite with the given color.
	     *
	     * @memberof PIXI.canvasUtils
	     * @param {PIXI.Texture} texture - the sprite to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @return {HTMLCanvasElement} The tinted canvas
	     */
	    getTintedPattern: function (texture, color) {
	        color = canvasUtils.roundColor(color);
	        var stringColor = "#" + ("00000" + (color | 0).toString(16)).substr(-6);
	        texture.patternCache = texture.patternCache || {};
	        var pattern = texture.patternCache[stringColor];
	        if (pattern && pattern.tintId === texture._updateID) {
	            return pattern;
	        }
	        if (!canvasUtils.canvas) {
	            canvasUtils.canvas = document.createElement('canvas');
	        }
	        canvasUtils.tintMethod(texture, color, canvasUtils.canvas);
	        pattern = canvasUtils.canvas.getContext('2d').createPattern(canvasUtils.canvas, 'repeat');
	        pattern.tintId = texture._updateID;
	        texture.patternCache[stringColor] = pattern;
	        return pattern;
	    },
	    /**
	     * Tint a texture using the 'multiply' operation.
	     *
	     * @memberof PIXI.canvasUtils
	     * @param {PIXI.Texture} texture - the texture to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @param {HTMLCanvasElement} canvas - the current canvas
	     */
	    tintWithMultiply: function (texture, color, canvas) {
	        var context = canvas.getContext('2d');
	        var crop = texture._frame.clone();
	        var resolution = texture.baseTexture.resolution;
	        crop.x *= resolution;
	        crop.y *= resolution;
	        crop.width *= resolution;
	        crop.height *= resolution;
	        canvas.width = Math.ceil(crop.width);
	        canvas.height = Math.ceil(crop.height);
	        context.save();
	        context.fillStyle = "#" + ("00000" + (color | 0).toString(16)).substr(-6);
	        context.fillRect(0, 0, crop.width, crop.height);
	        context.globalCompositeOperation = 'multiply';
	        var source = texture.baseTexture.getDrawableSource();
	        context.drawImage(source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	        context.globalCompositeOperation = 'destination-atop';
	        context.drawImage(source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	        context.restore();
	    },
	    /**
	     * Tint a texture using the 'overlay' operation.
	     *
	     * @memberof PIXI.canvasUtils
	     * @param {PIXI.Texture} texture - the texture to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @param {HTMLCanvasElement} canvas - the current canvas
	     */
	    tintWithOverlay: function (texture, color, canvas) {
	        var context = canvas.getContext('2d');
	        var crop = texture._frame.clone();
	        var resolution = texture.baseTexture.resolution;
	        crop.x *= resolution;
	        crop.y *= resolution;
	        crop.width *= resolution;
	        crop.height *= resolution;
	        canvas.width = Math.ceil(crop.width);
	        canvas.height = Math.ceil(crop.height);
	        context.save();
	        context.globalCompositeOperation = 'copy';
	        context.fillStyle = "#" + ("00000" + (color | 0).toString(16)).substr(-6);
	        context.fillRect(0, 0, crop.width, crop.height);
	        context.globalCompositeOperation = 'destination-atop';
	        context.drawImage(texture.baseTexture.getDrawableSource(), crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	        // context.globalCompositeOperation = 'copy';
	        context.restore();
	    },
	    /**
	     * Tint a texture pixel per pixel.
	     *
	     * @memberof PIXI.canvasUtils
	     * @param {PIXI.Texture} texture - the texture to tint
	     * @param {number} color - the color to use to tint the sprite with
	     * @param {HTMLCanvasElement} canvas - the current canvas
	     */
	    tintWithPerPixel: function (texture, color, canvas) {
	        var context = canvas.getContext('2d');
	        var crop = texture._frame.clone();
	        var resolution = texture.baseTexture.resolution;
	        crop.x *= resolution;
	        crop.y *= resolution;
	        crop.width *= resolution;
	        crop.height *= resolution;
	        canvas.width = Math.ceil(crop.width);
	        canvas.height = Math.ceil(crop.height);
	        context.save();
	        context.globalCompositeOperation = 'copy';
	        context.drawImage(texture.baseTexture.getDrawableSource(), crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	        context.restore();
	        var rgbValues = hex2rgb(color);
	        var r = rgbValues[0];
	        var g = rgbValues[1];
	        var b = rgbValues[2];
	        var pixelData = context.getImageData(0, 0, crop.width, crop.height);
	        var pixels = pixelData.data;
	        for (var i = 0; i < pixels.length; i += 4) {
	            pixels[i + 0] *= r;
	            pixels[i + 1] *= g;
	            pixels[i + 2] *= b;
	        }
	        context.putImageData(pixelData, 0, 0);
	    },
	    /**
	     * Rounds the specified color according to the canvasUtils.cacheStepsPerColorChannel.
	     *
	     * @memberof PIXI.canvasUtils
	     * @param {number} color - the color to round, should be a hex color
	     * @return {number} The rounded color.
	     */
	    roundColor: function (color) {
	        var step = canvasUtils.cacheStepsPerColorChannel;
	        var rgbValues = hex2rgb(color);
	        rgbValues[0] = Math.min(255, (rgbValues[0] / step) * step);
	        rgbValues[1] = Math.min(255, (rgbValues[1] / step) * step);
	        rgbValues[2] = Math.min(255, (rgbValues[2] / step) * step);
	        return rgb2hex(rgbValues);
	    },
	    /**
	     * Number of steps which will be used as a cap when rounding colors.
	     *
	     * @memberof PIXI.canvasUtils
	     * @type {number}
	     */
	    cacheStepsPerColorChannel: 8,
	    /**
	     * Tint cache boolean flag.
	     *
	     * @memberof PIXI.canvasUtils
	     * @type {boolean}
	     */
	    convertTintToImage: false,
	    /**
	     * Whether or not the Canvas BlendModes are supported, consequently the ability to tint using the multiply method.
	     *
	     * @memberof PIXI.canvasUtils
	     * @type {boolean}
	     */
	    canUseMultiply: canUseNewCanvasBlendModes(),
	    /**
	     * The tinting method that will be used.
	     *
	     * @memberof PIXI.canvasUtils
	     * @type {Function}
	     */
	    tintMethod: null,
	};
	canvasUtils.tintMethod = canvasUtils.canUseMultiply ? canvasUtils.tintWithMultiply : canvasUtils.tintWithPerPixel;

	// Reference to Renderer.create static function
	var parentCreate = Renderer.create;
	/**
	 * Override the Renderer.create to fallback to use CanvasRenderer.
	 * Also supports forceCanvas option with Application or autoDetectRenderer.
	 * @private
	 */
	Renderer.create = function create(options) {
	    var forceCanvas = options && options.forceCanvas;
	    if (!forceCanvas) {
	        try {
	            return parentCreate(options);
	        }
	        catch (err) {
	            // swallow WebGL-unsupported error
	        }
	    }
	    return new CanvasRenderer(options);
	};

	/**
	 * Get the drawable source, such as HTMLCanvasElement or HTMLImageElement suitable
	 * for rendering with CanvasRenderer. Provided by **@pixi/canvas-renderer** package.
	 * @method getDrawableSource
	 * @memberof PIXI.BaseTexture#
	 * @return {PIXI.ICanvasImageSource} Source to render with CanvasRenderer
	 */
	BaseTexture.prototype.getDrawableSource = function getDrawableSource() {
	    var resource = this.resource;
	    return resource ? (resource.bitmap || resource.source) : null;
	};
	/**
	 * A reference to the canvas render target (we only need one as this can be shared across renderers)
	 *
	 * @protected
	 * @member {PIXI.utils.CanvasRenderTarget} _canvasRenderTarget
	 * @memberof PIXI.BaseRenderTexture#
	 */
	BaseRenderTexture.prototype._canvasRenderTarget = null;
	Texture.prototype.patternCache = null;
	Texture.prototype.tintCache = null;

	/*!
	 * @pixi/canvas-mesh - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/canvas-mesh is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * Renderer dedicated to meshes.
	 *
	 * @class
	 * @protected
	 * @memberof PIXI
	 */
	var CanvasMeshRenderer = /** @class */ (function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - The renderer this downport works for
	     */
	    function CanvasMeshRenderer(renderer) {
	        this.renderer = renderer;
	    }
	    /**
	     * Renders the Mesh
	     *
	     * @param {PIXI.Mesh} mesh - the Mesh to render
	     */
	    CanvasMeshRenderer.prototype.render = function (mesh) {
	        var renderer = this.renderer;
	        var transform = mesh.worldTransform;
	        renderer.context.globalAlpha = mesh.worldAlpha;
	        renderer.setBlendMode(mesh.blendMode);
	        renderer.setContextTransform(transform, mesh.roundPixels);
	        if (mesh.drawMode !== exports.DRAW_MODES.TRIANGLES) {
	            this._renderTriangleMesh(mesh);
	        }
	        else {
	            this._renderTriangles(mesh);
	        }
	    };
	    /**
	     * Draws the object in Triangle Mesh mode
	     *
	     * @private
	     * @param {PIXI.Mesh} mesh - the Mesh to render
	     */
	    CanvasMeshRenderer.prototype._renderTriangleMesh = function (mesh) {
	        // draw triangles!!
	        var length = mesh.geometry.buffers[0].data.length;
	        for (var i = 0; i < length - 2; i++) {
	            // draw some triangles!
	            var index = i * 2;
	            this._renderDrawTriangle(mesh, index, (index + 2), (index + 4));
	        }
	    };
	    /**
	     * Draws the object in triangle mode using canvas
	     *
	     * @private
	     * @param {PIXI.Mesh} mesh - the current mesh
	     */
	    CanvasMeshRenderer.prototype._renderTriangles = function (mesh) {
	        // draw triangles!!
	        var indices = mesh.geometry.getIndex().data;
	        var length = indices.length;
	        for (var i = 0; i < length; i += 3) {
	            // draw some triangles!
	            var index0 = indices[i] * 2;
	            var index1 = indices[i + 1] * 2;
	            var index2 = indices[i + 2] * 2;
	            this._renderDrawTriangle(mesh, index0, index1, index2);
	        }
	    };
	    /**
	     * Draws one of the triangles that from the Mesh
	     *
	     * @private
	     * @param {PIXI.Mesh} mesh - the current mesh
	     * @param {number} index0 - the index of the first vertex
	     * @param {number} index1 - the index of the second vertex
	     * @param {number} index2 - the index of the third vertex
	     */
	    CanvasMeshRenderer.prototype._renderDrawTriangle = function (mesh, index0, index1, index2) {
	        var context = this.renderer.context;
	        var vertices = mesh.geometry.buffers[0].data;
	        var uvs = mesh.uvs, texture = mesh.texture;
	        if (!texture.valid) {
	            return;
	        }
	        var isTinted = mesh.tint !== 0xFFFFFF;
	        var base = texture.baseTexture;
	        var textureWidth = base.width;
	        var textureHeight = base.height;
	        if (isTinted) {
	            if (mesh._cachedTint !== mesh.tint) {
	                mesh._cachedTint = mesh.tint;
	                mesh._tintedCanvas = canvasUtils.getTintedCanvas(mesh, mesh.tint);
	            }
	        }
	        var textureSource = isTinted ? mesh._tintedCanvas : base.getDrawableSource();
	        var u0 = uvs[index0] * base.width;
	        var u1 = uvs[index1] * base.width;
	        var u2 = uvs[index2] * base.width;
	        var v0 = uvs[index0 + 1] * base.height;
	        var v1 = uvs[index1 + 1] * base.height;
	        var v2 = uvs[index2 + 1] * base.height;
	        var x0 = vertices[index0];
	        var x1 = vertices[index1];
	        var x2 = vertices[index2];
	        var y0 = vertices[index0 + 1];
	        var y1 = vertices[index1 + 1];
	        var y2 = vertices[index2 + 1];
	        var canvasPadding = mesh.canvasPadding / this.renderer.resolution;
	        if (canvasPadding > 0) {
	            var paddingX = canvasPadding / Math.abs(mesh.worldTransform.a);
	            var paddingY = canvasPadding / Math.abs(mesh.worldTransform.d);
	            var centerX = (x0 + x1 + x2) / 3;
	            var centerY = (y0 + y1 + y2) / 3;
	            var normX = x0 - centerX;
	            var normY = y0 - centerY;
	            var dist = Math.sqrt((normX * normX) + (normY * normY));
	            x0 = centerX + ((normX / dist) * (dist + paddingX));
	            y0 = centerY + ((normY / dist) * (dist + paddingY));
	            //
	            normX = x1 - centerX;
	            normY = y1 - centerY;
	            dist = Math.sqrt((normX * normX) + (normY * normY));
	            x1 = centerX + ((normX / dist) * (dist + paddingX));
	            y1 = centerY + ((normY / dist) * (dist + paddingY));
	            normX = x2 - centerX;
	            normY = y2 - centerY;
	            dist = Math.sqrt((normX * normX) + (normY * normY));
	            x2 = centerX + ((normX / dist) * (dist + paddingX));
	            y2 = centerY + ((normY / dist) * (dist + paddingY));
	        }
	        context.save();
	        context.beginPath();
	        context.moveTo(x0, y0);
	        context.lineTo(x1, y1);
	        context.lineTo(x2, y2);
	        context.closePath();
	        context.clip();
	        // Compute matrix transform
	        var delta = (u0 * v1) + (v0 * u2) + (u1 * v2) - (v1 * u2) - (v0 * u1) - (u0 * v2);
	        var deltaA = (x0 * v1) + (v0 * x2) + (x1 * v2) - (v1 * x2) - (v0 * x1) - (x0 * v2);
	        var deltaB = (u0 * x1) + (x0 * u2) + (u1 * x2) - (x1 * u2) - (x0 * u1) - (u0 * x2);
	        var deltaC = (u0 * v1 * x2) + (v0 * x1 * u2) + (x0 * u1 * v2) - (x0 * v1 * u2) - (v0 * u1 * x2) - (u0 * x1 * v2);
	        var deltaD = (y0 * v1) + (v0 * y2) + (y1 * v2) - (v1 * y2) - (v0 * y1) - (y0 * v2);
	        var deltaE = (u0 * y1) + (y0 * u2) + (u1 * y2) - (y1 * u2) - (y0 * u1) - (u0 * y2);
	        var deltaF = (u0 * v1 * y2) + (v0 * y1 * u2) + (y0 * u1 * v2) - (y0 * v1 * u2) - (v0 * u1 * y2) - (u0 * y1 * v2);
	        context.transform(deltaA / delta, deltaD / delta, deltaB / delta, deltaE / delta, deltaC / delta, deltaF / delta);
	        context.drawImage(textureSource, 0, 0, textureWidth * base.resolution, textureHeight * base.resolution, 0, 0, textureWidth, textureHeight);
	        context.restore();
	        this.renderer.invalidateBlendMode();
	    };
	    /**
	     * Renders a flat Mesh
	     *
	     * @private
	     * @param {PIXI.Mesh} mesh - The Mesh to render
	     */
	    CanvasMeshRenderer.prototype.renderMeshFlat = function (mesh) {
	        var context = this.renderer.context;
	        var vertices = mesh.geometry.getBuffer('aVertexPosition').data;
	        var length = vertices.length / 2;
	        // this.count++;
	        context.beginPath();
	        for (var i = 1; i < length - 2; ++i) {
	            // draw some triangles!
	            var index = i * 2;
	            var x0 = vertices[index];
	            var y0 = vertices[index + 1];
	            var x1 = vertices[index + 2];
	            var y1 = vertices[index + 3];
	            var x2 = vertices[index + 4];
	            var y2 = vertices[index + 5];
	            context.moveTo(x0, y0);
	            context.lineTo(x1, y1);
	            context.lineTo(x2, y2);
	        }
	        context.fillStyle = '#FF0000';
	        context.fill();
	        context.closePath();
	    };
	    /**
	     * destroy the the renderer.
	     *
	     */
	    CanvasMeshRenderer.prototype.destroy = function () {
	        this.renderer = null;
	    };
	    return CanvasMeshRenderer;
	}());

	/**
	 * Default `canvasPadding` for canvas-based Mesh rendering.
	 *
	 * @see PIXI.Mesh2d#canvasPadding
	 * @static
	 * @name MESH_CANVAS_PADDING
	 * @memberof PIXI.settings
	 * @type {number}
	 * @default 0
	 */
	settings.MESH_CANVAS_PADDING = 0;

	/**
	 * Renders the mesh using the Canvas renderer
	 *
	 * @protected
	 * @method render
	 * @memberof PIXI.MeshMaterial#
	 * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
	 * @param {PIXI.Mesh} mesh - Mesh to render.
	 */
	MeshMaterial.prototype._renderCanvas = function _renderCanvas(renderer, mesh) {
	    renderer.plugins.mesh.render(mesh);
	};

	/**
	 * Cached tint value so we can tell when the tint is changed.
	 * @memberof PIXI.NineSlicePlane#
	 * @member {number} _cachedTint
	 * @protected
	 */
	NineSlicePlane.prototype._cachedTint = 0xFFFFFF;
	/**
	 * Cached tinted texture.
	 * @memberof PIXI.NineSlicePlane#
	 * @member {HTMLCanvasElement} _tintedCanvas
	 * @protected
	 */
	NineSlicePlane.prototype._tintedCanvas = null;
	/**
	 * Temporary storage for canvas source coords
	 * @memberof PIXI.NineSlicePlane#
	 * @member {number[]} _canvasUvs
	 * @private
	 */
	NineSlicePlane.prototype._canvasUvs = null;
	/**
	 * Renders the object using the Canvas renderer
	 *
	 * @private
	 * @method _renderCanvas
	 * @memberof PIXI.NineSlicePlane#
	 * @param {PIXI.CanvasRenderer} renderer - The canvas renderer to render with.
	 */
	NineSlicePlane.prototype._renderCanvas = function _renderCanvas(renderer) {
	    var context = renderer.context;
	    var transform = this.worldTransform;
	    var isTinted = this.tint !== 0xFFFFFF;
	    var texture = this.texture;
	    if (!texture.valid) {
	        return;
	    }
	    // Work out tinting
	    if (isTinted) {
	        if (this._cachedTint !== this.tint) {
	            // Tint has changed, need to update the tinted texture and use that instead
	            this._cachedTint = this.tint;
	            this._tintedCanvas = canvasUtils.getTintedCanvas(this, this.tint);
	        }
	    }
	    var textureSource = !isTinted ? texture.baseTexture.getDrawableSource() : this._tintedCanvas;
	    if (!this._canvasUvs) {
	        this._canvasUvs = [0, 0, 0, 0, 0, 0, 0, 0];
	    }
	    var vertices = this.vertices;
	    var uvs = this._canvasUvs;
	    var u0 = isTinted ? 0 : texture.frame.x;
	    var v0 = isTinted ? 0 : texture.frame.y;
	    var u1 = u0 + texture.frame.width;
	    var v1 = v0 + texture.frame.height;
	    uvs[0] = u0;
	    uvs[1] = u0 + this._leftWidth;
	    uvs[2] = u1 - this._rightWidth;
	    uvs[3] = u1;
	    uvs[4] = v0;
	    uvs[5] = v0 + this._topHeight;
	    uvs[6] = v1 - this._bottomHeight;
	    uvs[7] = v1;
	    for (var i = 0; i < 8; i++) {
	        uvs[i] *= texture.baseTexture.resolution;
	    }
	    context.globalAlpha = this.worldAlpha;
	    renderer.setBlendMode(this.blendMode);
	    renderer.setContextTransform(transform, this.roundPixels);
	    for (var row = 0; row < 3; row++) {
	        for (var col = 0; col < 3; col++) {
	            var ind = (col * 2) + (row * 8);
	            var sw = Math.max(1, uvs[col + 1] - uvs[col]);
	            var sh = Math.max(1, uvs[row + 5] - uvs[row + 4]);
	            var dw = Math.max(1, vertices[ind + 10] - vertices[ind]);
	            var dh = Math.max(1, vertices[ind + 11] - vertices[ind + 1]);
	            context.drawImage(textureSource, uvs[col], uvs[row + 4], sw, sh, vertices[ind], vertices[ind + 1], dw, dh);
	        }
	    }
	};

	var warned = false;
	/**
	 * Cached tint value so we can tell when the tint is changed.
	 * @memberof PIXI.Mesh#
	 * @member {number} _cachedTint
	 * @protected
	 */
	Mesh.prototype._cachedTint = 0xFFFFFF;
	/**
	 * Cached tinted texture.
	 * @memberof PIXI.Mesh#
	 * @member {HTMLCanvasElement} _tintedCanvas
	 * @protected
	 */
	Mesh.prototype._tintedCanvas = null;
	/**
	 * Renders the object using the Canvas renderer
	 *
	 * @private
	 * @method _renderCanvas
	 * @memberof PIXI.Mesh#
	 * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
	 */
	Mesh.prototype._renderCanvas = function _renderCanvas(renderer) {
	    if (this.shader.uvMatrix) {
	        this.shader.uvMatrix.update();
	        this.calculateUvs();
	    }
	    if (this.material._renderCanvas) {
	        this.material._renderCanvas(renderer, this);
	    }
	    else if (!warned) {
	        warned = true;
	        if (window.console) {
	            console.warn('Mesh with custom shaders are not supported in CanvasRenderer.');
	        }
	    }
	};
	// IMPORTANT: Please do NOT use this as a precedent to use `settings` after the object is created
	// this was merely created to completely decouple canvas from the base Mesh class and we are
	// unable to add `canvasPadding` in the constructor anymore, as the case was for PixiJS v4.
	/**
	 * Internal variable for `canvasPadding`.
	 *
	 * @private
	 * @memberof PIXI.Mesh
	 * @member {number}
	 * @default null
	 */
	Mesh.prototype._canvasPadding = null;
	/**
	 * Triangles in canvas mode are automatically antialiased, use this value to force triangles
	 * to overlap a bit with each other. To set the global default, set {@link PIXI.settings.MESH_CANVAS_PADDING}
	 *
	 * @see PIXI.settings.MESH_CANVAS_PADDING
	 * @member {number} canvasPadding
	 * @memberof PIXI.SimpleMesh#
	 * @default 0
	 */
	Object.defineProperty(Mesh.prototype, 'canvasPadding', {
	    get: function () {
	        return this._canvasPadding !== null ? this._canvasPadding : settings.MESH_CANVAS_PADDING;
	    },
	    set: function (value) {
	        this._canvasPadding = value;
	    },
	});

	/**
	 * Renders the object using the Canvas renderer
	 *
	 * @private
	 * @method _renderCanvas
	 * @memberof PIXI.Mesh#
	 * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
	 */
	SimpleMesh.prototype._renderCanvas = function _renderCanvas(renderer) {
	    if (this.autoUpdate) {
	        this.geometry.getBuffer('aVertexPosition').update();
	    }
	    if (this.shader.update) {
	        this.shader.update();
	    }
	    this.calculateUvs();
	    this.material._renderCanvas(renderer, this);
	};

	/**
	 * Renders the object using the Canvas renderer
	 *
	 * @protected
	 * @method _renderCanvas
	 * @memberof PIXI.Mesh#
	 * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
	 */
	SimpleRope.prototype._renderCanvas = function _renderCanvas(renderer) {
	    if (this.autoUpdate
	        || this.geometry._width !== this.shader.texture.height) {
	        this.geometry._width = this.shader.texture.height;
	        this.geometry.update();
	    }
	    if (this.shader.update) {
	        this.shader.update();
	    }
	    this.calculateUvs();
	    this.material._renderCanvas(renderer, this);
	};

	/*!
	 * @pixi/canvas-graphics - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/canvas-graphics is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they
	 * now share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's CanvasGraphicsRenderer:
	 * https://github.com/libgdx/libgdx/blob/1.0.0/gdx/src/com/badlogic/gdx/graphics/glutils/ShapeRenderer.java
	 */
	/**
	 * Renderer dedicated to drawing and batching graphics objects.
	 *
	 * @class
	 * @protected
	 * @memberof PIXI
	 */
	var CanvasGraphicsRenderer = /** @class */ (function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - The current PIXI renderer.
	     */
	    function CanvasGraphicsRenderer(renderer) {
	        this.renderer = renderer;
	        this._svgMatrix = null;
	        this._tempMatrix = new Matrix();
	    }
	    /**
	     * calculates fill/stroke style for canvas
	     *
	     * @private
	     * @param {PIXI.FillStyle} style
	     * @param {number} tint
	     * @returns {string|CanvasPattern}
	     */
	    CanvasGraphicsRenderer.prototype._calcCanvasStyle = function (style, tint) {
	        var res;
	        if (style.texture && style.texture.baseTexture !== Texture.WHITE.baseTexture) {
	            if (style.texture.valid) {
	                res = canvasUtils.getTintedPattern(style.texture, tint);
	                this.setPatternTransform(res, style.matrix || Matrix.IDENTITY);
	            }
	            else {
	                res = '#808080';
	            }
	        }
	        else {
	            res = "#" + ("00000" + (tint | 0).toString(16)).substr(-6);
	        }
	        return res;
	    };
	    /**
	     * Renders a Graphics object to a canvas.
	     *
	     * @param {PIXI.Graphics} graphics - the actual graphics object to render
	     */
	    CanvasGraphicsRenderer.prototype.render = function (graphics) {
	        var renderer = this.renderer;
	        var context = renderer.context;
	        var worldAlpha = graphics.worldAlpha;
	        var transform = graphics.transform.worldTransform;
	        renderer.setContextTransform(transform);
	        renderer.setBlendMode(graphics.blendMode);
	        var graphicsData = graphics.geometry.graphicsData;
	        var contextFillStyle;
	        var contextStrokeStyle;
	        var tintR = ((graphics.tint >> 16) & 0xFF) / 255;
	        var tintG = ((graphics.tint >> 8) & 0xFF) / 255;
	        var tintB = (graphics.tint & 0xFF) / 255;
	        for (var i = 0; i < graphicsData.length; i++) {
	            var data = graphicsData[i];
	            var shape = data.shape;
	            var fillStyle = data.fillStyle;
	            var lineStyle = data.lineStyle;
	            var fillColor = data.fillStyle.color | 0;
	            var lineColor = data.lineStyle.color | 0;
	            if (data.matrix) {
	                renderer.setContextTransform(transform.copyTo(this._tempMatrix).append(data.matrix));
	            }
	            if (fillStyle.visible) {
	                var fillTint = ((((fillColor >> 16) & 0xFF) / 255 * tintR * 255 << 16)
	                    + (((fillColor >> 8) & 0xFF) / 255 * tintG * 255 << 8)
	                    + (((fillColor & 0xFF) / 255) * tintB * 255));
	                contextFillStyle = this._calcCanvasStyle(fillStyle, fillTint);
	            }
	            if (lineStyle.visible) {
	                var lineTint = ((((lineColor >> 16) & 0xFF) / 255 * tintR * 255 << 16)
	                    + (((lineColor >> 8) & 0xFF) / 255 * tintG * 255 << 8)
	                    + (((lineColor & 0xFF) / 255) * tintB * 255));
	                contextStrokeStyle = this._calcCanvasStyle(lineStyle, lineTint);
	            }
	            context.lineWidth = lineStyle.width;
	            context.lineCap = lineStyle.cap;
	            context.lineJoin = lineStyle.join;
	            context.miterLimit = lineStyle.miterLimit;
	            if (data.type === exports.SHAPES.POLY) {
	                context.beginPath();
	                var tempShape = shape;
	                var points = tempShape.points;
	                var holes = data.holes;
	                var outerArea = void 0;
	                var innerArea = void 0;
	                var px = void 0;
	                var py = void 0;
	                context.moveTo(points[0], points[1]);
	                for (var j = 2; j < points.length; j += 2) {
	                    context.lineTo(points[j], points[j + 1]);
	                }
	                if (tempShape.closeStroke) {
	                    context.closePath();
	                }
	                if (holes.length > 0) {
	                    outerArea = 0;
	                    px = points[0];
	                    py = points[1];
	                    for (var j = 2; j + 2 < points.length; j += 2) {
	                        outerArea += ((points[j] - px) * (points[j + 3] - py))
	                            - ((points[j + 2] - px) * (points[j + 1] - py));
	                    }
	                    for (var k = 0; k < holes.length; k++) {
	                        points = holes[k].shape.points;
	                        if (!points) {
	                            continue;
	                        }
	                        innerArea = 0;
	                        px = points[0];
	                        py = points[1];
	                        for (var j = 2; j + 2 < points.length; j += 2) {
	                            innerArea += ((points[j] - px) * (points[j + 3] - py))
	                                - ((points[j + 2] - px) * (points[j + 1] - py));
	                        }
	                        if (innerArea * outerArea < 0) {
	                            context.moveTo(points[0], points[1]);
	                            for (var j = 2; j < points.length; j += 2) {
	                                context.lineTo(points[j], points[j + 1]);
	                            }
	                        }
	                        else {
	                            context.moveTo(points[points.length - 2], points[points.length - 1]);
	                            for (var j = points.length - 4; j >= 0; j -= 2) {
	                                context.lineTo(points[j], points[j + 1]);
	                            }
	                        }
	                        if (holes[k].shape.closeStroke) {
	                            context.closePath();
	                        }
	                    }
	                }
	                if (fillStyle.visible) {
	                    context.globalAlpha = fillStyle.alpha * worldAlpha;
	                    context.fillStyle = contextFillStyle;
	                    context.fill();
	                }
	                if (lineStyle.visible) {
	                    context.globalAlpha = lineStyle.alpha * worldAlpha;
	                    context.strokeStyle = contextStrokeStyle;
	                    context.stroke();
	                }
	            }
	            else if (data.type === exports.SHAPES.RECT) {
	                var tempShape = shape;
	                if (fillStyle.visible) {
	                    context.globalAlpha = fillStyle.alpha * worldAlpha;
	                    context.fillStyle = contextFillStyle;
	                    context.fillRect(tempShape.x, tempShape.y, tempShape.width, tempShape.height);
	                }
	                if (lineStyle.visible) {
	                    context.globalAlpha = lineStyle.alpha * worldAlpha;
	                    context.strokeStyle = contextStrokeStyle;
	                    context.strokeRect(tempShape.x, tempShape.y, tempShape.width, tempShape.height);
	                }
	            }
	            else if (data.type === exports.SHAPES.CIRC) {
	                var tempShape = shape;
	                // TODO - need to be Undefined!
	                context.beginPath();
	                context.arc(tempShape.x, tempShape.y, tempShape.radius, 0, 2 * Math.PI);
	                context.closePath();
	                if (fillStyle.visible) {
	                    context.globalAlpha = fillStyle.alpha * worldAlpha;
	                    context.fillStyle = contextFillStyle;
	                    context.fill();
	                }
	                if (lineStyle.visible) {
	                    context.globalAlpha = lineStyle.alpha * worldAlpha;
	                    context.strokeStyle = contextStrokeStyle;
	                    context.stroke();
	                }
	            }
	            else if (data.type === exports.SHAPES.ELIP) {
	                // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
	                var tempShape = shape;
	                var w = tempShape.width * 2;
	                var h = tempShape.height * 2;
	                var x = tempShape.x - (w / 2);
	                var y = tempShape.y - (h / 2);
	                context.beginPath();
	                var kappa = 0.5522848;
	                var ox = (w / 2) * kappa; // control point offset horizontal
	                var oy = (h / 2) * kappa; // control point offset vertical
	                var xe = x + w; // x-end
	                var ye = y + h; // y-end
	                var xm = x + (w / 2); // x-middle
	                var ym = y + (h / 2); // y-middle
	                context.moveTo(x, ym);
	                context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
	                context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
	                context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
	                context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
	                context.closePath();
	                if (fillStyle.visible) {
	                    context.globalAlpha = fillStyle.alpha * worldAlpha;
	                    context.fillStyle = contextFillStyle;
	                    context.fill();
	                }
	                if (lineStyle.visible) {
	                    context.globalAlpha = lineStyle.alpha * worldAlpha;
	                    context.strokeStyle = contextStrokeStyle;
	                    context.stroke();
	                }
	            }
	            else if (data.type === exports.SHAPES.RREC) {
	                var tempShape = shape;
	                var rx = tempShape.x;
	                var ry = tempShape.y;
	                var width = tempShape.width;
	                var height = tempShape.height;
	                var radius = tempShape.radius;
	                var maxRadius = Math.min(width, height) / 2 | 0;
	                radius = radius > maxRadius ? maxRadius : radius;
	                context.beginPath();
	                context.moveTo(rx, ry + radius);
	                context.lineTo(rx, ry + height - radius);
	                context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
	                context.lineTo(rx + width - radius, ry + height);
	                context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
	                context.lineTo(rx + width, ry + radius);
	                context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
	                context.lineTo(rx + radius, ry);
	                context.quadraticCurveTo(rx, ry, rx, ry + radius);
	                context.closePath();
	                if (fillStyle.visible) {
	                    context.globalAlpha = fillStyle.alpha * worldAlpha;
	                    context.fillStyle = contextFillStyle;
	                    context.fill();
	                }
	                if (lineStyle.visible) {
	                    context.globalAlpha = lineStyle.alpha * worldAlpha;
	                    context.strokeStyle = contextStrokeStyle;
	                    context.stroke();
	                }
	            }
	        }
	    };
	    CanvasGraphicsRenderer.prototype.setPatternTransform = function (pattern, matrix) {
	        if (this._svgMatrix === false) {
	            return;
	        }
	        if (!this._svgMatrix) {
	            var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	            if (svg && svg.createSVGMatrix) {
	                this._svgMatrix = svg.createSVGMatrix();
	            }
	            if (!this._svgMatrix || !pattern.setTransform) {
	                this._svgMatrix = false;
	                return;
	            }
	        }
	        this._svgMatrix.a = matrix.a;
	        this._svgMatrix.b = matrix.b;
	        this._svgMatrix.c = matrix.c;
	        this._svgMatrix.d = matrix.d;
	        this._svgMatrix.e = matrix.tx;
	        this._svgMatrix.f = matrix.ty;
	        pattern.setTransform(this._svgMatrix.inverse());
	    };
	    /**
	     * destroy graphics object
	     *
	     */
	    CanvasGraphicsRenderer.prototype.destroy = function () {
	        this.renderer = null;
	        this._svgMatrix = null;
	        this._tempMatrix = null;
	    };
	    return CanvasGraphicsRenderer;
	}());

	var canvasRenderer;
	var tempMatrix$2 = new Matrix();
	/**
	 * Generates a canvas texture. Only available with **pixi.js-legacy** bundle
	 * or the **@pixi/canvas-graphics** package.
	 * @method generateCanvasTexture
	 * @memberof PIXI.Graphics#
	 * @param {PIXI.SCALE_MODES} scaleMode - The scale mode of the texture.
	 * @param {number} resolution - The resolution of the texture.
	 * @return {PIXI.Texture} The new texture.
	 */
	Graphics.prototype.generateCanvasTexture = function generateCanvasTexture(scaleMode, resolution) {
	    if (resolution === void 0) { resolution = 1; }
	    var bounds = this.getLocalBounds();
	    var canvasBuffer = RenderTexture.create({
	        width: bounds.width,
	        height: bounds.height,
	        scaleMode: scaleMode,
	        resolution: resolution,
	    });
	    if (!canvasRenderer) {
	        canvasRenderer = new CanvasRenderer();
	    }
	    this.transform.updateLocalTransform();
	    this.transform.localTransform.copyTo(tempMatrix$2);
	    tempMatrix$2.invert();
	    tempMatrix$2.tx -= bounds.x;
	    tempMatrix$2.ty -= bounds.y;
	    canvasRenderer.render(this, canvasBuffer, true, tempMatrix$2);
	    var texture = Texture.from(canvasBuffer.baseTexture._canvasRenderTarget.canvas, {
	        scaleMode: scaleMode,
	    });
	    texture.baseTexture.setResolution(resolution);
	    return texture;
	};
	Graphics.prototype.cachedGraphicsData = [];
	/**
	 * Renders the object using the Canvas renderer
	 *
	 * @method _renderCanvas
	 * @memberof PIXI.Graphics#
	 * @private
	 * @param {PIXI.CanvasRenderer} renderer - The renderer
	 */
	Graphics.prototype._renderCanvas = function _renderCanvas(renderer) {
	    if (this.isMask === true) {
	        return;
	    }
	    this.finishPoly();
	    renderer.plugins.graphics.render(this);
	};

	/*!
	 * @pixi/canvas-sprite - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/canvas-sprite is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	var canvasRenderWorldTransform = new Matrix();
	/**
	 * Types that can be passed to drawImage
	 * @typedef {HTMLImageElement | HTMLCanvasElement | HTMLVideoElement | ImageBitmap} ICanvasImageSource
	 * @memberof PIXI
	 */
	/**
	 * @author Mat Groves
	 *
	 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	 * for creating the original PixiJS version!
	 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
	 * share 4 bytes on the vertex buffer
	 *
	 * Heavily inspired by LibGDX's CanvasSpriteRenderer:
	 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/CanvasSpriteRenderer.java
	 */
	/**
	 * Renderer dedicated to drawing and batching sprites.
	 *
	 * @class
	 * @protected
	 * @memberof PIXI
	 */
	var CanvasSpriteRenderer = /** @class */ (function () {
	    /**
	     * @param {PIXI.Renderer} renderer -The renderer sprite this batch works for.
	     */
	    function CanvasSpriteRenderer(renderer) {
	        this.renderer = renderer;
	    }
	    /**
	     * Renders the sprite object.
	     *
	     * @param {PIXI.Sprite} sprite - the sprite to render when using this spritebatch
	     */
	    CanvasSpriteRenderer.prototype.render = function (sprite) {
	        var texture = sprite._texture;
	        var renderer = this.renderer;
	        var context = renderer.context;
	        var width = texture._frame.width;
	        var height = texture._frame.height;
	        var wt = sprite.transform.worldTransform;
	        var dx = 0;
	        var dy = 0;
	        var source = texture.baseTexture.getDrawableSource();
	        if (texture.orig.width <= 0 || texture.orig.height <= 0 || !texture.valid || !source) {
	            return;
	        }
	        if (!texture.valid) {
	            return;
	        }
	        renderer.setBlendMode(sprite.blendMode, true);
	        renderer.context.globalAlpha = sprite.worldAlpha;
	        // If smoothingEnabled is supported and we need to change the smoothing property for sprite texture
	        var smoothingEnabled = texture.baseTexture.scaleMode === exports.SCALE_MODES.LINEAR;
	        if (renderer.smoothProperty
	            && renderer.context[renderer.smoothProperty] !== smoothingEnabled) {
	            context[renderer.smoothProperty] = smoothingEnabled;
	        }
	        if (texture.trim) {
	            dx = (texture.trim.width / 2) + texture.trim.x - (sprite.anchor.x * texture.orig.width);
	            dy = (texture.trim.height / 2) + texture.trim.y - (sprite.anchor.y * texture.orig.height);
	        }
	        else {
	            dx = (0.5 - sprite.anchor.x) * texture.orig.width;
	            dy = (0.5 - sprite.anchor.y) * texture.orig.height;
	        }
	        if (texture.rotate) {
	            wt.copyTo(canvasRenderWorldTransform);
	            wt = canvasRenderWorldTransform;
	            groupD8.matrixAppendRotationInv(wt, texture.rotate, dx, dy);
	            // the anchor has already been applied above, so lets set it to zero
	            dx = 0;
	            dy = 0;
	        }
	        dx -= width / 2;
	        dy -= height / 2;
	        renderer.setContextTransform(wt, sprite.roundPixels, 1);
	        // Allow for pixel rounding
	        if (sprite.roundPixels) {
	            dx = dx | 0;
	            dy = dy | 0;
	        }
	        var resolution = texture.baseTexture.resolution;
	        var outerBlend = renderer._outerBlend;
	        if (outerBlend) {
	            context.save();
	            context.beginPath();
	            context.rect(dx * renderer.resolution, dy * renderer.resolution, width * renderer.resolution, height * renderer.resolution);
	            context.clip();
	        }
	        if (sprite.tint !== 0xFFFFFF) {
	            if (sprite._cachedTint !== sprite.tint || sprite._tintedCanvas.tintId !== sprite._texture._updateID) {
	                sprite._cachedTint = sprite.tint;
	                // TODO clean up caching - how to clean up the caches?
	                sprite._tintedCanvas = canvasUtils.getTintedCanvas(sprite, sprite.tint);
	            }
	            context.drawImage(sprite._tintedCanvas, 0, 0, Math.floor(width * resolution), Math.floor(height * resolution), Math.floor(dx * renderer.resolution), Math.floor(dy * renderer.resolution), Math.floor(width * renderer.resolution), Math.floor(height * renderer.resolution));
	        }
	        else {
	            context.drawImage(source, texture._frame.x * resolution, texture._frame.y * resolution, Math.floor(width * resolution), Math.floor(height * resolution), Math.floor(dx * renderer.resolution), Math.floor(dy * renderer.resolution), Math.floor(width * renderer.resolution), Math.floor(height * renderer.resolution));
	        }
	        if (outerBlend) {
	            context.restore();
	        }
	        // just in case, leaking outer blend here will be catastrophic!
	        renderer.setBlendMode(exports.BLEND_MODES.NORMAL);
	    };
	    /**
	     * destroy the sprite object.
	     *
	     */
	    CanvasSpriteRenderer.prototype.destroy = function () {
	        this.renderer = null;
	    };
	    return CanvasSpriteRenderer;
	}());

	/**
	 * Cached tinted texture.
	 * @memberof PIXI.Sprite#
	 * @member {HTMLCanvasElement} _tintedCanvas
	 * @protected
	 */
	Sprite.prototype._tintedCanvas = null;
	/**
	* Renders the object using the Canvas renderer
	*
	* @private
	* @method _renderCanvas
	* @memberof PIXI.Sprite#
	* @param {PIXI.CanvasRenderer} renderer - The renderer
	*/
	Sprite.prototype._renderCanvas = function _renderCanvas(renderer) {
	    renderer.plugins.sprite.render(this);
	};

	/*!
	 * @pixi/canvas-extract - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/canvas-extract is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	var TEMP_RECT$1 = new Rectangle();
	/**
	 * The extract manager provides functionality to export content from the renderers.
	 *
	 * An instance of this class is automatically created by default, and can be found at `renderer.plugins.extract`
	 *
	 * @class
	 * @memberof PIXI
	 */
	var CanvasExtract = /** @class */ (function () {
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - A reference to the current renderer
	     */
	    function CanvasExtract(renderer) {
	        this.renderer = renderer;
	    }
	    /**
	     * Will return a HTML Image of the target
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use the main renderer
	     * @param {string} [format] - Image format, e.g. "image/jpeg" or "image/webp".
	     * @param {number} [quality] - JPEG or Webp compression from 0 to 1. Default is 0.92.
	     * @return {HTMLImageElement} HTML Image of the target
	     */
	    CanvasExtract.prototype.image = function (target, format, quality) {
	        var image = new Image();
	        image.src = this.base64(target, format, quality);
	        return image;
	    };
	    /**
	     * Will return a a base64 encoded string of this target. It works by calling
	     *  `CanvasExtract.getCanvas` and then running toDataURL on that.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use the main renderer
	     * @param {string} [format] - Image format, e.g. "image/jpeg" or "image/webp".
	     * @param {number} [quality] - JPEG or Webp compression from 0 to 1. Default is 0.92.
	     * @return {string} A base64 encoded string of the texture.
	     */
	    CanvasExtract.prototype.base64 = function (target, format, quality) {
	        return this.canvas(target).toDataURL(format, quality);
	    };
	    /**
	     * Creates a Canvas element, renders this target to it and then returns it.
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use the main renderer
	     * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
	     */
	    CanvasExtract.prototype.canvas = function (target) {
	        var renderer = this.renderer;
	        var context;
	        var resolution;
	        var frame;
	        var renderTexture;
	        if (target) {
	            if (target instanceof RenderTexture) {
	                renderTexture = target;
	            }
	            else {
	                renderTexture = renderer.generateTexture(target);
	            }
	        }
	        if (renderTexture) {
	            context = renderTexture.baseTexture._canvasRenderTarget.context;
	            resolution = renderTexture.baseTexture._canvasRenderTarget.resolution;
	            frame = renderTexture.frame;
	        }
	        else {
	            context = renderer.rootContext;
	            resolution = renderer.resolution;
	            frame = TEMP_RECT$1;
	            frame.width = this.renderer.width;
	            frame.height = this.renderer.height;
	        }
	        var width = Math.floor((frame.width * resolution) + 1e-4);
	        var height = Math.floor((frame.height * resolution) + 1e-4);
	        var canvasBuffer = new CanvasRenderTarget(width, height, 1);
	        var canvasData = context.getImageData(frame.x * resolution, frame.y * resolution, width, height);
	        canvasBuffer.context.putImageData(canvasData, 0, 0);
	        // send the canvas back..
	        return canvasBuffer.canvas;
	    };
	    /**
	     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
	     * order, with integer values between 0 and 255 (included).
	     *
	     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
	     *  to convert. If left empty will use the main renderer
	     * @return {Uint8ClampedArray} One-dimensional array containing the pixel data of the entire texture
	     */
	    CanvasExtract.prototype.pixels = function (target) {
	        var renderer = this.renderer;
	        var context;
	        var resolution;
	        var frame;
	        var renderTexture;
	        if (target) {
	            if (target instanceof RenderTexture) {
	                renderTexture = target;
	            }
	            else {
	                renderTexture = renderer.generateTexture(target);
	            }
	        }
	        if (renderTexture) {
	            context = renderTexture.baseTexture._canvasRenderTarget.context;
	            resolution = renderTexture.baseTexture._canvasRenderTarget.resolution;
	            frame = renderTexture.frame;
	        }
	        else {
	            context = renderer.rootContext;
	            frame = TEMP_RECT$1;
	            frame.width = renderer.width;
	            frame.height = renderer.height;
	        }
	        return context.getImageData(0, 0, frame.width * resolution, frame.height * resolution).data;
	    };
	    /**
	     * Destroys the extract
	     *
	     */
	    CanvasExtract.prototype.destroy = function () {
	        this.renderer = null;
	    };
	    return CanvasExtract;
	}());
	/**
	 * @name PIXI.CanvasRenderer#extract
	 * @type {PIXI.CanvasExtract}
	 * @see PIXI.CanvasRenderer#plugins
	 * @deprecated since 5.3.0
	 */
	Object.defineProperty(CanvasRenderer.prototype, 'extract', {
	    get: function () {
	        deprecation('v5.3.0', 'CanvasRenderer#extract is deprecated, use CanvasRenderer#plugins.extract');
	        return this.plugins.extract;
	    },
	});

	/*!
	 * @pixi/canvas-prepare - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/canvas-prepare is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics$m = function(d, b) {
	    extendStatics$m = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } } };
	    return extendStatics$m(d, b);
	};

	function __extends$m(d, b) {
	    extendStatics$m(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	var CANVAS_START_SIZE = 16;
	/**
	 * Built-in hook to upload PIXI.Texture objects to the GPU.
	 *
	 * @private
	 * @param {*} prepare - Instance of CanvasPrepare
	 * @param {*} item - Item to check
	 * @return {boolean} If item was uploaded.
	 */
	function uploadBaseTextures$1(prepare, item) {
	    var tempPrepare = prepare;
	    if (item instanceof BaseTexture) {
	        var image = item.source;
	        // Sometimes images (like atlas images) report a size of zero, causing errors on windows phone.
	        // So if the width or height is equal to zero then use the canvas size
	        // Otherwise use whatever is smaller, the image dimensions or the canvas dimensions.
	        var imageWidth = image.width === 0 ? tempPrepare.canvas.width : Math.min(tempPrepare.canvas.width, image.width);
	        var imageHeight = image.height === 0 ? tempPrepare.canvas.height
	            : Math.min(tempPrepare.canvas.height, image.height);
	        // Only a small subsections is required to be drawn to have the whole texture uploaded to the GPU
	        // A smaller draw can be faster.
	        tempPrepare.ctx.drawImage(image, 0, 0, imageWidth, imageHeight, 0, 0, tempPrepare.canvas.width, tempPrepare.canvas.height);
	        return true;
	    }
	    return false;
	}
	/**
	 * The prepare manager provides functionality to upload content to the GPU.
	 *
	 * This cannot be done directly for Canvas like in WebGL, but the effect can be achieved by drawing
	 * textures to an offline canvas. This draw call will force the texture to be moved onto the GPU.
	 *
	 * An instance of this class is automatically created by default, and can be found at `renderer.plugins.prepare`
	 *
	 * @class
	 * @extends PIXI.BasePrepare
	 * @memberof PIXI
	 */
	var CanvasPrepare = /** @class */ (function (_super) {
	    __extends$m(CanvasPrepare, _super);
	    /**
	     * @param {PIXI.CanvasRenderer} renderer - A reference to the current renderer
	     */
	    function CanvasPrepare(renderer) {
	        var _this = _super.call(this, renderer) || this;
	        _this.uploadHookHelper = _this;
	        /**
	        * An offline canvas to render textures to
	        * @type {HTMLCanvasElement}
	        * @private
	        */
	        _this.canvas = document.createElement('canvas');
	        _this.canvas.width = CANVAS_START_SIZE;
	        _this.canvas.height = CANVAS_START_SIZE;
	        /**
	         * The context to the canvas
	        * @type {CanvasRenderingContext2D}
	        * @private
	        */
	        _this.ctx = _this.canvas.getContext('2d');
	        // Add textures to upload
	        _this.registerUploadHook(uploadBaseTextures$1);
	        return _this;
	    }
	    /**
	     * Destroys the plugin, don't use after this.
	     *
	     */
	    CanvasPrepare.prototype.destroy = function () {
	        _super.prototype.destroy.call(this);
	        this.ctx = null;
	        this.canvas = null;
	    };
	    return CanvasPrepare;
	}(BasePrepare));

	/*!
	 * @pixi/canvas-sprite-tiling - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/canvas-sprite-tiling is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * Renders the object using the Canvas renderer
	 *
	 * @protected
	 * @function _renderCanvas
	 * @memberof PIXI.TilingSprite#
	 * @param {PIXI.CanvasRenderer} renderer - a reference to the canvas renderer
	 */
	TilingSprite.prototype._renderCanvas = function _renderCanvas(renderer) {
	    var texture = this._texture;
	    if (!texture.baseTexture.valid) {
	        return;
	    }
	    var context = renderer.context;
	    var transform = this.worldTransform;
	    var baseTexture = texture.baseTexture;
	    var source = baseTexture.getDrawableSource();
	    var baseTextureResolution = baseTexture.resolution;
	    var modX = ((this.tilePosition.x / this.tileScale.x) % texture._frame.width) * baseTextureResolution;
	    var modY = ((this.tilePosition.y / this.tileScale.y) % texture._frame.height) * baseTextureResolution;
	    // create a nice shiny pattern!
	    if (this._textureID !== this._texture._updateID || this._cachedTint !== this.tint) {
	        this._textureID = this._texture._updateID;
	        // cut an object from a spritesheet..
	        var tempCanvas = new CanvasRenderTarget(texture._frame.width, texture._frame.height, baseTextureResolution);
	        // Tint the tiling sprite
	        if (this.tint !== 0xFFFFFF) {
	            this._tintedCanvas = canvasUtils.getTintedCanvas(this, this.tint);
	            tempCanvas.context.drawImage(this._tintedCanvas, 0, 0);
	        }
	        else {
	            tempCanvas.context.drawImage(source, -texture._frame.x * baseTextureResolution, -texture._frame.y * baseTextureResolution);
	        }
	        this._cachedTint = this.tint;
	        this._canvasPattern = tempCanvas.context.createPattern(tempCanvas.canvas, 'repeat');
	    }
	    // set context state..
	    context.globalAlpha = this.worldAlpha;
	    renderer.setBlendMode(this.blendMode);
	    renderer.setContextTransform(transform);
	    // fill the pattern!
	    context.fillStyle = this._canvasPattern;
	    // TODO - this should be rolled into the setTransform above..
	    context.scale(this.tileScale.x / baseTextureResolution, this.tileScale.y / baseTextureResolution);
	    var anchorX = this.anchor.x * -this._width;
	    var anchorY = this.anchor.y * -this._height;
	    if (this.uvRespectAnchor) {
	        context.translate(modX, modY);
	        context.fillRect(-modX + anchorX, -modY + anchorY, this._width / this.tileScale.x * baseTextureResolution, this._height / this.tileScale.y * baseTextureResolution);
	    }
	    else {
	        context.translate(modX + anchorX, modY + anchorY);
	        context.fillRect(-modX, -modY, this._width / this.tileScale.x * baseTextureResolution, this._height / this.tileScale.y * baseTextureResolution);
	    }
	};

	/*!
	 * @pixi/canvas-particles - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/canvas-particles is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * Renders the object using the Canvas renderer
	 * @method renderCanvas
	 * @memberof PIXI.ParticleContainer#
	 * @private
	 * @param {PIXI.CanvasRenderer} renderer - a reference to the canvas renderer
	 */
	ParticleContainer.prototype.renderCanvas = function renderCanvas(renderer) {
	    if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) {
	        return;
	    }
	    var context = renderer.context;
	    var transform = this.worldTransform;
	    var isRotated = true;
	    var positionX = 0;
	    var positionY = 0;
	    var finalWidth = 0;
	    var finalHeight = 0;
	    renderer.setBlendMode(this.blendMode);
	    context.globalAlpha = this.worldAlpha;
	    this.displayObjectUpdateTransform();
	    for (var i = 0; i < this.children.length; ++i) {
	        var child = this.children[i];
	        if (!child.visible) {
	            continue;
	        }
	        if (!child._texture.valid) {
	            continue;
	        }
	        var frame = child._texture.frame;
	        context.globalAlpha = this.worldAlpha * child.alpha;
	        if (child.rotation % (Math.PI * 2) === 0) {
	            // this is the fastest  way to optimise! - if rotation is 0 then we can avoid any kind of setTransform call
	            if (isRotated) {
	                renderer.setContextTransform(transform, false, 1);
	                isRotated = false;
	            }
	            positionX = ((child.anchor.x) * (-frame.width * child.scale.x)) + child.position.x + 0.5;
	            positionY = ((child.anchor.y) * (-frame.height * child.scale.y)) + child.position.y + 0.5;
	            finalWidth = frame.width * child.scale.x;
	            finalHeight = frame.height * child.scale.y;
	        }
	        else {
	            if (!isRotated) {
	                isRotated = true;
	            }
	            child.displayObjectUpdateTransform();
	            var childTransform = child.worldTransform;
	            renderer.setContextTransform(childTransform, this.roundPixels, 1);
	            positionX = ((child.anchor.x) * (-frame.width)) + 0.5;
	            positionY = ((child.anchor.y) * (-frame.height)) + 0.5;
	            finalWidth = frame.width;
	            finalHeight = frame.height;
	        }
	        var resolution = child._texture.baseTexture.resolution;
	        context.drawImage(child._texture.baseTexture.getDrawableSource(), frame.x * resolution, frame.y * resolution, frame.width * resolution, frame.height * resolution, positionX * renderer.resolution, positionY * renderer.resolution, finalWidth * renderer.resolution, finalHeight * renderer.resolution);
	    }
	};

	/*!
	 * @pixi/canvas-display - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/canvas-display is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * To be overridden by the subclass
	 * @method _renderCanvas
	 * @memberof PIXI.Container#
	 * @protected
	 * @param {PIXI.CanvasRenderer} renderer - The renderer
	 */
	Container.prototype._renderCanvas = function _renderCanvas(_renderer) {
	    // this is where content itself gets rendered...
	};
	/**
	 * Renders the object using the Canvas renderer
	 * @method renderCanvas
	 * @memberof PIXI.Container#
	 * @param {PIXI.CanvasRenderer} renderer - The renderer
	 */
	Container.prototype.renderCanvas = function renderCanvas(renderer) {
	    // if not visible or the alpha is 0 then no need to render this
	    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
	        return;
	    }
	    if (this._mask) {
	        renderer.maskManager.pushMask(this._mask);
	    }
	    this._renderCanvas(renderer);
	    for (var i = 0, j = this.children.length; i < j; ++i) {
	        this.children[i].renderCanvas(renderer);
	    }
	    if (this._mask) {
	        renderer.maskManager.popMask(renderer);
	    }
	};

	/**
	 * Renders the object using the Canvas renderer
	 * @method renderCanvas
	 * @memberof PIXI.Container#
	 * @param {PIXI.CanvasRenderer} renderer - The renderer
	 */
	DisplayObject.prototype.renderCanvas = function renderCanvas(_renderer) {
	    // OVERWRITE;
	};

	/*!
	 * @pixi/canvas-text - v5.3.11
	 * Compiled Mon, 01 Nov 2021 16:13:35 UTC
	 *
	 * @pixi/canvas-text is licensed under the MIT License.
	 * http://www.opensource.org/licenses/mit-license
	 */

	/**
	 * Renders the object using the Canvas renderer
	 *
	 * @method _renderCanvas
	 * @memberof PIXI.Text#
	 * @private
	 * @param {PIXI.CanvasRenderer} renderer - The renderer
	 */
	Text.prototype._renderCanvas = function _renderCanvas(renderer) {
	    if (this._autoResolution && this._resolution !== renderer.resolution) {
	        this._resolution = renderer.resolution;
	        this.dirty = true;
	    }
	    this.updateText(true);
	    Sprite.prototype._renderCanvas.call(this, renderer);
	};

	CanvasRenderer.registerPlugin('accessibility', AccessibilityManager);
	CanvasRenderer.registerPlugin('extract', CanvasExtract);
	CanvasRenderer.registerPlugin('graphics', CanvasGraphicsRenderer);
	CanvasRenderer.registerPlugin('interaction', InteractionManager);
	CanvasRenderer.registerPlugin('mesh', CanvasMeshRenderer);
	CanvasRenderer.registerPlugin('prepare', CanvasPrepare);
	CanvasRenderer.registerPlugin('sprite', CanvasSpriteRenderer);

	exports.AbstractBatchRenderer = AbstractBatchRenderer;
	exports.AbstractRenderer = AbstractRenderer;
	exports.AccessibilityManager = AccessibilityManager;
	exports.AnimatedSprite = AnimatedSprite;
	exports.AppLoaderPlugin = AppLoaderPlugin;
	exports.Application = Application;
	exports.Attribute = Attribute;
	exports.BasePrepare = BasePrepare;
	exports.BaseRenderTexture = BaseRenderTexture;
	exports.BaseTexture = BaseTexture;
	exports.BatchDrawCall = BatchDrawCall;
	exports.BatchGeometry = BatchGeometry;
	exports.BatchPluginFactory = BatchPluginFactory;
	exports.BatchRenderer = BatchRenderer;
	exports.BatchShaderGenerator = BatchShaderGenerator;
	exports.BatchTextureArray = BatchTextureArray;
	exports.BitmapFont = BitmapFont;
	exports.BitmapFontData = BitmapFontData;
	exports.BitmapFontLoader = BitmapFontLoader;
	exports.BitmapText = BitmapText;
	exports.Bounds = Bounds;
	exports.Buffer = Buffer;
	exports.CanvasExtract = CanvasExtract;
	exports.CanvasGraphicsRenderer = CanvasGraphicsRenderer;
	exports.CanvasMeshRenderer = CanvasMeshRenderer;
	exports.CanvasPrepare = CanvasPrepare;
	exports.CanvasRenderer = CanvasRenderer;
	exports.CanvasSpriteRenderer = CanvasSpriteRenderer;
	exports.Circle = Circle;
	exports.Container = Container;
	exports.CountLimiter = CountLimiter;
	exports.DEG_TO_RAD = DEG_TO_RAD;
	exports.DisplayObject = DisplayObject;
	exports.Ellipse = Ellipse;
	exports.Extract = Extract;
	exports.FillStyle = FillStyle;
	exports.Filter = Filter;
	exports.FilterState = FilterState;
	exports.Framebuffer = Framebuffer;
	exports.GLFramebuffer = GLFramebuffer;
	exports.GLProgram = GLProgram;
	exports.GLTexture = GLTexture;
	exports.GRAPHICS_CURVES = GRAPHICS_CURVES;
	exports.Geometry = Geometry;
	exports.Graphics = Graphics;
	exports.GraphicsData = GraphicsData;
	exports.GraphicsGeometry = GraphicsGeometry;
	exports.IGLUniformData = IGLUniformData;
	exports.InteractionData = InteractionData;
	exports.InteractionEvent = InteractionEvent;
	exports.InteractionManager = InteractionManager;
	exports.InteractionTrackingData = InteractionTrackingData;
	exports.LineStyle = LineStyle;
	exports.Loader = Loader$1;
	exports.LoaderResource = LoaderResource;
	exports.MaskData = MaskData;
	exports.Matrix = Matrix;
	exports.Mesh = Mesh;
	exports.MeshBatchUvs = MeshBatchUvs;
	exports.MeshGeometry = MeshGeometry;
	exports.MeshMaterial = MeshMaterial;
	exports.NineSlicePlane = NineSlicePlane;
	exports.ObjectRenderer = ObjectRenderer;
	exports.ObservablePoint = ObservablePoint;
	exports.PI_2 = PI_2;
	exports.ParticleContainer = ParticleContainer;
	exports.ParticleRenderer = ParticleRenderer;
	exports.PlaneGeometry = PlaneGeometry;
	exports.Point = Point;
	exports.Polygon = Polygon;
	exports.Prepare = Prepare;
	exports.Program = Program;
	exports.Quad = Quad;
	exports.QuadUv = QuadUv;
	exports.RAD_TO_DEG = RAD_TO_DEG;
	exports.Rectangle = Rectangle;
	exports.RenderTexture = RenderTexture;
	exports.RenderTexturePool = RenderTexturePool;
	exports.Renderer = Renderer;
	exports.RopeGeometry = RopeGeometry;
	exports.RoundedRectangle = RoundedRectangle;
	exports.Runner = Runner;
	exports.Shader = Shader;
	exports.SimpleMesh = SimpleMesh;
	exports.SimplePlane = SimplePlane;
	exports.SimpleRope = SimpleRope;
	exports.Sprite = Sprite;
	exports.SpriteMaskFilter = SpriteMaskFilter;
	exports.Spritesheet = Spritesheet;
	exports.SpritesheetLoader = SpritesheetLoader;
	exports.State = State;
	exports.System = System;
	exports.TemporaryDisplayObject = TemporaryDisplayObject;
	exports.Text = Text;
	exports.TextMetrics = TextMetrics;
	exports.TextStyle = TextStyle;
	exports.Texture = Texture;
	exports.TextureLoader = TextureLoader;
	exports.TextureMatrix = TextureMatrix;
	exports.TextureUvs = TextureUvs;
	exports.Ticker = Ticker;
	exports.TickerPlugin = TickerPlugin;
	exports.TilingSprite = TilingSprite;
	exports.TilingSpriteRenderer = TilingSpriteRenderer;
	exports.TimeLimiter = TimeLimiter;
	exports.Transform = Transform;
	exports.UniformGroup = UniformGroup;
	exports.VERSION = VERSION$1;
	exports.ViewableBuffer = ViewableBuffer;
	exports.accessibleTarget = accessibleTarget;
	exports.autoDetectRenderer = autoDetectRenderer;
	exports.canvasUtils = canvasUtils;
	exports.checkMaxIfStatementsInShader = checkMaxIfStatementsInShader;
	exports.defaultFilterVertex = defaultFilter;
	exports.defaultVertex = _default;
	exports.filters = filters;
	exports.graphicsUtils = index$2;
	exports.groupD8 = groupD8;
	exports.interactiveTarget = interactiveTarget;
	exports.isMobile = isMobile$1;
	exports.resources = index;
	exports.settings = settings;
	exports.systems = systems;
	exports.uniformParsers = uniformParsers;
	exports.useDeprecated = useDeprecated;
	exports.utils = utils_es;

	return exports;

}({}));
PIXI.useDeprecated();
//# sourceMappingURL=pixi-legacy.js.map
